
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("c2Y7c", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79927e3c1c348660896b3e18285ccee2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8c544d8771767dee$var$_react = $8c544d8771767dee$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $8c544d8771767dee$var$_iconNew = $8c544d8771767dee$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $8c544d8771767dee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/question-circle
 * Usage guidance:
 * Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8c544d8771767dee$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $8c544d8771767dee$var$_react.default.createElement($8c544d8771767dee$var$_iconNew.default, Object.assign({
        name: "QuestionCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3c-.586 0-1 .414-1 1H5.5c0-1.414 1.086-2.5 2.5-2.5s2.5 1.086 2.5 2.5c0 1.133-.713 1.706-1.162 2.058-.511.402-.588.494-.588.692v.75h-1.5v-.75c0-.977.689-1.507 1.078-1.806l.084-.065C8.838 6.544 9 6.367 9 6c0-.586-.414-1-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$8c544d8771767dee$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $8c544d8771767dee$var$_default = module.exports.default = $8c544d8771767dee$var$QuestionCircleIcon;

});

parcelRegister("iUc6n", function(module, exports) {
$parcel$export(module.exports, "ConfluenceIcon", () => $b6812553d1a566be$export$68f3db7f6af48bcb);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::932d47dd87f3f2976aabd1b4699b27b4>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $2IsXX = parcelRequire("2IsXX");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $b6812553d1a566be$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M17.888 14.461c-4.039-1.953-5.219-2.245-6.92-2.245-1.997 0-3.699.831-5.219 3.165l-.25.382c-.204.314-.249.426-.249.561s.068.247.318.404l2.564 1.594c.136.09.25.135.363.135.136 0 .226-.068.363-.27l.408-.628c.635-.966 1.203-1.28 1.928-1.28.636 0 1.385.18 2.315.629l2.677 1.257c.272.134.567.067.704-.247l1.27-2.783c.136-.315.046-.517-.272-.674M6.112 9.545c4.039 1.953 5.219 2.245 6.92 2.245 1.997 0 3.699-.83 5.219-3.165l.25-.381c.204-.315.249-.427.249-.562 0-.134-.068-.247-.318-.404L15.87 5.685c-.137-.09-.25-.135-.364-.135-.136 0-.226.067-.363.27l-.408.628c-.635.965-1.203 1.28-1.928 1.28-.636 0-1.385-.18-2.315-.63L7.814 5.843c-.272-.135-.567-.068-.703.247L5.84 8.872c-.136.314-.045.516.272.673"/>
</svg>
`;
const $b6812553d1a566be$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-7.032 12.217c-1.997 0-3.699.83-5.219 3.165l-.249.38c-.204.315-.25.427-.25.562s.068.247.317.404l2.565 1.594c.136.09.249.135.362.135.136 0 .227-.068.363-.27l.409-.628c.635-.966 1.202-1.28 1.928-1.28.636 0 1.384.18 2.315.63l2.677 1.256c.273.134.568.067.704-.247l1.27-2.783c.136-.315.045-.517-.272-.674-4.039-1.953-5.219-2.244-6.92-2.244m4.538-6.667c-.136 0-.227.067-.363.27l-.409.628c-.635.965-1.202 1.28-1.928 1.28-.636 0-1.384-.18-2.315-.63L7.813 5.843c-.272-.135-.567-.067-.703.247L5.84 8.872c-.136.314-.045.517.272.674 4.039 1.953 5.219 2.244 6.92 2.244 1.997 0 3.699-.83 5.219-3.165l.249-.382c.204-.314.25-.426.25-.56s-.068-.248-.317-.405l-2.565-1.593c-.136-.09-.249-.135-.362-.135"/>
</svg>
`;
function $b6812553d1a566be$export$68f3db7f6af48bcb({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Confluence', testId: testId }) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $2IsXX.IconWrapper), {
        svg: $b6812553d1a566be$var$svg,
        customThemeSvg: $b6812553d1a566be$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}
$b6812553d1a566be$export$68f3db7f6af48bcb.displayName = "ConfluenceIcon";

});
parcelRegister("2IsXX", function(module, exports) {
$parcel$export(module.exports, "IconWrapper", () => $a8aac4f7cefd259f$export$be58b4326e23250f);
/* icon-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $llCao = parcelRequire("llCao");

var $bJtVR = parcelRequire("bJtVR");
const $a8aac4f7cefd259f$var$styles = {
    root: "_3iDTPbvbI6",
    TEMP_assets: "_0C0F9q1qiM"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $a8aac4f7cefd259f$var$cloudLightAppearanceMap = {
    brand: "_36J4jyyL8i _0C0F9qyL8i",
    neutral: "_36J4jyBRVV _0C0F9q1qiM",
    inverse: "_36J4jyCl79 _0C0F9qt28M",
    legacy: "_36J4jyt28M _0C0F9q2bHZ"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $a8aac4f7cefd259f$var$cloudDarkAppearanceMap = {
    brand: "_36J4jyyL8i _0C0F9qyL8i",
    neutral: "_36J4jynrF4 _0C0F9qMlgR",
    inverse: "_36J4jyt28M _0C0F9qCl79",
    legacy: "_36J4jyt28M _0C0F9q2bHZ"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $a8aac4f7cefd259f$var$dataCenterLightAppearanceMap = {
    brand: "_36J4jy2bHZ _0C0F9qt28M _0g0wFM1qiM",
    neutral: "_36J4jyBRVV _0C0F9q1qiM _0g0wFMBRVV",
    inverse: "_36J4jyt28M _0C0F9qRvDB _0g0wFMt28M",
    legacy: "_36J4jy2bHZ _0C0F9qt28M _0g0wFM1qiM"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $a8aac4f7cefd259f$var$dataCenterDarkAppearanceMap = {
    brand: "_36J4jy2bHZ _0C0F9qRvDB _0g0wFMMlgR",
    neutral: "_36J4jynrF4 _0C0F9qMlgR _0g0wFMnrF4",
    inverse: "_36J4jyMmzW _0C0F9qt28M _0g0wFMMmzW",
    legacy: "_36J4jy2bHZ _0C0F9qRvDB _0g0wFMMlgR"
};
const $a8aac4f7cefd259f$var$rovoDarkAppearanceMap = {
    brand: "_2PY8Z6yL8i _05MzPYyL8i _0Yajk0yL8i _40KAGSyL8i",
    neutral: "_2PY8Z6nrF4 _05MzPYnrF4 _0Yajk0nrF4 _40KAGSnrF4",
    inverse: "_2PY8Z6RvDB _05MzPYRvDB _0Yajk0RvDB _40KAGSRvDB",
    legacy: "_2PY8Z62bHZ _05MzPY2bHZ _0Yajk02bHZ _40KAGS2bHZ"
};
const $a8aac4f7cefd259f$var$rovoLightAppearanceMap = {
    brand: "_2PY8Z6yL8i _05MzPYyL8i _0Yajk0yL8i _40KAGSyL8i",
    neutral: "_2PY8Z6BRVV _05MzPYBRVV _0Yajk0BRVV _40KAGSBRVV",
    inverse: "_2PY8Z6t28M _05MzPYt28M _0Yajk0t28M _40KAGSt28M",
    legacy: "_2PY8Z62bHZ _05MzPY2bHZ _0Yajk02bHZ _40KAGS2bHZ"
}; /* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */ const $a8aac4f7cefd259f$var$sizeMap = {
    xxsmall: "_0jFU0Vey7F",
    xsmall: "_0jFU0VSPN1",
    small: "_0jFU0VoWWg",
    medium: "_0jFU0VUofl",
    large: "_0jFU0VUF4f",
    xlarge: "_0jFU0VpJKa",
    '12': "_0jFU0VxpxF",
    '16': "_0jFU0Vey7F",
    '20': "_0jFU0VSPN1",
    '24': "_0jFU0VoWWg",
    '32': "_0jFU0VUofl"
};
function $a8aac4f7cefd259f$export$be58b4326e23250f({ size: size = '20', label: label, svg: svg, customThemeSvg: customThemeSvg, testId: userDefinedTestId, appearance: appearance = 'brand', iconColor: customIconColor, isAssets: isAssets = false, type: type = 'tile' }) {
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && customIconColor;
    const { colorMode: colorMode } = (0, $bJtVR.useThemeObserver)();
    return /*#__PURE__*/ (0, $5chsV.jsx)("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor || 'initial'
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        // This is because the SVG elements are static and will not change, so we get a little performance benefit by
        // bypassing React.
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $gJ6nT.default)([
            $a8aac4f7cefd259f$var$styles.root,
            $a8aac4f7cefd259f$var$sizeMap[size],
            colorMode === 'dark' ? $a8aac4f7cefd259f$var$dataCenterDarkAppearanceMap[appearance] : $a8aac4f7cefd259f$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $a8aac4f7cefd259f$var$rovoDarkAppearanceMap[appearance] : $a8aac4f7cefd259f$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $a8aac4f7cefd259f$var$cloudDarkAppearanceMap[appearance] : $a8aac4f7cefd259f$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && ((0, $llCao.fg)('assets-platform-branding') || (0, $llCao.fg)('assets-platform-branding-v2')) && $a8aac4f7cefd259f$var$styles.TEMP_assets
        ])
    });
}
$a8aac4f7cefd259f$export$be58b4326e23250f.displayName = "IconWrapper";

});
parcelRegister("bJtVR", function(module, exports) {
$parcel$export(module.exports, "useThemeObserver", () => $58b743975db5767c$export$3dd7971102e44fa8);
$parcel$export(module.exports, "default", () => $58b743975db5767c$export$2e2bcd8739ae039);

var $fsvuC = parcelRequire("fsvuC");

var $dIKZc = parcelRequire("dIKZc");

var $8HWVA = parcelRequire("8HWVA");
const $58b743975db5767c$export$3dd7971102e44fa8 = ()=>{
    const [theme, setTheme] = (0, $fsvuC.useState)((0, $dIKZc.getGlobalTheme)());
    (0, $fsvuC.useEffect)(()=>{
        const observer = new (0, $8HWVA.default)((theme)=>setTheme(theme));
        observer.observe();
        return ()=>observer.disconnect();
    }, []);
    return theme;
};
var $58b743975db5767c$export$2e2bcd8739ae039 = $58b743975db5767c$export$3dd7971102e44fa8;

});



parcelRegister("8B0Ox", function(module, exports) {
$parcel$export(module.exports, "JiraIcon", () => $f388f01be679e1b0$export$c4b5b1f965d8b3eb);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c0e4bfbb3ca87324a6e97db845b2ae2c>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $2IsXX = parcelRequire("2IsXX");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $f388f01be679e1b0$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M9.051 15.434H7.734c-1.988 0-3.413-1.218-3.413-3h7.085c.367 0 .605.26.605.63v7.13c-1.772 0-2.96-1.435-2.96-3.434zm3.5-3.543h-1.318c-1.987 0-3.413-1.196-3.413-2.978h7.085c.367 0 .627.239.627.608v7.13c-1.772 0-2.981-1.435-2.981-3.434zm3.52-3.522h-1.317c-1.987 0-3.413-1.217-3.413-3h7.085c.367 0 .605.262.605.61v7.129c-1.771 0-2.96-1.435-2.96-3.434z"/>
</svg>
`;
const $f388f01be679e1b0$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM4.321 12.434c0 1.782 1.425 3 3.412 3h1.319v1.326c0 2 1.188 3.433 2.959 3.433v-7.129c0-.369-.238-.63-.605-.63zm3.5-3.52c0 1.781 1.425 2.977 3.412 2.977h1.318v1.326c0 2 1.21 3.433 2.98 3.433V9.521c0-.369-.259-.608-.626-.608zm3.52-3.544c0 1.782 1.426 3 3.413 3h1.317v1.304c0 2 1.188 3.433 2.96 3.433V5.98c0-.348-.238-.609-.605-.609z"/>
</svg>
`;
function $f388f01be679e1b0$export$c4b5b1f965d8b3eb({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Jira', testId: testId }) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $2IsXX.IconWrapper), {
        svg: $f388f01be679e1b0$var$svg,
        customThemeSvg: $f388f01be679e1b0$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}
$f388f01be679e1b0$export$c4b5b1f965d8b3eb.displayName = "JiraIcon";

});

parcelRegister("8OcK0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $88cd0d3eac5c55a5$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $1oQru = parcelRequire("1oQru");
/**
 * __Modal wrapper__
 *
 * A modal wrapper displays content that requires user interaction, in a layer above the page.
 * This component is primary container for other modal components.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $88cd0d3eac5c55a5$var$ModalWrapper = /*#__PURE__*/ (0, $fsvuC.forwardRef)((props, ref)=>{
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $1oQru.default), {
        ...props,
        isFullScreen: false,
        ref: ref
    });
});
$88cd0d3eac5c55a5$var$ModalWrapper.displayName = 'ModalWrapper';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$88cd0d3eac5c55a5$export$2e2bcd8739ae039 = $88cd0d3eac5c55a5$var$ModalWrapper;

});
parcelRegister("1oQru", function(module, exports) {
$parcel$export(module.exports, "default", () => $709207ee6a47cb04$export$2e2bcd8739ae039);
/* modal-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $kyAKM = parcelRequire("kyAKM");

var $121xR = parcelRequire("121xR");

var $d5Gwv = parcelRequire("d5Gwv");

var $cO2CB = parcelRequire("cO2CB");

var $9Tkwf = parcelRequire("9Tkwf");

var $cO4y2 = parcelRequire("cO4y2");

var $cTXsj = parcelRequire("cTXsj");

var $awR7e = parcelRequire("awR7e");

var $iqc8V = parcelRequire("iqc8V");

var $ceFHj = parcelRequire("ceFHj");

var $hk7fM = parcelRequire("hk7fM");

var $eEY7a = parcelRequire("eEY7a");

var $ixlCP = parcelRequire("ixlCP");

var $llCao = parcelRequire("llCao");

var $bDK6L = parcelRequire("bDK6L");

var $8wYaX = parcelRequire("8wYaX");

var $QrsDO = parcelRequire("QrsDO");

var $2ri6P = parcelRequire("2ri6P");

var $fBYqz = parcelRequire("fBYqz");

var $5J4vr = parcelRequire("5J4vr");

var $ijAKY = parcelRequire("ijAKY");

var $9xWjb = parcelRequire("9xWjb");

var $8AMYy = parcelRequire("8AMYy");

var $34U9g = parcelRequire("34U9g");

var $1NFIQ = parcelRequire("1NFIQ");

var $ij1dL = parcelRequire("ij1dL");

var $5uxBM = parcelRequire("5uxBM");

var $ifNCA = parcelRequire("ifNCA");

var $kE6KB = parcelRequire("kE6KB");
const $709207ee6a47cb04$var$fillScreenStyles = null; /**
                                * Styles applied to the <dialog> wrapper, NOT the visual modal surface.
                                */ 
const $709207ee6a47cb04$var$dialogStyles = {
    'body-scroll': "_4bt5LAYvD1 _2WAcuGYvD1 _313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _4fJ90yfI2J _1tgHQuIZbP _3GDW4sfI2J _4ntsTKIZbP",
    'viewport-scroll': "_1qyfxmyhct _39xV02qUim _0jFU0VWP8C",
    'full-screen': ""
}; // Visual styles for modal content inside native <dialog>.
// Uses cssMap (not css) to avoid triggering no-nested-styles lint rule.
const $709207ee6a47cb04$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current'; /**
                                                                                                         * Styles applied to the visual modal surface.
                                                                                                         */ 
const $709207ee6a47cb04$var$surfaceStyles = {
    root: "_3iDTPbQ4SZ _0aFT5vbt8w _0KLXruoI2d _45TjwHoI2d _1pp6NdIZbP _3Sk04SOLYo _1s1YRNOLYo _3gkMN6OLYo _1ubuxonXvL _34b3D2vc3e _1NDpvb6wH8 _2wtOC9vc3e _2l47gTGk8v",
    borderRadius: "_0bjKvDdnbC _0YcdZAyzSk"
};
const $709207ee6a47cb04$var$topLayerScrollModeStyles = {
    'full-screen': "_39xV02qUim _0jFU0VWP8C _1mT5xdy1CL _2I62gzPgdg _3iC0zdPgdg _2WAcuGIZbP _0xWutCdqJc",
    'viewport-scroll': "_0jFU0VWP8C _4fJ90yfI2J _1tgHQuIZbP _3GDW4sfI2J _4ntsTKIZbP _3ShBvMBY1A _3GZDR8k2yd _14gTsZ5dtV _28xGbQw4ra",
    'body-scroll': "_39xV02qUim _0jFU0VWP8C _3GZDR8k2yd _14gTsZ5dtV _28xGbQw4ra"
};
const $709207ee6a47cb04$var$topLayerAutoHeightStyles = null;
const $709207ee6a47cb04$var$allowlistElements = (element, callback)=>{
    // Allow focus outside modal when AUI dialog is visible
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- legacy FocusLock allowlist
    if (document.querySelector('.aui-blanket:not([hidden])')) return false;
     // Optional callback to let consumers exclude elements from focus lock
    if (typeof callback === 'function') return callback(element);
    return true;
}; // Analytics-wrapped close handler. Extracted so both rendering paths build it
// identically.
function $709207ee6a47cb04$var$useModalCloseHandler(providedOnClose) {
    return (0, $d5Gwv.usePlatformLeafEventHandler)({
        fn: providedOnClose || (0, $9Tkwf.default),
        action: 'closed',
        componentName: 'modalDialog',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
}
function $709207ee6a47cb04$var$getScrollMode({ shouldScrollInViewport: shouldScrollInViewport, isFullScreen: isFullScreen }) {
    if (isFullScreen) return 'full-screen';
    if (shouldScrollInViewport) return 'viewport-scroll';
    return 'body-scroll';
}
function $709207ee6a47cb04$var$isWidthName(value) {
    return (0, $ifNCA.width).values.includes(value);
}
function $709207ee6a47cb04$var$getTopLayerSurfaceWidth(input) {
    if (!input) return 'auto';
    if (typeof input === 'number') return `${input}px`;
    if ($709207ee6a47cb04$var$isWidthName(input)) return `${(0, $ifNCA.width).widths[input]}px`;
    if (input.endsWith('%')) // Percentage widths need special handling in the top layer.
    // In legacy, the percentage resolved against the Positioner's max-width
    // (100vw - 120px). In the top layer, the <dialog>'s containing block is the
    // viewport (100vw), so a raw percentage would produce a wider modal.
    // Transform e.g. '42%' → 'calc(42 * (100vw - 120px) / 100)' to match legacy.
    return `calc(${parseFloat(input)} * (100vw - 120px) / 100)`;
    return input;
}
function $709207ee6a47cb04$var$getTopLayerSurfaceHeight(input) {
    if (!input) // Although this value would ordinarily fill the viewport height,
    // there is also a `max-height: max-content` applied to keep it constrained.
    // But we need to provide the modal with a fixed height (non-keyword, non-percentage)
    // in order for child elements with 100% height to work correctly.
    return 'calc(100vh - 120px)';
    if (typeof input === 'number') return `${input}px`;
    if (input.endsWith('%')) // Percentage heights need special handling in the top layer.
    // In legacy, the percentage resolved against the Positioner's max-height
    // (100vh - 120px). In the top layer, the <dialog>'s containing block is the
    // viewport (100vh), so a raw percentage would produce a taller modal.
    // Transform e.g. '42%' → 'calc(42 * (100vh - 120px) / 100)' to match legacy.
    return `calc(${parseFloat(input)} * (100vh - 120px) / 100)`;
    return input;
}
function $709207ee6a47cb04$var$getDismissedBy({ shouldCloseOnEscapePress: shouldCloseOnEscapePress, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick }) {
    if (shouldCloseOnEscapePress && shouldCloseOnOverlayClick) return 'escape-and-outside-click';
    if (shouldCloseOnEscapePress) return 'escape';
     // Backdrop clicks only: `Dialog` asks on both, and `onDialogAsk` ignores Escape.
    if (shouldCloseOnOverlayClick) return 'escape-and-outside-click';
    return 'none';
} /**
   * Top-layer rendering path (platform-dst-top-layer).
   *
   * Replaces Portal, FocusLock, ScrollLock, Blanket, Positioner, and z-index
   * management with native <dialog> via @atlaskit/top-layer/dialog.
   *
   * Key decisions:
   * - Animation: CSS transitions via @starting-style / allow-discrete.
   * - Close gating: matches legacy while open. Dialog asks on Escape and backdrop
   *   clicks (the consumer may refuse any number of times). During the exit they
   *   do not call `onClose` again.
   * - A close that Dialog did not ask about (e.g. `<form method="dialog">`): not
   *   supported. Dialog shows the modal again, and `onClose` does not run.
   * - onClose event param: undefined - consumers should use close reason.
   * - Focus restoration: native <dialog> behavior replaces react-focus-lock's
   *   returnFocus (see accessibility-criteria.md).
   *
   * Every hook here runs unconditionally: this component only mounts on the
   * top-layer path, so it never shares a hook sequence with the legacy path.
   */ 
function $709207ee6a47cb04$var$ModalWrapperTopLayer(props) {
    const { autoFocus: autoFocus, shouldCloseOnEscapePress: shouldCloseOnEscapePress = true, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick = true, shouldScrollInViewport: shouldScrollInViewport = false, shouldReturnFocus: shouldReturnFocus = true, onClose: providedOnClose, onStackChange: onStackChange = (0, $9Tkwf.default), isBlanketHidden: isBlanketHidden, children: children, height: height, width: width = 'medium', onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, label: label, testId: testId, isFullScreen: isFullScreen = false } = props;
    (0, $9xWjb.default)({
        onStackChange: onStackChange
    });
    const onCloseHandler = $709207ee6a47cb04$var$useModalCloseHandler(providedOnClose);
    const { isExiting: isExiting, onFinish: onExitFinish } = (0, $hk7fM.useExitingPersistence)(); // Native <dialog> always restores focus on close - no opt-out via shouldReturnFocus.
    const defaultTestId = testId || 'modal-dialog';
    const id = (0, $cTXsj.useId)();
    const titleId = `modal-dialog-title-${id}`; // Content container ref - used for onOpenComplete/onCloseComplete callbacks.
    const contentRef = (0, $fsvuC.useRef)(null); // Cache last content element for onCloseComplete after children unmount
    // (with reduced motion, contentRef clears before onExitFinish fires).
    const lastContentElRef = (0, $fsvuC.useRef)(null);
    if (contentRef.current) lastContentElRef.current = contentRef.current;
     // Native <dialog> ref - needed for ExitingPersistence to call dialog.close().
    const dialogRef = (0, $fsvuC.useRef)(null);
    const hasProvidedOnClose = Boolean(providedOnClose);
    const modalDialogContext = (0, $fsvuC.useMemo)(()=>({
            testId: defaultTestId,
            titleId: titleId,
            onClose: onCloseHandler,
            hasProvidedOnClose: hasProvidedOnClose,
            isFullScreen: isFullScreen ?? false
        }), [
        defaultTestId,
        titleId,
        onCloseHandler,
        hasProvidedOnClose,
        isFullScreen
    ]); // Pass a synthetic event to satisfy the KeyboardOrMouseEvent contract. Dialog calls this
    // for an allowed Escape or backdrop click.
    const onDialogClose = (0, $fsvuC.useCallback)(({ reason: reason })=>{
        onCloseHandler((0, $2ri6P.createCloseEvent)({
            reason: reason
        }));
    }, [
        onCloseHandler
    ]); /**
                         * Dialog asks on an allowed Escape or backdrop click. Ignoring an Escape ask refuses it:
                         * Dialog still cancels the Escape `keydown`, so nothing else closes.
                         */ 
    const onDialogAsk = (0, $fsvuC.useCallback)(({ reason: reason })=>{
        if (reason === 'escape' && !shouldCloseOnEscapePress) return;
        onDialogClose({
            reason: reason
        });
    }, [
        onDialogClose,
        shouldCloseOnEscapePress
    ]); // Unlike legacy, Escape and backdrop clicks during the exit do not call `onClose` again.
    // See `@atlaskit/top-layer` notes: `decisions/dialog-close-flow.md`.
    // Dialog could not reopen after a close it did not ask about (its parent layer is closed), so
    // the `<dialog>` is already gone. End the exit.
    (0, $fsvuC.useEffect)(()=>{
        if (isExiting && !dialogRef.current) onExitFinish?.();
    }, [
        isExiting,
        onExitFinish
    ]); // ExitingPersistence: isExiting → isOpen={false} → Dialog exit animation →
    // onExitFinish → onCloseComplete + unmount.
    const handleDialogExitFinish = (0, $fsvuC.useCallback)(()=>{
        const el = contentRef.current ?? lastContentElRef.current;
        if (onCloseComplete && el) onCloseComplete(el);
        lastContentElRef.current = null;
        onExitFinish?.();
    }, [
        onExitFinish,
        onCloseComplete
    ]);
    const handleDialogEnterFinish = (0, $fsvuC.useCallback)(()=>{
        if (onOpenComplete && contentRef.current) onOpenComplete(contentRef.current, true);
    }, [
        onOpenComplete
    ]); // Honor `shouldReturnFocus={ref}` on unmount.
    // Native <dialog>.close() restores focus to the trigger that opened it,
    // but the consumer asked for focus to go to a specific element instead.
    // Run this in an unmount cleanup so it fires after dialog.close()
    // (which fires in the Dialog's effect cleanup).
    const shouldReturnFocusRef = (0, $fsvuC.useRef)(shouldReturnFocus);
    shouldReturnFocusRef.current = shouldReturnFocus;
    (0, $fsvuC.useEffect)(()=>{
        return ()=>{
            const target = shouldReturnFocusRef.current;
            if (typeof target === 'object' && target.current) target.current.focus();
        };
    }, []); // Focus a ref-targeted element after mount (when autoFocus is a ref).
    // When true, native <dialog>.showModal() handles focus automatically.
    (0, $cO4y2.default)(typeof autoFocus === 'object' ? autoFocus : undefined, typeof autoFocus === 'object'); // Chrome cross-origin iframe DnD workaround (crbug.com/362301053)
    (0, $fsvuC.useEffect)(()=>{
        return (0, $8wYaX.combine)((0, $34U9g.disableDraggingToCrossOriginIFramesForElement)(), (0, $ij1dL.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, $1NFIQ.disableDraggingToCrossOriginIFramesForExternal)());
    }, []);
    const scrollMode = $709207ee6a47cb04$var$getScrollMode({
        isFullScreen: isFullScreen,
        shouldScrollInViewport: shouldScrollInViewport
    });
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $fBYqz.Dialog), {
        ref: dialogRef,
        onClose: onDialogAsk,
        dismissedBy: $709207ee6a47cb04$var$getDismissedBy({
            shouldCloseOnEscapePress: shouldCloseOnEscapePress,
            shouldCloseOnOverlayClick: shouldCloseOnOverlayClick
        }),
        onExitFinish: handleDialogExitFinish,
        shouldAnimate: !isFullScreen,
        isOpen: !isExiting,
        onEnterFinish: handleDialogEnterFinish,
        shouldHideBackdrop: isBlanketHidden,
        ...label ? {
            label: label
        } : {
            labelledBy: titleId
        },
        testId: defaultTestId,
        xcss: $709207ee6a47cb04$var$dialogStyles[scrollMode],
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $5J4vr.DialogScrollLock), {
                isOpen: true
            }),
            /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                ref: contentRef,
                style: {
                    '--modal-dialog-height': $709207ee6a47cb04$var$getTopLayerSurfaceHeight(height),
                    '--modal-dialog-width': $709207ee6a47cb04$var$getTopLayerSurfaceWidth(width)
                },
                className: (0, $gJ6nT.default)([
                    $709207ee6a47cb04$var$surfaceStyles.root,
                    !isFullScreen && $709207ee6a47cb04$var$surfaceStyles.borderRadius,
                    $709207ee6a47cb04$var$topLayerScrollModeStyles[scrollMode],
                    !height && !isFullScreen && "_0Wik48W9qI"
                ]),
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $ijAKY.ModalContext).Provider, {
                    value: modalDialogContext,
                    children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $5uxBM.ScrollContext).Provider, {
                        value: shouldScrollInViewport,
                        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $ixlCP.default), {
                            children: children
                        })
                    })
                })
            })
        ]
    });
}
$709207ee6a47cb04$var$ModalWrapperTopLayer.displayName = "ModalWrapperTopLayer";
/**
 * Legacy rendering path (Portal + FocusLock + ScrollLock + Blanket).
 *
 * Every hook here runs unconditionally: this component only mounts on the
 * legacy path, so it never shares a hook sequence with the top-layer path.
 */ const $709207ee6a47cb04$var$ModalWrapperLegacy = /*#__PURE__*/ (0, $fsvuC.forwardRef)((props, ref)=>{
    const { autoFocus: autoFocus, focusLockAllowlist: focusLockAllowlist, shouldCloseOnEscapePress: shouldCloseOnEscapePress = true, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick = true, shouldScrollInViewport: shouldScrollInViewport = false, shouldReturnFocus: shouldReturnFocus = true, stackIndex: stackIndexOverride, onClose: providedOnClose, onStackChange: onStackChange = (0, $9Tkwf.default), isBlanketHidden: isBlanketHidden, children: children, height: height, width: width, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, label: label, testId: testId, isFullScreen: isFullScreen, UNSAFE_shouldDisableMotionUplift: UNSAFE_shouldDisableMotionUplift = false } = props;
    const calculatedStackIndex = (0, $9xWjb.default)({
        onStackChange: onStackChange
    });
    const stackIndex = stackIndexOverride || calculatedStackIndex;
    const isForeground = stackIndex === 0; // If no ref is provided, autofocus on first element
    const autoFocusLock = !(typeof autoFocus === 'object');
    const onCloseHandler = $709207ee6a47cb04$var$useModalCloseHandler(providedOnClose);
    const onBlanketClicked = (0, $fsvuC.useCallback)((e)=>{
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]); // Stable callback to avoid re-renders when focusLockAllowlist is not provided.
    const allowListCallback = (0, $fsvuC.useCallback)((element)=>$709207ee6a47cb04$var$allowlistElements(element, focusLockAllowlist), [
        focusLockAllowlist
    ]); // Prevent background scroll (top-layer path uses DialogScrollLock instead).
    (0, $8AMYy.default)(); // Register with the open layer observer. On the top-layer path the Dialog
    // primitive does this itself, which is why it lives in this legacy-only
    // component rather than the shared dispatcher.
    (0, $iqc8V.useNotifyOpenLayerObserver)({
        type: 'modal',
        // Always open — modal is conditionally rendered when visible.
        isOpen: true,
        // No-op: no current use case for programmatic close via OpenLayerObserver.
        onClose: (0, $9Tkwf.default)
    });
    const modalDialogWithBlanket = /*#__PURE__*/ (0, $5chsV.jsx)((0, $cO2CB.default), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && `${testId}--blanket`,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $kE6KB.default), {
            testId: testId,
            label: label,
            autoFocus: autoFocus,
            stackIndex: stackIndex,
            onClose: onCloseHandler,
            shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
            shouldScrollInViewport: shouldScrollInViewport,
            height: height,
            width: width,
            onCloseComplete: onCloseComplete,
            onOpenComplete: onOpenComplete,
            hasProvidedOnClose: Boolean(providedOnClose),
            isFullScreen: isFullScreen,
            UNSAFE_shouldDisableMotionUplift: UNSAFE_shouldDisableMotionUplift,
            ref: ref,
            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $ixlCP.default), {
                children: children
            })
        })
    });
    let returnFocus = true;
    let onDeactivation = (0, $9Tkwf.default);
    if ('boolean' === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
    else onDeactivation = ()=>{
        window.setTimeout(()=>{
            shouldReturnFocus.current?.focus();
        }, 0);
    };
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $awR7e.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $bDK6L.default), {
            zIndex: (0, $QrsDO.layers).modal(),
            children: !UNSAFE_shouldDisableMotionUplift && (0, $llCao.fg)('platform-dst-motion-uplift-modal') ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $ceFHj.default), {
                enteringAnimation: "var(--ds-blanket-enter, 250ms cubic-bezier(0.4, 0, 0, 1) FadeIn0to100)",
                exitingAnimation: "var(--ds-blanket-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
                children: /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                    "aria-hidden": !isForeground,
                    className: (0, $gJ6nT.default)([
                        "_39xV02qUim _0jFU0VWP8C _1mT5xdy1CL _2I62gzPgdg _3iC0zdPgdg _2WAcuGIZbP _0xWutCdqJc"
                    ]),
                    children: /*#__PURE__*/ (0, $5chsV.jsxs)((0, $kyAKM.default), {
                        autoFocus: autoFocusLock,
                        returnFocus: returnFocus,
                        onDeactivation: onDeactivation,
                        whiteList: allowListCallback,
                        children: [
                            /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($121xR))), {}),
                            shouldScrollInViewport ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $121xR.TouchScrollable), {
                                children: modalDialogWithBlanket
                            }) : modalDialogWithBlanket
                        ]
                    })
                })
            }) : /*#__PURE__*/ (0, $5chsV.jsx)((0, $eEY7a.default), {
                children: (fadeInProps)=>/*#__PURE__*/ (0, $5chsV.jsx)("div", {
                        ...fadeInProps,
                        className: (0, $gJ6nT.default)([
                            "_39xV02qUim _0jFU0VWP8C _1mT5xdy1CL _2I62gzPgdg _3iC0zdPgdg _2WAcuGIZbP _0xWutCdqJc",
                            fadeInProps.className
                        ]),
                        "aria-hidden": !isForeground,
                        children: /*#__PURE__*/ (0, $5chsV.jsxs)((0, $kyAKM.default), {
                            autoFocus: autoFocusLock,
                            returnFocus: returnFocus,
                            onDeactivation: onDeactivation,
                            whiteList: allowListCallback,
                            children: [
                                /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($121xR))), {}),
                                shouldScrollInViewport ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $121xR.TouchScrollable), {
                                    children: modalDialogWithBlanket
                                }) : modalDialogWithBlanket
                            ]
                        })
                    })
            })
        })
    });
}); // Choose the rendering implementation at the component boundary rather than
// gating hooks inside a single component. Each implementation owns its own
// hooks unconditionally, so a runtime feature-flag change swaps component types
// (a clean remount) instead of changing the hook order of a mounted component.
const $709207ee6a47cb04$var$InternalModalWrapper = /*#__PURE__*/ (0, $fsvuC.forwardRef)((props, ref)=>{
    if ((0, $llCao.fg)('platform-dst-top-layer')) // TODO: the top-layer path does not forward the external `ref` (parity
    // with the pre-refactor behavior, where the top-layer branch never
    // consumed it). The public type still advertises `RefAttributes`, so a
    // consumer ref silently no-ops here. Follow up by forwarding `ref` to a
    // sensible element (for example the content `div`) once ref parity is
    // intentionally desired.
    return /*#__PURE__*/ (0, $5chsV.jsx)($709207ee6a47cb04$var$ModalWrapperTopLayer, {
        ...props
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)($709207ee6a47cb04$var$ModalWrapperLegacy, {
        ref: ref,
        ...props
    });
}); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $709207ee6a47cb04$export$2e2bcd8739ae039 = $709207ee6a47cb04$var$InternalModalWrapper;

});
parcelRegister("cO2CB", function(module, exports) {
$parcel$export(module.exports, "default", () => $57dd49a1413c0fd0$export$2e2bcd8739ae039);
/* blanket.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $d5Gwv = parcelRequire("d5Gwv");

var $9Tkwf = parcelRequire("9Tkwf");
const $57dd49a1413c0fd0$var$packageName = "platform-pkg";
const $57dd49a1413c0fd0$var$packageVersion = "0.0.0-use.local";
const $57dd49a1413c0fd0$var$analyticsAttributes = {
    componentName: 'blanket',
    packageName: $57dd49a1413c0fd0$var$packageName,
    packageVersion: $57dd49a1413c0fd0$var$packageVersion
};
const $57dd49a1413c0fd0$var$baseStyles = null;
const $57dd49a1413c0fd0$var$shouldAllowClickThroughStyles = null;
const $57dd49a1413c0fd0$var$invisibleStyles = null; /**
                               * __Blanket__
                               *
                               * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
                               *
                               * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
                               */ 
const $57dd49a1413c0fd0$var$Blanket = /*#__PURE__*/ (0, $fsvuC.memo)(/*#__PURE__*/ (0, $fsvuC.forwardRef)(function Blanket({ shouldAllowClickThrough: shouldAllowClickThrough = false, isTinted: isTinted = false, onBlanketClicked: onBlanketClicked = (0, $9Tkwf.default), testId: testId, children: children, analyticsContext: analyticsContext }, ref) {
    const mouseDownTarget = (0, $fsvuC.useRef)(null);
    const onBlanketClickedWithAnalytics = (0, $d5Gwv.usePlatformLeafEventHandler)({
        fn: onBlanketClicked,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$57dd49a1413c0fd0$var$analyticsAttributes
    });
    const blanketClickOutsideChildren = (0, $fsvuC.useCallback)((e)=>e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined, [
        onBlanketClickedWithAnalytics
    ]);
    const onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    const onMouseDown = (0, $fsvuC.useCallback)((e)=>{
        mouseDownTarget.current = e.target;
    }, []);
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        role: "presentation",
        onClick: onClick,
        onMouseDown: onMouseDown,
        "data-testid": testId,
        ref: ref,
        className: (0, $gJ6nT.default)([
            "_49OCfRdnbC _1mT5xdy1CL _42Yu6BN779 _0KLXruA5lS _2WAcuGIZbP _1pp6NdIZbP",
            shouldAllowClickThrough && "_1pp6NdYbGa",
            !isTinted && "_0KLXruyL8i"
        ]),
        children: children
    });
}));
$57dd49a1413c0fd0$var$Blanket.displayName = 'Blanket';
var $57dd49a1413c0fd0$export$2e2bcd8739ae039 = $57dd49a1413c0fd0$var$Blanket;

});

parcelRegister("awR7e", function(module, exports) {
$parcel$export(module.exports, "Layering", () => $a9f37339e1339247$export$7c885f891c940977);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $akVhO = parcelRequire("akVhO");

var $gc5zE = parcelRequire("gc5zE");

var $cbFSo = parcelRequire("cbFSo");

var $cgADR = parcelRequire("cgADR");
const $a9f37339e1339247$var$LevelProvider = ({ children: children, currentLevel: currentLevel, node: levelNode })=>{
    (0, $fsvuC.useEffect)(()=>{
        const levelNodeSafe = levelNode.current;
        const parentNode = levelNodeSafe.parent;
        parentNode?.addChild(levelNodeSafe);
        return ()=>{
            parentNode?.removeChild(levelNodeSafe);
        };
    }, [
        levelNode
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $gc5zE.LevelContext).Provider, {
        value: currentLevel,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $cbFSo.LevelNodeContext).Provider, {
            value: levelNode,
            children: children
        })
    });
};
$a9f37339e1339247$var$LevelProvider.displayName = "LevelProvider";
const $a9f37339e1339247$export$7c885f891c940977 = ({ children: children, isDisabled: isDisabled = true })=>{
    const currentLevel = (0, $fsvuC.useContext)((0, $gc5zE.LevelContext));
    const parentNode = (0, $fsvuC.useContext)((0, $cbFSo.LevelNodeContext));
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    const newNode = (0, $fsvuC.useRef)(new (0, $akVhO.LayerNode)(Math.random().toString(36), parentNode.current));
    if (isDisabled) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $5chsV.Fragment), {
        children: children
    });
    const isNested = currentLevel > 0;
    const content = /*#__PURE__*/ (0, $5chsV.jsx)($a9f37339e1339247$var$LevelProvider, {
        currentLevel: currentLevel + 1,
        node: newNode,
        children: children
    });
    return isNested ? content : /*#__PURE__*/ (0, $5chsV.jsx)((0, $cgADR.RootNodeContext).Provider, {
        value: newNode,
        children: content
    });
};
$a9f37339e1339247$export$7c885f891c940977.displayName = "Layering";

});
parcelRegister("akVhO", function(module, exports) {
$parcel$export(module.exports, "LayerNode", () => $a77bc2c4eca16ab4$export$da4f61fd78d35243);
class $a77bc2c4eca16ab4$export$da4f61fd78d35243 {
    constructor(id, parent){
        this.id = id;
        this.childNodes = [];
        this.parent = parent;
    }
    addChild(node) {
        this.childNodes.push(node);
    }
    removeChild(node) {
        this.childNodes = this.childNodes.filter((child)=>child.id !== node.id);
    }
    getLevel() {
        if (!this.parent) return 1;
        return this.parent.getLevel() + 1;
    }
    getHeight() {
        if (this.childNodes.length === 0) return 1;
        return Math.max(...this.childNodes.map((child)=>child.getHeight())) + 1;
    }
}
$a77bc2c4eca16ab4$export$da4f61fd78d35243.displayName = "LayerNode";

});

parcelRegister("gc5zE", function(module, exports) {
$parcel$export(module.exports, "LevelContext", () => $0271dfc67134ce9b$export$650d12d3c2ddb8fc);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $fsvuC = parcelRequire("fsvuC");
const $0271dfc67134ce9b$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $fsvuC.createContext)(0);

});

parcelRegister("cbFSo", function(module, exports) {
$parcel$export(module.exports, "LevelNodeContext", () => $1f787a02f1b12ae7$export$18f4d8b5b3a77f59);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $fsvuC = parcelRequire("fsvuC");
const $1f787a02f1b12ae7$export$18f4d8b5b3a77f59 = /*#__PURE__*/ (0, $fsvuC.createContext)({
    current: null
});

});

parcelRegister("cgADR", function(module, exports) {
$parcel$export(module.exports, "RootNodeContext", () => $aa77905676753acb$export$fa973f110e8f6ca8);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $fsvuC = parcelRequire("fsvuC");
const $aa77905676753acb$export$fa973f110e8f6ca8 = /*#__PURE__*/ (0, $fsvuC.createContext)({
    current: null
});

});


parcelRegister("2ri6P", function(module, exports) {
$parcel$export(module.exports, "createCloseEvent", () => $1bbb3481e01b1177$export$330cd73b9da5838b);
function $1bbb3481e01b1177$export$330cd73b9da5838b({ reason: reason }) {
    if (reason === 'escape') return new KeyboardEvent('keydown', {
        key: 'Escape',
        code: 'Escape',
        bubbles: true
    });
    return new MouseEvent('click', {
        bubbles: true,
        cancelable: true
    });
}

});

parcelRegister("fBYqz", function(module, exports) {
$parcel$export(module.exports, "Dialog", () => $10754d8614df5370$export$3ddf2d174ce01153);
/* dialog-content.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");

var $fsvuC = parcelRequire("fsvuC");

var $80czl = parcelRequire("80czl");

var $4twf9 = parcelRequire("4twf9");

var $dqdTY = parcelRequire("dqdTY");

var $fz4Xf = parcelRequire("fz4Xf");

var $9Tkwf = parcelRequire("9Tkwf");

var $7EsQa = parcelRequire("7EsQa");

var $iqc8V = parcelRequire("iqc8V");

var $gbYGm = parcelRequire("gbYGm");

var $8b7DD = parcelRequire("8b7DD");

var $9K6DR = parcelRequire("9K6DR");

var $0zo4h = parcelRequire("0zo4h");

var $jghzZ = parcelRequire("jghzZ");

var $lpWZj = parcelRequire("lpWZj");
// Surface reset, including `color` (the UA `dialog` rule sets `CanvasText`).
// KEEP IN SYNC with `surfaceResetStyles` in `popover/popover.tsx`.
const $10754d8614df5370$var$surfaceResetStyles = {
    root: "_16fQCjIZbP _22xN0BzUZr _31O5bFzUZr _3npKLMzUZr _1W8Jgq7p2s _1sv16BdnbC _37eVqOYbGa _0D9ajdy7kJ"
};
const $10754d8614df5370$var$dialogStyles = {
    root: "_313842IZbP _0adFHsIZbP _1DCdHiIZbP _2XsHFMIZbP _1EqgXlYbGa _1rY2tZYbGa _1uleA0Pgdg _1q5MkmPgdg _0SwjAoPgdg _22YA6yPgdg _4DVkoZIZbP _3sidotIZbP _0HFSp6YbGa _3NthtFzUZr _1hzzDPzUZr _3n2izOYbGa _2bmTl7YbGa _1Wet47YbGa _4eTLRPYbGa _2Q5CZ97dHp _3hz6pUy1CL _00JIZJdnbC _4bqM9MyL8i _0sSBqpvLZJ",
    motion: "_1kOSYtHCFx _3Z9K0wLrT7 _4f1LA5ThaV _3Y6bKpZSoF _0LqqFdYbGa _2Iz54kxlqh",
    enter: "_2fBhte18fs",
    exit: "_2fBhte9ddd"
};
const $10754d8614df5370$var$backdropStyles = {
    root: "_3OBRCTA5lS",
    hidden: "_3OBRCTyL8i",
    enter: "_3PXcY4o0Nz",
    exit: "_3PXcY4nJl0"
};
function $10754d8614df5370$var$isEscapeAllowed({ dismissedBy: dismissedBy }) {
    return dismissedBy === 'escape' || dismissedBy === 'escape-and-outside-click';
}
function $10754d8614df5370$var$isBackdropClickAllowed({ dismissedBy: dismissedBy }) {
    return dismissedBy === 'escape-and-outside-click';
}
// Whether every `<dialog>` and `[popover]` that contains the node is open. Crosses shadow roots.
function $10754d8614df5370$var$isEveryAncestorLayerOpen({ node: node }) {
    const parent = node.parentNode instanceof ShadowRoot ? node.parentNode.host : node.parentElement;
    if (!parent) return true;
    if (parent instanceof HTMLElement && (parent instanceof HTMLDialogElement || parent.hasAttribute('popover')) && !(0, $gbYGm.isNativeElementOpen)({
        element: parent
    })) return false;
    return $10754d8614df5370$var$isEveryAncestorLayerOpen({
        node: parent
    });
}
/**
 * Safety net for a direct native close (for example `dialog.close()` or a `<form method="dialog">`
 * submit), which consumers should not do. `isOpen` is the source of truth, so show it again.
 *
 * Skipped inside a closed layer: an open modal there is invisible but still makes the page inert.
 * Returns whether the dialog is open again.
 */ function $10754d8614df5370$var$reopenAfterUnaskedClose({ dialog: dialog }) {
    if (dialog.open || !$10754d8614df5370$var$isEveryAncestorLayerOpen({
        node: dialog
    })) return false;
    try {
        dialog.showModal();
    } catch  {
        return false;
    }
    return dialog.open;
}
const $10754d8614df5370$export$3ddf2d174ce01153 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(function Dialog({ children: children, isOpen: isOpen, onClose: onClose, dismissedBy: dismissedBy = 'escape-and-outside-click', onEnterFinish: onEnterFinish, onExitFinish: onExitFinish, shouldAnimate: shouldAnimate = false, xcss: consumerXcss, enteringAnimationXcss: enteringAnimationXcss, exitingAnimationXcss: exitingAnimationXcss, style: style, testId: testId, id: providedId, label: label, labelledBy: labelledBy, shouldHideBackdrop: shouldHideBackdrop }, ref) {
    const generatedId = (0, $fsvuC.useId)();
    const dialogId = providedId ?? generatedId;
    const ownRef = (0, $fsvuC.useRef)(null);
    const combinedRef = (0, $fz4Xf.default)([
        ownRef,
        ref
    ]);
    const dismissedByRef = (0, $fsvuC.useRef)(dismissedBy);
    const onCloseRef = (0, $fsvuC.useRef)(onClose);
    const isOpenRef = (0, $fsvuC.useRef)(isOpen);
    // Keep native event handlers stable while ensuring they read the latest committed props.
    (0, $7EsQa.useLayoutEffect)(()=>{
        dismissedByRef.current = dismissedBy;
        onCloseRef.current = onClose;
        isOpenRef.current = isOpen;
    }, [
        dismissedBy,
        onClose,
        isOpen
    ]);
    const { phase: phase, isMounted: isMounted, onBeforeToggle: onBeforeToggle, onToggle: onToggle } = (0, $8b7DD.useAnimatedVisibility)({
        isOpen: isOpen,
        shouldAnimate: shouldAnimate,
        elementRef: ownRef,
        onEnterFinish: onEnterFinish,
        onExitFinish: onExitFinish
    });
    // Ordering is important: bind native lifecycle listeners before the later
    // layout effect calls showModal() or close(), because `beforetoggle` fires
    // synchronously during those calls.
    (0, $7EsQa.useLayoutEffect)(()=>{
        if (!isMounted) return;
        const dialog = ownRef.current;
        if (!dialog) return;
        return (0, $dqdTY.bindAll)(dialog, [
            {
                type: 'beforetoggle',
                listener: onBeforeToggle
            },
            {
                type: 'toggle',
                listener (event) {
                    // The consumer unmounted the dialog in `onClose`. Do not schedule
                    // `onExitFinish` after unmount.
                    if (!dialog.isConnected) return;
                    // Safety net: something closed the native dialog while `isOpen` is `true`, so
                    // show it again. Runs before `onToggle`, so the exit never settles.
                    if (event.newState === 'closed' && isOpenRef.current && $10754d8614df5370$var$reopenAfterUnaskedClose({
                        dialog: dialog
                    })) return;
                    onToggle(event);
                }
            }
        ]);
    }, [
        isMounted,
        onBeforeToggle,
        onToggle
    ]);
    // Native `<dialog>.showModal()` traps focus but wraps through `<body>` at
    // the boundary (A → B → C → body → A). This hook intercepts Tab to wrap
    // directly (A → B → C → A), matching the WAI-ARIA APG pattern. Passing
    // `phase` keeps the listener attached through the animated-exit window
    // (WCAG 2.4.3 Focus Order regression guard).
    (0, $9K6DR.useFocusWrap)({
        elementRef: ownRef,
        role: 'dialog',
        phase: phase
    });
    // Notify the open layer observer so app-coordination features
    // (open-count subscriptions) work with top-layer dialogs.
    (0, $iqc8V.useNotifyOpenLayerObserver)({
        type: 'modal',
        // A close that `Dialog` did not ask about, inside a closed layer, unmounts the dialog while
        // `isOpen` stays `true`.
        isOpen: isOpen && isMounted,
        // No-op: no current use case for programmatic close via OpenLayerObserver.
        onClose: (0, $9Tkwf.default)
    });
    (0, $7EsQa.useLayoutEffect)(()=>{
        const dialog = ownRef.current;
        if (!dialog) return;
        if (isOpen) {
            if (!dialog.open) dialog.showModal();
            return ()=>{
                if (dialog.open) dialog.close();
            };
        }
        if (dialog.open) dialog.close();
    }, [
        isOpen
    ]);
    // Standard path: Escape.
    const handleEscape = (0, $fsvuC.useCallback)(()=>{
        if (!$10754d8614df5370$var$isEscapeAllowed({
            dismissedBy: dismissedByRef.current
        })) return;
        // Commit the consumer's `isOpen` answer before the keydown ends.
        (0, $80czl.flushSync)(()=>{
            onCloseRef.current({
                reason: 'escape'
            });
        });
    }, []);
    (0, $lpWZj.useEscapeKeydown)({
        dialogRef: ownRef,
        isMounted: isMounted,
        onEscape: handleEscape
    });
    // Standard path: backdrop click.
    const handleBackdropClick = (0, $fsvuC.useCallback)(()=>{
        if (!$10754d8614df5370$var$isBackdropClickAllowed({
            dismissedBy: dismissedByRef.current
        })) return;
        // Commit the consumer's `isOpen` answer before the click ends.
        (0, $80czl.flushSync)(()=>{
            onCloseRef.current({
                reason: 'overlay-click'
            });
        });
    }, []);
    (0, $0zo4h.useBackdropClick)({
        dialogRef: ownRef,
        isMounted: isMounted,
        onBackdropClick: handleBackdropClick
    });
    // Fallback: only in browsers without `closedby`.
    (0, $jghzZ.useCancelFallback)({
        dialogRef: ownRef,
        isMounted: isMounted
    });
    // Unmount the `<dialog>` once exit completes so it does not leave an
    // empty `role="dialog"` element in the accessibility tree. A later open
    // remounts a fresh element, so the listener-binding and native-visibility
    // effects run against that element.
    if (!isMounted) return null;
    const shouldAnimateBackdrop = !shouldHideBackdrop && shouldAnimate;
    return /*#__PURE__*/ (0, $5chsV.jsx)("dialog", {
        ref: combinedRef,
        id: dialogId,
        // `aria-modal` is intentionally NOT set: native `<dialog>.showModal()`
        // already conveys modal semantics to assistive tech, and double-
        // declaring it forecloses non-modal use cases (consumers calling
        // `.show()` would still appear modal). Modern AT (NVDA / JAWS /
        // VoiceOver) infer modality from the platform accessibility API.
        "aria-label": label,
        "aria-labelledby": label ? undefined : labelledBy,
        style: style,
        // The browser never closes the dialog for a user action. `Dialog` handles Escape and
        // backdrop clicks itself. Fixed, so the server and client render the same markup.
        closedby: "none",
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $gJ6nT.default)([
            // Dialog styles
            $10754d8614df5370$var$dialogStyles.root,
            $10754d8614df5370$var$surfaceResetStyles.root,
            shouldAnimate && phase === 'entering' && $10754d8614df5370$var$dialogStyles.enter,
            shouldAnimate && phase === 'exiting' && $10754d8614df5370$var$dialogStyles.exit,
            shouldAnimate && $10754d8614df5370$var$dialogStyles.motion,
            shouldHideBackdrop ? $10754d8614df5370$var$backdropStyles.hidden : $10754d8614df5370$var$backdropStyles.root,
            shouldAnimateBackdrop && phase === 'entering' && $10754d8614df5370$var$backdropStyles.enter,
            shouldAnimateBackdrop && phase === 'exiting' && $10754d8614df5370$var$backdropStyles.exit,
            (0, $4twf9.cx)(consumerXcss, shouldAnimate && phase === 'entering' && enteringAnimationXcss, shouldAnimate && phase === 'exiting' && exitingAnimationXcss)
        ]),
        children: children
    });
});

});
parcelRegister("0zo4h", function(module, exports) {
$parcel$export(module.exports, "useBackdropClick", () => $2406e37320c4a843$export$a18054e824c0afa5);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");
function $2406e37320c4a843$export$a18054e824c0afa5({ dialogRef: dialogRef, isMounted: isMounted, onBackdropClick: onBackdropClick }) {
    (0, $fsvuC.useEffect)(()=>{
        const dialog = dialogRef.current;
        if (!isMounted || !dialog) return;
        /**
		 * Matches native dialog light dismiss: the `pointerdown` and `pointerup` targets must match.
		 * A `click` alone is not enough, as it fires on the common ancestor of both targets.
		 * https://html.spec.whatwg.org/multipage/interactive-elements.html#dialog-light-dismiss
		 */ let isBackdropPress = false;
        return (0, $dqdTY.bindAll)(dialog, [
            {
                type: 'pointerdown',
                listener (event) {
                    // Primary button only. `!button`: jsdom has no `PointerEvent`, so `button` is undefined.
                    isBackdropPress = event.target === dialog && !event.button;
                }
            },
            {
                type: 'pointerup',
                listener (event) {
                    isBackdropPress = isBackdropPress && event.target === dialog;
                }
            },
            {
                type: 'pointercancel',
                listener () {
                    isBackdropPress = false;
                }
            },
            {
                type: 'click',
                listener (event) {
                    // Each press is used once.
                    const wasBackdropPress = isBackdropPress;
                    isBackdropPress = false;
                    if (!wasBackdropPress || event.target !== dialog || !dialog.open) return;
                    onBackdropClick();
                }
            }
        ]);
    }, [
        dialogRef,
        isMounted,
        onBackdropClick
    ]);
}

});

parcelRegister("jghzZ", function(module, exports) {
$parcel$export(module.exports, "useCancelFallback", () => $1690b796ea87e8f1$export$91a60beba8b292ad);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");
/**
 * Whether the browser supports the `closedby` attribute on `<dialog>`.
 *
 * Read on the client only (in an effect), so it never changes the server markup.
 */ function $1690b796ea87e8f1$var$isClosedBySupported() {
    // eslint-disable-next-line compat/compat -- every browser in the browser policy has `<dialog>`
    return 'closedBy' in HTMLDialogElement.prototype;
}
function $1690b796ea87e8f1$export$91a60beba8b292ad({ dialogRef: dialogRef, isMounted: isMounted }) {
    (0, $fsvuC.useEffect)(()=>{
        const dialog = dialogRef.current;
        if (!isMounted || !dialog || $1690b796ea87e8f1$var$isClosedBySupported()) return;
        // Native `cancel` does not bubble, so a nested dialog's `cancel` does not reach this listener.
        return (0, $dqdTY.bind)(dialog, {
            type: 'cancel',
            listener (event) {
                event.preventDefault();
            }
        });
    }, [
        dialogRef,
        isMounted
    ]);
}

});

parcelRegister("lpWZj", function(module, exports) {
$parcel$export(module.exports, "useEscapeKeydown", () => $891f9cd8aff98fc0$export$3a72a57244d6e765);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $5crEs = parcelRequire("5crEs");
function $891f9cd8aff98fc0$var$isOpenPopover(node) {
    try {
        return node instanceof HTMLElement && node.hasAttribute('popover') && node.matches(':popover-open');
    } catch  {
        // `:popover-open` is unsupported in some environments (e.g. jsdom without a polyfill).
        return false;
    }
}
// `auto` and `hint` popovers take Escape (light dismiss). A `manual` popover does not. The property
// normalizes the attribute (a bare `popover` is `auto`, values are case-insensitive).
function $891f9cd8aff98fc0$var$isOpenLightDismissPopover(node) {
    return node instanceof HTMLElement && (node.popover === 'auto' || node.popover === 'hint') && $891f9cd8aff98fc0$var$isOpenPopover(node);
}
// An open light-dismiss popover in the dialog takes the Escape, even with focus outside it.
// If the dialog canceled the keydown, the browser would not close the popover.
// `querySelectorAll` does not search shadow roots, so a popover inside a shadow root is missed
// (ADS does not use shadow roots).
function $891f9cd8aff98fc0$var$hasOpenChildPopover(dialog) {
    return Array.from(dialog.querySelectorAll('[popover]')).some($891f9cd8aff98fc0$var$isOpenLightDismissPopover);
}
// Focus is on `<body>` when the focused element was removed, or after `blur()`.
function $891f9cd8aff98fc0$var$isFocusOnBody({ event: event }) {
    return event.target instanceof HTMLBodyElement || event.target instanceof HTMLHtmlElement;
}
// The nearest `<dialog>` that contains the node, crossing shadow roots.
function $891f9cd8aff98fc0$var$getNearestDialog({ node: node }) {
    if (!node) return null;
    if (node instanceof HTMLDialogElement) return node;
    if (node instanceof ShadowRoot) return $891f9cd8aff98fc0$var$getNearestDialog({
        node: node.host
    });
    return $891f9cd8aff98fc0$var$getNearestDialog({
        node: node.parentNode
    });
}
/**
 * The dialog owns the Escape when:
 * - it is the nearest layer that takes Escape (a `<dialog>`, or an open `auto` or `hint` popover)
 *   on the composed path from the focused element, or
 * - focus is on `<body>`, and focus was last in this dialog (`wasLastFocused`).
 *
 * And it has no open light-dismiss child popover.
 */ function $891f9cd8aff98fc0$var$isOwnEscape({ dialog: dialog, event: event, wasLastFocused: wasLastFocused }) {
    if ($891f9cd8aff98fc0$var$hasOpenChildPopover(dialog)) return false;
    if ($891f9cd8aff98fc0$var$isFocusOnBody({
        event: event
    })) return wasLastFocused;
    const layer = event.composedPath().find((node)=>node instanceof HTMLDialogElement || $891f9cd8aff98fc0$var$isOpenLightDismissPopover(node));
    return layer === dialog;
}
function $891f9cd8aff98fc0$export$3a72a57244d6e765({ dialogRef: dialogRef, isMounted: isMounted, onEscape: onEscape }) {
    (0, $fsvuC.useEffect)(()=>{
        const dialog = dialogRef.current;
        if (!isMounted || !dialog) return;
        /**
		 * Whether focus was last in this dialog (and not in a nested dialog).
		 *
		 * Only the top modal can hold focus (the rest of the page is inert), so the dialog that
		 * focus was last in is the top modal. Recorded on `focusin`: removing the focused element
		 * fires no event in Firefox and WebKit, so the value stays on the dialog focus left.
		 * The dialog is already open here (`showModal()` runs in a layout effect), so start from
		 * the current focus.
		 */ let wasLastFocused = $891f9cd8aff98fc0$var$getNearestDialog({
            node: (0, $5crEs.getDeepActiveElement)({
                root: dialog.ownerDocument
            })
        }) === dialog;
        let isOwn = false;
        return (0, $dqdTY.bindAll)(window, [
            {
                type: 'focusin',
                listener (event) {
                    // At `window`, `event.target` is retargeted to the shadow host. The first node on the
                    // composed path is the focused element inside the shadow root.
                    const target = event.composedPath()[0] ?? event.target;
                    wasLastFocused = target instanceof Node && $891f9cd8aff98fc0$var$getNearestDialog({
                        node: target
                    }) === dialog;
                },
                options: {
                    capture: true
                }
            },
            {
                // Capture: the child popover is still open here.
                type: 'keydown',
                listener (event) {
                    if (event.key === 'Escape') isOwn = $891f9cd8aff98fc0$var$isOwnEscape({
                        dialog: dialog,
                        event: event,
                        wasLastFocused: wasLastFocused
                    });
                },
                options: {
                    capture: true
                }
            },
            {
                // Bubble: inner handlers run first.
                type: 'keydown',
                listener (event) {
                    // `defaultPrevented`: an inner handler took this Escape, so one press undoes one thing (as
                    // native `<dialog>`). Legacy ModalDialog closes anyway; that changes when the flag rolls out.
                    if (event.key !== 'Escape' || !isOwn || event.defaultPrevented || event.isComposing || !dialog.open) return;
                    /**
					 * Stops the browser's close request. With `closedby="none"`, the request would skip this
					 * dialog and go to the next close watcher in its group (for example a parent `auto`
					 * popover, which would close). In browsers without `closedby`, it would fire `cancel`.
					 */ event.preventDefault();
                    // A held key repeats `keydown`. Ask once per key press.
                    if (event.repeat) return;
                    onEscape();
                }
            }
        ]);
    }, [
        dialogRef,
        isMounted,
        onEscape
    ]);
}

});
parcelRegister("5crEs", function(module, exports) {
$parcel$export(module.exports, "getDeepActiveElement", () => $15246fbebdd3a0ae$export$40cd1ce44cf5ec1a);
// The focused element, inside shadow roots too.
function $15246fbebdd3a0ae$export$40cd1ce44cf5ec1a({ root: root }) {
    const activeElement = root.activeElement;
    const shadowRoot = activeElement?.shadowRoot;
    if (shadowRoot?.activeElement) return $15246fbebdd3a0ae$export$40cd1ce44cf5ec1a({
        root: shadowRoot
    });
    return activeElement;
}

});



parcelRegister("5J4vr", function(module, exports) {
$parcel$export(module.exports, "DialogScrollLock", () => $ac05adc3203babb6$export$e458030908e2d723);

var $jF8Yw = parcelRequire("jF8Yw");

var $7EsQa = parcelRequire("7EsQa");
function $ac05adc3203babb6$export$e458030908e2d723({ isOpen: isOpen }) {
    (0, $7EsQa.useLayoutEffect)(()=>{
        if (!isOpen) return;
        const body = (0, $jF8Yw.getDocument)()?.body;
        if (!body) return;
        const previousOverflow = body.style.overflow;
        body.style.overflow = 'hidden';
        return ()=>{
            body.style.overflow = previousOverflow;
        };
    }, [
        isOpen
    ]);
    return null;
}
$ac05adc3203babb6$export$e458030908e2d723.displayName = "DialogScrollLock";

});

parcelRegister("ijAKY", function(module, exports) {
$parcel$export(module.exports, "ModalContext", () => $002b4a480ea456be$export$ab57792b9b6974a6);

var $fsvuC = parcelRequire("fsvuC");
const $002b4a480ea456be$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $fsvuC.createContext)(null);

});

parcelRegister("9xWjb", function(module, exports) {
$parcel$export(module.exports, "default", () => $d810bad9e314b3c9$export$2e2bcd8739ae039);

var $fsvuC = parcelRequire("fsvuC");

var $7eFEV = parcelRequire("7eFEV");

var $aLJHG = parcelRequire("aLJHG");

var $1OLT3 = parcelRequire("1OLT3");

var $hk7fM = parcelRequire("hk7fM");
/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ const $d810bad9e314b3c9$var$modalStackRegister = [];
function $d810bad9e314b3c9$export$2e2bcd8739ae039({ onStackChange: onStackChange }) {
    const { isExiting: isExiting } = (0, $hk7fM.useExitingPersistence)();
    const [stackIndexRef, setStackIndex] = (0, $1OLT3.default)(0);
    const currentStackIndex = stackIndexRef.current;
    const previousStackIndex = (0, $aLJHG.default)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    const updateStack = (0, $7eFEV.default)(()=>{
        const newStackIndex = $d810bad9e314b3c9$var$modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, $fsvuC.useEffect)(()=>{
        const currentStackIndex = $d810bad9e314b3c9$var$modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        $d810bad9e314b3c9$var$modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        $d810bad9e314b3c9$var$modalStackRegister.splice(currentStackIndex, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        $d810bad9e314b3c9$var$modalStackRegister.forEach((cb)=>cb());
    }, [
        updateStack,
        isExiting
    ]);
    (0, $fsvuC.useEffect)(()=>()=>{
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            const currentStackIndex = $d810bad9e314b3c9$var$modalStackRegister.indexOf(updateStack);
            if (currentStackIndex !== -1) {
                $d810bad9e314b3c9$var$modalStackRegister.splice(currentStackIndex, 1);
                $d810bad9e314b3c9$var$modalStackRegister.forEach((cb)=>cb());
            }
        }, [
        updateStack
    ]);
    (0, $fsvuC.useEffect)(()=>{
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}

});
parcelRegister("7eFEV", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b821c3d216f305e$export$2e2bcd8739ae039);

var $2Qdeg = parcelRequire("2Qdeg");
function $4b821c3d216f305e$export$2e2bcd8739ae039(callback) {
    const ref = (0, $2Qdeg.default)(()=>callback);
    return ref.current;
}

});
parcelRegister("2Qdeg", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd4c5e884937eee2$export$2e2bcd8739ae039);

var $fsvuC = parcelRequire("fsvuC");
const $bd4c5e884937eee2$var$uniqueReferencedValue = {};
function $bd4c5e884937eee2$export$2e2bcd8739ae039(initializer) {
    const ref = (0, $fsvuC.useRef)($bd4c5e884937eee2$var$uniqueReferencedValue);
    if (ref.current === $bd4c5e884937eee2$var$uniqueReferencedValue) ref.current = initializer();
    return ref;
}

});


parcelRegister("aLJHG", function(module, exports) {
$parcel$export(module.exports, "default", () => $828f49d1b366e5c4$export$2e2bcd8739ae039);

var $fsvuC = parcelRequire("fsvuC");
function $828f49d1b366e5c4$export$2e2bcd8739ae039(value) {
    const ref = (0, $fsvuC.useRef)();
    (0, $fsvuC.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});

parcelRegister("1OLT3", function(module, exports) {
$parcel$export(module.exports, "default", () => $dce55cf7686947a1$export$2e2bcd8739ae039);

var $fsvuC = parcelRequire("fsvuC");
function $dce55cf7686947a1$export$2e2bcd8739ae039(initialState) {
    const [value, setValue] = (0, $fsvuC.useState)(initialState);
    const valueRef = (0, $fsvuC.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}

});


parcelRegister("8AMYy", function(module, exports) {
$parcel$export(module.exports, "default", () => $bfc59d17946bae14$export$2e2bcd8739ae039);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $bfc59d17946bae14$var$getScrollDistance() {
    return window.pageYOffset || document.documentElement?.scrollTop || document.body?.scrollTop || 0;
}
function $bfc59d17946bae14$export$2e2bcd8739ae039() {
    const [scrollTopOffset, setScrollTopOffset] = (0, $fsvuC.useState)(0);
    (0, $fsvuC.useLayoutEffect)(()=>{
        setScrollTopOffset($bfc59d17946bae14$var$getScrollDistance());
    }, []);
    const onWindowScroll = (0, $fsvuC.useCallback)(()=>{
        if ($bfc59d17946bae14$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $fsvuC.useEffect)(()=>{
        return (0, $dqdTY.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});

parcelRegister("34U9g", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForElement", () => $3c35fe54f090f27e$export$ec28e97c7d8b1b35);

var $dqdTY = parcelRequire("dqdTY");

var $iNmwK = parcelRequire("iNmwK");

var $8wYaX = parcelRequire("8wYaX");

var $9gwAL = parcelRequire("9gwAL");
function $3c35fe54f090f27e$var$watchForInteractionEnd({ stop: stop }) {
    let isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    const unbindEvents = (0, $dqdTY.bindAll)(window, [
        {
            // Another interaction is starting, this fix should be removed.
            type: 'pointerdown',
            listener: stop
        },
        {
            // The user did not start a drag
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            // if a "dragstart" occurs and the flag is not set,
            // then a drag has not started.
            // Note: could not use "pointercancel" as it is not
            // published in Safari
            // → https://bugs.webkit.org/show_bug.cgi?id=222632
            type: 'dragstart',
            listener: stopIfNotDragging,
            // Need to come after the element adapter
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // Being super clear these should only run once
        once: true
    });
    const unbindMonitor = (0, $iNmwK.monitorForElements)({
        onGenerateDragPreview () {
            isDragging = true;
        },
        onDrop () {
            isDragging = false;
            stop();
        }
    });
    return (0, $8wYaX.combine)(unbindEvents, unbindMonitor);
}
function $3c35fe54f090f27e$var$watchForInteractionStart({ start: start }) {
    return (0, $dqdTY.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener (event) {
            // Only starting if pressing down inside a draggable element
            // At this point, we are not sure which if:
            // 1. a text selection drag is starting
            // 2. a draggable managed by pdnd is going to be dragged
            // 3. a draggable not managed by pdnd is going to be dragged
            // 4. The user will be dragging anything at all (might be doing a click)
            if (event.target instanceof HTMLElement && event.target.closest('[draggable="true"]')) start();
        }
    });
}
const $3c35fe54f090f27e$var$api = (0, $9gwAL.makeFixForAdapter)({
    watchForInteractionStart: $3c35fe54f090f27e$var$watchForInteractionStart,
    watchForInteractionEnd: $3c35fe54f090f27e$var$watchForInteractionEnd
});
function $3c35fe54f090f27e$export$ec28e97c7d8b1b35() {
    return $3c35fe54f090f27e$var$api.registerUsage();
}

});
parcelRegister("9gwAL", function(module, exports) {
$parcel$export(module.exports, "makeFixForAdapter", () => $09bb9bbf1bedf9dd$export$a74bff2507e6126b);

var $8wYaX = parcelRequire("8wYaX");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $09bb9bbf1bedf9dd$var$setStyle(el, { property: property, rule: rule, priority: priority = '' }) {
    const originalValue = el.style.getPropertyValue(property);
    const originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
function $09bb9bbf1bedf9dd$var$hasSameOrigin(href1, href2) {
    let url1;
    let url2;
    try {
        url1 = new URL(href1);
        url2 = new URL(href2);
    } catch  {
        // failed to parse a href
        return false;
    }
    // https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy
    return url1.protocol === url2.protocol && url1.host === url2.host && url1.port === url2.port;
}
function $09bb9bbf1bedf9dd$var$isIframeOnAnotherDomain(iframe) {
    /**
	 * iframe with contents defined inline. Runs on the current origin.
	 * `<iframe srcdoc="<!doctype html><body>Hello</body>" />`
	 */ if (iframe.srcdoc) return false;
    /**
	 * iframe with contents defined inline. Runs on the current origin.
	 * `<iframe src={`data:text/html;charset=utf-8,${encodeURI('<!doctype html><body>Hello</body>')}`} />`
	 */ if (iframe.src.startsWith('data:')) return false;
    return !$09bb9bbf1bedf9dd$var$hasSameOrigin(window.location.href, iframe.src);
}
const $09bb9bbf1bedf9dd$var$registry = new Map();
function $09bb9bbf1bedf9dd$var$applyFix(watchForEndOfInteraction) {
    const iframes = Array.from(document.querySelectorAll('iframe')).filter($09bb9bbf1bedf9dd$var$isIframeOnAnotherDomain);
    const cleanups = iframes.map((iframe)=>{
        let entry = $09bb9bbf1bedf9dd$var$registry.get(iframe);
        if (!entry) {
            entry = {
                reset: $09bb9bbf1bedf9dd$var$setStyle(iframe, {
                    property: 'pointer-events',
                    rule: 'none',
                    priority: 'important'
                }),
                count: 1
            };
            $09bb9bbf1bedf9dd$var$registry.set(iframe, entry);
        } else // pointer-events:none already applied to the iframe
        // increment how many things requested the fix
        entry.count++;
        return function cleanup() {
            entry.count--;
            if (entry.count < 1) {
                entry.reset();
                $09bb9bbf1bedf9dd$var$registry.delete(iframe);
            }
        };
    });
    function stop() {
        cleanupWatcher();
        (0, $8wYaX.combine)(...cleanups)();
    }
    const cleanupWatcher = watchForEndOfInteraction({
        stop: stop
    });
}
function $09bb9bbf1bedf9dd$export$a74bff2507e6126b({ watchForInteractionStart: watchForInteractionStart, watchForInteractionEnd: watchForInteractionEnd }) {
    let registrationCount = 0;
    let stopWatchingInteractionStart = null;
    function start() {
        $09bb9bbf1bedf9dd$var$applyFix(watchForInteractionEnd);
    }
    function registerUsage() {
        if (registrationCount === 0) stopWatchingInteractionStart = watchForInteractionStart({
            start: start
        });
        registrationCount++;
        return function unregisterUsage() {
            registrationCount--;
            if (registrationCount !== 0) return;
            stopWatchingInteractionStart?.();
            stopWatchingInteractionStart = null;
        };
    }
    return {
        registerUsage: registerUsage
    };
}

});


parcelRegister("1NFIQ", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForExternal", () => $f1d73a376dd08a20$export$27d79116d3a4e7d5);

var $3c6LS = parcelRequire("3c6LS");

var $9gwAL = parcelRequire("9gwAL");
function $f1d73a376dd08a20$var$watchForInteractionStart({ start: start }) {
    return (0, $3c6LS.monitorForExternal)({
        onDragStart () {
            start();
        }
    });
}
function $f1d73a376dd08a20$var$watchForInteractionEnd({ stop: stop }) {
    return (0, $3c6LS.monitorForExternal)({
        onDrop () {
            stop();
        }
    });
}
const $f1d73a376dd08a20$var$api = (0, $9gwAL.makeFixForAdapter)({
    watchForInteractionStart: $f1d73a376dd08a20$var$watchForInteractionStart,
    watchForInteractionEnd: $f1d73a376dd08a20$var$watchForInteractionEnd
});
function $f1d73a376dd08a20$export$27d79116d3a4e7d5() {
    return $f1d73a376dd08a20$var$api.registerUsage();
}

});

parcelRegister("ij1dL", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForTextSelection", () => $8c9659177a13a0a7$export$9c0606fcefb5d1e2);

var $dqdTY = parcelRequire("dqdTY");

var $kwIhN = parcelRequire("kwIhN");

var $8wYaX = parcelRequire("8wYaX");

var $9gwAL = parcelRequire("9gwAL");
function $8c9659177a13a0a7$var$watchForInteractionEnd({ stop: stop }) {
    let isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    let frameId = null;
    const unbindEvents = (0, $dqdTY.bindAll)(window, [
        {
            // User is starting another interaction
            type: 'pointerdown',
            listener: stop
        },
        {
            // User did not start a drag.
            // "pointerdown" won't be fired if a drag started
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            type: 'dragstart',
            listener () {
                /**
					 * The pdnd `onDragStart()` fires in the frame after "dragstart"
					 * So we are delaying our isDragging check to give a chance
					 * for `onDragStart()` to set the value correctly.
					 *
					 * Note: could not use "pointercancel" as it is not
					 * published in Safari → https://bugs.webkit.org/show_bug.cgi?id=222632
					 */ frameId = requestAnimationFrame(()=>{
                    frameId = null;
                    stopIfNotDragging();
                });
            },
            // need to schedule our frame after the text-selection
            // adapter queues it's `onDragStart` frame.
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // being super clear these should only run once
        once: true
    });
    const unbindMonitor = (0, $kwIhN.monitorForTextSelection)({
        onDragStart () {
            isDragging = true;
        },
        onDrop () {
            isDragging = false;
            stop();
        }
    });
    return (0, $8wYaX.combine)(unbindEvents, unbindMonitor, function abortFrame() {
        if (frameId != null) cancelAnimationFrame(frameId);
    });
}
function $8c9659177a13a0a7$var$watchForInteractionStart({ start: start }) {
    return (0, $dqdTY.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener () {
            // A text selection drag will only start when there is
            // an active text selection.
            const selection = window.getSelection();
            // No selection object found
            if (!selection) return;
            // `isCollapsed` is "true" if there is currently no selected text
            if (selection.isCollapsed) return;
            start();
        }
    });
}
const $8c9659177a13a0a7$var$api = (0, $9gwAL.makeFixForAdapter)({
    watchForInteractionStart: $8c9659177a13a0a7$var$watchForInteractionStart,
    watchForInteractionEnd: $8c9659177a13a0a7$var$watchForInteractionEnd
});
function $8c9659177a13a0a7$export$9c0606fcefb5d1e2() {
    return $8c9659177a13a0a7$var$api.registerUsage();
}

});

parcelRegister("5uxBM", function(module, exports) {
$parcel$export(module.exports, "ScrollContext", () => $84ef07ff3f29a27b$export$dece24112a937f92);

var $fsvuC = parcelRequire("fsvuC");
const $84ef07ff3f29a27b$export$dece24112a937f92 = /*#__PURE__*/ (0, $fsvuC.createContext)(null);

});

parcelRegister("ifNCA", function(module, exports) {
$parcel$export(module.exports, "width", () => $6a5e4548a4310f80$export$7e3df82ee760448c);
const $6a5e4548a4310f80$export$7e3df82ee760448c = {
    values: [
        'small',
        'medium',
        'large',
        'x-large'
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        'x-large': 968
    },
    defaultValue: 'medium'
};

});

parcelRegister("kE6KB", function(module, exports) {
$parcel$export(module.exports, "default", () => $5df5f10513a7eb5d$export$2e2bcd8739ae039);
/* modal-dialog.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $dwUnm = parcelRequire("dwUnm");

var $fz4Xf = parcelRequire("fz4Xf");

var $cO4y2 = parcelRequire("cO4y2");

var $cTXsj = parcelRequire("cTXsj");

var $chnGv = parcelRequire("chnGv");

var $hZwjD = parcelRequire("hZwjD");

var $ceFHj = parcelRequire("ceFHj");

var $eEY7a = parcelRequire("eEY7a");

var $llCao = parcelRequire("llCao");

var $8wYaX = parcelRequire("8wYaX");

var $ijAKY = parcelRequire("ijAKY");

var $4J7la = parcelRequire("4J7la");

var $34U9g = parcelRequire("34U9g");

var $1NFIQ = parcelRequire("1NFIQ");

var $ij1dL = parcelRequire("ij1dL");

var $5uxBM = parcelRequire("5uxBM");

var $l3kvt = parcelRequire("l3kvt");

var $gU7xT = parcelRequire("gU7xT");

var $gLv0v = parcelRequire("gLv0v");
const $5df5f10513a7eb5d$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $5df5f10513a7eb5d$var$dialogStyles = {
    root: "_2O5VijdnbC _3YEZNO7dHp _1bHrqEIZbP _3iDTPbQ4SZ _39xV02N91d _1EqgXlqUim _0jFU0VN91d _4kiQYAdnbC _0NUa3rWP8C _0aFT5vbt8w _0KLXruoI2d _1UtDYzy7kJ _45TjwHoI2d _1pp6NdIZbP _3Sk04SOLYo _1s1YRNOLYo _3gkMN6OLYo _1ubuxonXvL _34b3D2vc3e _1NDpvb6wH8 _2wtOC9vc3e _3e11vU6wH8 _0hSAgbHZdu _28xGbQOLYo _2l47gTGk8v _2gkHrTOLYo _0iOkeGOLYo _4APJLd5dtV",
    borderRadius: "_0YcdZAyzSk",
    motion: "_0NUa3rOLYo _1EqgXlOLYo _3iDTPbQ4SZ _3GZDR8B2PM _3AHHrTN91d",
    rootMotion: "_2gkHrTIZbP _0iOkeGIZbP",
    fullscreen: "_3GZDR8N91d"
};
const $5df5f10513a7eb5d$var$viewportScrollStyles = null;
const $5df5f10513a7eb5d$var$bodyScrollStyles = null;
const $5df5f10513a7eb5d$var$ModalDialog = /*#__PURE__*/ (0, $fsvuC.forwardRef)((props, ref)=>{
    const { width: width = 'medium', shouldScrollInViewport: shouldScrollInViewport = false, shouldCloseOnEscapePress: shouldCloseOnEscapePress, autoFocus: autoFocus, stackIndex: stackIndex, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, height: height, hasProvidedOnClose: hasProvidedOnClose, children: children, label: label, testId: testId, isFullScreen: isFullScreen = false, UNSAFE_shouldDisableMotionUplift: UNSAFE_shouldDisableMotionUplift = false } = props;
    const id = (0, $cTXsj.useId)();
    const titleId = `modal-dialog-title-${id}`;
    const defaultTestId = testId || 'modal-dialog';
    (0, $fsvuC.useEffect)(()=>// Modal dialogs can appear on top of iframe elements that are on another domain.
        // There is a Chrome bug where drag and drop in an element on top of a cross domain
        // iframe is not working. We are applying the workaround for this bug in modal so
        // that consumers of our modal don't have to worry about this bug and are free to
        // create whatever drag and drop experience they like inside a modal
        //
        // Chrome bug: https://issues.chromium.org/issues/362301053
        (0, $8wYaX.combine)((0, $34U9g.disableDraggingToCrossOriginIFramesForElement)(), (0, $ij1dL.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, $1NFIQ.disableDraggingToCrossOriginIFramesForExternal)()), []);
    (0, $cO4y2.default)(autoFocus, // When a user supplies  a ref to focus we enable this hook
    typeof autoFocus === 'object');
    const [motionRef, onMotionFinish] = (0, $4J7la.default)({
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete
    });
    const modalDialogContext = (0, $fsvuC.useMemo)(()=>({
            testId: defaultTestId,
            titleId: titleId,
            onClose: onClose,
            hasProvidedOnClose: hasProvidedOnClose,
            isFullScreen: isFullScreen
        }), [
        defaultTestId,
        titleId,
        onClose,
        hasProvidedOnClose,
        isFullScreen
    ]);
    (0, $chnGv.useCloseOnEscapePress)({
        onClose: onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    const { currentLevel: currentLevel } = (0, $hZwjD.useLayering)();
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $gLv0v.default), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: defaultTestId,
        isFullScreen: isFullScreen,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $ijAKY.ModalContext).Provider, {
            value: modalDialogContext,
            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $5uxBM.ScrollContext).Provider, {
                value: shouldScrollInViewport,
                children: !UNSAFE_shouldDisableMotionUplift && (0, $llCao.fg)('platform-dst-motion-uplift-modal') ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $ceFHj.default), {
                    enteringAnimation: "var(--ds-modal-enter, 250ms cubic-bezier(0.4, 0, 0, 1) ScaleIn95to100)",
                    exitingAnimation: "var(--ds-modal-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to95)",
                    onFinish: onMotionFinish,
                    xcss: (0, $dwUnm.cx)($5df5f10513a7eb5d$var$dialogStyles.motion, isFullScreen && $5df5f10513a7eb5d$var$dialogStyles.fullscreen),
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--modal-dialog-width': (0, $gU7xT.dialogWidth)(width),
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--modal-dialog-height': (0, $l3kvt.dialogHeight)(height)
                    },
                    children: /*#__PURE__*/ (0, $5chsV.jsx)("section", {
                        "aria-label": label,
                        ref: (0, $fz4Xf.default)([
                            motionRef,
                            ref
                        ]),
                        style: {
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                            '--modal-dialog-width': (0, $gU7xT.dialogWidth)(width),
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                            '--modal-dialog-height': (0, $l3kvt.dialogHeight)(height)
                        },
                        role: "dialog",
                        "aria-labelledby": label ? undefined : titleId,
                        "data-testid": defaultTestId,
                        "data-modal-stack": stackIndex,
                        tabIndex: -1,
                        "aria-modal": true,
                        "data-ds--level": currentLevel,
                        className: (0, $gJ6nT.default)([
                            $5df5f10513a7eb5d$var$dialogStyles.root,
                            $5df5f10513a7eb5d$var$dialogStyles.rootMotion,
                            !isFullScreen && $5df5f10513a7eb5d$var$dialogStyles.borderRadius,
                            shouldScrollInViewport ? "_4kiQYAWP8C _0NUa3rYbGa _0z5aewk2yd" : "_0OpL60k2yd _0LO9FMOLYo"
                        ]),
                        children: children
                    })
                }) : /*#__PURE__*/ (0, $5chsV.jsx)((0, $eEY7a.default /**
                           * We don't want a 'slide in' for the full screen modals.
                           */ ), {
                    entranceDirection: isFullScreen ? undefined : 'bottom',
                    onFinish: onMotionFinish,
                    children: (bottomFadeInProps)=>/*#__PURE__*/ (0, $5chsV.jsx)("section", {
                            ...bottomFadeInProps,
                            "aria-label": label,
                            ref: (0, $fz4Xf.default)([
                                bottomFadeInProps.ref,
                                motionRef,
                                ref
                            ]),
                            style: {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                '--modal-dialog-width': (0, $gU7xT.dialogWidth)(width),
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                '--modal-dialog-height': (0, $l3kvt.dialogHeight)(height)
                            },
                            className: (0, $gJ6nT.default)([
                                $5df5f10513a7eb5d$var$dialogStyles.root,
                                !isFullScreen && $5df5f10513a7eb5d$var$dialogStyles.borderRadius,
                                shouldScrollInViewport ? "_4kiQYAWP8C _0NUa3rYbGa _0z5aewk2yd" : "_0OpL60k2yd _0LO9FMOLYo",
                                bottomFadeInProps.className
                            ]),
                            role: "dialog",
                            "aria-labelledby": label ? undefined : titleId,
                            "data-testid": defaultTestId,
                            "data-modal-stack": stackIndex,
                            tabIndex: -1,
                            "aria-modal": true,
                            "data-ds--level": currentLevel,
                            children: children
                        })
                })
            })
        })
    });
}); // eslint-disable-next-line @repo/internal/react/require-jsdoc, @atlaskit/volt-strict-mode/no-multiple-exports
var $5df5f10513a7eb5d$export$2e2bcd8739ae039 = $5df5f10513a7eb5d$var$ModalDialog;

});
parcelRegister("chnGv", function(module, exports) {
$parcel$export(module.exports, "useCloseOnEscapePress", () => $b45f43d674b89d1d$export$4a4bf067ea9e7886);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $hZwjD = parcelRequire("hZwjD");
const $b45f43d674b89d1d$var$ESCAPE = 'Escape';
function $b45f43d674b89d1d$export$4a4bf067ea9e7886({ onClose: onClose, isDisabled: isDisabled }) {
    const escapePressed = (0, $fsvuC.useRef)(false);
    const { isLayerDisabled: isLayerDisabled } = (0, $hZwjD.useLayering)();
    const onKeyDown = (0, $fsvuC.useCallback)((e)=>{
        const isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $b45f43d674b89d1d$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    const onKeyUp = (0, $fsvuC.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $fsvuC.useEffect)(()=>{
        return (0, $dqdTY.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}

});
parcelRegister("hZwjD", function(module, exports) {
$parcel$export(module.exports, "useLayering", () => $e23fb5a67b95d356$export$c8b4d54e03dee6ed);

var $fsvuC = parcelRequire("fsvuC");

var $gc5zE = parcelRequire("gc5zE");

var $cbFSo = parcelRequire("cbFSo");

var $cgADR = parcelRequire("cgADR");
function $e23fb5a67b95d356$export$c8b4d54e03dee6ed() {
    const currentLevel = (0, $fsvuC.useContext)((0, $gc5zE.LevelContext));
    const layerNode = (0, $fsvuC.useContext)((0, $cbFSo.LevelNodeContext));
    const rootNode = (0, $fsvuC.useContext)((0, $cgADR.RootNodeContext));
    const isLayerDisabled = (0, $fsvuC.useCallback)(()=>{
        // This is an impossible case, added for type safety
        if (!layerNode?.current || !rootNode?.current) return false;
        return layerNode.current.getLevel() < rootNode.current.getHeight();
    }, [
        layerNode,
        rootNode
    ]);
    const getTopLevel = (0, $fsvuC.useCallback)(()=>rootNode?.current ? rootNode.current.getHeight() : null, [
        rootNode
    ]);
    return {
        currentLevel: currentLevel,
        isLayerDisabled: isLayerDisabled,
        getTopLevel: getTopLevel
    };
}

});


parcelRegister("4J7la", function(module, exports) {
$parcel$export(module.exports, "default", () => $a2e277adc9b0df57$export$2e2bcd8739ae039);

var $fsvuC = parcelRequire("fsvuC");
function $a2e277adc9b0df57$export$2e2bcd8739ae039({ onOpenComplete: onOpenComplete, onCloseComplete: onCloseComplete }) {
    const motionRef = (0, $fsvuC.useRef)(null);
    const onMotionFinish = (0, $fsvuC.useCallback)((state)=>{
        if (state === 'entering' && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === 'exiting' && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
}

});

parcelRegister("l3kvt", function(module, exports) {
$parcel$export(module.exports, "dialogHeight", () => $3e4c705e2f9ac889$export$ceba93bf0bdd16f2);
const $3e4c705e2f9ac889$export$ceba93bf0bdd16f2 = (input)=>{
    if (!input) return 'auto';
    return typeof input === 'number' ? `${input}px` : input;
};

});

parcelRegister("gU7xT", function(module, exports) {
$parcel$export(module.exports, "dialogWidth", () => $c98ea5cd1edb53dc$export$a3da89b899389ed8);

var $ifNCA = parcelRequire("ifNCA");
const $c98ea5cd1edb53dc$export$a3da89b899389ed8 = (input)=>{
    if (!input) return 'auto';
    const isWidthName = (0, $ifNCA.width).values.indexOf(input.toString()) !== -1;
    const widthName = isWidthName && input;
    if (widthName) return `${(0, $ifNCA.width).widths[widthName]}px`;
    return typeof input === 'number' ? `${input}px` : input;
};

});

parcelRegister("gLv0v", function(module, exports) {
$parcel$export(module.exports, "default", () => $73e26e707b56bdaa$export$2e2bcd8739ae039);
/* positioner.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");


var $ciGt1 = parcelRequire("ciGt1");
// Flex and min-content are set to constrain the height of the body and support multi-column scrolling experiences
const $73e26e707b56bdaa$var$positionerStyles = null;
const $73e26e707b56bdaa$var$stackStyles = {
    stackTransition: "_1kOSYtC67X _39Ohv4YbGa _1SdfoHYbGa",
    stackTransform: "_1VJPcamUxd",
    stackIdle: "_1VJPcaYbGa"
};
// Hardcoded pixels are based off a 60px base gutter
const $73e26e707b56bdaa$var$scrollStyles = {
    viewport: "_0jFU0VIZbP _1mT5xdRAKS _3ns3u9fI2J _3lqkkiIZbP _0Y3dgaYbGa",
    body: "_28xGbQw4ra _0Wik48UMig _2fj8asWVPG _0m5YQyahDP _4pesVsdnbC _3GyDTtdnbC _2gkHrTIZbP _0iOkeGIZbP _0Y3dgaYbGa",
    fullScreen: ""
};
function $73e26e707b56bdaa$var$getScrollBehavior({ isFullScreen: isFullScreen, shouldScrollInViewport: shouldScrollInViewport }) {
    if (isFullScreen) return 'fullScreen';
    if (shouldScrollInViewport) return 'viewport';
    return 'body';
}
const $73e26e707b56bdaa$var$Positioner = (props)=>{
    const { children: children, stackIndex: stackIndex, shouldScrollInViewport: shouldScrollInViewport, testId: testId, isFullScreen: isFullScreen } = props;
    const scrollBehavior = $73e26e707b56bdaa$var$getScrollBehavior({
        isFullScreen: isFullScreen,
        shouldScrollInViewport: shouldScrollInViewport
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        style: {
            '--modal-dialog-translate-y': `calc(${stackIndex}px * ${"var(--ds-space-100, 8px)"})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            transitionDuration: `${(0, $ciGt1.durations).medium}ms`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            transitionTimingFunction: (0, $ef43174c6184897f$export$c07234257a03d5e9)
        },
        "data-testid": testId && `${testId}--positioner`,
        className: (0, $gJ6nT.default)([
            "_3iDTPbQ4SZ _39xV02N91d _1EqgXlN91d _0jFU0VN91d _1mT5xdy1CL _42Yu6BFIQA _0aFT5vbt8w _2I62gzdnbC _3iC0zddnbC",
            $73e26e707b56bdaa$var$stackStyles.stackTransition,
            stackIndex > 0 ? $73e26e707b56bdaa$var$stackStyles.stackTransform : $73e26e707b56bdaa$var$stackStyles.stackIdle,
            $73e26e707b56bdaa$var$scrollStyles[scrollBehavior]
        ]),
        children: children
    });
};
$73e26e707b56bdaa$var$Positioner.displayName = "Positioner";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$73e26e707b56bdaa$export$2e2bcd8739ae039 = $73e26e707b56bdaa$var$Positioner;

});
const $ef43174c6184897f$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $ef43174c6184897f$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $ef43174c6184897f$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
const $ef43174c6184897f$export$fc825baa2ef870d0 = 'cubic-bezier(0.4,0,0,1)';
const $ef43174c6184897f$export$816ee5d79b5bd9a5 = 'cubic-bezier(0.6,0,0,1)';
const $ef43174c6184897f$export$53ce3390a1a8f2a2 = 'cubic-bezier(0.8,0,0,1)';
const $ef43174c6184897f$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';





parcelRegister("g9Smr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $0536e05eec42599f$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $lfw4f = parcelRequire("lfw4f");
/**
 * __Modal transition__
 *
 * A modal transition wraps a modal to provide a fluid transition upon opening and closing.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $0536e05eec42599f$var$ModalTransition = (props)=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $lfw4f.default), {
        appear: true,
        children: //Checking if children are undefined to prevent potential runtime errors in React 17
        props.children ?? null
    });
};
$0536e05eec42599f$var$ModalTransition.displayName = "ModalTransition";
var $0536e05eec42599f$export$2e2bcd8739ae039 = $0536e05eec42599f$var$ModalTransition;

});

parcelRegister("79e8h", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $c542095348fb4f31$export$2e2bcd8739ae039);
/* modal-header.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");
parcelRequire("fsvuC");

var $jR7Rq = parcelRequire("jR7Rq");

var $93IrE = parcelRequire("93IrE");

var $2rTAp = parcelRequire("2rTAp");
const $c542095348fb4f31$var$styles = {
    header: "_2Y7lL4NHnM _3iDTPbQ4SZ _1mT5xdRAKS _0hPCNLDIqT _37wbyuI7V3 _0rIjykLl21 _0xmtko5zaO _46hvQmNHnM",
    flex: "_0aFT5vf5Xk _39xV02N91d",
    titleContainer: "_4ouGXIdnbC"
};
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $c542095348fb4f31$var$ModalHeader = (props)=>{
    const { children: children, testId: userDefinedTestId, hasCloseButton: hasCloseButton = false, closeButtonLabel: closeButtonLabel } = props;
    const { hasProvidedOnClose: hasProvidedOnClose, onClose: onClose, testId: modalTestId } = (0, $2rTAp.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--header`;
    // Only show if an onClose was provided for the modal dialog
    const shouldShowCloseButton = hasCloseButton && hasProvidedOnClose && onClose;
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        "data-testid": testId,
        className: (0, $gJ6nT.default)([
            $c542095348fb4f31$var$styles.header
        ]),
        children: shouldShowCloseButton ? /*#__PURE__*/ (0, $5chsV.jsxs)((0, $jR7Rq.Flex), {
            gap: "space.200",
            justifyContent: "space-between",
            xcss: $c542095348fb4f31$var$styles.flex,
            children: [
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $jR7Rq.Flex), {
                    justifyContent: "end",
                    children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $93IrE.CloseButton), {
                        label: closeButtonLabel,
                        onClick: onClose,
                        testId: modalTestId
                    })
                }),
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $jR7Rq.Flex), {
                    justifyContent: "start",
                    alignItems: "center",
                    xcss: $c542095348fb4f31$var$styles.titleContainer,
                    children: children
                })
            ]
        }) : children
    });
};
$c542095348fb4f31$var$ModalHeader.displayName = "ModalHeader";
var $c542095348fb4f31$export$2e2bcd8739ae039 = $c542095348fb4f31$var$ModalHeader;

});
parcelRegister("93IrE", function(module, exports) {
$parcel$export(module.exports, "CloseButton", () => $192f9e93e3641e80$export$de65de8213222d10);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $kfsyS = parcelRequire("kfsyS");

var $irYrv = parcelRequire("irYrv");
const $192f9e93e3641e80$export$de65de8213222d10 = ({ label: label, onBlur: onBlur, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $kfsyS.default), {
        testId: testId && `${testId}--close-button`,
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($irYrv))),
        label: label || 'Close Modal',
        onBlur: onBlur,
        onClick: onClick
    });
$192f9e93e3641e80$export$de65de8213222d10.displayName = "CloseButton";

});

parcelRegister("2rTAp", function(module, exports) {
$parcel$export(module.exports, "useModal", () => $e7bd4172f3620e1a$export$33ffd74ebf07f060);

var $fsvuC = parcelRequire("fsvuC");

var $ijAKY = parcelRequire("ijAKY");
const $e7bd4172f3620e1a$export$33ffd74ebf07f060 = ()=>{
    const modalContext = (0, $fsvuC.useContext)((0, $ijAKY.ModalContext));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};

});


parcelRegister("fTkoK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $46a62a56a1fa6f14$export$2e2bcd8739ae039);
/* modal-title.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $6Pb6R = parcelRequire("6Pb6R");

var $gD3tC = parcelRequire("gD3tC");

var $2rTAp = parcelRequire("2rTAp");
const $46a62a56a1fa6f14$var$iconColor = {
    danger: "var(--ds-icon-danger, #C9372C)",
    warning: "var(--ds-icon-warning, #E06C00)"
};
const $46a62a56a1fa6f14$var$iconStyles = null;
const $46a62a56a1fa6f14$var$titleStyles = null;
const $46a62a56a1fa6f14$var$textStyles = null;
const $46a62a56a1fa6f14$var$truncatedTextStyles = null;
const $46a62a56a1fa6f14$var$TitleIcon = ({ appearance: appearance })=>{
    const Icon = appearance === 'danger' ? (0, (/*@__PURE__*/$parcel$interopDefault($6Pb6R))) : (0, (/*@__PURE__*/$parcel$interopDefault($gD3tC)));
    return /*#__PURE__*/ (0, $5chsV.jsx)("span", {
        className: (0, $gJ6nT.default)([
            "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP _1UtDYzOLYo _4ya3eEOLYo _2l4i3rOLYo _1kk5TkOLYo _3iugoSOLYo _26BoRwOLYo"
        ]),
        children: /*#__PURE__*/ (0, $5chsV.jsx)(Icon, {
            label: appearance,
            color: $46a62a56a1fa6f14$var$iconColor[appearance],
            spacing: "spacious"
        })
    });
};
$46a62a56a1fa6f14$var$TitleIcon.displayName = "TitleIcon";
/**
 * __Modal title__
 *
 * A modal title is used to display a title within a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $46a62a56a1fa6f14$var$ModalTitle = (props)=>{
    const { appearance: appearance, children: children, isMultiline: isMultiline = true, testId: userDefinedTestId } = props;
    const { titleId: titleId, testId: modalTestId } = (0, $2rTAp.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--title`;
    return /*#__PURE__*/ (0, $5chsV.jsxs)("h1", {
        "data-testid": testId,
        className: (0, $gJ6nT.default)([
            "_2mHwu82ADO _2sNsIgWSk4 _3iDTPbQ4SZ _4ouGXIdnbC _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg"
        ]),
        children: [
            appearance && /*#__PURE__*/ (0, $5chsV.jsx)($46a62a56a1fa6f14$var$TitleIcon, {
                appearance: appearance
            }),
            /*#__PURE__*/ (0, $5chsV.jsx)("span", {
                id: titleId,
                "data-testid": testId && `${testId}-text`,
                className: (0, $gJ6nT.default)([
                    "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _2sNsIgWSk4 _4ouGXIdnbC _1T2N03wPeg",
                    !isMultiline && "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7"
                ]),
                children: children
            })
        ]
    });
};
$46a62a56a1fa6f14$var$ModalTitle.displayName = "ModalTitle";
var $46a62a56a1fa6f14$export$2e2bcd8739ae039 = $46a62a56a1fa6f14$var$ModalTitle;

});

parcelRegister("kJ3Vl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $5d1f805737ad19a1$export$2e2bcd8739ae039);
/* modal-body.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");
parcelRequire("fsvuC");

var $121xR = parcelRequire("121xR");

var $2rTAp = parcelRequire("2rTAp");

var $4ESUR = parcelRequire("4ESUR");

var $i5jTu = parcelRequire("i5jTu");
const $5d1f805737ad19a1$var$styles = {
    root: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _2sNsIgmnOE",
    paddingBlock: "_4c065UFQfX",
    paddingInline: "_2Y7lL4NHnM"
};
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $5d1f805737ad19a1$var$ModalBody = (props)=>{
    const { children: children, testId: userDefinedTestId, hasInlinePadding: hasInlinePadding = true } = props;
    const { testId: modalTestId } = (0, $2rTAp.useModal)();
    const shouldScrollInViewport = (0, $i5jTu.default)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--body`;
    return shouldScrollInViewport ? /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        "data-testid": testId,
        className: (0, $gJ6nT.default)([
            $5d1f805737ad19a1$var$styles.root,
            hasInlinePadding && $5d1f805737ad19a1$var$styles.paddingInline
        ]),
        children: children
    }) : /*#__PURE__*/ (0, $5chsV.jsx)((0, $121xR.TouchScrollable), {
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $4ESUR.default), {
            testId: userDefinedTestId || modalTestId,
            children: /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                "data-testid": testId,
                className: (0, $gJ6nT.default)([
                    $5d1f805737ad19a1$var$styles.root,
                    /**
       * Adding block padding for scroll keylines, which are only shown when the scrolling
       * is on the container.
       */ $5d1f805737ad19a1$var$styles.paddingBlock,
                    hasInlinePadding && $5d1f805737ad19a1$var$styles.paddingInline
                ]),
                children: children
            })
        })
    });
};
$5d1f805737ad19a1$var$ModalBody.displayName = "ModalBody";
var $5d1f805737ad19a1$export$2e2bcd8739ae039 = $5d1f805737ad19a1$var$ModalBody;

});
parcelRegister("4ESUR", function(module, exports) {
$parcel$export(module.exports, "default", () => $96504a49d43e3727$export$2e2bcd8739ae039);
/* scroll-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $hMOFt = parcelRequire("hMOFt");

var $dwUnm = parcelRequire("dwUnm");

var $fz4Xf = parcelRequire("fz4Xf");

var $9Tkwf = parcelRequire("9Tkwf");

var $7eFEV = parcelRequire("7eFEV");

var $iLp2b = parcelRequire("iLp2b");
const $96504a49d43e3727$var$keylineColor = "var(--ds-border, #0B120E24)";
const $96504a49d43e3727$var$styles = {
    base: "_1ma2CfOLYo _3iDTPbOLYo _0aFT5vOLYo _2O5Vij7dHp _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _4bt5LAnQyn _2WAcuGIZbP _3GZDR8ZqHV _2aYxTvIZbP",
    topKeyline: "_1v3aPqOeNX",
    bottomKeyline: "_2R4pr3OeNX"
};
const $96504a49d43e3727$var$keylineHeight = 1;
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ const $96504a49d43e3727$var$ScrollContainer = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ testId: testId, children: children }, ref)=>{
    const scrollableRef = (0, $fsvuC.useRef)(null);
    const [showTopKeyline, setTopKeyline] = (0, $fsvuC.useState)(false);
    const [showBottomKeyline, setBottomKeyline] = (0, $fsvuC.useState)(false);
    const [showContentFocus, setContentFocus] = (0, $fsvuC.useState)(false);
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $fsvuC.useEffect)(()=>{
        const schedule = (0, $hMOFt.default)(()=>{
            const target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        });
        schedule();
    }, [
        scrollableRef
    ]);
    const setLazyKeylines = (0, $7eFEV.default)((0, $hMOFt.default)(()=>{
        const target = scrollableRef.current;
        if (target) {
            const scrollableDistance = target.scrollHeight - target.clientHeight;
            if (target.previousElementSibling) setTopKeyline(target.scrollTop > $96504a49d43e3727$var$keylineHeight);
            if (target.nextElementSibling) setBottomKeyline(target.scrollTop <= scrollableDistance - $96504a49d43e3727$var$keylineHeight);
        }
    }));
    // On load (and scroll/resize events), we set "keylines"
    // these border the content to indicate scrollability when content underflows the header or footer
    (0, $fsvuC.useEffect)(()=>{
        const target = scrollableRef.current;
        setLazyKeylines();
        const unbindWindowEvent = (0, $dqdTY.bind)(window, {
            type: 'resize',
            listener: setLazyKeylines
        });
        const unbindTargetEvent = target ? (0, $dqdTY.bind)(target, {
            type: 'scroll',
            listener: setLazyKeylines
        }) : (0, $9Tkwf.default);
        return ()=>{
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyKeylines
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $iLp2b.Focusable), {
        as: "div",
        isInset: true,
        // tabindex is allowed here so that keyboard users can scroll content
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? 'region' : undefined,
        "aria-label": showContentFocus ? 'Scrollable content' : undefined,
        testId: testId && `${testId}--scrollable`,
        ref: (0, $fz4Xf.default)([
            ref,
            scrollableRef
        ]),
        xcss: (0, $dwUnm.cx)($96504a49d43e3727$var$styles.base, showTopKeyline && $96504a49d43e3727$var$styles.topKeyline, showBottomKeyline && $96504a49d43e3727$var$styles.bottomKeyline),
        children: children
    });
});
$96504a49d43e3727$var$ScrollContainer.displayName = 'ScrollContainer';
var $96504a49d43e3727$export$2e2bcd8739ae039 = $96504a49d43e3727$var$ScrollContainer;

});

parcelRegister("i5jTu", function(module, exports) {
$parcel$export(module.exports, "default", () => $35da66a23acb9cb9$export$2e2bcd8739ae039);

var $fsvuC = parcelRequire("fsvuC");

var $5uxBM = parcelRequire("5uxBM");
function $35da66a23acb9cb9$export$2e2bcd8739ae039() {
    const shouldScrollInViewport = (0, $fsvuC.useContext)((0, $5uxBM.ScrollContext));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}

});


parcelRegister("djI0m", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $7c017ee66964f1ae$export$2e2bcd8739ae039);
/* modal-footer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $2rTAp = parcelRequire("2rTAp");
const $7c017ee66964f1ae$var$footerStyles = null;
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $7c017ee66964f1ae$var$ModalFooter = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $2rTAp.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--footer`;
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        "data-testid": testId,
        className: (0, $gJ6nT.default)([
            "_2mHwu82ADO _2Y7lL4NHnM _3iDTPbQ4SZ _1mT5xdRAKS _0hPCNLDIqT _37wbyuz9WS _43nrzTLl21 _0xmtkoNHnM _46hvQm5zaO"
        ]),
        children: children
    });
};
$7c017ee66964f1ae$var$ModalFooter.displayName = "ModalFooter";
var $7c017ee66964f1ae$export$2e2bcd8739ae039 = $7c017ee66964f1ae$var$ModalFooter;

});

parcelRegister("2jeEB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::403d648a4ec6dc7540968c496b0b831a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1ae8b91677446cef$var$_react = $1ae8b91677446cef$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $1ae8b91677446cef$var$_iconNew = $1ae8b91677446cef$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $1ae8b91677446cef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Dashboard".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/dashboard
 * Usage guidance:
 * Single purpose - Reserved for dashboards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1ae8b91677446cef$var$DashboardIcon = (props)=>/*#__PURE__*/ $1ae8b91677446cef$var$_react.default.createElement($1ae8b91677446cef$var$_iconNew.default, Object.assign({
        name: "DashboardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h4.25v-11zm5.75 0v4.75h4.75V3a.5.5 0 0 0-.5-.5zm4.75 6.25H8.75v4.75H13a.5.5 0 0 0 .5-.5zM1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$1ae8b91677446cef$var$DashboardIcon.displayName = 'DashboardIcon';
var $1ae8b91677446cef$var$_default = module.exports.default = $1ae8b91677446cef$var$DashboardIcon;

});

parcelRegister("hdkV2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::07ce97dc138cd4f55e8a1bb0a6f266b9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c883e0a5a45fe2e5$var$_react = $c883e0a5a45fe2e5$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $c883e0a5a45fe2e5$var$_iconNew = $c883e0a5a45fe2e5$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $c883e0a5a45fe2e5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Add".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/add
 * Usage guidance:
 * Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c883e0a5a45fe2e5$var$AddIcon = (props)=>/*#__PURE__*/ $c883e0a5a45fe2e5$var$_react.default.createElement($c883e0a5a45fe2e5$var$_iconNew.default, Object.assign({
        name: "AddIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.75 1.5v5.75h5.75v1.5H8.75v5.75h-1.5V8.75H1.5v-1.5h5.75V1.5z"/>`
    }, props));
$c883e0a5a45fe2e5$var$AddIcon.displayName = 'AddIcon';
var $c883e0a5a45fe2e5$var$_default = module.exports.default = $c883e0a5a45fe2e5$var$AddIcon;

});

parcelRegister("3Zxrq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d485ff62f9140a59decb65646f9f10e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2e81025b4c9c517f$var$_react = $2e81025b4c9c517f$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $2e81025b4c9c517f$var$_iconNew = $2e81025b4c9c517f$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $2e81025b4c9c517f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/arrow-left
 * Usage guidance:
 * Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2e81025b4c9c517f$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $2e81025b4c9c517f$var$_react.default.createElement($2e81025b4c9c517f$var$_iconNew.default, Object.assign({
        name: "ArrowLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.22 7.47 5-5 1.06 1.06-3.72 3.72H15v1.5H3.56l3.72 3.72-1.06 1.06-5-5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$2e81025b4c9c517f$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $2e81025b4c9c517f$var$_default = module.exports.default = $2e81025b4c9c517f$var$ArrowLeftIcon;

});

parcelRegister("6UDJ1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::790216e1b1c39b618aa630400c4ea535>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5086c9a0e8e3ee15$var$_react = $5086c9a0e8e3ee15$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $5086c9a0e8e3ee15$var$_iconNew = $5086c9a0e8e3ee15$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $5086c9a0e8e3ee15$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/check-circle
 * Usage guidance:
 * Known uses: completed items, productivity emoji category. Completed task work type in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5086c9a0e8e3ee15$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $5086c9a0e8e3ee15$var$_react.default.createElement($5086c9a0e8e3ee15$var$_iconNew.default, Object.assign({
        name: "CheckCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0m-2.174-2.52-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308zM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/>`
    }, props));
$5086c9a0e8e3ee15$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $5086c9a0e8e3ee15$var$_default = module.exports.default = $5086c9a0e8e3ee15$var$CheckCircleIcon;

});

parcelRegister("cklu4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::289e45520b45682e3c0f255c5bc3a3e5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8f98049692c988c8$var$_react = $8f98049692c988c8$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $8f98049692c988c8$var$_iconNew = $8f98049692c988c8$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $8f98049692c988c8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CreditCard".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/credit-card
 * Usage guidance:
 * Multi purpose - Known uses: billing in Admin, invoices in PPC, payments.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8f98049692c988c8$var$CreditCardIcon = (props)=>/*#__PURE__*/ $8f98049692c988c8$var$_react.default.createElement($8f98049692c988c8$var$_iconNew.default, Object.assign({
        name: "CreditCardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1.5h13V4a.5.5 0 0 0-.5-.5zM14.5 7h-13v5a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zM9 9.5h4V11H9z" clip-rule="evenodd"/>`
    }, props));
$8f98049692c988c8$var$CreditCardIcon.displayName = 'CreditCardIcon';
var $8f98049692c988c8$var$_default = module.exports.default = $8f98049692c988c8$var$CreditCardIcon;

});

parcelRegister("gUoEG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::23550e9a9f6f237ba15b0b9afdf2850e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4f5004c159be631$var$_react = $c4f5004c159be631$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $c4f5004c159be631$var$_iconNew = $c4f5004c159be631$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $c4f5004c159be631$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/cross-circle
 * Usage guidance:
 * Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c4f5004c159be631$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $c4f5004c159be631$var$_react.default.createElement($c4f5004c159be631$var$_iconNew.default, Object.assign({
        name: "CrossCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0m0 6.94L5.03 3.97 3.97 5.03 6.94 8l-2.97 2.97 1.06 1.06L8 9.06l2.97 2.97 1.06-1.06L9.06 8l2.97-2.97-1.06-1.06z" clip-rule="evenodd"/>`
    }, props));
$c4f5004c159be631$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $c4f5004c159be631$var$_default = module.exports.default = $c4f5004c159be631$var$CrossCircleIcon;

});

parcelRegister("fE6ce", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0cdb9e6baa42be79f49a55523cb2c1b4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b63f65e16945ca81$var$_react = $b63f65e16945ca81$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $b63f65e16945ca81$var$_iconNew = $b63f65e16945ca81$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $b63f65e16945ca81$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShowMoreHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/show-more-horizontal
 * Usage guidance:
 * Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b63f65e16945ca81$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $b63f65e16945ca81$var$_react.default.createElement($b63f65e16945ca81$var$_iconNew.default, Object.assign({
        name: "ShowMoreHorizontalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m6.5 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M13 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$b63f65e16945ca81$var$ShowMoreHorizontalIcon.displayName = 'ShowMoreHorizontalIcon';
var $b63f65e16945ca81$var$_default = module.exports.default = $b63f65e16945ca81$var$ShowMoreHorizontalIcon;

});

parcelRegister("kwWcS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f9c38bfa054ce139eb4eb1d828621cdf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ef23f26dd3fb839f$var$_react = $ef23f26dd3fb839f$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $ef23f26dd3fb839f$var$_iconNew = $ef23f26dd3fb839f$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $ef23f26dd3fb839f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Clock".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/clock
 * Usage guidance:
 * Known uses: recent, time input, sprint time remaining, overdue task work type status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ef23f26dd3fb839f$var$ClockIcon = (props)=>/*#__PURE__*/ $ef23f26dd3fb839f$var$_react.default.createElement($ef23f26dd3fb839f$var$_iconNew.default, Object.assign({
        name: "ClockIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0M8.75 3.25v4.389l2.219 1.775-.938 1.172-2.5-2-.281-.226V3.25zM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/>`
    }, props));
$ef23f26dd3fb839f$var$ClockIcon.displayName = 'ClockIcon';
var $ef23f26dd3fb839f$var$_default = module.exports.default = $ef23f26dd3fb839f$var$ClockIcon;

});

parcelRegister("edN4B", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::455ddf841838a21b0f783ea6448b0f9c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a5a858860203907a$var$_react = $a5a858860203907a$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $a5a858860203907a$var$_iconNew = $a5a858860203907a$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $a5a858860203907a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Search".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/search
 * Usage guidance:
 * Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a5a858860203907a$var$SearchIcon = (props)=>/*#__PURE__*/ $a5a858860203907a$var$_react.default.createElement($a5a858860203907a$var$_iconNew.default, Object.assign({
        name: "SearchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 2.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M1 7a6 6 0 1 1 10.74 3.68l3.29 3.29-1.06 1.06-3.29-3.29A6 6 0 0 1 1 7" clip-rule="evenodd"/>`
    }, props));
$a5a858860203907a$var$SearchIcon.displayName = 'SearchIcon';
var $a5a858860203907a$var$_default = module.exports.default = $a5a858860203907a$var$SearchIcon;

});

parcelRegister("hQpu3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bfb96ac8121d6e86aa07f23b47de6511>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cfdb0f8e3cbcf032$var$_react = $cfdb0f8e3cbcf032$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $cfdb0f8e3cbcf032$var$_iconNew = $cfdb0f8e3cbcf032$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $cfdb0f8e3cbcf032$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Settings".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/settings
 * Usage guidance:
 * Single purpose - Reserved for any object or user settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cfdb0f8e3cbcf032$var$SettingsIcon = (props)=>/*#__PURE__*/ $cfdb0f8e3cbcf032$var$_react.default.createElement($cfdb0f8e3cbcf032$var$_iconNew.default, Object.assign({
        name: "SettingsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.058.462A.75.75 0 0 1 6.75 0h2.5a.75.75 0 0 1 .692.462l1.026 2.462 2.578-.374a.75.75 0 0 1 .757.367l1.25 2.166a.75.75 0 0 1-.049.824L13.937 8l1.567 2.093c.18.24.2.565.05.825l-1.25 2.165a.75.75 0 0 1-.758.367l-2.578-.374-1.026 2.463A.75.75 0 0 1 9.25 16h-2.5a.75.75 0 0 1-.692-.461l-1.026-2.463-2.578.374a.75.75 0 0 1-.757-.367l-1.25-2.165a.75.75 0 0 1 .049-.825L2.063 8 .496 5.907a.75.75 0 0 1-.05-.824l1.25-2.166a.75.75 0 0 1 .758-.367l2.578.374zM7.25 1.5l-.871 2.09c-.242.58-.845.923-1.467.833l-2.17-.315-.749 1.296L3.32 7.176c.366.488.366 1.16 0 1.648l-1.327 1.772.749 1.296 2.17-.315a1.375 1.375 0 0 1 1.467.832L7.25 14.5h1.5l.871-2.09c.242-.58.845-.923 1.467-.833l2.17.315.749-1.296-1.327-1.772a1.375 1.375 0 0 1 0-1.648l1.327-1.772-.749-1.296-2.17.315A1.375 1.375 0 0 1 9.62 3.59L8.75 1.5zm.75 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$cfdb0f8e3cbcf032$var$SettingsIcon.displayName = 'SettingsIcon';
var $cfdb0f8e3cbcf032$var$_default = module.exports.default = $cfdb0f8e3cbcf032$var$SettingsIcon;

});

parcelRegister("jbwic", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a56ed314940e96507f3d40e0a0c01e78>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $df78180ad2d43de2$var$_react = $df78180ad2d43de2$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $df78180ad2d43de2$var$_iconNew = $df78180ad2d43de2$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $df78180ad2d43de2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Filter".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/filter
 * Usage guidance:
 * Single purpose - Reserved for filterting data or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $df78180ad2d43de2$var$FilterIcon = (props)=>/*#__PURE__*/ $df78180ad2d43de2$var$_react.default.createElement($df78180ad2d43de2$var$_iconNew.default, Object.assign({
        name: "FilterIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11 12v1.5H5V12zm2-4.75v1.5H3v-1.5zm2-4.75V4H1V2.5z"/>`
    }, props));
$df78180ad2d43de2$var$FilterIcon.displayName = 'FilterIcon';
var $df78180ad2d43de2$var$_default = module.exports.default = $df78180ad2d43de2$var$FilterIcon;

});

parcelRegister("byNe2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7bd0b1f6d8e717040c997f247b7acc7d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $86a90dd3b1529e2e$var$_react = $86a90dd3b1529e2e$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $86a90dd3b1529e2e$var$_iconNew = $86a90dd3b1529e2e$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $86a90dd3b1529e2e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notification".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/notification
 * Usage guidance:
 * Single purpose - Reserved for notifications within global app navigation and within app screens.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $86a90dd3b1529e2e$var$NotificationIcon = (props)=>/*#__PURE__*/ $86a90dd3b1529e2e$var$_react.default.createElement($86a90dd3b1529e2e$var$_iconNew.default, Object.assign({
        name: "NotificationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6.42 13.5a1.748 1.748 0 0 0 3.16 0zM4.5 8.636c0 .215-.06.426-.175.608L2.603 12h10.795l-1.723-2.756a1.15 1.15 0 0 1-.175-.608V5a3.5 3.5 0 0 0-7 0zm8.5-.1 1.788 2.86a1.375 1.375 0 0 1-1.166 2.104h-2.46a3.25 3.25 0 0 1-6.324 0h-2.46a1.375 1.375 0 0 1-1.166-2.104L3 8.537V5a5 5 0 0 1 10 0z"/>`
    }, props));
$86a90dd3b1529e2e$var$NotificationIcon.displayName = 'NotificationIcon';
var $86a90dd3b1529e2e$var$_default = module.exports.default = $86a90dd3b1529e2e$var$NotificationIcon;

});

parcelRegister("9sBmE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1823cfe9afabe77ba419bd26f71a4aac>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6e33b660ecc29b11$var$_react = $6e33b660ecc29b11$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $6e33b660ecc29b11$var$_iconNew = $6e33b660ecc29b11$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $6e33b660ecc29b11$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAvatar".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/person-avatar
 * Usage guidance:
 * Single purpose - Reserved for user avatar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6e33b660ecc29b11$var$PersonAvatarIcon = (props)=>/*#__PURE__*/ $6e33b660ecc29b11$var$_react.default.createElement($6e33b660ecc29b11$var$_iconNew.default, Object.assign({
        name: "PersonAvatarIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 0 0-4.148 11.505A2.75 2.75 0 0 1 6.5 11h3c1.26 0 2.323.848 2.648 2.005A6.5 6.5 0 0 0 8 1.5m2.75 12.392v-.142c0-.69-.56-1.25-1.25-1.25h-3c-.69 0-1.25.56-1.25 1.25v.142l.06.027c.82.373 1.73.581 2.69.581s1.87-.208 2.69-.58q.03-.016.06-.028M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-3.5 2a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" clip-rule="evenodd"/>`
    }, props));
$6e33b660ecc29b11$var$PersonAvatarIcon.displayName = 'PersonAvatarIcon';
var $6e33b660ecc29b11$var$_default = module.exports.default = $6e33b660ecc29b11$var$PersonAvatarIcon;

});

parcelRegister("anXxY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a375ef61b97315ae7ff25123b3ed791c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $78fa3e2291bb332c$var$_react = $78fa3e2291bb332c$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $78fa3e2291bb332c$var$_iconNew = $78fa3e2291bb332c$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $78fa3e2291bb332c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Release".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/release
 * Usage guidance:
 * Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $78fa3e2291bb332c$var$ReleaseIcon = (props)=>/*#__PURE__*/ $78fa3e2291bb332c$var$_react.default.createElement($78fa3e2291bb332c$var$_iconNew.default, Object.assign({
        name: "ReleaseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2h3v2h2a.75.75 0 0 1 .648.372L11.18 7h4.069a.75.75 0 0 1 .646 1.132l-2.887 4.886a2 2 0 0 1-1.722.982H2a2 2 0 0 1-2-2V7.75A.75.75 0 0 1 .75 7H2V4.75A.75.75 0 0 1 2.75 4H4zm-.5 5h5.944L8.57 5.5H3.5zm-2 1.5V12a.5.5 0 0 0 .5.5h9.287a.5.5 0 0 0 .43-.246L13.936 8.5z" clip-rule="evenodd"/>`
    }, props));
$78fa3e2291bb332c$var$ReleaseIcon.displayName = 'ReleaseIcon';
var $78fa3e2291bb332c$var$_default = module.exports.default = $78fa3e2291bb332c$var$ReleaseIcon;

});

parcelRegister("dM6XP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::508bd9728f54ab48d8a573901bb484ef>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a07528f1ca291773$var$_react = $a07528f1ca291773$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $a07528f1ca291773$var$_iconNew = $a07528f1ca291773$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $a07528f1ca291773$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LogIn".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/log-in
 * Usage guidance:
 * Single purpose - Reserved for log in.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a07528f1ca291773$var$LogInIcon = (props)=>/*#__PURE__*/ $a07528f1ca291773$var$_react.default.createElement($a07528f1ca291773$var$_iconNew.default, Object.assign({
        name: "LogInIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13 2.5H8V1h5a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H8v-1.5h5a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5M7.44 7.25 5.22 5.03l1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$a07528f1ca291773$var$LogInIcon.displayName = 'LogInIcon';
var $a07528f1ca291773$var$_default = module.exports.default = $a07528f1ca291773$var$LogInIcon;

});

parcelRegister("4w7e7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53379c98771562c0fa194d02f1725934>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $349fc1aa9434e318$var$_react = $349fc1aa9434e318$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $349fc1aa9434e318$var$_iconNew = $349fc1aa9434e318$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $349fc1aa9434e318$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarUnstarred".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/star-unstarred
 * Usage guidance:
 * Single purpose - Reserved for starring or favoriting objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $349fc1aa9434e318$var$StarUnstarredIcon = (props)=>/*#__PURE__*/ $349fc1aa9434e318$var$_react.default.createElement($349fc1aa9434e318$var$_iconNew.default, Object.assign({
        name: "StarUnstarredIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/>`
    }, props));
$349fc1aa9434e318$var$StarUnstarredIcon.displayName = 'StarUnstarredIcon';
var $349fc1aa9434e318$var$_default = module.exports.default = $349fc1aa9434e318$var$StarUnstarredIcon;

});

parcelRegister("fvWrV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5e1c792fe94266e0516d7c57a92d4d2b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b4b7171f8f564573$var$_react = $b4b7171f8f564573$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $b4b7171f8f564573$var$_iconNew = $b4b7171f8f564573$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $b4b7171f8f564573$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FullscreenEnter".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/fullscreen-enter
 * Usage guidance:
 * Single purpose - Reserved for full screen videos or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b4b7171f8f564573$var$FullscreenEnterIcon = (props)=>/*#__PURE__*/ $b4b7171f8f564573$var$_react.default.createElement($b4b7171f8f564573$var$_iconNew.default, Object.assign({
        name: "FullscreenEnterIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13 2.5h-3V1h3a2 2 0 0 1 2 2v3h-1.5V3a.5.5 0 0 0-.5-.5m-10 0a.5.5 0 0 0-.5.5v3H1V3a2 2 0 0 1 2-2h3v1.5zM2.5 10v3a.5.5 0 0 0 .5.5h3V15H3a2 2 0 0 1-2-2v-3zm11 3v-3H15v3a2 2 0 0 1-2 2h-3v-1.5h3a.5.5 0 0 0 .5-.5" clip-rule="evenodd"/>`
    }, props));
$b4b7171f8f564573$var$FullscreenEnterIcon.displayName = 'FullscreenEnterIcon';
var $b4b7171f8f564573$var$_default = module.exports.default = $b4b7171f8f564573$var$FullscreenEnterIcon;

});

parcelRegister("4Cn0v", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::891f8b0b0e6811694a02696ff381b7b5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $35cc8ec74e5ac2a4$var$_react = $35cc8ec74e5ac2a4$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $35cc8ec74e5ac2a4$var$_iconNew = $35cc8ec74e5ac2a4$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $35cc8ec74e5ac2a4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AppSwitcher".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/app-switcher
 * Usage guidance:
 * Single purpose - Reserved for app switcher in global app navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $35cc8ec74e5ac2a4$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $35cc8ec74e5ac2a4$var$_react.default.createElement($35cc8ec74e5ac2a4$var$_iconNew.default, Object.assign({
        name: "AppSwitcherIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.5 11a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm8 0a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm-8-8a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm8 0a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zM7 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm8 0a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zM7 5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm8 0a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2z"/>`
    }, props));
$35cc8ec74e5ac2a4$var$AppSwitcherIcon.displayName = 'AppSwitcherIcon';
var $35cc8ec74e5ac2a4$var$_default = module.exports.default = $35cc8ec74e5ac2a4$var$AppSwitcherIcon;

});

parcelRegister("gI1yN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::44bfe3fda6843e57916c639848bc7fcd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c2a1f73d851ba605$var$_react = $c2a1f73d851ba605$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $c2a1f73d851ba605$var$_iconNew = $c2a1f73d851ba605$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $c2a1f73d851ba605$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/person
 * Usage guidance:
 * Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c2a1f73d851ba605$var$PersonIcon = (props)=>/*#__PURE__*/ $c2a1f73d851ba605$var$_react.default.createElement($c2a1f73d851ba605$var$_iconNew.default, Object.assign({
        name: "PersonIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 9a3.75 3.75 0 0 1 3.75-3.75h4.5A3.75 3.75 0 0 1 14 13v2h-1.5v-2a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 3.5 13v2H2z" clip-rule="evenodd"/>`
    }, props));
$c2a1f73d851ba605$var$PersonIcon.displayName = 'PersonIcon';
var $c2a1f73d851ba605$var$_default = module.exports.default = $c2a1f73d851ba605$var$PersonIcon;

});

parcelRegister("26iws", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fc8c5bcc855f6883f121e0d08f8186bb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $187a827dde894ab9$var$_react = $187a827dde894ab9$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $187a827dde894ab9$var$_iconNew = $187a827dde894ab9$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $187a827dde894ab9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Roadmap".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/roadmap
 * Usage guidance:
 * Single purpose - Reserved for roadmaps in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $187a827dde894ab9$var$RoadmapIcon = (props)=>/*#__PURE__*/ $187a827dde894ab9$var$_react.default.createElement($187a827dde894ab9$var$_iconNew.default, Object.assign({
        name: "RoadmapIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM3 11a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$187a827dde894ab9$var$RoadmapIcon.displayName = 'RoadmapIcon';
var $187a827dde894ab9$var$_default = module.exports.default = $187a827dde894ab9$var$RoadmapIcon;

});

parcelRegister("hQOf7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e090651e87a4c0aa5c0215d940612c2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cfee4430572b27d7$var$_react = $cfee4430572b27d7$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $cfee4430572b27d7$var$_iconNew = $cfee4430572b27d7$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $cfee4430572b27d7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Teams".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/teams
 * Usage guidance:
 * Single purpose - Reserved for teams in Atlassian.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cfee4430572b27d7$var$TeamsIcon = (props)=>/*#__PURE__*/ $cfee4430572b27d7$var$_react.default.createElement($cfee4430572b27d7$var$_iconNew.default, Object.assign({
        name: "TeamsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M1 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0m11-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M9 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0M3.75 9.5a2.25 2.25 0 0 0-2.25 2.25V13a.5.5 0 0 0 .5.5h4V15H2a2 2 0 0 1-2-2v-1.25A3.75 3.75 0 0 1 3.75 8h1.149a3.75 3.75 0 0 1 3.524 2.469l.564 1.55A2.25 2.25 0 0 0 11.1 13.5H14a.5.5 0 0 0 .5-.5v-1.25a2.25 2.25 0 0 0-2.25-2.25H12c-.775 0-1.258.06-1.531.112-.137.026-.22.05-.26.062l-.027.01.007-.003.01-.004.005-.003.003-.002h.002c.001-.001.001-.001-.334-.672l-.335-.671h.001l.002-.002.004-.001.008-.004.018-.008a1 1 0 0 1 .174-.066q.156-.053.44-.11C10.572 8.065 11.15 8 12 8h.25A3.75 3.75 0 0 1 16 11.75V13a2 2 0 0 1-2 2h-2.899a3.75 3.75 0 0 1-3.524-2.469l-.564-1.55A2.25 2.25 0 0 0 4.9 9.5z" clip-rule="evenodd"/>`
    }, props));
$cfee4430572b27d7$var$TeamsIcon.displayName = 'TeamsIcon';
var $cfee4430572b27d7$var$_default = module.exports.default = $cfee4430572b27d7$var$TeamsIcon;

});

parcelRegister("gjVYm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1078ad25bb88c0aacc625e83cbe31eaf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $be1b63d5576e92d7$var$_react = $be1b63d5576e92d7$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $be1b63d5576e92d7$var$_iconNew = $be1b63d5576e92d7$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $be1b63d5576e92d7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiAgent".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/ai-agent
 * Usage guidance:
 * Single purpose - Reserved for Rovo Agent.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $be1b63d5576e92d7$var$AiAgentIcon = (props)=>/*#__PURE__*/ $be1b63d5576e92d7$var$_react.default.createElement($be1b63d5576e92d7$var$_iconNew.default, Object.assign({
        name: "AiAgentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.971.493a2 2 0 0 1 2.058 0l5 3A2 2 0 0 1 15 5.208v5.584a2 2 0 0 1-.971 1.715l-5 3a2 2 0 0 1-2.058 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .971-1.715zm1.286 1.286a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.429v5.584a.5.5 0 0 0 .243.429l1.098.66a4.25 4.25 0 1 1 8.318 0l1.098-.66a.5.5 0 0 0 .243-.429V5.208a.5.5 0 0 0-.243-.429zM8 8.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5" clip-rule="evenodd"/>`
    }, props));
$be1b63d5576e92d7$var$AiAgentIcon.displayName = 'AiAgentIcon';
var $be1b63d5576e92d7$var$_default = module.exports.default = $be1b63d5576e92d7$var$AiAgentIcon;

});

parcelRegister("fm5Zq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5d9d22b41ee491811e82fedd8cf80d9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b2dd8e865dde220e$var$_react = $b2dd8e865dde220e$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $b2dd8e865dde220e$var$_iconNew = $b2dd8e865dde220e$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $b2dd8e865dde220e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Apps".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/apps
 * Usage guidance:
 * Single purpose - Reserved for adding or viewing apps.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b2dd8e865dde220e$var$AppsIcon = (props)=>/*#__PURE__*/ $b2dd8e865dde220e$var$_react.default.createElement($b2dd8e865dde220e$var$_iconNew.default, Object.assign({
        name: "AppsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.5 11a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm7.25-2v2.25H15v1.5h-2.25V15h-1.5v-2.25H9v-1.5h2.25V9zM5.5 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm8 0a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zM7 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm0-8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm8 0a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2z"/>`
    }, props));
$b2dd8e865dde220e$var$AppsIcon.displayName = 'AppsIcon';
var $b2dd8e865dde220e$var$_default = module.exports.default = $b2dd8e865dde220e$var$AppsIcon;

});

parcelRegister("9JQ5n", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::98f19b4ce1cb01bc604b2707417d4c9a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7170b82ebff4624b$var$_react = $7170b82ebff4624b$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $7170b82ebff4624b$var$_iconNew = $7170b82ebff4624b$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $7170b82ebff4624b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartTrendUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chart-trend-up
 * Usage guidance:
 * Known uses: Upward trending data; Trend charts; Reports in Jira; Sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7170b82ebff4624b$var$ChartTrendUpIcon = (props)=>/*#__PURE__*/ $7170b82ebff4624b$var$_react.default.createElement($7170b82ebff4624b$var$_iconNew.default, Object.assign({
        name: "ChartTrendUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M15 7.5h-1.5V5.56L9.78 9.28a.75.75 0 0 1-1.06 0L7.25 7.81l-2.22 2.22-1.06-1.06 2.75-2.75.056-.052a.75.75 0 0 1 1.004.052l1.47 1.47 3.19-3.19H10.5V3h3.75a.75.75 0 0 1 .75.75z"/>`
    }, props));
$7170b82ebff4624b$var$ChartTrendUpIcon.displayName = 'ChartTrendUpIcon';
var $7170b82ebff4624b$var$_default = module.exports.default = $7170b82ebff4624b$var$ChartTrendUpIcon;

});

parcelRegister("2TESP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0f3b83dd529b07788ee27a881ae63826>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $21c06e6bae0ffe89$var$_react = $21c06e6bae0ffe89$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $21c06e6bae0ffe89$var$_iconNew = $21c06e6bae0ffe89$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $21c06e6bae0ffe89$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Devices".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/devices
 * Usage guidance:
 * Known usages: 'Asset' work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $21c06e6bae0ffe89$var$DevicesIcon = (props)=>/*#__PURE__*/ $21c06e6bae0ffe89$var$_react.default.createElement($21c06e6bae0ffe89$var$_iconNew.default, Object.assign({
        name: "DevicesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a.5.5 0 0 0-.5-.5h-2.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5H14a.5.5 0 0 0 .5-.5zM13 3a.5.5 0 0 0-.5-.5h-9A.5.5 0 0 0 3 3v7h5v1.5H1.5v.5a.5.5 0 0 0 .5.5h6V14H2a2 2 0 0 1-2-2v-1.25l.004-.077A.75.75 0 0 1 .75 10h.75V3a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1.5H13zm3 11a2 2 0 0 1-2 2h-2.5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2H14a2 2 0 0 1 2 2z"/>`
    }, props));
$21c06e6bae0ffe89$var$DevicesIcon.displayName = 'DevicesIcon';
var $21c06e6bae0ffe89$var$_default = module.exports.default = $21c06e6bae0ffe89$var$DevicesIcon;

});

parcelRegister("dpfDo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d79300678d2a12fe66aec1aaa52c9d3a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9c29bcd4b676c882$var$_react = $9c29bcd4b676c882$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $9c29bcd4b676c882$var$_iconNew = $9c29bcd4b676c882$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $9c29bcd4b676c882$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Goal".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/goal
 * Usage guidance:
 * Single purpose - Reserved for goals in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9c29bcd4b676c882$var$GoalIcon = (props)=>/*#__PURE__*/ $9c29bcd4b676c882$var$_react.default.createElement($9c29bcd4b676c882$var$_iconNew.default, Object.assign({
        name: "GoalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 8a4 4 0 1 1 8 0 4 4 0 0 1-8 0" clip-rule="evenodd"/>`
    }, props));
$9c29bcd4b676c882$var$GoalIcon.displayName = 'GoalIcon';
var $9c29bcd4b676c882$var$_default = module.exports.default = $9c29bcd4b676c882$var$GoalIcon;

});

parcelRegister("h4F8m", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4635c4898bffdbedd4e5aefaeceb12e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6e2b7b9c97f35ed$var$_react = $c6e2b7b9c97f35ed$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $c6e2b7b9c97f35ed$var$_iconNew = $c6e2b7b9c97f35ed$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $c6e2b7b9c97f35ed$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Headphones".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/headphones
 * Usage guidance:
 * Known uses: music, audio.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c6e2b7b9c97f35ed$var$HeadphonesIcon = (props)=>/*#__PURE__*/ $c6e2b7b9c97f35ed$var$_react.default.createElement($c6e2b7b9c97f35ed$var$_iconNew.default, Object.assign({
        name: "HeadphonesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 7a5.5 5.5 0 1 0-11 0v5H1V7a7 7 0 0 1 14 0v5h-1.5z"/><path fill="currentcolor" d="M4.5 10a1 1 0 0 0-2 0v1.92c0 .87.71 1.58 1.58 1.58.23 0 .42-.19.42-.42zM6 13.08A1.92 1.92 0 0 1 4.08 15 3.08 3.08 0 0 1 1 11.92V10a2.5 2.5 0 0 1 5 0zm7.5-1.16V10a1 1 0 1 0-2 0v3.08c0 .23.19.42.42.42.87 0 1.58-.71 1.58-1.58m1.5 0A3.08 3.08 0 0 1 11.92 15 1.92 1.92 0 0 1 10 13.08V10a2.5 2.5 0 0 1 5 0z"/>`
    }, props));
$c6e2b7b9c97f35ed$var$HeadphonesIcon.displayName = 'HeadphonesIcon';
var $c6e2b7b9c97f35ed$var$_default = module.exports.default = $c6e2b7b9c97f35ed$var$HeadphonesIcon;

});

parcelRegister("3JqUG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8426d0f71b15f9c5b7a2d1d52ee1c968>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2b7a73796932bf92$var$_react = $2b7a73796932bf92$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $2b7a73796932bf92$var$_iconNew = $2b7a73796932bf92$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $2b7a73796932bf92$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Operations".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/operations
 * Usage guidance:
 * Single purpose - Reserved for IT Operations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2b7a73796932bf92$var$OperationsIcon = (props)=>/*#__PURE__*/ $2b7a73796932bf92$var$_react.default.createElement($2b7a73796932bf92$var$_iconNew.default, Object.assign({
        name: "OperationsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.036 2.904A6.501 6.501 0 1 0 8 14.5V16a8 8 0 1 1 5.657-13.657l.53.53L8.28 8.78 7.22 7.72l2.304-2.305A3.001 3.001 0 1 0 8 11v1.5a4.5 4.5 0 1 1 2.608-8.168z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M14.58 4.862a.75.75 0 0 1 .959.454l.008.025a.75.75 0 1 1-1.414.499l-.007-.02a.75.75 0 0 1 .454-.958m-2.798 2.573a.75.75 0 0 1 .713.786l-.001.015-.001.014a.75.75 0 1 1-1.498-.083v-.01l.001-.01a.75.75 0 0 1 .786-.712m3.497.184a.75.75 0 0 1 .71.787v.026a.75.75 0 1 1-1.498-.081V8.33a.75.75 0 0 1 .788-.711m-4.205 2.656a.75.75 0 0 1-.052 1.06l-.022.019a.75.75 0 1 1-1-1.118l.015-.013a.75.75 0 0 1 1.059.052m3.799.16a.75.75 0 0 1 .355.999l-.011.023a.75.75 0 0 1-1.353-.649l.01-.019a.75.75 0 0 1 .999-.355m-1.457 2.442a.75.75 0 0 1-.053 1.06l-.02.017a.75.75 0 0 1-1.001-1.117l.015-.014a.75.75 0 0 1 1.06.054m-2.278 1.703a.75.75 0 0 1-.454.959l-.025.008a.75.75 0 0 1-.499-1.414l.02-.007a.75.75 0 0 1 .958.454" clip-rule="evenodd"/>`
    }, props));
$2b7a73796932bf92$var$OperationsIcon.displayName = 'OperationsIcon';
var $2b7a73796932bf92$var$_default = module.exports.default = $2b7a73796932bf92$var$OperationsIcon;

});

parcelRegister("4dsZm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e9008592011ce9e8020afead221c92f2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $311edce1d06bde81$var$_react = $311edce1d06bde81$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $311edce1d06bde81$var$_iconNew = $311edce1d06bde81$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $311edce1d06bde81$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Project".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/project
 * Usage guidance:
 * Single purpose - Reserved for projects in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $311edce1d06bde81$var$ProjectIcon = (props)=>/*#__PURE__*/ $311edce1d06bde81$var$_react.default.createElement($311edce1d06bde81$var$_iconNew.default, Object.assign({
        name: "ProjectIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.5 3a.5.5 0 0 0-.5-.5h-2.482a.5.5 0 0 0-.354.146L7.78 5.03a.75.75 0 0 1-.53.22H3.018a.5.5 0 0 0-.354.146l-.353.354 1.72 1.72a.75.75 0 0 1 0 1.06l-2.25 2.25L.72 9.72 2.44 8 .72 6.28a.75.75 0 0 1 0-1.06l.884-.884a2 2 0 0 1 1.414-.586h3.921l2.165-2.164A2 2 0 0 1 10.518 1H13a2 2 0 0 1 2 2v2.482a2 2 0 0 1-.586 1.414L12.25 9.061v3.921a2 2 0 0 1-.586 1.415l-.884.883a.75.75 0 0 1-1.06 0L8 13.56l-1.72 1.72-1.06-1.06 2.25-2.25a.75.75 0 0 1 1.06 0l1.72 1.72.354-.354a.5.5 0 0 0 .146-.354V8.75a.75.75 0 0 1 .22-.53l2.384-2.384a.5.5 0 0 0 .146-.354zm-6.72 7.28-5 5-1.06-1.06 5-5z" clip-rule="evenodd"/><path fill="currentcolor" d="M12.5 4.625a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0"/>`
    }, props));
$311edce1d06bde81$var$ProjectIcon.displayName = 'ProjectIcon';
var $311edce1d06bde81$var$_default = module.exports.default = $311edce1d06bde81$var$ProjectIcon;

});

parcelRegister("dVPyc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9b4f1367f1cd984cea139cd322f85553>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a248961e7e2b5da4$var$_react = $a248961e7e2b5da4$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $a248961e7e2b5da4$var$_iconNew = $a248961e7e2b5da4$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $a248961e7e2b5da4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SidebarCollapse".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/sidebar-collapse
 * Usage guidance:
 * Single purpose - Reserved for collapsing the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a248961e7e2b5da4$var$SidebarCollapseIcon = (props)=>/*#__PURE__*/ $a248961e7e2b5da4$var$_react.default.createElement($a248961e7e2b5da4$var$_iconNew.default, Object.assign({
        name: "SidebarCollapseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h2v-11zm3.5 0v11H14a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM0 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm7.97 4.47 2.5-2.5 1.06 1.06L9.56 8l1.97 1.97-1.06 1.06-2.5-2.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$a248961e7e2b5da4$var$SidebarCollapseIcon.displayName = 'SidebarCollapseIcon';
var $a248961e7e2b5da4$var$_default = module.exports.default = $a248961e7e2b5da4$var$SidebarCollapseIcon;

});

parcelRegister("9s66L", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a887af9d6920f2ef0ce00494c960319>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6e1b778a989d06b8$var$_react = $6e1b778a989d06b8$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $6e1b778a989d06b8$var$_iconNew = $6e1b778a989d06b8$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $6e1b778a989d06b8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SidebarExpand".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/sidebar-expand
 * Usage guidance:
 * Single purpose - Reserved for expanding the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6e1b778a989d06b8$var$SidebarExpandIcon = (props)=>/*#__PURE__*/ $6e1b778a989d06b8$var$_react.default.createElement($6e1b778a989d06b8$var$_iconNew.default, Object.assign({
        name: "SidebarExpandIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14 2.5a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-2v-11zm-3.5 0v11H2a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5zM16 3a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zM8.03 7.47l-2.5-2.5-1.06 1.06L6.44 8 4.47 9.97l1.06 1.06 2.5-2.5a.75.75 0 0 0 0-1.06" clip-rule="evenodd"/>`
    }, props));
$6e1b778a989d06b8$var$SidebarExpandIcon.displayName = 'SidebarExpandIcon';
var $6e1b778a989d06b8$var$_default = module.exports.default = $6e1b778a989d06b8$var$SidebarExpandIcon;

});

parcelRegister("3CdLT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e4c39bfa2c8ba34f67b9a83cec6525e0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2a1f9a69daf3e12c$var$_react = $2a1f9a69daf3e12c$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $2a1f9a69daf3e12c$var$_iconNew = $2a1f9a69daf3e12c$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $2a1f9a69daf3e12c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Support".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/support
 * Usage guidance:
 * Reserved for representing help support.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2a1f9a69daf3e12c$var$SupportIcon = (props)=>/*#__PURE__*/ $2a1f9a69daf3e12c$var$_react.default.createElement($2a1f9a69daf3e12c$var$_iconNew.default, Object.assign({
        name: "SupportIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.964 2.904 5.752 4.69a4 4 0 0 1 4.497 0l1.787-1.787a6.5 6.5 0 0 0-8.072 0m9.132 1.06L11.31 5.752a4 4 0 0 1 0 4.497l1.787 1.787a6.5 6.5 0 0 0 0-8.072m-1.06 9.132-1.787-1.787a4 4 0 0 1-4.497 0l-1.788 1.787a6.5 6.5 0 0 0 8.072 0m-9.132-1.06 1.787-1.787a4 4 0 0 1 0-4.497L2.904 3.964a6.5 6.5 0 0 0 0 8.072m-.56-9.693a8 8 0 1 1 11.313 11.314A8 8 0 0 1 2.343 2.343m7.424 3.89a2.5 2.5 0 1 0-3.536 3.535 2.5 2.5 0 0 0 3.536-3.536" clip-rule="evenodd"/>`
    }, props));
$2a1f9a69daf3e12c$var$SupportIcon.displayName = 'SupportIcon';
var $2a1f9a69daf3e12c$var$_default = module.exports.default = $2a1f9a69daf3e12c$var$SupportIcon;

});

parcelRegister("f7Hlw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $39d600e8f37393ad$export$2e2bcd8739ae039);
/* badge.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $9SmtC = parcelRequire("9SmtC");

var $51bQI = parcelRequire("51bQI");

var $l22Ni = parcelRequire("l22Ni");
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in `children`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ const $39d600e8f37393ad$var$Badge = /*#__PURE__*/ (0, $fsvuC.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
    // Map old appearance names to new ones
    const newAppearance = (0, $9SmtC.appearanceMapping)[appearance];
    // Pre-format the value using the backward-compatible formatter (supports negative numbers)
    // then pass max={false} to BadgeNew so it doesn't apply its own (clamping) formatting.
    const formattedValue = typeof children === 'number' && typeof max === 'number' ? (0, $l22Ni.formatValueWithNegativeSupport)(children, max) : children;
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $51bQI.default), {
        appearance: newAppearance,
        max: false,
        style: style,
        testId: testId,
        children: formattedValue
    });
});
var $39d600e8f37393ad$export$2e2bcd8739ae039 = $39d600e8f37393ad$var$Badge;

});
parcelRegister("9SmtC", function(module, exports) {
$parcel$export(module.exports, "appearanceMapping", () => $c0d8deac4f106eff$export$d21bba0569254935);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $c0d8deac4f106eff$export$d21bba0569254935 = {
    added: 'success',
    removed: 'danger',
    default: 'neutral',
    primary: 'information',
    primaryInverted: 'inverse',
    important: 'danger',
    warning: 'warning',
    discovery: 'discovery',
    danger: 'danger',
    success: 'success',
    information: 'information',
    inverse: 'inverse',
    neutral: 'neutral',
    informationBold: 'informationBold',
    successBold: 'successBold',
    dangerBold: 'dangerBold',
    warningBold: 'warningBold',
    discoveryBold: 'discoveryBold'
};

});

parcelRegister("51bQI", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd52951ebe7a542b$export$2e2bcd8739ae039);
/* badge-new.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $daZXj = parcelRequire("daZXj");

var $bJtVR = parcelRequire("bJtVR");

var $bLtxj = parcelRequire("bLtxj");
// Nested selectors with data attributes are required for theme switching
const $dd52951ebe7a542b$var$stylesNew = {
    root: "_0bjKvDcjp5 _2Y7lL41Y8M _4c065UdnbC _3iDTPbccYA _24h04i2Njc _4ouGXINHnM _37wbyuDIqT _3YEZNOdnbC _3L9DPXBY1A",
    success: "_1UtDYzM9Wa _0KLXruQuCm",
    danger: "_1UtDYzOZ2O _0KLXruJXmd",
    warning: "_1UtDYzVRW9 _0KLXru2bwY",
    information: "_1UtDYzdx2f _0KLXru9V7L",
    discovery: "_1UtDYzAGgF _0KLXruZB9y",
    neutral: "_1UtDYzy7kJ _0KLXruG6qS",
    inverse: "_0KLXrulfZc _1UtDYzy7kJ",
    informationBold: "_1UtDYzdx2f _0KLXruJVoT",
    successBold: "_1UtDYzM9Wa _0KLXruX1bq",
    dangerBold: "_1UtDYzOZ2O _0KLXrug6EK",
    warningBold: "_1UtDYzVRW9 _0KLXruKLKE",
    warningBoldDark: "_1UtDYzVRW9 _0KLXruDh4Z",
    discoveryBold: "_1UtDYzAGgF _0KLXruXfaS"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ const $dd52951ebe7a542b$var$badgeValueWithNegativeNumberSupported = (children, max)=>{
    return typeof children === 'number' && max ? (0, $bLtxj.formatValue)(children, max) : children;
}; /**
    * __BadgeNew__
    *
    * New visual refresh implementation of Badge component for the labelling system.
    *
    * Uses new appearance naming convention:
    * - success (green)
    * - danger (red)
    * - neutral (gray)
    * - information (blue)
    * - inverse (inverted colors)
    * - warning (orange/yellow)
    * - discovery (purple)
    * - informationBold (bold blue, color.background.information.subtle)
    * - successBold (bold green, color.background.success.subtle)
    * - dangerBold (bold red, color.background.danger.subtle)
    * - warningBold (bold warning, color.background.warning.bold)
    * - discoveryBold (bold purple, color.background.discovery.subtle)
    */ 
const $dd52951ebe7a542b$var$BadgeNew = /*#__PURE__*/ (0, $fsvuC.memo)(function BadgeNew({ appearance: appearance = 'neutral', children: children = 0, max: max = 99, style: style, testId: testId }) {
    const { colorMode: colorMode } = (0, $bJtVR.useThemeObserver)(); // In dark theme, warningBold needs to swap to a lighter background
    // (color.background.warning.subtle / Orange800) for better contrast against
    // the typical dark surface colors.
    const resolvedAppearance = appearance === 'warningBold' && colorMode === 'dark' ? 'warningBoldDark' : appearance;
    return /*#__PURE__*/ (0, $5chsV.jsx)("span", {
        "data-testid": testId,
        style: {
            background: style?.backgroundColor,
            color: style?.color
        },
        className: (0, $gJ6nT.default)([
            $dd52951ebe7a542b$var$stylesNew.root,
            $dd52951ebe7a542b$var$stylesNew[resolvedAppearance]
        ]),
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $daZXj.Text), {
            size: "small",
            align: "center",
            color: "inherit",
            children: $dd52951ebe7a542b$var$badgeValueWithNegativeNumberSupported(children, max)
        })
    });
});
var $dd52951ebe7a542b$export$2e2bcd8739ae039 = $dd52951ebe7a542b$var$BadgeNew;

});
parcelRegister("bLtxj", function(module, exports) {
$parcel$export(module.exports, "formatValue", () => $318c717d7b0013f8$export$7c4d25c0c3217d8c);
function $318c717d7b0013f8$var$getSafeValue(value = 0) {
    const numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $318c717d7b0013f8$export$7c4d25c0c3217d8c(value, max) {
    const safeValue = $318c717d7b0013f8$var$getSafeValue(value);
    const safeMax = $318c717d7b0013f8$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("l22Ni", function(module, exports) {
$parcel$export(module.exports, "formatValueWithNegativeSupport", () => $2a21524396bc6ec7$export$4b844743568d5983);
function $2a21524396bc6ec7$var$getSafeValueWithNegativeSupport(value = 0) {
    const numericValue = +value;
    // NOTE: Changing below code as this causes custom fields -ve number to show up as zero in activity timeline.
    // This will ensure it renders correctly if it is a number otherwise renders 0
    // If the value is NaN, return it as is (assuming it's a non-numeric string)
    if (isNaN(numericValue)) return value;
    // Return the numeric value, allowing negative numbers
    return numericValue;
}
function $2a21524396bc6ec7$export$4b844743568d5983(value, max) {
    const safeValue = $2a21524396bc6ec7$var$getSafeValueWithNegativeSupport(value);
    const safeMax = $2a21524396bc6ec7$var$getSafeValueWithNegativeSupport(max);
    let hasSafeMaxValue = false;
    if (max !== undefined) hasSafeMaxValue = true;
    if (safeMax === Infinity && safeValue === Infinity) return "\u221E";
    if (hasSafeMaxValue && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("9Tueh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::25fc5e06165a31c1790a9d0782b9d836>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7340b303ffea4c0c$var$_react = $7340b303ffea4c0c$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $7340b303ffea4c0c$var$_iconNew = $7340b303ffea4c0c$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $7340b303ffea4c0c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Plan".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/plan
 * Usage guidance:
 * Reserved for representing plans.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7340b303ffea4c0c$var$PlanIcon = (props)=>/*#__PURE__*/ $7340b303ffea4c0c$var$_react.default.createElement($7340b303ffea4c0c$var$_iconNew.default, Object.assign({
        name: "PlanIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 12.75a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m1.5 0a2.75 2.75 0 0 1-5.394.75H5.625a3.125 3.125 0 1 1 0-6.25h4.75a1.625 1.625 0 1 0 0-3.25H5.394A2.749 2.749 0 0 1 0 3.25a2.75 2.75 0 0 1 5.394-.75h4.981a3.125 3.125 0 1 1 0 6.25h-4.75a1.625 1.625 0 0 0 0 3.25h4.981a2.749 2.749 0 0 1 5.394.75M1.5 3.25a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0"/>`
    }, props));
$7340b303ffea4c0c$var$PlanIcon.displayName = 'PlanIcon';
var $7340b303ffea4c0c$var$_default = module.exports.default = $7340b303ffea4c0c$var$PlanIcon;

});

parcelRegister("cB4mc", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ae16317377fd108$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d072e16631e9fcbd519ab65335430217>>
 * @codegenCommand yarn build tokens
 */ const $8ae16317377fd108$var$tokens = {
    'motion.avatar.enter': '--ds-avatar-enter',
    'motion.avatar.exit': '--ds-avatar-exit',
    'motion.avatar.hovered': '--ds-avatar-hovered',
    'motion.blanket.enter': '--ds-blanket-enter',
    'motion.blanket.exit': '--ds-blanket-exit',
    'motion.button.hovered': '--ds-button-hovered',
    'motion.button.pressed': '--ds-button-pressed',
    'motion.duration.instant': '--ds-duration-instant',
    'motion.duration.long': '--ds-duration-long',
    'motion.duration.medium': '--ds-duration-medium',
    'motion.duration.short': '--ds-duration-short',
    'motion.duration.xlong': '--ds-duration-xlong',
    'motion.duration.xshort': '--ds-duration-xshort',
    'motion.duration.xxlong': '--ds-duration-xxlong',
    'motion.duration.xxshort': '--ds-duration-xxshort',
    'motion.easing.in.practical': '--ds-easing-in-practical',
    'motion.easing.inout.bold': '--ds-easing-inout-bold',
    'motion.easing.out.practical': '--ds-easing-out-practical',
    'motion.easing.out.bold': '--ds-easing-out-bold',
    'motion.easing.spring': '--ds-easing-spring',
    'motion.flag.enter': '--ds-flag-enter',
    'motion.flag.exit': '--ds-flag-exit',
    'motion.flag.reposition': '--ds-flag-reposition',
    'motion.form.message.enter': '--ds-form-message-enter',
    'motion.form.message.exit': '--ds-form-message-exit',
    'motion.input': '--ds-input',
    'motion.input.selection': '--ds-input-selection',
    'motion.input.toggle': '--ds-input-toggle',
    'motion.keyframe.fade.in': '--ds-keyframe-fade-in',
    'motion.keyframe.fade.out': '--ds-keyframe-fade-out',
    'motion.keyframe.grid.column.in': '--ds-keyframe-grid-column-in',
    'motion.keyframe.grid.column.out': '--ds-keyframe-grid-column-out',
    'motion.keyframe.scale.in.medium': '--ds-keyframe-scale-in-medium',
    'motion.keyframe.scale.in.small': '--ds-keyframe-scale-in-small',
    'motion.keyframe.scale.out.medium': '--ds-keyframe-scale-out-medium',
    'motion.keyframe.scale.out.small': '--ds-keyframe-scale-out-small',
    'motion.keyframe.slide.in.bottom.short': '--ds-keyframe-slide-in-bottom-short',
    'motion.keyframe.slide.in.left.half': '--ds-keyframe-slide-in-left-half',
    'motion.keyframe.slide.in.left.short': '--ds-keyframe-slide-in-left-short',
    'motion.keyframe.slide.in.right.short': '--ds-keyframe-slide-in-right-short',
    'motion.keyframe.slide.in.top.short': '--ds-keyframe-slide-in-top-short',
    'motion.keyframe.slide.out.bottom.short': '--ds-keyframe-slide-out-bottom-short',
    'motion.keyframe.slide.out.left.half': '--ds-keyframe-slide-out-left-half',
    'motion.keyframe.slide.out.left.short': '--ds-keyframe-slide-out-left-short',
    'motion.keyframe.slide.out.right.short': '--ds-keyframe-slide-out-right-short',
    'motion.keyframe.slide.out.top.short': '--ds-keyframe-slide-out-top-short',
    'motion.label.enter': '--ds-label-enter',
    'motion.label.exit': '--ds-label-exit',
    'motion.listitem.hovered': '--ds-listitem-hovered',
    'motion.listitem.pressed': '--ds-listitem-pressed',
    'motion.listitem.selected': '--ds-listitem-selected',
    'motion.modal.enter': '--ds-modal-enter',
    'motion.modal.exit': '--ds-modal-exit',
    'motion.panel.content.enter': '--ds-panel-content-enter',
    'motion.panel.content.exit': '--ds-panel-content-exit',
    'motion.panel.enter': '--ds-panel-enter',
    'motion.panel.enter.left': '--ds-panel-enter-left',
    'motion.panel.enter.right': '--ds-panel-enter-right',
    'motion.panel.exit': '--ds-panel-exit',
    'motion.panel.exit.left': '--ds-panel-exit-left',
    'motion.panel.exit.right': '--ds-panel-exit-right',
    'motion.popup.enter.bottom': '--ds-popup-enter-bottom',
    'motion.popup.enter.left': '--ds-popup-enter-left',
    'motion.popup.enter.right': '--ds-popup-enter-right',
    'motion.popup.enter.top': '--ds-popup-enter-top',
    'motion.popup.exit.bottom': '--ds-popup-exit-bottom',
    'motion.popup.exit.left': '--ds-popup-exit-left',
    'motion.popup.exit.right': '--ds-popup-exit-right',
    'motion.popup.exit.top': '--ds-popup-exit-top',
    'motion.sidenav.enter.left': '--ds-sidenav-enter-left',
    'motion.sidenav.enter.right': '--ds-sidenav-enter-right',
    'motion.sidenav.exit.left': '--ds-sidenav-exit-left',
    'motion.sidenav.exit.right': '--ds-sidenav-exit-right',
    'motion.spotlight.enter': '--ds-spotlight-enter',
    'motion.spotlight.exit': '--ds-spotlight-exit',
    'motion.tab': '--ds-tab',
    'motion.tab.indicator.enter.left': '--ds-tab-indicator-enter-left',
    'motion.tab.indicator.enter.right': '--ds-tab-indicator-enter-right',
    'motion.tab.indicator.exit.left': '--ds-tab-indicator-exit-left',
    'motion.tab.indicator.exit.right': '--ds-tab-indicator-exit-right',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.code.added.highlight': '--ds-background-code-added-highlight',
    'color.background.code.added.line': '--ds-background-code-added-line',
    'color.background.code.default': '--ds-background-code-default',
    'color.background.code.gutter': '--ds-background-code-gutter',
    'color.background.code.highlight': '--ds-background-code-highlight',
    'color.background.code.removed.highlight': '--ds-background-code-removed-highlight',
    'color.background.code.removed.line': '--ds-background-code-removed-line',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.subtler': '--ds-background-danger-subtler',
    'color.background.danger.subtler.hovered': '--ds-background-danger-subtler-hovered',
    'color.background.danger.subtler.pressed': '--ds-background-danger-subtler-pressed',
    'color.background.danger.subtle': '--ds-background-danger-subtle',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.subtler': '--ds-background-warning-subtler',
    'color.background.warning.subtler.hovered': '--ds-background-warning-subtler-hovered',
    'color.background.warning.subtler.pressed': '--ds-background-warning-subtler-pressed',
    'color.background.warning.subtle': '--ds-background-warning-subtle',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.subtler': '--ds-background-success-subtler',
    'color.background.success.subtler.hovered': '--ds-background-success-subtler-hovered',
    'color.background.success.subtler.pressed': '--ds-background-success-subtler-pressed',
    'color.background.success.subtle': '--ds-background-success-subtle',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.subtler': '--ds-background-discovery-subtler',
    'color.background.discovery.subtler.hovered': '--ds-background-discovery-subtler-hovered',
    'color.background.discovery.subtler.pressed': '--ds-background-discovery-subtler-pressed',
    'color.background.discovery.subtle': '--ds-background-discovery-subtle',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.subtler': '--ds-background-information-subtler',
    'color.background.information.subtler.hovered': '--ds-background-information-subtler-hovered',
    'color.background.information.subtler.pressed': '--ds-background-information-subtler-pressed',
    'color.background.information.subtle': '--ds-background-information-subtle',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.lime.subtle': '--ds-border-accent-lime-subtle',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.red.subtle': '--ds-border-accent-red-subtle',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.orange.subtle': '--ds-border-accent-orange-subtle',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.yellow.subtle': '--ds-border-accent-yellow-subtle',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.green.subtle': '--ds-border-accent-green-subtle',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.teal.subtle': '--ds-border-accent-teal-subtle',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.blue.subtle': '--ds-border-accent-blue-subtle',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.purple.subtle': '--ds-border-accent-purple-subtle',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.magenta.subtle': '--ds-border-accent-magenta-subtle',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.accent.gray.subtle': '--ds-border-accent-gray-subtle',
    'color.border.code': '--ds-border-code',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.input.search': '--ds-border-input-search',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.danger.subtle': '--ds-border-danger-subtle',
    'color.border.warning': '--ds-border-warning',
    'color.border.warning.subtle': '--ds-border-warning-subtle',
    'color.border.success': '--ds-border-success',
    'color.border.success.subtle': '--ds-border-success-subtle',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.discovery.subtle': '--ds-border-discovery-subtle',
    'color.border.information': '--ds-border-information',
    'color.border.information.subtle': '--ds-border-information-subtle',
    'color.border.bold': '--ds-border-bold',
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.code.accent.1': '--ds-text-code-accent-1',
    'color.text.code.accent.2': '--ds-text-code-accent-2',
    'color.text.code.comments': '--ds-text-code-comments',
    'color.text.code.default': '--ds-text-code-default',
    'color.text.code.functions': '--ds-text-code-functions',
    'color.text.code.gutter': '--ds-text-code-gutter',
    'color.text.code.keywords': '--ds-text-code-keywords',
    'color.text.code.numbers': '--ds-text-code-numbers',
    'color.text.code.operators': '--ds-text-code-operators',
    'color.text.code.strings': '--ds-text-code-strings',
    'color.text.code.tags': '--ds-text-code-tags',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.danger.bolder': '--ds-text-danger-bolder',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.warning.bolder': '--ds-text-warning-bolder',
    'color.text.success': '--ds-text-success',
    'color.text.success.bolder': '--ds-text-success-bolder',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.discovery.bolder': '--ds-text-discovery-bolder',
    'color.text.information': '--ds-text-information',
    'color.text.information.bolder': '--ds-text-information-bolder',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'color.rovo.background.brand.bold': '--ds-rovo-background-brand-bold',
    'color.rovo.background.brand.bold.hovered': '--ds-rovo-background-brand-bold-hovered',
    'color.rovo.background.brand.bold.pressed': '--ds-rovo-background-brand-bold-pressed',
    'color.rovo.border.lime': '--ds-rovo-border-lime',
    'color.rovo.border.saffron': '--ds-rovo-border-saffron',
    'color.rovo.border.blue': '--ds-rovo-border-blue',
    'color.rovo.border.purple': '--ds-rovo-border-purple',
    'color.rovo.icon.lime': '--ds-rovo-icon-lime',
    'color.rovo.icon.saffron': '--ds-rovo-icon-saffron',
    'color.rovo.icon.blue': '--ds-rovo-icon-blue',
    'color.rovo.icon.purple': '--ds-rovo-icon-purple',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.container': '--ds-surface-container',
    'elevation.surface.container.hovered': '--ds-surface-container-hovered',
    'elevation.surface.container.pressed': '--ds-surface-container-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.rovo.surface.overlay': '--ds-rovo-surface-overlay',
    'elevation.rovo.surface.overlay.hovered': '--ds-rovo-surface-overlay-hovered',
    'elevation.rovo.surface.overlay.pressed': '--ds-rovo-surface-overlay-pressed',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.gap.large': '--ds-space-gap-large',
    'space.gap.medium': '--ds-space-gap-medium',
    'space.gap.small': '--ds-space-gap-small',
    'space.gap.xlarge': '--ds-space-gap-xlarge',
    'space.gap.xsmall': '--ds-space-gap-xsmall',
    'space.gap.xxlarge': '--ds-space-gap-xxlarge',
    'space.gap.xxsmall': '--ds-space-gap-xxsmall',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.metric.large': '--ds-font-metric-large',
    'font.metric.medium': '--ds-font-metric-medium',
    'font.metric.small': '--ds-font-metric-small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body',
    'radius.xsmall': '--ds-radius-xsmall',
    'radius.small': '--ds-radius-small',
    'radius.medium': '--ds-radius-medium',
    'radius.large': '--ds-radius-large',
    'radius.xlarge': '--ds-radius-xlarge',
    'radius.xxlarge': '--ds-radius-xxlarge',
    'radius.full': '--ds-radius-full',
    'radius.tile': '--ds-radius-tile',
    'border.width': '--ds-border-width',
    'border.width.selected': '--ds-border-width-selected',
    'border.width.focused': '--ds-border-width-focused'
};
var $8ae16317377fd108$export$2e2bcd8739ae039 = $8ae16317377fd108$var$tokens;

});

parcelRegister("buAwh", function(module, exports) {
$parcel$export(module.exports, "default", () => $39c4201daa6fcfb9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $dwUnm = parcelRequire("dwUnm");

var $cGW6W = parcelRequire("cGW6W");

var $jRYjy = parcelRequire("jRYjy");
const $39c4201daa6fcfb9$var$styles = {
    base: "_0bjKvDcjp5 _0WKd3G4z3T",
    visitedLink: "_2nTuUYWfPD _3ADzdEWfPD _1warJ9WfPD _4scvAwWyeI",
    defaultAppearance: "_00uqCYyL8i _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYzM7Tp _32C2rkyL8i _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5M7Tp _0DCa9Ds4Fm _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMM7Tp _3WzCGis4Fm _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbkAwSC",
    subtleAppearance: "_00uqCYs4Fm _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYzZpcK _32C2rks4Fm _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5ZpcK _0DCa9DyL8i _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMZpcK _3WzCGiyL8i _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbky7kJ",
    inverseAppearance: "_00uqCYyL8i _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYze5R3 _2nTuUYe5R3 _32C2rkyL8i _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5e5R3 _0DCa9Ds4Fm _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMe5R3 _3WzCGis4Fm _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbke5R3",
    iconWrapper: "_3iDTPbS8kF _1ANEUSLRg7 _1RrJLiyL8i _1mT5xdRAKS _2I62gzVQEB"
};
const $39c4201daa6fcfb9$var$iconStyles = null;
const $39c4201daa6fcfb9$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>/*#__PURE__*/ (0, $5chsV.jsxs)((0, $cGW6W.Anchor), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $dwUnm.cx)($39c4201daa6fcfb9$var$styles.base, appearance === 'default' && $39c4201daa6fcfb9$var$styles.defaultAppearance, appearance === 'subtle' && $39c4201daa6fcfb9$var$styles.subtleAppearance, appearance === 'inverse' && $39c4201daa6fcfb9$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $39c4201daa6fcfb9$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $5chsV.jsxs)((0, $jRYjy.Box), {
                as: "span",
                xcss: $39c4201daa6fcfb9$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    /*#__PURE__*/ (0, $5chsV.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $gJ6nT.default)([
                            "_39xV02YsW8 _0jFU0VYsW8 _0GTcwRu3qR"
                        ]),
                        children: /*#__PURE__*/ (0, $5chsV.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    })
                ]
            })
        ]
    });
$39c4201daa6fcfb9$var$LinkWithoutRef.displayName = "LinkWithoutRef";
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $39c4201daa6fcfb9$var$Link = /*#__PURE__*/ (0, $fsvuC.forwardRef)($39c4201daa6fcfb9$var$LinkWithoutRef);
var $39c4201daa6fcfb9$export$2e2bcd8739ae039 = $39c4201daa6fcfb9$var$Link;

});
parcelRegister("cGW6W", function(module, exports) {
$parcel$export(module.exports, "Anchor", () => $ece26180e12650ee$export$b688253958b8dfe7);
/* anchor.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $4twf9 = parcelRequire("4twf9");

var $l9kus = parcelRequire("l9kus");

var $d5Gwv = parcelRequire("d5Gwv");

var $gVC77 = parcelRequire("gVC77");

var $9Tkwf = parcelRequire("9Tkwf");

var $cTXsj = parcelRequire("cTXsj");

var $lNjwN = parcelRequire("lNjwN");

var $8e1dR = parcelRequire("8e1dR");

var $iLp2b = parcelRequire("iLp2b");
const $ece26180e12650ee$var$styles = {
    root: "_00uqCYyL8i _3xtjKN0Rl6 _0H9qDF6wH8 _24h04i2Njc",
    position: "_1mT5xdRAKS"
};
const $ece26180e12650ee$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $ece26180e12650ee$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/; /**
                                                              * __Anchor__
                                                              *
                                                              * A primitive for building custom anchor links.
                                                              *
                                                              * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
                                                              * - [Code](https://atlassian.design/components/primitives/anchor/code)
                                                              * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
                                                              */ 
const $ece26180e12650ee$var$AnchorNoRef = ({ href: href, children: children, onClick: providedOnClick = (0, $9Tkwf.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, newWindowLabel: newWindowLabel = '(opens new window)', ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $fsvuC.useContext)((0, $lNjwN.default));
    const handleClick = (0, $fsvuC.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const opensNewWindowLabelId = (0, $cTXsj.useId)();
    const onClick = (0, $d5Gwv.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    }); // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const RouterLink = (0, $gVC77.useRouterLink)();
    const isExternal = typeof href === 'string' && $ece26180e12650ee$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $ece26180e12650ee$var$IS_NON_HTTP_BASED.test(href); /**
                                                                                    * Renders a router link if:
                                                                                    *
                                                                                    * - a link component is set in the app provider
                                                                                    * - it's not an external link (starting with `http://` or `https://`)
                                                                                    * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
                                                                                    */ 
    const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
    (0, $l9kus.default)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $iLp2b.Focusable // @ts-expect-error we don't allow `a` on Focusable for makers as they should use Anchor instead
    ), {
        as: Component,
        className: xcss,
        style: style,
        ref: ref,
        ...safeHtmlAttributes,
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? `${ariaLabel} , ${newWindowLabel}` : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
        xcss: (0, $4twf9.cx)($ece26180e12650ee$var$styles.root, $ece26180e12650ee$var$styles.position, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
        children: [
            children,
            target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, $5chsV.jsx)((0, $8e1dR.default), {
                id: opensNewWindowLabelId,
                children: `, ${newWindowLabel}`
            })
        ]
    });
};
$ece26180e12650ee$var$AnchorNoRef.displayName = "AnchorNoRef";
const $ece26180e12650ee$export$b688253958b8dfe7 = /*#__PURE__*/ (0, $fsvuC.forwardRef)($ece26180e12650ee$var$AnchorNoRef);

});
parcelRegister("gVC77", function(module, exports) {
$parcel$export(module.exports, "useRouterLink", () => $81a36a85a0cf89f0$export$6d558eab13290f59);

var $fsvuC = parcelRequire("fsvuC");

var $6TE5T = parcelRequire("6TE5T");
const $81a36a85a0cf89f0$export$6d558eab13290f59 = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $fsvuC.useContext)((0, $6TE5T.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};

});
parcelRegister("6TE5T", function(module, exports) {
$parcel$export(module.exports, "RouterLinkProviderContext", () => $2cd4169c140ede87$export$2931e0ee690eee88);
$parcel$export(module.exports, "default", () => $2cd4169c140ede87$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");
const $2cd4169c140ede87$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $fsvuC.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $2cd4169c140ede87$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)($2cd4169c140ede87$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
$2cd4169c140ede87$var$RouterLinkProvider.displayName = "RouterLinkProvider";
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$2cd4169c140ede87$export$2e2bcd8739ae039 = $2cd4169c140ede87$var$RouterLinkProvider;

});




parcelRegister("dhkoW", function(module, exports) {
$parcel$export(module.exports, "default", () => $89e416510f6f2bf2$export$2e2bcd8739ae039);
/* banner.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");

var $fsvuC = parcelRequire("fsvuC");

var $jRYjy = parcelRequire("jRYjy");

var $cogH0 = parcelRequire("cogH0");
const $89e416510f6f2bf2$var$CSS_VAR_TEXT_COLOR = '--banner-text-color';
const $89e416510f6f2bf2$var$inlineStyles = {
    root: "_4ouGXIdnbC"
};
const $89e416510f6f2bf2$var$textStyles = {
    root: "_2sNsIgmnOE _4bt5LAnQyn _2WAcuGnQyn _1UtDYzH6EN _1kk5Tkf7mX _39HuIbz8Lp _1ANEUSLRg7 _0luBOgyL8i _0uGipIyL8i _0DlTgXyL8i _1Oh6lcyL8i _1KbF3ryL8i _2h5UOz0Rl6 _2LQVB40Rl6 _27PHXJ0Rl6 _38ddKy0Rl6 _1R2oCZ0Rl6 _3W2WEt6wH8 _4BW6TR6wH8 _2IWu1s6wH8 _4i4dA66wH8 _06nYrP6wH8 _0gKGie98eZ _1EjoPe98eZ _1BrKNs98eZ _1E1xWz98eZ _3bFj0T98eZ"
};
const $89e416510f6f2bf2$var$backgroundColors = {
    warning: 'color.background.warning.bold',
    error: 'color.background.danger.bold',
    announcement: 'color.background.neutral.bold'
};
const $89e416510f6f2bf2$var$tokenBackgroundColors = {
    warning: "var(--ds-background-warning-bold, #FBC828)",
    error: "var(--ds-background-danger-bold, #C9372C)",
    announcement: "var(--ds-background-neutral-bold, #292A2E)"
};
const $89e416510f6f2bf2$var$tokenTextColors = {
    warning: "var(--ds-text-warning-inverse, #292A2E)",
    error: "var(--ds-text-inverse, #FFFFFF)",
    announcement: "var(--ds-text-inverse, #FFFFFF)"
};
const $89e416510f6f2bf2$var$containerStyles = {
    root: "_0jFU0VDuDI _0hPCNLDIqT _3iDTPbQ4SZ"
};
const $89e416510f6f2bf2$var$iconWrapperStyles = {
    root: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV029DVM _0jFU0V9DVM _3YEZNOdnbC"
};
/**
 * __Banner__
 *
 * A banner displays a prominent message at the top of the screen.
 *
 * - [Examples](https://atlassian.design/components/banner/examples)
 * - [Code](https://atlassian.design/components/banner/code)
 * - [Usage](https://atlassian.design/components/banner/usage)
 */ const $89e416510f6f2bf2$var$Banner = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ appearance: appearance = 'warning', children: children, icon: icon, testId: testId }, ref)=>{
    const appearanceType = appearance in $89e416510f6f2bf2$var$backgroundColors ? appearance : 'warning';
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $jRYjy.Box), {
        xcss: $89e416510f6f2bf2$var$containerStyles.root,
        backgroundColor: $89e416510f6f2bf2$var$backgroundColors[appearanceType],
        padding: "space.150",
        testId: testId,
        ref: ref,
        role: "alert",
        children: /*#__PURE__*/ (0, $5chsV.jsxs)((0, $cogH0.Inline), {
            space: "space.050",
            alignBlock: "center",
            alignInline: "start",
            xcss: $89e416510f6f2bf2$var$inlineStyles.root,
            children: [
                icon ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $jRYjy.Box), {
                    as: "span",
                    xcss: $89e416510f6f2bf2$var$iconWrapperStyles.root,
                    style: {
                        fill: $89e416510f6f2bf2$var$tokenBackgroundColors[appearanceType],
                        color: $89e416510f6f2bf2$var$tokenTextColors[appearanceType]
                    },
                    children: icon
                }) : null,
                /*#__PURE__*/ (0, $5chsV.jsx)("span", {
                    style: {
                        [$89e416510f6f2bf2$var$CSS_VAR_TEXT_COLOR]: $89e416510f6f2bf2$var$tokenTextColors[appearanceType]
                    },
                    className: (0, $gJ6nT.default)([
                        $89e416510f6f2bf2$var$textStyles.root
                    ]),
                    children: children
                })
            ]
        })
    });
});
var $89e416510f6f2bf2$export$2e2bcd8739ae039 = $89e416510f6f2bf2$var$Banner;

});

parcelRegister("l1T84", function(module, exports) {
$parcel$export(module.exports, "default", () => $57032e7307d9cb6c$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $d5Gwv = parcelRequire("d5Gwv");

var $9Tkwf = parcelRequire("9Tkwf");

var $awR7e = parcelRequire("awR7e");

var $chnGv = parcelRequire("chnGv");

var $hZwjD = parcelRequire("hZwjD");

var $llCao = parcelRequire("llCao");

var $f3WQU = parcelRequire("f3WQU");

var $1ihvq = parcelRequire("1ihvq");

var $fD9oc = parcelRequire("fD9oc");

var $av6Iw = parcelRequire("av6Iw");

var $jlKvU = parcelRequire("jlKvU");
const $57032e7307d9cb6c$var$checkIsChildOfPortal = (node)=>{
    if (!node) return false;
    return node.classList && node.classList.contains('atlaskit-portal-container') || $57032e7307d9cb6c$var$checkIsChildOfPortal(node.parentElement);
};
// Close manager for layering
const $57032e7307d9cb6c$var$CloseManager = ({ handleEscapeClose: handleEscapeClose, handleClick: handleClick })=>{
    (0, $chnGv.useCloseOnEscapePress)({
        onClose: handleEscapeClose
    });
    const { isLayerDisabled: isLayerDisabled } = (0, $hZwjD.useLayering)();
    (0, $fsvuC.useEffect)(()=>{
        return (0, $dqdTY.bind)(window, {
            type: 'click',
            listener: (e)=>{
                if (isLayerDisabled()) return;
                handleClick(e);
            },
            options: {
                capture: true
            }
        });
    }, [
        handleClick,
        isLayerDisabled
    ]);
    // only create a dummy component for using ths hook in class component
    return /*#__PURE__*/ (0, $5chsV.jsx)("span", {});
};
$57032e7307d9cb6c$var$CloseManager.displayName = "CloseManager";
const $57032e7307d9cb6c$var$InlineDialog = /*#__PURE__*/ (0, $fsvuC.memo)(function InlineDialog(props) {
    if ((0, $llCao.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $jlKvU.default), {
        ...props
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)($57032e7307d9cb6c$var$InlineDialogLegacy, {
        ...props
    });
});
function $57032e7307d9cb6c$var$InlineDialogLegacy({ isOpen: isOpen = false, onContentBlur: onContentBlur = (0, $9Tkwf.default), onContentClick: onContentClick = (0, $9Tkwf.default), onContentFocus: onContentFocus = (0, $9Tkwf.default), onClose: providedOnClose = (0, $9Tkwf.default), placement: placement = 'bottom-start', strategy: strategy = 'fixed', testId: testId, content: content, children: children, fallbackPlacements: fallbackPlacements }) {
    const containerRef = (0, $fsvuC.useRef)(null);
    const triggerRef = (0, $fsvuC.useRef)(null);
    const onClose = (0, $d5Gwv.usePlatformLeafEventHandler)({
        fn: (event)=>providedOnClose(event),
        action: 'closed',
        componentName: 'inlineDialog',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    // we put this into a ref to avoid handleCloseRequest having this as a dependency
    const onCloseRef = (0, $fsvuC.useRef)(onClose);
    (0, $fsvuC.useEffect)(()=>{
        onCloseRef.current = onClose;
    });
    const handleCloseRequest = (0, $fsvuC.useCallback)((event)=>{
        const { target: target } = event;
        // checks for when target is not HTMLElement
        if (!(target instanceof HTMLElement)) return;
        // TODO: This is to handle the case where the target is no longer in the DOM.
        // This happens with react-select in datetime picker. There might be other
        // edge cases for this.
        if (!document.body.contains(target)) return;
        if (isOpen) {
            onCloseRef.current?.({
                isOpen: false,
                event: event
            });
            return;
        }
        // handles the case where inline dialog opens portalled elements such as modal
        if ($57032e7307d9cb6c$var$checkIsChildOfPortal(target)) return;
        // call onClose if the click originated from outside the dialog
        if (containerRef.current && !containerRef.current.contains(target)) onCloseRef.current?.({
            isOpen: false,
            event: event
        });
    }, [
        isOpen
    ]);
    const handleClick = (0, $fsvuC.useCallback)((event)=>{
        // exit if we click outside but on the trigger — it can handle the clicks itself
        if (triggerRef.current && triggerRef.current.contains(event.target)) return;
        if (containerRef.current?.contains(event.target)) return;
        handleCloseRequest(event);
    }, [
        handleCloseRequest,
        containerRef,
        triggerRef
    ]);
    /**
   * Auto-flip is enabled by default in `@atlaskit/popper` and
   * the `InlineDialog` API does not allow disabling it.
   *
   * We only need to override it if there are `fallbackPlacements` specified.
   */ const modifiers = (0, $fsvuC.useMemo)(()=>fallbackPlacements ? [
            {
                name: 'flip',
                options: {
                    fallbackPlacements: fallbackPlacements
                }
            }
        ] : [], [
        fallbackPlacements
    ]);
    const popper = isOpen ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $f3WQU.Popper), {
        placement: placement,
        strategy: strategy,
        modifiers: modifiers,
        children: ({ ref: ref, style: style })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $av6Iw.Container), {
                onBlur: onContentBlur,
                onFocus: onContentFocus,
                onClick: onContentClick,
                ref: (node)=>{
                    if (node) {
                        containerRef.current = node;
                        if (typeof ref === 'function') ref(node);
                        else ref.current = node;
                    }
                },
                style: style,
                testId: testId,
                children: typeof content === 'function' ? content() : content
            })
    }) : null;
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $1ihvq.Manager), {
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $fD9oc.Reference), {
                children: ({ ref: ref })=>/*#__PURE__*/ (0, $5chsV.jsx)("div", {
                        ref: (node)=>{
                            // Resolve to the first element child of the div in `children`
                            const firstElementChild = node?.firstElementChild || null;
                            triggerRef.current = firstElementChild;
                            if (typeof ref === 'function') ref(firstElementChild);
                            else ref.current = firstElementChild;
                        },
                        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Fragment, {
                            children: children
                        })
                    })
            }),
            isOpen ? /*#__PURE__*/ (0, $5chsV.jsxs)((0, $awR7e.Layering), {
                isDisabled: false,
                children: [
                    popper,
                    /*#__PURE__*/ (0, $5chsV.jsx)($57032e7307d9cb6c$var$CloseManager, {
                        handleEscapeClose: handleCloseRequest,
                        handleClick: handleClick
                    })
                ]
            }) : popper
        ]
    });
}
$57032e7307d9cb6c$var$InlineDialogLegacy.displayName = "InlineDialogLegacy";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$57032e7307d9cb6c$export$2e2bcd8739ae039 = $57032e7307d9cb6c$var$InlineDialog;

});
parcelRegister("av6Iw", function(module, exports) {
$parcel$export(module.exports, "Container", () => $f40fb2ddaccd7ae6$export$42a852a2b6b56249);
/* inline-dialog-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");
const $f40fb2ddaccd7ae6$var$containerStyles = null;
const $f40fb2ddaccd7ae6$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ children: children, onBlur: onBlur, onClick: onClick, onFocus: onFocus, style: style, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        "data-testid": testId,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        className: (0, $gJ6nT.default)([
            "_0bjKvDzXzM _24h04iyL8i _1EqgXlhPwX _0NUa3rhPwX _42Yu6BPvK5 _0KLXruoI2d _2OUyjtGk8v _1UtDYzy7kJ _0xmtko5zaO _46hvQm5zaO _03SyCPNHnM _0LQT5ENHnM _1zr6Dc98eZ _0htemXYbGa _067LceT6kp"
        ]),
        children: typeof children === 'function' ? children() : children
    });
});

});

parcelRegister("jlKvU", function(module, exports) {
$parcel$export(module.exports, "default", () => $be2cccb0777ed022$export$2e2bcd8739ae039);
/* inline-dialog-top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $d5Gwv = parcelRequire("d5Gwv");

var $9Tkwf = parcelRequire("9Tkwf");

var $6KgHe = parcelRequire("6KgHe");

var $974dn = parcelRequire("974dn");

var $4CLv7 = parcelRequire("4CLv7");

var $2jUY9 = parcelRequire("2jUY9");

var $gc525 = parcelRequire("gc525");

var $kOb0h = parcelRequire("kOb0h");
const $be2cccb0777ed022$var$displayContentsStyles = {
    root: "_3iDTPbcK7c"
};
const $be2cccb0777ed022$var$styles = {
    container: "_0bjKvDzXzM _24h04iyL8i _1EqgXlhPwX _0NUa3rhPwX _0KLXruoI2d _2OUyjtGk8v _0xmtko5zaO _46hvQm5zaO _03SyCPNHnM _0LQT5ENHnM"
};
function $be2cccb0777ed022$var$getTriggerElement(trigger) {
    if (!trigger) return null;
    if (trigger instanceof HTMLButtonElement) return trigger;
    return trigger.querySelector('button');
} /**
   * Applies ARIA attributes to the child trigger element via an effect,
   * keeping them in sync with popup state.
   */ 
function $be2cccb0777ed022$var$TriggerWrapper({ children: children, triggerRef: triggerRef, ariaAttributes: ariaAttributes }) {
    (0, $fsvuC.useEffect)(()=>{
        const trigger = $be2cccb0777ed022$var$getTriggerElement(triggerRef.current);
        if (!trigger) return;
         // Apply each attribute. When a value is `undefined` (e.g.
        // `aria-controls` while the popover host is not in the DOM),
        // remove the attribute so the trigger does not retain a stale
        // reference from a previous open.
        Object.entries(ariaAttributes).forEach(([key, value])=>{
            if (value === undefined) {
                trigger.removeAttribute(key);
                return;
            }
            trigger.setAttribute(key, String(value));
        });
    }, [
        ariaAttributes,
        triggerRef
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        ref: (node)=>{
            if (!node) {
                triggerRef.current = null;
                return;
            } // CSS-in-JS may inject <style> elements into this wrapper; they are not trigger elements.
            const triggerElement = Array.from(node.children).find((child)=>child instanceof HTMLElement && !(child instanceof HTMLStyleElement));
            triggerRef.current = triggerElement ?? null;
        },
        className: (0, $gJ6nT.default)([
            $be2cccb0777ed022$var$displayContentsStyles.root
        ]),
        children: children
    });
}
$be2cccb0777ed022$var$TriggerWrapper.displayName = "TriggerWrapper";
/**
 * Top-layer implementation of InlineDialog.
 *
 * Replaces the legacy rendering pipeline (Popper.js + Portal + @atlaskit/layering)
 * with the native Popover API + CSS Anchor Positioning via @atlaskit/top-layer.
 *
 * Gated behind the `platform-dst-top-layer` feature flag.
 */ const $be2cccb0777ed022$var$InlineDialogTopLayer = /*#__PURE__*/ (0, $fsvuC.memo)(function InlineDialogTopLayer({ isOpen: isOpen = false, onContentBlur: onContentBlur = (0, $9Tkwf.default), onContentClick: onContentClick = (0, $9Tkwf.default), onContentFocus: onContentFocus = (0, $9Tkwf.default), onClose: providedOnClose = (0, $9Tkwf.default), placement: placement = 'bottom-start', testId: testId, content: content, children: children, // No-op props.
// These props are accepted for API compatibility but have no effect
// in the top-layer path. Each is documented with why it is unnecessary.
// top-layer: CSS Anchor Positioning replaces Popper strategy. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
strategy: _strategy, // top-layer: Popper.js fallbackPlacements not applicable. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
fallbackPlacements: _fallbackPlacements }) {
    const triggerRef = (0, $fsvuC.useRef)(null);
    const popoverRef = (0, $fsvuC.useRef)(null);
    const popoverId = (0, $kOb0h.usePopoverId)();
    const onClose = (0, $d5Gwv.usePlatformLeafEventHandler)({
        fn: (event)=>providedOnClose(event),
        action: 'closed',
        componentName: 'inlineDialog',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    }); // Placement conversion.
    const topLayerPlacement = (0, $fsvuC.useMemo)(()=>(0, $974dn.fromLegacyPlacement)({
            legacy: placement
        }), [
        placement
    ]); // `isOpen` is included so the anchor positioning effect re-runs when
    // the Popover host element is unmounted/remounted across open cycles.
    (0, $gc525.useAnchoredPopover)({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isOpen
    }); // onClose bridge.
    // Translates top-layer's { reason } into the legacy onClose({ isOpen, event }) shape.
    // Focus restoration is handled automatically by the Popover based on the content role
    // (role="dialog" -> auto-restore).
    const handleOnClose = (0, $fsvuC.useCallback)(({ reason: reason })=>{
        const syntheticEvent = (0, $4CLv7.createPopoverCloseEvent)({
            reason: reason
        });
        onClose({
            isOpen: false,
            event: syntheticEvent
        });
    }, [
        onClose
    ]);
    const ariaAttributes = (0, $6KgHe.getAriaForTrigger)({
        role: 'dialog',
        isOpen: isOpen,
        popoverId: popoverId
    });
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $fsvuC.Fragment), {
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)($be2cccb0777ed022$var$TriggerWrapper, {
                triggerRef: triggerRef,
                ariaAttributes: ariaAttributes,
                children: children
            }),
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $2jUY9.Popover), {
                ref: popoverRef,
                id: popoverId,
                role: "dialog",
                // Acceptable given this component is intent-to-deprecate.
                label: "Inline dialog",
                isOpen: isOpen,
                onClose: handleOnClose,
                shouldAnimate: true,
                placement: topLayerPlacement,
                testId: testId,
                children: /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                    role: "presentation",
                    onBlur: onContentBlur,
                    onClick: onContentClick,
                    onFocus: onContentFocus,
                    className: (0, $gJ6nT.default)([
                        $be2cccb0777ed022$var$styles.container
                    ]),
                    children: typeof content === 'function' ? content() : content
                })
            })
        ]
    });
});
var $be2cccb0777ed022$export$2e2bcd8739ae039 = $be2cccb0777ed022$var$InlineDialogTopLayer;

});
parcelRegister("6KgHe", function(module, exports) {
$parcel$export(module.exports, "getAriaForTrigger", () => $8bd410f79aabc474$export$9dd1d61dd4d4755);
/**
 * Maps each supported popover role to its `aria-haspopup` value.
 *
 * Derived from the HTML spec - maps popover roles to what the trigger
 * announces. Roles that do not produce a popup use `undefined` instead (for
 * non-popup roles like `tooltip`/`status`/`alert`/`note`/`log` where
 * `aria-haspopup` would be misleading), so they are intentionally excluded
 * from this mapping and from `getAriaForTrigger`.
 *
 * `true` is intentionally not a value in this mapping. The runtime only ever
 * produces the explicit string forms, so allowing it would invite consumers
 * to pass `true` and get an `aria-haspopup="true"` serialisation that the
 * runtime no longer emits.
 */ const $8bd410f79aabc474$var$roleToAriaHasPopup = {
    dialog: 'dialog',
    alertdialog: 'dialog',
    menu: 'menu',
    listbox: 'listbox',
    tree: 'tree',
    grid: 'grid'
};
function $8bd410f79aabc474$export$9dd1d61dd4d4755({ role: role, isOpen: isOpen, popoverId: popoverId }) {
    // `aria-controls` is set to `undefined` while closed. The `Popover` /
    // `Dialog` primitives unmount their host element after the exit
    // animation finishes, so a closed-state `aria-controls` would point
    // at a node that is not in the DOM. Returning `undefined` here means
    // JSX spread renders no `aria-controls` attribute on the trigger
    // until the target exists, avoiding the dangling reference while
    // keeping the relationship live whenever it is meaningful.
    return {
        'aria-haspopup': role ? $8bd410f79aabc474$var$roleToAriaHasPopup[role] : undefined,
        'aria-expanded': isOpen,
        'aria-controls': isOpen ? popoverId : undefined
    };
}

});

parcelRegister("4CLv7", function(module, exports) {
$parcel$export(module.exports, "createPopoverCloseEvent", () => $9ff0072eb955a3d0$export$27b4de066896ac63);
function $9ff0072eb955a3d0$export$27b4de066896ac63({ reason: reason }) {
    if (reason === 'escape') return new KeyboardEvent('keydown', {
        key: 'Escape',
        code: 'Escape',
        bubbles: true
    });
    if (reason === 'light-dismiss') return new MouseEvent('click', {
        bubbles: true,
        cancelable: true
    });
    return new Event('close');
}

});



parcelRegister("8xjQm", function(module, exports) {
$parcel$export(module.exports, "PopoverContent", () => $290f4a9a7cb45f2f$export$d7e1f420b25549ff);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $llCao = parcelRequire("llCao");

var $aXgoT = parcelRequire("aXgoT");

var $cs4Km = parcelRequire("cs4Km");
/**
 * __PopoverContent__
 *
 * A `PopoverContent` is the element that is shown as a popover.
 */ const $290f4a9a7cb45f2f$var$renderPopoverContent = (Component, { children: children, placement: placement, motion: motion, isVisible: isVisible, shouldDismissOnClickOutside: shouldDismissOnClickOutside, dismiss: dismiss, back: back, testId: testId, offset: offset, strategy: strategy, ...actionProps })=>{
    if ('next' in actionProps && actionProps.next) return /*#__PURE__*/ (0, $5chsV.jsx)(Component, {
        placement: placement,
        motion: motion,
        isVisible: isVisible,
        shouldDismissOnClickOutside: shouldDismissOnClickOutside,
        dismiss: dismiss,
        back: back,
        testId: testId,
        offset: offset,
        strategy: strategy,
        next: actionProps.next,
        children: children
    });
    if ('done' in actionProps && actionProps.done) return /*#__PURE__*/ (0, $5chsV.jsx)(Component, {
        placement: placement,
        motion: motion,
        isVisible: isVisible,
        shouldDismissOnClickOutside: shouldDismissOnClickOutside,
        dismiss: dismiss,
        back: back,
        testId: testId,
        offset: offset,
        strategy: strategy,
        done: actionProps.done,
        children: children
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)(Component, {
        placement: placement,
        motion: motion,
        isVisible: isVisible,
        shouldDismissOnClickOutside: shouldDismissOnClickOutside,
        dismiss: dismiss,
        back: back,
        testId: testId,
        offset: offset,
        strategy: strategy,
        children: children
    });
};
const $290f4a9a7cb45f2f$export$d7e1f420b25549ff = (props)=>(0, $llCao.fg)('platform-dst-top-layer-spotlight') ? $290f4a9a7cb45f2f$var$renderPopoverContent((0, $cs4Km.PopoverContent), props) : $290f4a9a7cb45f2f$var$renderPopoverContent((0, $aXgoT.PopoverContent), props);

});
parcelRegister("aXgoT", function(module, exports) {
$parcel$export(module.exports, "PopoverContent", () => $a2ed9fd1a7db1b30$export$d7e1f420b25549ff);
/* legacy.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $fz4Xf = parcelRequire("fz4Xf");

var $ceFHj = parcelRequire("ceFHj");

var $llCao = parcelRequire("llCao");

var $f3WQU = parcelRequire("f3WQU");

var $4Uu5R = parcelRequire("4Uu5R");

var $aPhKY = parcelRequire("aPhKY");

var $k45Hz = parcelRequire("k45Hz");

var $4s2yL = parcelRequire("4s2yL");

var $iKELx = parcelRequire("iKELx");
const $a2ed9fd1a7db1b30$var$styles = {
    root: "_42Yu6BkKjW"
};
/**
 * The `transform: rotate(45deg);` styles used to rotate the `Caret` component result in the corners of
 * the caret extending beyond the bounding box (by roughly 2px). So, apply an offset to ensure
 * the caret points to the very edge of the target element.
 *
 * Note: `@atlaskit/popper` maps the offset to the placement, so we only need to define `[0, 2]` and
 * the offset will get correctly rotated depending on the placement.
 */ const $a2ed9fd1a7db1b30$var$defaultOffset = [
    0,
    2
];
/**
 * The Spotlight card can be positioned in many different configurations, but the caret should always point to
 * the center of the target element. `@atlaskit/popper` uses `'top' | 'right' | 'bottom' | 'left'` values for
 * this center alignment along the respective face. So we translate between the Spotlight position, and the
 * Popper position using this map.
 */ const $a2ed9fd1a7db1b30$var$popperPlacementMap = {
    'top-start': 'top',
    'top-center': 'top',
    'top-end': 'top',
    'bottom-start': 'bottom',
    'bottom-center': 'bottom',
    'bottom-end': 'bottom',
    'right-start': 'right',
    'right-end': 'right',
    'left-start': 'left',
    'left-end': 'left'
};
const $a2ed9fd1a7db1b30$var$DefaultMotion = ({ children: children })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $ceFHj.default), {
        enteringAnimation: "var(--ds-spotlight-enter, 250ms cubic-bezier(0.4, 0, 0, 1) ScaleIn95to100, 250ms cubic-bezier(0.4, 0, 0, 1) FadeIn0to100)",
        exitingAnimation: "var(--ds-spotlight-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to95, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
        children: children
    });
$a2ed9fd1a7db1b30$var$DefaultMotion.displayName = "DefaultMotion";
const $a2ed9fd1a7db1b30$export$d7e1f420b25549ff = (props)=>{
    const { children: children, placement: placement, motion: motion = $a2ed9fd1a7db1b30$var$DefaultMotion, isVisible: isVisible = true, shouldDismissOnClickOutside: shouldDismissOnClickOutside = true, dismiss: dismiss, back: back, testId: testId, offset: offset = $a2ed9fd1a7db1b30$var$defaultOffset, strategy: strategy } = props;
    /**
   * A user should only be able to pass a `done` or a `next`. Not both.
   * The type is set up as a discriminant union. So, we need a typeguard
   * here to destructure it properly.
   */ const done = 'done' in props ? props.done : undefined;
    const next = 'next' in props ? props.next : undefined;
    const updateRef = (0, $fsvuC.useRef)(()=>new Promise(()=>undefined));
    const ref = (0, $fsvuC.useRef)(null);
    const { heading: heading, popoverContent: popoverContent, card: card, primaryAction: primaryAction, secondaryAction: secondaryAction } = (0, $fsvuC.useContext)((0, $4Uu5R.SpotlightContext));
    const focusWithin = (0, $aPhKY.useFocusWithin)(popoverContent.ref);
    (0, $fsvuC.useEffect)(()=>{
        popoverContent.setRef(ref);
    }, [
        ref,
        popoverContent
    ]);
    (0, $fsvuC.useEffect)(()=>{
        if (!done && !next) return;
        if (done) {
            primaryAction.setAction(done);
            return;
        } else if (next) {
            primaryAction.setAction(next);
            return;
        }
    }, [
        done,
        next,
        primaryAction
    ]);
    (0, $fsvuC.useEffect)(()=>{
        popoverContent.setDismiss(dismiss);
    }, [
        dismiss,
        popoverContent
    ]);
    (0, $fsvuC.useEffect)(()=>{
        if (!back) return;
        secondaryAction.setAction(back);
    }, [
        back,
        secondaryAction
    ]);
    (0, $fsvuC.useLayoutEffect)(()=>{
        card.setPlacement(placement);
        if (motion) card.setMotion(()=>motion);
    }, [
        placement,
        card,
        motion
    ]);
    (0, $fsvuC.useEffect)(()=>{
        if (updateRef.current) popoverContent.setUpdate(()=>updateRef.current);
    }, [
        popoverContent
    ]);
    (0, $4s2yL.useOnEscape)((event)=>{
        if (!focusWithin) return;
        popoverContent.dismiss.current(event);
    });
    (0, $k45Hz.useOnClickOutside)((event)=>{
        if (!shouldDismissOnClickOutside) return;
        popoverContent.dismiss.current(event);
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $f3WQU.Popper), {
        offset: offset,
        strategy: strategy,
        placement: $a2ed9fd1a7db1b30$var$popperPlacementMap[placement],
        children: ({ ref: localRef, style: style, update: update })=>{
            if (!isVisible && !(0, $llCao.fg)('platform-dst-motion-uplift-spotlight')) return;
            updateRef.current = update;
            return (0, $llCao.fg)('platform-dst-motion-uplift-spotlight') ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $iKELx.ConditionalExitingPersistence), {
                children: isVisible && /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                    role: "dialog",
                    "data-testid": testId,
                    "aria-labelledby": heading.id,
                    ref: (0, $fz4Xf.default)([
                        ref,
                        localRef
                    ]),
                    style: style,
                    className: (0, $gJ6nT.default)([
                        $a2ed9fd1a7db1b30$var$styles.root
                    ]),
                    children: children
                })
            }) : /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                role: "dialog",
                "data-testid": testId,
                "aria-labelledby": heading.id,
                ref: (0, $fz4Xf.default)([
                    ref,
                    localRef
                ]),
                style: style,
                className: (0, $gJ6nT.default)([
                    $a2ed9fd1a7db1b30$var$styles.root
                ]),
                children: children
            });
        }
    });
};
$a2ed9fd1a7db1b30$export$d7e1f420b25549ff.displayName = "PopoverContent";

});
parcelRegister("4Uu5R", function(module, exports) {
$parcel$export(module.exports, "SpotlightContext", () => $c08138dc8af3a65e$export$7b5aa0f5b37a336d);
$parcel$export(module.exports, "SpotlightContextProvider", () => $c08138dc8af3a65e$export$ad26233dae620a42);
/* context.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");
const $c08138dc8af3a65e$export$7b5aa0f5b37a336d = /*#__PURE__*/ (0, $fsvuC.createContext)({
    card: {
        ref: null,
        setRef: ()=>undefined,
        placement: 'bottom-end',
        setPlacement: ()=>undefined,
        motion: undefined,
        setMotion: ()=>undefined
    },
    heading: {
        id: '',
        setId: ()=>undefined
    },
    popoverContent: {
        ref: undefined,
        setRef: ()=>undefined,
        positionArea: undefined,
        setPositionArea: ()=>undefined,
        update: ()=>new Promise(()=>null),
        setUpdate: ()=>new Promise(()=>null),
        dismiss: {
            current: ()=>undefined
        },
        setDismiss: ()=>undefined
    },
    target: {
        ref: {
            current: null
        },
        setRef: ()=>undefined
    },
    primaryAction: {
        action: {
            current: ()=>undefined
        },
        setAction: ()=>undefined
    },
    secondaryAction: {
        action: {
            current: ()=>undefined
        },
        setAction: ()=>undefined
    }
});
const $c08138dc8af3a65e$export$ad26233dae620a42 = ({ children: children, targetRef: targetRef })=>{
    const id = (0, $fsvuC.useId)();
    const defaultTargetRef = (0, $fsvuC.useRef)(null);
    const [motion, setMotion] = (0, $fsvuC.useState)();
    const [placement, setPlacement] = (0, $fsvuC.useState)('bottom-end');
    const [headingId, setHeadingId] = (0, $fsvuC.useState)(`${id}-heading`);
    const [update, setUpdate] = (0, $fsvuC.useState)(()=>async ()=>undefined);
    const [popoverRef, setPopoverRef] = (0, $fsvuC.useState)();
    const [positionArea, setPositionArea] = (0, $fsvuC.useState)();
    const [cardRef, setCardRef] = (0, $fsvuC.useState)(null);
    const [internalTargetRef, setInternalTargetRef] = (0, $fsvuC.useState)(defaultTargetRef);
    // `targetRef` (the prop) takes precedence when provided. Its identity is
    // allowed to change over time; downstream consumers that depend on
    // `target.ref` identity (e.g. `useAnchoredPopover`'s effect deps) will
    // re-run accordingly.
    const effectiveTargetRef = targetRef ?? internalTargetRef;
    const dismissRef = (0, $fsvuC.useRef)(()=>undefined);
    const setDismiss = (dismissFn)=>{
        dismissRef.current = dismissFn;
    };
    const secondaryActionRef = (0, $fsvuC.useRef)(()=>undefined);
    const setSecondaryAction = (actionFn)=>{
        secondaryActionRef.current = actionFn;
    };
    const primaryActionRef = (0, $fsvuC.useRef)(()=>undefined);
    const setPrimaryAction = (actionFn)=>{
        primaryActionRef.current = actionFn;
    };
    return /*#__PURE__*/ (0, $5chsV.jsx)($c08138dc8af3a65e$export$7b5aa0f5b37a336d.Provider, {
        value: {
            card: {
                ref: cardRef,
                setRef: setCardRef,
                placement: placement,
                setPlacement: setPlacement,
                motion: motion,
                setMotion: setMotion
            },
            heading: {
                id: headingId,
                setId: setHeadingId
            },
            popoverContent: {
                ref: popoverRef,
                setRef: setPopoverRef,
                positionArea: positionArea,
                setPositionArea: setPositionArea,
                update: update,
                setUpdate: setUpdate,
                dismiss: dismissRef,
                setDismiss: setDismiss
            },
            target: {
                ref: effectiveTargetRef,
                setRef: setInternalTargetRef
            },
            primaryAction: {
                action: primaryActionRef,
                setAction: setPrimaryAction
            },
            secondaryAction: {
                action: secondaryActionRef,
                setAction: setSecondaryAction
            }
        },
        children: children
    });
};
$c08138dc8af3a65e$export$ad26233dae620a42.displayName = "SpotlightContextProvider";

});

parcelRegister("aPhKY", function(module, exports) {
$parcel$export(module.exports, "useFocusWithin", () => $ac6ed50423fc1e37$export$420e68273165f4ec);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $jF8Yw = parcelRequire("jF8Yw");
const $ac6ed50423fc1e37$export$420e68273165f4ec = (ref)=>{
    const [active, setActive] = (0, $fsvuC.useState)(null);
    const updateFocusedElement = (0, $fsvuC.useCallback)(()=>{
        const doc = (0, $jF8Yw.getDocument)();
        const activeElement = doc?.activeElement || null;
        if (!ref || !ref.current) {
            setActive(null);
            return;
        }
        if (!activeElement) {
            setActive(null);
            return;
        }
        // Check if the focused element is within the ref element
        if (!ref.current.contains(activeElement)) {
            setActive(null);
            return;
        }
        setActive(activeElement);
    }, [
        ref
    ]);
    (0, $fsvuC.useEffect)(()=>{
        const doc = (0, $jF8Yw.getDocument)();
        if (!doc) return;
        updateFocusedElement();
        const unbindFocusIn = (0, $dqdTY.bind)(doc, {
            type: 'focusin',
            listener: updateFocusedElement
        });
        return ()=>{
            unbindFocusIn();
        };
    }, [
        updateFocusedElement
    ]);
    return active;
};

});

parcelRegister("k45Hz", function(module, exports) {
$parcel$export(module.exports, "useOnClickOutside", () => $9500cca9e4e3ba2d$export$9afc64c180e82dc4);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $jF8Yw = parcelRequire("jF8Yw");

var $4Uu5R = parcelRequire("4Uu5R");
const $9500cca9e4e3ba2d$export$9afc64c180e82dc4 = (onClickOutside)=>{
    const { card: card } = (0, $fsvuC.useContext)((0, $4Uu5R.SpotlightContext));
    const ref = card.ref;
    (0, $fsvuC.useEffect)(()=>{
        const doc = (0, $jF8Yw.getDocument)();
        if (!doc) return;
        const unbindMouseUp = (0, $dqdTY.bind)(doc, {
            type: 'mouseup',
            listener: (event)=>{
                if (!ref || !ref.current) return;
                const target = event.target instanceof Node ? event.target : null;
                if (ref.current.contains(target)) return;
                onClickOutside(event);
            }
        });
        return ()=>{
            unbindMouseUp();
        };
    }, [
        onClickOutside,
        ref
    ]);
};

});

parcelRegister("4s2yL", function(module, exports) {
$parcel$export(module.exports, "useOnEscape", () => $0a26e5f9d149cf11$export$795d56022f0285ed);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $jF8Yw = parcelRequire("jF8Yw");
const $0a26e5f9d149cf11$var$onKeyDown = (event, { onEscape: onEscape })=>{
    switch(event.key){
        case 'Escape':
            onEscape();
            break;
        default:
            break;
    }
};
const $0a26e5f9d149cf11$export$795d56022f0285ed = (onEscape)=>{
    (0, $fsvuC.useEffect)(()=>{
        const doc = (0, $jF8Yw.getDocument)();
        if (!doc) return;
        const unbindFocusIn = (0, $dqdTY.bind)(doc, {
            type: 'keydown',
            listener: (event)=>$0a26e5f9d149cf11$var$onKeyDown(event, {
                    onEscape: ()=>onEscape(event)
                })
        });
        return ()=>{
            unbindFocusIn();
        };
    }, [
        onEscape
    ]);
};

});

parcelRegister("iKELx", function(module, exports) {
$parcel$export(module.exports, "ConditionalExitingPersistence", () => $70153031af43ce52$export$4c013c06aa0aee51);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $lfw4f = parcelRequire("lfw4f");

var $4Uu5R = parcelRequire("4Uu5R");
const $70153031af43ce52$export$4c013c06aa0aee51 = ({ children: children })=>{
    const { card: card } = (0, $fsvuC.useContext)((0, $4Uu5R.SpotlightContext));
    if (card.motion) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $lfw4f.default), {
        children: children
    });
    return children;
};
$70153031af43ce52$export$4c013c06aa0aee51.displayName = "ConditionalExitingPersistence";

});


parcelRegister("cs4Km", function(module, exports) {
$parcel$export(module.exports, "PopoverContent", () => $da76b45a62fd4b13$export$d7e1f420b25549ff);
/* top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $ceFHj = parcelRequire("ceFHj");

var $4CLv7 = parcelRequire("4CLv7");

var $2jUY9 = parcelRequire("2jUY9");

var $gc525 = parcelRequire("gc525");

var $9qGz4 = parcelRequire("9qGz4");

var $4Uu5R = parcelRequire("4Uu5R");

var $7Qpz6 = parcelRequire("7Qpz6");

var $dk0Y9 = parcelRequire("dk0Y9");
const $da76b45a62fd4b13$var$noopUpdate = ()=>Promise.resolve();
const $da76b45a62fd4b13$var$DefaultMotion = ({ children: children })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $ceFHj.default), {
        enteringAnimation: "var(--ds-spotlight-enter, 250ms cubic-bezier(0.4, 0, 0, 1) ScaleIn95to100, 250ms cubic-bezier(0.4, 0, 0, 1) FadeIn0to100)",
        exitingAnimation: "var(--ds-spotlight-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to95, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
        children: children
    });
$da76b45a62fd4b13$var$DefaultMotion.displayName = "DefaultMotion";
const $da76b45a62fd4b13$export$d7e1f420b25549ff = (props)=>{
    /**
   * This composes the low-level `@atlaskit/top-layer` `Popover` primitive directly
   * (rather than `@atlaskit/popup` or a higher-level wrapper) for two reasons:
   *
   * 1. Spotlight has bespoke positioning, dismiss, and motion requirements that
   *    are coupled to the surrounding `SpotlightContext` (heading id, card
   *    placement, primary/secondary actions, etc.). Building on the primitive
   *    keeps that wiring local to spotlight without leaking into a shared popup.
   * 2. Spotlight's public API exposes a `dismiss(event)` callback that takes a
   *    `KeyboardEvent` / `MouseEvent`, while the top-layer primitive surfaces a
   *    structured `{ reason }`. Bridging that contract here (via
   *    `createPopoverCloseEvent`) preserves backwards compatibility for existing
   *    consumers as we migrate behind the `platform-dst-top-layer-spotlight` gate.
   */ const { children: children, placement: placement, motion: motion = $da76b45a62fd4b13$var$DefaultMotion, isVisible: isVisible = true, shouldDismissOnClickOutside: shouldDismissOnClickOutside = true, dismiss: dismiss, back: back, testId: testId, offset: offset } = props;
    const done = 'done' in props ? props.done : undefined;
    const next = 'next' in props ? props.next : undefined;
    const popoverRef = (0, $fsvuC.useRef)(null);
    const { heading: heading, popoverContent: popoverContent, card: card, primaryAction: primaryAction, secondaryAction: secondaryAction, target: target } = (0, $fsvuC.useContext)((0, $4Uu5R.SpotlightContext));
    (0, $gc525.useAnchoredPopover)({
        anchorRef: target.ref,
        popoverRef: popoverRef,
        placement: (0, $dk0Y9.getPlacementWithOffset)({
            placement: placement,
            offset: offset
        }),
        isOpen: isVisible
    });
    (0, $9qGz4.useSimpleLightDismiss)({
        popoverRef: popoverRef,
        isOpen: isVisible,
        onClose: ({ reason: reason })=>{
            if (reason === 'light-dismiss' && !shouldDismissOnClickOutside) return;
            // `createPopoverCloseEvent` is typed as `KeyboardEvent | MouseEvent | Event`
            // for forward-compatibility, but only `escape` / `light-dismiss` are
            // possible here, so the result is always a Keyboard/MouseEvent.
            dismiss((0, $4CLv7.createPopoverCloseEvent)({
                reason: reason
            }));
        }
    });
    (0, $fsvuC.useEffect)(()=>{
        popoverContent.setRef(popoverRef);
        popoverContent.setUpdate(()=>$da76b45a62fd4b13$var$noopUpdate);
    }, [
        popoverContent
    ]);
    const positionArea = (0, $7Qpz6.usePositionArea)(popoverRef);
    (0, $fsvuC.useEffect)(()=>{
        popoverContent.setPositionArea(positionArea);
    }, [
        popoverContent,
        positionArea
    ]);
    (0, $fsvuC.useEffect)(()=>{
        if (!done && !next) return;
        if (done) {
            primaryAction.setAction(done);
            return;
        } else if (next) {
            primaryAction.setAction(next);
            return;
        }
    }, [
        done,
        next,
        primaryAction
    ]);
    (0, $fsvuC.useEffect)(()=>{
        popoverContent.setDismiss(dismiss);
    }, [
        dismiss,
        popoverContent
    ]);
    (0, $fsvuC.useEffect)(()=>{
        if (!back) return;
        secondaryAction.setAction(back);
    }, [
        back,
        secondaryAction
    ]);
    (0, $fsvuC.useLayoutEffect)(()=>{
        card.setPlacement(placement);
        if (motion) card.setMotion(()=>motion);
    }, [
        placement,
        card,
        motion
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $2jUY9.Popover), {
        ref: popoverRef,
        isOpen: isVisible,
        mode: "manual",
        role: "dialog",
        labelledBy: heading.id,
        testId: testId,
        children: children
    });
};
$da76b45a62fd4b13$export$d7e1f420b25549ff.displayName = "PopoverContent";

});
parcelRegister("9qGz4", function(module, exports) {
$parcel$export(module.exports, "useSimpleLightDismiss", () => $966dd632b127ddf7$export$a1840020a453c833);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");
function $966dd632b127ddf7$export$a1840020a453c833({ popoverRef: popoverRef, additionalInsideElementRefs: additionalInsideElementRefs, isOpen: isOpen, onClose: onClose }) {
    // Keep a stable ref to onClose so the effect does not re-bind on every render.
    const onCloseRef = (0, $fsvuC.useRef)(onClose);
    onCloseRef.current = onClose;
    (0, $fsvuC.useEffect)(()=>{
        if (!isOpen) return;
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- binding to document for light dismiss
        const unbindEscape = (0, $dqdTY.bind)(document, {
            type: 'keydown',
            listener: (event)=>{
                if (event.key !== 'Escape' || event.defaultPrevented) return;
                // Preserve JavaScript bubbling while preventing a native/manual
                // popover ancestor from also handling this Escape key.
                event.preventDefault();
                onCloseRef.current({
                    reason: 'escape'
                });
            }
        });
        // Listen for click-outside in the **capture** phase.
        //
        // The click that opened the popover propagates in bubble phase
        // (trigger onClick → setIsOpen(true) → React render → useEffect).
        // By the time this effect runs, the opening click has finished
        // bubbling. A capture-phase listener added now cannot retroactively
        // fire for that event - it only fires for *future* clicks.
        //
        // This avoids the need for timestamp guards or deferred binding.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- binding to document for light dismiss
        const unbindClickOutside = (0, $dqdTY.bind)(document, {
            type: 'click',
            listener: (event)=>{
                const element = popoverRef.current;
                const target = event.target;
                if (!element || !(target instanceof Node)) return;
                // Clicks inside the popover or its additional inside elements do not dismiss it.
                if (element.contains(target) || additionalInsideElementRefs?.some((insideElementRef)=>insideElementRef.current?.contains(target))) return;
                onCloseRef.current({
                    reason: 'light-dismiss'
                });
            },
            options: {
                capture: true
            }
        });
        return ()=>{
            unbindEscape();
            unbindClickOutside();
        };
    }, [
        additionalInsideElementRefs,
        isOpen,
        popoverRef
    ]);
}

});

parcelRegister("7Qpz6", function(module, exports) {
$parcel$export(module.exports, "usePositionArea", () => $fe7c56ad68eb46d9$export$c25d226a9f6a64fa);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");
const $fe7c56ad68eb46d9$export$c25d226a9f6a64fa = (ref)=>{
    const [positionArea, setPositionArea] = (0, $fsvuC.useState)(undefined);
    (0, $fsvuC.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const readPositionArea = ()=>{
            try {
                return el.computedStyleMap().get('position-area')?.toString();
            } catch  {
                // Some old browsers do not support computedStyleMap, so fall back to getPropertyValue
                return window.getComputedStyle(el).getPropertyValue('position-area').trim();
            }
        };
        const read = ()=>{
            const positionArea = readPositionArea();
            setPositionArea(positionArea);
        };
        read();
        /**
		 * requestAnimationFrame ensures that initial renders are in a different position
		 * to the supplied prop value (e.g. the viewport is too small so the position is
		 * recalculated) are rendered correctly.
		 */ const rafId = window.requestAnimationFrame(read);
        // Check if the viewport resizes
        const unbindResize = (0, $dqdTY.bind)(window, {
            type: 'resize',
            listener: read,
            options: {
                passive: true
            }
        });
        // Check if the viewport scrolls
        const unbindScroll = (0, $dqdTY.bind)(window, {
            type: 'scroll',
            listener: read,
            options: {
                passive: true,
                capture: true
            }
        });
        return ()=>{
            window.cancelAnimationFrame(rafId);
            unbindResize();
            unbindScroll();
        };
    }, [
        ref
    ]);
    return positionArea;
};

});

parcelRegister("dk0Y9", function(module, exports) {
$parcel$export(module.exports, "getPlacementWithOffset", () => $bfcec560f3b578ba$export$ca1bb198c4ca0115);

var $l4ybh = parcelRequire("l4ybh");
const $bfcec560f3b578ba$var$DEFAULT_GAP = "var(--ds-space-050, 4px)";
function $bfcec560f3b578ba$var$normalizeOffsetMember({ value: value }) {
    return value ?? 0;
}
function $bfcec560f3b578ba$var$addCssLength({ base: base, delta: delta }) {
    if (delta === 0) return base;
    if (typeof base === 'number') return base + delta;
    const operator = delta > 0 ? '+' : '-';
    return `calc(${base} ${operator} ${Math.abs(delta)}px)`;
}
function $bfcec560f3b578ba$var$toSignedCrossAxisShiftValue({ crossAxisShift: crossAxisShift }) {
    const baseValue = crossAxisShift.value ?? 0;
    if (crossAxisShift.direction === 'forwards') return baseValue;
    if (typeof baseValue === 'number') return -baseValue;
    return `calc(-1 * ${baseValue})`;
}
function $bfcec560f3b578ba$var$getCrossAxisShiftWithOffset({ baseCrossAxisShift: baseCrossAxisShift, along: along }) {
    if (!baseCrossAxisShift) {
        if (along === 0) return undefined;
        return {
            value: along,
            direction: 'forwards'
        };
    }
    if (along === 0) return baseCrossAxisShift;
    // Collapse sign into the CSS length so additive composition works even
    // when the existing shift is already expressed as a `calc(...)` string.
    return {
        value: $bfcec560f3b578ba$var$addCssLength({
            base: $bfcec560f3b578ba$var$toSignedCrossAxisShiftValue({
                crossAxisShift: baseCrossAxisShift
            }),
            delta: along
        }),
        direction: 'forwards'
    };
}
function $bfcec560f3b578ba$export$ca1bb198c4ca0115({ placement: placement, offset: offset }) {
    const basePlacement = (0, $l4ybh.placementMap)[placement];
    if (!offset) return basePlacement;
    const [alongRaw, awayRaw] = offset;
    const along = $bfcec560f3b578ba$var$normalizeOffsetMember({
        value: alongRaw
    });
    const away = $bfcec560f3b578ba$var$normalizeOffsetMember({
        value: awayRaw
    });
    if (along === 0 && away === 0) return basePlacement;
    const gap = $bfcec560f3b578ba$var$addCssLength({
        base: basePlacement.offset?.gap ?? $bfcec560f3b578ba$var$DEFAULT_GAP,
        delta: away
    });
    const crossAxisShift = $bfcec560f3b578ba$var$getCrossAxisShiftWithOffset({
        baseCrossAxisShift: basePlacement.offset?.crossAxisShift,
        along: along
    });
    return {
        ...basePlacement,
        offset: {
            ...basePlacement.offset,
            gap: gap,
            ...crossAxisShift ? {
                crossAxisShift: crossAxisShift
            } : {}
        }
    };
}

});
parcelRegister("l4ybh", function(module, exports) {
$parcel$export(module.exports, "placementMap", () => $1f0d45d6567e7382$export$168f55451c1c934);
const $1f0d45d6567e7382$var$GAP = "var(--ds-space-050, 4px)";
/**
 * Cross-axis shift toward target centre on block-axis placements (CSS anchor path).
 */ const $1f0d45d6567e7382$var$INLINE_TARGET_CENTER_SHIFT = 'calc(anchor-size(width) / 2 - 28px)';
/**
 * Cross-axis shift toward target centre on inline-axis placements (CSS anchor path).
 */ const $1f0d45d6567e7382$var$BLOCK_TARGET_CENTER_SHIFT = 'calc(anchor-size(height) / 2 - 22px)';
const $1f0d45d6567e7382$export$168f55451c1c934 = {
    'top-start': {
        axis: 'block',
        edge: 'start',
        align: 'end',
        offset: {
            gap: $1f0d45d6567e7382$var$GAP,
            crossAxisShift: {
                value: $1f0d45d6567e7382$var$INLINE_TARGET_CENTER_SHIFT,
                direction: 'backwards'
            }
        }
    },
    'top-center': {
        axis: 'block',
        edge: 'start',
        align: 'center',
        offset: {
            gap: $1f0d45d6567e7382$var$GAP
        }
    },
    'top-end': {
        axis: 'block',
        edge: 'start',
        align: 'start',
        offset: {
            gap: $1f0d45d6567e7382$var$GAP,
            crossAxisShift: {
                value: $1f0d45d6567e7382$var$INLINE_TARGET_CENTER_SHIFT,
                direction: 'forwards'
            }
        }
    },
    'bottom-start': {
        axis: 'block',
        edge: 'end',
        align: 'end',
        offset: {
            gap: $1f0d45d6567e7382$var$GAP,
            crossAxisShift: {
                value: $1f0d45d6567e7382$var$INLINE_TARGET_CENTER_SHIFT,
                direction: 'backwards'
            }
        }
    },
    'bottom-center': {
        axis: 'block',
        edge: 'end',
        align: 'center',
        offset: {
            gap: $1f0d45d6567e7382$var$GAP
        }
    },
    'bottom-end': {
        axis: 'block',
        edge: 'end',
        align: 'start',
        offset: {
            gap: $1f0d45d6567e7382$var$GAP,
            crossAxisShift: {
                value: $1f0d45d6567e7382$var$INLINE_TARGET_CENTER_SHIFT,
                direction: 'forwards'
            }
        }
    },
    'right-start': {
        axis: 'inline',
        edge: 'end',
        align: 'end',
        offset: {
            gap: $1f0d45d6567e7382$var$GAP,
            crossAxisShift: {
                value: $1f0d45d6567e7382$var$BLOCK_TARGET_CENTER_SHIFT,
                direction: 'backwards'
            }
        }
    },
    'right-end': {
        axis: 'inline',
        edge: 'end',
        align: 'start',
        offset: {
            gap: $1f0d45d6567e7382$var$GAP,
            crossAxisShift: {
                value: `calc(${$1f0d45d6567e7382$var$BLOCK_TARGET_CENTER_SHIFT} - 4px)`,
                direction: 'forwards'
            }
        }
    },
    'left-start': {
        axis: 'inline',
        edge: 'start',
        align: 'end',
        offset: {
            gap: $1f0d45d6567e7382$var$GAP,
            crossAxisShift: {
                value: $1f0d45d6567e7382$var$BLOCK_TARGET_CENTER_SHIFT,
                direction: 'backwards'
            }
        }
    },
    'left-end': {
        axis: 'inline',
        edge: 'start',
        align: 'start',
        offset: {
            gap: $1f0d45d6567e7382$var$GAP,
            crossAxisShift: {
                value: `calc(${$1f0d45d6567e7382$var$BLOCK_TARGET_CENTER_SHIFT} - 4px)`,
                direction: 'forwards'
            }
        }
    }
};

});




parcelRegister("RG5NG", function(module, exports) {
$parcel$export(module.exports, "Popup", () => $ca4a571221645036$export$129a32eedafa97c5);
/* popup.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $cTXsj = parcelRequire("cTXsj");

var $awR7e = parcelRequire("awR7e");

var $iqc8V = parcelRequire("iqc8V");

var $lfw4f = parcelRequire("lfw4f");

var $llCao = parcelRequire("llCao");

var $1ihvq = parcelRequire("1ihvq");

var $fD9oc = parcelRequire("fD9oc");

var $bDK6L = parcelRequire("bDK6L");

var $jRYjy = parcelRequire("jRYjy");

var $gC2P9 = parcelRequire("gC2P9");

var $9LFyV = parcelRequire("9LFyV");

var $2FHIx = parcelRequire("2FHIx");

var $2Wwgj = parcelRequire("2Wwgj");

var $jOpEM = parcelRequire("jOpEM");
const $ca4a571221645036$var$defaultLayer = 400;
const $ca4a571221645036$var$wrapperStyles = {
    root: "_1mT5xdRAKS"
};
const $ca4a571221645036$var$PopupLegacy = (props)=>{
    const { xcss: xcss, appearance: inAppearance = 'default', isOpen: isOpen, id: providedId, offset: offset, testId: testId, trigger: trigger, content: content, onClose: onClose, boundary: boundary, rootBoundary: rootBoundary = 'viewport', shouldFlip: shouldFlip = true, placement: placement = 'auto', fallbackPlacements: fallbackPlacements, popupComponent: PopupContainer, autoFocus: autoFocus = true, zIndex: zIndex = $ca4a571221645036$var$defaultLayer, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick = false, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent, shouldRenderToParent: inShouldRenderToParent = false, shouldFitContainer: shouldFitContainer = false, shouldDisableFocusLock: shouldDisableFocusLock = false, shouldReturnFocus: shouldReturnFocus = true, strategy: strategy, role: role, label: label, titleId: titleId, modifiers: modifiers, shouldFitViewport: shouldFitViewport } = props;
    const [triggerRef, setTriggerRef] = (0, $fsvuC.useState)(null);
    const getMergedTriggerRef = (0, $2Wwgj.useGetMemoizedMergedTriggerRef)();
    const getMergedTriggerRefNew = (0, $jOpEM.useGetMemoizedMergedTriggerRefNew)();
    const generatedId = (0, $cTXsj.useId)();
    const { appearance: appearance, shouldRenderToParent: shouldRenderToParent } = (0, $2FHIx.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    });
    const id = providedId || generatedId;
    const handleOpenLayerObserverCloseSignal = (0, $fsvuC.useCallback)(()=>{
        onClose?.(null);
    }, [
        onClose
    ]);
    (0, $iqc8V.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal,
        type: 'popup'
    });
    // `xcss` is part of Popup's public API and is forwarded as-is to
    // the internal PopperWrapper, which rebuilds the inner styles. We
    // re-bind via a property accessor on a stable object so the
    // design-system css-prop lint rule's identifier-shape check no
    // longer flags it (avoiding a ratcheted lint suppression here).
    const xcssPassthrough = {
        value: xcss
    };
    const renderPopperWrapper = /*#__PURE__*/ (0, $5chsV.jsx)((0, $awR7e.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $gC2P9.default), {
            xcss: xcssPassthrough.value,
            appearance: appearance,
            content: content,
            isOpen: isOpen,
            placement: placement,
            fallbackPlacements: fallbackPlacements,
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: shouldFlip,
            offset: offset,
            popupComponent: PopupContainer,
            id: id,
            testId: testId,
            onClose: onClose,
            autoFocus: autoFocus,
            shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
            shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
            shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
            shouldFitContainer: shouldFitContainer,
            shouldDisableFocusLock: shouldDisableFocusLock,
            shouldReturnFocus: shouldReturnFocus,
            triggerRef: triggerRef,
            zIndex: zIndex,
            strategy: shouldFitContainer ? 'absolute' : strategy,
            role: role,
            label: label,
            titleId: titleId,
            modifiers: modifiers,
            shouldFitViewport: shouldFitViewport
        })
    });
    const popupContent = /*#__PURE__*/ (0, $5chsV.jsxs)((0, $1ihvq.Manager), {
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $fD9oc.Reference), {
                children: ({ ref: ref })=>{
                    return trigger({
                        ref: !(0, $llCao.fg)('platform-design-system-popup-ref') ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
                        'aria-controls': isOpen ? id : undefined,
                        'aria-expanded': isOpen,
                        'aria-haspopup': role === 'dialog' && (0, $llCao.fg)('platform_dst_popup-disable-focuslock') ? 'dialog' : true
                    });
                }
            }),
            !(0, $llCao.fg)('platform-dst-motion-uplift-popup') && isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ (0, $5chsV.jsx)((0, $bDK6L.default), {
                zIndex: zIndex,
                children: renderPopperWrapper
            })),
            (0, $llCao.fg)('platform-dst-motion-uplift-popup') && /*#__PURE__*/ (0, $5chsV.jsx)((0, $lfw4f.default), {
                appear: true,
                children: isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ (0, $5chsV.jsx)((0, $bDK6L.default), {
                    zIndex: zIndex,
                    children: renderPopperWrapper
                }))
            })
        ]
    });
    if (shouldFitContainer) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $jRYjy.Box), {
        xcss: $ca4a571221645036$var$wrapperStyles.root,
        children: popupContent
    });
    return popupContent;
};
$ca4a571221645036$var$PopupLegacy.displayName = "PopupLegacy";
const $ca4a571221645036$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $fsvuC.memo)((props)=>{
    // Choose the rendering implementation at the component boundary rather than
    // gating hooks inside a single component. Each implementation owns its own
    // hooks unconditionally, so a runtime feature-flag change swaps component
    // types (a clean remount) instead of changing the hook order of a mounted
    // component.
    if ((0, $llCao.fg)('platform-dst-top-layer')) // Pass the original props object to preserve the discriminated union
    // (shouldFitContainer: true vs false) that is lost after destructuring.
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $9LFyV.PopupTopLayer), {
        ...props
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)($ca4a571221645036$var$PopupLegacy, {
        ...props
    });
});

});
parcelRegister("gC2P9", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd8044c9121890e0$export$2e2bcd8739ae039);
/* popper-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $hZwjD = parcelRequire("hZwjD");

var $ceFHj = parcelRequire("ceFHj");

var $ixlCP = parcelRequire("ixlCP");

var $llCao = parcelRequire("llCao");

var $f3WQU = parcelRequire("f3WQU");

var $31xNG = parcelRequire("31xNG");

var $guB7K = parcelRequire("guB7K");

var $a3XlP = parcelRequire("a3XlP");
const $dd8044c9121890e0$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $dd8044c9121890e0$var$fullWidthStyles = null;
const $dd8044c9121890e0$var$wrapperStyles = {
    root: "_0bjKvD8fU6 _3iDTPbvLZJ _24h04i2Njc _42Yu6B3fRC _0KLXruoI2d _2OUyjtGk8v _1UtDYzy7kJ _45TjwHoI2d _1zr6Dc98eZ _0htemXYbGa _067LceT6kp",
    fullWidth: "_39xV02N91d",
    motion: "_0NUa3rOLYo _3iDTPbQ4SZ"
};
const $dd8044c9121890e0$var$scrollableStyles = null;
const $dd8044c9121890e0$var$blanketStyles = null;
const $dd8044c9121890e0$var$modalStyles = null;
const $dd8044c9121890e0$var$focusRingStyles = {
    root: "_1ubuxonXvL _34b3D2vc3e _1NDpvb6wH8 _2wtOC9vc3e _3e11vU6wH8 _0hSAgbHZdu"
};
const $dd8044c9121890e0$var$placementMap = {
    top: {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'top-start': {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'top-end': {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    bottom: {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'bottom-start': {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'bottom-end': {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    left: {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'left-start': {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'left-end': {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    right: {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'right-start': {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'right-end': {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    }
};
const $dd8044c9121890e0$var$DefaultPopupComponent = /*#__PURE__*/ (0, $fsvuC.forwardRef)((props, ref)=>{
    const { shouldRenderToParent: shouldRenderToParent, shouldFitContainer: shouldFitContainer, children: children, appearance: appearance, className: className, isReferenceHidden: _isReferenceHidden, shouldFitViewport: shouldFitViewport, ...htmlAttributes } = props;
    return /*#__PURE__*/ (0, $5chsV.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gJ6nT.default)([
            $dd8044c9121890e0$var$wrapperStyles.root,
            appearance === 'UNSAFE_modal-below-sm' && "_0Tuepk1Y8M _0NUa3rEtrx _1mT5xdy1CL _2I62gz1Y8M",
            (!shouldRenderToParent || shouldFitViewport) && "_4bt5LAIZbP _2WAcuGIZbP",
            shouldFitContainer && "_39xV02N91d",
            className
        ]),
        ...htmlAttributes,
        ref: !(0, $llCao.fg)('platform-dst-motion-uplift-popup') ? ref : undefined,
        children: children
    });
});
function $dd8044c9121890e0$var$PopperWrapper({ xcss: xcss, isOpen: isOpen, id: id, offset: offset, testId: testId, content: content, fallbackPlacements: fallbackPlacements, onClose: onClose, boundary: boundary, rootBoundary: rootBoundary, shouldFlip: shouldFlip, placement: placement = 'auto', popupComponent: PopupContainer = $dd8044c9121890e0$var$DefaultPopupComponent, autoFocus: autoFocus = true, triggerRef: triggerRef, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent, shouldRenderToParent: shouldRenderToParent, shouldFitContainer: shouldFitContainer, shouldDisableFocusLock: shouldDisableFocusLock, shouldReturnFocus: shouldReturnFocus = true, strategy: strategy, role: role, label: label, titleId: titleId, modifiers: modifiers, shouldFitViewport: shouldFitViewport, appearance: appearance = 'default', zIndex: zIndex }) {
    const [popupRef, setPopupRef] = (0, $fsvuC.useState)(null);
    const [initialFocusRef, setInitialFocusRef] = (0, $fsvuC.useState)(null); // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
    const shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    const shouldDisableFocusTrap = role !== 'dialog';
    (0, $a3XlP.useFocusManager)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldReturnFocus: shouldReturnFocus
    });
    (0, $guB7K.useCloseManager)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    const { currentLevel: currentLevel } = (0, $hZwjD.useLayering)();
    const mergedModifiers = (0, $fsvuC.useMemo)(()=>[
            {
                name: 'flip',
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            },
            ...modifiers || []
        ], [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $f3WQU.Popper), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport,
        children: ({ ref: ref, style: style, placement: placement, update: update, isReferenceHidden: isReferenceHidden })=>{
            const popupContainer = /*#__PURE__*/ (0, $5chsV.jsx)(PopupContainer // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            , {
                className: (0, $gJ6nT.default)([
                    xcss,
                    // @ts-expect-error: `ax` is not typed correctly
                    !initialFocusRef && (0, $llCao.fg)('platform-design-system-apply-popup-wrapper-focus') && $dd8044c9121890e0$var$focusRingStyles.root
                ]),
                appearance: appearance,
                id: id,
                "data-ds--level": currentLevel,
                "data-placement": placement,
                "data-testid": testId,
                role: role,
                "aria-label": label,
                "aria-labelledby": titleId,
                ref: !(0, $llCao.fg)('platform-dst-motion-uplift-popup') ? (node)=>{
                    if (node) {
                        if (typeof ref === 'function') ref(node);
                        else ref.current = node;
                        setPopupRef(node);
                    }
                } : undefined,
                style: (0, $llCao.fg)('platform-dst-motion-uplift-popup') || appearance === 'UNSAFE_modal-below-sm' ? {} : style,
                // first on the browser address bar when using keyboard
                tabIndex: autoFocus ? 0 : undefined,
                shouldRenderToParent: shouldRenderToParent,
                shouldFitContainer: shouldFitContainer,
                shouldFitViewport: shouldFitViewport,
                isReferenceHidden: isReferenceHidden,
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $31xNG.RepositionOnUpdate), {
                    update: update,
                    children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $ixlCP.default), {
                        children: content({
                            update: update,
                            isOpen: isOpen,
                            onClose: onClose,
                            setInitialFocusRef: setInitialFocusRef
                        })
                    })
                })
            });
            const isAutoPlacement = placement === 'auto' || placement === 'auto-start' || placement === 'auto-end';
            const container = /*#__PURE__*/ (0, $5chsV.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            , {
                style: {
                    ...style,
                    zIndex: zIndex
                },
                // first on the browser address bar when using keyboard
                ref: (node)=>{
                    if (node) {
                        if (typeof ref === 'function') ref(node);
                        else ref.current = node;
                        setPopupRef(node);
                    }
                },
                "data-testid": `${testId}--container`,
                className: (0, $gJ6nT.default)([
                    shouldFitContainer && $dd8044c9121890e0$var$wrapperStyles.fullWidth
                ]),
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $ceFHj.default), {
                    enteringAnimation: !isAutoPlacement ? $dd8044c9121890e0$var$placementMap[placement].enter : undefined,
                    exitingAnimation: !isAutoPlacement ? $dd8044c9121890e0$var$placementMap[placement].exit : undefined,
                    xcss: $dd8044c9121890e0$var$wrapperStyles.motion,
                    children: popupContainer
                })
            });
            return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $fsvuC.Fragment), {
                children: [
                    (0, $llCao.fg)('platform-dst-motion-uplift-popup') ? container : popupContainer,
                    appearance === 'UNSAFE_modal-below-sm' && /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                        className: (0, $gJ6nT.default)([
                            "_49OCfRdnbC _1mT5xdy1CL _0KLXruA5lS"
                        ])
                    })
                ]
            });
        }
    });
}
$dd8044c9121890e0$var$PopperWrapper.displayName = "PopperWrapper";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$dd8044c9121890e0$export$2e2bcd8739ae039 = $dd8044c9121890e0$var$PopperWrapper;

});
parcelRegister("31xNG", function(module, exports) {
$parcel$export(module.exports, "RepositionOnUpdate", () => $e11da18b18460ba6$export$51eddd7655ca235a);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");
const $e11da18b18460ba6$export$51eddd7655ca235a = ({ children: children, update: update })=>{
    // Ref used here to skip update on first render (when refs haven't been set)
    const isFirstRenderRef = (0, $fsvuC.useRef)(true);
    (0, $fsvuC.useLayoutEffect)(()=>{
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update.
        // Guard against `update` being undefined: on Safari the Popper instance may
        // not be fully initialised when this layout effect fires, in which case the
        // render-prop `update` is undefined and calling it throws
        // `TypeError: e.update is not a function`.
        if (typeof update === 'function') update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $fsvuC.Fragment), {
        children: children
    });
};
$e11da18b18460ba6$export$51eddd7655ca235a.displayName = "RepositionOnUpdate";

});

parcelRegister("guB7K", function(module, exports) {
$parcel$export(module.exports, "useCloseManager", () => $6f3acc7de4dd2e1f$export$92dae2778ae88f9d);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $9Tkwf = parcelRequire("9Tkwf");

var $hZwjD = parcelRequire("hZwjD");

var $llCao = parcelRequire("llCao");

var $dVemO = parcelRequire("dVemO");

var $lOsVx = parcelRequire("lOsVx");
const $6f3acc7de4dd2e1f$export$92dae2778ae88f9d = ({ isOpen: isOpen, onClose: onClose, popupRef: popupRef, triggerRef: triggerRef, autoFocus: autoFocus, shouldDisableFocusTrap: shouldDisableFocusTrap, shouldUseCaptureOnOutsideClick: capture, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent, shouldCloseOnTab: shouldCloseOnTab, shouldRenderToParent: shouldRenderToParent })=>{
    const { isLayerDisabled: isLayerDisabled, currentLevel: currentLevel } = (0, $hZwjD.useLayering)();
    const { requestFrame: requestFrame, cancelAllFrames: cancelAllFrames } = (0, $lOsVx.useAnimationFrame)();
    const mouseDownTarget = (0, $fsvuC.useRef)(null);
    (0, $fsvuC.useEffect)(()=>{
        if (!isOpen || !popupRef) return 0, $9Tkwf.default;
        const closePopup = (event)=>{
            if (shouldIgnoreCloseEvent?.(event)) return;
            if (onClose) {
                let currentLevel = null;
                if (event.target instanceof HTMLElement) currentLevel = event.target.closest(`[data-ds--level]`)?.getAttribute('data-ds--level') ?? null;
                currentLevel ? onClose(event, Number(currentLevel)) : onClose(event);
            }
            if (shouldDisableFocusTrap && (0, $llCao.fg)('platform_dst_popup-disable-focuslock')) // Restoring the normal focus order for trigger.
            requestFrame(()=>{
                triggerRef?.setAttribute('tabindex', '0');
                if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '0');
            });
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        const onClick = (event)=>{
            const { target: target } = event;
            const doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist) return;
            if (target instanceof HTMLElement) {
                const layeredElement = target.closest?.(`[data-ds--level]`);
                if (layeredElement) {
                    const closeType = layeredElement.getAttribute('data-ds--close--type');
                    if (closeType === 'single' && isLayerDisabled()) // if the close type is single, we won't close other disabled layers when clicking outside
                    return;
                    const levelOfClickedLayer = layeredElement.getAttribute('data-ds--level');
                    if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) // Don't close this popup when the click landed inside a higher-level layer
                    // (e.g. a Drawer or Modal that portals to <body>). Such nodes are not DOM
                    // descendants of popupRef, so the contains() checks below would wrongly
                    // classify them as "outside" clicks and close the popup prematurely.
                    return;
                }
            }
            const isClickOnPopup = popupRef && popupRef.contains(target);
            const isClickOnTrigger = triggerRef && triggerRef.contains(target);
            const didClickStartInsidePopup = popupRef && mouseDownTarget.current instanceof Node && popupRef.contains(mouseDownTarget.current);
            if (!isClickOnPopup && !isClickOnTrigger && !didClickStartInsidePopup) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, $dVemO.isInteractiveElement)(document.activeElement) && (0, $llCao.fg)('platform_dst_popup-disable-focuslock')) triggerRef?.focus();
            }
        };
        const onMouseDown = (event)=>{
            /**
			 * Tracking the target of the mouse down event.
			 * This is used to prevent the popup from closing when the user mouses down inside the popup, but then
			 * moves the mouse outside the popup before releasing the mouse button.
			 *
			 * This is a common user interaction - users may have mistakenly clicked on something, or changed their mind,
			 * so they try to cancel their click by moving their mouse away from what they had moused down on.
			 *
			 * Blanket uses the same technique.
			 */ mouseDownTarget.current = event.target;
        };
        const onKeyDown = (event)=>{
            const key = event.key;
            if ((key === 'Escape' || key === 'Esc') && (0, $llCao.fg)('platform_dst_nested_escape')) {
                const eventTarget = event.target instanceof HTMLElement ? event.target : null;
                const layeredAncestor = eventTarget?.closest?.('[data-ds--level]');
                const levelStr = layeredAncestor?.getAttribute('data-ds--level');
                if (levelStr && Number(levelStr) > currentLevel) return;
            }
            if ((0, $llCao.fg)('platform_dst_popup-disable-focuslock')) {
                const { shiftKey: shiftKey } = event;
                if (shiftKey && key === 'Tab' && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(()=>{
                        const isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef?.focus();
                        }
                    });
                    return;
                }
                if (key === 'Tab') {
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && document.activeElement?.closest('[aria-modal]')) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(()=>{
                            const isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(()=>{
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc') {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc' || shouldCloseOnTab && key === 'Tab') closePopup(event);
            }
        };
        let unbind = (0, $9Tkwf.default);
        if ((0, $llCao.fg)('popup-onclose-fix')) setTimeout(()=>{
            unbind = (0, $dqdTY.bindAll)(window, [
                {
                    type: 'click',
                    listener: onClick,
                    options: {
                        capture: capture
                    }
                },
                {
                    type: 'keydown',
                    listener: onKeyDown
                },
                {
                    type: 'mousedown',
                    listener: onMouseDown
                }
            ]);
        }, 0);
        else unbind = (0, $dqdTY.bindAll)(window, [
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'mousedown',
                listener: onMouseDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        let unbindBlur = (0, $9Tkwf.default);
        unbindBlur = (0, $dqdTY.bind)(window, {
            type: 'blur',
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return ()=>{
            if ((0, $llCao.fg)('popup-onclose-fix')) setTimeout(()=>{
                unbind();
            }, 0);
            else unbind();
            cancelAllFrames();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        shouldIgnoreCloseEvent,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};

});
parcelRegister("dVemO", function(module, exports) {
$parcel$export(module.exports, "isInteractiveElement", () => $0d4628998d08f689$export$3dee5e4542c672d9);
const $0d4628998d08f689$var$interactiveTags = [
    'button',
    'a',
    'input',
    'select',
    'textarea'
];
const $0d4628998d08f689$export$3dee5e4542c672d9 = (element)=>{
    if ($0d4628998d08f689$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute('tabindex') !== null || element.hasAttribute('contenteditable')) return true;
    return false;
};

});

parcelRegister("lOsVx", function(module, exports) {
$parcel$export(module.exports, "useAnimationFrame", () => $94a21d8f76f4eba8$export$641fa9c94086b46e);

var $fsvuC = parcelRequire("fsvuC");
const $94a21d8f76f4eba8$export$641fa9c94086b46e = ()=>{
    const animationsRef = (0, $fsvuC.useRef)([]);
    const requestFrame = (0, $fsvuC.useCallback)((callback)=>{
        const id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    const cancelFrame = (0, $fsvuC.useCallback)((id)=>{
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter((frameId)=>frameId !== id);
    }, []);
    const cancelAllFrames = (0, $fsvuC.useCallback)(()=>{
        animationsRef.current.forEach((id)=>cancelAnimationFrame(id));
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};

});


parcelRegister("a3XlP", function(module, exports) {
$parcel$export(module.exports, "useFocusManager", () => $9ef6182dc77e4162$export$10c5169755ce7bd7);

var $fsvuC = parcelRequire("fsvuC");

var $1mzzO = parcelRequire("1mzzO");

var $9Tkwf = parcelRequire("9Tkwf");

var $hZwjD = parcelRequire("hZwjD");

var $llCao = parcelRequire("llCao");

var $lOsVx = parcelRequire("lOsVx");
const $9ef6182dc77e4162$export$10c5169755ce7bd7 = ({ initialFocusRef: initialFocusRef, popupRef: popupRef, triggerRef: triggerRef, autoFocus: autoFocus, shouldCloseOnTab: shouldCloseOnTab, shouldDisableFocusTrap: shouldDisableFocusTrap, shouldReturnFocus: shouldReturnFocus, shouldRenderToParent: shouldRenderToParent })=>{
    const { requestFrame: requestFrame, cancelAllFrames: cancelAllFrames } = (0, $lOsVx.useAnimationFrame)();
    const { currentLevel: currentLevel } = (0, $hZwjD.useLayering)();
    (0, $fsvuC.useEffect)(()=>{
        if (!popupRef || shouldCloseOnTab) return 0, $9Tkwf.default;
        if (shouldDisableFocusTrap && (0, $llCao.fg)('platform_dst_popup-disable-focuslock')) {
            const isDropdown = popupRef.matches('[id^=ds--dropdown--]');
            const popups = document.querySelectorAll(`[data-ds--level="${currentLevel - 1}"]`);
            if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                // Plucking trigger & popup content container from the tab order so that
                // when we Shift+Tab, the focus moves to the element before trigger
                requestFrame(()=>{
                    triggerRef?.setAttribute('tabindex', '-1');
                    if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '-1');
                    (initialFocusRef || popupRef).focus();
                });
                return 0, $9Tkwf.default;
            }
        }
        const trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: (0, $llCao.fg)('platform_dst_nested_escape') ? false : true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: shouldReturnFocus
        };
        const focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($1mzzO)))(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(()=>{
            focusTrap.activate();
        });
        return ()=>{
            cancelAllFrames();
            focusTrap.deactivate();
            if (((0, $llCao.fg)('platform-dst-popup-trigger-focus-fix') || (0, $llCao.fg)('platform_dst-popup-trigger-initial-focus-ref')) && shouldReturnFocus) requestFrame(()=>{
                if (triggerRef?.isConnected && (document.activeElement === document.body || document.activeElement === document.documentElement || !document.activeElement)) triggerRef.focus();
            });
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames,
        shouldReturnFocus,
        shouldRenderToParent,
        currentLevel
    ]);
};

});


parcelRegister("9LFyV", function(module, exports) {
$parcel$export(module.exports, "PopupTopLayer", () => $f9312f0ffd56784e$export$e24b8cb659609dee);
/* popup-top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $9Tkwf = parcelRequire("9Tkwf");

var $ixlCP = parcelRequire("ixlCP");

var $6KgHe = parcelRequire("6KgHe");

var $974dn = parcelRequire("974dn");

var $9RE4M = parcelRequire("9RE4M");

var $4CLv7 = parcelRequire("4CLv7");

var $2jUY9 = parcelRequire("2jUY9");

var $gc525 = parcelRequire("gc525");

var $kOb0h = parcelRequire("kOb0h");

var $lxNvO = parcelRequire("lxNvO");

var $6uV09 = parcelRequire("6uV09");

var $dwq6k = parcelRequire("dwq6k");
// Top-layer positioning is handled by CSS Anchor Positioning, not inline styles.
const $f9312f0ffd56784e$var$EMPTY_STYLE = {};
const $f9312f0ffd56784e$export$e24b8cb659609dee = /*#__PURE__*/ (0, $fsvuC.memo)(function PopupTopLayer({ xcss: xcss, isOpen: isOpen, id: providedId, offset: offsetProp, testId: testId, trigger: trigger, content: content, onClose: onClose = (0, $9Tkwf.default), placement: placement = 'auto', fallbackPlacements: _fallbackPlacements, shouldFlip: _shouldFlip = true, popupComponent: PopupContainer, // top-layer: initial focus follows `role`. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
autoFocus: _autoFocus = true, shouldFitContainer: shouldFitContainer = false, // top-layer: focus restoration is handled natively by the Popover API. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldReturnFocus: _shouldReturnFocus = true, role: role, label: label, titleId: titleId, // No-op props.
// These props are accepted for API compatibility but have no effect
// in the top-layer path. Each is documented with why it is unnecessary.
// top-layer: stacking managed by browser top layer. zIndex is a no-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
zIndex: _zIndex, // top-layer: always renders in top layer. shouldRenderToParent is a no-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldRenderToParent: _shouldRenderToParent, // top-layer: CSS Anchor Positioning replaces Popper strategy. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
strategy: _strategy, // top-layer: Popper.js modifiers not applicable. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
modifiers: _modifiers, // top-layer: viewport is the natural boundary. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
boundary: _boundary, // top-layer: viewport is the natural boundary. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
rootBoundary: _rootBoundary, // top-layer: native light dismiss replaces capture-phase click handler.
// Could add mousedown drag guard later if needed.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldUseCaptureOnOutsideClick: _shouldUseCaptureOnOutsideClick, // top-layer: focus trapping is role-based. shouldDisableFocusLock is a no-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldDisableFocusLock: _shouldDisableFocusLock, shouldFitViewport: // top-layer: maps onto `'max-available'`, capping the popup to the space
// between the trigger and the viewport edge. `PopoverSurface` already owns
// `overflow: auto`, so the capped surface scrolls.
//
// Keep the explicit `false`: `undefined` previously reached an
// `isEnabled = true` default and silently enabled fitting for every popup
// that omitted the prop.
shouldFitViewport = false, // top-layer: appearance is accepted but UNSAFE_modal-below-sm is not yet implemented.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
appearance: _appearance }) {
    const triggerRef = (0, $fsvuC.useRef)(null);
    const popoverRef = (0, $fsvuC.useRef)(null);
    /**
   * Consumer-chosen initial focus target.
   *
   * The legacy `Popup` surfaced `setInitialFocusRef` on the content
   * render prop with a `Dispatch<SetStateAction<HTMLElement | null>>`
   * signature so it could be passed as a React `ref` callback. We
   * keep the same shape for API compatibility, but store the value in
   * a ref. `Popover` reads it as `initialFocusRef` when it opens. For a
   * role that moves focus, a target inside the popup takes focus instead
   * of the role default, and focus moves once. Other roles ignore it. `autoFocus` has no effect here: role and focus go
   * together. See `@atlaskit/top-layer` `notes/decisions/role-and-focus.md`.
   */ const consumerInitialFocusRef = (0, $fsvuC.useRef)(null);
    const setInitialFocusRef = (0, $fsvuC.useCallback)((value)=>{
        consumerInitialFocusRef.current = typeof value === 'function' ? value(consumerInitialFocusRef.current) : value;
    }, []);
    const popoverId = (0, $kOb0h.usePopoverId)();
    // Placement conversion.
    // Legacy `offset` is the popper `[along, away]` tuple; `fromLegacyPlacement`
    // folds it into the new `placement.offset` shape so it travels with placement.
    const topLayerPlacement = (0, $fsvuC.useMemo)(()=>(0, $974dn.fromLegacyPlacement)({
            legacy: placement,
            offset: offsetProp
        }), [
        placement,
        offsetProp
    ]);
    (0, $gc525.useAnchoredPopover)({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isOpen,
        ...(0, $lxNvO.getPopupAxisSizes)({
            shouldFitContainer: shouldFitContainer,
            shouldFitViewport: shouldFitViewport
        })
    });
    // onClose bridge.
    // Translates top-layer's { reason: TPopoverCloseReason } into legacy
    // onClose(event, currentLevel?) by synthesizing DOM events.
    //
    // Focus restoration is handled natively by the Popover API:
    //   - Escape: browser restores focus to the trigger automatically
    //   - Click-outside: browser does NOT restore (correct behavior)
    // No manual triggerRef.current?.focus() is needed.
    const handleOnClose = (0, $fsvuC.useCallback)(({ reason: reason })=>{
        onClose((0, $4CLv7.createPopoverCloseEvent)({
            reason: reason
        }));
    }, [
        onClose
    ]);
    // Content render-prop bridge.
    // Legacy content() receives { isOpen, update, setInitialFocusRef, onClose }.
    // update is a no-op because CSS Anchor Positioning self-updates.
    // The args always hold the setter; the `TPopup` types decide who can see it.
    const contentProps = (0, $fsvuC.useMemo)(()=>({
            isOpen: isOpen,
            update: (0, $9Tkwf.default),
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        }), [
        isOpen,
        onClose,
        setInitialFocusRef
    ]);
    // Role mapping.
    // Build the role/label props for Popover.
    // Roles requiring accessible names must have label or labelledBy.
    const roleProps = (0, $dwq6k.useRoleProps)({
        role: role,
        label: label,
        titleId: titleId,
        initialFocusRef: consumerInitialFocusRef
    });
    const resolvedPopoverId = providedId ?? popoverId;
    const ariaAttributes = (0, $6KgHe.getAriaForTrigger)({
        role: (0, $6uV09.getTriggerRole)({
            role: roleProps.role
        }),
        isOpen: isOpen,
        popoverId: resolvedPopoverId
    });
    // Narrow to ForwardRefExoticComponent so JSX accepts the ref prop.
    // All popupComponent implementations use forwardRef per the PopupComponentProps contract.
    const Container = PopupContainer;
    // Map to legacy TriggerProps.
    const triggerProps = {
        ref: (node)=>{
            triggerRef.current = node;
        },
        'aria-controls': ariaAttributes['aria-controls'],
        // `aria-expanded` reflects current open state.
        'aria-expanded': ariaAttributes['aria-expanded'],
        'aria-haspopup': ariaAttributes['aria-haspopup']
    };
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $fsvuC.Fragment), {
        children: [
            trigger(triggerProps),
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $2jUY9.Popover), {
                ref: popoverRef,
                id: resolvedPopoverId,
                ...roleProps,
                isOpen: isOpen,
                onClose: handleOnClose,
                shouldAnimate: true,
                placement: topLayerPlacement,
                testId: testId && `${testId}--container`,
                children: Container ? /*#__PURE__*/ (0, $5chsV.jsx)(Container, {
                    style: $f9312f0ffd56784e$var$EMPTY_STYLE,
                    id: providedId,
                    "data-placement": placement,
                    "data-testid": testId,
                    tabIndex: -1,
                    xcss: xcss,
                    // Forwarded because several in-tree containers key their own
                    // `overflow: auto` branch off it.
                    shouldFitViewport: shouldFitViewport,
                    children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $ixlCP.default), {
                        children: content(contentProps)
                    })
                }) : // `PopoverSurface` owns `overflow: auto` and the `box-shadow` on the
                // same element, so it is the scroll container. The wrapper exists only
                // to carry the consumer's `xcss`: `PopoverSurface` exposes no
                // `className` or `xcss` by design, so `xcss` lands on a CHILD of the
                // surface. `width` works there; surface-level declarations apply one
                // level in. Same shape as `compositional/popup-content-top-layer.tsx`.
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $9RE4M.PopoverSurface), {
                    children: /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                        className: xcss,
                        "data-testid": testId,
                        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $ixlCP.default), {
                            children: content(contentProps)
                        })
                    })
                })
            })
        ]
    });
});

});
parcelRegister("9RE4M", function(module, exports) {
$parcel$export(module.exports, "PopoverSurface", () => $fab1437d357a1fbd$export$8b7437164e479115);
/* popover-surface.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");
const $fab1437d357a1fbd$var$styles = {
    root: "_0bjKvD8fU6 _4bt5LAIZbP _2WAcuGIZbP _0KLXruoI2d _1UtDYzy7kJ _2OUyjtGk8v"
};
function $fab1437d357a1fbd$export$8b7437164e479115({ children: children }) {
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        className: (0, $gJ6nT.default)([
            $fab1437d357a1fbd$var$styles.root
        ]),
        children: children
    });
}
$fab1437d357a1fbd$export$8b7437164e479115.displayName = "PopoverSurface";

});

parcelRegister("lxNvO", function(module, exports) {
$parcel$export(module.exports, "getPopupAxisSizes", () => $a20cb4db17f157eb$export$60eb6c71554f82c4);
function $a20cb4db17f157eb$export$60eb6c71554f82c4({ shouldFitContainer: shouldFitContainer, shouldFitViewport: shouldFitViewport }) {
    const blockSize = shouldFitViewport ? 'max-available' : 'content';
    if (shouldFitContainer) return {
        inlineSize: 'match-anchor',
        blockSize: blockSize
    };
    if (shouldFitViewport) return {
        inlineSize: 'max-available',
        blockSize: blockSize
    };
    return {
        inlineSize: 'content',
        blockSize: blockSize
    };
}

});

parcelRegister("6uV09", function(module, exports) {
$parcel$export(module.exports, "getTriggerRole", () => $23b74e1b91ac4423$export$7647c858fbf2aa3);
/**
 * Narrows a popup `role` to one that `getAriaForTrigger` accepts.
 *
 * Tooltip-family roles and no role give `undefined`, so the trigger gets no `aria-haspopup`.
 */ function $23b74e1b91ac4423$export$7647c858fbf2aa3({ role: role }) {
    if (role === 'dialog' || role === 'alertdialog' || role === 'menu' || role === 'listbox' || role === 'tree' || role === 'grid') return role;
    return undefined;
}

});

parcelRegister("dwq6k", function(module, exports) {
$parcel$export(module.exports, "useRoleProps", () => $34d109f09bb0ee71$export$892580369e97d8b9);

var $fsvuC = parcelRequire("fsvuC");
function $34d109f09bb0ee71$export$892580369e97d8b9({ role: role, label: label, titleId: titleId, initialFocusRef: initialFocusRef }) {
    return (0, $fsvuC.useMemo)(()=>{
        if (role === 'dialog' || role === 'alertdialog' || role === 'menu') {
            if (titleId) return {
                role: role,
                labelledBy: titleId,
                initialFocusRef: initialFocusRef
            };
            return {
                role: role,
                label: label ?? 'Popup',
                initialFocusRef: initialFocusRef
            };
        }
        if (role === 'listbox') return {
            role: role,
            label: label,
            initialFocusRef: initialFocusRef
        };
        if (role) return {
            role: role,
            label: label
        };
        // No role supplied: preserve the legacy "no popup semantics" contract.
        return {
            role: undefined,
            label: label
        };
    }, [
        role,
        label,
        titleId,
        initialFocusRef
    ]);
}

});


parcelRegister("2FHIx", function(module, exports) {
$parcel$export(module.exports, "usePopupAppearance", () => $e2e698b74476a1b8$export$4065aef1d79a5730);

var $fsvuC = parcelRequire("fsvuC");

var $llCao = parcelRequire("llCao");

var $21OfU = parcelRequire("21OfU");
function $e2e698b74476a1b8$export$4065aef1d79a5730({ appearance: _appearance, shouldRenderToParent: _shouldRenderToParent }) {
    const canBecomeModal = _appearance === 'UNSAFE_modal-below-sm';
    /**
	 * This gate removes unnecessary state changes across the below-sm boundary
	 * The state change is only needed if the popup can become a modal - and this is maintained
	 */ const shouldUseMediaQuery = !(0, $llCao.fg)('platform_dst_popup_media_query_perf_fix') || canBecomeModal;
    const mq = (0, $21OfU.UNSAFE_useMediaQuery)('below.sm', shouldUseMediaQuery ? (e)=>{
        setIsSmallViewport(!!e.matches);
    } : undefined);
    const [isSmallViewport, setIsSmallViewport] = (0, $fsvuC.useState)(!!mq?.matches);
    const appearance = canBecomeModal && isSmallViewport ? 'UNSAFE_modal-below-sm' : 'default';
    const shouldRenderToParent = _shouldRenderToParent && appearance === 'default';
    return {
        appearance: appearance,
        shouldRenderToParent: shouldRenderToParent
    };
}

});
parcelRegister("21OfU", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_useMediaQuery", () => $ba9958d5185b858b$export$49e55ae2c03d6045);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $c1m5V = parcelRequire("c1m5V");
const $ba9958d5185b858b$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $c1m5V.media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $c1m5V.media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $c1m5V.media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $c1m5V.media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $c1m5V.media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $c1m5V.media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $c1m5V.media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $c1m5V.media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $c1m5V.media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $c1m5V.media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $c1m5V.media).below.xl.replace('@media ', '').trim())
};
const $ba9958d5185b858b$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $fsvuC.useRef)(listener);
    (0, $fsvuC.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
	 * We explicitly only react to boolean changes for binding our listener
	 * Changes to the functional reference are ignored.
	 */ const hasListener = !!listener;
    /**
	 * The `matchMedia(…)` return value for our breakpoint query.
	 */ const mq = $ba9958d5185b858b$var$queries[queryString];
    (0, $fsvuC.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $dqdTY.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};
$ba9958d5185b858b$export$49e55ae2c03d6045.displayName = "UNSAFE_useMediaQuery";

});
parcelRegister("c1m5V", function(module, exports) {
$parcel$export(module.exports, "media", () => $6e21d4e32b3e63d3$export$987d49ffe1b0900f);
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ const $6e21d4e32b3e63d3$export$987d49ffe1b0900f = {
    above: {
        // TODO: Should this even exist, we don't want `css({ [media.above.xxs]: { … } })` because that just adds duplicates styles!
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};

});



parcelRegister("2Wwgj", function(module, exports) {
$parcel$export(module.exports, "useGetMemoizedMergedTriggerRef", () => $7fab7fd313da72fd$export$7cc5c058dd769dff);

var $fsvuC = parcelRequire("fsvuC");

var $kZVJU = parcelRequire("kZVJU");
const $7fab7fd313da72fd$export$7cc5c058dd769dff = ()=>{
    const [getMemoizedMergedTriggerRef] = (0, $fsvuC.useState)(()=>(0, $kZVJU.default)((ref, setTriggerRef, isOpen)=>{
            return (node)=>{
                if (node && isOpen) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        }));
    return getMemoizedMergedTriggerRef;
};

});

parcelRegister("jOpEM", function(module, exports) {
$parcel$export(module.exports, "useGetMemoizedMergedTriggerRefNew", () => $7d08c6f11419f733$export$5d3a2de79e07b376);

var $fsvuC = parcelRequire("fsvuC");

var $kZVJU = parcelRequire("kZVJU");
const $7d08c6f11419f733$export$5d3a2de79e07b376 = ()=>{
    const [getMemoizedMergedTriggerRefNew] = (0, $fsvuC.useState)(()=>(0, $kZVJU.default)((ref, setTriggerRef)=>{
            return (node)=>{
                if (node) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        }));
    return getMemoizedMergedTriggerRefNew;
};

});


parcelRegister("72dzD", function(module, exports) {
$parcel$export(module.exports, "default", () => $a44793a59bd7074f$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $ci3mO = parcelRequire("ci3mO");

var $gY8Aw = parcelRequire("gY8Aw");
/**
 * __Spotlight__
 *
 * An onboarding spotlight introduces new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 *
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ const $a44793a59bd7074f$var$Spotlight = ({ actions: actions, actionsBeforeElement: actionsBeforeElement, children: children, dialogPlacement: dialogPlacement, dialogWidth: dialogWidth = 400, footer: footer, header: header, heading: heading, headingAfterElement: headingAfterElement, image: image, label: label, pulse: pulse = true, scrollPositionBlock: scrollPositionBlock, shouldWatchTarget: shouldWatchTarget = false, target: target, targetBgColor: targetBgColor, targetNode: targetNode, targetOnClick: targetOnClick, targetRadius: targetRadius, targetReplacement: targetReplacement, testId: testId = 'spotlight', titleId: titleId, ...rest })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $gY8Aw.SpotlightConsumer), {
        children: ({ opened: opened, closed: closed, targets: targets })=>{
            // use the targetNode prop or try get the target from context targets using name
            const actualTargetNode = targetNode || (typeof target === 'string' ? targets[target] : undefined);
            return actualTargetNode ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $ci3mO.default), {
                ...rest,
                actions: actions,
                actionsBeforeElement: actionsBeforeElement,
                children: children,
                dialogPlacement: dialogPlacement,
                dialogWidth: dialogWidth,
                footer: footer,
                header: header,
                heading: heading,
                headingAfterElement: headingAfterElement,
                image: image,
                label: label,
                onClosed: closed,
                onOpened: opened,
                pulse: pulse,
                scrollPositionBlock: scrollPositionBlock,
                shouldWatchTarget: shouldWatchTarget,
                target: target,
                targetBgColor: targetBgColor,
                targetNode: actualTargetNode,
                targetOnClick: targetOnClick,
                targetRadius: targetRadius,
                targetReplacement: targetReplacement,
                testId: testId,
                titleId: titleId
            }) : null;
        }
    });
$a44793a59bd7074f$var$Spotlight.displayName = "Spotlight";
var $a44793a59bd7074f$export$2e2bcd8739ae039 = $a44793a59bd7074f$var$Spotlight;

});
parcelRegister("ci3mO", function(module, exports) {
$parcel$export(module.exports, "default", () => $345e4c4e01040ede$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $lpPPJ = parcelRequire("lpPPJ");

var $121xR = parcelRequire("121xR");

var $cv14p = parcelRequire("cv14p");

var $awR7e = parcelRequire("awR7e");

var $lfw4f = parcelRequire("lfw4f");

var $eEY7a = parcelRequire("eEY7a");

var $llCao = parcelRequire("llCao");

var $bDK6L = parcelRequire("bDK6L");

var $boWtJ = parcelRequire("boWtJ");

var $dKEES = parcelRequire("dKEES");

var $dQG4F = parcelRequire("dQG4F");

var $52MKK = parcelRequire("52MKK");

var $1HhHB = parcelRequire("1HhHB");
/**
 * __Spotlight inner__
 *
 * Renders the spotlight target clone and dialog.
 *
 * @internal
 */ // eslint-disable-next-line @repo/internal/react/no-class-components
class $345e4c4e01040ede$var$SpotlightInner extends (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Component {
    static{
        this.defaultProps = {
            dialogWidth: 400,
            pulse: true
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.targetNode !== this.props.targetNode) (0, $cv14p.default)(this.props.targetNode, {
            scrollMode: 'if-needed',
            block: this.props.scrollPositionBlock
        });
    }
    componentDidMount() {
        (0, $cv14p.default)(this.props.targetNode, {
            scrollMode: 'if-needed',
            block: this.props.scrollPositionBlock
        });
        this.props.onOpened();
    }
    componentWillUnmount() {
        this.props.onClosed();
    }
    render() {
        const { pulse: pulse, shouldWatchTarget: shouldWatchTarget, target: target, targetNode: targetNode, targetBgColor: targetBgColor, targetOnClick: targetOnClick, targetRadius: targetRadius, testId: testId, targetReplacement: TargetReplacement } = this.props;
        const { replacementElement: replacementElement } = this.state;
        return /*#__PURE__*/ (0, $5chsV.jsx)((0, $1HhHB.SpotlightTransitionConsumer), {
            children: ({ isOpen: isOpen, onExited: onExited })=>/*#__PURE__*/ (0, $5chsV.jsxs)((0, $bDK6L.default), {
                    zIndex: 701,
                    children: [
                        TargetReplacement ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $dQG4F.default), {
                            hasNodeResolver: !(0, $llCao.fg)('platform_design_system_team_onboarding_noderesolve'),
                            innerRef: (elem)=>this.setState({
                                    replacementElement: elem
                                }),
                            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $boWtJ.ElementBox), {
                                element: targetNode,
                                resizeUpdateMethod: shouldWatchTarget ? 'polling' : undefined,
                                children: (box)=>/*#__PURE__*/ (0, $5chsV.jsx)(TargetReplacement, {
                                        "data-testid": `${testId}--target`,
                                        ...this.getTargetNodeStyle(box)
                                    })
                            })
                        }) : /*#__PURE__*/ (0, $5chsV.jsx)((0, $boWtJ.ElementBox), {
                            element: targetNode,
                            resizeUpdateMethod: shouldWatchTarget ? 'polling' : undefined,
                            children: (box)=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $dKEES.default), {
                                    shouldWatch: shouldWatchTarget,
                                    testId: `${testId}--target`,
                                    pulse: pulse,
                                    target: target,
                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                    style: this.getTargetNodeStyle(box),
                                    targetBgColor: targetBgColor,
                                    targetNode: targetNode,
                                    targetOnClick: targetOnClick,
                                    targetRadius: targetRadius
                                })
                        }),
                        TargetReplacement && !replacementElement ? null : /*#__PURE__*/ (0, $5chsV.jsx)((0, $awR7e.Layering), {
                            isDisabled: false,
                            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $lfw4f.default), {
                                appear: true,
                                children: isOpen && /*#__PURE__*/ (0, $5chsV.jsx)((0, $eEY7a.default), {
                                    onFinish: (state)=>{
                                        state === 'exiting' && onExited();
                                    },
                                    duration: "medium",
                                    children: ({ ref: ref, className: className, style: style })=>/*#__PURE__*/ (0, $5chsV.jsx)("div", {
                                            ref: ref,
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                                            className: className,
                                            style: style,
                                            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $52MKK.default), {
                                                testId: `${testId}--dialog`,
                                                actions: this.props.actions,
                                                actionsBeforeElement: this.props.actionsBeforeElement,
                                                children: this.props.children,
                                                dialogPlacement: this.props.dialogPlacement,
                                                dialogWidth: this.props.dialogWidth,
                                                footer: this.props.footer,
                                                header: this.props.header,
                                                heading: this.props.heading,
                                                titleId: this.props.titleId,
                                                label: this.props.label,
                                                headingAfterElement: this.props.headingAfterElement,
                                                image: this.props.image,
                                                targetNode: replacementElement || targetNode
                                            })
                                        })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($121xR))), {})
                    ]
                })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            // This is only used when targetReplacement is specified.
            // In this case, we have to render the targetReplacement component,
            // get a dom reference from that component, then render again passing
            // that reference into SpotlightDialog (Popper).
            replacementElement: null
        }, this.getTargetNodeStyle = (box)=>{
            if (!(0, $lpPPJ.canUseDOM)) return {};
            const { height: height, left: left, top: top, width: width, ...rest } = box;
            return {
                // Handling this just in case there are invalid elements being sent in to
                // the `box` arg
                ...rest,
                height: height,
                left: left,
                top: top,
                width: width,
                position: 'fixed',
                // when width is 0, set visibility hidden to avoid the target flashing issue
                ...width === 0 && (0, $llCao.fg)('scroll-lock-replacement') && {
                    visibility: 'hidden'
                }
            };
        };
    }
}
$345e4c4e01040ede$var$SpotlightInner.displayName = "SpotlightInner";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$345e4c4e01040ede$export$2e2bcd8739ae039 = $345e4c4e01040ede$var$SpotlightInner;

});
parcelRegister("boWtJ", function(module, exports) {
$parcel$export(module.exports, "ElementBox", () => $2f0e093cf9ca586d$export$1b6719bd7aff3c00);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $9Tkwf = parcelRequire("9Tkwf");

var $llCao = parcelRequire("llCao");
// The minimum interval between position updates in milliseconds
const $2f0e093cf9ca586d$var$POSITION_UPDATE_INTERVAL = 200;
const $2f0e093cf9ca586d$var$getElementRect = (element)=>{
    const { height: height, left: left, top: top, width: width } = element.getBoundingClientRect();
    return {
        height: height,
        left: left,
        top: top,
        width: width
    };
};
const $2f0e093cf9ca586d$var$useResizeAwareElementBox = (element, updateMethod)=>{
    const [box, setBox] = (0, $fsvuC.useState)({
        width: 0,
        height: 0,
        left: 0,
        top: 0
    });
    (0, $fsvuC.useLayoutEffect)(()=>{
        if (updateMethod === 'resizeListener') {
            if ((0, $llCao.fg)('scroll-lock-replacement')) // use setTimeout 0 to defer the state update to avoid content shifting when pages have scrollbars
            // more details are https://www.loom.com/share/96a5d7c2afd74146a3c005bf20a8c69e?sid=968b00c1-e5ab-4ea0-9fe4-e534fe7088e4
            setTimeout(()=>{
                setBox($2f0e093cf9ca586d$var$getElementRect(element));
            }, 0);
            else setBox($2f0e093cf9ca586d$var$getElementRect(element));
        }
    }, [
        element,
        updateMethod
    ]);
    (0, $fsvuC.useEffect)(()=>{
        const onResize = ()=>{
            requestAnimationFrame(()=>{
                setBox($2f0e093cf9ca586d$var$getElementRect(element));
            });
        };
        if (updateMethod === 'resizeListener') return (0, $dqdTY.bind)(window, {
            type: 'resize',
            listener: onResize
        });
        return 0, $9Tkwf.default;
    }, [
        element,
        updateMethod
    ]);
    return box;
};
const $2f0e093cf9ca586d$var$usePollingElementBox = (element, updateMethod)=>{
    // These are intentionally tracked as number primitives rather than as a shared `box` object.
    // Since the requestAnimationFrame code below updates this often, we want to avoid re-renders
    // when the values are the same.  React uses `Object.is` to figure out if the state changed after a setState.
    // If we represent this as a shared `box` object, this will re-render even if the two objects have identical contents.
    const [width, setWidth] = (0, $fsvuC.useState)(0);
    const [height, setHeight] = (0, $fsvuC.useState)(0);
    const [left, setLeft] = (0, $fsvuC.useState)(0);
    const [top, setTop] = (0, $fsvuC.useState)(0);
    (0, $fsvuC.useLayoutEffect)(()=>{
        if (updateMethod === 'polling') {
            if ((0, $llCao.fg)('scroll-lock-replacement')) // use setTimeout 0 to defer the state update to avoid content shifting when pages have scrollbars
            // more details are https://www.loom.com/share/96a5d7c2afd74146a3c005bf20a8c69e?sid=968b00c1-e5ab-4ea0-9fe4-e534fe7088e4
            setTimeout(()=>{
                const newBox = $2f0e093cf9ca586d$var$getElementRect(element);
                setWidth(newBox.width);
                setHeight(newBox.height);
                setLeft(newBox.left);
                setTop(newBox.top);
            }, 0);
            else {
                const newBox = $2f0e093cf9ca586d$var$getElementRect(element);
                setWidth(newBox.width);
                setHeight(newBox.height);
                setLeft(newBox.left);
                setTop(newBox.top);
            }
        }
    }, [
        element,
        updateMethod
    ]);
    // Souce: https://css-tricks.com/using-requestanimationframe-with-react-hooks/
    // Use useRef for mutable variables that we want to persist
    // without triggering a re-render on their change
    const requestRef = (0, $fsvuC.useRef)();
    const previousUpdateTimeRef = (0, $fsvuC.useRef)();
    const animate = (0, $fsvuC.useCallback)((time)=>{
        if (previousUpdateTimeRef.current !== undefined) {
            const timeSinceLastUpdate = time - previousUpdateTimeRef.current;
            if (timeSinceLastUpdate > $2f0e093cf9ca586d$var$POSITION_UPDATE_INTERVAL) {
                const newBox = $2f0e093cf9ca586d$var$getElementRect(element);
                setWidth(newBox.width);
                setHeight(newBox.height);
                setLeft(newBox.left);
                setTop(newBox.top);
                previousUpdateTimeRef.current = time;
            }
        } else // Initialize previousUpdateTimeRef
        previousUpdateTimeRef.current = time;
        requestRef.current = requestAnimationFrame(animate);
    }, [
        element
    ]);
    (0, $fsvuC.useEffect)(()=>{
        if (updateMethod === 'polling') requestRef.current = requestAnimationFrame(animate);
        return ()=>{
            if (requestRef.current !== undefined) cancelAnimationFrame(requestRef.current);
        };
    // This useEffect should only run on mount and when `element` or `updateMethod` changes.
    }, [
        animate,
        element,
        updateMethod
    ]);
    const box = (0, $fsvuC.useMemo)(()=>({
            width: width,
            height: height,
            left: left,
            top: top
        }), [
        width,
        height,
        left,
        top
    ]);
    return box;
};
/**
 * Will listen to the document resizing to see if an element has moved positions.
 * Not using ResizeObserver because of IE11 support.
 * @param element HTMLElement to watch when resizing.
 */ const $2f0e093cf9ca586d$var$useElementBox = (element, resizeUpdateMethod)=>{
    const updateMethod = resizeUpdateMethod || 'resizeListener';
    const boxViaResizeListener = $2f0e093cf9ca586d$var$useResizeAwareElementBox(element, updateMethod);
    const boxViaPolling = $2f0e093cf9ca586d$var$usePollingElementBox(element, updateMethod);
    return updateMethod === 'resizeListener' ? boxViaResizeListener : boxViaPolling;
};
const $2f0e093cf9ca586d$export$1b6719bd7aff3c00 = (props)=>{
    const box = $2f0e093cf9ca586d$var$useElementBox(props.element, props.resizeUpdateMethod);
    return props.children(box);
};
$2f0e093cf9ca586d$export$1b6719bd7aff3c00.displayName = "ElementBox";

});

parcelRegister("dKEES", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b69b17702e709e7$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $fPBr2 = parcelRequire("fPBr2");

var $lc1Op = parcelRequire("lc1Op");
const $9b69b17702e709e7$var$computedStyleAttributesToClone = [
    'fontSize',
    'fontWeight',
    'lineHeight',
    'padding',
    'color',
    'textOverflow'
];
function $9b69b17702e709e7$var$cloneAndOverrideStyles(node) {
    const shouldCloneChildren = true;
    const clonedNode = node.cloneNode(shouldCloneChildren);
    const computedStyles = getComputedStyle(node);
    $9b69b17702e709e7$var$computedStyleAttributesToClone.forEach((attribute)=>{
        clonedNode.style[attribute] = computedStyles[attribute];
    });
    clonedNode.style.margin = '0';
    clonedNode.style.position = 'static';
    // The target may have other transforms applied. Avoid unintended side effects
    // by zeroing out "translate" rather than applying a value of "none".
    clonedNode.style.transform = 'translate(0, 0) translate3d(0, 0, 0)';
    return clonedNode;
}
/**
 * __Clone__
 *
 * Used for cloning spotlight targets. The clone is positioned on top of the spotlight target with
 * a pulsing animation.
 *
 * @internal
 */ const $9b69b17702e709e7$var$Clone = (props)=>{
    const { pulse: pulse, style: style, shouldWatch: shouldWatch, target: target, targetBgColor: targetBgColor, targetOnClick: targetOnClick, targetNode: targetNode, targetRadius: targetRadius, testId: testId } = props;
    const contentVersion = (0, $lc1Op.useElementObserver)(targetNode, {
        disableWatch: !shouldWatch
    });
    const contentHTML = (0, $fsvuC.useMemo)(()=>$9b69b17702e709e7$var$cloneAndOverrideStyles(targetNode).outerHTML, // eslint-disable-next-line react-hooks/exhaustive-deps -- We only want to update when the content changes
    [
        contentVersion,
        targetNode
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $fPBr2.TargetInner), {
        "data-testid": testId,
        pulse: pulse,
        bgColor: targetBgColor,
        radius: targetRadius,
        style: style,
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: contentHTML
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    height: '100%',
                    pointerEvents: 'none'
                }
            }),
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $fPBr2.TargetOverlay), {
                onClick: targetOnClick ? (event)=>targetOnClick({
                        event: event,
                        target: target
                    }) : undefined
            })
        ]
    });
};
$9b69b17702e709e7$var$Clone.displayName = "Clone";
var $9b69b17702e709e7$export$2e2bcd8739ae039 = $9b69b17702e709e7$var$Clone;

});
parcelRegister("fPBr2", function(module, exports) {
$parcel$export(module.exports, "TargetInner", () => $898363ff4397c3c1$export$b1542cc928b93af);
$parcel$export(module.exports, "TargetOverlay", () => $898363ff4397c3c1$export$a28a07e0025d709d);
$parcel$export(module.exports, "Pulse", () => $898363ff4397c3c1$export$927d63e2511364c0);
/* target.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");
const $898363ff4397c3c1$var$reduceMotionAsPerUserPreference = null;
// NOTE:
// Pulse color "rgb(101, 84, 192)" derived from "colors.P300"
const $898363ff4397c3c1$var$baseShadow = `0 0 0 2px ${"var(--ds-border-discovery, #AF59E1)"}`;
const $898363ff4397c3c1$var$easing = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
const $898363ff4397c3c1$var$pulseKeyframes = null;
const $898363ff4397c3c1$var$animationStyles = null;
const $898363ff4397c3c1$var$Base = ({ bgColor: bgColor, children: children, className: className, radius: radius, testId: testId, style: style, // The rest of these props are from `HTMLDivElement`
...props })=>/*#__PURE__*/ (0, $5chsV.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Pass-through style is not allowed at the moment
            ...style,
            backgroundColor: bgColor,
            borderRadius: radius ? typeof radius === 'number' ? `${radius}px` : radius : undefined
        },
        ...props,
        children: children
    });
$898363ff4397c3c1$var$Base.displayName = "Base";
const $898363ff4397c3c1$export$b1542cc928b93af = ({ bgColor: bgColor, children: children, className: className, pulse: pulse, radius: radius, testId: testId, // Thes rest of these are from `HTMLDivElement`
...props })=>/*#__PURE__*/ (0, $5chsV.jsx)($898363ff4397c3c1$var$Base, {
        bgColor: bgColor,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $gJ6nT.default)([
            pulse && "",
            pulse && "_0nFVCG2h6w _03m2nySHWH _1gBibyAup0 _43vdfTs3G2 _2OUyjtgbYL",
            "_39Ohv4YbGa _1SdfoHYbGa",
            className
        ]),
        radius: radius,
        testId: testId,
        ...props,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: props.style,
        children: children
    });
$898363ff4397c3c1$export$b1542cc928b93af.displayName = "TargetInner";
const $898363ff4397c3c1$var$targetOverlayStyles = null;
const $898363ff4397c3c1$export$a28a07e0025d709d = ({ onClick: onClick, ...props })=>/*#__PURE__*/ (0, $5chsV.jsx)("div", {
        onClick: onClick,
        ...props,
        style: {
            cursor: onClick ? 'pointer' : 'auto'
        },
        className: (0, $gJ6nT.default)([
            "_39xV02N91d _0jFU0VN91d _1mT5xdWVPG _2I62gzPgdg _3iC0zdPgdg"
        ])
    });
$898363ff4397c3c1$export$a28a07e0025d709d.displayName = "TargetOverlay";
const $898363ff4397c3c1$export$927d63e2511364c0 = ({ bgColor: bgColor, children: children, className: className, radius: radius, pulse: pulse = true, testId: testId, ...props })=>/*#__PURE__*/ (0, $5chsV.jsx)($898363ff4397c3c1$var$Base, {
        bgColor: bgColor,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $gJ6nT.default)([
            pulse && "",
            pulse && "_0nFVCG2h6w _03m2nySHWH _1gBibyAup0 _43vdfTs3G2 _2OUyjtgbYL",
            "_39Ohv4YbGa _1SdfoHYbGa",
            className
        ]),
        radius: radius,
        testId: testId,
        ...props,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: props.style,
        children: children
    });
$898363ff4397c3c1$export$927d63e2511364c0.displayName = "Pulse";

});

parcelRegister("lc1Op", function(module, exports) {
$parcel$export(module.exports, "useElementObserver", () => $2e7f95dacffe98ba$export$729bafd4e621fba0);

var $fsvuC = parcelRequire("fsvuC");
function $2e7f95dacffe98ba$export$729bafd4e621fba0(element, opts = {}) {
    const { onChange: onChange, disableWatch: disableWatch = false } = opts;
    // This state is used to force a re-render when the target changes
    const [targetContentVersion, setTargetContentVersion] = (0, $fsvuC.useState)(0);
    const mutationObserver = (0, $fsvuC.useRef)(undefined);
    const cancelIdleCallback1 = (0, $fsvuC.useRef)(undefined);
    const disposer = (0, $fsvuC.useCallback)(()=>{
        cancelIdleCallback1.current?.();
        cancelIdleCallback1.current = undefined;
        mutationObserver.current?.disconnect();
        mutationObserver.current = undefined;
    }, []);
    const onMutation = (0, $fsvuC.useCallback)(()=>{
        // MutationObserver can make multiple calls to the callback in quick succession so debounce when idle
        cancelIdleCallback1.current?.();
        cancelIdleCallback1.current = $2e7f95dacffe98ba$var$callWhenIdle(()=>setTargetContentVersion((v)=>{
                const version = v + 1;
                onChange?.(version);
                return version;
            }));
    }, [
        onChange
    ]);
    (0, $fsvuC.useEffect)(()=>{
        // Clean up any existing observer in the case that the target node has changed
        disposer();
        if (!disableWatch && element) {
            mutationObserver.current = new MutationObserver(onMutation);
            mutationObserver.current.observe(element, {
                attributes: true,
                childList: true,
                subtree: true
            });
        }
        return disposer;
    }, [
        disableWatch,
        disposer,
        element,
        onMutation
    ]);
    return targetContentVersion;
}
/**
 * When the browser is idle call the callback.
 *
 * This function will use `requestIdleCallback` if available, otherwise it will fallback to `setTimeout`.
 *
 * @param callback The function to call when the browser is idle.
 * @param [opts] Options for the idle callback.
 * @param [opts.timeout=100] The maximum time to wait for the browser to be idle.
 *
 * @returns A function that can be called to cancel the idle callback.
 *
 * @internal
 */ function $2e7f95dacffe98ba$var$callWhenIdle(callback, opts = {}) {
    const { timeout: timeout = 100 } = opts;
    if (typeof window.requestIdleCallback === 'function') {
        const idleHandle = window.requestIdleCallback(callback, {
            timeout: timeout
        });
        return ()=>cancelIdleCallback(idleHandle);
    }
    // Fallback to setTimeout if requestIdleCallback is not available
    const timeoutHandle = setTimeout(callback, timeout);
    return ()=>clearTimeout(timeoutHandle);
}

});


parcelRegister("dQG4F", function(module, exports) {
$parcel$export(module.exports, "default", () => $784f0a9a95332515$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $knrfi = parcelRequire("knrfi");
/**
 * A wrapper component that conditionally applies a NodeResolver to its children.
 *
 * Note: NodeResolver should not be used in React 18 concurrent mode. This component
 * is intended to be removed once the feature flag  is removed.
 * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
 * @param {ReactElement} props.children - The child elements to be wrapped.
 * @param {(instance: HTMLDivElement) => void} props.innerRef - A ref callback to get the instance of the HTMLDivElement.
 * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
 */ const $784f0a9a95332515$var$NodeResolverSpotlightInner = ({ hasNodeResolver: hasNodeResolver, children: children, innerRef: innerRef })=>{
    const divRef = (0, $fsvuC.useRef)(null);
    (0, $fsvuC.useEffect)(()=>{
        if (!hasNodeResolver) innerRef(divRef.current?.firstElementChild);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hasNodeResolver
    ]);
    if (hasNodeResolver) return /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($knrfi))), {
        innerRef: innerRef,
        children: children
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        ref: divRef,
        children: children
    });
};
$784f0a9a95332515$var$NodeResolverSpotlightInner.displayName = "NodeResolverSpotlightInner";
var $784f0a9a95332515$export$2e2bcd8739ae039 = $784f0a9a95332515$var$NodeResolverSpotlightInner;

});

parcelRegister("52MKK", function(module, exports) {
$parcel$export(module.exports, "default", () => $e67e8e56cc934752$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $kyAKM = parcelRequire("kyAKM");

var $f3WQU = parcelRequire("f3WQU");

var $jRYjy = parcelRequire("jRYjy");

var $4viLm = parcelRequire("4viLm");

var $d3HMC = parcelRequire("d3HMC");

var $bgcJs = parcelRequire("bgcJs");
/**
 * __Spotlight dialog__
 *
 * An onboarding spotlight introduces new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 */ // eslint-disable-next-line @repo/internal/react/no-class-components
class $e67e8e56cc934752$var$SpotlightDialogComponent extends (0, $fsvuC.Component) {
    componentDidMount() {
        this.focusLockTimeoutId = window.setTimeout(()=>{
            // we delay the enabling of the focus lock to avoid the scroll position
            // jumping around in some situations
            this.setState({
                focusLockDisabled: false
            });
        }, 200);
    }
    componentWillUnmount() {
        window.clearTimeout(this.focusLockTimeoutId);
    }
    render() {
        const { actions: actions, actionsBeforeElement: actionsBeforeElement, children: children, dialogPlacement: dialogPlacement, dialogWidth: dialogWidth, footer: footer, header: header, heading: heading, headingAfterElement: headingAfterElement, image: image, label: label = 'Introducing new feature', titleId: titleId, targetNode: targetNode, testId: testId } = this.props;
        const { focusLockDisabled: focusLockDisabled } = this.state;
        const dialogLabel = !heading && !titleId ? label : undefined;
        const dialogLabelledBy = titleId || (heading ? 'spotlight-dialog-label' : undefined);
        const translatedPlacement = dialogPlacement ? ({
            'top left': 'top-start',
            'top center': 'top',
            'top right': 'top-end',
            'right top': 'right-start',
            'right middle': 'right',
            'right bottom': 'right-end',
            'bottom left': 'bottom-start',
            'bottom center': 'bottom',
            'bottom right': 'bottom-end',
            'left top': 'left-start',
            'left middle': 'left',
            'left bottom': 'left-end'
        })[dialogPlacement] : undefined;
        // If there's no room on either side of the popper, it will extend off-screen.
        //  This looks buggy when scroll-lock and focus is placed on the dialog, so we
        //  customise popper so it overflows the spotlight instead with altAxis=true.
        const modifiers = [
            {
                name: 'preventOverflow',
                options: {
                    padding: 5,
                    rootBoundary: 'document',
                    altAxis: true,
                    tether: false
                }
            }
        ];
        return /*#__PURE__*/ (0, $5chsV.jsx)((0, $f3WQU.Popper), {
            modifiers: modifiers,
            referenceElement: targetNode,
            placement: translatedPlacement,
            children: ({ ref: ref, style: style, update: update })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $bgcJs.default), {
                    value: dialogWidth,
                    onChange: update,
                    children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $kyAKM.default), {
                        disabled: focusLockDisabled,
                        returnFocus: false,
                        autoFocus: true,
                        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $jRYjy.Box), {
                            style: style,
                            ref: ref,
                            "aria-modal": true,
                            role: "dialog",
                            "aria-label": dialogLabel,
                            "aria-labelledby": dialogLabelledBy,
                            testId: `${testId}-container`,
                            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $d3HMC.default), {
                                testId: testId,
                                width: dialogWidth,
                                actions: actions,
                                actionsBeforeElement: actionsBeforeElement,
                                image: image && /*#__PURE__*/ (0, $5chsV.jsx)((0, $4viLm.DialogImage), {
                                    alt: heading,
                                    src: image
                                }),
                                components: {
                                    Header: header,
                                    Footer: footer
                                },
                                heading: heading,
                                headingId: "spotlight-dialog-label",
                                headingAfterElement: headingAfterElement,
                                // This should be heading level 1 since this is technically a modal, including a focus lock on the modal window.
                                // But because it is not a _true_ modal, we are setting it to `2` until that is fixed.
                                headingLevel: 2,
                                children: children
                            })
                        })
                    })
                })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            focusLockDisabled: true
        };
    }
}
$e67e8e56cc934752$var$SpotlightDialogComponent.displayName = "SpotlightDialogComponent";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e67e8e56cc934752$export$2e2bcd8739ae039 = $e67e8e56cc934752$var$SpotlightDialogComponent;

});
parcelRegister("4viLm", function(module, exports) {
$parcel$export(module.exports, "DialogImage", () => $9419167d7b0c2b30$export$855e1a47874d6b81);
$parcel$export(module.exports, "DialogActionItemContainer", () => $9419167d7b0c2b30$export$ed9b6b50bbed5f27);
$parcel$export(module.exports, "DialogActionItem", () => $9419167d7b0c2b30$export$6ae54e00f59e1f33);
/* dialog.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $jRYjy = parcelRequire("jRYjy");
const $9419167d7b0c2b30$var$imageStyles = null;
const $9419167d7b0c2b30$var$actionItemContainerStyles = {
    root: "_3iDTPbQ4SZ _0aFT5vf5Xk _0rIjykPgdg _43nrzTPgdg _2xTnZx5UaJ _0GTcwR5UaJ"
};
const $9419167d7b0c2b30$var$actionItemStyles = {
    root: "_0rIjykPgdg _43nrzTPgdg _2xTnZx1Y8M _0GTcwR1Y8M"
};
const $9419167d7b0c2b30$export$855e1a47874d6b81 = ({ alt: alt, ...props })=>/*#__PURE__*/ (0, $5chsV.jsx)("img", {
        alt: alt,
        ...props,
        className: (0, $gJ6nT.default)([
            "_1EqgXlN91d _0jFU0VIZbP"
        ])
    });
$9419167d7b0c2b30$export$855e1a47874d6b81.displayName = "DialogImage";
const $9419167d7b0c2b30$export$ed9b6b50bbed5f27 = ({ children: children })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $jRYjy.Box), {
        xcss: $9419167d7b0c2b30$var$actionItemContainerStyles.root,
        children: children
    });
$9419167d7b0c2b30$export$ed9b6b50bbed5f27.displayName = "DialogActionItemContainer";
const $9419167d7b0c2b30$export$6ae54e00f59e1f33 = ({ children: children })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $jRYjy.Box), {
        xcss: $9419167d7b0c2b30$var$actionItemStyles.root,
        children: children
    });
$9419167d7b0c2b30$export$6ae54e00f59e1f33.displayName = "DialogActionItem";

});

parcelRegister("d3HMC", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4ad547978540c21$export$2e2bcd8739ae039);
/* spotlight-card.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $3KROw = parcelRequire("3KROw");

var $cuUd3 = parcelRequire("cuUd3");

var $dwUnm = parcelRequire("dwUnm");

var $lgvAm = parcelRequire("lgvAm");

var $hZwjD = parcelRequire("hZwjD");

var $jRYjy = parcelRequire("jRYjy");

var $daZXj = parcelRequire("daZXj");

var $4viLm = parcelRequire("4viLm");

var $fTvUu = parcelRequire("fTvUu");
const $d4ad547978540c21$var$bodyStyles = null;
const $d4ad547978540c21$var$imageStyles = null;
const $d4ad547978540c21$var$defaultHeaderStyles = null;
const $d4ad547978540c21$var$DefaultHeader = ({ children: children })=>/*#__PURE__*/ (0, $5chsV.jsx)("div", {
        className: (0, $gJ6nT.default)([
            "_3iDTPbQ4SZ _0hPCNLQame _37wbyuI7V3 _0xmtko2ADO"
        ]),
        children: children
    });
$d4ad547978540c21$var$DefaultHeader.displayName = "DefaultHeader";
const $d4ad547978540c21$var$defaultFooterStyles = null;
const $d4ad547978540c21$var$DefaultFooter = ({ children: children })=>/*#__PURE__*/ (0, $5chsV.jsx)("div", {
        "data-testid": "spotlight--dialog-footer",
        className: (0, $gJ6nT.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _46hvQm2ADO"
        ]),
        children: children
    });
$d4ad547978540c21$var$DefaultFooter.displayName = "DefaultFooter";
const $d4ad547978540c21$var$containerStyles = {
    root: "_0bjKvDKxmn _4bt5LAIZbP _2WAcuGIZbP _0jFU0VE6Kk _1UtDYze5R3 _4ouGXIoaux _1EqgXlpNyl"
};
const $d4ad547978540c21$var$containerShadowStyles = {
    root: "_2OUyjtzwhj"
};
/**
 * __Spotlight card__
 *
 * A spotlight card is for onboarding messages that need a more flexible layout, or don't require a dialog.
 *
 * - [Examples](https://atlassian.design/components/onboarding/spotlight-card/examples)
 * - [Code](https://atlassian.design/components/onboarding/spotlight-card/code)
 * - [Usage](https://atlassian.design/components/onboarding/spotlight-card/usage)
 *
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ const $d4ad547978540c21$var$SpotlightCard = /*#__PURE__*/ (0, $fsvuC.forwardRef)((props, ref)=>{
    const { actions: actions = [], actionsBeforeElement: actionsBeforeElement, children: children, components: components = {}, heading: heading, headingLevel: headingLevel = 4, headingAfterElement: headingAfterElement, image: image, innerRef: innerRef, isFlat: isFlat, testId: testId, width: width = 400, headingId: headingId } = props;
    const { Header: Header = $d4ad547978540c21$var$DefaultHeader, Footer: Footer = $d4ad547978540c21$var$DefaultFooter } = components;
    const { currentLevel: currentLevel } = (0, $hZwjD.useLayering)();
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $cuUd3.default).Provider, {
        value: (0, $fTvUu.spotlightButtonTheme),
        children: /*#__PURE__*/ (0, $5chsV.jsxs)((0, $jRYjy.Box), {
            backgroundColor: "color.background.discovery.bold",
            xcss: (0, $dwUnm.cx)($d4ad547978540c21$var$containerStyles.root, !isFlat && $d4ad547978540c21$var$containerShadowStyles.root),
            style: {
                width: width
            },
            ref: ref || innerRef,
            testId: testId,
            "data-ds--level": currentLevel,
            // temporarily use this data attribute to prevent clicking outside won't close spotlight correctly issue
            "data-ds--close--type": "single",
            children: [
                typeof image === 'string' ? /*#__PURE__*/ (0, $5chsV.jsx)("img", {
                    src: image,
                    alt: "",
                    className: (0, $gJ6nT.default)([
                        "_3iDTPbvLZJ"
                    ])
                }) : image,
                /*#__PURE__*/ (0, $5chsV.jsxs)("div", {
                    className: (0, $gJ6nT.default)([
                        "_3iDTPbQ4SZ _0aFT5vbt8w _0xmtko5zaO _46hvQm5zaO _03SyCPkG2W _0LQT5EkG2W"
                    ]),
                    children: [
                        heading || headingAfterElement ? /*#__PURE__*/ (0, $5chsV.jsxs)(Header, {
                            children: [
                                /*#__PURE__*/ (0, $5chsV.jsx)((0, $lgvAm.default), {
                                    id: headingId,
                                    size: "medium",
                                    as: `h${headingLevel}`,
                                    color: "color.text.inverse",
                                    children: heading
                                }),
                                headingAfterElement
                            ]
                        }) : null,
                        /*#__PURE__*/ (0, $5chsV.jsx)((0, $daZXj.Text), {
                            children: children
                        }),
                        actions.length > 0 || actionsBeforeElement ? /*#__PURE__*/ (0, $5chsV.jsxs)(Footer, {
                            children: [
                                actionsBeforeElement || /*#__PURE__*/ (0, $5chsV.jsx)("span", {}),
                                /*#__PURE__*/ (0, $5chsV.jsx)((0, $4viLm.DialogActionItemContainer), {
                                    children: actions.map(({ text: text, key: key, ...rest }, idx)=>{
                                        return /*#__PURE__*/ (0, $5chsV.jsx)((0, $4viLm.DialogActionItem), {
                                            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $3KROw.default), {
                                                ...rest,
                                                children: text
                                            })
                                        }, key || (typeof text === 'string' ? text : `${idx}`));
                                    })
                                })
                            ]
                        }) : null
                    ]
                })
            ]
        })
    });
});
$d4ad547978540c21$var$SpotlightCard.displayName = 'SpotlightCard';
var $d4ad547978540c21$export$2e2bcd8739ae039 = $d4ad547978540c21$var$SpotlightCard;

});
parcelRegister("fTvUu", function(module, exports) {
$parcel$export(module.exports, "spotlightButtonTheme", () => $6f7e397586cd1e93$export$39a36121076ca24);
$parcel$export(module.exports, "modalButtonTheme", () => $6f7e397586cd1e93$export$d131eb21ba4cbd16);
const $6f7e397586cd1e93$var$spotlightTheme = {
    default: {
        background: {
            default: "var(--ds-background-inverse-subtle, #00000029)",
            hover: "var(--ds-background-inverse-subtle-hovered, #0000003D)",
            active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
            disabled: "var(--ds-background-disabled, #0515240F)",
            selected: "var(--ds-background-inverse-subtle-pressed, #00000052)",
            focus: "var(--ds-background-inverse-subtle, #00000029)"
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            hover: "var(--ds-text-inverse, #FFFFFF)",
            active: "var(--ds-text-inverse, #FFFFFF)",
            disabled: {
                light: "var(--ds-text-disabled, #080F214A)",
                dark: "var(--ds-text-disabled, #080F214A)"
            },
            selected: "var(--ds-text-inverse, #FFFFFF)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    },
    subtle: {
        background: {
            default: 'none',
            hover: "var(--ds-background-inverse-subtle-hovered, #0000003D)",
            active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
            disabled: 'none',
            selected: {
                light: "var(--ds-background-selected-hovered, #CFE1FD)",
                dark: "var(--ds-background-selected-hovered, #CFE1FD)"
            },
            focusSelected: {
                light: "var(--ds-background-selected-hovered, #CFE1FD)",
                dark: "var(--ds-background-selected-hovered, #CFE1FD)"
            }
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            hover: "var(--ds-text-inverse, #FFFFFF)",
            active: "var(--ds-text-inverse, #FFFFFF)",
            disabled: "var(--ds-text-disabled, #080F214A)",
            selected: "var(--ds-text-inverse, #FFFFFF)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    },
    'subtle-link': {
        textDecoration: {
            hover: `underline ${"var(--ds-text-inverse, #FFFFFF)"}`
        },
        textDecorationLine: {
            active: 'none'
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            hover: "var(--ds-text-inverse, #FFFFFF)",
            active: "var(--ds-text-inverse, #FFFFFF)",
            disabled: "var(--ds-text-discovery, #803FA5)",
            selected: "var(--ds-text-selected, #1868DB)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    }
};
const $6f7e397586cd1e93$var$modalTheme = {
    primary: {
        background: {
            default: "var(--ds-background-discovery-bold, #964AC0)",
            hover: "var(--ds-background-discovery-bold-hovered, #803FA5)",
            active: "var(--ds-background-discovery-bold-pressed, #673286)",
            disabled: {
                light: "var(--ds-background-disabled, #0515240F)",
                dark: "var(--ds-background-disabled, #0515240F)"
            },
            selected: "var(--ds-background-selected-hovered, #CFE1FD)",
            focus: "var(--ds-background-discovery-bold-hovered, #803FA5)"
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            disabled: {
                light: "var(--ds-text-disabled, #080F214A)",
                dark: "var(--ds-text-disabled, #080F214A)"
            },
            selected: "var(--ds-text-selected, #1868DB)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    }
};
function $6f7e397586cd1e93$var$extract(newTheme, { mode: mode, appearance: appearance, state: state }) {
    if (!newTheme[appearance]) return undefined;
    const root = newTheme[appearance];
    return Object.keys(root).reduce((acc, val)=>{
        let node = root;
        [
            val,
            state,
            mode
        ].forEach((item)=>{
            if (!node[item]) return undefined;
            if (typeof node[item] !== 'object') {
                acc[val] = node[item];
                return undefined;
            }
            node = node[item];
            return undefined;
        });
        return acc;
    }, {});
}
const $6f7e397586cd1e93$export$39a36121076ca24 = (current, themeProps)=>{
    const { buttonStyles: buttonStyles, ...rest } = current(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            ...$6f7e397586cd1e93$var$extract($6f7e397586cd1e93$var$spotlightTheme, themeProps)
        },
        ...rest
    };
};
const $6f7e397586cd1e93$export$d131eb21ba4cbd16 = (current, themeProps)=>{
    const { buttonStyles: buttonStyles, ...rest } = current(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            ...$6f7e397586cd1e93$var$extract($6f7e397586cd1e93$var$modalTheme, themeProps)
        },
        ...rest
    };
};

});


parcelRegister("bgcJs", function(module, exports) {
$parcel$export(module.exports, "default", () => $2cb6ce84c2396f55$export$2e2bcd8739ae039);

var $fsvuC = parcelRequire("fsvuC");
class $2cb6ce84c2396f55$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) this.props.onChange();
    }
    render() {
        return this.props.children;
    }
}
$2cb6ce84c2396f55$export$2e2bcd8739ae039.displayName = "ValueChanged";

});


parcelRegister("1HhHB", function(module, exports) {
$parcel$export(module.exports, "SpotlightTransitionConsumer", () => $539229a5578178c6$export$7d63b19b854c2fe8);
$parcel$export(module.exports, "default", () => $539229a5578178c6$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $9Tkwf = parcelRequire("9Tkwf");
const $539229a5578178c6$var$SpotlightTransitionContext = /*#__PURE__*/ (0, $fsvuC.createContext)({
    isOpen: true,
    onExited: (0, $9Tkwf.default)
});
// checks if children exist and are truthy
const $539229a5578178c6$var$hasChildren = (children)=>(0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Children.count(children) > 0 && ((0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Children.map(children || false, (child)=>!!child)?.filter(Boolean)?.length || 0) > 0;
/**
 * __Spotlight transition__
 *
 * A spotlight transition holds onto spotlights so they can fade out when exiting the viewport.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 *
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ // eslint-disable-next-line @repo/internal/react/no-class-components
class $539229a5578178c6$var$SpotlightTransition extends (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Component {
    static getDerivedStateFromProps(props, state) {
        const { currentChildren: previousChildren } = state;
        const exiting = $539229a5578178c6$var$hasChildren(previousChildren) && !$539229a5578178c6$var$hasChildren(props.children);
        return {
            currentChildren: exiting ? previousChildren : props.children
        };
    }
    render() {
        return /*#__PURE__*/ (0, $5chsV.jsx)($539229a5578178c6$var$SpotlightTransitionContext.Provider, {
            value: {
                onExited: this.onExited,
                isOpen: $539229a5578178c6$var$hasChildren(this.props.children)
            },
            children: this.state.currentChildren
        });
    }
    constructor(...args){
        super(...args), this.state = {
            currentChildren: undefined
        }, this.onExited = ()=>{
            this.setState({
                currentChildren: this.props.children
            });
        };
    }
}
$539229a5578178c6$var$SpotlightTransition.displayName = "SpotlightTransition";
const $539229a5578178c6$export$7d63b19b854c2fe8 = $539229a5578178c6$var$SpotlightTransitionContext.Consumer;
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$539229a5578178c6$export$2e2bcd8739ae039 = $539229a5578178c6$var$SpotlightTransition;

});


parcelRegister("gY8Aw", function(module, exports) {
$parcel$export(module.exports, "TargetConsumer", () => $98bd5a4150776c93$export$f643dd64c1952cc8);
$parcel$export(module.exports, "SpotlightContext", () => $98bd5a4150776c93$export$7b5aa0f5b37a336d);
$parcel$export(module.exports, "SpotlightConsumer", () => $98bd5a4150776c93$export$3503199acd121708);
$parcel$export(module.exports, "default", () => $98bd5a4150776c93$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $kZVJU = parcelRequire("kZVJU");

var $9Tkwf = parcelRequire("9Tkwf");

var $lfw4f = parcelRequire("lfw4f");

var $eEY7a = parcelRequire("eEY7a");

var $bDK6L = parcelRequire("bDK6L");

var $1Gslh = parcelRequire("1Gslh");

var $hoalA = parcelRequire("hoalA");
const $98bd5a4150776c93$var$dest = /*#__PURE__*/ (0, $fsvuC.createContext)(undefined);
const $98bd5a4150776c93$export$f643dd64c1952cc8 = $98bd5a4150776c93$var$dest.Consumer;
const $98bd5a4150776c93$var$TargetProvider = $98bd5a4150776c93$var$dest.Provider;
const $98bd5a4150776c93$export$7b5aa0f5b37a336d = /*#__PURE__*/ (0, $fsvuC.createContext)({
    opened: (0, $9Tkwf.default),
    closed: (0, $9Tkwf.default),
    targets: {}
});
const $98bd5a4150776c93$export$3503199acd121708 = $98bd5a4150776c93$export$7b5aa0f5b37a336d.Consumer;
const $98bd5a4150776c93$var$SpotlightStateProvider = $98bd5a4150776c93$export$7b5aa0f5b37a336d.Provider;
const $98bd5a4150776c93$var$Container = ({ component: Wrapper, children: children })=>/*#__PURE__*/ (0, $5chsV.jsx)(Wrapper, {
        children: children
    });
$98bd5a4150776c93$var$Container.displayName = "Container";
class $98bd5a4150776c93$export$2e2bcd8739ae039 extends (0, $fsvuC.PureComponent) {
    static{
        this.defaultProps = {
            blanketIsTinted: true
        };
    }
    componentDidMount() {
        typeof $hoalA;
    }
    render() {
        const { blanketIsTinted: blanketIsTinted, children: children, component: Tag, onBlanketClicked: onBlanketClicked } = this.props;
        const isActive = this.state.spotlightCount > 0;
        return /*#__PURE__*/ (0, $5chsV.jsx)($98bd5a4150776c93$var$SpotlightStateProvider, {
            value: this.getStateProviderValue(this.state.targets),
            children: /*#__PURE__*/ (0, $5chsV.jsx)($98bd5a4150776c93$var$TargetProvider, {
                value: this.getTargetRef,
                children: /*#__PURE__*/ (0, $5chsV.jsxs)($98bd5a4150776c93$var$Container, {
                    component: Tag || (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Fragment,
                    children: [
                        /*#__PURE__*/ (0, $5chsV.jsx)((0, $lfw4f.default), {
                            children: isActive && /*#__PURE__*/ (0, $5chsV.jsx)((0, $eEY7a.default), {
                                duration: "medium",
                                children: ({ ref: ref, className: className, style: style })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $bDK6L.default), {
                                        zIndex: 700,
                                        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $1Gslh.default), {
                                            ref: ref,
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                                            className: className,
                                            style: style,
                                            isTinted: blanketIsTinted,
                                            onBlanketClicked: onBlanketClicked
                                        })
                                    })
                            })
                        }),
                        children
                    ]
                })
            })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            spotlightCount: 0,
            targets: {}
        }, /*
	 * When enabling React Streaming in Confluence, a
	 * "This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering"
	 * error happens.
	 * This is to fix this error by wrapping the state update in startTransition as suggested by React: https://react.dev/errors/421?invariant=421
	 */ this.getTargetRef = (name)=>(element)=>{
                (0, $fsvuC.startTransition)(()=>{
                    this.setState((state)=>({
                            targets: {
                                ...state.targets,
                                [name]: element || undefined
                            }
                        }));
                });
            }, this.spotlightOpen = ()=>{
            this.setState((state)=>({
                    spotlightCount: state.spotlightCount + 1
                }));
        }, this.spotlightClose = ()=>{
            this.setState((state)=>({
                    spotlightCount: state.spotlightCount - 1
                }));
        }, this.getStateProviderValue = (0, $kZVJU.default)((targets)=>({
                opened: this.spotlightOpen,
                closed: this.spotlightClose,
                targets: targets
            }));
    }
}
$98bd5a4150776c93$export$2e2bcd8739ae039.displayName = "SpotlightManager";

});
parcelRegister("1Gslh", function(module, exports) {
$parcel$export(module.exports, "default", () => $d3bd8b879d366074$export$2e2bcd8739ae039);
/* blanket.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");
// IE11 and Edge: z-index needed because fixed position calculates z-index relative
// to body instead of nearest stacking context (Portal in our case).
const $d3bd8b879d366074$var$blanketStyles = null;
/**
 * __Blanket__
 *
 * A replacement for `@atlaskit/blanket`.
 *
 * We use this for spotlights instead of `@atlaskit/blanket`
 * because spotlights must sit on top of other layered elements,
 * such as modals, which have their own blankets.
 *
 * @internal
 */ const $d3bd8b879d366074$var$Blanket = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ isTinted: isTinted, onBlanketClicked: onBlanketClicked, style: style, className: className }, ref)=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        ref: ref,
        role: "presentation",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $gJ6nT.default)([
            "_49OCfRdnbC _23rrnHZtEe _1mT5xdy1CL _42Yu6BkKjW",
            className
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Pass-through style props are not allowed
            ...style,
            backgroundColor: isTinted ? "var(--ds-blanket, #050C1F75)" : 'transparent'
        },
        onClick: onBlanketClicked
    });
});
var $d3bd8b879d366074$export$2e2bcd8739ae039 = $d3bd8b879d366074$var$Blanket;

});



parcelRegister("gOANe", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca60bb2318d5ca35$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $jBG9w = parcelRequire("jBG9w");

var $bJtVR = parcelRequire("bJtVR");
const $ca60bb2318d5ca35$var$baseImageStyles = null; /**
                               * __Image__
                               *
                               * This component can be used interchangeably with the native `img` element. It includes additional functionality, such as theme support.
                               *
                               * - [Examples](https://atlassian.design/components/image/examples)
                               * - [Code](https://atlassian.design/components/image/code)
                               * - [Usage](https://atlassian.design/components/image/usage)
                               */ 
function $ca60bb2318d5ca35$export$2e2bcd8739ae039({ src: src, srcDark: srcDark, alt: alt, testId: testId, className: className, ...props }) {
    const imgRef = (0, $fsvuC.useRef)(null);
    const providedColorMode = (0, $jBG9w.UNSAFE_useColorModeForMigration)();
    const { colorMode: observedColorMode } = (0, $bJtVR.useThemeObserver)();
    const colorMode = providedColorMode || observedColorMode;
    (0, $fsvuC.useEffect)(()=>{
        if (imgRef === null || imgRef.current === null) return;
        if (srcDark && colorMode === 'dark') imgRef.current.src = srcDark;
        else if (src) imgRef.current.src = src;
    }, [
        src,
        srcDark,
        colorMode
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)("img", {
        alt: alt,
        "data-testid": testId,
        src: src,
        className: (0, $gJ6nT.default)([
            "_1EqgXlN91d _0jFU0VIZbP",
            className
        ]),
        ref: imgRef,
        ...props
    });
}
$ca60bb2318d5ca35$export$2e2bcd8739ae039.displayName = "Image";

});
parcelRegister("jBG9w", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_useColorModeForMigration", () => $22db6d12c3dccae5$export$ce91654eb9fea460);

var $fsvuC = parcelRequire("fsvuC");

var $9xFXq = parcelRequire("9xFXq");
function $22db6d12c3dccae5$export$ce91654eb9fea460() {
    const value = (0, $fsvuC.useContext)((0, $9xFXq.ColorModeContext));
    return value;
}
$22db6d12c3dccae5$export$ce91654eb9fea460.displayName = "UNSAFE_useColorModeForMigration";

});


parcelRegister("eygIb", function(module, exports) {
$parcel$export(module.exports, "SpotlightActions", () => $83d000a75f51ad06$export$205c28213090dc52);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $jR7Rq = parcelRequire("jR7Rq");
const $83d000a75f51ad06$var$styles = {
    root: "_39xV02N91d"
};
const $83d000a75f51ad06$export$205c28213090dc52 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $jR7Rq.Flex), {
        ref: ref,
        testId: testId,
        xcss: $83d000a75f51ad06$var$styles.root,
        role: "group",
        justifyContent: "end",
        gap: "space.050",
        children: children
    });
});

});

parcelRegister("3Ru3M", function(module, exports) {
$parcel$export(module.exports, "SpotlightBody", () => $03998ae46f52ac58$export$4ae665cf62a00c3f);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $jRYjy = parcelRequire("jRYjy");
const $03998ae46f52ac58$var$styles = {
    root: "_2Y7lL45zaO _1UtDYze5R3 _46hvQm2ADO"
};
const $03998ae46f52ac58$export$4ae665cf62a00c3f = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $jRYjy.Box), {
        ref: ref,
        xcss: $03998ae46f52ac58$var$styles.root,
        testId: testId,
        children: children
    });
});

});

parcelRegister("9Cyj3", function(module, exports) {
$parcel$export(module.exports, "SpotlightCard", () => $7cbe88303e83a7dc$export$14710e13fc01d383);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $llCao = parcelRequire("llCao");

var $kLoxN = parcelRequire("kLoxN");

var $5uKvy = parcelRequire("5uKvy");
const $7cbe88303e83a7dc$export$14710e13fc01d383 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ children: children, placement: placement, testId: testId }, ref)=>(0, $llCao.fg)('platform-dst-top-layer-spotlight') ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $5uKvy.SpotlightCard), {
        ref: ref,
        placement: placement,
        testId: testId,
        children: children
    }) : /*#__PURE__*/ (0, $5chsV.jsx)((0, $kLoxN.SpotlightCard), {
        ref: ref,
        placement: placement,
        testId: testId,
        children: children
    }));

});
parcelRegister("kLoxN", function(module, exports) {
$parcel$export(module.exports, "SpotlightCard", () => $69223b7314e2542b$export$14710e13fc01d383);
/* legacy.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $dwUnm = parcelRequire("dwUnm");

var $llCao = parcelRequire("llCao");

var $jRYjy = parcelRequire("jRYjy");

var $4Uu5R = parcelRequire("4Uu5R");

var $g2fjC = parcelRequire("g2fjC");
const $69223b7314e2542b$var$styles = {
    root: "_39xV02E6Kk",
    container: "_1mT5xdRAKS",
    card: "_0bjKvD8fU6 _2mHwu82ADO _1mT5xdWVPG _39xV02T1Vg _46hvQm2ADO _0xmtko8HPE _3iDTPbQ4SZ _0aFT5vbt8w _2OUyjtFYNq"
};
const $69223b7314e2542b$var$placementStyles = {
    'top-start': "_1ZB6UygVvo _1OKFqYYfXA",
    'top-center': "_1ZB6UygVvo _3iC0zdHCju",
    'top-end': "_1ZB6UygVvo _3iC0zdYfXA",
    'right-start': "_3iC0zdgVvo _1ZB6UyUgYP",
    'right-end': "_3iC0zdgVvo _2I62gzUgYP",
    'bottom-start': "_2I62gzgVvo _1OKFqYYfXA",
    'bottom-center': "_2I62gzgVvo _3iC0zdHCju",
    'bottom-end': "_2I62gzgVvo _3iC0zdYfXA",
    'left-start': "_1OKFqYgVvo _1ZB6UyUgYP",
    'left-end': "_1OKFqYgVvo _2I62gzUgYP"
};
const $69223b7314e2542b$export$14710e13fc01d383 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ children: children, placement: placement, testId: testId }, ref)=>{
    const { card: card } = (0, $fsvuC.useContext)((0, $4Uu5R.SpotlightContext));
    const cardRef = (0, $fsvuC.useRef)(null);
    (0, $fsvuC.useEffect)(()=>{
        card.setRef(cardRef);
    }, [
        card
    ]);
    const content = (0, $llCao.fg)('platform_spotlight_card_fit_content_anchor') ? /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        "data-testid": testId,
        ref: ref,
        className: (0, $gJ6nT.default)([
            $69223b7314e2542b$var$styles.root
        ]),
        children: /*#__PURE__*/ (0, $5chsV.jsxs)("div", {
            className: (0, $gJ6nT.default)([
                $69223b7314e2542b$var$styles.container
            ]),
            children: [
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $g2fjC.Caret), {
                    placement: placement || card.placement
                }),
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $jRYjy.Box), {
                    ref: cardRef,
                    backgroundColor: "color.background.neutral.bold",
                    xcss: (0, $dwUnm.cx)($69223b7314e2542b$var$styles.card, $69223b7314e2542b$var$placementStyles[placement || card.placement]),
                    children: children
                })
            ]
        })
    }) : /*#__PURE__*/ (0, $5chsV.jsxs)("div", {
        "data-testid": testId,
        ref: ref,
        className: (0, $gJ6nT.default)([
            $69223b7314e2542b$var$styles.container
        ]),
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $g2fjC.Caret), {
                placement: placement || card.placement
            }),
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $jRYjy.Box), {
                ref: cardRef,
                backgroundColor: "color.background.neutral.bold",
                xcss: (0, $dwUnm.cx)($69223b7314e2542b$var$styles.card, $69223b7314e2542b$var$placementStyles[placement || card.placement]),
                children: children
            })
        ]
    });
    if ((0, $llCao.fg)('platform-dst-motion-uplift-spotlight')) {
        const Motion = card.motion;
        if (Motion) return /*#__PURE__*/ (0, $5chsV.jsx)(Motion, {
            children: content
        });
        else return content;
    }
    return content;
});

});
parcelRegister("g2fjC", function(module, exports) {
$parcel$export(module.exports, "Caret", () => $61165f6fd74c1a49$export$88fca06e22f21720);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $llCao = parcelRequire("llCao");

var $geavH = parcelRequire("geavH");

var $3YFT0 = parcelRequire("3YFT0");
const $61165f6fd74c1a49$export$88fca06e22f21720 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ placement: placement, testId: testId }, ref)=>{
    return (0, $llCao.fg)('platform-dst-top-layer-spotlight') ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $3YFT0.Caret), {
        ref: ref,
        placement: placement,
        testId: testId
    }) : /*#__PURE__*/ (0, $5chsV.jsx)((0, $geavH.Caret), {
        ref: ref,
        placement: placement,
        testId: testId
    });
});

});
parcelRegister("geavH", function(module, exports) {
$parcel$export(module.exports, "Caret", () => $febbf2629a3b559f$export$88fca06e22f21720);
/* legacy.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $4Uu5R = parcelRequire("4Uu5R");
const $febbf2629a3b559f$var$styles = {
    root: "_0KLXrugozt _1uo2Zf1cEy _0jFU0V2sAl _1mT5xdRAKS _39xV022sAl _42Yu6BkKjW",
    'top-start': "_1VJPcaMZzS",
    'top-center': "_1VJPcaMZzS",
    'top-end': "_1VJPcaMZzS",
    'bottom-start': "_1VJPcacqvQ",
    'bottom-center': "_1VJPcacqvQ",
    'bottom-end': "_1VJPcacqvQ",
    'right-start': "_1VJPcaEFNz",
    'right-end': "_1VJPcaEFNz",
    'left-start': "_1VJPcaEoIx",
    'left-end': "_1VJPcaEoIx"
};
const $febbf2629a3b559f$export$88fca06e22f21720 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ placement: placement, testId: testId }, ref)=>{
    const { card: card } = (0, $fsvuC.useContext)((0, $4Uu5R.SpotlightContext));
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        "data-testid": testId,
        ref: ref,
        // Growth Pattern Library designs dictate 1px radius. cssMap only allows tokens
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            borderEndStartRadius: '1px'
        },
        className: (0, $gJ6nT.default)([
            $febbf2629a3b559f$var$styles.root,
            $febbf2629a3b559f$var$styles[placement || card.placement]
        ])
    });
});

});

parcelRegister("3YFT0", function(module, exports) {
$parcel$export(module.exports, "Caret", () => $b12ff2ae32f1f520$export$88fca06e22f21720);
/* top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $4Uu5R = parcelRequire("4Uu5R");

var $2aAme = parcelRequire("2aAme");
const $b12ff2ae32f1f520$var$styles = {
    root: "_0KLXrugozt _1uo2Zf1cEy _0jFU0V2sAl _1mT5xdWVPG _39xV022sAl",
    'start span-start': "_1ZB6UyPgdg _1OKFqYkG2W _1VJPcaMZzS",
    'block-start': "_1ZB6UyPgdg _3iC0zdgHOl _1VJPcaMZzS",
    'start span-end': "_1ZB6UyPgdg _3iC0zdv3tX _1VJPcaMZzS",
    'span-start end': "_3iC0zdPgdg _1ZB6UyEbN9 _1VJPcaEFNz",
    'span-end end': "_3iC0zdPgdg _2I62gzXCiO _1VJPcaEFNz",
    'span-start start': "_1OKFqYPgdg _1ZB6UyEbN9 _1VJPcaEoIx",
    'span-end start': "_1OKFqYPgdg _2I62gzXCiO _1VJPcaEoIx",
    'end span-start': "_2I62gzPgdg _1OKFqYSPN1 _1VJPcacqvQ",
    'block-end': "_2I62gzPgdg _3iC0zdgHOl _1VJPcacqvQ",
    'end span-end': "_2I62gzPgdg _3iC0zdv3tX _1VJPcacqvQ"
};
const $b12ff2ae32f1f520$export$88fca06e22f21720 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ placement: placement, testId: testId }, ref)=>{
    const { card: card, popoverContent: popoverContent } = (0, $fsvuC.useContext)((0, $4Uu5R.SpotlightContext));
    const positionArea = (0, $2aAme.getResolvedPositionArea)(placement || card.placement, popoverContent.positionArea);
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        "data-testid": testId,
        ref: ref,
        // Growth Pattern Library designs dictate 1px radius. cssMap only allows tokens
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            borderEndStartRadius: '1px'
        },
        className: (0, $gJ6nT.default)([
            $b12ff2ae32f1f520$var$styles.root,
            $b12ff2ae32f1f520$var$styles[positionArea]
        ])
    });
});

});
parcelRegister("2aAme", function(module, exports) {
$parcel$export(module.exports, "getResolvedPositionArea", () => $1ba44d7a84391af0$export$3aecfab3bd204999);
const $1ba44d7a84391af0$var$caretPositionMap = {
    'top-start': 'start span-start',
    'top-center': 'block-start',
    'top-end': 'start span-end',
    'left-start': 'span-start start',
    'right-start': 'span-start end',
    'left-end': 'span-end start',
    'right-end': 'span-end end',
    'bottom-start': 'end span-start',
    'bottom-center': 'block-end',
    'bottom-end': 'end span-end'
};
const $1ba44d7a84391af0$export$3aecfab3bd204999 = (placement, positionArea)=>{
    if (!positionArea || positionArea === 'none') return $1ba44d7a84391af0$var$caretPositionMap[placement];
    return positionArea;
};

});




parcelRegister("5uKvy", function(module, exports) {
$parcel$export(module.exports, "SpotlightCard", () => $33052c4c8c64890f$export$14710e13fc01d383);
/* top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $llCao = parcelRequire("llCao");

var $jRYjy = parcelRequire("jRYjy");

var $4Uu5R = parcelRequire("4Uu5R");

var $2aAme = parcelRequire("2aAme");

var $g2fjC = parcelRequire("g2fjC");
const $33052c4c8c64890f$var$styles = {
    root: "_1mT5xdRAKS _39xV02E6Kk",
    card: "_0bjKvD8fU6 _2mHwu82ADO _39xV02T1Vg _46hvQm2ADO _0xmtko8HPE _3iDTPbQ4SZ _0aFT5vbt8w _2OUyjtFYNq",
    'start span-start': "_0xmtkogVvo",
    'block-start': "_0xmtkogVvo",
    'start span-end': "_0xmtkogVvo",
    'end span-start': "_46hvQmgVvo",
    'block-end': "_46hvQmgVvo",
    'end span-end': "_46hvQmgVvo",
    'span-start end': "_0LQT5EgVvo",
    'span-end end': "_0LQT5EgVvo",
    'span-start start': "_03SyCPgVvo",
    'span-end start': "_03SyCPgVvo"
};
const $33052c4c8c64890f$export$14710e13fc01d383 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ children: children, placement: placement, testId: testId }, ref)=>{
    const { card: card, popoverContent: popoverContent } = (0, $fsvuC.useContext)((0, $4Uu5R.SpotlightContext));
    const cardRef = (0, $fsvuC.useRef)(null);
    const positionArea = (0, $2aAme.getResolvedPositionArea)(placement || card.placement, popoverContent.positionArea);
    (0, $fsvuC.useEffect)(()=>{
        card.setRef(cardRef);
    }, [
        card
    ]);
    const content = /*#__PURE__*/ (0, $5chsV.jsxs)("div", {
        "data-testid": testId,
        ref: ref,
        className: (0, $gJ6nT.default)([
            $33052c4c8c64890f$var$styles.root,
            $33052c4c8c64890f$var$styles[positionArea]
        ]),
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $g2fjC.Caret), {
                placement: placement
            }),
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $jRYjy.Box), {
                ref: cardRef,
                backgroundColor: "color.background.neutral.bold",
                xcss: $33052c4c8c64890f$var$styles.card,
                children: children
            })
        ]
    });
    if ((0, $llCao.fg)('platform-dst-motion-uplift-spotlight')) {
        const Motion = card.motion;
        if (Motion) return /*#__PURE__*/ (0, $5chsV.jsx)(Motion, {
            children: content
        });
    }
    return content;
});

});


parcelRegister("3NMdW", function(module, exports) {
$parcel$export(module.exports, "SpotlightControls", () => $c7fbeaa36000daf2$export$67fb68d4ebe55a86);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");
const $c7fbeaa36000daf2$var$styles = {
    root: "_2mHwu82ADO _3iDTPbQ4SZ _0aFT5vf5Xk"
};
const $c7fbeaa36000daf2$export$67fb68d4ebe55a86 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ testId: testId, children: children }, ref)=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        "data-testid": testId,
        ref: ref,
        role: "group",
        className: (0, $gJ6nT.default)([
            $c7fbeaa36000daf2$var$styles.root
        ]),
        children: children
    });
});

});

parcelRegister("e9bDS", function(module, exports) {
$parcel$export(module.exports, "SpotlightDismissControl", () => $0435bbbd07ff43ae$export$4eef19754b0d485e);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $dwUnm = parcelRequire("dwUnm");

var $irYrv = parcelRequire("irYrv");

var $3OsKS = parcelRequire("3OsKS");

var $4Uu5R = parcelRequire("4Uu5R");
const $0435bbbd07ff43ae$var$styles = {
    root: "_0bjKvDKTcp _4c065UgVvo _1UtDYze5R3 _0KLXrugozt _1eOmH6kTlo _3gzVzLVbka"
};
const $0435bbbd07ff43ae$export$4eef19754b0d485e = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ autoFocus: autoFocus = true, onClick: onClick, testId: testId }, ref)=>{
    const { popoverContent: popoverContent } = (0, $fsvuC.useContext)((0, $4Uu5R.SpotlightContext));
    const dismiss = (event)=>{
        popoverContent.dismiss.current(event);
    };
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $3OsKS.Pressable), {
        autoFocus: autoFocus,
        onClick: onClick || dismiss,
        ref: ref,
        testId: testId,
        xcss: (0, $dwUnm.cx)($0435bbbd07ff43ae$var$styles.root),
        "aria-label": "Dismiss",
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($irYrv))), {
            label: "Close"
        })
    });
});

});

parcelRegister("6k44y", function(module, exports) {
$parcel$export(module.exports, "SpotlightFooter", () => $657a68e33e0958ef$export$f76dbc85ba76ccc2);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $jR7Rq = parcelRequire("jR7Rq");
const $657a68e33e0958ef$var$styles = {
    root: "_0LQT5E5zaO _03SyCP8HPE _39xV02N91d"
};
const $657a68e33e0958ef$export$f76dbc85ba76ccc2 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $jR7Rq.Flex), {
        ref: ref,
        testId: testId,
        xcss: $657a68e33e0958ef$var$styles.root,
        alignItems: "center",
        justifyContent: "space-between",
        children: children
    });
});

});

parcelRegister("jZ2NQ", function(module, exports) {
$parcel$export(module.exports, "SpotlightHeader", () => $28076445c6e3bb0a$export$d646029b3ba8ab76);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $jR7Rq = parcelRequire("jR7Rq");
const $28076445c6e3bb0a$var$styles = {
    root: "_0LQT5E5zaO _03SyCP8HPE"
};
const $28076445c6e3bb0a$export$d646029b3ba8ab76 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $jR7Rq.Flex), {
        ref: ref,
        testId: testId,
        xcss: $28076445c6e3bb0a$var$styles.root,
        alignItems: "center",
        justifyContent: "space-between",
        gap: "space.100",
        children: children
    });
});

});

parcelRegister("4iMK3", function(module, exports) {
$parcel$export(module.exports, "SpotlightHeadline", () => $64b31e290b30db02$export$b57275b1b6b9863b);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $lgvAm = parcelRequire("lgvAm");

var $4Uu5R = parcelRequire("4Uu5R");
const $64b31e290b30db02$export$b57275b1b6b9863b = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ children: children, testId: testId }, ref)=>{
    const { heading: heading } = (0, $fsvuC.useContext)((0, $4Uu5R.SpotlightContext));
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $lgvAm.default), {
        id: heading.id,
        ref: ref,
        testId: testId,
        size: "xsmall",
        children: children
    });
});

});

parcelRegister("kpS32", function(module, exports) {
$parcel$export(module.exports, "SpotlightMedia", () => $b004fca63aa85c79$export$cf33151c3f01cd9a);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $jRYjy = parcelRequire("jRYjy");
const $b004fca63aa85c79$var$styles = {
    root: "_4bt5LAnQyn _2WAcuGnQyn _39xV02T1Vg _0jFU0V13wc"
};
const $b004fca63aa85c79$export$cf33151c3f01cd9a = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $jRYjy.Box), {
        ref: ref,
        xcss: $b004fca63aa85c79$var$styles.root,
        testId: testId,
        children: children
    });
});

});

parcelRegister("TLRFC", function(module, exports) {
$parcel$export(module.exports, "PopoverProvider", () => $274eb8340763f6ce$export$bf694c7c431c162a);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $llCao = parcelRequire("llCao");

var $96lzO = parcelRequire("96lzO");

var $frA9K = parcelRequire("frA9K");
const $274eb8340763f6ce$export$bf694c7c431c162a = ({ children: children })=>(0, $llCao.fg)('platform-dst-top-layer-spotlight') ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $frA9K.PopoverProvider), {
        children: children
    }) : /*#__PURE__*/ (0, $5chsV.jsx)((0, $96lzO.PopoverProvider), {
        children: children
    });
$274eb8340763f6ce$export$bf694c7c431c162a.displayName = "PopoverProvider";

});
parcelRegister("96lzO", function(module, exports) {
$parcel$export(module.exports, "PopoverProvider", () => $7749601b4b1dc065$export$bf694c7c431c162a);
/* legacy.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $1ihvq = parcelRequire("1ihvq");

var $4Uu5R = parcelRequire("4Uu5R");
const $7749601b4b1dc065$export$bf694c7c431c162a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $4Uu5R.SpotlightContextProvider), {
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $1ihvq.Manager), {
            children: children
        })
    });
};
$7749601b4b1dc065$export$bf694c7c431c162a.displayName = "PopoverProvider";

});

parcelRegister("frA9K", function(module, exports) {
$parcel$export(module.exports, "PopoverProvider", () => $19f947e557e1ab04$export$bf694c7c431c162a);
/* top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $4Uu5R = parcelRequire("4Uu5R");
const $19f947e557e1ab04$export$bf694c7c431c162a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $4Uu5R.SpotlightContextProvider), {
        children: children
    });
};
$19f947e557e1ab04$export$bf694c7c431c162a.displayName = "PopoverProvider";

});


parcelRegister("35rMO", function(module, exports) {
$parcel$export(module.exports, "PopoverTarget", () => $f302eae86a91bf6d$export$5ad0c0856b469f13);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $llCao = parcelRequire("llCao");

var $gXE1A = parcelRequire("gXE1A");

var $6aGRI = parcelRequire("6aGRI");
const $f302eae86a91bf6d$export$5ad0c0856b469f13 = ({ children: children })=>(0, $llCao.fg)('platform-dst-top-layer-spotlight') ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $6aGRI.PopoverTarget), {
        children: children
    }) : /*#__PURE__*/ (0, $5chsV.jsx)((0, $gXE1A.PopoverTarget), {
        children: children
    });
$f302eae86a91bf6d$export$5ad0c0856b469f13.displayName = "PopoverTarget";

});
parcelRegister("gXE1A", function(module, exports) {
$parcel$export(module.exports, "PopoverTarget", () => $0a4fbbf64d21bbd4$export$5ad0c0856b469f13);
/* legacy.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $fD9oc = parcelRequire("fD9oc");
const $0a4fbbf64d21bbd4$export$5ad0c0856b469f13 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $fD9oc.Reference), {
        children: ({ ref: ref })=>/*#__PURE__*/ (0, $5chsV.jsx)("div", {
                ref: ref,
                children: children
            })
    });
};
$0a4fbbf64d21bbd4$export$5ad0c0856b469f13.displayName = "PopoverTarget";

});

parcelRegister("6aGRI", function(module, exports) {
$parcel$export(module.exports, "PopoverTarget", () => $ceedcb86d3576ff5$export$5ad0c0856b469f13);
/* top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $4Uu5R = parcelRequire("4Uu5R");
const $ceedcb86d3576ff5$export$5ad0c0856b469f13 = ({ children: children })=>{
    const localRef = (0, $fsvuC.useRef)(null);
    const { target: target } = (0, $fsvuC.useContext)((0, $4Uu5R.SpotlightContext));
    (0, $fsvuC.useLayoutEffect)(()=>{
        target.setRef(localRef);
    }, [
        target
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        ref: localRef,
        children: children
    });
};
$ceedcb86d3576ff5$export$5ad0c0856b469f13.displayName = "PopoverTarget";

});


parcelRegister("sAY9X", function(module, exports) {
$parcel$export(module.exports, "SpotlightPrimaryAction", () => $d360ede83796ba02$export$eea27caf91a85655);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $dwUnm = parcelRequire("dwUnm");

var $3OsKS = parcelRequire("3OsKS");

var $daZXj = parcelRequire("daZXj");

var $4Uu5R = parcelRequire("4Uu5R");
const $d360ede83796ba02$var$styles = {
    root: "_0bjKvDKxmn _1UtDYze5R3",
    outline: "_3hxITi6wH8 _2V7sgONvrM _3vBAKHFIvx _0KLXrugozt _1eOmH6kTlo _3gzVzLVbka",
    primary: "_3hxITi6wH8 _2V7sgONvrM _3vBAKHJrlu _0KLXruDM2k _1eOmH6hmrj _3gzVzLczkD"
};
const $d360ede83796ba02$export$eea27caf91a85655 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ 'aria-label': ariaLabel, onClick: onClick, children: children, appearance: appearance = 'outline', testId: testId }, ref)=>{
    const { primaryAction: primaryAction } = (0, $fsvuC.useContext)((0, $4Uu5R.SpotlightContext));
    const done = (event)=>{
        primaryAction.action.current(event);
    };
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $3OsKS.Pressable), {
        "aria-label": ariaLabel,
        ref: ref,
        testId: testId,
        xcss: (0, $dwUnm.cx)($d360ede83796ba02$var$styles.root, $d360ede83796ba02$var$styles[appearance]),
        onClick: onClick || done,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $daZXj.Text), {
            as: "span",
            children: children
        })
    });
});

});

parcelRegister("1rHDk", function(module, exports) {
$parcel$export(module.exports, "SpotlightSecondaryAction", () => $f312d4c56fc17e62$export$869dfff69399fe87);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $3OsKS = parcelRequire("3OsKS");

var $daZXj = parcelRequire("daZXj");

var $4Uu5R = parcelRequire("4Uu5R");
const $f312d4c56fc17e62$var$styles = {
    rootMotion: "_0bjKvDKxmn _23rrnHyKLB _1UtDYze5R3 _0KLXrugozt _1eOmH6kTlo _3sFUREiSCN _3gzVzLVbka"
};
const $f312d4c56fc17e62$export$869dfff69399fe87 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ 'aria-label': ariaLabel, onClick: onClick, children: children, testId: testId }, ref)=>{
    const { secondaryAction: secondaryAction } = (0, $fsvuC.useContext)((0, $4Uu5R.SpotlightContext));
    const back = (event)=>{
        secondaryAction.action.current(event);
    };
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $3OsKS.Pressable), {
        "aria-label": ariaLabel,
        ref: ref,
        testId: testId,
        xcss: $f312d4c56fc17e62$var$styles.rootMotion,
        onClick: onClick || back,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $daZXj.Text), {
            as: "span",
            children: children
        })
    });
});

});

parcelRegister("5SxcE", function(module, exports) {
$parcel$export(module.exports, "SpotlightStepCount", () => $3f2897a04b1c9e39$export$f4d9def8bfebca);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $jR7Rq = parcelRequire("jR7Rq");

var $daZXj = parcelRequire("daZXj");

var $8e1dR = parcelRequire("8e1dR");
const $3f2897a04b1c9e39$var$styles = {
    root: "_4ouGXIW9qI"
};
const $3f2897a04b1c9e39$export$f4d9def8bfebca = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $jR7Rq.Flex), {
        xcss: $3f2897a04b1c9e39$var$styles.root,
        children: /*#__PURE__*/ (0, $5chsV.jsxs)((0, $daZXj.Text), {
            ref: ref,
            testId: testId,
            children: [
                children,
                " ",
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $8e1dR.default), {
                    children: "steps"
                })
            ]
        })
    });
});

});

parcelRegister("a5Zx6", function(module, exports) {
$parcel$export(module.exports, "default", () => $9090b8b709f6f7d4$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $llCao = parcelRequire("llCao");

var $1tV3l = parcelRequire("1tV3l");

var $gY8Aw = parcelRequire("gY8Aw");
/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 *
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ const $9090b8b709f6f7d4$var$SpotlightTarget = ({ children: children, name: name })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $gY8Aw.TargetConsumer), {
        children: (getTargetRef)=>{
            if (typeof children === 'function') return children({
                targetRef: getTargetRef?.(name)
            });
            return getTargetRef ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $1tV3l.default), {
                name: name,
                hasNodeResolver: !(0, $llCao.fg)('platform_design_system_team_onboarding_noderesolve'),
                getTargetRef: getTargetRef,
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $5chsV.Fragment), {
                    children: children
                })
            }) : children;
        }
    });
$9090b8b709f6f7d4$var$SpotlightTarget.displayName = "SpotlightTarget";
$9090b8b709f6f7d4$var$SpotlightTarget.displayName = 'SpotlightTarget';
var $9090b8b709f6f7d4$export$2e2bcd8739ae039 = $9090b8b709f6f7d4$var$SpotlightTarget;

});
parcelRegister("1tV3l", function(module, exports) {
$parcel$export(module.exports, "default", () => $b9c7254f09f216fb$export$2e2bcd8739ae039);
/* node-resolver-spotlight-target.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $knrfi = parcelRequire("knrfi");
const $b9c7254f09f216fb$var$spanStyles = null;
/**
 * A wrapper component that conditionally applies a NodeResolver to its children.
 *
 * Note: NodeResolver should not be used in React 18 concurrent mode. This component
 * is intended to be removed once the feature flag  is removed.
 * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
 * @param {ReactElement} props.children - The child elements to be wrapped.
 * @param {string} props.name - The name to reference from Spotlight.
 * @param {ReactElement} props.getTargetRef - Setting up Target Node in Spotlight Manager.
 * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
 */ const $b9c7254f09f216fb$var$NodeResolverSpotlightTarget = ({ hasNodeResolver: hasNodeResolver, children: children, getTargetRef: getTargetRef, name: name })=>{
    const divRef = (0, $fsvuC.useRef)(null);
    (0, $fsvuC.useEffect)(()=>{
        const targetRef = getTargetRef(name);
        if (!hasNodeResolver) targetRef(divRef.current?.firstElementChild);
        return ()=>{
            !hasNodeResolver && targetRef(undefined);
        };
    }, [
        hasNodeResolver,
        name,
        getTargetRef
    ]);
    if (hasNodeResolver) return /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($knrfi))), {
        innerRef: getTargetRef(name),
        children: children
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)("span", {
        ref: divRef,
        className: (0, $gJ6nT.default)([
            "_3iDTPbcK7c"
        ]),
        children: children
    });
};
$b9c7254f09f216fb$var$NodeResolverSpotlightTarget.displayName = "NodeResolverSpotlightTarget";
$b9c7254f09f216fb$var$NodeResolverSpotlightTarget.displayName = 'NodeResolverSpotlightTarget';
var $b9c7254f09f216fb$export$2e2bcd8739ae039 = $b9c7254f09f216fb$var$NodeResolverSpotlightTarget;

});


parcelRegister("gP7u8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "Box", () => $4233dc5a8a92b3ce$export$e71c4d32a2263218);
$parcel$export(module.exports, "default", () => $4233dc5a8a92b3ce$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fsvuC = parcelRequire("fsvuC");

var $h2YWL = parcelRequire("h2YWL");

var $ewzCi = parcelRequire("ewzCi");

var $27lhO = parcelRequire("27lhO");

var $4hbQp = parcelRequire("4hbQp");

var $dosU1 = parcelRequire("dosU1");

var $9TNvK = parcelRequire("9TNvK");

var $h6lnG = parcelRequire("h6lnG");
function $4233dc5a8a92b3ce$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4233dc5a8a92b3ce$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $9TNvK.parseXcss)(xcss);
    const node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    /*#__PURE__*/ (0, $h2YWL.jsx)(Component, {
        style: style,
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        css: [
            $4233dc5a8a92b3ce$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $27lhO.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $4hbQp.isSurfaceColorToken)(backgroundColor) && (0, $h6lnG.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $dosU1.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $dosU1.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $dosU1.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $dosU1.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $dosU1.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $dosU1.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $dosU1.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }, children);
    return backgroundColor ? /*#__PURE__*/ (0, $h2YWL.jsx)((0, $ewzCi.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$4233dc5a8a92b3ce$export$2e2bcd8739ae039 = $4233dc5a8a92b3ce$export$e71c4d32a2263218;
const $4233dc5a8a92b3ce$var$baseStyles = {
    name: "1b8qmvl",
    styles: "box-sizing:border-box;appearance:none;border:none"
};

});
parcelRegister("27lhO", function(module, exports) {
$parcel$export(module.exports, "backgroundColorStylesMap", () => $93455ccf0001ae76$export$e7af83bafe7f9e63);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $7HP7E = parcelRequire("7HP7E");

var $iOD0p = parcelRequire("iOD0p");
const $93455ccf0001ae76$export$e7af83bafe7f9e63 = (0, $iOD0p.getSerializedStylesMap)('backgroundColor', (0, $7HP7E.backgroundColorMap));

});
parcelRegister("7HP7E", function(module, exports) {
$parcel$export(module.exports, "backgroundColorMap", () => $4c1775a1ad4b7300$export$d1d79bf68ac056bd);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b9ffd6dcccead720baadbffd4a1648a>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $4c1775a1ad4b7300$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #BDE97C)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #BDE97C)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #3F5224)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FFECEB)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FFD5D2)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #F87168)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FD9891)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FFB8B2)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #C9372C)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #872821)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FBD779)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #FBD779)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #FCA700)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #FBC828)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #FBD779)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #BD5B00)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #7A3B00)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #F5E989)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #EED12B)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #EFDD4E)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #946F00)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #614A05)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #97EDC9)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #BAF3DB)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #97EDC9)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #4BCE97)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #7EE2B8)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #97EDC9)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #1F845A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #19573D)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #B1E4F7)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #9DD9EE)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #B1E4F7)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #227D9B)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #1A5265)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #669DF1)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #8FB8F6)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #ADCBFB)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #1868DB)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #144794)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #EED7FC)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #C97CF4)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #D8A0F7)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #E3BDFA)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #964AC0)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #673286)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FCB6E1)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #77325B)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #8C8F97)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #8C8F97)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #DDDEE1)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #6B6E76)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
    'color.background.code.added.highlight': "var(--ds-background-code-added-highlight, #DCFFF1)",
    'color.background.code.added.line': "var(--ds-background-code-added-line, #BAF3DB66)",
    'color.background.code.default': "var(--ds-background-code-default, #FFFFFF)",
    'color.background.code.gutter': "var(--ds-background-code-gutter, #F0F1F2)",
    'color.background.code.highlight': "var(--ds-background-code-highlight, #F0F1F2)",
    'color.background.code.removed.highlight': "var(--ds-background-code-removed-highlight, #FFECEB)",
    'color.background.code.removed.line': "var(--ds-background-code-removed-line, #FFD5D266)",
    'color.background.disabled': "var(--ds-background-disabled, #0515240F)",
    'color.background.input': "var(--ds-background-input, #FFFFFF)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #F8F8F8)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #0515240F)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #0B120E24)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #080F214A)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, #00000000)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #292A2E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #3B3D42)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #505258)",
    'color.background.selected': "var(--ds-background-selected, #E9F2FE)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #CFE1FD)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #8FB8F6)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #1868DB)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #1558BC)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #123263)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #E9F2FE)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #CFE1FD)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #ADCBFB)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #1868DB)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #1558BC)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #144794)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #1C2B42)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #123263)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #144794)",
    'color.background.danger': "var(--ds-background-danger, #FFECEB)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFD5D2)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FFB8B2)",
    'color.background.danger.subtler': "var(--ds-background-danger-subtler, #FFD5D2)",
    'color.background.danger.subtler.hovered': "var(--ds-background-danger-subtler-hovered, #FFB8B2)",
    'color.background.danger.subtler.pressed': "var(--ds-background-danger-subtler-pressed, #FD9891)",
    'color.background.danger.subtle': "var(--ds-background-danger-subtle, #FD9891)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #C9372C)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #AE2E24)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #872821)",
    'color.background.warning': "var(--ds-background-warning, #FFF5DB)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FCE4A6)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FBD779)",
    'color.background.warning.subtler': "var(--ds-background-warning-subtler, #FCE4A6)",
    'color.background.warning.subtler.hovered': "var(--ds-background-warning-subtler-hovered, #FBD779)",
    'color.background.warning.subtler.pressed': "var(--ds-background-warning-subtler-pressed, #FBC828)",
    'color.background.warning.subtle': "var(--ds-background-warning-subtle, #FBD779)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FBC828)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FCA700)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #F68909)",
    'color.background.success': "var(--ds-background-success, #EFFFD6)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #D3F1A7)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #BDE97C)",
    'color.background.success.subtler': "var(--ds-background-success-subtler, #D3F1A7)",
    'color.background.success.subtler.hovered': "var(--ds-background-success-subtler-hovered, #BDE97C)",
    'color.background.success.subtler.pressed': "var(--ds-background-success-subtler-pressed, #B3DF72)",
    'color.background.success.subtle': "var(--ds-background-success-subtle, #B3DF72)",
    'color.background.success.bold': "var(--ds-background-success-bold, #5B7F24)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #4C6B1F)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #3F5224)",
    'color.background.discovery': "var(--ds-background-discovery, #F8EEFE)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #EED7FC)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #E3BDFA)",
    'color.background.discovery.subtler': "var(--ds-background-discovery-subtler, #EED7FC)",
    'color.background.discovery.subtler.hovered': "var(--ds-background-discovery-subtler-hovered, #E3BDFA)",
    'color.background.discovery.subtler.pressed': "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'color.background.discovery.subtle': "var(--ds-background-discovery-subtle, #D8A0F7)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #964AC0)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #803FA5)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #673286)",
    'color.background.information': "var(--ds-background-information, #E9F2FE)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #CFE1FD)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #ADCBFB)",
    'color.background.information.subtler': "var(--ds-background-information-subtler, #CFE1FD)",
    'color.background.information.subtler.hovered': "var(--ds-background-information-subtler-hovered, #ADCBFB)",
    'color.background.information.subtler.pressed': "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    'color.background.information.subtle': "var(--ds-background-information-subtle, #8FB8F6)",
    'color.background.information.bold': "var(--ds-background-information-bold, #1868DB)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #1558BC)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #144794)",
    'color.skeleton': "var(--ds-skeleton, #0515240F)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #17171708)",
    'color.blanket': "var(--ds-blanket, #050C1F75)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.rovo.background.brand.bold': "var(--ds-rovo-background-brand-bold, #000000)",
    'color.rovo.background.brand.bold.hovered': "var(--ds-rovo-background-brand-bold-hovered, #1E1F21)",
    'color.rovo.background.brand.bold.pressed': "var(--ds-rovo-background-brand-bold-pressed, #292A2E)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.container': "var(--ds-surface-container, #17171708)",
    'elevation.surface.container.hovered': "var(--ds-surface-container-hovered, #0515240F)",
    'elevation.surface.container.pressed': "var(--ds-surface-container-pressed, #0B120E24)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};

});

parcelRegister("iOD0p", function(module, exports) {
$parcel$export(module.exports, "getSerializedStylesMap", () => $108f99986316a1ee$export$ca0f9c2de39ffed7);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $h2YWL = parcelRequire("h2YWL");
const $108f99986316a1ee$export$ca0f9c2de39ffed7 = (cssProperty, tokenMap)=>{
    return Object.keys(tokenMap).reduce((emotionSpacingMap, tokenName)=>{
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[tokenName] = /*#__PURE__*/ (0, $h2YWL.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            [cssProperty]: tokenMap[tokenName]
        });
        return emotionSpacingMap;
    }, {});
};

});


parcelRegister("4hbQp", function(module, exports) {
$parcel$export(module.exports, "isSurfaceColorToken", () => $64e21a551cd57b7d$export$5e65a44e5b6ecadb);

var $jzhZX = parcelRequire("jzhZX");
const $64e21a551cd57b7d$export$5e65a44e5b6ecadb = (color)=>(0, $jzhZX.surfaceColorMap)[color] !== undefined;

});
parcelRegister("jzhZX", function(module, exports) {
$parcel$export(module.exports, "surfaceColorMap", () => $83b0fe00cda93931$export$41a358c9c2356760);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6c124f7044e82421c90bec6e00efe281>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $83b0fe00cda93931$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.container': "var(--ds-surface-container, #17171708)",
    'elevation.surface.container.hovered': "var(--ds-surface-container-hovered, #0515240F)",
    'elevation.surface.container.pressed': "var(--ds-surface-container-pressed, #0B120E24)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)"
};

});


parcelRegister("dosU1", function(module, exports) {
$parcel$export(module.exports, "paddingStylesMap", () => $be0c442adad63227$export$e615f061ca585a6c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $df4zD = parcelRequire("df4zD");

var $lqjDQ = parcelRequire("lqjDQ");
const $be0c442adad63227$export$e615f061ca585a6c = (0, $df4zD.createSpacingStylesMap)((0, $lqjDQ.positiveSpaceMap), [
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd'
]);

});
parcelRegister("df4zD", function(module, exports) {
$parcel$export(module.exports, "createSpacingStylesMap", () => $5e091096a70d4d07$export$f2bee1f59203ac70);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $iOD0p = parcelRequire("iOD0p");
const $5e091096a70d4d07$var$spacingProperties = [
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'gap',
    'rowGap',
    'columnGap'
];
const $5e091096a70d4d07$export$f2bee1f59203ac70 = (tokenMap, properties)=>{
    return properties.reduce((styleMap, spacingProperty)=>{
        styleMap[spacingProperty] = (0, $iOD0p.getSerializedStylesMap)(spacingProperty, tokenMap);
        return styleMap;
    }, {});
};

});

parcelRegister("lqjDQ", function(module, exports) {
$parcel$export(module.exports, "positiveSpaceMap", () => $ac41ed299f2db967$export$958d0ae7f2977ae4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::530295593aa7866ac0aa775911222ebc>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-spacing.tsx <<SignedSource::d315a72fd47775e37868465c88b3ebfb>>
 */ const $ac41ed299f2db967$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};

});


parcelRegister("9TNvK", function(module, exports) {
$parcel$export(module.exports, "parseXcss", () => $ffcb16670692cfe2$export$a9c84988c8f81f2d);
/* parse-xcss.tsx generated by @compiled/babel-plugin v3.0.2 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
parcelRequire("fsvuC");

var $fpQNO = parcelRequire("fpQNO");
const $ffcb16670692cfe2$export$a9c84988c8f81f2d = (args)=>{
    if (Array.isArray(args)) {
        const emotion = [];
        const staticArr = [];
        for (const arg of args){
            const result = $ffcb16670692cfe2$export$a9c84988c8f81f2d(arg);
            if (result.emotion) emotion.push(...result.emotion);
            if (result.static) staticArr.push(result.static);
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    const objArgs = args;
    const { [(0, $fpQNO.uniqueSymbol)]: styles } = objArgs || {};
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        const stringifiedArgs = `${args}`;
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};

});
parcelRegister("fpQNO", function(module, exports) {
$parcel$export(module.exports, "uniqueSymbol", () => $c6c860e4951562d6$export$43e479c916cb4ada);
const $c6c860e4951562d6$export$43e479c916cb4ada = Symbol('UNSAFE_INTERNAL_styles');

});


parcelRegister("h6lnG", function(module, exports) {
$parcel$export(module.exports, "surfaceColorStylesMap", () => $75ba67f236cf8013$export$ff257d957d48c421);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $gCKKR = parcelRequire("gCKKR");

var $iOD0p = parcelRequire("iOD0p");

var $jzhZX = parcelRequire("jzhZX");
const $75ba67f236cf8013$export$ff257d957d48c421 = (0, $iOD0p.getSerializedStylesMap)((0, $gCKKR.CURRENT_SURFACE_CSS_VAR), (0, $jzhZX.surfaceColorMap));

});


parcelRegister("9orrx", function(module, exports) {
$parcel$export(module.exports, "xcss", () => $65e58d96cd772878$export$f6c783d06584602c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $h2YWL = parcelRequire("h2YWL");

var $4Xthn = parcelRequire("4Xthn");

var $fpQNO = parcelRequire("fpQNO");

var $hoalA = parcelRequire("hoalA");
const $65e58d96cd772878$var$isSafeEnvToThrow = ()=>typeof $hoalA === 'object' && typeof $hoalA.env === 'object' && false;
const $65e58d96cd772878$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
const $65e58d96cd772878$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
const $65e58d96cd772878$var$transformStyles = (styleObj)=>{
    if (!styleObj || typeof styleObj !== 'object') return styleObj;
     // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($65e58d96cd772878$var$transformStyles);
     // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(([key, value])=>{
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if (typeof value === 'object' && $65e58d96cd772878$var$safeSelectors.test(key)) {
            styleObj[key] = $65e58d96cd772878$var$transformStyles(value);
            return;
        }
        if ($65e58d96cd772878$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($65e58d96cd772878$var$reNestedSelectors.test(key)) throw new Error(`Styles not supported for key '${key}'.`);
        } // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in (0, $4Xthn.tokensMap))) return;
        const tokenValue = (0, $4Xthn.tokensMap)[key][value];
        styleObj[key] = tokenValue ?? value;
    });
    return styleObj;
};
const $65e58d96cd772878$var$baseXcss = (style)=>{
    const transformedStyles = $65e58d96cd772878$var$transformStyles(style);
    return {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [(0, $fpQNO.uniqueSymbol)]: /*#__PURE__*/ (0, $h2YWL.css)(transformedStyles)
    };
};
function $65e58d96cd772878$export$f6c783d06584602c(style) {
    return $65e58d96cd772878$var$baseXcss(style);
}

});
parcelRegister("4Xthn", function(module, exports) {
$parcel$export(module.exports, "tokensMap", () => $adf67bde377679e3$export$9a199fbafee0014e);

var $jeAuz = parcelRequire("jeAuz");

var $7HP7E = parcelRequire("7HP7E");

var $jcSR2 = parcelRequire("jcSR2");

var $9JtyS = parcelRequire("9JtyS");

var $h680d = parcelRequire("h680d");

var $vvSKZ = parcelRequire("vvSKZ");

var $jNY1w = parcelRequire("jNY1w");

var $79kuu = parcelRequire("79kuu");

var $gwmdW = parcelRequire("gwmdW");

var $aH2Pn = parcelRequire("aH2Pn");

var $1dZLz = parcelRequire("1dZLz");

var $iU7VK = parcelRequire("iU7VK");

var $lqjDQ = parcelRequire("lqjDQ");

var $20MXF = parcelRequire("20MXF");

var $5kqbx = parcelRequire("5kqbx");
const $adf67bde377679e3$export$9a199fbafee0014e = {
    backgroundColor: (0, $7HP7E.backgroundColorMap),
    blockSize: (0, $vvSKZ.dimensionMap),
    borderBlockColor: (0, $jcSR2.borderColorMap),
    borderBlockEndColor: (0, $jcSR2.borderColorMap),
    borderBlockEndWidth: (0, $h680d.borderWidthMap),
    borderBlockStartColor: (0, $jcSR2.borderColorMap),
    borderBlockStartWidth: (0, $h680d.borderWidthMap),
    borderBlockWidth: (0, $h680d.borderWidthMap),
    borderBottomColor: (0, $jcSR2.borderColorMap),
    borderBottomLeftRadius: (0, $9JtyS.borderRadiusMap),
    borderBottomRightRadius: (0, $9JtyS.borderRadiusMap),
    borderBottomWidth: (0, $h680d.borderWidthMap),
    borderColor: (0, $jcSR2.borderColorMap),
    borderEndEndRadius: (0, $9JtyS.borderRadiusMap),
    borderEndStartRadius: (0, $9JtyS.borderRadiusMap),
    borderInlineColor: (0, $jcSR2.borderColorMap),
    borderInlineEndColor: (0, $jcSR2.borderColorMap),
    borderInlineEndWidth: (0, $h680d.borderWidthMap),
    borderInlineStartColor: (0, $jcSR2.borderColorMap),
    borderInlineStartWidth: (0, $h680d.borderWidthMap),
    borderInlineWidth: (0, $h680d.borderWidthMap),
    borderLeftColor: (0, $jcSR2.borderColorMap),
    borderLeftWidth: (0, $h680d.borderWidthMap),
    borderRadius: (0, $9JtyS.borderRadiusMap),
    borderRightColor: (0, $jcSR2.borderColorMap),
    borderRightWidth: (0, $h680d.borderWidthMap),
    borderStartEndRadius: (0, $9JtyS.borderRadiusMap),
    borderStartStartRadius: (0, $9JtyS.borderRadiusMap),
    borderTopColor: (0, $jcSR2.borderColorMap),
    borderTopLeftRadius: (0, $9JtyS.borderRadiusMap),
    borderTopRightRadius: (0, $9JtyS.borderRadiusMap),
    borderTopWidth: (0, $h680d.borderWidthMap),
    borderWidth: (0, $h680d.borderWidthMap),
    bottom: (0, $jeAuz.allSpaceMap),
    boxShadow: (0, $20MXF.shadowMap),
    color: (0, $5kqbx.textColorMap),
    columnGap: (0, $aH2Pn.gapSpaceMap),
    font: (0, $jNY1w.fontMap),
    fontFamily: (0, $79kuu.fontFamilyMap),
    fontWeight: (0, $gwmdW.fontWeightMap),
    gap: (0, $aH2Pn.gapSpaceMap),
    height: (0, $vvSKZ.dimensionMap),
    inlineSize: (0, $vvSKZ.dimensionMap),
    inset: (0, $jeAuz.allSpaceMap),
    insetBlock: (0, $jeAuz.allSpaceMap),
    insetBlockEnd: (0, $jeAuz.allSpaceMap),
    insetBlockStart: (0, $jeAuz.allSpaceMap),
    insetInline: (0, $jeAuz.allSpaceMap),
    insetInlineEnd: (0, $jeAuz.allSpaceMap),
    insetInlineStart: (0, $jeAuz.allSpaceMap),
    left: (0, $jeAuz.allSpaceMap),
    margin: (0, $jeAuz.allSpaceMap),
    marginBlock: (0, $jeAuz.allSpaceMap),
    marginBlockEnd: (0, $jeAuz.allSpaceMap),
    marginBlockStart: (0, $jeAuz.allSpaceMap),
    marginBottom: (0, $jeAuz.allSpaceMap),
    marginInline: (0, $jeAuz.allSpaceMap),
    marginInlineEnd: (0, $jeAuz.allSpaceMap),
    marginInlineStart: (0, $jeAuz.allSpaceMap),
    marginLeft: (0, $jeAuz.allSpaceMap),
    marginRight: (0, $jeAuz.allSpaceMap),
    marginTop: (0, $jeAuz.allSpaceMap),
    maxBlockSize: (0, $vvSKZ.dimensionMap),
    maxHeight: (0, $vvSKZ.dimensionMap),
    maxInlineSize: (0, $vvSKZ.dimensionMap),
    maxWidth: (0, $vvSKZ.dimensionMap),
    minBlockSize: (0, $vvSKZ.dimensionMap),
    minHeight: (0, $vvSKZ.dimensionMap),
    minInlineSize: (0, $vvSKZ.dimensionMap),
    minWidth: (0, $vvSKZ.dimensionMap),
    opacity: (0, $iU7VK.opacityMap),
    outlineColor: (0, $jcSR2.borderColorMap),
    outlineOffset: (0, $jeAuz.allSpaceMap),
    outlineWidth: (0, $h680d.borderWidthMap),
    padding: (0, $lqjDQ.positiveSpaceMap),
    paddingBlock: (0, $lqjDQ.positiveSpaceMap),
    paddingBlockEnd: (0, $lqjDQ.positiveSpaceMap),
    paddingBlockStart: (0, $lqjDQ.positiveSpaceMap),
    paddingBottom: (0, $lqjDQ.positiveSpaceMap),
    paddingInline: (0, $lqjDQ.positiveSpaceMap),
    paddingInlineEnd: (0, $lqjDQ.positiveSpaceMap),
    paddingInlineStart: (0, $lqjDQ.positiveSpaceMap),
    paddingLeft: (0, $lqjDQ.positiveSpaceMap),
    paddingRight: (0, $lqjDQ.positiveSpaceMap),
    paddingTop: (0, $lqjDQ.positiveSpaceMap),
    right: (0, $jeAuz.allSpaceMap),
    rowGap: (0, $aH2Pn.gapSpaceMap),
    top: (0, $jeAuz.allSpaceMap),
    width: (0, $vvSKZ.dimensionMap),
    zIndex: (0, $1dZLz.layerMap)
};

});
parcelRegister("jeAuz", function(module, exports) {
$parcel$export(module.exports, "allSpaceMap", () => $643b82e5ad23295d$export$632685d741f3dbbf);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e7046dc26bdc5919611c94881a16cf5f>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-spacing.tsx <<SignedSource::d315a72fd47775e37868465c88b3ebfb>>
 */ const $643b82e5ad23295d$export$632685d741f3dbbf = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)",
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};

});

parcelRegister("jcSR2", function(module, exports) {
$parcel$export(module.exports, "borderColorMap", () => $71a2a32c7cd110c1$export$1531ad5bb3fbedac);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2852cd6e8656adbef1c6b8cb926235c9>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $71a2a32c7cd110c1$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #0B120E24)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.lime.subtle': "var(--ds-border-accent-lime-subtle, #B3DF72)",
    'color.border.accent.red': "var(--ds-border-accent-red, #E2483D)",
    'color.border.accent.red.subtle': "var(--ds-border-accent-red-subtle, #FD9891)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #E06C00)",
    'color.border.accent.orange.subtle': "var(--ds-border-accent-orange-subtle, #FBC828)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #B38600)",
    'color.border.accent.yellow.subtle': "var(--ds-border-accent-yellow-subtle, #EED12B)",
    'color.border.accent.green': "var(--ds-border-accent-green, #22A06B)",
    'color.border.accent.green.subtle': "var(--ds-border-accent-green-subtle, #7EE2B8)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #2898BD)",
    'color.border.accent.teal.subtle': "var(--ds-border-accent-teal-subtle, #9DD9EE)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #357DE8)",
    'color.border.accent.blue.subtle': "var(--ds-border-accent-blue-subtle, #8FB8F6)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #AF59E1)",
    'color.border.accent.purple.subtle': "var(--ds-border-accent-purple-subtle, #D8A0F7)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.magenta.subtle': "var(--ds-border-accent-magenta-subtle, #F797D2)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #7D818A)",
    'color.border.accent.gray.subtle': "var(--ds-border-accent-gray-subtle, #B7B9BE)",
    'color.border.code': "var(--ds-border-code, #0B120E24)",
    'color.border.disabled': "var(--ds-border-disabled, #0515240F)",
    'color.border.focused': "var(--ds-border-focused, #4688EC)",
    'color.border.input': "var(--ds-border-input, #8C8F97)",
    'color.border.input.search': "var(--ds-border-input-search, #0B120E24)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #1868DB)",
    'color.border.brand': "var(--ds-border-brand, #1868DB)",
    'color.border.danger': "var(--ds-border-danger, #E2483D)",
    'color.border.danger.subtle': "var(--ds-border-danger-subtle, #FD9891)",
    'color.border.warning': "var(--ds-border-warning, #E06C00)",
    'color.border.warning.subtle': "var(--ds-border-warning-subtle, #FBC828)",
    'color.border.success': "var(--ds-border-success, #6A9A23)",
    'color.border.success.subtle': "var(--ds-border-success-subtle, #B3DF72)",
    'color.border.discovery': "var(--ds-border-discovery, #AF59E1)",
    'color.border.discovery.subtle': "var(--ds-border-discovery-subtle, #D8A0F7)",
    'color.border.information': "var(--ds-border-information, #357DE8)",
    'color.border.information.subtle': "var(--ds-border-information-subtle, #8FB8F6)",
    'color.border.bold': "var(--ds-border-bold, #7D818A)"
};

});

parcelRegister("9JtyS", function(module, exports) {
$parcel$export(module.exports, "borderRadiusMap", () => $ac4bc8caf2829b84$export$3c0a6c3e64bb180d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aac51b10fd4c84e2b653aff461a93b73>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-shape.tsx <<SignedSource::419cf7fccef8a341df2ce9890e3cdad2>>
 */ const $ac4bc8caf2829b84$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.xxlarge': "var(--ds-radius-xxlarge, 16px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)"
};

});

parcelRegister("h680d", function(module, exports) {
$parcel$export(module.exports, "borderWidthMap", () => $df6daede14944f24$export$e1b83c5210c471b8);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7cdb9fba904c3ac54bf1c429a821ffc2>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-shape.tsx <<SignedSource::419cf7fccef8a341df2ce9890e3cdad2>>
 */ const $df6daede14944f24$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};

});

parcelRegister("vvSKZ", function(module, exports) {
$parcel$export(module.exports, "dimensionMap", () => $888925e4a5770e88$export$6ccdbebca2ee545f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1e4616710c813452a5dda10e6c422716>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 */ const $888925e4a5770e88$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};

});

parcelRegister("jNY1w", function(module, exports) {
$parcel$export(module.exports, "fontMap", () => $0a9666d6db6d0cfd$export$6ffa317d5e70375);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a9dc903b89132658c3e8db351b3cf92f>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $0a9666d6db6d0cfd$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 653 32px/36px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 653 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};

});

parcelRegister("79kuu", function(module, exports) {
$parcel$export(module.exports, "fontFamilyMap", () => $96a0fe56b18da667$export$3c7e9587132614b4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1bd05ea1282426e07fb0ae630b07823d>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $96a0fe56b18da667$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};

});

parcelRegister("gwmdW", function(module, exports) {
$parcel$export(module.exports, "fontWeightMap", () => $88db52066bdfb55a$export$303e322c6b1ed114);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::709c4cdac6e8ef806ec1e227c3e362d1>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $88db52066bdfb55a$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 653)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};

});

parcelRegister("aH2Pn", function(module, exports) {
$parcel$export(module.exports, "gapSpaceMap", () => $1273a50550a92c43$export$ae2d66f16ab57ecd);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aaab37d95b3ad5a410df83f119600eba>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-spacing.tsx <<SignedSource::d315a72fd47775e37868465c88b3ebfb>>
 */ const $1273a50550a92c43$export$ae2d66f16ab57ecd = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)",
    'space.gap.large': "var(--ds-space-gap-large, 12px)",
    'space.gap.medium': "var(--ds-space-gap-medium, 8px)",
    'space.gap.small': "var(--ds-space-gap-small, 6px)",
    'space.gap.xlarge': "var(--ds-space-gap-xlarge, 16px)",
    'space.gap.xsmall': "var(--ds-space-gap-xsmall, 4px)",
    'space.gap.xxlarge': "var(--ds-space-gap-xxlarge, 24px)",
    'space.gap.xxsmall': "var(--ds-space-gap-xxsmall, 2px)"
};

});

parcelRegister("1dZLz", function(module, exports) {
$parcel$export(module.exports, "layerMap", () => $0271cf99349046c6$export$b5f31a7e431d2eab);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::10940883f780b624bff6c0029b7ac6fd>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $0271cf99349046c6$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};

});

parcelRegister("iU7VK", function(module, exports) {
$parcel$export(module.exports, "opacityMap", () => $f8359fabf4909f08$export$daf94a976c798b4f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f768e44d85ca8256730a17510c4d3901>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $f8359fabf4909f08$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};

});

parcelRegister("20MXF", function(module, exports) {
$parcel$export(module.exports, "shadowMap", () => $0acf78cfc2dcb0c2$export$7aff6e7ba39bb774);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::31f7af0716c25896201100f27266bca7>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $0acf78cfc2dcb0c2$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #1E1F211f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #1E1F2129)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #1E1F21, 0px 0px 1px #1E1F21)"
};

});

parcelRegister("5kqbx", function(module, exports) {
$parcel$export(module.exports, "textColorMap", () => $d919384688f5a798$export$8473307aa00d6ea1);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8c49ded1370dd9125e2572ecce0dec81>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $d919384688f5a798$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #292A2E)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #AE2E24)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #5D1F1A)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #9E4C00)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #693200)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #7F5F01)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #533F04)",
    'color.text.accent.green': "var(--ds-text-accent-green, #216E4E)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #164B35)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #206A83)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #164555)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #1558BC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #123263)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #803FA5)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #48245D)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #943D73)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #50253F)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505258)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #1E1F21)",
    'color.text.code.accent.1': "var(--ds-text-code-accent-1, #943D73)",
    'color.text.code.accent.2': "var(--ds-text-code-accent-2, #1558BC)",
    'color.text.code.comments': "var(--ds-text-code-comments, #505258)",
    'color.text.code.default': "var(--ds-text-code-default, #505258)",
    'color.text.code.functions': "var(--ds-text-code-functions, #216E4E)",
    'color.text.code.gutter': "var(--ds-text-code-gutter, #6B6E76)",
    'color.text.code.keywords': "var(--ds-text-code-keywords, #AE2E24)",
    'color.text.code.numbers': "var(--ds-text-code-numbers, #7F5F01)",
    'color.text.code.operators': "var(--ds-text-code-operators, #292A2E)",
    'color.text.code.strings': "var(--ds-text-code-strings, #4C6B1F)",
    'color.text.code.tags': "var(--ds-text-code-tags, #9E4C00)",
    'color.text.disabled': "var(--ds-text-disabled, #080F214A)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #1868DB)",
    'color.text.brand': "var(--ds-text-brand, #1868DB)",
    'color.text.danger': "var(--ds-text-danger, #AE2E24)",
    'color.text.danger.bolder': "var(--ds-text-danger-bolder, #5D1F1A)",
    'color.text.warning': "var(--ds-text-warning, #9E4C00)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #292A2E)",
    'color.text.warning.bolder': "var(--ds-text-warning-bolder, #693200)",
    'color.text.success': "var(--ds-text-success, #4C6B1F)",
    'color.text.success.bolder': "var(--ds-text-success-bolder, #37471F)",
    'color.text.discovery': "var(--ds-text-discovery, #803FA5)",
    'color.text.discovery.bolder': "var(--ds-text-discovery-bolder, #48245D)",
    'color.text.information': "var(--ds-text-information, #1558BC)",
    'color.text.information.bolder': "var(--ds-text-information-bolder, #123263)",
    'color.text.subtlest': "var(--ds-text-subtlest, #6B6E76)",
    'color.text.subtle': "var(--ds-text-subtle, #505258)",
    'color.link': "var(--ds-link, #1868DB)",
    'color.link.pressed': "var(--ds-link-pressed, #1558BC)",
    'color.link.visited': "var(--ds-link-visited, #803FA5)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #48245D)"
};

});



parcelRegister("BP2AV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $fbf5b870dce0e89a$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $k56Mb = parcelRequire("k56Mb");

var $5Qhtn = parcelRequire("5Qhtn");

var $eYXrv = parcelRequire("eYXrv");
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ const $fbf5b870dce0e89a$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).forwardRef(function Button({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, type: type = 'button', ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $k56Mb.default), {
        analyticsContext: analyticsContext,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter),
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "Button",
        type: type,
        interactionName: interactionName,
        ...saferRest,
        children: [
            iconBefore && /*#__PURE__*/ (0, $5chsV.jsx)((0, $5Qhtn.default), {
                type: "icon",
                position: "before",
                isLoading: isLoading,
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $eYXrv.default), {
                    icon: iconBefore
                })
            }),
            children && /*#__PURE__*/ (0, $5chsV.jsx)((0, $5Qhtn.default), {
                isLoading: isLoading,
                children: children
            }),
            iconAfter && /*#__PURE__*/ (0, $5chsV.jsx)((0, $5Qhtn.default), {
                type: "icon",
                position: "after",
                isLoading: isLoading,
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $eYXrv.default), {
                    icon: iconAfter
                })
            })
        ]
    });
}));
$fbf5b870dce0e89a$var$Button.displayName = 'Button';
var $fbf5b870dce0e89a$export$2e2bcd8739ae039 = $fbf5b870dce0e89a$var$Button;

});

parcelRegister("lt7r9", function(module, exports) {
$parcel$export(module.exports, "Flex", () => $ede3022312e50085$export$f51f4c4ede09e011);
$parcel$export(module.exports, "default", () => $ede3022312e50085$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fsvuC = parcelRequire("fsvuC");

var $h2YWL = parcelRequire("h2YWL");

var $9TNvK = parcelRequire("9TNvK");

var $eyIag = parcelRequire("eyIag");
function $ede3022312e50085$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ede3022312e50085$var$justifyContentMap = {
    start: {
        name: "j1lm6p",
        styles: "justify-content:start"
    },
    center: {
        name: "f7ay7b",
        styles: "justify-content:center"
    },
    end: {
        name: "jab4lt",
        styles: "justify-content:end"
    },
    'space-between': {
        name: "2o6p8u",
        styles: "justify-content:space-between"
    },
    'space-around': {
        name: "46cjum",
        styles: "justify-content:space-around"
    },
    'space-evenly': {
        name: "16166rn",
        styles: "justify-content:space-evenly"
    },
    stretch: {
        name: "11z2bqs",
        styles: "justify-content:stretch"
    }
};
const $ede3022312e50085$var$flexDirectionMap = {
    column: {
        name: "qdeacm",
        styles: "flex-direction:column"
    },
    row: {
        name: "mcnhyd",
        styles: "flex-direction:row"
    }
};
const $ede3022312e50085$var$flexWrapMap = {
    wrap: {
        name: "1qemjat",
        styles: "flex-wrap:wrap"
    },
    nowrap: {
        name: "14gl6v0",
        styles: "flex-wrap:nowrap"
    }
};
const $ede3022312e50085$var$alignItemsMap = {
    start: {
        name: "yvwru5",
        styles: "align-items:start"
    },
    center: {
        name: "1h3rtzg",
        styles: "align-items:center"
    },
    baseline: {
        name: "fzr848",
        styles: "align-items:baseline"
    },
    end: {
        name: "uj5xqj",
        styles: "align-items:end"
    },
    stretch: {
        name: "1ikgkii",
        styles: "align-items:stretch"
    }
};
const $ede3022312e50085$var$baseStyles = {
    name: "kxpnum",
    styles: "display:flex;box-sizing:border-box"
};
const $ede3022312e50085$export$f51f4c4ede09e011 = /*#__PURE__*/ (0, $fsvuC.memo)(/*#__PURE__*/ (0, $fsvuC.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss, id: id }, ref)=>{
    const resolvedStyles = (0, $9TNvK.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $h2YWL.jsx)(Component, {
        id: id,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $ede3022312e50085$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $eyIag.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $eyIag.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $eyIag.spaceStylesMap).rowGap[rowGap],
            alignItems && $ede3022312e50085$var$alignItemsMap[alignItems],
            direction && $ede3022312e50085$var$flexDirectionMap[direction],
            justifyContent && $ede3022312e50085$var$justifyContentMap[justifyContent],
            wrap && $ede3022312e50085$var$flexWrapMap[wrap],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$ede3022312e50085$export$f51f4c4ede09e011.displayName = 'Flex';
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$ede3022312e50085$export$2e2bcd8739ae039 = $ede3022312e50085$export$f51f4c4ede09e011;

});
parcelRegister("eyIag", function(module, exports) {
$parcel$export(module.exports, "spaceStylesMap", () => $9e41aaee70f8dd65$export$bf46c3f9eeafc71f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $df4zD = parcelRequire("df4zD");

var $aH2Pn = parcelRequire("aH2Pn");
const $9e41aaee70f8dd65$export$bf46c3f9eeafc71f = (0, $df4zD.createSpacingStylesMap)((0, $aH2Pn.gapSpaceMap), [
    'gap',
    'rowGap',
    'columnGap'
]);

});


parcelRegister("euR7U", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "Pressable", () => $f4e663f45dd926de$export$27c701ed9e449e99);
$parcel$export(module.exports, "default", () => $f4e663f45dd926de$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fsvuC = parcelRequire("fsvuC");

var $h2YWL = parcelRequire("h2YWL");

var $d5Gwv = parcelRequire("d5Gwv");

var $9Tkwf = parcelRequire("9Tkwf");

var $lNjwN = parcelRequire("lNjwN");

var $27lhO = parcelRequire("27lhO");

var $jcSR2 = parcelRequire("jcSR2");

var $h680d = parcelRequire("h680d");

var $dosU1 = parcelRequire("dosU1");

var $9TNvK = parcelRequire("9TNvK");

var $lqjDQ = parcelRequire("lqjDQ");
function $f4e663f45dd926de$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
const $f4e663f45dd926de$var$focusRingStyles = /*#__PURE__*/ (0, $h2YWL.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $jcSR2.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $lqjDQ.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $h680d.borderWidthMap)['border.width.focused']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: `${(0, $h680d.borderWidthMap)['border.width']} solid`
        }
    }
});
const $f4e663f45dd926de$var$baseStyles = {
    name: "1b8qmvl",
    styles: "box-sizing:border-box;appearance:none;border:none"
};
const $f4e663f45dd926de$var$enabledStyles = {
    name: "e0dnmk",
    styles: "cursor:pointer"
};
const $f4e663f45dd926de$var$disabledStyles = {
    name: "1sfig4b",
    styles: "cursor:not-allowed"
};
const $f4e663f45dd926de$export$27c701ed9e449e99 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, isDisabled: isDisabled, type: type = 'button', onClick: providedOnClick = (0, $9Tkwf.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $fsvuC.useContext)((0, $lNjwN.default));
    const handleClick = (0, $fsvuC.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $d5Gwv.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $9TNvK.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $h2YWL.jsx)("button", {
        style: style,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $f4e663f45dd926de$var$baseStyles,
            $f4e663f45dd926de$var$focusRingStyles,
            isDisabled ? $f4e663f45dd926de$var$disabledStyles : $f4e663f45dd926de$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $27lhO.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $dosU1.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $dosU1.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $dosU1.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $dosU1.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $dosU1.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $dosU1.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $dosU1.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId
    }, children);
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$f4e663f45dd926de$export$2e2bcd8739ae039 = $f4e663f45dd926de$export$27c701ed9e449e99;

});

parcelRegister("2I5i9", function(module, exports) {
$parcel$export(module.exports, "getTokenValue", () => $61436fb8bce09daf$export$37e2c47c7e49c28a);
$parcel$export(module.exports, "default", () => $61436fb8bce09daf$export$2e2bcd8739ae039);


var $cB4mc = parcelRequire("cB4mc");

var $hoalA = parcelRequire("hoalA");
function $61436fb8bce09daf$export$37e2c47c7e49c28a(tokenId, fallback = '') {
    let token = (0, $cB4mc.default)[tokenId];
    let tokenValue = fallback;
    typeof $hoalA;
    if (typeof window === 'undefined') return tokenValue;
    tokenValue = window.getComputedStyle(document.documentElement).getPropertyValue(token).trim();
    tokenValue = tokenValue || fallback;
    return tokenValue;
}
var $61436fb8bce09daf$export$2e2bcd8739ae039 = $61436fb8bce09daf$export$37e2c47c7e49c28a;

});

parcelRegister("8XDhJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $4c4ef75f8de0c36c$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $BP2AV = parcelRequire("BP2AV");


var $fz4Xf = parcelRequire("fz4Xf");

var $9Tkwf = parcelRequire("9Tkwf");

var $e7IxC = parcelRequire("e7IxC");

var $7eVz8 = parcelRequire("7eVz8");

var $9cVKi = parcelRequire("9cVKi");

var $hZwjD = parcelRequire("hZwjD");

var $llCao = parcelRequire("llCao");

var $RG5NG = parcelRequire("RG5NG");

var $QrsDO = parcelRequire("QrsDO");

var $2qNMI = parcelRequire("2qNMI");

var $ihDwO = parcelRequire("ihDwO");

var $4YH4m = parcelRequire("4YH4m");

var $cdEBp = parcelRequire("cdEBp");

var $7damY = parcelRequire("7damY");

var $cTzv0 = parcelRequire("cTzv0");
const $4c4ef75f8de0c36c$var$MAX_HEIGHT = `calc(100vh - 16px)`;
const $4c4ef75f8de0c36c$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $4c4ef75f8de0c36c$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$4c4ef75f8de0c36c$var$opposites[crossAxis]}`,
            `${$4c4ef75f8de0c36c$var$opposites[mainAxis]}-${crossAxis}`,
            `${$4c4ef75f8de0c36c$var$opposites[mainAxis]}`,
            `${$4c4ef75f8de0c36c$var$opposites[mainAxis]}-${$4c4ef75f8de0c36c$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$4c4ef75f8de0c36c$var$opposites[mainAxis]}`,
        `${$4c4ef75f8de0c36c$var$opposites[mainAxis]}-start`,
        `${$4c4ef75f8de0c36c$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
function $4c4ef75f8de0c36c$var$isKeyboardEvent(event) {
    return event !== null && (event instanceof KeyboardEvent || 'nativeEvent' in event && event.nativeEvent instanceof KeyboardEvent);
}
/**
 * Legacy Popper/Popup implementation (hooks run unconditionally when this component mounts).
 */ function $4c4ef75f8de0c36c$var$DropdownMenuLegacy({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $9Tkwf.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $QrsDO.layers).modal(), label: label, interactionName: interactionName, strategy: strategy, menuLabel: menuLabel, shouldPreventEscapePropagation: shouldPreventEscapePropagation = false, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent }) {
    const [isLocalOpen, setLocalIsOpen] = (0, $e7IxC.default)(isOpen, ()=>defaultOpen);
    const triggerRef = (0, $fsvuC.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $fsvuC.useState)(false);
    const id = (0, $cTzv0.default)();
    const itemRef = (0, $7damY.default)();
    const { currentLevel: currentLevel } = (0, $hZwjD.useLayering)();
    const fallbackPlacements = (0, $fsvuC.useMemo)(()=>$4c4ef75f8de0c36c$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $fsvuC.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    const handleOnClose = (0, $fsvuC.useCallback)((event, currentLevel)=>{
        const isTabLeftOrEscapeKey = $4c4ef75f8de0c36c$var$isKeyboardEvent(event) && (event.key === 'Tab' || event.key === 'Escape' || event.key === (0, $4096afce6d06a916$export$fc4577f2a2af0ae3));
        // Stop propagation on ESCAPE or Left arrow if shouldPreventEscapePropagation is true
        if (shouldPreventEscapePropagation && $4c4ef75f8de0c36c$var$isKeyboardEvent(event) && (event.key === 'Escape' || event.key === (0, $4096afce6d06a916$export$fc4577f2a2af0ae3))) event.stopPropagation();
        if (event !== null && !isTabLeftOrEscapeKey && event.target instanceof HTMLElement && event.target.closest?.(`[id^=${(0, $cTzv0.PREFIX)}] [aria-haspopup="menu"], [id^=${(0, $cTzv0.PREFIX)}] [aria-haspopup="true"]`)) {
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            const toCloseLevel = itemRef.current?.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        else if ($4c4ef75f8de0c36c$var$isKeyboardEvent(event) && (event.key === 'Tab' && event.shiftKey || event.key === 'Escape' || event.key === (0, $4096afce6d06a916$export$fc4577f2a2af0ae3))) requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        else if (triggerRef.current) {
            // Don't focus the trigger if the click was outside of the menu
            const isClickOutsideMenu = event?.target instanceof HTMLElement && event.target.closest?.('[role="menu"]') === null;
            const shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body; // except if clicking on the body
            if (!shouldPreventFocus) requestAnimationFrame(()=>{
                triggerRef.current?.focus();
            });
        }
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen,
        shouldPreventEscapePropagation
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $7eVz8.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $fsvuC.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $9Tkwf.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $9Tkwf.default;
        return (0, $dqdTY.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $cTzv0.PREFIX)}] [aria-haspopup="menu"], [id^=${(0, $cTzv0.PREFIX)}] [aria-haspopup="true"]`);
                if (e.key === (0, $4096afce6d06a916$export$a80636c6f41931fe) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $4096afce6d06a916$export$e51a3576c045c8d5) || e.key === (0, $4096afce6d06a916$export$8152f929a25a0ff4)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $4096afce6d06a916$export$10f6869ed0a7d75b) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
	 * The Popup component requires either:
	 * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
	 * or
	 * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
	 *
	 * But not:
	 * - shouldFitContainer={true} and shouldRenderToParent={false}
	 *
	 * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
	 * types are satisfied.
	 */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $cdEBp.default), {
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $RG5NG.Popup), {
            id: isLocalOpen ? id : undefined,
            shouldFlip: shouldFlip,
            isOpen: isLocalOpen,
            shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
            // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
            returnFocusRef === undefined,
            onClose: handleOnClose,
            zIndex: zIndex,
            placement: placement,
            role: shouldRenderToParent && currentLevel > 0 ? 'group' : undefined,
            fallbackPlacements: fallbackPlacements,
            testId: testId && `${testId}--content`,
            shouldUseCaptureOnOutsideClick: true,
            shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
            ...conditionalProps,
            shouldDisableFocusLock: true,
            trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
            ...rest })=>{
                if (typeof trigger === 'function') return trigger({
                    'aria-controls': ariaControls,
                    'aria-expanded': ariaExpanded,
                    'aria-haspopup': ariaHasPopup,
                    ...rest,
                    ...bindFocus,
                    triggerRef: (0, $fz4Xf.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    isSelected: isLocalOpen,
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`
                });
                return /*#__PURE__*/ (0, $5chsV.jsx)((0, $BP2AV.default), {
                    ...bindFocus,
                    ref: (0, $fz4Xf.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    "aria-controls": ariaControls,
                    "aria-expanded": ariaExpanded,
                    "aria-haspopup": ariaHasPopup,
                    isSelected: isLocalOpen,
                    iconAfter: (iconProps)=>/*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9cVKi))), {
                            ...iconProps,
                            size: "small"
                        }),
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`,
                    "aria-label": label,
                    interactionName: interactionName,
                    children: trigger
                });
            },
            // Legacy only. Run time passes the setter for every role; the types hide it.
            // The cast goes at the flag cleanup.
            content: (contentProps)=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $ihDwO.default), {
                    onClose: handleOnClose,
                    children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $4YH4m.default), {
                        spacing: spacing,
                        maxHeight: $4c4ef75f8de0c36c$var$MAX_HEIGHT,
                        maxWidth: shouldFitContainer ? undefined : 800,
                        onClose: handleOnClose,
                        onUpdate: contentProps.update,
                        isLoading: isLoading,
                        statusLabel: statusLabel,
                        setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? contentProps.setInitialFocusRef : undefined,
                        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                        autoFocus: autoFocus,
                        testId: testId && `${testId}--menu-wrapper`,
                        menuLabel: menuLabel,
                        children: children
                    })
                })
        })
    });
}
$4c4ef75f8de0c36c$var$DropdownMenuLegacy.displayName = "DropdownMenuLegacy";
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $4c4ef75f8de0c36c$var$DropdownMenu = (props)=>{
    const { autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading, isOpen: isOpen, onOpenChange: onOpenChange = (0, $9Tkwf.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, label: label, interactionName: interactionName, menuLabel: menuLabel } = props;
    if ((0, $llCao.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $2qNMI.default), {
        autoFocus: autoFocus,
        children: children,
        defaultOpen: defaultOpen,
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: onOpenChange,
        placement: placement,
        shouldFitContainer: shouldFitContainer,
        returnFocusRef: returnFocusRef,
        spacing: spacing,
        statusLabel: statusLabel,
        testId: testId,
        trigger: trigger,
        label: label,
        interactionName: interactionName,
        menuLabel: menuLabel
    });
    // Forward full public props to the legacy Popper/Popup implementation unchanged.
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props -- wrapper delegates entire DropdownMenuProps API
    return /*#__PURE__*/ (0, $5chsV.jsx)($4c4ef75f8de0c36c$var$DropdownMenuLegacy, {
        ...props
    });
};
$4c4ef75f8de0c36c$var$DropdownMenu.displayName = "DropdownMenu";
var $4c4ef75f8de0c36c$export$2e2bcd8739ae039 = $4c4ef75f8de0c36c$var$DropdownMenu;

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $4096afce6d06a916$export$390330c10ff2b9a1 = 'ArrowUp';
const $4096afce6d06a916$export$a80636c6f41931fe = 'ArrowDown';
const $4096afce6d06a916$export$fc4577f2a2af0ae3 = 'ArrowLeft';
const $4096afce6d06a916$export$c40f9845adc73fb5 = 'ArrowRight';
const $4096afce6d06a916$export$4af703091671bc = 'Home';
const $4096afce6d06a916$export$e2bc30913faa5db7 = 'End';
const $4096afce6d06a916$export$10f6869ed0a7d75b = 'Tab';
const $4096afce6d06a916$export$8152f929a25a0ff4 = 'Enter';
const $4096afce6d06a916$export$e51a3576c045c8d5 = 'Space';
const $4096afce6d06a916$export$2bb790b9008907b4 = 'Escape';

parcelRegister("e7IxC", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0a6b56ec5fa5e1b$export$2e2bcd8739ae039);

var $fsvuC = parcelRequire("fsvuC");
function $f0a6b56ec5fa5e1b$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $fsvuC.useState)(getDefaultPropValue);
    const isControlledRef = (0, $fsvuC.useRef)(isControlled);
    (0, $fsvuC.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $fsvuC.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("7eVz8", function(module, exports) {
$parcel$export(module.exports, "default", () => $3fde8ff540167697$export$2e2bcd8739ae039);

var $fsvuC = parcelRequire("fsvuC");
function $3fde8ff540167697$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $fsvuC.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $fsvuC.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $fsvuC.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("2qNMI", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a6d6ea1dc21130e$export$2e2bcd8739ae039);
/* dropdown-menu-top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $dqdTY = parcelRequire("dqdTY");

var $BP2AV = parcelRequire("BP2AV");


var $9Tkwf = parcelRequire("9Tkwf");

var $e7IxC = parcelRequire("e7IxC");

var $7eVz8 = parcelRequire("7eVz8");

var $9cVKi = parcelRequire("9cVKi");

var $55Ij3 = parcelRequire("55Ij3");

var $9cT91 = parcelRequire("9cT91");

var $6KgHe = parcelRequire("6KgHe");

var $3sk8R = parcelRequire("3sk8R");

var $974dn = parcelRequire("974dn");

var $9RE4M = parcelRequire("9RE4M");

var $2jUY9 = parcelRequire("2jUY9");

var $gc525 = parcelRequire("gc525");

var $eO9TI = parcelRequire("eO9TI");

var $kOb0h = parcelRequire("kOb0h");

var $cdEBp = parcelRequire("cdEBp");
const $8a6d6ea1dc21130e$var$MAX_HEIGHT = `calc(100vh - 16px)`;
const $8a6d6ea1dc21130e$var$styles = {
    spinnerContainer: "_3iDTPbQ4SZ _4ouGXIoaux _37wbyuDIqT _46hvQmkG2W _03SyCPkG2W _0xmtkokG2W _0LQT5EkG2W"
};
function $8a6d6ea1dc21130e$var$getRootMenuPopover({ menu: menu }) {
    const parentMenu = menu.parentElement?.closest('[popover][role="menu"]');
    if (!parentMenu) return menu;
    return $8a6d6ea1dc21130e$var$getRootMenuPopover({
        menu: parentMenu
    });
}
/**
 * Loading indicator for the dropdown menu.
 */ function $8a6d6ea1dc21130e$var$LoadingIndicator({ statusLabel: statusLabel = 'Loading', testId: testId }) {
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        role: "menuitem",
        className: (0, $gJ6nT.default)([
            $8a6d6ea1dc21130e$var$styles.spinnerContainer
        ]),
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $9cT91.default), {
            size: "small",
            label: statusLabel,
            testId: testId
        })
    });
}
$8a6d6ea1dc21130e$var$LoadingIndicator.displayName = "LoadingIndicator";
/**
 * Top-layer implementation of DropdownMenu.
 *
 * Replaces the legacy `@atlaskit/popup` + `@atlaskit/portal` + `@atlaskit/layering` pipeline
 * with the native Popover API via `@atlaskit/top-layer`.
 *
 * What is no longer needed:
 * - Portal: top layer handles stacking natively
 * - FocusLock / react-focus-lock: popover=auto provides light dismiss
 * - z-index: top layer is always above everything
 * - FocusManager (ref registration): replaced by DOM-query-based `useArrowNavigation`
 * - handle-focus.tsx: replaced by `useArrowNavigation`
 * - Layering context: top layer nesting is handled by the browser
 * - Fallback placements / Popper: CSS Anchor Positioning handles positioning
 */ function $8a6d6ea1dc21130e$var$DropdownMenuTopLayer({ children: children, defaultOpen: defaultOpen = false, isLoading: isLoading, isOpen: isOpenProp, onOpenChange: onOpenChange = (0, $9Tkwf.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, label: label, interactionName: interactionName, menuLabel: menuLabel }) {
    const [isLocalOpen, setLocalIsOpen] = (0, $e7IxC.default)(isOpenProp, ()=>defaultOpen);
    const triggerRef = (0, $fsvuC.useRef)(null);
    const popoverRef = (0, $fsvuC.useRef)(null);
    const setPopoverRef = (0, $fsvuC.useCallback)((element)=>{
        popoverRef.current = element;
        // Leave untouched menus without a busy state; retain false once it has been set.
        if (isLoading !== undefined || element?.hasAttribute('aria-busy')) element?.setAttribute('aria-busy', String(Boolean(isLoading)));
    }, [
        isLoading
    ]);
    const popoverId = (0, $kOb0h.usePopoverId)();
    const topLayerPlacement = (0, $fsvuC.useMemo)(()=>(0, $974dn.fromLegacyPlacement)({
            legacy: placement
        }), [
        placement
    ]);
    // DropdownMenu has no `shouldFitViewport` equivalent, so neither axis ever
    // fits and `blockSize` stays `'content'` - `MenuGroup`'s `maxHeight` owns the
    // block axis.
    (0, $gc525.useAnchoredPopover)({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isLocalOpen,
        inlineSize: shouldFitContainer ? 'min-anchor' : 'content'
    });
    // Close handling.
    // Focus restoration is handled natively by the Popover API:
    //   - Escape: browser restores focus to the trigger automatically
    //   - Click-outside: browser does NOT restore (correct behavior)
    //
    // The only custom focus handling needed is `returnFocusRef`: when provided,
    // we redirect focus to a different element than the trigger. We do this
    // in the onClose callback via rAF, which runs after the browser's native
    // restoration, effectively overriding it.
    const handleOnClose = (0, $fsvuC.useCallback)(()=>{
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        setLocalIsOpen(false);
        onOpenChange({
            isOpen: false,
            event: null
        });
    }, [
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    // Trigger click handling.
    const handleTriggerClicked = (0, $fsvuC.useCallback)((event)=>{
        const nextIsOpen = !isLocalOpen;
        setLocalIsOpen(nextIsOpen);
        // Extract the native DOM event for onOpenChange
        const nativeEvent = 'nativeEvent' in event ? event.nativeEvent : event;
        onOpenChange({
            isOpen: nextIsOpen,
            event: nativeEvent
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $7eVz8.default)();
    // When trigger is focused, open dropdown on ArrowDown (top-level only).
    // Per WAI-ARIA, ArrowDown opens a menu from a menubar/button trigger,
    // but inside a vertical submenu, ArrowDown navigates between siblings
    // and ArrowRight opens nested menus instead.
    (0, $fsvuC.useEffect)(()=>{
        if (!isFocused || isLocalOpen) return;
        // Do not open on ArrowDown if this trigger is inside a parent menu.
        // Nested menus should only be opened via ArrowRight or Enter.
        const isNestedTrigger = Boolean(triggerRef.current?.closest('[role="menu"]'));
        return (0, $dqdTY.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $4096afce6d06a916$export$a80636c6f41931fe) && !isNestedTrigger) {
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked
    ]);
    const handleNestedOpen = (0, $fsvuC.useCallback)(({ trigger: trigger })=>{
        if (!trigger.matches('[aria-haspopup="menu"], [aria-haspopup="true"]')) return;
        trigger.click();
    }, []);
    const handleTabClose = (0, $fsvuC.useCallback)(()=>{
        const currentMenu = popoverRef.current;
        if (!currentMenu) return;
        // Hiding the root native popover synchronously closes its descendant popovers and restores
        // focus to the root trigger. The browser can then perform the Tab default action from there.
        $8a6d6ea1dc21130e$var$getRootMenuPopover({
            menu: currentMenu
        }).hidePopover();
    }, []);
    (0, $eO9TI.useArrowNavigation)({
        containerRef: popoverRef,
        onClose: handleTabClose,
        onNestedOpen: handleNestedOpen,
        onNestedClose: handleOnClose,
        isEnabled: isLocalOpen,
        filter: (0, $3sk8R.isAtCurrentMenuLevel)
    });
    // Close on menu item click.
    // Close when a regular menuitem is clicked, but not checkboxes/radios
    // and not nested submenu triggers.
    const handleMenuClick = (0, $fsvuC.useCallback)((e)=>{
        if (!(e.target instanceof Element)) return;
        const menuItem = e.target.closest?.('[role="menuitem"], [role="menuitemcheckbox"], [role="menuitemradio"]');
        if (!menuItem) return;
        const isCheckboxOrRadio = menuItem.getAttribute('role') === 'menuitemcheckbox' || menuItem.getAttribute('role') === 'menuitemradio';
        // Only menu/true popup values identify submenus.
        // The nested dropdown will handle its own open/close.
        const isNestedTrigger = menuItem.matches('[aria-haspopup="menu"], [aria-haspopup="true"]');
        if (!isCheckboxOrRadio && !isNestedTrigger) {
            setLocalIsOpen(false);
            onOpenChange({
                isOpen: false,
                event: e.nativeEvent
            });
        }
    }, [
        setLocalIsOpen,
        onOpenChange
    ]);
    const ariaAttributes = (0, $6KgHe.getAriaForTrigger)({
        role: 'menu',
        isOpen: isLocalOpen,
        popoverId: popoverId
    });
    /**
   * Custom trigger consumers historically receive a callback ref,
   * and their code assumes it is one.
   * Using this wrapper for compatibility...
   */ const setTriggerRef = (0, $fsvuC.useCallback)((node)=>{
        triggerRef.current = node;
    }, []);
    const renderTrigger = ()=>{
        if (typeof trigger === 'function') return trigger({
            ...ariaAttributes,
            onFocus: bindFocus.onFocus,
            onBlur: bindFocus.onBlur,
            triggerRef: setTriggerRef,
            isSelected: isLocalOpen,
            onClick: handleTriggerClicked,
            testId: testId && `${testId}--trigger`
        });
        return /*#__PURE__*/ (0, $5chsV.jsx)((0, $BP2AV.default), {
            onFocus: bindFocus.onFocus,
            onBlur: bindFocus.onBlur,
            ref: setTriggerRef,
            ...ariaAttributes,
            isSelected: isLocalOpen,
            iconAfter: (iconProps)=>/*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9cVKi))), {
                    ...iconProps,
                    size: "small"
                }),
            onClick: handleTriggerClicked,
            testId: testId && `${testId}--trigger`,
            "aria-label": label,
            interactionName: interactionName,
            children: trigger
        });
    };
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $cdEBp.default), {
        children: [
            renderTrigger(),
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $2jUY9.Popover), {
                ref: setPopoverRef,
                id: popoverId,
                role: "menu",
                label: menuLabel ?? label ?? (typeof trigger === 'string' ? trigger : 'Menu'),
                isOpen: isLocalOpen,
                onClose: handleOnClose,
                shouldAnimate: true,
                placement: topLayerPlacement,
                testId: testId && `${testId}--content`,
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $9RE4M.PopoverSurface), {
                    children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $55Ij3.default), {
                        maxHeight: $8a6d6ea1dc21130e$var$MAX_HEIGHT,
                        maxWidth: shouldFitContainer ? undefined : 800,
                        onClick: handleMenuClick,
                        spacing: spacing,
                        testId: testId && `${testId}--menu-wrapper--menu-group`,
                        children: isLoading ? /*#__PURE__*/ (0, $5chsV.jsx)($8a6d6ea1dc21130e$var$LoadingIndicator, {
                            statusLabel: statusLabel,
                            testId: testId && `${testId}--menu-wrapper--loading-indicator`
                        }) : children
                    })
                })
            })
        ]
    });
}
$8a6d6ea1dc21130e$var$DropdownMenuTopLayer.displayName = "DropdownMenuTopLayer";
var $8a6d6ea1dc21130e$export$2e2bcd8739ae039 = $8a6d6ea1dc21130e$var$DropdownMenuTopLayer;

});
parcelRegister("55Ij3", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a62f828e540db59$export$2e2bcd8739ae039);
/* menu-group.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $9BiiY = parcelRequire("9BiiY");

var $io8Sm = parcelRequire("io8Sm");
const $6a62f828e540db59$var$baseStyles = null;
/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $6a62f828e540db59$var$MenuGroup = ({ isLoading: isLoading, maxWidth: maxWidth, minWidth: minWidth, minHeight: minHeight, maxHeight: maxHeight, testId: testId, role: role, spacing: spacing = 'cozy', menuLabel: menuLabel, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $9BiiY.SpacingContext).Provider, {
        value: spacing,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $io8Sm.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "border",
            children: /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                "aria-busy": isLoading,
                style: {
                    minWidth: minWidth,
                    maxWidth: maxWidth,
                    minHeight: minHeight,
                    maxHeight: maxHeight
                },
                "data-testid": testId,
                role: role,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, $gJ6nT.default)([
                    "_4bt5LAIZbP _2WAcuGIZbP _3iDTPbQ4SZ _1mT5xd5HSx _0aFT5vbt8w",
                    UNSAFE_className
                ]),
                "aria-label": menuLabel,
                ...rest
            })
        })
    });
$6a62f828e540db59$var$MenuGroup.displayName = "MenuGroup";
var $6a62f828e540db59$export$2e2bcd8739ae039 = $6a62f828e540db59$var$MenuGroup;

});
parcelRegister("9BiiY", function(module, exports) {
$parcel$export(module.exports, "SpacingContext", () => $ed297e0f5605ab24$export$443076ec7ebce042);

var $fsvuC = parcelRequire("fsvuC");
const $ed297e0f5605ab24$export$443076ec7ebce042 = /*#__PURE__*/ (0, $fsvuC.createContext)('cozy');

});

parcelRegister("io8Sm", function(module, exports) {
$parcel$export(module.exports, "SELECTION_STYLE_CONTEXT_DO_NOT_USE", () => $422158e8eb59a577$export$9ca534b70725964d);

var $fsvuC = parcelRequire("fsvuC");
const $422158e8eb59a577$export$9ca534b70725964d = /*#__PURE__*/ (0, $fsvuC.createContext)('border');

});


parcelRegister("3sk8R", function(module, exports) {
$parcel$export(module.exports, "isAtCurrentMenuLevel", () => $95d3aa7d6875fa90$export$f1bba0ef464d60af);
const $95d3aa7d6875fa90$var$menuScope = '[role="menu"]';
/**
 * Recursively walks from `node` toward `container`, returning `true` when
 * `container` is reached without crossing another `role="menu"` ancestor.
 *
 * Used by `isAtCurrentMenuLevel` (pattern 2) to determine if the
 * `closestMenu` is owned by the wrapper container directly. Recursion
 * avoids a mutable `let parent` walk and keeps the function body linear.
 */ function $95d3aa7d6875fa90$var$reachesContainerWithoutNestedMenu(node, container) {
    if (!node || node === container) return node === container;
    if (node.getAttribute('role') === 'menu') return false;
    return $95d3aa7d6875fa90$var$reachesContainerWithoutNestedMenu(node.parentElement, container);
}
function $95d3aa7d6875fa90$export$f1bba0ef464d60af(element, container) {
    const closestMenu = element.closest($95d3aa7d6875fa90$var$menuScope);
    // Container itself has role="menu". Element belongs to this level
    // if its closest menu is the container.
    if (container.getAttribute('role') === 'menu') return closestMenu === container;
    // Container is a wrapper without role="menu" (e.g. dropdown-menu
    // wraps a MenuGroup). The element belongs to the top level if its
    // closest role="menu" ancestor is a direct child of the container,
    // i.e. there is no nested role="menu" between them.
    if (closestMenu === null) return true;
    // Walk up from the closest menu to see if it is "owned" by this
    // container without passing through another role="menu" first.
    return $95d3aa7d6875fa90$var$reachesContainerWithoutNestedMenu(closestMenu.parentElement, container);
}

});

parcelRegister("eO9TI", function(module, exports) {
$parcel$export(module.exports, "useArrowNavigation", () => $2565731d43f758f2$export$23dfbae28e0cc453);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");


var $8c95s = parcelRequire("8c95s");

var $aQFwo = parcelRequire("aQFwo");

var $jemDr = parcelRequire("jemDr");
const $2565731d43f758f2$var$menuScope = '[role="menu"]';
function $2565731d43f758f2$export$23dfbae28e0cc453({ containerRef: containerRef, onClose: onClose, onNestedOpen: onNestedOpen, onNestedClose: onNestedClose, isEnabled: isEnabled = true, filter: filter }) {
    const handleKeyDown = (0, $fsvuC.useCallback)((event)=>{
        const container = containerRef.current;
        if (!container) return;
        // Guard: only handle the event if the currently focused element
        // belongs to this menu level. The focused element's closest
        // [role="menu"] must be this container (not a nested sub-menu).
        // When no filter is provided, fall back to the closest-menu check
        // if the container has role="menu".
        const focused = container.ownerDocument.activeElement;
        if (focused instanceof HTMLElement) {
            if (filter) {
                if (!filter(focused, container)) return;
            }
            if (!filter && container.getAttribute('role') === 'menu' && focused.closest($2565731d43f758f2$var$menuScope) !== container) return;
        }
        if (event.key === (0, $4096afce6d06a916$export$a80636c6f41931fe)) {
            // Prevent page scroll while navigating menu items.
            event.preventDefault();
            (0, $jemDr.getNextFocusable)({
                container: container,
                direction: 'forwards',
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $4096afce6d06a916$export$390330c10ff2b9a1)) {
            // Prevent page scroll while navigating menu items.
            event.preventDefault();
            (0, $jemDr.getNextFocusable)({
                container: container,
                direction: 'backwards',
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $4096afce6d06a916$export$4af703091671bc)) {
            // Prevent browser default (e.g. scrolling to top of page).
            event.preventDefault();
            (0, $8c95s.getFirstFocusable)({
                container: container,
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $4096afce6d06a916$export$e2bc30913faa5db7)) {
            // Prevent browser default (e.g. scrolling to bottom of page).
            event.preventDefault();
            (0, $aQFwo.getLastFocusable)({
                container: container,
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $4096afce6d06a916$export$10f6869ed0a7d75b)) {
            onClose();
            return;
        }
        // ── Nested menu navigation (WAI-ARIA menu pattern) ──
        // ArrowRight on a menuitem with aria-haspopup opens the submenu.
        if (event.key === 'ArrowRight') {
            if (onNestedOpen && focused instanceof HTMLElement && focused.hasAttribute('aria-haspopup')) {
                event.preventDefault();
                onNestedOpen({
                    trigger: focused
                });
            }
            return;
        }
        // ArrowLeft closes the current menu if it is nested inside a parent menu.
        if (event.key === 'ArrowLeft') {
            if (onNestedClose) {
                // Only close if this container is inside another role="menu"
                // (i.e. it is a submenu, not the top-level menu).
                // Walk up from the parent to avoid matching the container itself.
                const isNested = Boolean(container.parentElement?.closest($2565731d43f758f2$var$menuScope));
                if (isNested) {
                    event.preventDefault();
                    onNestedClose();
                }
            }
            return;
        }
    }, [
        containerRef,
        onClose,
        onNestedOpen,
        onNestedClose,
        filter
    ]);
    (0, $fsvuC.useEffect)(()=>{
        const container = containerRef.current;
        if (!container || !isEnabled) return;
        return (0, $dqdTY.bind)(container, {
            type: 'keydown',
            listener: handleKeyDown
        });
    }, [
        containerRef,
        handleKeyDown,
        isEnabled
    ]);
}

});

parcelRegister("cdEBp", function(module, exports) {
$parcel$export(module.exports, "default", () => $a2a5bcbe9093c798$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gk8BM = parcelRequire("gk8BM");
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $a2a5bcbe9093c798$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $fsvuC.useRef)({});
    const context = (0, $fsvuC.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $gk8BM.SelectionStoreContext).Provider, {
        value: context,
        children: children
    });
};
$a2a5bcbe9093c798$var$SelectionStore.displayName = "SelectionStore";
var $a2a5bcbe9093c798$export$2e2bcd8739ae039 = $a2a5bcbe9093c798$var$SelectionStore;

});
parcelRegister("gk8BM", function(module, exports) {
$parcel$export(module.exports, "SelectionStoreContext", () => $97ddfd79bb377bc1$export$756f795847463ebd);

var $fsvuC = parcelRequire("fsvuC");

var $9Tkwf = parcelRequire("9Tkwf");
const $97ddfd79bb377bc1$export$756f795847463ebd = /*#__PURE__*/ (0, $fsvuC.createContext)({
    setItemState: (0, $9Tkwf.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $9Tkwf.default),
    getGroupState: ()=>({})
});

});



parcelRegister("ihDwO", function(module, exports) {
$parcel$export(module.exports, "default", () => $8852d311acaaee05$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $hZwjD = parcelRequire("hZwjD");

var $ca9yn = parcelRequire("ca9yn");

var $c9SBC = parcelRequire("c9SBC");
/**
 * Focus manager logic.
 */ const $8852d311acaaee05$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $fsvuC.useRef)([]);
    // Used to force a re-render only
    const [refresh, setRefresh] = (0, $fsvuC.useState)(0);
    const registerMode = (0, $fsvuC.useRef)('ordered');
    registerMode.current = 'ordered';
    const registerRef = (0, $fsvuC.useCallback)((ref)=>{
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error(`Unexpected case of ${registerMode.current}`);
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    const { isLayerDisabled: isLayerDisabled, currentLevel: currentLevel } = (0, $hZwjD.useLayering)();
    // Root menu (from a button) is at level 1; first submenu is at level 2. ARIA: Left only closes submenus.
    const isNestedMenu = currentLevel > 1;
    // Intentionally rebinding on each render
    (0, $fsvuC.useEffect)(()=>{
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, $fsvuC.useEffect)(()=>(0, $dqdTY.bind)(window, {
            type: 'keydown',
            listener: (0, $ca9yn.default)(menuItemRefs, isLayerDisabled, onClose, isNestedMenu)
        }), [
        isLayerDisabled,
        onClose,
        isNestedMenu
    ]);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $c9SBC.FocusManagerContext).Provider, {
        value: contextValue,
        children: children
    });
};
$8852d311acaaee05$var$FocusManager.displayName = "FocusManager";
var $8852d311acaaee05$export$2e2bcd8739ae039 = $8852d311acaaee05$var$FocusManager;

});
parcelRegister("ca9yn", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ba63115c15a6187$export$2e2bcd8739ae039);


var $llCao = parcelRequire("llCao");

var $cTzv0 = parcelRequire("cTzv0");
const $1ba63115c15a6187$var$actionMap = {
    [(0, $4096afce6d06a916$export$a80636c6f41931fe)]: 'next',
    [(0, $4096afce6d06a916$export$390330c10ff2b9a1)]: 'prev',
    [(0, $4096afce6d06a916$export$4af703091671bc)]: 'first',
    [(0, $4096afce6d06a916$export$e2bc30913faa5db7)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $1ba63115c15a6187$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx + 1 === refs.length) currentFocusedIdx = 0;
        else currentFocusedIdx++;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $1ba63115c15a6187$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx === 0) currentFocusedIdx = refs.length - 1;
        else currentFocusedIdx--;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
function $1ba63115c15a6187$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose, isNestedMenu = false) {
    return (e)=>{
        const currentRefs = refs.current ?? [];
        const currentFocusedIdx = currentRefs.findIndex(({ current: el })=>el && document.activeElement?.isSameNode(el));
        if ((0, $llCao.fg)('platform_dst_popup-disable-focuslock')) {
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            const isNestedDropdown = !!document.activeElement?.closest(`[id^=${(0, $cTzv0.PREFIX)}]`);
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $4096afce6d06a916$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $4096afce6d06a916$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        // Left arrow: only in a submenu — close and return focus to parent. No navigation within menu.
        if (e.key === (0, $4096afce6d06a916$export$fc4577f2a2af0ae3)) {
            e.preventDefault();
            if (isNestedMenu) onClose(e);
            return;
        }
        // Right arrow: only when item has submenu — open it. No navigation within menu.
        if (e.key === (0, $4096afce6d06a916$export$c40f9845adc73fb5)) {
            const activeElement = document.activeElement;
            if (activeElement instanceof HTMLElement && (activeElement.getAttribute('aria-haspopup') === 'true' || activeElement.getAttribute('aria-haspopup') === 'menu')) {
                e.preventDefault();
                activeElement.click();
            }
            return;
        }
        const action = $1ba63115c15a6187$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const nextFocusableElement = $1ba63115c15a6187$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                nextFocusableElement?.focus();
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const prevFocusableElement = $1ba63115c15a6187$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                prevFocusableElement?.focus();
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const firstFocusableElement = $1ba63115c15a6187$var$getNextFocusableElement(currentRefs, -1);
                firstFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const lastFocusableElement = $1ba63115c15a6187$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                lastFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});
parcelRegister("cTzv0", function(module, exports) {
$parcel$export(module.exports, "PREFIX", () => $2c4dddb37fd200e3$export$8a682ae47622dbb9);
$parcel$export(module.exports, "default", () => $2c4dddb37fd200e3$export$2e2bcd8739ae039);

var $cTXsj = parcelRequire("cTXsj");
const $2c4dddb37fd200e3$export$8a682ae47622dbb9 = 'ds--dropdown--';
function $2c4dddb37fd200e3$export$2e2bcd8739ae039() {
    const id = (0, $cTXsj.useId)();
    return `${$2c4dddb37fd200e3$export$8a682ae47622dbb9}${id}`;
}

});


parcelRegister("c9SBC", function(module, exports) {
$parcel$export(module.exports, "FocusManagerContext", () => $9ee910210f4030ab$export$f18c1d4fc7326096);

var $fsvuC = parcelRequire("fsvuC");

var $9Tkwf = parcelRequire("9Tkwf");
const $9ee910210f4030ab$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $fsvuC.createContext)({
    menuItemRefs: [],
    registerRef: (0, $9Tkwf.default)
});

});


parcelRegister("4YH4m", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ac7e6753537b703$export$2e2bcd8739ae039);
/* menu-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $55Ij3 = parcelRequire("55Ij3");

var $llCao = parcelRequire("llCao");

var $jRYjy = parcelRequire("jRYjy");

var $9cT91 = parcelRequire("9cT91");

var $5dDUu = parcelRequire("5dDUu");

var $1tjRT = parcelRequire("1tjRT");

var $c9SBC = parcelRequire("c9SBC");
const $1ac7e6753537b703$var$styles = {
    spinnerContainer: "_3iDTPbQ4SZ _4ouGXIoaux _37wbyuDIqT _46hvQmkG2W _03SyCPkG2W _0xmtkokG2W _0LQT5EkG2W"
};
const $1ac7e6753537b703$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $jRYjy.Box), {
        xcss: $1ac7e6753537b703$var$styles.spinnerContainer,
        role: "menuitem",
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $9cT91.default), {
            size: "small",
            label: statusLabel,
            testId: testId
        })
    });
$1ac7e6753537b703$var$LoadingIndicator.displayName = "LoadingIndicator";
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $1ac7e6753537b703$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus, menuLabel: menuLabel })=>{
    const { menuItemRefs: menuItemRefs } = (0, $fsvuC.useContext)((0, $c9SBC.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDescendant = menuItemRefs.some((menuItemRef)=>{
            const { current: menuItem } = menuItemRef;
            if (!menuItem) return false;
            const isCheckboxOrRadio = (0, $5dDUu.default)(menuItem) || (0, $1tjRT.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $fsvuC.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $fsvuC.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.map(({ current: current })=>current).find((el)=>!!el && !el.hasAttribute('disabled')) ?? null;
        if (((0, $llCao.fg)('platform_dst_menu_item_focus') || shouldRenderToParent) && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $55Ij3.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`,
        menuLabel: menuLabel,
        children: isLoading ? /*#__PURE__*/ (0, $5chsV.jsx)($1ac7e6753537b703$var$LoadingIndicator, {
            statusLabel: statusLabel,
            testId: testId && `${testId}--loading-indicator`
        }) : children
    });
};
$1ac7e6753537b703$var$MenuWrapper.displayName = "MenuWrapper";
var $1ac7e6753537b703$export$2e2bcd8739ae039 = $1ac7e6753537b703$var$MenuWrapper;

});
parcelRegister("5dDUu", function(module, exports) {
$parcel$export(module.exports, "default", () => $111c480f73d532af$export$2e2bcd8739ae039);
function $111c480f73d532af$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("1tjRT", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4c30cd9adeffbe6$export$2e2bcd8739ae039);
function $a4c30cd9adeffbe6$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("7damY", function(module, exports) {
$parcel$export(module.exports, "default", () => $c3b9f3462db1d6ba$export$2e2bcd8739ae039);
// eslint-disable-next-line sort-imports

var $fsvuC = parcelRequire("fsvuC");

var $llCao = parcelRequire("llCao");

var $c9SBC = parcelRequire("c9SBC");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
function $c3b9f3462db1d6ba$var$useRegisterItemWithFocusManager(hasPopup = false) {
    const { registerRef: registerRef } = (0, $fsvuC.useContext)((0, $c9SBC.FocusManagerContext));
    const itemRef = (0, $fsvuC.useRef)(null);
    (0, $fsvuC.useEffect)(()=>{
        if (hasPopup && (0, $llCao.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
}
var $c3b9f3462db1d6ba$export$2e2bcd8739ae039 = $c3b9f3462db1d6ba$var$useRegisterItemWithFocusManager;

});


parcelRegister("8HvJO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::28569a1ba0e49d9b1ede9e97db5921f7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $655af55ba814acd4$var$_react = $655af55ba814acd4$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $655af55ba814acd4$var$_iconNew = $655af55ba814acd4$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $655af55ba814acd4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiSearch".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/ai-search
 * Usage guidance:
 * Reserved for search interactions powered by Rovo/AI.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $655af55ba814acd4$var$AiSearchIcon = (props)=>/*#__PURE__*/ $655af55ba814acd4$var$_react.default.createElement($655af55ba814acd4$var$_iconNew.default, Object.assign({
        name: "AiSearchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6 2.612A4.501 4.501 0 0 0 7 11.5a4.48 4.48 0 0 0 3.182-1.318A4.5 4.5 0 0 0 11.387 8h1.53a6 6 0 0 1-1.179 2.678l3.292 3.292-1.06 1.06-3.292-3.292A6 6 0 1 1 6 1.084z"/><path fill="currentcolor" d="M14 3.25a.75.75 0 0 1-.493.705l-1.285.469a.5.5 0 0 0-.298.298l-.469 1.285a.75.75 0 0 1-1.41 0l-.469-1.285a.5.5 0 0 0-.298-.298l-1.285-.469a.75.75 0 0 1-.484-.589L7.5 3.25l.009-.116a.75.75 0 0 1 .484-.59l1.285-.468a.5.5 0 0 0 .298-.298l.469-1.285.049-.106A.75.75 0 0 1 10.749 0l.116.009a.75.75 0 0 1 .541.378l.05.106.468 1.285a.5.5 0 0 0 .298.298l1.285.469A.75.75 0 0 1 14 3.25"/>`
    }, props));
$655af55ba814acd4$var$AiSearchIcon.displayName = 'AiSearchIcon';
var $655af55ba814acd4$var$_default = module.exports.default = $655af55ba814acd4$var$AiSearchIcon;

});

parcelRegister("1ewxO", function(module, exports) {
$parcel$export(module.exports, "RovoIcon", () => $77e380836b575fa4$export$e23ae35269442b4f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e4ebbb5ba469a9ff5e91d5204f2f881d>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $2IsXX = parcelRequire("2IsXX");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $77e380836b575fa4$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--rovo-blue-color, #1868db)" fill-rule="evenodd" d="m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z" clip-rule="evenodd"/>
    <path fill="var(--rovo-green-color, #6a9a23)" fill-rule="evenodd" d="m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z" clip-rule="evenodd"/>
    <path fill="var(--rovo-purple-color, #af59e1)" fill-rule="evenodd" d="m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354" clip-rule="evenodd"/>
    <path fill="var(--rovo-yellow-color, #fca700)" fill-rule="evenodd" d="M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z" clip-rule="evenodd"/>
</svg>
`;
function $77e380836b575fa4$export$e23ae35269442b4f({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Rovo', testId: testId }) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $2IsXX.IconWrapper), {
        svg: $77e380836b575fa4$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}
$77e380836b575fa4$export$e23ae35269442b4f.displayName = "RovoIcon";

});

parcelRegister("6dQ8U", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f1f5e59a1768f91$export$2e2bcd8739ae039);
/* link.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $dwUnm = parcelRequire("dwUnm");

var $fz4Xf = parcelRequire("fz4Xf");

var $cO4y2 = parcelRequire("cO4y2");

var $cGW6W = parcelRequire("cGW6W");

var $3Kmf8 = parcelRequire("3Kmf8");

var $8e1dR = parcelRequire("8e1dR");

var $5Qhtn = parcelRequire("5Qhtn");

var $eYXrv = parcelRequire("eYXrv");
const $5f1f5e59a1768f91$var$styles = {
    base: "_0bjKvDKTcp _2sNsIgmnOE _23rrnHoacQ _2V7sgOdnbC _4c065UgVvo _3iDTPbccYA _24h04i2Njc _39xV02IZbP _1EqgXlN91d _1mT5xdRAKS _0hPCNLQame _37wbyuDIqT _17lj8p1Y8M _3YEZNOdnbC _0jFU0VZ49V _1kk5Tkf7mX _03SyCP8HPE _0LQT5E8HPE _2fwxA5DIqT _1RrJLit2nV _2Gfj6iOLYo _0EnhYgPgdg _4lwhQT6wH8 _0dpm39NvrM _2tbAUcYbGa _2WYcYGWVPG",
    interactiveMotion: "_23rrnHyKLB _3sFUREiSCN",
    linkDecorationUnset: "_00uqCYIoZn _3xtjKNOiJt _0H9qDFp3yX _32C2rkyL8i _0i9AWAYbGa _0mm6KQ6wH8 _0DCa9DyL8i _3932vvYbGa _02cRtH6wH8 _3WzCGiyL8i _0NqVRtYbGa _3BKYwu6wH8",
    disabled: "_0wOv4Qsyl5 _0KLXruVrZW _1UtDYzot27 _0GBAIrYbGa _1eOmH6VrZW _0clgaMot27 _3gzVzLVrZW _0CMRbkot27",
    spacingCompact: "_4c065UFQfX _17lj8p1Y8M _03SyCP8HPE _0LQT5E8HPE _1RrJLit2nV _0jFU0V9DVM _39xV029DVM",
    iconButton: "_0jFU0VZ49V _39xV02Z49V _03SyCPPgdg _0LQT5EPgdg",
    circle: "_0bjKvDS5Zs"
};
const $5f1f5e59a1768f91$var$defaultStyles = {
    root: "_0KLXru5FNy _1UtDYzZpcK _0z8nYC9r67 _0GBAIrogpp _2nTuUYZpcK _10n1R5ZpcK _1eOmH6o126 _0clgaMZpcK _3gzVzLN4oS _0CMRbkZpcK"
};
const $5f1f5e59a1768f91$var$primaryStyles = {
    root: "_0KLXruDM2k _1UtDYze5R3 _2nTuUYe5R3 _0clgaMe5R3 _1eOmH6hmrj _0CMRbke5R3 _3gzVzLczkD"
};
const $5f1f5e59a1768f91$var$rovoStyles = {
    root: "_0KLXruWwnm _1UtDYze5R3 _2nTuUYe5R3 _1eOmH63nEM _3gzVzLjYGY"
};
const $5f1f5e59a1768f91$var$discoveryStyles = {
    root: "_0KLXruqjHC _1UtDYze5R3 _2nTuUYe5R3 _0clgaMe5R3 _1eOmH6nIkF _0CMRbke5R3 _3gzVzLSHT5"
};
const $5f1f5e59a1768f91$var$subtleStyles = {
    root: "_0KLXru5FNy _1UtDYzZpcK _2nTuUYZpcK _10n1R5zfdP _1eOmH6o126 _0clgaMZpcK _3gzVzLN4oS _0CMRbkZpcK"
};
const $5f1f5e59a1768f91$var$selectedStyles = {
    root: "_0KLXruY9q9 _1UtDYzjTy9 _0z8nYCrzt2 _0GBAIrogpp _2nTuUYjTy9 _10n1R5jTy9 _0clgaMjTy9 _0CMRbkjTy9",
    discovery: "_0KLXruY9q9 _1UtDYzjTy9 _0clgaMjTy9 _1eOmH6Y9q9 _0CMRbkjTy9 _3gzVzLY9q9"
};
const $5f1f5e59a1768f91$var$LinkIconButtonBase = ({ // Prevent duplicate labels being added.
'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance = 'default', autoFocus: autoFocus = false, href: href, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, newWindowLabel: newWindowLabel, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const localRef = (0, $fsvuC.useRef)(null);
    (0, $cO4y2.default)(localRef, autoFocus);
    if (!isTooltipDisabled) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $3Kmf8.default), {
        content: tooltip?.content ?? label,
        testId: tooltip?.testId,
        position: tooltip?.position,
        delay: tooltip?.delay,
        onShow: tooltip?.onShow,
        onHide: tooltip?.onHide,
        mousePosition: tooltip?.mousePosition,
        analyticsContext: tooltip?.analyticsContext,
        strategy: tooltip?.strategy,
        tag: tooltip?.tag,
        truncate: tooltip?.truncate,
        component: tooltip?.component,
        hideTooltipOnClick: tooltip?.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip?.hideTooltipOnMouseDown,
        hasNewContentOnTriggerClick: tooltip?.hasNewContentOnTriggerClick,
        ignoreTooltipPointerEvents: tooltip?.ignoreTooltipPointerEvents,
        children: (triggerProps)=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $cGW6W.Anchor), {
                ...saferRest,
                "aria-labelledby": ariaLabelledBy,
                newWindowLabel: newWindowLabel,
                testId: testId,
                componentName: "LinkIconButton",
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                // Shared between tooltip and native props
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    saferRest.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    saferRest.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    saferRest.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    saferRest.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    saferRest.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    saferRest.onBlur?.(e);
                },
                // Shared between tooltip and base props
                onClick: (event, analyticsEvent)=>{
                    onClick?.(event, analyticsEvent);
                    triggerProps?.onClick?.(event);
                },
                ref: (0, $fz4Xf.default)([
                    localRef,
                    ref,
                    triggerProps.ref
                ].filter(Boolean)),
                // Base props only
                xcss: (0, $dwUnm.cx)($5f1f5e59a1768f91$var$styles.base, !isDisabled && $5f1f5e59a1768f91$var$styles.interactiveMotion, appearance === 'default' && $5f1f5e59a1768f91$var$defaultStyles.root, appearance === 'primary' && $5f1f5e59a1768f91$var$primaryStyles.root, appearance === 'rovo' && $5f1f5e59a1768f91$var$rovoStyles.root, appearance === 'discovery' && $5f1f5e59a1768f91$var$discoveryStyles.root, appearance === 'subtle' && $5f1f5e59a1768f91$var$subtleStyles.root, $5f1f5e59a1768f91$var$styles.linkDecorationUnset, isSelected && $5f1f5e59a1768f91$var$selectedStyles.root, isSelected && appearance === 'discovery' && $5f1f5e59a1768f91$var$selectedStyles.discovery, isDisabled && $5f1f5e59a1768f91$var$styles.disabled, $5f1f5e59a1768f91$var$styles.iconButton, spacing === 'compact' && $5f1f5e59a1768f91$var$styles.spacingCompact, shape === 'circle' && $5f1f5e59a1768f91$var$styles.circle),
                onMouseDownCapture: onMouseDownCapture,
                onMouseUpCapture: onMouseUpCapture,
                onKeyDownCapture: onKeyDownCapture,
                onKeyUpCapture: onKeyUpCapture,
                onTouchStartCapture: onTouchStartCapture,
                onTouchEndCapture: onTouchEndCapture,
                onPointerDownCapture: onPointerDownCapture,
                onPointerUpCapture: onPointerUpCapture,
                onClickCapture: onClickCapture,
                /**
       * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
       * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
       */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
                href: isDisabled ? undefined : href,
                role: isDisabled ? 'link' : undefined,
                "aria-disabled": isDisabled === true ? true : undefined,
                children: /*#__PURE__*/ (0, $5chsV.jsxs)((0, $5Qhtn.default), {
                    type: "icon",
                    isLoading: false,
                    children: [
                        /*#__PURE__*/ (0, $5chsV.jsx)((0, $eYXrv.default), {
                            icon: icon
                        }),
                        /*#__PURE__*/ (0, $5chsV.jsx)((0, $8e1dR.default), {
                            children: label
                        })
                    ]
                })
            })
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $cGW6W.Anchor), {
        ...saferRest,
        // aria-label={preventedAriaLabel}
        "aria-labelledby": ariaLabelledBy,
        newWindowLabel: newWindowLabel,
        ref: (0, $fz4Xf.default)([
            localRef,
            ref
        ]),
        xcss: (0, $dwUnm.cx)($5f1f5e59a1768f91$var$styles.base, !isDisabled && $5f1f5e59a1768f91$var$styles.interactiveMotion, appearance === 'default' && $5f1f5e59a1768f91$var$defaultStyles.root, appearance === 'primary' && $5f1f5e59a1768f91$var$primaryStyles.root, appearance === 'rovo' && $5f1f5e59a1768f91$var$rovoStyles.root, appearance === 'discovery' && $5f1f5e59a1768f91$var$discoveryStyles.root, appearance === 'subtle' && $5f1f5e59a1768f91$var$subtleStyles.root, $5f1f5e59a1768f91$var$styles.linkDecorationUnset, isSelected && $5f1f5e59a1768f91$var$selectedStyles.root, isSelected && appearance === 'discovery' && $5f1f5e59a1768f91$var$selectedStyles.discovery, isDisabled && $5f1f5e59a1768f91$var$styles.disabled, $5f1f5e59a1768f91$var$styles.iconButton, spacing === 'compact' && $5f1f5e59a1768f91$var$styles.spacingCompact, shape === 'circle' && $5f1f5e59a1768f91$var$styles.circle),
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        testId: testId,
        /**
   * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
   * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
   */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: isDisabled ? undefined : href,
        role: isDisabled ? 'link' : undefined,
        "aria-disabled": isDisabled === true ? true : undefined,
        componentName: "LinkIconButton",
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        children: /*#__PURE__*/ (0, $5chsV.jsxs)((0, $5Qhtn.default), {
            type: "icon",
            isLoading: false,
            children: [
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $eYXrv.default), {
                    icon: icon
                }),
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $8e1dR.default), {
                    children: label
                })
            ]
        })
    });
};
$5f1f5e59a1768f91$var$LinkIconButtonBase.displayName = "LinkIconButtonBase";
// Workarounds to support generic types with forwardRef + memo
const $5f1f5e59a1768f91$var$WithRef = /*#__PURE__*/ (0, $fsvuC.forwardRef)($5f1f5e59a1768f91$var$LinkIconButtonBase);
/**
 * __Link Icon Button__
 *
 * Renders a link in the style of an icon button.
 *
 * - [Examples](https://atlassian.design/components/button/link-icon-button/examples)
 * - [Code](https://atlassian.design/components/button/link-icon-button/code)
 * - [Usage](https://atlassian.design/components/button/link-icon-button/usage)
 */ const $5f1f5e59a1768f91$var$LinkIconButton = /*#__PURE__*/ (0, $fsvuC.memo)($5f1f5e59a1768f91$var$WithRef);
var $5f1f5e59a1768f91$export$2e2bcd8739ae039 = $5f1f5e59a1768f91$var$LinkIconButton;

});

parcelRegister("gTDLR", function(module, exports) {
$parcel$export(module.exports, "default", () => $28355e276abc892e$export$2e2bcd8739ae039);
/* link.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $dwUnm = parcelRequire("dwUnm");

var $fz4Xf = parcelRequire("fz4Xf");

var $cO4y2 = parcelRequire("cO4y2");

var $cGW6W = parcelRequire("cGW6W");

var $5Qhtn = parcelRequire("5Qhtn");

var $eYXrv = parcelRequire("eYXrv");
const $28355e276abc892e$var$styles = {
    base: "_0bjKvDKTcp _2sNsIgmnOE _23rrnHoacQ _2V7sgOdnbC _4c065UgVvo _3iDTPbccYA _24h04i2Njc _39xV02IZbP _1EqgXlN91d _1mT5xdRAKS _0hPCNLQame _37wbyuDIqT _17lj8p1Y8M _3YEZNOdnbC _0jFU0VZ49V _1kk5Tkf7mX _03SyCP8HPE _0LQT5E8HPE _2fwxA5DIqT _1RrJLit2nV _2Gfj6iOLYo _0EnhYgPgdg _4lwhQT6wH8 _0dpm39NvrM _2tbAUcYbGa _2WYcYGWVPG",
    interactiveMotion: "_23rrnHyKLB _3sFUREiSCN",
    linkDecorationUnset: "_00uqCYIoZn _3xtjKNOiJt _0H9qDFp3yX _32C2rkyL8i _0i9AWAYbGa _0mm6KQ6wH8 _0DCa9DyL8i _3932vvYbGa _02cRtH6wH8 _3WzCGiyL8i _0NqVRtYbGa _3BKYwu6wH8",
    disabled: "_0wOv4Qsyl5 _0KLXruVrZW _1UtDYzot27 _0GBAIrYbGa _2nTuUYot27 _1iy5hxVrZW _10n1R5ot27 _1eOmH6VrZW _0clgaMot27 _3gzVzLVrZW _0CMRbkot27",
    spacingCompact: "_4c065UFQfX _17lj8p1Y8M _0jFU0V9DVM _03SyCP8HPE _0LQT5E8HPE _1RrJLit2nV",
    buttonIconBefore: "_0LQT5E8HPE _17lj8pgVvo",
    buttonIconAfter: "_03SyCP8HPE _17lj8pgVvo",
    fullWidth: "_39xV02N91d"
};
const $28355e276abc892e$var$defaultStyles = {
    root: "_0KLXru5FNy _1UtDYzZpcK _0z8nYC9r67 _0GBAIrogpp _2nTuUYZpcK _10n1R5ZpcK _1eOmH6o126 _0clgaMZpcK _3gzVzLN4oS _0CMRbkZpcK"
};
const $28355e276abc892e$var$primaryStyles = {
    root: "_0KLXruDM2k _1UtDYze5R3 _2nTuUYe5R3 _10n1R5e5R3 _0clgaMe5R3 _1eOmH6hmrj _0CMRbke5R3 _3gzVzLczkD"
};
const $28355e276abc892e$var$rovoStyles = {
    root: "_0KLXruWwnm _1UtDYze5R3 _2nTuUYe5R3 _10n1R5e5R3 _1eOmH63nEM _3gzVzLjYGY"
};
const $28355e276abc892e$var$warningStyles = {
    root: "_0KLXruKLKE _1UtDYzVW6T _2nTuUYVW6T _10n1R5VW6T _0clgaMVW6T _1eOmH6OCpk _0CMRbkVW6T _3gzVzLSN2W"
};
const $28355e276abc892e$var$dangerStyles = {
    root: "_0KLXruqsXs _1UtDYze5R3 _2nTuUYe5R3 _10n1R5e5R3 _0clgaMe5R3 _1eOmH6EISo _0CMRbke5R3 _3gzVzLL5fL"
};
const $28355e276abc892e$var$discoveryStyles = {
    root: "_0KLXruqjHC _1UtDYze5R3 _2nTuUYe5R3 _10n1R5e5R3 _0clgaMe5R3 _1eOmH6nIkF _0CMRbke5R3 _3gzVzLSHT5"
};
const $28355e276abc892e$var$subtleStyles = {
    root: "_0KLXru5FNy _1UtDYzZpcK _2nTuUYZpcK _10n1R5zfdP _1eOmH6o126 _0clgaMZpcK _3gzVzLN4oS _0CMRbkZpcK"
};
const $28355e276abc892e$var$selectedStyles = {
    root: "_0KLXruY9q9 _1UtDYzjTy9 _0z8nYCrzt2 _0GBAIrogpp _2nTuUYjTy9 _10n1R5jTy9 _0clgaMjTy9 _0CMRbkjTy9",
    warning: "_0KLXruY9q9 _1UtDYzjTy9 _0clgaMjTy9 _1eOmH6Y9q9 _0CMRbkjTy9 _3gzVzLY9q9",
    danger: "_0KLXruY9q9 _1UtDYzjTy9 _0clgaMjTy9 _1eOmH6Y9q9 _0CMRbkjTy9 _3gzVzLY9q9",
    discovery: "_0KLXruY9q9 _1UtDYzjTy9 _0clgaMjTy9 _1eOmH6Y9q9 _0CMRbkjTy9 _3gzVzLY9q9"
};
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ const $28355e276abc892e$var$LinkButtonBase = ({ analyticsContext: analyticsContext, appearance: appearance = 'default', 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus = false, children: children, href: href, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const hasIconAfter = Boolean(iconAfter);
    const hasIconBefore = Boolean(iconBefore);
    const localRef = (0, $fsvuC.useRef)(null);
    (0, $cO4y2.default)(localRef, autoFocus);
    const combinedRef = (0, $fz4Xf.default)([
        localRef,
        ref
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $cGW6W.Anchor), {
        analyticsContext: analyticsContext,
        ref: combinedRef,
        /**
   * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
   * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
   */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: isDisabled ? undefined : href,
        role: isDisabled ? 'link' : undefined,
        "aria-disabled": isDisabled === true ? true : undefined,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        testId: testId,
        componentName: "LinkButton",
        interactionName: interactionName,
        ...saferRest,
        xcss: (0, $dwUnm.cx)($28355e276abc892e$var$styles.base, !isDisabled && $28355e276abc892e$var$styles.interactiveMotion, appearance === 'default' && $28355e276abc892e$var$defaultStyles.root, appearance === 'primary' && $28355e276abc892e$var$primaryStyles.root, appearance === 'rovo' && $28355e276abc892e$var$rovoStyles.root, appearance === 'warning' && $28355e276abc892e$var$warningStyles.root, appearance === 'danger' && $28355e276abc892e$var$dangerStyles.root, appearance === 'discovery' && $28355e276abc892e$var$discoveryStyles.root, appearance === 'subtle' && $28355e276abc892e$var$subtleStyles.root, $28355e276abc892e$var$styles.linkDecorationUnset, isSelected && $28355e276abc892e$var$selectedStyles.root, isSelected && appearance === 'danger' && $28355e276abc892e$var$selectedStyles.danger, isSelected && appearance === 'warning' && $28355e276abc892e$var$selectedStyles.warning, isSelected && appearance === 'discovery' && $28355e276abc892e$var$selectedStyles.discovery, isDisabled && $28355e276abc892e$var$styles.disabled, spacing === 'compact' && $28355e276abc892e$var$styles.spacingCompact, hasIconBefore && $28355e276abc892e$var$styles.buttonIconBefore, hasIconAfter && $28355e276abc892e$var$styles.buttonIconAfter, shouldFitContainer && $28355e276abc892e$var$styles.fullWidth),
        children: [
            iconBefore && /*#__PURE__*/ (0, $5chsV.jsx)((0, $5Qhtn.default), {
                type: "icon",
                position: "before",
                isLoading: false,
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $eYXrv.default), {
                    icon: iconBefore
                })
            }),
            children && /*#__PURE__*/ (0, $5chsV.jsx)((0, $5Qhtn.default), {
                isLoading: false,
                children: children
            }),
            iconAfter && /*#__PURE__*/ (0, $5chsV.jsx)((0, $5Qhtn.default), {
                type: "icon",
                position: "after",
                isLoading: false,
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $eYXrv.default), {
                    icon: iconAfter
                })
            })
        ]
    });
};
$28355e276abc892e$var$LinkButtonBase.displayName = "LinkButtonBase";
// Workarounds to support generic types with forwardRef
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ const $28355e276abc892e$var$LinkButton = /*#__PURE__*/ (0, $fsvuC.forwardRef)($28355e276abc892e$var$LinkButtonBase);
$28355e276abc892e$var$LinkButton.displayName = 'LinkButton';
var $28355e276abc892e$export$2e2bcd8739ae039 = $28355e276abc892e$var$LinkButton;

});

parcelRegister("hTGok", function(module, exports) {
$parcel$export(module.exports, "default", () => $6b49508482dbb7a2$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $fz4Xf = parcelRequire("fz4Xf");

var $gEkQX = parcelRequire("gEkQX");

var $1pyTQ = parcelRequire("1pyTQ");

var $h0PRs = parcelRequire("h0PRs");

var $llCao = parcelRequire("llCao");

var $7damY = parcelRequire("7damY");
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ const $6b49508482dbb7a2$var$DropdownMenuItem = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, role: role, ...rest }, ref)=>{
    // Nested submenu triggers register with the focus manager inside DropdownMenu.
    // Dialog triggers must register here so arrow navigation can reach them.
    const isNestedTrigger = !!rest['aria-haspopup'] && rest['aria-haspopup'] !== 'dialog';
    const itemRef = (0, $7damY.default)(isNestedTrigger);
    const handleItemClick = (0, $fsvuC.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $1pyTQ.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $fz4Xf.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest,
        children: children
    });
    else if (href) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $h0PRs.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $fz4Xf.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        interactionName: interactionName,
        ...rest,
        children: children
    });
    else return /*#__PURE__*/ (0, $5chsV.jsx)((0, $gEkQX.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $fz4Xf.default)([
            ref,
            itemRef
        ]),
        role: role || 'menuitem',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest,
        ...isNestedTrigger && (0, $llCao.fg)('platform_dst_dropdown_nested_trigger_aria_current') ? {
            'aria-current': undefined
        } : {},
        children: children
    });
});
var $6b49508482dbb7a2$export$2e2bcd8739ae039 = $6b49508482dbb7a2$var$DropdownMenuItem;

});
parcelRegister("gEkQX", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e1f1079f28abea8$export$2e2bcd8739ae039);
/* button-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $lNjwN = parcelRequire("lNjwN");

var $kYV05 = parcelRequire("kYV05");
/**
 * __Button item__
 *
 * A button item is used to populate a menu with items that are buttons.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/button-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $2e1f1079f28abea8$var$ButtonItem = /*#__PURE__*/ (0, $fsvuC.memo)(/*#__PURE__*/ (0, $fsvuC.forwardRef)((props, ref)=>{
    const { children: children, description: description, iconAfter: iconAfter, iconBefore: iconBefore, isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, interactionName: interactionName, ...rest } = props;
    const onMouseDownHandler = onMouseDown;
    const interactionContext = (0, $fsvuC.useContext)((0, $lNjwN.default));
    const handleClick = (0, $fsvuC.useCallback)((e)=>{
        interactionContext?.tracePress(interactionName, e.timeStamp);
        onClick?.(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $kYV05.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        ...rest,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        isTitleHeading: false,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && `${testId}--primitive`,
        children: ({ children: children, className: className })=>/*#__PURE__*/ (0, $5chsV.jsx)("button", {
                "data-testid": testId,
                // This is intentionally placed before the `...rest` spread to prevent overriding existing usages of `aria-current`,
                // which are already being passed to the button element.
                "aria-current": isSelected ? 'true' : undefined,
                ...rest,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                ref: ref,
                disabled: isDisabled,
                onClick: handleClick,
                onMouseDown: onMouseDownHandler,
                type: "button",
                children: children
            })
    });
}));
var $2e1f1079f28abea8$export$2e2bcd8739ae039 = $2e1f1079f28abea8$var$ButtonItem;

});
parcelRegister("kYV05", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f11f855ea0df006$export$2e2bcd8739ae039);
/* menu-item-primitive.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $cogH0 = parcelRequire("cogH0");

var $9BiiY = parcelRequire("9BiiY");

var $io8Sm = parcelRequire("io8Sm");
const $1f11f855ea0df006$var$renderTitle = (Component, props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $5chsV.jsx)(Component, {
        ...props
    });
const $1f11f855ea0df006$var$styles = {
    root: "_30huDKdnbC _2xIroY98eZ _497WNwYbGa _2zndICdnbC _00uqCYyL8i _3xtjKNYbGa _0H9qDF6wH8 _1mT5xdRAKS _3iDTPbQ4SZ _24h04i2Njc _39xV02N91d _4kiQYAUF4f _43nrzTPgdg _2xTnZxPgdg _0rIjykPgdg _0GTcwRPgdg _0hPCNLDIqT _20VacPYbGa _0wOv4Q7zJH _2hGPVj98eZ _2i3C1kYbGa _2kH23qT6kp _1zr6DcnXvL _1ubuxonXvL _38a67RZPSy _34b3D2ZPSy _0htemX6wH8 _1NDpvb6wH8 _067Lcevc3e _2wtOC9vc3e _0DCa9DyL8i _3932vvYbGa _02cRtH6wH8 _3e11vU6wH8 _0hSAgbHZdu",
    beforeAfterElement: "_3iDTPbQ4SZ _4ouGXIoWWg _4kiQYAoWWg _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC",
    content: "_2xIroY98eZ _497WNwYbGa _2zndICT6kp _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _2O5Vij7dHp _2fwxA5ecOK",
    truncate: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _39HuIbz8Lp _1ANEUSLRg7",
    title: "_2sNsIgmnOE",
    wordBreak: "_3W2Oc8wPeg",
    description: "_2sNsIg7NXe _1UtDYzKGUX",
    disabledDescription: "_1UtDYzot27",
    unselected: "_0KLXru5FNy _1UtDYz98eZ _2nTuUY98eZ _1eOmH6o126 _0clgaM98eZ _3gzVzLo126 _0CMRbk98eZ",
    disabled: "_0wOv4Qsyl5 _0KLXru5FNy _1UtDYzot27 _1eOmH65FNy _0clgaMot27 _3gzVzL5FNy _0CMRbkot27",
    selectedBorder: "_3ScelF4Jdh _3dCYwDWVPG _4diMdqrzt2 _3Ku51Iogpp _3p3AmIPgdg _1cR5ZLPgdg _2jTvwtPgdg",
    selectedNotch: "_1OimfuMLSV _3ScelFUNDJ _3dCYwDWVPG _4diMdqrzt2 _3Ku51Iogpp _3p3AmI8HPE _1cR5ZL8HPE _2jTvwtPgdg",
    selected: "_0KLXruY9q9 _1UtDYzjTy9 _2nTuUYjTy9 _1eOmH6sumd _0clgaM866Z _3gzVzLXsxn _0CMRbkjTy9",
    selectedOld: "_0clgaMjTy9",
    motionUnselected: "_23rrnHo10F _1B4rbIo10F _3sFUREDdj4",
    motionSelected: "_23rrnHWE38 _1B4rbIo10F"
};
const $1f11f855ea0df006$var$spacingMapStyles = {
    cozy: "_4c065U2ADO _2Y7lL45zaO",
    compact: "_4c065U1Y8M _2Y7lL48HPE _4kiQYAUofl"
};
const $1f11f855ea0df006$var$gapMap = {
    compact: 'space.100',
    cozy: 'space.150'
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ const $1f11f855ea0df006$var$MenuItemPrimitive = ({ children: children, title: title, description: description, iconAfter: iconAfter, iconBefore: iconBefore, className: UNSAFE_externalClassName, shouldTitleWrap: shouldTitleWrap = false, shouldDescriptionWrap: shouldDescriptionWrap = false, isDisabled: isDisabled = false, isSelected: isSelected = false, isTitleHeading: isTitleHeading = false, testId: testId })=>{
    const spacing = (0, $fsvuC.useContext)((0, $9BiiY.SpacingContext));
    const selectionStyle = (0, $fsvuC.useContext)((0, $io8Sm.SELECTION_STYLE_CONTEXT_DO_NOT_USE));
    const UNSAFE_className = UNSAFE_externalClassName;
    return (()=>{
        return children({
            className: (0, $gJ6nT.default)([
                (0, $gJ6nT.default)([
                    $1f11f855ea0df006$var$styles.root,
                    $1f11f855ea0df006$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $1f11f855ea0df006$var$styles.unselected,
                    !isDisabled && !isSelected && $1f11f855ea0df006$var$styles.motionUnselected,
                    !isDisabled && isSelected && $1f11f855ea0df006$var$styles.selected,
                    !isDisabled && isSelected && $1f11f855ea0df006$var$styles.motionSelected,
                    !isDisabled && isSelected && $1f11f855ea0df006$var$styles.selectedOld,
                    !isDisabled && isSelected && selectionStyle === 'border' && $1f11f855ea0df006$var$styles.selectedBorder,
                    !isDisabled && isSelected && selectionStyle === 'notch' && $1f11f855ea0df006$var$styles.selectedNotch,
                    isDisabled && $1f11f855ea0df006$var$styles.disabled
                ]),
                UNSAFE_className
            ]),
            children: /*#__PURE__*/ (0, $5chsV.jsxs)((0, $cogH0.Inline), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $1f11f855ea0df006$var$gapMap[spacing],
                grow: "fill",
                testId: testId && `${testId}--container`,
                children: [
                    iconBefore && /*#__PURE__*/ (0, $5chsV.jsx)("span", {
                        "data-item-elem-before": true,
                        "data-testid": testId && `${testId}--icon-before`,
                        className: (0, $gJ6nT.default)([
                            $1f11f855ea0df006$var$styles.beforeAfterElement
                        ]),
                        children: iconBefore
                    }),
                    title && /*#__PURE__*/ (0, $5chsV.jsxs)("div", {
                        className: (0, $gJ6nT.default)([
                            $1f11f855ea0df006$var$styles.content
                        ]),
                        children: [
                            $1f11f855ea0df006$var$renderTitle(isTitleHeading ? 'h2' : 'span', {
                                children: title,
                                className: (0, $gJ6nT.default)([
                                    $1f11f855ea0df006$var$styles.title,
                                    shouldTitleWrap ? $1f11f855ea0df006$var$styles.wordBreak : $1f11f855ea0df006$var$styles.truncate
                                ]),
                                'data-item-title': true
                            }),
                            description && /*#__PURE__*/ (0, $5chsV.jsx)("span", {
                                "data-item-description": true,
                                className: (0, $gJ6nT.default)([
                                    $1f11f855ea0df006$var$styles.description,
                                    isDisabled && $1f11f855ea0df006$var$styles.disabledDescription,
                                    shouldDescriptionWrap && $1f11f855ea0df006$var$styles.wordBreak,
                                    !shouldDescriptionWrap && $1f11f855ea0df006$var$styles.truncate
                                ]),
                                children: description
                            })
                        ]
                    }),
                    iconAfter && /*#__PURE__*/ (0, $5chsV.jsx)("span", {
                        "data-item-elem-after": true,
                        "data-testid": testId && `${testId}--icon-after`,
                        className: (0, $gJ6nT.default)([
                            $1f11f855ea0df006$var$styles.beforeAfterElement
                        ]),
                        children: iconAfter
                    })
                ]
            })
        });
    })();
};
$1f11f855ea0df006$var$MenuItemPrimitive.displayName = "MenuItemPrimitive";
var $1f11f855ea0df006$export$2e2bcd8739ae039 = $1f11f855ea0df006$var$MenuItemPrimitive;

});


parcelRegister("1pyTQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $56fb8a4288b2badd$export$2e2bcd8739ae039);
/* custom-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $lNjwN = parcelRequire("lNjwN");

var $kYV05 = parcelRequire("kYV05");
const $56fb8a4288b2badd$var$preventEvent = (e)=>{
    e.preventDefault();
};
/**
 * __Custom item__
 *
 * @deprecated
 * CustomItem must not be used and will be deleted soon. Custom menu items are not supported.
 * Use ButtonItem or LinkItem instead. If you need a custom list item, do not use `@atlaskit/menu`.
 *
 * A custom item is used to populate a menu with items that can be any element.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/custom-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $56fb8a4288b2badd$var$CustomItem = /*#__PURE__*/ (0, $fsvuC.memo)(/*#__PURE__*/ (0, $fsvuC.forwardRef)(({ component: Component, isDisabled: isDisabled = false, isSelected: isSelected = false, isTitleHeading: isTitleHeading = false, onClick: onClick, testId: testId, children: children, description: description, iconAfter: iconAfter, iconBefore: iconBefore, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, UNSAFE_isDraggable: UNSAFE_isDraggable, interactionName: interactionName, ...rest }, ref)=>{
    const onMouseDownHandler = onMouseDown;
    const interactionContext = (0, $fsvuC.useContext)((0, $lNjwN.default));
    const handleClick = (0, $fsvuC.useCallback)((e)=>{
        interactionContext?.tracePress(interactionName, e.timeStamp);
        onClick?.(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!Component) return null;
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $kYV05.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        ...rest,
        description: description,
        iconAfter: iconAfter,
        title: children,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: isTitleHeading,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && `${testId}--primitive`,
        children: ({ children: children, className: className })=>/*#__PURE__*/ (0, $5chsV.jsx)(Component, {
                "data-testid": testId,
                ...rest,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                ref: ref,
                ...UNSAFE_isDraggable ? {} : {
                    draggable: false,
                    onDragStart: $56fb8a4288b2badd$var$preventEvent
                },
                onMouseDown: isDisabled ? $56fb8a4288b2badd$var$preventEvent : onMouseDownHandler,
                onClick: isDisabled ? $56fb8a4288b2badd$var$preventEvent : handleClick,
                tabIndex: isDisabled ? -1 : undefined,
                "aria-disabled": isDisabled || undefined,
                children: children
            })
    });
}));
var $56fb8a4288b2badd$export$2e2bcd8739ae039 = $56fb8a4288b2badd$var$CustomItem;

});

parcelRegister("h0PRs", function(module, exports) {
$parcel$export(module.exports, "default", () => $2dca3d7858c4ebe6$export$2e2bcd8739ae039);
/* link-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gVC77 = parcelRequire("gVC77");

var $lNjwN = parcelRequire("lNjwN");

var $kYV05 = parcelRequire("kYV05");
const $2dca3d7858c4ebe6$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $2dca3d7858c4ebe6$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
const $2dca3d7858c4ebe6$var$preventEvent = (e)=>{
    e.preventDefault();
};
/**
 * __Link item__
 *
 * A link item is used to populate a menu with items that are links.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $2dca3d7858c4ebe6$var$LinkItem = /*#__PURE__*/ (0, $fsvuC.memo)(/*#__PURE__*/ (0, $fsvuC.forwardRef)((props, ref)=>{
    const { children: children, href: href, description: description, iconAfter: iconAfter, iconBefore: iconBefore, isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable: UNSAFE_isDraggable, interactionName: interactionName, ...rest } = props;
    const onMouseDownHandler = onMouseDown;
    const RouterLink = (0, $gVC77.useRouterLink)();
    const interactionContext = (0, $fsvuC.useContext)((0, $lNjwN.default));
    const handleClick = (0, $fsvuC.useCallback)((e)=>{
        interactionContext?.tracePress(interactionName, e.timeStamp);
        onClick?.(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    const isExternal = typeof href === 'string' && $2dca3d7858c4ebe6$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $2dca3d7858c4ebe6$var$IS_NON_HTTP_BASED.test(href);
    const isEmptyHref = href == null || href === '';
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.)
   * - it doesn't have an empty href (e.g. href="" or href={undefined})
   */ const isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased && !isEmptyHref;
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $kYV05.default), {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: false,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        title: children,
        testId: testId && `${testId}--primitive`,
        children: ({ children: children, className: className })=>/*#__PURE__*/ (0, $5chsV.jsx)(Component, {
                "data-testid": testId,
                "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
                "data-vc": "link-item",
                ...rest,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                // @ts-expect-error
                href: isDisabled ? undefined : href,
                ...UNSAFE_isDraggable ? {} : {
                    draggable: false,
                    onDragStart: $2dca3d7858c4ebe6$var$preventEvent
                },
                onMouseDown: isDisabled ? $2dca3d7858c4ebe6$var$preventEvent : onMouseDownHandler,
                onClick: isDisabled ? $2dca3d7858c4ebe6$var$preventEvent : handleClick,
                "aria-current": isSelected ? 'page' : undefined,
                "aria-disabled": isDisabled || undefined,
                ref: ref,
                children: children
            })
    });
}));
var $2dca3d7858c4ebe6$export$2e2bcd8739ae039 = $2dca3d7858c4ebe6$var$LinkItem;

});


parcelRegister("3R2Wy", function(module, exports) {
$parcel$export(module.exports, "default", () => $4088683f4eb1db47$export$2e2bcd8739ae039);

var $fsvuC = parcelRequire("fsvuC");
var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $4088683f4eb1db47$export$2e2bcd8739ae039 = (0, $fsvuC.forwardRef);

});

parcelRegister("itXZv", function(module, exports) {
$parcel$export(module.exports, "default", () => $f4bd61d938743d18$export$2e2bcd8739ae039);
/* avatar.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $mhEfz = parcelRequire("mhEfz");

var $cTXsj = parcelRequire("cTXsj");

var $llCao = parcelRequire("llCao");

var $iBCyw = parcelRequire("iBCyw");

var $cwS28 = parcelRequire("cwS28");

var $34UXi = parcelRequire("34UXi");

var $jSIZf = parcelRequire("jSIZf");

var $9Qrxv = parcelRequire("9Qrxv");

var $76ZVa = parcelRequire("76ZVa");

var $1y9wE = parcelRequire("1y9wE");

var $cT19d = parcelRequire("cT19d");
const $f4bd61d938743d18$var$packageName = "platform-pkg";
const $f4bd61d938743d18$var$packageVersion = "0.0.0-use.local";
const $f4bd61d938743d18$var$containerStyles = null;
const $f4bd61d938743d18$var$updatedHexagonNegativeMarginMap = {
    xxsmall: "_0rIjykJnIq _43nrzTJnIq",
    small: "_0rIjykwUPW _43nrzTwUPW",
    medium: "_0rIjykP0CX _43nrzTP0CX",
    large: "_0rIjykO0L5 _43nrzTO0L5",
    xlarge: "_0rIjykFQC7 _43nrzTFQC7",
    xxlarge: "_0rIjykaf0R _43nrzTaf0R"
};
const $f4bd61d938743d18$var$normalizeAvatarSize = (size)=>size === 'xsmall' && !(0, $llCao.fg)('platform_design-system-team_avatar-remove-xsmall') ? 'xxsmall' : size; /**
                                                                                                                                                            * Popup trigger ARIA attributes are optional. Use `aria-controls` to identify
                                                                                                                                                            * the popup and `aria-expanded` to announce whether it is open. An
                                                                                                                                                            * `aria-haspopup` value indicating a popup renders Avatar as a button,
                                                                                                                                                            * even when `onClick` is absent.
                                                                                                                                                            */ 
const $f4bd61d938743d18$var$Avatar = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ analyticsContext: analyticsContext, appearance: appearance = 'circle', UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry, label: label, borderColor: borderColor, children: children, href: href, isDisabled: isDisabled, name: name, onClick: onClick, presence: presence, size: sizeProp, src: src, stackIndex: stackIndex, status: status, target: target, testId: testId, as: AvatarContainer = 'div', imgLoading: imgLoading, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $mhEfz.useAnalyticsEvents)();
    const context = (0, $cT19d.useAvatarContext)();
    const size = $f4bd61d938743d18$var$normalizeAvatarSize(sizeProp || context?.size || 'medium');
    const isUpdatedHexagonGeometry = appearance === 'hexagon' && Boolean(UNSAFE_isUpdatedGeometry) && size !== 'UNSAFE_xsmall';
    const customPresenceNode = /*#__PURE__*/ (0, $fsvuC.isValidElement)(presence) ? presence : null;
    const customStatusNode = /*#__PURE__*/ (0, $fsvuC.isValidElement)(status) ? status : null;
    const isValidIconSize = size !== 'xxlarge' && size !== 'xxsmall' && size !== 'xsmall'; // Presence/status indicators are only defined for `IndicatorSizeType`
    // (small, medium, large, xlarge). Compute `indicatorSize` only for sizes
    // that support an indicator (`isValidIconSize`), so the value is
    // structurally guaranteed to be a valid `IndicatorSizeType` rather than
    // relying on the guard at each call site. The `UNSAFE_xsmall` (20px) size
    // reuses the `small` indicator sizing as its nearest supported neighbor;
    // unsupported sizes (`xxsmall`/`xsmall`/`xxlarge`) fall back to `small` and are never
    // actually rendered because `isPresence`/`isStatus` also guard on
    // `isValidIconSize`.
    const indicatorSize = !isValidIconSize ? 'small' : size === 'UNSAFE_xsmall' ? 'small' : size;
    const lastAnalytics = (0, $fsvuC.useRef)(analyticsContext);
    const labelId = (0, $cTXsj.useId)();
    (0, $fsvuC.useEffect)(()=>{
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    const onClickHandler = (0, $fsvuC.useCallback)((event)=>{
        if (isDisabled || typeof onClick !== 'function') return;
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'avatar',
            attributes: {
                componentName: 'avatar',
                packageName: $f4bd61d938743d18$var$packageName,
                packageVersion: $f4bd61d938743d18$var$packageVersion
            }
        }); /**
         * To avoid wrapping this component in AnalyticsContext we manually
         * push the parent context's meta data into the context.
         */ 
        const context = {
            componentName: 'avatar',
            packageName: $f4bd61d938743d18$var$packageName,
            packageVersion: $f4bd61d938743d18$var$packageVersion,
            ...lastAnalytics.current
        };
        analyticsEvent.context.push(context); /**
                                           * Replicating the logic in the `withAnalyticsEvents` HOC.
                                           */ 
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    const isPresence = isValidIconSize && presence && !status;
    const isStatus = isValidIconSize && status; // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    const defaultLabel = [
        name,
        isStatus && !customStatusNode && `(${status})`,
        isPresence && !customPresenceNode && `(${presence})`
    ].filter(Boolean).join(' ');
    const isInteractive = onClick || href || isDisabled || ariaHasPopup;
    const containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $jSIZf.EnsureIsInsideAvatarContext).Provider, {
        value: true,
        children: /*#__PURE__*/ (0, $5chsV.jsxs)(AvatarContainer, {
            "data-testid": testId,
            role: containerShouldBeImage ? 'img' : undefined,
            "aria-labelledby": containerShouldBeImage ? labelId : undefined,
            style: {
                zIndex: stackIndex
            },
            className: (0, $gJ6nT.default)([
                "_2xIroY98eZ _497WNwYbGa _2zndICdnbC _3iDTPbvbI6 _1mT5xdRAKS",
                isUpdatedHexagonGeometry && $f4bd61d938743d18$var$updatedHexagonNegativeMarginMap[size]
            ]),
            children: [
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $34UXi.AvatarContentContext).Provider, {
                    value: {
                        as: (0, $9Qrxv.default)(isDisabled, href, onClick, ariaHasPopup),
                        appearance: appearance,
                        UNSAFE_isUpdatedGeometry: isUpdatedHexagonGeometry,
                        borderColor: borderColor,
                        href: href,
                        isDisabled: isDisabled,
                        label: label || defaultLabel,
                        onClick: isInteractive ? onClickHandler : undefined,
                        ref: ref,
                        size: size,
                        stackIndex: stackIndex,
                        target: target,
                        testId: testId ? `${testId}--inner` : undefined,
                        'aria-controls': ariaControls,
                        'aria-expanded': ariaExpanded,
                        'aria-haspopup': ariaHasPopup,
                        avatarImage: /*#__PURE__*/ (0, $5chsV.jsx)((0, $cwS28.default), {
                            alt: !containerShouldBeImage && src ? name : undefined,
                            src: src,
                            appearance: appearance,
                            UNSAFE_isUpdatedGeometry: isUpdatedHexagonGeometry,
                            size: size,
                            testId: testId,
                            imgLoading: imgLoading
                        })
                    },
                    children: children || /*#__PURE__*/ (0, $5chsV.jsx)((0, $iBCyw.AvatarContent), {})
                }),
                isPresence && /*#__PURE__*/ (0, $5chsV.jsx)((0, $76ZVa.default), {
                    appearance: appearance,
                    size: indicatorSize,
                    presence: typeof presence === 'string' ? presence : undefined,
                    testId: testId,
                    children: customPresenceNode
                }),
                isStatus && /*#__PURE__*/ (0, $5chsV.jsx)((0, $1y9wE.default), {
                    appearance: appearance,
                    size: indicatorSize,
                    borderColor: borderColor,
                    status: typeof status === 'string' ? status : undefined,
                    testId: testId,
                    children: customStatusNode
                }),
                containerShouldBeImage ? /*#__PURE__*/ (0, $5chsV.jsx)("span", {
                    "data-testid": testId && `${testId}--label`,
                    id: labelId,
                    hidden: true,
                    children: defaultLabel
                }) : undefined
            ]
        })
    });
});
$f4bd61d938743d18$var$Avatar.displayName = 'Avatar';
var $f4bd61d938743d18$export$2e2bcd8739ae039 = $f4bd61d938743d18$var$Avatar;

});
parcelRegister("iBCyw", function(module, exports) {
$parcel$export(module.exports, "AvatarContent", () => $e8585df2e8a7661f$export$47fbc0b44cae5559);
/* avatar-content.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $llCao = parcelRequire("llCao");

var $34UXi = parcelRequire("34UXi");

var $eEkRB = parcelRequire("eEkRB");
const $e8585df2e8a7661f$var$boxShadowCssVar = '--avatar-box-shadow';
const $e8585df2e8a7661f$var$bgColorCssVar = '--avatar-bg-color';
const $e8585df2e8a7661f$var$styles = {
    root: "_30huDKYbGa _2xIroY98eZ _497WNwYbGa _2zndICT6kp _4bt5LAnQyn _2WAcuGnQyn _23rrnHiNRm _3iDTPbQ4SZ _1mT5xd5HSx _0hPCNLFlnN _37wbyuDIqT _0aFT5vbt8w _0wOv4QOLYo _0rIjykFQfX _43nrzTFQfX _2xTnZxFQfX _0GTcwRFQfX _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg _1VJPcaeKTE _0EnhYgPgdg _1JM8vv4Jcb _2jfUf9N91d _2WYcYGWVPG _3wEj0XyL8i _0GBAIrJ5bs _43i6GSdnbC _2tbAUcYbGa _3kPd40YbGa _1ubuxonXvL _34b3D2FQfX _1NDpvb6wH8 _2wtOC9vc3e _0hSAgbNvrM",
    circle: "_0bjKvDaaQb _2Gfj6iaaQb",
    square: "_0bjKvD0O7w",
    positionRelative: "_1mT5xdRAKS",
    disabled: "_0wOv4Qsyl5 _3wEj0XlfZc _43i6GSVx3j"
};
const $e8585df2e8a7661f$var$unboundStyles = {
    root: "_2uo31fVZWJ _24h04iyL8i _2OUyjtrcoi",
    hexagonFocusContainer: "_4c065U9E27 _2Y7lL42M4S _3SamIHoYZL _2YLqiKnBff _0KLXruyL8i _1uo2ZfTcEg _3YCJEinXvL",
    updatedHexagonClipPath: "_1uo2ZfEXe0",
    hexagonBorderContainer: "_2uo31fVZWJ _4c065U7oRc _2Y7lL4Aa7o _3SamIHzX4W _2YLqiKTz7d _1uo2ZfOLYo _3YCJEilfZc",
    hexagon: "_0bjKvDdnbC _1uo2ZfOLYo _2OUyjtZqHV _2Gfj6idnbC _3kPd40ZqHV _2wtOC9dnbC _0hSAgbdnbC",
    interactive: "_0wOv4Q7zJH _0jKh9gMC01 _0ZgYXI7dHp _14Uf36qui9 _0WVYA37dHp _1if2KaHZdu",
    interactiveMotion: "_23rrnHimX9 _1sLQ8qC67X _3NJLv82rpu"
};
const $e8585df2e8a7661f$var$hexagonBorderFixStyles = {
    hexagonBorderContainer: "_0xmtkoUduD _46hvQmUduD _03SyCPUduD _0LQT5EUduD _0rIjykPM89 _43nrzTPM89 _2xTnZxPM89 _0GTcwRPM89",
    hexagonFocusContainer: "_0xmtko7SV6 _46hvQm7SV6 _03SyCP7SV6 _0LQT5E7SV6 _0rIjykAoU6 _43nrzTAoU6 _2xTnZxAoU6 _0GTcwRAoU6"
};
// See https://hello.atlassian.net/wiki/spaces/DST/pages/7432283012
const $e8585df2e8a7661f$var$updatedHexagonBorderFixStyles = {
    hexagonBorderContainer: "_0xmtkofkS7 _46hvQmfkS7 _03SyCPdnbC _0LQT5EdnbC _0rIjyk5hfz _43nrzT5hfz _2xTnZxdnbC _0GTcwRdnbC",
    hexagonFocusContainer: "_0xmtkoQVeh _46hvQmQVeh _03SyCP2M4S _0LQT5E2M4S _0rIjyk59JZ _43nrzT59JZ _2xTnZxnBff _0GTcwRnBff"
};
const $e8585df2e8a7661f$var$widthHeightMap = {
    xxsmall: "_39xV02ey7F _0jFU0Vey7F",
    xsmall: "_39xV02ey7F _0jFU0Vey7F",
    UNSAFE_xsmall: "_39xV02SPN1 _0jFU0VSPN1",
    small: "_39xV02oWWg _0jFU0VoWWg",
    medium: "_39xV02Uofl _0jFU0VUofl",
    large: "_39xV02UF4f _0jFU0VUF4f",
    xlarge: "_39xV02JgOI _0jFU0VJgOI",
    xxlarge: "_39xV02NNui _0jFU0VNNui"
};
// The sole source of truth for the updated hexagon width/height geometry (per size).
const $e8585df2e8a7661f$var$updatedHexagonDimensionMap = {
    xxsmall: "_39xV02EGCh _0jFU0VQSd4",
    small: "_39xV021R6D _0jFU0V7qhK",
    medium: "_39xV02U2XU _0jFU0VRlO4",
    large: "_39xV02s3iu _0jFU0VNmyB",
    xlarge: "_39xV02OhVQ _0jFU0VHWFU",
    xxlarge: "_39xV02c73x _0jFU0VSk01"
};
const $e8585df2e8a7661f$export$47fbc0b44cae5559 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ children: children }, ref)=>{
    (0, $eEkRB.useEnsureIsInsideAvatar)();
    const { as: Container, appearance: appearance, UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry, avatarImage: avatarImage, borderColor: borderColor = "var(--ds-surface, #FFFFFF)", href: href, isDisabled: isDisabled, label: label, onClick: onClick, ref: contextRef, tabIndex: tabIndex, target: target, testId: testId, size: size, stackIndex: stackIndex, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup } = (0, $fsvuC.useContext)((0, $34UXi.AvatarContentContext));
    const isInteractive = Boolean(onClick || href || isDisabled || ariaHasPopup);
    const renderedContent = /*#__PURE__*/ (0, $5chsV.jsx)(Container, {
        style: {
            [$e8585df2e8a7661f$var$bgColorCssVar]: borderColor,
            [$e8585df2e8a7661f$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        ref: ref || contextRef,
        "aria-label": isInteractive ? label : undefined,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        onClick: onClick,
        tabIndex: tabIndex,
        "data-testid": testId,
        disabled: isDisabled,
        type: Container === 'button' ? 'button' : undefined,
        ...href && {
            href: href,
            target: target,
            rel: target === '_blank' ? 'noopener noreferrer' : undefined
        },
        className: (0, $gJ6nT.default)([
            $e8585df2e8a7661f$var$unboundStyles.root,
            $e8585df2e8a7661f$var$styles.root,
            appearance === 'square' && $e8585df2e8a7661f$var$styles.square,
            appearance === 'circle' && $e8585df2e8a7661f$var$styles.circle,
            appearance === 'hexagon' && $e8585df2e8a7661f$var$unboundStyles.hexagon,
            $e8585df2e8a7661f$var$widthHeightMap[size],
            UNSAFE_isUpdatedGeometry && $e8585df2e8a7661f$var$updatedHexagonDimensionMap[size],
            stackIndex !== undefined && $e8585df2e8a7661f$var$styles.positionRelative,
            isInteractive && !isDisabled && $e8585df2e8a7661f$var$unboundStyles.interactive,
            isInteractive && !isDisabled && appearance !== 'hexagon' && (0, $llCao.fg)('platform-dst-motion-uplift') && $e8585df2e8a7661f$var$unboundStyles.interactiveMotion,
            isDisabled && $e8585df2e8a7661f$var$styles.disabled
        ]),
        children: children || avatarImage
    });
    if (appearance !== 'hexagon') return renderedContent;
    // For a Hexagon Avatar in order to have hexagonal "border" and "outline", we have to
    // layer multiple elements and use their background colors to create the different layers.
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        style: {
            [$e8585df2e8a7661f$var$bgColorCssVar]: borderColor,
            [$e8585df2e8a7661f$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        "data-testid": testId ? `${testId}-hexagon-focus-container` : 'hexagon-focus-container',
        className: (0, $gJ6nT.default)([
            $e8585df2e8a7661f$var$unboundStyles.hexagonFocusContainer,
            UNSAFE_isUpdatedGeometry && $e8585df2e8a7661f$var$unboundStyles.updatedHexagonClipPath,
            isInteractive && !isDisabled && (0, $llCao.fg)('platform-dst-motion-uplift') && $e8585df2e8a7661f$var$unboundStyles.interactiveMotion,
            UNSAFE_isUpdatedGeometry && $e8585df2e8a7661f$var$updatedHexagonBorderFixStyles.hexagonFocusContainer,
            (0, $llCao.fg)('platform_editor_agent_mentions_drop_one_fixes') && !UNSAFE_isUpdatedGeometry && $e8585df2e8a7661f$var$hexagonBorderFixStyles.hexagonFocusContainer
        ]),
        children: /*#__PURE__*/ (0, $5chsV.jsx)("div", {
            "data-testid": testId ? `${testId}-hexagon-border-container` : 'hexagon-border-container',
            className: (0, $gJ6nT.default)([
                $e8585df2e8a7661f$var$unboundStyles.hexagonBorderContainer,
                UNSAFE_isUpdatedGeometry && $e8585df2e8a7661f$var$updatedHexagonBorderFixStyles.hexagonBorderContainer,
                (0, $llCao.fg)('platform_editor_agent_mentions_drop_one_fixes') && !UNSAFE_isUpdatedGeometry && $e8585df2e8a7661f$var$hexagonBorderFixStyles.hexagonBorderContainer
            ]),
            children: renderedContent
        })
    });
});

});
parcelRegister("34UXi", function(module, exports) {
$parcel$export(module.exports, "AvatarContentContext", () => $5be15607a696400e$export$b983474ddd0b6d28);

var $fsvuC = parcelRequire("fsvuC");
const $5be15607a696400e$var$defaultAvatarContentProps = {
    as: 'span',
    appearance: 'circle',
    avatarImage: null,
    ref: null,
    size: 'medium'
};
const $5be15607a696400e$export$b983474ddd0b6d28 = /*#__PURE__*/ (0, $fsvuC.createContext)($5be15607a696400e$var$defaultAvatarContentProps);

});

parcelRegister("eEkRB", function(module, exports) {
$parcel$export(module.exports, "useEnsureIsInsideAvatar", () => $d0d6d9680336b406$export$7db5c57474082dd9);

var $fsvuC = parcelRequire("fsvuC");

var $jSIZf = parcelRequire("jSIZf");
const $d0d6d9680336b406$export$7db5c57474082dd9 = ()=>{
    const context = (0, $fsvuC.useContext)((0, $jSIZf.EnsureIsInsideAvatarContext));
    if (!context) throw new Error('Avatar sub-components must be used within a Avatar component.');
};

});
parcelRegister("jSIZf", function(module, exports) {
$parcel$export(module.exports, "EnsureIsInsideAvatarContext", () => $a29415d02d087435$export$6b4cbd90d24955ad);

var $fsvuC = parcelRequire("fsvuC");
const $a29415d02d087435$export$6b4cbd90d24955ad = /*#__PURE__*/ (0, $fsvuC.createContext)(false);

});



parcelRegister("cwS28", function(module, exports) {
$parcel$export(module.exports, "default", () => $00828df5957eb286$export$2e2bcd8739ae039);
/* avatar-image.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $gjVYm = parcelRequire("gjVYm");

var $gI1yN = parcelRequire("gI1yN");

var $anXxY = parcelRequire("anXxY");
const $00828df5957eb286$var$styles = {
    image: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEN91d _3iDTPbQ4SZ _39xV02N91d _0jFU0VN91d",
    icon: "_3iDTPbQ4SZ _39xV02N91d _0jFU0VN91d _0KLXruG6qS",
    circle: "_0bjKvDS5Zs",
    hexagon: "_1uo2ZfTcEg",
    updatedHexagonIcon: "_0hPCNLDIqT _37wbyuDIqT",
    updatedHexagonImage: "_1uo2ZfOLYo _00EA0eiObl _3IONCnIZbP"
};
const $00828df5957eb286$var$borderRadiusMap = {
    xxsmall: "_0bjKvDcjp5",
    xsmall: "_0bjKvDcjp5",
    UNSAFE_xsmall: "_0bjKvDcjp5",
    small: "_0bjKvDcjp5",
    medium: "_0bjKvDKxmn",
    large: "_0bjKvDKxmn",
    xlarge: "_0bjKvDKTcp",
    xxlarge: "_0bjKvDyzSk"
};
const $00828df5957eb286$var$nestedSvgStylesMap = {
    xxsmall: "_27VeLCey7F _2Qxi4ney7F",
    xsmall: "_27VeLCey7F _2Qxi4ney7F",
    UNSAFE_xsmall: "_27VeLCSPN1 _2Qxi4nSPN1",
    small: "_27VeLCoWWg _2Qxi4noWWg",
    medium: "_27VeLCUofl _2Qxi4nUofl",
    large: "_27VeLCUF4f _2Qxi4nUF4f",
    xlarge: "_27VeLCJgOI _2Qxi4nJgOI",
    xxlarge: "_27VeLCNNui _2Qxi4nNNui"
};
// NOTE: Must mirror `updatedHexagonDimensionMap` in `../avatar-content.tsx`.
const $00828df5957eb286$var$updatedHexagonNestedSvgStylesMap = {
    xxsmall: "_27VeLCEGCh _2Qxi4nQSd4",
    small: "_27VeLC1R6D _2Qxi4n7qhK",
    medium: "_27VeLCU2XU _2Qxi4nRlO4",
    large: "_27VeLCs3iu _2Qxi4nNmyB",
    xlarge: "_27VeLCOhVQ _2Qxi4nHWFU",
    xxlarge: "_27VeLCc73x _2Qxi4nSk01"
};
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ const $00828df5957eb286$var$AvatarImage = ({ alt: alt = '', src: src, appearance: appearance, UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry, size: size, testId: testId, imgLoading: imgLoading })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $fsvuC.useState)(false);
    // If src changes, reset state
    (0, $fsvuC.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) {
        let renderedIcon;
        switch(appearance){
            case 'circle':
                renderedIcon = /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gI1yN))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && `${testId}--person`,
                    spacing: "spacious"
                });
                break;
            case 'hexagon':
                renderedIcon = /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gjVYm))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && `${testId}--agent`,
                    spacing: "spacious"
                });
                break;
            default:
            case 'square':
                renderedIcon = /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($anXxY))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && `${testId}--ship`,
                    spacing: "spacious"
                });
                break;
        }
        return /*#__PURE__*/ (0, $5chsV.jsx)("span", {
            className: (0, $gJ6nT.default)([
                $00828df5957eb286$var$styles.icon,
                UNSAFE_isUpdatedGeometry ? $00828df5957eb286$var$updatedHexagonNestedSvgStylesMap[size] : $00828df5957eb286$var$nestedSvgStylesMap[size],
                UNSAFE_isUpdatedGeometry && $00828df5957eb286$var$styles.updatedHexagonIcon
            ]),
            children: renderedIcon
        });
    }
    return /*#__PURE__*/ (0, $5chsV.jsx)("img", {
        loading: imgLoading,
        src: src,
        alt: alt,
        "data-testid": testId && `${testId}--image`,
        onError: ()=>setHasImageErrored(true),
        "aria-hidden": !alt ? true : undefined,
        "data-vc": testId ? `${testId}--image` : 'avatar-image',
        "data-ssr-placeholder-ignored": true,
        className: (0, $gJ6nT.default)([
            $00828df5957eb286$var$styles.image,
            $00828df5957eb286$var$borderRadiusMap[size],
            appearance === 'circle' && $00828df5957eb286$var$styles.circle,
            appearance === 'hexagon' && $00828df5957eb286$var$styles.hexagon,
            UNSAFE_isUpdatedGeometry && $00828df5957eb286$var$styles.updatedHexagonImage
        ])
    });
};
$00828df5957eb286$var$AvatarImage.displayName = "AvatarImage";
var $00828df5957eb286$export$2e2bcd8739ae039 = $00828df5957eb286$var$AvatarImage;

});

parcelRegister("9Qrxv", function(module, exports) {
$parcel$export(module.exports, "default", () => $956284604e28c40b$export$2e2bcd8739ae039);
const $956284604e28c40b$var$getCustomElement = (isDisabled, href, onClick, ariaHasPopup)=>{
    if (href && !isDisabled) return 'a';
    if (onClick || isDisabled || ariaHasPopup) return 'button';
    return 'span';
};
var $956284604e28c40b$export$2e2bcd8739ae039 = $956284604e28c40b$var$getCustomElement;

});

parcelRegister("76ZVa", function(module, exports) {
$parcel$export(module.exports, "default", () => $169656815e08565f$export$2e2bcd8739ae039);
/* presence-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $b3cjK = parcelRequire("b3cjK");
const $169656815e08565f$var$styles = {
    root: "_1mT5xdWVPG _1pp6NdYbGa"
};
const $169656815e08565f$var$iconSizeMap = {
    small: "_0jFU0VxpxF _39xV02xpxF",
    medium: "_0jFU0VEbN9 _39xV02EbN9",
    large: "_0jFU0V2sAl _39xV022sAl",
    xlarge: "_0jFU0V70UD _39xV0270UD"
};
const $169656815e08565f$var$circleIconOffsetMap = {
    small: "_0Bm75GdnbC _4ApkO2dnbC",
    medium: "_0Bm75GdnbC _4ApkO2dnbC",
    large: "_0Bm75GHZdu _4ApkO2HZdu",
    xlarge: "_0Bm75GXJux _4ApkO2XJux"
};
const $169656815e08565f$var$squareIconOffsetMap = {
    root: "_0Bm75GVo9d _4ApkO2Vo9d"
};
const $169656815e08565f$var$hexagonIconOffsetMap = {
    small: "_0Bm75GA17z _4ApkO2A17z",
    medium: "_0Bm75GA17z _4ApkO2A17z",
    large: "_0Bm75GUNDJ _4ApkO2Vo9d",
    xlarge: "_0Bm75GvFgp _4ApkO28e2l"
};
/**
 * __Presence wrapper__
 *
 * A presence wrapper is used internally to position presence ontop of the avatar.
 */ const $169656815e08565f$var$PresenceWrapper = ({ size: size, appearance: appearance, children: children, borderColor: borderColor, presence: presence, testId: testId })=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)("span", {
        "aria-hidden": "true",
        "data-testid": testId && `${testId}--presence`,
        className: (0, $gJ6nT.default)([
            $169656815e08565f$var$styles.root,
            $169656815e08565f$var$iconSizeMap[size],
            $169656815e08565f$var$circleIconOffsetMap[size],
            appearance === 'square' && $169656815e08565f$var$squareIconOffsetMap.root,
            appearance === 'hexagon' && $169656815e08565f$var$hexagonIconOffsetMap[size]
        ]),
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $b3cjK.default), {
            borderColor: borderColor,
            presence: !children ? presence : undefined,
            children: children
        })
    });
};
$169656815e08565f$var$PresenceWrapper.displayName = "PresenceWrapper";
var $169656815e08565f$export$2e2bcd8739ae039 = $169656815e08565f$var$PresenceWrapper;

});
parcelRegister("b3cjK", function(module, exports) {
$parcel$export(module.exports, "default", () => $1abb2303afea23a3$export$2e2bcd8739ae039);
/* presence.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $iSJTy = parcelRequire("iSJTy");
const $1abb2303afea23a3$var$BusyIndicator = /*#__PURE__*/ (0, $5chsV.jsxs)((0, $fsvuC.Fragment), {
    children: [
        /*#__PURE__*/ (0, $5chsV.jsx)("circle", {
            fill: "var(--ds-icon-danger, #C9372C)",
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $5chsV.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
        })
    ]
});
const $1abb2303afea23a3$var$FocusIndicator = /*#__PURE__*/ (0, $5chsV.jsx)((0, $fsvuC.Fragment), {
    children: /*#__PURE__*/ (0, $5chsV.jsx)("path", {
        fill: "var(--ds-icon-discovery, #AF59E1)",
        d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
    })
});
const $1abb2303afea23a3$var$OfflineIndicator = /*#__PURE__*/ (0, $5chsV.jsxs)((0, $fsvuC.Fragment), {
    children: [
        /*#__PURE__*/ (0, $5chsV.jsx)("path", {
            fill: "var(--ds-text-subtlest, #6B6E76)",
            d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
        }),
        /*#__PURE__*/ (0, $5chsV.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
        })
    ]
});
const $1abb2303afea23a3$var$OnlineIndicator = /*#__PURE__*/ (0, $5chsV.jsx)("circle", {
    fill: "var(--ds-icon-success, #6A9A23)",
    cx: "4",
    cy: "4",
    r: "4"
});
function $1abb2303afea23a3$var$getPresence(presence) {
    switch(presence){
        case 'busy':
            return $1abb2303afea23a3$var$BusyIndicator;
        case 'focus':
            return $1abb2303afea23a3$var$FocusIndicator;
        case 'offline':
            return $1abb2303afea23a3$var$OfflineIndicator;
        case 'online':
            return $1abb2303afea23a3$var$OnlineIndicator;
    }
}
/**
 * __Avatar presence__
 *
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
 */ const $1abb2303afea23a3$var$AvatarPresence = ({ borderColor: borderColor, children: children, presence: presence })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $iSJTy.default), {
        bgColor: borderColor,
        children: presence ? /*#__PURE__*/ (0, $5chsV.jsx)("svg", {
            height: "100%",
            version: "1.1",
            viewBox: "0 0 8 8",
            width: "100%",
            xmlns: "http://www.w3.org/2000/svg",
            children: $1abb2303afea23a3$var$getPresence(presence)
        }) : children
    });
$1abb2303afea23a3$var$AvatarPresence.displayName = "AvatarPresence";
var $1abb2303afea23a3$export$2e2bcd8739ae039 = $1abb2303afea23a3$var$AvatarPresence;

});
parcelRegister("iSJTy", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f92050c49ea232e$export$2e2bcd8739ae039);
/* icon-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");
const $6f92050c49ea232e$var$styles = {
    root: "_0bjKvDaaQb _4bt5LAnQyn _2WAcuGnQyn _2V7sgO2M4S _3hxITi6wH8 _3iDTPbQ4SZ _24h04i2Njc _39xV02N91d _0jFU0VN91d _0hPCNLDIqT _0GwItXDIqT _0KLXruoI2d"
};
const $6f92050c49ea232e$var$unboundStyles = {
    root: "_3vBAKHoI2d"
};
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ const $6f92050c49ea232e$var$IconWrapper = ({ bgColor: bgColor, children: children })=>/*#__PURE__*/ (0, $5chsV.jsx)("span", {
        role: "presentation",
        style: {
            borderColor: bgColor,
            backgroundColor: bgColor
        },
        className: (0, $gJ6nT.default)([
            $6f92050c49ea232e$var$styles.root,
            $6f92050c49ea232e$var$unboundStyles.root
        ]),
        children: children
    });
$6f92050c49ea232e$var$IconWrapper.displayName = "IconWrapper";
var $6f92050c49ea232e$export$2e2bcd8739ae039 = $6f92050c49ea232e$var$IconWrapper;

});



parcelRegister("1y9wE", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f8ae62fe443e6a2$export$2e2bcd8739ae039);
/* status-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $8nYIW = parcelRequire("8nYIW");
const $0f8ae62fe443e6a2$var$styles = {
    root: "_1mT5xdWVPG"
};
const $0f8ae62fe443e6a2$var$iconSizeMap = {
    small: "_0jFU0VxpxF _39xV02xpxF",
    medium: "_0jFU0VEbN9 _39xV02EbN9",
    large: "_0jFU0V2sAl _39xV022sAl",
    xlarge: "_0jFU0V70UD _39xV0270UD"
};
const $0f8ae62fe443e6a2$var$circleIconOffsetMap = {
    small: "_1OKFqYdnbC _2I62gzdnbC",
    medium: "_1OKFqYdnbC _2I62gzdnbC",
    large: "_1OKFqYHZdu _2I62gzHZdu",
    xlarge: "_1OKFqYXJux _2I62gzXJux"
};
const $0f8ae62fe443e6a2$var$squareIconOffsetMap = {
    root: "_1OKFqYdnbC _2I62gzdnbC"
};
const $0f8ae62fe443e6a2$var$hexagonIconOffsetMap = {
    small: "_1OKFqYA17z _2I62gzA17z",
    medium: "_1OKFqYA17z _2I62gzA17z",
    large: "_1OKFqYVo9d _2I62gzUNDJ",
    xlarge: "_1OKFqY8e2l _2I62gzvFgp"
};
/**
 * __Status wrapper__
 *
 * A status wrapper is used internally to position status on top of the avatar.
 */ const $0f8ae62fe443e6a2$var$StatusWrapper = ({ size: size, status: status, appearance: appearance, borderColor: borderColor, children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)("span", {
        "aria-hidden": "true",
        "data-testid": testId && `${testId}--status`,
        className: (0, $gJ6nT.default)([
            $0f8ae62fe443e6a2$var$styles.root,
            $0f8ae62fe443e6a2$var$iconSizeMap[size],
            $0f8ae62fe443e6a2$var$circleIconOffsetMap[size],
            appearance === 'square' && $0f8ae62fe443e6a2$var$squareIconOffsetMap.root,
            appearance === 'hexagon' && $0f8ae62fe443e6a2$var$hexagonIconOffsetMap[size]
        ]),
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $8nYIW.default), {
            borderColor: borderColor,
            status: !children ? status : undefined,
            children: children
        })
    });
};
$0f8ae62fe443e6a2$var$StatusWrapper.displayName = "StatusWrapper";
var $0f8ae62fe443e6a2$export$2e2bcd8739ae039 = $0f8ae62fe443e6a2$var$StatusWrapper;

});
parcelRegister("8nYIW", function(module, exports) {
$parcel$export(module.exports, "default", () => $858de77b1bfd1d48$export$2e2bcd8739ae039);
/* status.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $iSJTy = parcelRequire("iSJTy");
const $858de77b1bfd1d48$var$ApprovedIndicator = /*#__PURE__*/ (0, $5chsV.jsxs)((0, $fsvuC.Fragment), {
    children: [
        /*#__PURE__*/ (0, $5chsV.jsx)("circle", {
            fill: "var(--ds-icon-success, #6A9A23)",
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $5chsV.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
        })
    ]
});
const $858de77b1bfd1d48$var$DeclinedIndicator = /*#__PURE__*/ (0, $5chsV.jsxs)((0, $fsvuC.Fragment), {
    children: [
        /*#__PURE__*/ (0, $5chsV.jsx)("circle", {
            fill: "var(--ds-icon-danger, #C9372C)",
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $5chsV.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
        })
    ]
});
const $858de77b1bfd1d48$var$LockedIndicator = /*#__PURE__*/ (0, $5chsV.jsxs)((0, $fsvuC.Fragment), {
    children: [
        /*#__PURE__*/ (0, $5chsV.jsx)("circle", {
            fill: "var(--ds-text-subtlest, #6B6E76)",
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $5chsV.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
        })
    ]
});
const $858de77b1bfd1d48$var$WarningIndicator = /*#__PURE__*/ (0, $5chsV.jsxs)((0, $fsvuC.Fragment), {
    children: [
        /*#__PURE__*/ (0, $5chsV.jsx)("circle", {
            fill: "var(--ds-icon-warning, #E06C00)",
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $5chsV.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M4,1.33333333 C4.36918944,1.33333333 4.66666667,1.63081056 4.66666667,2 L4.66666667,4 C4.66666667,4.36918944 4.36918944,4.66666667 4,4.66666667 C3.63081056,4.66666667 3.33333333,4.36918944 3.33333333,4 L3.33333333,2 C3.33333333,1.63081056 3.63081056,1.33333333 4,1.33333333 Z M4,5.33333333 C4.36918944,5.33333333 4.66666667,5.63081056 4.66666667,6 C4.66666667,6.36918944 4.36918944,6.66666667 4,6.66666667 C3.63081056,6.66666667 3.33333333,6.36918944 3.33333333,6 C3.33333333,5.63081056 3.63081056,5.33333333 4,5.33333333 Z"
        })
    ]
});
function $858de77b1bfd1d48$var$getStatus(status) {
    switch(status){
        case 'approved':
            return $858de77b1bfd1d48$var$ApprovedIndicator;
        case 'declined':
            return $858de77b1bfd1d48$var$DeclinedIndicator;
        case 'locked':
            return $858de77b1bfd1d48$var$LockedIndicator;
        case 'warning':
            return $858de77b1bfd1d48$var$WarningIndicator;
    }
}
/**
 * __Avatar status__
 *
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
 */ const $858de77b1bfd1d48$var$AvatarStatus = ({ borderColor: borderColor, children: children, status: status })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $iSJTy.default), {
        bgColor: borderColor,
        children: status ? /*#__PURE__*/ (0, $5chsV.jsx)("svg", {
            height: "100%",
            version: "1.1",
            viewBox: "0 0 8 8",
            width: "100%",
            xmlns: "http://www.w3.org/2000/svg",
            children: $858de77b1bfd1d48$var$getStatus(status)
        }) : children
    });
$858de77b1bfd1d48$var$AvatarStatus.displayName = "AvatarStatus";
var $858de77b1bfd1d48$export$2e2bcd8739ae039 = $858de77b1bfd1d48$var$AvatarStatus;

});


parcelRegister("cT19d", function(module, exports) {
$parcel$export(module.exports, "useAvatarContext", () => $96132b89ecba6588$export$b50b87a1c4086b23);

var $fsvuC = parcelRequire("fsvuC");

var $dLRYl = parcelRequire("dLRYl");
const $96132b89ecba6588$export$b50b87a1c4086b23 = ()=>(0, $fsvuC.useContext)((0, $dLRYl.AvatarContext));

});
parcelRegister("dLRYl", function(module, exports) {
$parcel$export(module.exports, "AvatarContext", () => $f203eb4c63c3c0fc$export$a20dad690e1279e2);

var $fsvuC = parcelRequire("fsvuC");
const $f203eb4c63c3c0fc$export$a20dad690e1279e2 = /*#__PURE__*/ (0, $fsvuC.createContext)(undefined);

});



parcelRegister("23Cin", function(module, exports) {
$parcel$export(module.exports, "default", () => $5fd5ee61f43c2bbd$export$2e2bcd8739ae039);
/* section.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $hizzu = parcelRequire("hizzu");
const $5fd5ee61f43c2bbd$var$itemHeadingTopMargin = 20;
const $5fd5ee61f43c2bbd$var$itemHeadingBottomMargin = 6;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
const $5fd5ee61f43c2bbd$var$itemHeadingContentHeight = 16; // Originally headingSizes.h100.lineHeight from '@atlaskit/theme/typography'
const $5fd5ee61f43c2bbd$var$skeletonHeadingHeight = 8;
const $5fd5ee61f43c2bbd$var$skeletonHeadingMarginOffset = 3;
const $5fd5ee61f43c2bbd$var$skeletonHeadingTopMargin = $5fd5ee61f43c2bbd$var$itemHeadingTopMargin + ($5fd5ee61f43c2bbd$var$itemHeadingContentHeight - $5fd5ee61f43c2bbd$var$skeletonHeadingHeight) - $5fd5ee61f43c2bbd$var$skeletonHeadingMarginOffset;
const $5fd5ee61f43c2bbd$var$sectionPaddingTopBottom = 6;
const $5fd5ee61f43c2bbd$var$styles = {
    root: "_4Gb5FivLZJ _0OU75rvLZJ _47eTBtZimw _1lBcDcZimw _0GBAIrogpp _3Ku51Iogpp _420PbdZimw _3LXXKoSPN1 _1DqDD4EbN9 _0Ipfpy2AF2 _1apEF8fFOW _3R93WOXCiO _38a67RA17z",
    scrollable: "_4bt5LAIZbP _2WAcuGIZbP _3YEZNO7dHp",
    unscrollable: "_3YEZNOdnbC",
    thinSeparator: "_1v3aPqo71H",
    noSeparator: "_1wX8q6mW1D",
    sideNavSectionHeading: "_2Y7lL42ADO"
};
/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $5fd5ee61f43c2bbd$var$Section = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ children: children, title: title, titleId: titleId, testId: testId, isScrollable: isScrollable, hasSeparator: hasSeparator, id: id, isList: isList = false, isSideNavSection: isSideNavSection = false, label: label, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest }, ref)=>{
    const content = isList ? /*#__PURE__*/ (0, $5chsV.jsx)("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        },
        children: (0, $fsvuC.Children).map((0, $fsvuC.Children).toArray(children), (child, index)=>/*#__PURE__*/ (0, $5chsV.jsx)("li", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    listStyleType: 'none',
                    margin: 0,
                    padding: 0
                },
                children: child
            }, index))
    }) : children;
    const childrenMarkup = title !== undefined ? /*#__PURE__*/ (0, $5chsV.jsxs)((0, $fsvuC.Fragment), {
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $hizzu.default), {
                testId: testId && `${testId}--heading`,
                "aria-hidden": true,
                // @ts-expect-error
                // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
                className: (0, $gJ6nT.default)([
                    isSideNavSection && $5fd5ee61f43c2bbd$var$styles.sideNavSectionHeading
                ]),
                children: title
            }),
            content
        ]
    }) : /*#__PURE__*/ (0, $5chsV.jsx)((0, $fsvuC.Fragment), {
        children: content
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $gJ6nT.default)([
            $5fd5ee61f43c2bbd$var$styles.root,
            isScrollable ? $5fd5ee61f43c2bbd$var$styles.scrollable : $5fd5ee61f43c2bbd$var$styles.unscrollable,
            hasSeparator ? $5fd5ee61f43c2bbd$var$styles.thinSeparator : $5fd5ee61f43c2bbd$var$styles.noSeparator,
            UNSAFE_className
        ]),
        id: id,
        // NOTE: Firefox allows elements that have "overflow: auto" to gain focus (as if it had tab-index="0")
        // We have made a deliberate choice to leave this behaviour as is.
        "aria-label": title || label,
        "aria-labelledby": titleId,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref,
        children: childrenMarkup
    });
});
var $5fd5ee61f43c2bbd$export$2e2bcd8739ae039 = $5fd5ee61f43c2bbd$var$Section;

});
parcelRegister("hizzu", function(module, exports) {
$parcel$export(module.exports, "default", () => $a39a677cbd1d62cf$export$2e2bcd8739ae039);
/* heading-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");
const $a39a677cbd1d62cf$var$headingStyles = null;
/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $a39a677cbd1d62cf$var$HeadingItem = /*#__PURE__*/ (0, $fsvuC.memo)(({ children: children, testId: testId, headingLevel: headingLevel = 2, id: id, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest })=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $gJ6nT.default)([
            "_2sNsIgd8bj _4c065UPgdg _2Y7lL45zaO _1UtDYzZpcK",
            UNSAFE_className
        ]),
        ...rest,
        children: children
    });
});
var $a39a677cbd1d62cf$export$2e2bcd8739ae039 = $a39a677cbd1d62cf$var$HeadingItem;

});


parcelRegister("aCtVx", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf3e74bb11bed9bf$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $cTXsj = parcelRequire("cTXsj");

var $23Cin = parcelRequire("23Cin");

var $8DPDL = parcelRequire("8DPDL");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $bf3e74bb11bed9bf$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, ...rest }, ref)=>{
    const uid = (0, $cTXsj.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $23Cin.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        ...rest,
        children: [
            title && /*#__PURE__*/ (0, $5chsV.jsx)((0, $8DPDL.default), {
                id: titleId,
                title: title
            }),
            children
        ]
    });
});
var $bf3e74bb11bed9bf$export$2e2bcd8739ae039 = $bf3e74bb11bed9bf$var$DropdownMenuItemGroup;

});
parcelRegister("8DPDL", function(module, exports) {
$parcel$export(module.exports, "default", () => $9d7a11621e5f6bdb$export$2e2bcd8739ae039);
/* group-title.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $jRYjy = parcelRequire("jRYjy");
const $9d7a11621e5f6bdb$var$styles = {
    heading: "_2sNsIgd8bj _4c065UPgdg _2Y7lL45zaO _1UtDYzZpcK"
};
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups.
 *
 * Pre-existing a11y note: uses `role="menuitem"` with `aria-hidden="true"`.
 * WAI-ARIA APG recommends `role="presentation"` for non-interactive group
 * headings, with the group linked via `aria-labelledby`. Out of scope for
 * the top-layer migration — this is legacy behavior.
 *
 * @internal
 */ const $9d7a11621e5f6bdb$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $jRYjy.Box), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $9d7a11621e5f6bdb$var$styles.heading,
        children: title
    });
$9d7a11621e5f6bdb$var$GroupTitle.displayName = "GroupTitle";
var $9d7a11621e5f6bdb$export$2e2bcd8739ae039 = $9d7a11621e5f6bdb$var$GroupTitle;

});


parcelRegister("3uRAY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $9a1ce52173e8aa5f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");

var $fsvuC = parcelRequire("fsvuC");

var $lNjwN = parcelRequire("lNjwN");

var $llCao = parcelRequire("llCao");
const $9a1ce52173e8aa5f$var$shimmerKeyframes = null;
const $9a1ce52173e8aa5f$var$skeletonStyles = null;
const $9a1ce52173e8aa5f$var$activeShimmerStyles = null; /**
                                   * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
                                   * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
                                   * which makes things simpler than doing an `isServer` check or a `null` check.
                                   *
                                   * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
                                   */ 
const $9a1ce52173e8aa5f$var$useLayoutEffect = typeof window === 'undefined' ? (0, $fsvuC.useEffect) : (0, $fsvuC.useLayoutEffect); /**
                                                                                          * __Skeleton__
                                                                                          *
                                                                                          * A skeleton acts as a placeholder for content, usually while the content loads.
                                                                                          *
                                                                                          * - [Examples](https://atlassian.design/components/skeleton/examples)
                                                                                          * - [Code](https://atlassian.design/components/skeleton/code)
                                                                                          */ 
const $9a1ce52173e8aa5f$var$Skeleton = ({ width: width, height: height, borderRadius: borderRadius = "var(--ds-radius-small, 4px)", color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: isShimmering = false, groupName: groupName, interactionName: interactionName, testId: testId })=>{
    const groupDataAttribute = groupName && `data-${groupName}`;
    const context = (0, $fsvuC.useContext)((0, $lNjwN.default));
    $9a1ce52173e8aa5f$var$useLayoutEffect(()=>{
        if (context != null && (0, $llCao.fg)('platform-dst-skeleton-ufo-hold')) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        "data-testid": testId,
        style: {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            // Override the keyframes if both colors are provided, otherwise use the CSS variable fallbacks in our keyframes
            '--ds-skeleton-from-color': color && ShimmeringEndColor ? color : undefined,
            '--ds-skeleton-to-color': color && ShimmeringEndColor ? ShimmeringEndColor : undefined
        },
        ...groupDataAttribute && {
            [groupDataAttribute]: 'true'
        },
        className: (0, $gJ6nT.default)([
            "_0uDzWjkSs3 _0nFVCGfONH _03m2nySHWH _43vdfTHVQb _0KLXruGsB2",
            isShimmering && "",
            isShimmering && "_1gBibyKB6V"
        ])
    });
};
$9a1ce52173e8aa5f$var$Skeleton.displayName = "Skeleton";
var $9a1ce52173e8aa5f$export$2e2bcd8739ae039 = $9a1ce52173e8aa5f$var$Skeleton;

});

parcelRegister("3bv5z", function(module, exports) {
$parcel$export(module.exports, "ProjectsIcon", () => $f1fec5559ffa617c$export$5ed3e1bb3b04fc02);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e8862141676163c22cf5b4279aef2ba3>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $2IsXX = parcelRequire("2IsXX");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $f1fec5559ffa617c$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m5.106 14.44 1.856-1.856-1.856-1.856L6.653 9.18h3.712l2.784-2.784h4.332v4.33l-2.785 2.785v3.712L13.15 18.77l-1.857-1.856-1.856 1.856-1.7-1.7 2.784-2.784-.928-.928-2.784 2.784zm10.209-4.331a1.094 1.094 0 1 1-1.547-1.546 1.094 1.094 0 0 1 1.547 1.546" clip-rule="evenodd"/>
</svg>
`;
function $f1fec5559ffa617c$export$5ed3e1bb3b04fc02({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Projects', testId: testId }) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $2IsXX.IconWrapper), {
        svg: $f1fec5559ffa617c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}
$f1fec5559ffa617c$export$5ed3e1bb3b04fc02.displayName = "ProjectsIcon";

});

parcelRegister("lB42M", function(module, exports) {
$parcel$export(module.exports, "AssetsIcon", () => $9933a0bd33cc37ea$export$d89497e7f33ca6f5);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::505dbad49a3dfa1729f04b26edcebd32>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $2IsXX = parcelRequire("2IsXX");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $9933a0bd33cc37ea$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727" clip-rule="evenodd"/>
    <path fill="var(--icon-color, #101214)" d="M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z"/>
</svg>
`;
const $9933a0bd33cc37ea$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM7.432 14.704a2.273 2.273 0 1 0 .001 4.547 2.273 2.273 0 0 0-.001-4.547m9.545 0a2.274 2.274 0 1 0 .001 4.548 2.274 2.274 0 0 0 0-4.548m-6.364 1.364v1.819h3.183v-1.819zM7.887 4.25a3.637 3.637 0 0 0-1.365 7.009v2.537h1.819v-2.302a3.64 3.64 0 0 0 3.153-3.153h2.302V6.522h-2.537A3.64 3.64 0 0 0 7.887 4.25m8.181 6.363v3.183h1.819v-3.183zm.91-5.454a2.273 2.273 0 1 0 0 4.547 2.273 2.273 0 0 0 0-4.547M7.887 6.522a1.364 1.364 0 1 1-.002 2.729 1.364 1.364 0 0 1 .002-2.729"/>
</svg>
`;
function $9933a0bd33cc37ea$export$d89497e7f33ca6f5({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Assets', testId: testId }) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $2IsXX.IconWrapper), {
        svg: $9933a0bd33cc37ea$var$svg,
        customThemeSvg: $9933a0bd33cc37ea$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}
$9933a0bd33cc37ea$export$d89497e7f33ca6f5.displayName = "AssetsIcon";

});

parcelRegister("lLT4i", function(module, exports) {
$parcel$export(module.exports, "SplitButton", () => $a2b08a88137ea1d1$export$651ad66661acd392);
/* split-button.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $2jZkK = parcelRequire("2jZkK");

var $ad8Kv = parcelRequire("ad8Kv");

var $9djJE = parcelRequire("9djJE");

var $3T0iC = parcelRequire("3T0iC");
const $a2b08a88137ea1d1$var$buttonStyles = {
    primaryButton: "_3rzkiodnbC _1kWzVtdnbC _0uVYyIdnbC _2qDbL0dnbC",
    secondaryButton: "_1jomYRdnbC _4oPZ7ddnbC _2kv5QsdnbC _0geU8cdnbC"
};
const $a2b08a88137ea1d1$export$651ad66661acd392 = ({ children: children, appearance: appearance = 'default', spacing: spacing = 'default', isDisabled: isDisabled = false })=>{
    const { PrimaryAction: PrimaryAction, SecondaryAction: SecondaryAction } = (0, $3T0iC.getActions)(children);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $ad8Kv.SplitButtonContainer), {
        appearance: appearance,
        isDisabled: isDisabled,
        children: /*#__PURE__*/ (0, $5chsV.jsxs)((0, $9djJE.SplitButtonContext).Provider, {
            value: {
                appearance: appearance,
                spacing: spacing,
                isDisabled: isDisabled
            },
            children: [
                /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                    className: (0, $gJ6nT.default)([
                        $a2b08a88137ea1d1$var$buttonStyles.primaryButton
                    ]),
                    children: PrimaryAction
                }),
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $2jZkK.Divider), {
                    appearance: appearance,
                    spacing: spacing,
                    isDisabled: isDisabled
                }),
                /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                    className: (0, $gJ6nT.default)([
                        $a2b08a88137ea1d1$var$buttonStyles.secondaryButton
                    ]),
                    children: SecondaryAction
                })
            ]
        })
    });
};
$a2b08a88137ea1d1$export$651ad66661acd392.displayName = "SplitButton";

});
parcelRegister("2jZkK", function(module, exports) {
$parcel$export(module.exports, "Divider", () => $dffd25cb4c8d9bd1$export$2e0a83ec2e27ecbb);
/* divider.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");
const $dffd25cb4c8d9bd1$var$dividerStyles = {
    baseDivider: "_39xV02NvrM _1mT5xdRAKS _42Yu6B7dHp",
    dividerDisabled: "_0KLXruhQC5 _0wOv4Qsyl5",
    dividerOffset: "_2YLqiKA17z"
};
const $dffd25cb4c8d9bd1$var$dividerAppearanceStyles = {
    default: "_0KLXru9r67",
    primary: "_0KLXruxCOs _1YKVNsjLrf",
    navigation: "_3SamIH2ADO _2YLqiKwmY0 _0jFU0Vey7F _0KLXruZpcK _1YKVNsCfZC"
};
const $dffd25cb4c8d9bd1$var$dividerHeightStyles = {
    default: "_0jFU0VZ49V",
    compact: "_0jFU0V9DVM"
};
const $dffd25cb4c8d9bd1$var$defaultDividerHeightStyles = {
    default: "_0jFU0Vbu0M",
    compact: "_0jFU0Vv8uz"
};
const $dffd25cb4c8d9bd1$export$2e0a83ec2e27ecbb = ({ appearance: appearance, spacing: spacing, isDisabled: isDisabled = false })=>{
    const isDefaultDivider = appearance === 'default' && !isDisabled;
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        className: (0, $gJ6nT.default)([
            $dffd25cb4c8d9bd1$var$dividerStyles.baseDivider,
            isDefaultDivider && $dffd25cb4c8d9bd1$var$defaultDividerHeightStyles[spacing],
            !isDefaultDivider && $dffd25cb4c8d9bd1$var$dividerHeightStyles[spacing],
            isDisabled && $dffd25cb4c8d9bd1$var$dividerStyles.dividerDisabled,
            !isDisabled && $dffd25cb4c8d9bd1$var$dividerAppearanceStyles[appearance],
            $dffd25cb4c8d9bd1$var$dividerStyles.dividerOffset
        ])
    });
};
$dffd25cb4c8d9bd1$export$2e0a83ec2e27ecbb.displayName = "Divider";

});

parcelRegister("ad8Kv", function(module, exports) {
$parcel$export(module.exports, "SplitButtonContainer", () => $50d97bf3117aabb3$export$994ba1b4c598f7);
/* split-button-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");
const $50d97bf3117aabb3$var$buttonStyles = {
    splitButton: "_3iDTPbccYA _1mT5xdRAKS _0hPCNLDIqT _1ANEUSLRg7",
    defaultAppearanceContainer: "_0bjKvDKTcp _2xIroY9r67 _3e6OgrA17z _497WNw6wH8 _2zndICHZdu",
    defaultAppearanceDisabledContainer: "_2xIroYhQC5"
};
const $50d97bf3117aabb3$export$994ba1b4c598f7 = ({ appearance: appearance, children: children, isDisabled: isDisabled = false })=>/*#__PURE__*/ (0, $5chsV.jsx)("div", {
        className: (0, $gJ6nT.default)([
            appearance === 'default' && $50d97bf3117aabb3$var$buttonStyles.defaultAppearanceContainer,
            appearance === 'default' && isDisabled && $50d97bf3117aabb3$var$buttonStyles.defaultAppearanceDisabledContainer,
            $50d97bf3117aabb3$var$buttonStyles.splitButton
        ]),
        children: children
    });
$50d97bf3117aabb3$export$994ba1b4c598f7.displayName = "SplitButtonContainer";

});

parcelRegister("3T0iC", function(module, exports) {
$parcel$export(module.exports, "getActions", () => $97889841e9e8191e$export$fe3955935f564b31);

var $fsvuC = parcelRequire("fsvuC");

var $hoalA = parcelRequire("hoalA");
const $97889841e9e8191e$export$fe3955935f564b31 = (children)=>{
    const [PrimaryAction, SecondaryAction] = (0, $fsvuC.Children).toArray(children);
    typeof $hoalA;
    return {
        PrimaryAction: PrimaryAction,
        SecondaryAction: SecondaryAction
    };
};

});


parcelRegister("iOSqF", function(module, exports) {
$parcel$export(module.exports, "Grid", () => $4d7bf1d3d9f95247$export$ef2184bd89960b14);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fsvuC = parcelRequire("fsvuC");

var $h2YWL = parcelRequire("h2YWL");

var $9TNvK = parcelRequire("9TNvK");

var $eyIag = parcelRequire("eyIag");
function $4d7bf1d3d9f95247$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4d7bf1d3d9f95247$var$gridTemplateAreasVar = '--ds-grid--grid-template-areas';
const $4d7bf1d3d9f95247$var$gridTemplateColumnsVar = '--ds-grid--grid-template-columns';
const $4d7bf1d3d9f95247$var$gridTemplateRowsVar = '--ds-grid--grid-template-rows';
const $4d7bf1d3d9f95247$var$justifyContentMap = {
    start: {
        name: "j1lm6p",
        styles: "justify-content:start"
    },
    center: {
        name: "f7ay7b",
        styles: "justify-content:center"
    },
    end: {
        name: "jab4lt",
        styles: "justify-content:end"
    },
    'space-between': {
        name: "2o6p8u",
        styles: "justify-content:space-between"
    },
    'space-around': {
        name: "46cjum",
        styles: "justify-content:space-around"
    },
    'space-evenly': {
        name: "16166rn",
        styles: "justify-content:space-evenly"
    },
    stretch: {
        name: "11z2bqs",
        styles: "justify-content:stretch"
    }
};
const $4d7bf1d3d9f95247$var$justifyItemsMap = {
    start: {
        name: "lno2ya",
        styles: "justify-items:start"
    },
    center: {
        name: "1wg53za",
        styles: "justify-items:center"
    },
    end: {
        name: "3f7lhf",
        styles: "justify-items:end"
    },
    stretch: {
        name: "16hnylu",
        styles: "justify-items:stretch"
    }
};
const $4d7bf1d3d9f95247$var$alignContentMap = {
    start: {
        name: "iqu4as",
        styles: "align-content:start"
    },
    center: {
        name: "13vy23x",
        styles: "align-content:center"
    },
    end: {
        name: "1fj2toh",
        styles: "align-content:end"
    },
    'space-between': {
        name: "1pem0lx",
        styles: "align-content:space-between"
    },
    'space-around': {
        name: "127p7gk",
        styles: "align-content:space-around"
    },
    'space-evenly': {
        name: "kcqjal",
        styles: "align-content:space-evenly"
    },
    stretch: {
        name: "1f8yzab",
        styles: "align-content:stretch"
    }
};
const $4d7bf1d3d9f95247$var$alignItemsMap = {
    start: {
        name: "yvwru5",
        styles: "align-items:start"
    },
    center: {
        name: "1h3rtzg",
        styles: "align-items:center"
    },
    baseline: {
        name: "fzr848",
        styles: "align-items:baseline"
    },
    end: {
        name: "uj5xqj",
        styles: "align-items:end"
    }
};
const $4d7bf1d3d9f95247$var$baseStyles = /*#__PURE__*/ (0, $h2YWL.css)({
    display: 'grid',
    boxSizing: 'border-box',
    gridTemplateAreas: `var(${$4d7bf1d3d9f95247$var$gridTemplateAreasVar})`,
    gridTemplateColumns: `var(${$4d7bf1d3d9f95247$var$gridTemplateColumnsVar})`,
    gridTemplateRows: `var(${$4d7bf1d3d9f95247$var$gridTemplateRowsVar})`
});
const $4d7bf1d3d9f95247$var$gridAutoFlowMap = {
    row: {
        name: "k3yepi",
        styles: "grid-auto-flow:row"
    },
    column: {
        name: "qu4z1d",
        styles: "grid-auto-flow:column"
    },
    dense: {
        name: "mgx7bc",
        styles: "grid-auto-flow:dense"
    },
    'row dense': {
        name: "1u50cee",
        styles: "grid-auto-flow:row dense"
    },
    'column dense': {
        name: "5ak4pc",
        styles: "grid-auto-flow:column dense"
    }
};
const $4d7bf1d3d9f95247$export$ef2184bd89960b14 = /*#__PURE__*/ (0, $fsvuC.memo)(/*#__PURE__*/ (0, $fsvuC.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, templateAreas: gridTemplateAreas, templateRows: gridTemplateRows, templateColumns: gridTemplateColumns, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    const resolvedStyles = (0, $9TNvK.parseXcss)(xcss);
    /**
   * We use CSS variables to allow for dynamic grid templates instead of dynamically setting to `props.style`
   * This allows `props.xcss` to override them as `style={{ gridTemplateAreas }}` would have higher specificity.
   *
   * This must be reset to `initial` if `gridTemplateAreas` is not set, otherwise nested grids will break!
   *
   * NOTE: If we disallow `grid-template-areas` (etc) to be set via `props.xcss`, we can remove this.
   */ const style = (0, $fsvuC.useMemo)(()=>({
            [$4d7bf1d3d9f95247$var$gridTemplateAreasVar]: gridTemplateAreas ? gridTemplateAreas.map((str)=>`"${str}"`).join('\n') || 'initial' : 'initial',
            [$4d7bf1d3d9f95247$var$gridTemplateColumnsVar]: gridTemplateColumns || 'initial',
            [$4d7bf1d3d9f95247$var$gridTemplateRowsVar]: gridTemplateRows || 'initial'
        }), [
        gridTemplateAreas,
        gridTemplateColumns,
        gridTemplateRows
    ]);
    return /*#__PURE__*/ (0, $h2YWL.jsx)(Component, {
        id: id,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $4d7bf1d3d9f95247$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $eyIag.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $eyIag.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $eyIag.spaceStylesMap).rowGap[rowGap],
            alignItems && $4d7bf1d3d9f95247$var$alignItemsMap[alignItems],
            alignContent && $4d7bf1d3d9f95247$var$alignContentMap[alignContent],
            justifyContent && $4d7bf1d3d9f95247$var$justifyContentMap[justifyContent],
            autoFlow && $4d7bf1d3d9f95247$var$gridAutoFlowMap[autoFlow],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$4d7bf1d3d9f95247$export$ef2184bd89960b14.displayName = 'Grid';

});

parcelRegister("1oQSL", function(module, exports) {
$parcel$export(module.exports, "default", () => $f15c7bf8370232c0$export$2e2bcd8739ae039);
/* skeleton-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");
const $f15c7bf8370232c0$var$skeletonItemElemSize = 20;
const $f15c7bf8370232c0$var$styles = {
    root: "_4c065UPgdg _2Y7lL4kG2W _3iDTPbQ4SZ _4kiQYAUF4f _0hPCNLDIqT _1pp6NdYbGa _2Gfj6iQEt6 _47eTBt2AF2 _3wEj0XGsB2 _0GBAIrogpp _0eSLDaHZdu",
    defaultWidth: "_1ShRFFoBHb _0jufqb715P _0KfecEygnw _1v7p3wE1Ft _0pFvyeR1Le _1n9qNYrXaT",
    customWidth: "_2v4nLRyRC6",
    beforeElement: "_3ScelFSPN1 _1lBcDcSPN1 _0tXlYZdnbC _4diMdqGsB2 _3Ku51Iogpp _3QFY1HEbN9 _4bQ7pPFQfX",
    avatar: "_1OimfuS5Zs",
    icon: "_1OimfuzXzM",
    sideNavSkeleton: "_2Y7lL42ADO _1lBcDc9DVM _3QFY1H5zaO _3ScelF9DVM"
};
/**
 * These styles are mirrored in:
 * packages/design-system/theme/src/constants.tsx
 * packages/design-system/menu/src/menu-item/skeleton-heading-item.tsx
 *
 * Please update both.
 */ const $f15c7bf8370232c0$var$shimmerKeyframes = null;
/**
 * These styles are defined using `css` rather than `cssMap` as there is a bug when using
 * `cssMap` that causes a build failure due to the use of keyframes within this pseudo-element.
 */ const $f15c7bf8370232c0$var$shimmerStyles = null;
/**
 * __Skeleton item__
 *
 * A skeleton item is used in place of an item when its contents it not ready.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/skeleton-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $f15c7bf8370232c0$var$SkeletonItem = ({ hasAvatar: hasAvatar, hasIcon: hasIcon, isShimmering: isShimmering = false, isSideNavSkeleton: isSideNavSkeleton = false, testId: testId, width: width, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        className: (0, $gJ6nT.default)([
            $f15c7bf8370232c0$var$styles.root,
            (hasAvatar || hasIcon) && $f15c7bf8370232c0$var$styles.beforeElement,
            hasAvatar && $f15c7bf8370232c0$var$styles.avatar,
            hasIcon && $f15c7bf8370232c0$var$styles.icon,
            width ? $f15c7bf8370232c0$var$styles.customWidth : $f15c7bf8370232c0$var$styles.defaultWidth,
            isSideNavSkeleton && $f15c7bf8370232c0$var$styles.sideNavSkeleton,
            isShimmering && "",
            isShimmering && "_21qtfOkSs3 _0160FKkSs3 _1nw4qxfONH _1iAcE9fONH _2VLDZtSHWH _0YTlblSHWH _30VpOT55dm _2ofBtg55dm _2WuqwLHVQb _2lXp1JHVQb _3wEj0XGsB2 _4diMdqGsB2",
            xcss
        ]),
        style: {
            '--width': width
        },
        "data-testid": testId
    });
};
$f15c7bf8370232c0$var$SkeletonItem.displayName = "SkeletonItem";
var $f15c7bf8370232c0$export$2e2bcd8739ae039 = $f15c7bf8370232c0$var$SkeletonItem;

});

parcelRegister("6pEG8", function(module, exports) {
$parcel$export(module.exports, "getWorkspaceThemePreference", () => $3033e3e03242fec3$export$8a05dde4568766d5);
$parcel$export(module.exports, "updateWorkspaceThemePreference", () => $3033e3e03242fec3$export$21a54a869d2847fd);

var $9OzVF = parcelRequire("9OzVF");

var $dj0x8 = parcelRequire("dj0x8");

var $iNT4o = parcelRequire("iNT4o");

var $llCao = parcelRequire("llCao");

var $5YW6K = parcelRequire("5YW6K");

var $hstQk = parcelRequire("hstQk");
const $3033e3e03242fec3$export$8a05dde4568766d5 = async (environment, workspaceAri, accountId)=>{
    if (!(0, $llCao.fg)('shared-user-preferences')) return undefined;
    const response = await (0, $iNT4o.fetchQuery)(environment, (0, $dj0x8.default), {
        workspaceAri: workspaceAri,
        accountId: accountId
    }).toPromise();
    const themeString = response?.settings_userPreferencesResolved?.theme;
    if (!themeString) return undefined;
    return (0, $hstQk.updateThemeWithDefaultValues)(themeString);
};
const $3033e3e03242fec3$export$21a54a869d2847fd = async (environment, workspaceAri, accountId, themeState)=>{
    if (!(0, $llCao.fg)('shared-user-preferences')) return;
    // Serialize theme object to string for GraphQL
    const themeString = (0, $5YW6K.themeObjectToString)(themeState);
    // Shared cache updater function for both optimistic and confirmed updates
    const updateCache = (store)=>{
        const root = store.getRoot();
        const resolvedPreferences = root.getLinkedRecord('settings_userPreferencesResolved', {
            workspaceAri: workspaceAri,
            accountId: accountId
        });
        if (resolvedPreferences) resolvedPreferences.setValue(themeString, 'theme');
    };
    return new Promise((resolve, reject)=>{
        (0, $iNT4o.commitMutation)(environment, {
            mutation: (0, $9OzVF.default),
            variables: {
                workspaceAri: workspaceAri,
                accountId: accountId,
                theme: themeString
            },
            // Optimistically update the cache for immediate UI feedback
            // Relay automatically reverts this if the mutation fails
            optimisticUpdater: updateCache,
            // Apply the confirmed server response to the cache
            updater: updateCache,
            onCompleted: (_, errors)=>{
                if (errors && errors.length > 0) reject(new Error(errors.map((e)=>e.message).join('; ')));
                else resolve();
            },
            onError: (error)=>{
                reject(error);
            }
        });
    });
};

});
parcelRegister("9OzVF", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c2a99492a373577$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<987867774544e4f15c78f3627b3a8203>>
 * @relayHash ced2fc19e942c004393c066bef43384d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2d8511617c2ae739deca629af208d0c0aff791868ae7f06fd41f3bca8189b104
const $6c2a99492a373577$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "theme"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "workspaceAri"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accountId",
                    "variableName": "accountId"
                },
                {
                    "kind": "Variable",
                    "name": "theme",
                    "variableName": "theme"
                },
                {
                    "kind": "Variable",
                    "name": "workspaceAri",
                    "variableName": "workspaceAri"
                }
            ],
            "concreteType": "SettingsUserPreferences",
            "kind": "LinkedField",
            "name": "settings_updateUserPreferencesWorkspace",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "theme"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "workspaceThemeManagementSetWorkspaceThemePreferenceMutation",
            "selections": v3 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "workspaceThemeManagementSetWorkspaceThemePreferenceMutation",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "id": "2d8511617c2ae739deca629af208d0c0aff791868ae7f06fd41f3bca8189b104",
            "metadata": {},
            "name": "workspaceThemeManagementSetWorkspaceThemePreferenceMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$6c2a99492a373577$var$node.hash = "a59aa9b6da224d8962255852220e8493";
var $6c2a99492a373577$export$2e2bcd8739ae039 = $6c2a99492a373577$var$node;

});

parcelRegister("dj0x8", function(module, exports) {
$parcel$export(module.exports, "default", () => $fabfe3a0f43f15b8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f3d7efe2efb8521ac39409b96cee46e7>>
 * @relayHash 62e15c72deef7eaf4c9035e5e1976db0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 58bfe0135afad3b1d316f22b2877ad9574655e849a508aebd203bfbc9e5828dc
const $fabfe3a0f43f15b8$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "workspaceAri"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accountId",
                    "variableName": "accountId"
                },
                {
                    "kind": "Variable",
                    "name": "workspaceAri",
                    "variableName": "workspaceAri"
                }
            ],
            "concreteType": "SettingsUserPreferences",
            "kind": "LinkedField",
            "name": "settings_userPreferencesResolved",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "theme"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "workspaceThemeManagementGetWorkspaceThemePreferenceQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "workspaceThemeManagementGetWorkspaceThemePreferenceQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "id": "58bfe0135afad3b1d316f22b2877ad9574655e849a508aebd203bfbc9e5828dc",
            "metadata": {},
            "name": "workspaceThemeManagementGetWorkspaceThemePreferenceQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$fabfe3a0f43f15b8$var$node.hash = "3f7fd599e886181a5359ad8f6fbe4487";
var $fabfe3a0f43f15b8$export$2e2bcd8739ae039 = $fabfe3a0f43f15b8$var$node;

});

parcelRegister("hstQk", function(module, exports) {
$parcel$export(module.exports, "updateThemeWithDefaultValues", () => $0d8fecdb8dc2447c$export$bc77b52491b156d8);

var $34ieU = parcelRequire("34ieU");

var $6MspN = parcelRequire("6MspN");
const $0d8fecdb8dc2447c$export$bc77b52491b156d8 = (themeString)=>(0, $6MspN.updateThemeObjectWithDefaultValues)((0, $34ieU.themeStringToObject)(themeString));

});
parcelRegister("6MspN", function(module, exports) {
$parcel$export(module.exports, "updateThemeObjectWithDefaultValues", () => $5676c6dab9682db0$export$830acc849806885d);

var $9eB94 = parcelRequire("9eB94");
const $5676c6dab9682db0$export$830acc849806885d = (themeObject)=>({
        ...(0, $9eB94.DEFAULT_THEME),
        ...themeObject
    });

});
parcelRegister("9eB94", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_THEME", () => $5dc97f2474489efa$export$2faeed762aac6741);
const $5dc97f2474489efa$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
const $5dc97f2474489efa$export$854b45b62d1eb6d4 = 'auto';
const $5dc97f2474489efa$export$2faeed762aac6741 = {
    dark: 'dark',
    light: 'light',
    colorMode: $5dc97f2474489efa$export$854b45b62d1eb6d4,
    typography: 'typography'
};

});




parcelRegister("dm1zq", function(module, exports) {
$parcel$export(module.exports, "SideNav", () => (parcelRequire("e2iel")).SideNav);
$parcel$export(module.exports, "SideNavHeader", () => (parcelRequire("6TzXj")).SideNavHeader);
$parcel$export(module.exports, "SideNavBody", () => (parcelRequire("1cXVb")).SideNavBody);
$parcel$export(module.exports, "SideNavFooter", () => (parcelRequire("6gbAc")).SideNavFooter);
$parcel$export(module.exports, "SideNavToggleButton", () => (parcelRequire("5HD6l")).SideNavToggleButton);
$parcel$export(module.exports, "useToggleSideNav", () => (parcelRequire("1MUCD")).useToggleSideNav);
$parcel$export(module.exports, "useExpandSideNav", () => (parcelRequire("dXooW")).useExpandSideNav);
$parcel$export(module.exports, "useSideNavRef", () => (parcelRequire("5GVRi")).useSideNavRef);
$parcel$export(module.exports, "SideNavPanelSplitter", () => (parcelRequire("dfLOm")).SideNavPanelSplitter);

var $e2iel = parcelRequire("e2iel");

var $6TzXj = parcelRequire("6TzXj");

var $1cXVb = parcelRequire("1cXVb");

var $6gbAc = parcelRequire("6gbAc");

var $5HD6l = parcelRequire("5HD6l");

var $1MUCD = parcelRequire("1MUCD");

var $dXooW = parcelRequire("dXooW");

var $5GVRi = parcelRequire("5GVRi");

var $dfLOm = parcelRequire("dfLOm");

});
parcelRegister("e2iel", function(module, exports) {
$parcel$export(module.exports, "SideNav", () => $7b5d093607cf439b$export$1a35787d6353cf6a);
/* side-nav.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");

var $fsvuC = parcelRequire("fsvuC");

var $80czl = parcelRequire("80czl");

var $dqdTY = parcelRequire("dqdTY");

var $mhEfz = parcelRequire("mhEfz");

var $fz4Xf = parcelRequire("fz4Xf");

var $hDNNn = parcelRequire("hDNNn");

var $BWeKH = parcelRequire("BWeKH");

var $jDV7v = parcelRequire("jDV7v");

var $llCao = parcelRequire("llCao");

var $iNmwK = parcelRequire("iNmwK");

var $ekfU9 = parcelRequire("ekfU9");

var $eMRN7 = parcelRequire("eMRN7");

var $eVEPg = parcelRequire("eVEPg");

var $kqgCs = parcelRequire("kqgCs");

var $c04Nx = parcelRequire("c04Nx");

var $gli8N = parcelRequire("gli8N");

var $cRpV8 = parcelRequire("cRpV8");

var $brcYx = parcelRequire("brcYx");

var $cNKD8 = parcelRequire("cNKD8");

var $gGB9z = parcelRequire("gGB9z");

var $a1xUa = parcelRequire("a1xUa");

var $1tX1p = parcelRequire("1tX1p");

var $1swgG = parcelRequire("1swgG");


var $hpUp8 = parcelRequire("hpUp8");

var $6F8Q8 = parcelRequire("6F8Q8");

var $3ruGx = parcelRequire("3ruGx");

var $bDAkn = parcelRequire("bDAkn");

var $dXooW = parcelRequire("dXooW");

var $h4mAl = parcelRequire("h4mAl");

var $5GVRi = parcelRequire("5GVRi");

var $fxB4T = parcelRequire("fxB4T");

var $2SRvb = parcelRequire("2SRvb");

var $3jUQt = parcelRequire("3jUQt");

var $1MUCD = parcelRequire("1MUCD");
const $7b5d093607cf439b$var$panelSplitterResizingVar = '--n_snvRsz';
const $7b5d093607cf439b$var$fallbackMinWidth = '240px';
function $7b5d093607cf439b$var$getPixelCustomProperty(element, propertyName, fallback) {
    const raw = getComputedStyle(element).getPropertyValue(propertyName).trim();
    const value = Number.parseFloat(raw);
    return Number.isFinite(value) ? (0, $brcYx.resolveLayoutWidth)(raw.endsWith('vw') ? `${value}vw` : value, window.innerWidth) : fallback;
}
/**
 * We are using JS to detect Firefox and disable animations, instead of using CSS, as Compiled currently does not merge duplicate
 * CSS at-rules when at-rules are nested: https://github.com/atlassian-labs/compiled/blob/e04a325915e1d13010205089e4915de0e53bc2d4/packages/css/src/plugins/merge-duplicate-at-rules.ts#L5
 * Avoiding nesting the `@supports` at-rule inside of `@media` means Compiled can remove duplicate styles from the generated CSS.
 */ const $7b5d093607cf439b$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
const $7b5d093607cf439b$var$styles = {
    root: "_2YmqfPYbGa _1VfddaYbGa _0KLXruoI2d _2OUyjtGk8v _24h04i2Njc _0jFU0VlOMI _2I62gzgiHs _1mT5xdHE3j _39xV02uZus _42Yu6BiZR3 _2EWYUbX3P0 _1KvygPUzyj _1EUs3cOeNX _0hAebtlfZc _1RYJRxYbGa _0xO92q39pk",
    chatPanelSizing: "_39xV02X3P0",
    managedOverlay: "_0PZ8vNOQJL _0qV2O6YbGa _27XaGGoI2d _3GwBusGk8v",
    flyoutOpen: "_1KvygPOQJL _1EUs3cYbGa _0hAebtoI2d _1RYJRxGk8v _2AFbI1Rodp _4kVtJl2HTN _1UvFJ1ThaV _1E7uFmIt9z",
    flyoutAnimateClosed: "_3iDTPbYbGa _1KvygPOQJL _2AFbI1Rodp _4kVtJl2HTN _1UvFJ1ThaV _4pNSLEIt9z",
    flexContainer: "_0jFU0VN91d _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuI7V3",
    hiddenMobileAndDesktop: "_3iDTPbYbGa",
    hiddenMobileOnly: "_3iDTPbYbGa _0THHewyL8i",
    hiddenDesktopOnly: "_0THHewYbGa"
};
/**
 * Styles for the side nav enter/exit animations when `platform-dst-motion-uplift-sidenav` is enabled.
 *
 * These use the `motion.sidenav.*` tokens (keyframe animations) instead of the `transform` transitions
 * with `@starting-style` used by `styles`.
 *
 * ⚠️ The `transition-duration` values below need to stay in sync with the duration baked into the tokens
 * (`motion.sidenav.enter.*` is 250ms, `motion.sidenav.exit.*` is 200ms). The `display` property is
 * transitioned (with `allow-discrete`) so the element stays rendered for the length of the exit animation —
 * if the transition is shorter than the animation, `display: none` applies early and the exit animation
 * never runs.
 */ const $7b5d093607cf439b$var$motionUpliftStyles = {
    animationRTLSupport: "_0PlsTg2NCt _41VWnOVFMz _3G2eGnoK2N _0bboGQuqca",
    animationBaseStyles: "_2qDx9m4Gny _4tikTSThaV _03Q0eeLrT7",
    expandAnimationMobile: "_1jZhRJWRfq",
    collapseAnimationMobile: "_3NcSKiOQJL _1jZhRJTRd8",
    flyoutOpen: "_1KvygPOQJL _1EUs3cYbGa _0hAebtoI2d _1RYJRxGk8v _0k9R9aWRfq _4kVtJlqvoi _1UvFJ1ThaV",
    flyoutAnimateClosed: "_3iDTPbYbGa _1KvygPOQJL _0k9R9aTRd8 _4kVtJlLrT7 _1UvFJ1ThaV",
    expandAnimationDesktop: "_4fJQ5SUzyj _1wp4FmWRfq _4Bj9bNOQJL _2SsmzmIE5y _19NLAJxlqh _4y5EJLCT93",
    collapseAnimationDesktop: "_4fJQ5SOQJL _1wp4FmTRd8 _2SsmzmjYL6 _19NLAJw3oi _4y5EJLxGIf"
};
const $7b5d093607cf439b$var$fallbackDefaultWidth = 320;
const $7b5d093607cf439b$export$c735dc1c21910e21 = 500;
/**
 * We need an additional component layer so we can wrap the side nav in a `OpenLayerObserver` and have access to the
 * context value.
 */ function $7b5d093607cf439b$var$SideNavInternal({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidthProp = $7b5d093607cf439b$var$fallbackDefaultWidth, minWidth: minWidth = $7b5d093607cf439b$var$fallbackMinWidth, maxWidth: maxWidth, testId: testId, label: label = 'Sidebar', skipLinkLabel: skipLinkLabel = label, onExpand: onExpand, onCollapse: onCollapse, onPeekStart: onPeekStart, onPeekEnd: onPeekEnd, id: providedId, canToggleWithShortcut: canToggleWithShortcut }) {
    const isChatPanelLayoutEnabled = (0, $llCao.fg)('platform-dst-chat-panel-layout');
    const id = (0, $a1xUa.useLayoutId)({
        providedId: providedId
    });
    const expandAndFocusSideNav = (0, $dXooW.useExpandSideNav)({
        trigger: 'skip-link'
    });
    /**
   * Called after clicking on the side nav skip link, and ensures the side nav is expanded so that it is focusable.
   *
   * We need to update the DOM synchronously because `.focus()` is called synchronously after this state update.
   *
   * Only used when `platform_dst_nav4_skip_link_a11y_1` is OFF; can be removed on gate cleanup.
   */ const synchronouslyExpandSideNav = (0, $fsvuC.useCallback)(()=>{
        (0, $80czl.flushSync)(()=>{
            /**
       * Calling this unconditionally and relying on it to avoid no-op renders.
       *
       * We _could_ call it conditionally, but we'd be duplicating the screen size checks `expandAndFocusSideNav` makes.
       */ expandAndFocusSideNav();
        });
    }, [
        expandAndFocusSideNav
    ]);
    (0, $ekfU9.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        /**
     * `navigate` is the gate-on contract: it owns expanding the side nav AND moving
     * focus to the first nav item, atomically (via `useExpandSideNav`'s `flushSync`).
     *
     * `onBeforeNavigate` is the legacy contract used only when the gate is OFF.
     * On gate cleanup, drop `onBeforeNavigate` and `synchronouslyExpandSideNav` here.
     */ navigate: (0, $llCao.fg)('platform_dst_nav4_skip_link_a11y_1') ? expandAndFocusSideNav : undefined,
        onBeforeNavigate: (0, $llCao.fg)('platform_dst_nav4_skip_link_a11y_1') ? undefined : synchronouslyExpandSideNav
    });
    const sideNavState = (0, $fsvuC.useContext)((0, $bDAkn.SideNavVisibilityState));
    const setSideNavState = (0, $fsvuC.useContext)((0, $hpUp8.SetSideNavVisibilityState));
    const { isExpandedOnDesktop: isExpandedOnDesktop, isExpandedOnMobile: isExpandedOnMobile } = (0, $2SRvb.useSideNavVisibility)({
        defaultCollapsed: defaultCollapsed
    });
    // We are placing `defaultCollapsed` into a state container so we can have a stable reference to the initial value.
    // This is so we can use it in an effect _that only runs once_, after the initial render on the client,
    // to sync the side nav context (provided in `<Root>`) with the `defaultCollapsed` prop provided to `<SideNav>`.
    const [initialDefaultCollapsed] = (0, $fsvuC.useState)(defaultCollapsed);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $mhEfz.useAnalyticsEvents)();
    const [initialIsExpandedOnDesktop] = (0, $fsvuC.useState)(isExpandedOnDesktop);
    /**
   * Captures the initial collapsed/expanded state of the side nav.
   *
   * Only firing on desktop because the nav is never open by default on mobile.
   */ (0, $fsvuC.useEffect)(()=>{
        if (initialIsExpandedOnDesktop) {
            const isDesktop = window.matchMedia('(min-width: 64rem)').matches;
            if (isDesktop) {
                const navigationAnalyticsEvent = createAnalyticsEvent({
                    source: 'topNav',
                    actionSubject: 'sideNav',
                    action: 'viewedOnLoad',
                    actionSubjectId: 'sideNavMenu',
                    attributes: {
                        screen: 'desktop'
                    }
                });
                navigationAnalyticsEvent.fire('navigation');
            }
        }
    }, [
        createAnalyticsEvent,
        initialIsExpandedOnDesktop
    ]);
    const defaultWidth = (0, $1swgG.useSafeDefaultWidth)({
        defaultWidthProp: defaultWidthProp,
        fallbackDefaultWidth: $7b5d093607cf439b$var$fallbackDefaultWidth,
        slotName: 'SideNav'
    });
    const [inlineWidth, setInlineWidth] = (0, $fsvuC.useState)(defaultWidth);
    const [overlayWidth, setOverlayWidth] = (0, $fsvuC.useState)(defaultWidth);
    const [isInline, setIsInline] = (0, $fsvuC.useState)(false);
    (0, $fsvuC.useEffect)(()=>{
        if (!isChatPanelLayoutEnabled) return;
        const mediaQuery = window.matchMedia('(min-width: 64rem)');
        setIsInline(mediaQuery.matches);
        const onChange = (event)=>setIsInline(event.matches);
        return (0, $dqdTY.bind)(mediaQuery, {
            type: 'change',
            listener: onChange
        });
    }, [
        isChatPanelLayoutEnabled
    ]);
    const toggleVisibilityForChatPanel = (0, $1MUCD.useToggleSideNav)({
        trigger: 'programmatic'
    });
    const closeOverlayForChatPanel = (0, $fsvuC.useCallback)(()=>{
        // Allocation can overlay an expanded desktop nav when other slots consume
        // its space. Dismiss the visibility state selected by the viewport, not the mode.
        const isDesktop = window.matchMedia('(min-width: 64rem)').matches;
        if (isDesktop ? isExpandedOnDesktop : isExpandedOnMobile) toggleVisibilityForChatPanel();
    }, [
        isExpandedOnDesktop,
        isExpandedOnMobile,
        toggleVisibilityForChatPanel
    ]);
    const { state: managedSizing, isManaged: isManaged, prepareResize: prepareResize, getResizeBounds: getManagedResizeBounds, startResize: startResize, resize: resize, completeResize: completeResize } = (0, $gGB9z.useLayoutAreaSizing)({
        area: 'side-nav',
        config: {
            defaultWidth: defaultWidth,
            minWidth: minWidth,
            maxWidth: maxWidth,
            isOpen: isInline ? isExpandedOnDesktop : isExpandedOnMobile,
            onRequestClose: closeOverlayForChatPanel
        }
    });
    const mode = managedSizing?.mode ?? (isInline ? 'inline' : 'overlay');
    const renderedWidth = isChatPanelLayoutEnabled ? managedSizing?.width ?? (mode === 'inline' ? inlineWidth : overlayWidth) : inlineWidth;
    const configuredMaxWidth = maxWidth ?? '100vw';
    const clampedWidth = !isChatPanelLayoutEnabled ? `clamp(240px, ${inlineWidth}px, 50vw)` : managedSizing ? `${renderedWidth}px` : `clamp(${minWidth}, ${renderedWidth}px, ${configuredMaxWidth})`;
    const dangerouslyHoistSlotSizes = (0, $fsvuC.useContext)((0, $c04Nx.DangerouslyHoistSlotSizes));
    const navRef = (0, $fsvuC.useRef)(null);
    const getResizeBounds = (0, $fsvuC.useCallback)(()=>{
        if (!isChatPanelLayoutEnabled) return {
            min: '240px',
            max: '50vw'
        };
        const managedBounds = getManagedResizeBounds();
        if (managedBounds) return managedBounds;
        const sideNav = navRef.current;
        const layoutRoot = sideNav?.parentElement;
        const main = layoutRoot?.querySelector(':scope > [data-layout-slot][role="main"]');
        const fallbackMaxWidth = maxWidth ?? (mode === 'inline' ? '100vw' : '90vw');
        if (!sideNav || mode === 'overlay') {
            const chatPanel = layoutRoot?.querySelector(':scope > [data-layout-chat-panel]');
            const inlineChatPanelWidth = chatPanel && getComputedStyle(chatPanel).gridArea === 'chat-panel' ? chatPanel.getBoundingClientRect().width : 0;
            const overlayMaxWidth = Math.floor((window.innerWidth - inlineChatPanelWidth) * 0.9);
            const constrainedMaxWidth = maxWidth ? Math.min((0, $gli8N.convertResizeBoundToPixels)(maxWidth), overlayMaxWidth) : overlayMaxWidth;
            return {
                min: minWidth,
                max: `${Math.max((0, $gli8N.convertResizeBoundToPixels)(minWidth), constrainedMaxWidth)}px`
            };
        }
        if (!main) return {
            min: minWidth,
            max: fallbackMaxWidth
        };
        const sideNavWidth = sideNav.getBoundingClientRect().width;
        const mainWidth = main.getBoundingClientRect().width;
        // JSDOM does not perform layout, so retain the static fallback in unit tests and other
        // environments where used widths cannot be measured.
        if (sideNavWidth === 0 || mainWidth === 0) return {
            min: minWidth,
            max: fallbackMaxWidth
        };
        const localPanel = main.querySelector('[data-layout-with-panel-slot]');
        const isLocalPanelInline = localPanel && getComputedStyle(localPanel).gridArea === 'panel';
        const localPanelWidth = isLocalPanelInline ? localPanel.getBoundingClientRect().width : 0;
        const mainContentWidth = mainWidth - localPanelWidth;
        const mainMinimumWidth = $7b5d093607cf439b$var$getPixelCustomProperty(main, (0, $eVEPg.mainMinimumWidthVar), 320);
        const availableWidth = Math.max(0, mainContentWidth - mainMinimumWidth);
        const availableInlineWidth = Math.floor(sideNavWidth + availableWidth);
        const constrainedMaxWidth = maxWidth ? Math.min((0, $gli8N.convertResizeBoundToPixels)(maxWidth), availableInlineWidth) : availableInlineWidth;
        return {
            min: minWidth,
            max: `${Math.max((0, $gli8N.convertResizeBoundToPixels)(minWidth), constrainedMaxWidth)}px`
        };
    }, [
        getManagedResizeBounds,
        isChatPanelLayoutEnabled,
        maxWidth,
        minWidth,
        mode
    ]);
    /**
   * Used to share the side nav element with the `Panel`,
   * which observes the side nav to determine its maximum width.
   */ const sharedRef = (0, $5GVRi.useSideNavRef)();
    const mergedRef = (0, $fz4Xf.default)([
        navRef,
        sharedRef
    ]);
    const onCompleteResize = (0, $fsvuC.useCallback)((finalWidth)=>{
        if (!isChatPanelLayoutEnabled) {
            setInlineWidth(finalWidth);
            return;
        }
        if (mode === 'inline') setInlineWidth(finalWidth);
        else setOverlayWidth(finalWidth);
        completeResize(mode, finalWidth);
    }, [
        completeResize,
        isChatPanelLayoutEnabled,
        mode
    ]);
    const onResizeStartInternal = (0, $fsvuC.useCallback)(()=>{
        startResize(mode);
    }, [
        mode,
        startResize
    ]);
    const onResizeInternal = (0, $fsvuC.useCallback)((width)=>resize(mode, width), [
        mode,
        resize
    ]);
    const toggleButtonElement = (0, $fsvuC.useContext)((0, $6F8Q8.SideNavToggleButtonElement));
    const topNavStartElement = (0, $fsvuC.useContext)((0, $eMRN7.TopNavStartElement));
    const devTimeOnlyAttributes = {};
    const openLayerObserver = (0, $jDV7v.useOpenLayerObserver)();
    const flyoutStateRef = (0, $fsvuC.useRef)({
        type: 'not-active'
    });
    const isFlyoutVisible = sideNavState?.flyout === 'open';
    // Flyouts, including their close animation, already have overlay placement.
    // The CSS-first inline allocation must not override it with an ID selector.
    const shouldApplyUnmanagedSizing = !managedSizing && sideNavState?.flyout !== 'open' && sideNavState?.flyout !== 'triggered-animate-close';
    const isExpandedOnDesktopRef = (0, $hDNNn.default)(isExpandedOnDesktop);
    const hasPeekStartedRef = (0, $fsvuC.useRef)(false);
    const onPeekStartRef = (0, $hDNNn.default)(onPeekStart);
    const onPeekEndRef = (0, $hDNNn.default)(onPeekEnd);
    const onPeekStartTimeoutIdRef = (0, $fsvuC.useRef)(undefined);
    (0, $fsvuC.useEffect)(()=>{
        return ()=>{
            clearTimeout(onPeekStartTimeoutIdRef.current);
        };
    }, []);
    const updateFlyoutState = (0, $fsvuC.useMemo)(()=>{
        function tryAbortPendingClose() {
            if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
        }
        function open() {
            const prevFlyoutState = flyoutStateRef.current;
            tryAbortPendingClose();
            flyoutStateRef.current = {
                type: 'open'
            };
            setSideNavState((currentState)=>{
                if (currentState?.desktop === 'collapsed' && currentState?.flyout !== 'open') return {
                    ...currentState,
                    flyout: 'open'
                };
                return currentState;
            });
            // Avoid redundant calls to `onPeekStart()`
            if (prevFlyoutState.type === 'not-active') {
                clearTimeout(onPeekStartTimeoutIdRef.current);
                onPeekStartTimeoutIdRef.current = setTimeout(()=>{
                    // If the flyout isn't still open after ~500ms then we won't count the peek
                    // As we want to track user intention rather than all hovers
                    if (isExpandedOnDesktopRef.current || flyoutStateRef.current.type !== 'open') return;
                    hasPeekStartedRef.current = true;
                    onPeekStartRef.current?.();
                }, $7b5d093607cf439b$export$c735dc1c21910e21);
            }
        }
        function close() {
            const prevFlyoutState = flyoutStateRef.current;
            tryAbortPendingClose();
            flyoutStateRef.current = {
                type: 'not-active'
            };
            setSideNavState((currentState)=>{
                if (currentState?.desktop === 'collapsed' && currentState?.flyout === 'open') return {
                    ...currentState,
                    flyout: 'triggered-animate-close'
                };
                return currentState;
            });
            // Avoid redundant calls to `onPeekEnd()`
            if (prevFlyoutState.type !== 'not-active' && hasPeekStartedRef.current) {
                hasPeekStartedRef.current = false;
                onPeekEndRef.current?.({
                    trigger: isExpandedOnDesktopRef.current ? 'side-nav-expand' : 'mouse-leave'
                });
            }
        }
        return function onAction(action) {
            if (action === 'drag-from-flyout-started') {
                open();
                flyoutStateRef.current = {
                    type: 'is-dragging-from-flyout'
                };
                return;
            }
            if (action === 'drag-from-flyout-finished') {
                open();
                return;
            }
            // ignoring all actions until the drag is finished
            if (flyoutStateRef.current.type === 'is-dragging-from-flyout') return;
            if (action === 'open') {
                open();
                return;
            }
            if (action === 'waiting-for-close') {
                if (flyoutStateRef.current.type === 'waiting-for-close') return;
                // A timeout is used to close the flyout after a delay when the user mouses out of the flyout area, and to allow
                // us to cancel the close if the user mouses back in.
                const timeout = setTimeout(()=>{
                    updateFlyoutState('ready-to-close');
                }, (0, $506751ca64a81ea5$export$a7801e29f563faad));
                flyoutStateRef.current = {
                    type: 'waiting-for-close',
                    abort () {
                        clearTimeout(timeout);
                    }
                };
                return;
            }
            if (action === 'ready-to-close') {
                // If there are no open layers, we can close the flyout.
                if (openLayerObserver?.getCount({
                    namespace: (0, $eVEPg.openLayerObserverSideNavNamespace)
                }) === 0) {
                    close();
                    return;
                }
                flyoutStateRef.current = {
                    type: 'ready-to-close'
                };
                return;
            }
            if (action === 'force-close') {
                close();
                return;
            }
        };
    }, [
        isExpandedOnDesktopRef,
        onPeekEndRef,
        onPeekStartRef,
        openLayerObserver,
        setSideNavState
    ]);
    const toggleVisibilityByScreenResize = (0, $1MUCD.useToggleSideNav)({
        trigger: 'screen-resize'
    });
    const toggleVisibilityByClickOutsideOnMobile = (0, $1MUCD.useToggleSideNav)({
        trigger: 'click-outside-on-mobile'
    });
    // Using `useLayoutEffect` so that there's no visual shift in non-SSR environments when using legacy API
    // For SSR the new API is still necessary
    (0, $fsvuC.useLayoutEffect)(()=>{
        if (sideNavState !== null) // Only need to do an initial sync if it hasn't been initialized from Root
        return;
        // Sync the visibility in context (provided in `<Root>`) with the local `defaultCollapsed` prop provided to `SideNav`
        // after SSR hydration. This should only run once, after the initial render on the client.
        (0, $fsvuC.startTransition)(()=>{
            setSideNavState({
                desktop: initialDefaultCollapsed ? 'collapsed' : 'expanded',
                mobile: 'collapsed',
                flyout: 'closed',
                lastTrigger: null
            });
        });
    }, [
        initialDefaultCollapsed,
        setSideNavState,
        sideNavState
    ]);
    const handleExpand = (0, $fsvuC.useCallback)(({ screen: screen, trigger: trigger })=>{
        onExpand?.({
            screen: screen,
            trigger: trigger
        });
        const navigationAnalyticsEvent = createAnalyticsEvent({
            source: 'topNav',
            actionSubject: 'sideNav',
            action: 'expanded',
            actionSubjectId: 'sideNavMenu',
            attributes: {
                trigger: trigger
            }
        });
        navigationAnalyticsEvent.fire('navigation');
        // When the side nav gets expanded, we close the flyout to reset it.
        // This prevents the flyout from staying open and ensures we are respecting the user's intent to expand.
        updateFlyoutState('force-close');
    }, [
        onExpand,
        updateFlyoutState,
        createAnalyticsEvent
    ]);
    const handleCollapse = (0, $fsvuC.useCallback)(({ screen: screen, trigger: trigger })=>{
        onCollapse?.({
            screen: screen,
            trigger: trigger
        });
        const navigationAnalyticsEvent = createAnalyticsEvent({
            source: 'topNav',
            actionSubject: 'sideNav',
            action: 'collapsed',
            actionSubjectId: 'sideNavMenu',
            attributes: {
                trigger: trigger
            }
        });
        navigationAnalyticsEvent.fire('navigation');
        // When the side nav gets collapsed, we close the flyout to reset it.
        // This prevents the flyout from staying open and ensures we are respecting the user's intent to collapse.
        updateFlyoutState('force-close');
    }, [
        onCollapse,
        updateFlyoutState,
        createAnalyticsEvent
    ]);
    (0, $3jUQt.useSideNavVisibilityCallbacks)({
        onExpand: handleExpand,
        onCollapse: handleCollapse,
        isExpandedOnDesktop: isExpandedOnDesktop,
        isExpandedOnMobile: isExpandedOnMobile,
        lastTrigger: sideNavState?.lastTrigger ?? null
    });
    (0, $fsvuC.useEffect)(()=>{
        const mediaQueryList = window.matchMedia('(min-width: 64rem)');
        return (0, $dqdTY.bind)(mediaQueryList, {
            type: 'change',
            listener () {
                if (mediaQueryList.matches) // We're transitioning from tablet to desktop viewport size.
                // We forcibly show the side nav if it was shown on mobile.
                {
                    if (isExpandedOnMobile && !isExpandedOnDesktop) toggleVisibilityByScreenResize();
                }
            }
        });
    }, [
        toggleVisibilityByScreenResize,
        isExpandedOnDesktop,
        isExpandedOnMobile
    ]);
    /**
   * Close the mobile side nav if there is a click outside.
   *
   * Binding/unbinding on changes to `isExpandedOnMobile` instead of window size changes for simplicity.
   * If we listened to window size changes we'd need nested `bind()` calls.
   */ (0, $fsvuC.useEffect)(()=>{
        if (!isExpandedOnMobile) return;
        /**
     * The expected URL fragment used by the side nav skip link.
     */ const skipLinkUrlFragment = `#${id}`;
        return (0, $dqdTY.bind)(window, {
            type: 'click',
            listener (event) {
                if (window.matchMedia('(min-width: 64rem)').matches) // Clicks on desktop should do nothing
                return;
                const sideNav = navRef.current;
                if (!sideNav || !(event.target instanceof Node)) // Ignore if our element references are invalid
                return;
                if (!event.target.isConnected) /**
           * If the element that was clicked is no longer in the document, we should not collapse the side nav.
           * This can happen when the user clicks on a dropdown menu item (such as one used in a `...` More menu),
           * as the dropdown menu will close after being clicked. By the time this event listener runs, the clicked
           * element will no longer be in the document, so the check below for `sideNav.contains(event.target)` will fail.
           */ return;
                if (sideNav.contains(event.target)) // Clicks inside the side nav should not close it
                return;
                if (toggleButtonElement?.contains(event.target)) // Clicks on the toggle button will already toggle the side nav,
                // so we need to ignore it or we end up doing a double toggle
                return;
                if (event.target instanceof HTMLAnchorElement && /**
         * Intentionally using `.getAttribute()` for simplicity to match exactly what we expect
         * for skip links.
         *
         * Alternatives considered:
         *
         * - Using `.href` returns a full URL, which would then require extra parsing.
         * - Using `.hash` could incorrectly capture `<a href="/another-page#skip-link-id>` so we'd need extra checks.
         *
         * This approach has an edge case of `<a href="/same-page#skip-link-id>` not being captured,
         * but we are okay with that trade-off.
         */ event.target.getAttribute('href') === skipLinkUrlFragment) // This was a click on a link to the side nav, so we shouldn't try to collapse the SideNav.
                // It was most likely the skip link, although anyone can render a link with the ID.
                // In either case keeping the SideNav expanded makes sense.
                return;
                toggleVisibilityByClickOutsideOnMobile();
            }
        });
    }, [
        id,
        isExpandedOnMobile,
        toggleButtonElement,
        toggleVisibilityByClickOutsideOnMobile
    ]);
    (0, $fsvuC.useEffect)(()=>{
        if (!toggleButtonElement) return;
        return (0, $dqdTY.bind)(toggleButtonElement, {
            type: 'mouseenter',
            listener () {
                // Only flyout the side nav if the user hovered while the side nav was collapsed
                if (isExpandedOnDesktop) return;
                // Only flyout the side nav on desktop viewports
                const { matches: matches } = window.matchMedia('(min-width: 64rem)');
                if (matches) updateFlyoutState('open');
            }
        });
    }, [
        updateFlyoutState,
        toggleButtonElement,
        isExpandedOnDesktop
    ]);
    (0, $fsvuC.useEffect)(()=>{
        if (!toggleButtonElement) return;
        return (0, $dqdTY.bind)(toggleButtonElement, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        toggleButtonElement,
        updateFlyoutState
    ]);
    (0, $fsvuC.useEffect)(()=>{
        if (!navRef.current) return;
        return (0, $dqdTY.bind)(navRef.current, {
            type: 'mouseenter',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (isExpandedOnDesktop || !isFlyoutVisible) return;
                // The user mouses has moused back over the side nav
                updateFlyoutState('open');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState,
        isExpandedOnDesktop
    ]);
    (0, $fsvuC.useEffect)(()=>{
        if (!navRef.current) return;
        return (0, $dqdTY.bind)(navRef.current, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $fsvuC.useEffect)(()=>{
        const nav = navRef.current;
        if (!nav) return;
        if (!isFlyoutVisible) return;
        // Using a monitor rather than a drop target. Rationale:
        // - We are not creating a drop target for the users to drop on,
        //   we are just interested in listening to events within an element
        // - We do not want to impact `location.{*}.dropTargets` in events
        return (0, $iNmwK.monitorForElements)({
            canMonitor ({ source: source }) {
                return nav.contains(source.element);
            },
            onGenerateDragPreview () {
                updateFlyoutState('drag-from-flyout-started');
            },
            onDrop ({ location: location }) {
                // Always marking the drag and done
                updateFlyoutState('drag-from-flyout-finished');
                // If the user dropped outside of the flyout, we will close the flyout
                const underUsersPointer = document.elementFromPoint(location.current.input.clientX, location.current.input.clientY);
                if (!nav.contains(underUsersPointer)) updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $fsvuC.useEffect)(()=>{
        if (!topNavStartElement || !toggleButtonElement) return;
        return (0, $dqdTY.bind)(topNavStartElement, {
            type: 'mouseover',
            listener (event) {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (isExpandedOnDesktop || !isFlyoutVisible) return;
                if (event.target === topNavStartElement) {
                    // The mouse is directly over the TopNavStart element, so cancel any pending flyout closes.
                    updateFlyoutState('open');
                    return;
                }
                if (event.target instanceof Element && toggleButtonElement.contains(event.target)) // The mouse is over the toggle button or any of its children, so we don't want to close the flyout.
                // We also don't need to cancel any pending closes, as we have separate event listeners for the toggle button mouse events.
                return;
                // The user has moused over a child element of the TopNavStart element that isn't the toggle button, e.g. the app switcher or nav logo,
                // so we should close the flyout (with a delay).
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        topNavStartElement,
        isFlyoutVisible,
        toggleButtonElement,
        isExpandedOnDesktop,
        updateFlyoutState
    ]);
    (0, $fsvuC.useEffect)(()=>{
        if (!topNavStartElement) return;
        return (0, $dqdTY.bind)(topNavStartElement, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                // The mouse has left the TopNavStart element, so we should close the flyout with a delay.
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        topNavStartElement,
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $fsvuC.useEffect)(()=>{
        // Close the flyout if there are no more layers open and the user is not mousing over the
        // flyout areas (side nav, TopNavStart element)
        return openLayerObserver?.onChange(({ count: count })=>{
            if (flyoutStateRef.current.type === 'ready-to-close' && count === 0) updateFlyoutState('force-close');
        }, {
            namespace: (0, $eVEPg.openLayerObserverSideNavNamespace)
        });
    }, [
        openLayerObserver,
        updateFlyoutState
    ]);
    (0, $fsvuC.useEffect)(()=>{
        // Clear flyout close timer if being unmounted
        return function cleanupPendingFlyoutClose() {
            if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
        };
    }, []);
    (0, $fxB4T.useSideNavToggleKeyboardShortcut)({
        canToggleWithShortcut: canToggleWithShortcut
    });
    // Used to conditionally display the keyboard shortcut in the SideNavPanelSplitter tooltip.
    const isShortcutEnabled = (0, $h4mAl.useIsSideNavShortcutEnabled)();
    (0, $1tX1p.useResizingWidthCssVarOnRootElement)({
        isEnabled: !isChatPanelLayoutEnabled || !managedSizing,
        cssVar: $7b5d093607cf439b$var$panelSplitterResizingVar,
        panelId: (0, $eVEPg.sideNavPanelSplitterId)
    });
    const isExpandedStateDifferentFromInitial = isExpandedOnMobile || isExpandedOnDesktop !== initialIsExpandedOnDesktop;
    /**
   * Used to track (between renders) if the expanded state of the side nav has ever changed since mount.
   *
   * Cannot rely solely on `isExpandedStateDifferentFromInitial` because the expanded state can go back to the initial state.
   */ const hasExpandedStateChangedRef = (0, $fsvuC.useRef)(false);
    (0, $fsvuC.useEffect)(()=>{
        if (hasExpandedStateChangedRef.current) return;
        if (isExpandedStateDifferentFromInitial) hasExpandedStateChangedRef.current = true;
    }, [
        isExpandedStateDifferentFromInitial
    ]);
    /**
   * If the expanded state of the side nav has ever changed since mount.
   *
   * Used to prevent sidebar expand animations from running on the initial load.
   * Otherwise, the `@starting-style` rule will cause the sidebar to slide in initially.
   */ const hasExpandedStateChanged = isExpandedStateDifferentFromInitial || hasExpandedStateChangedRef.current;
    const isMotionUpliftEnabled = (0, $llCao.fg)('platform-dst-motion-uplift-sidenav');
    // This is only used for the regular expand and collapse animations, not the flyout animations.
    const shouldShowSidebarToggleAnimation = isMotionUpliftEnabled && // We do not apply the animation styles on the initial render, as the `@starting-style` rule will cause the sidebar to
    // slide in initially.
    hasExpandedStateChanged && // We also do not apply the animation styles if the side nav is in flyout mode to make sure we don't override flyout styles.
    // If we instead try to unset the `transform` property in the flyout styles using `transform: initial`, it results in the entire
    // flyout animation being disabled.
    !isFlyoutVisible && /**
   * Disabling animations for Firefox, as it doesn't support animating the `display` property:
   * https://caniuse.com/mdn-css_properties_display_is_transitionable
   *
   * As of October 2025, Firefox supports the expand animation, but not the collapse animation (it instantly changes to `display: none`).
   * Because of this, we are disabling all sidebar animations for Firefox so it doesn't look like a bug.
   *
   * Unfortunately we cannot use `@supports` to target the support of `transition-behavior: allow-discrete` specifically
   * for the `display` property. And `@supports at-rule(@starting-style)` is also not ready for browser use yet.
   *
   * We are using JS to detect Firefox and disable animations, instead of using CSS, as Compiled currently does not merge duplicate
   * CSS at-rules when at-rules are nested: https://github.com/atlassian-labs/compiled/blob/e04a325915e1d13010205089e4915de0e53bc2d4/packages/css/src/plugins/merge-duplicate-at-rules.ts#L5
   * Avoiding nesting the `@supports` at-rule inside of `@media` means Compiled can remove duplicate styles from the generated CSS.
   */ !$7b5d093607cf439b$var$isFirefox;
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Fragment, {
        children: /*#__PURE__*/ (0, $5chsV.jsxs)("nav", {
            id: id,
            ...devTimeOnlyAttributes,
            "data-layout-slot": true,
            "aria-label": label,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop
                [(0, $eVEPg.sideNavVar)]: clampedWidth
            },
            ref: mergedRef,
            "data-testid": testId,
            className: (0, $gJ6nT.default)([
                $7b5d093607cf439b$var$styles.root,
                isChatPanelLayoutEnabled && $7b5d093607cf439b$var$styles.chatPanelSizing,
                isChatPanelLayoutEnabled && managedSizing?.mode === 'overlay' && $7b5d093607cf439b$var$styles.managedOverlay,
                isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $7b5d093607cf439b$var$styles.hiddenMobileOnly,
                !isExpandedOnDesktop && isExpandedOnMobile && !isFlyoutVisible && $7b5d093607cf439b$var$styles.hiddenDesktopOnly,
                !isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $7b5d093607cf439b$var$styles.hiddenMobileAndDesktop,
                isMotionUpliftEnabled && $7b5d093607cf439b$var$motionUpliftStyles.animationRTLSupport,
                shouldShowSidebarToggleAnimation && isMotionUpliftEnabled && $7b5d093607cf439b$var$motionUpliftStyles.animationBaseStyles,
                isExpandedOnMobile && shouldShowSidebarToggleAnimation && isMotionUpliftEnabled && $7b5d093607cf439b$var$motionUpliftStyles.expandAnimationMobile,
                !isExpandedOnMobile && shouldShowSidebarToggleAnimation && isMotionUpliftEnabled && $7b5d093607cf439b$var$motionUpliftStyles.collapseAnimationMobile,
                isExpandedOnDesktop && shouldShowSidebarToggleAnimation && isMotionUpliftEnabled && $7b5d093607cf439b$var$motionUpliftStyles.expandAnimationDesktop,
                !isExpandedOnDesktop && shouldShowSidebarToggleAnimation && isMotionUpliftEnabled && $7b5d093607cf439b$var$motionUpliftStyles.collapseAnimationDesktop,
                sideNavState?.flyout === 'open' && isMotionUpliftEnabled && $7b5d093607cf439b$var$motionUpliftStyles.flyoutOpen,
                sideNavState?.flyout === 'open' && !isMotionUpliftEnabled && $7b5d093607cf439b$var$styles.flyoutOpen,
                sideNavState?.flyout === 'triggered-animate-close' && isMotionUpliftEnabled && $7b5d093607cf439b$var$motionUpliftStyles.flyoutAnimateClosed,
                sideNavState?.flyout === 'triggered-animate-close' && !isMotionUpliftEnabled && $7b5d093607cf439b$var$styles.flyoutAnimateClosed
            ]),
            children: [
                isChatPanelLayoutEnabled && // CSS reserves only the nav minimum for chat's fit decision, before effects or lazy loading.
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
                /*#__PURE__*/ (0, $5chsV.jsx)("style", {
                    children: `
#${(0, $cNKD8.gridRootChatFitId)} { --n_fitNav: 0px; }
${shouldApplyUnmanagedSizing ? `#${0, $cNKD8.gridRootId} nav[data-layout-slot] { grid-area: main / aside / aside / aside; width: min(90%, ${clampedWidth}); }` : ''}
@media (min-width: 64rem) {
  @container navigation-main-space (min-width: ${minWidth}) {
    #${(0, $cNKD8.gridRootChatFitId)} { --n_fitNav: ${isExpandedOnDesktop ? minWidth : '0px'}; }
    ${shouldApplyUnmanagedSizing ? `#${0, $cNKD8.gridRootId} nav[data-layout-slot] { grid-area: side-nav; width: min(${clampedWidth}, calc(100cqw + var(--n_fitNav) - var(--n_chatTrack, 0px))); }` : ''}
  }
}
`
                }),
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $kqgCs.DangerouslyHoistCssVarToDocumentRoot), {
                    variableName: (0, $eVEPg.sideNavLiveWidthVar),
                    value: "0px",
                    mediaQuery: '@media (min-width: 64rem)',
                    responsiveValue: isExpandedOnDesktop ? `var(${$7b5d093607cf439b$var$panelSplitterResizingVar}, ${clampedWidth})` : 0
                }),
                dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
                // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
                // When they aren't needed anymore we can delete them wholesale.
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $kqgCs.DangerouslyHoistCssVarToDocumentRoot), {
                    variableName: (0, $eVEPg.UNSAFE_sideNavLayoutVar),
                    value: `var(${(0, $eVEPg.sideNavLiveWidthVar)})`
                }),
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $cRpV8.PanelSplitterProvider), {
                    panelId: (0, $eVEPg.sideNavPanelSplitterId),
                    panelRef: navRef,
                    panelWidth: renderedWidth,
                    onCompleteResize: onCompleteResize,
                    onResizeStartInternal: isChatPanelLayoutEnabled && isManaged ? onResizeStartInternal : undefined,
                    onResizeInternal: isChatPanelLayoutEnabled && isManaged ? onResizeInternal : undefined,
                    prepareResize: isChatPanelLayoutEnabled ? prepareResize : undefined,
                    getResizeBounds: getResizeBounds,
                    resizingCssVar: $7b5d093607cf439b$var$panelSplitterResizingVar,
                    // Not resizable when in peek (flyout) mode.
                    isEnabled: !isFlyoutVisible,
                    shortcut: isShortcutEnabled ? (0, $3ruGx.sideNavToggleTooltipKeyboardShortcut) : undefined,
                    children: /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                        className: (0, $gJ6nT.default)([
                            $7b5d093607cf439b$var$styles.flexContainer
                        ]),
                        children: children
                    })
                })
            ]
        })
    });
}
$7b5d093607cf439b$var$SideNavInternal.displayName = "SideNavInternal";
function $7b5d093607cf439b$export$1a35787d6353cf6a({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidth = 320, minWidth: minWidth, maxWidth: maxWidth, testId: testId, label: label, skipLinkLabel: // Default value is defined in `SideNavInternal`
skipLinkLabel = label, onExpand: // Default value is defined in `SideNavInternal`
onExpand, onCollapse: onCollapse, onPeekStart: onPeekStart, onPeekEnd: onPeekEnd, canToggleWithShortcut: canToggleWithShortcut, id: id }) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $BWeKH.OpenLayerObserverNamespaceProvider), {
        namespace: (0, $eVEPg.openLayerObserverSideNavNamespace),
        children: /*#__PURE__*/ (0, $5chsV.jsx)($7b5d093607cf439b$var$SideNavInternal, {
            defaultCollapsed: defaultCollapsed,
            defaultWidth: defaultWidth,
            minWidth: minWidth,
            maxWidth: maxWidth,
            testId: testId,
            label: label,
            skipLinkLabel: skipLinkLabel,
            onExpand: onExpand,
            onCollapse: onCollapse,
            onPeekStart: onPeekStart,
            onPeekEnd: onPeekEnd,
            id: id,
            canToggleWithShortcut: canToggleWithShortcut,
            children: children
        })
    });
}
$7b5d093607cf439b$export$1a35787d6353cf6a.displayName = "SideNav";

});
parcelRegister("BWeKH", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverNamespaceProvider", () => $3659ed05c9f3cd7c$export$327d0d2a7ae6f7cc);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $l9kus = parcelRequire("l9kus");

var $45zXM = parcelRequire("45zXM");

var $8JHGZ = parcelRequire("8JHGZ");
function $3659ed05c9f3cd7c$export$327d0d2a7ae6f7cc({ children: children, namespace: namespace }) {
    // If there is an existing namespace context being provided, throw an invariant.
    // This use case is not supported at this time.
    const parentContext = (0, $8JHGZ.useOpenLayerObserverNamespace)();
    (0, $fsvuC.useEffect)(()=>{
        (0, $l9kus.default)(parentContext === null, `An OpenLayerObserver namespace already exists in this component tree: ${parentContext}. Nesting OpenLayerObserverNamespaceProvider is not supported.`);
    }, [
        parentContext
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $45zXM.OpenLayerObserverNamespaceContext).Provider, {
        value: namespace,
        children: children
    });
}
$3659ed05c9f3cd7c$export$327d0d2a7ae6f7cc.displayName = "OpenLayerObserverNamespaceProvider";

});

parcelRegister("jDV7v", function(module, exports) {
$parcel$export(module.exports, "useOpenLayerObserver", () => $f472546e69974679$export$750f5b0d6c51617e);

var $fsvuC = parcelRequire("fsvuC");

var $3zaUu = parcelRequire("3zaUu");
function $f472546e69974679$export$750f5b0d6c51617e() {
    const context = (0, $fsvuC.useContext)((0, $3zaUu.OpenLayerObserverContext));
    const publicAPI = (0, $fsvuC.useMemo)(()=>{
        if (context === null) return null;
        return {
            getCount: context.getCount,
            onChange: context.onChange,
            closeLayers: context.closeLayers
        };
    }, [
        context
    ]);
    return publicAPI;
}

});

parcelRegister("ekfU9", function(module, exports) {
$parcel$export(module.exports, "useSkipLinkInternal", () => $ce390b749750af84$export$707b94c26b8b75aa);

var $fsvuC = parcelRequire("fsvuC");

var $gOqED = parcelRequire("gOqED");
const $ce390b749750af84$export$707b94c26b8b75aa = ({ id: id, label: label, listIndex: listIndex, onBeforeNavigate: onBeforeNavigate, navigate: navigate, isHidden: isHidden })=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = (0, $fsvuC.useContext)((0, $gOqED.SkipLinksContext));
    (0, $fsvuC.useEffect)(()=>{
        if (isHidden) /**
			 * Skip links are hidden for slots with 0 height or width.
			 * They should not be registered.
			 */ return;
        registerSkipLink({
            id: id,
            label: label,
            listIndex: listIndex,
            onBeforeNavigate: onBeforeNavigate,
            navigate: navigate,
            isHidden: isHidden
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        isHidden,
        label,
        listIndex,
        onBeforeNavigate,
        navigate,
        registerSkipLink,
        unregisterSkipLink
    ]);
};

});
parcelRegister("gOqED", function(module, exports) {
$parcel$export(module.exports, "SkipLinksContext", () => $946c78b5942500a6$export$4c5cc3b14c7678a);

var $fsvuC = parcelRequire("fsvuC");

var $9Tkwf = parcelRequire("9Tkwf");
const $946c78b5942500a6$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $fsvuC.createContext)({
    registerSkipLink: (0, $9Tkwf.default),
    unregisterSkipLink: (0, $9Tkwf.default)
});

});


parcelRegister("eMRN7", function(module, exports) {
$parcel$export(module.exports, "TopNavStartElement", () => $e5172eb2eb9a8b67$export$e9e5087bd319cc8c);

var $fsvuC = parcelRequire("fsvuC");
const $e5172eb2eb9a8b67$export$e9e5087bd319cc8c = /*#__PURE__*/ (0, $fsvuC.createContext)(null);

});

parcelRegister("eVEPg", function(module, exports) {
$parcel$export(module.exports, "sideNavVar", () => $57d63fd66b043080$export$951bf5156e86d974);
$parcel$export(module.exports, "asideVar", () => $57d63fd66b043080$export$594e6a30db7c057e);
$parcel$export(module.exports, "panelVar", () => $57d63fd66b043080$export$db0c2e1d744fb281);
$parcel$export(module.exports, "mainMinimumWidthVar", () => $57d63fd66b043080$export$c331a3472b90c7fa);
$parcel$export(module.exports, "bannerMountedVar", () => $57d63fd66b043080$export$515a0b1baafe906c);
$parcel$export(module.exports, "topNavMountedVar", () => $57d63fd66b043080$export$60ef3a7b1ed42328);
$parcel$export(module.exports, "sideNavLiveWidthVar", () => $57d63fd66b043080$export$1216dacffd1e9e65);
$parcel$export(module.exports, "sideNavPanelSplitterId", () => $57d63fd66b043080$export$5db28b16b6e686bc);
$parcel$export(module.exports, "asidePanelSplitterId", () => $57d63fd66b043080$export$de580d653bac8ad9);
$parcel$export(module.exports, "panelPanelSplitterId", () => $57d63fd66b043080$export$3452dcb65711af44);
$parcel$export(module.exports, "contentInsetBlockStart", () => $57d63fd66b043080$export$bfabd8c2c572ad29);
$parcel$export(module.exports, "UNSAFE_topNavVar", () => $57d63fd66b043080$export$855f5a09f5c99ac);
$parcel$export(module.exports, "UNSAFE_bannerVar", () => $57d63fd66b043080$export$26354f9814213292);
$parcel$export(module.exports, "UNSAFE_sideNavLayoutVar", () => $57d63fd66b043080$export$6bfc931a04ec5741);
$parcel$export(module.exports, "UNSAFE_asideLayoutVar", () => $57d63fd66b043080$export$bbbace2ff0c7ae1b);
$parcel$export(module.exports, "UNSAFE_panelLayoutVar", () => $57d63fd66b043080$export$753bf7651b25db91);
$parcel$export(module.exports, "UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY", () => $57d63fd66b043080$export$6460bd6a2446260);
$parcel$export(module.exports, "UNSAFE_MAIN_INLINE_START_FOR_LEGACY_PAGES_ONLY", () => $57d63fd66b043080$export$3055529fab2b4edf);
$parcel$export(module.exports, "UNSAFE_MAIN_INLINE_END_FOR_LEGACY_PAGES_ONLY", () => $57d63fd66b043080$export$166d8fd766c3eb92);
$parcel$export(module.exports, "openLayerObserverSideNavNamespace", () => $57d63fd66b043080$export$876effa8b02edc2f);
$parcel$export(module.exports, "openLayerObserverTopNavMiddleNamespace", () => $57d63fd66b043080$export$762ad20d97870b35);
$parcel$export(module.exports, "openLayerObserverTopNavEndNamespace", () => $57d63fd66b043080$export$8dd71e8a7db48024);
/**
 * These variables are shared across the different page layout slots.
 * This violates the [UI styling standard](https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-imported-style-values/usage).
 * We have chosen to ignore this rule to prevent duplicating them across the different slots, and to provide a high level view of them and how they relate.
 */ // These are "compressed" to discourage usage.
const $57d63fd66b043080$export$951bf5156e86d974 = '--n_sNvw';
const $57d63fd66b043080$export$594e6a30db7c057e = '--n_asDw';
const $57d63fd66b043080$export$db0c2e1d744fb281 = '--n_pnlW';
const $57d63fd66b043080$export$8b0055855c9c088f = '--n_cPnlW';
const $57d63fd66b043080$export$c80e4a9eb4c90d80 = '--n_cPnlLw';
const $57d63fd66b043080$export$c331a3472b90c7fa = '--n_mainMinW';
const $57d63fd66b043080$export$515a0b1baafe906c = '--n_bnrM';
const $57d63fd66b043080$export$60ef3a7b1ed42328 = '--n_tNvM';
const $57d63fd66b043080$export$a16bbd599f6269e7 = '--n_rbnW';
const $57d63fd66b043080$export$1216dacffd1e9e65 = '--n_sNvlw';
const $57d63fd66b043080$export$5db28b16b6e686bc = Symbol('SideNav PanelSplitter');
const $57d63fd66b043080$export$de580d653bac8ad9 = Symbol('Aside PanelSplitter');
const $57d63fd66b043080$export$3452dcb65711af44 = Symbol('Panel PanelSplitter');
const $57d63fd66b043080$export$2874e68531ce3163 = `calc(100vh - var(--n_bnrM, 0px) - var(--n_tNvM, 0px))`;
const $57d63fd66b043080$export$bfabd8c2c572ad29 = `calc(var(--n_bnrM, 0px) + var(--n_tNvM, 0px))`;
const $57d63fd66b043080$export$855f5a09f5c99ac = '--topNavigationHeight';
const $57d63fd66b043080$export$26354f9814213292 = '--bannerHeight';
const $57d63fd66b043080$export$6bfc931a04ec5741 = '--leftSidebarWidth';
const $57d63fd66b043080$export$58de0a46980ca7f4 = '--leftPanelWidth';
const $57d63fd66b043080$export$bbbace2ff0c7ae1b = '--rightSidebarWidth';
const $57d63fd66b043080$export$753bf7651b25db91 = '--rightPanelWidth';
const $57d63fd66b043080$export$6460bd6a2446260 = `calc(var(${$57d63fd66b043080$export$26354f9814213292}, 0px) + var(${$57d63fd66b043080$export$855f5a09f5c99ac}, 0px))`;
const $57d63fd66b043080$export$3055529fab2b4edf = `calc(var(${$57d63fd66b043080$export$58de0a46980ca7f4}, 0px) + var(${$57d63fd66b043080$export$6bfc931a04ec5741}, 0px))`;
const $57d63fd66b043080$export$166d8fd766c3eb92 = `calc(var(${$57d63fd66b043080$export$bbbace2ff0c7ae1b}, 0px) + var(${$57d63fd66b043080$export$753bf7651b25db91}, 0px))`;
const $57d63fd66b043080$export$61156ceb1a99f6a0 = {
    // Chat overlays the app, including TopNav and SideNav, below the banner.
    chatPanelOverlay: 5,
    ribbon: 4,
    topBar: 4,
    banner: 4,
    sideNav: 2,
    panelSmallViewports: 1
};
const $57d63fd66b043080$export$876effa8b02edc2f = 'side-nav';
const $57d63fd66b043080$export$762ad20d97870b35 = 'top-nav-middle';
const $57d63fd66b043080$export$8dd71e8a7db48024 = 'top-nav-end';

});

parcelRegister("kqgCs", function(module, exports) {
$parcel$export(module.exports, "DangerouslyHoistCssVarToDocumentRoot", () => $9e17359a9ab8218d$export$9f45a1325e3cdfb8);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");
const $9e17359a9ab8218d$var$getCssStringValue = (value)=>typeof value === 'number' ? `${value}px` : value;
const $9e17359a9ab8218d$export$9f45a1325e3cdfb8 = ({ variableName: variableName, value: value, mediaQuery: mediaQuery, responsiveValue: responsiveValue })=>{
    /**
	 * Note don't put multiple variables in multiple lines. eg
	 * <style>
	 *   {css1}
	 *   {css2}
	 * </style>
	 *
	 * React will insert an empty HTML comment in between the text in SSR.
	 * This is not a valid tag and will break the page.
	 * <style>foo<!-- -->bar</style>
	 */ let style = `:root { ${variableName}: ${$9e17359a9ab8218d$var$getCssStringValue(value)} }`;
    if (mediaQuery && responsiveValue) style += ` ${mediaQuery} { :root { ${variableName}: ${$9e17359a9ab8218d$var$getCssStringValue(responsiveValue)} } }`;
    return(// Using a global style is required for SSR, as we can't use React hooks
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
    /*#__PURE__*/ (0, $5chsV.jsx)("style", {
        children: style
    }));
};
$9e17359a9ab8218d$export$9f45a1325e3cdfb8.displayName = "DangerouslyHoistCssVarToDocumentRoot";

});

parcelRegister("c04Nx", function(module, exports) {
$parcel$export(module.exports, "DangerouslyHoistSlotSizes", () => $c4461e3991b53dc7$export$66e2c1a0115af861);

var $fsvuC = parcelRequire("fsvuC");
const $c4461e3991b53dc7$export$66e2c1a0115af861 = /*#__PURE__*/ (0, $fsvuC.createContext)(false);

});

parcelRegister("gli8N", function(module, exports) {
$parcel$export(module.exports, "convertResizeBoundToPixels", () => $9d3d5dbe595744b9$export$3d412b3011b66f82);
function $9d3d5dbe595744b9$export$3d412b3011b66f82(resizeBound) {
    if (resizeBound.endsWith('vw')) {
        // Max width was provided in `vw` units, so is relative to the viewport width.
        // e.g. 50vw = 50% of the viewport width.
        // `parseInt` will remove the `vw` suffix.
        const maxWidthFraction = parseInt(resizeBound) / 100;
        return Math.floor(window.innerWidth * maxWidthFraction);
    }
    // Max width was provided in `px` units, so we can parse it directly.
    // `parseInt` will remove the `px` suffix.
    return Math.floor(parseInt(resizeBound));
}

});

parcelRegister("cRpV8", function(module, exports) {
$parcel$export(module.exports, "PanelSplitterProvider", () => $8eb1e13b67fb4c86$export$f662bfb764348932);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $18BJt = parcelRequire("18BJt");
const $8eb1e13b67fb4c86$export$f662bfb764348932 = ({ panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, onResizeStartInternal: onResizeStartInternal, onResizeInternal: onResizeInternal, prepareResize: prepareResize, getResizeBounds: getResizeBounds, resizingCssVar: resizingCssVar, panelRef: panelRef, resizingElementRef: resizingElementRef, portalRef: providedPortalRef, position: position = 'end', isEnabled: isEnabled = true, shortcut: shortcut, children: children })=>{
    const portalRef = (0, $fsvuC.useRef)(null);
    const context = (0, $fsvuC.useMemo)(()=>({
            panelId: panelId,
            panelWidth: panelWidth,
            onCompleteResize: onCompleteResize,
            onResizeStartInternal: onResizeStartInternal,
            onResizeInternal: onResizeInternal,
            prepareResize: prepareResize,
            getResizeBounds: getResizeBounds,
            resizingCssVar: resizingCssVar,
            position: position,
            panelRef: panelRef,
            resizingElementRef: resizingElementRef,
            isEnabled: isEnabled,
            portalRef: typeof providedPortalRef !== 'undefined' ? providedPortalRef : portalRef,
            shortcut: shortcut
        }), [
        panelId,
        panelWidth,
        onCompleteResize,
        onResizeStartInternal,
        onResizeInternal,
        prepareResize,
        getResizeBounds,
        resizingCssVar,
        position,
        panelRef,
        resizingElementRef,
        isEnabled,
        providedPortalRef,
        shortcut
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $fsvuC.Fragment), {
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $18BJt.PanelSplitterContext).Provider, {
                value: context,
                children: children
            }),
            typeof providedPortalRef !== 'undefined' ? null : /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                ref: portalRef
            })
        ]
    });
};
$8eb1e13b67fb4c86$export$f662bfb764348932.displayName = "PanelSplitterProvider";

});
parcelRegister("18BJt", function(module, exports) {
$parcel$export(module.exports, "PanelSplitterContext", () => $3e7aacc7f68a248b$export$7a4054f2c546f2cd);

var $fsvuC = parcelRequire("fsvuC");
const $3e7aacc7f68a248b$export$7a4054f2c546f2cd = /*#__PURE__*/ (0, $fsvuC.createContext)(null);

});


parcelRegister("brcYx", function(module, exports) {
$parcel$export(module.exports, "resolveLayoutWidth", () => $a5071eebbafcd3c9$export$fca44cc45c9c7d43);
function $a5071eebbafcd3c9$export$fca44cc45c9c7d43(bound, viewportWidth) {
    if (typeof bound === 'number') return bound;
    const value = Number.parseFloat(bound);
    return bound.endsWith('vw') ? viewportWidth * value / 100 : value;
}

});

parcelRegister("cNKD8", function(module, exports) {
$parcel$export(module.exports, "gridRootId", () => $700536b761cea3fa$export$a6d827031bcb31d1);
$parcel$export(module.exports, "gridRootFitId", () => $700536b761cea3fa$export$27a44a3a56ddb00b);
$parcel$export(module.exports, "gridRootChatFitId", () => $700536b761cea3fa$export$5903b21beb1d1891);
$parcel$export(module.exports, "Root", () => $700536b761cea3fa$export$be92b6f5f03c0fe9);
/* root.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");

var $fsvuC = parcelRequire("fsvuC");

var $015dA = parcelRequire("015dA");

var $llCao = parcelRequire("llCao");

var $l2dXf = parcelRequire("l2dXf");

var $dgeBf = parcelRequire("dgeBf");

var $c04Nx = parcelRequire("c04Nx");

var $1RYkG = parcelRequire("1RYkG");

var $7kMmS = parcelRequire("7kMmS");

var $knOLS = parcelRequire("knOLS");

var $9wH8f = parcelRequire("9wH8f");

var $jdvjm = parcelRequire("jdvjm");
const $700536b761cea3fa$export$a6d827031bcb31d1 = 'unsafe-design-system-page-layout-root';
const $700536b761cea3fa$export$27a44a3a56ddb00b = `${$700536b761cea3fa$export$a6d827031bcb31d1}-fit`;
const $700536b761cea3fa$export$5903b21beb1d1891 = `${$700536b761cea3fa$export$a6d827031bcb31d1}-chat-fit`;
const $700536b761cea3fa$var$styles = {
    widthContainer: "_0u2WMmrU95 _3n40gWjQQ2 _39xV02N91d",
    mainSpace: "_0x0m3Pytah _3e862PzZoh _0u2WMmrU95 _3n40gWhnFZ _24h04iyL8i _39xV02Yi9r",
    chatSpace: "_00F2PoB6f5 _0u2WMmrU95 _3n40gWwgYM _39xV02riSj",
    legacyRoot: "_3iDTPbgBM8 _4kiQYAWP8C _3NN0tOsKlt _2iEGP28wUV _0ca6V72ulg _2xgI2Ymk5d _2yz9PXk6i4 _4cQPhCuAep _2dnLWx2dcB _1h2oUBk6i4 _1YDlQuSe0G",
    root: "_3e862PzZoh _3iDTPbgBM8 _4kiQYAWP8C _39xV024eQp _3NN0tOsKlt _2iEGP28wUV _0ca6V72ulg _2wGBBqwhpO _0sNGaGmt1K _2xgI2Y0gUc _2yz9PXk6i4 _4cQPhCXkqu _2dnLWxRpCc _1YDlQuBl9j",
    safetyRail: "_3cypjiOiJt",
    safetyRailWithTopLayer: "_4lA8aSOiJt",
    panelUplift: "_4bt5LAoWuR _2WAcuGoWuR"
};
function $700536b761cea3fa$var$LayoutFitContainers({ children: children }) {
    // CSS cannot use custom properties in a size-query condition. Query the
    // remaining capacity instead: these wrappers subtract configured minimums
    // and occupied tracks, while the actual grid keeps its original host width.
    return /*#__PURE__*/ (0, $5chsV.jsxs)("div", {
        "data-layout-width-container": "",
        className: (0, $gJ6nT.default)([
            $700536b761cea3fa$var$styles.widthContainer
        ]),
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)("style", {
                dangerouslySetInnerHTML: {
                    __html: `@property --n_layoutW { syntax: '<length>'; inherits: true; initial-value: 0px; }`
                }
            }),
            /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                id: $700536b761cea3fa$export$27a44a3a56ddb00b,
                className: (0, $gJ6nT.default)([
                    $700536b761cea3fa$var$styles.mainSpace
                ]),
                children: /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                    id: $700536b761cea3fa$export$5903b21beb1d1891,
                    className: (0, $gJ6nT.default)([
                        $700536b761cea3fa$var$styles.chatSpace
                    ]),
                    children: children
                })
            })
        ]
    });
}
$700536b761cea3fa$var$LayoutFitContainers.displayName = "LayoutFitContainers";
function $700536b761cea3fa$export$be92b6f5f03c0fe9({ children: children, xcss: xcss, UNSAFE_dangerouslyHoistSlotSizes: UNSAFE_dangerouslyHoistSlotSizes = false, skipLinksLabel: skipLinksLabel = (0, $llCao.fg)('platform_dst_nav4_skip_link_a11y_1') ? 'Skip to' : 'Skip to:', skipLinksTriggerLabel: skipLinksTriggerLabel = 'Skip to', testId: testId, defaultSideNavCollapsed: defaultSideNavCollapsed, isSideNavShortcutEnabled: isSideNavShortcutEnabled = false }) {
    const ref = (0, $fsvuC.useRef)(null);
    const isChatPanelLayoutEnabled = (0, $llCao.fg)('platform-dst-chat-panel-layout');
    const LayoutProvider = isChatPanelLayoutEnabled ? (0, $1RYkG.LayoutAreaSizingProvider) : (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Fragment;
    const WidthContainer = isChatPanelLayoutEnabled ? $700536b761cea3fa$var$LayoutFitContainers : (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Fragment;
    (0, $fsvuC.useEffect)(()=>{}, []);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $jdvjm.SideNavVisibilityProvider), {
        defaultCollapsed: defaultSideNavCollapsed,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $9wH8f.SideNavToggleButtonProvider), {
            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $knOLS.SideNavElementProvider), {
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $7kMmS.IsSideNavShortcutEnabledProvider), {
                    isSideNavShortcutEnabled: isSideNavShortcutEnabled,
                    children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $dgeBf.TopNavStartProvider), {
                        children: /*#__PURE__*/ (0, $5chsV.jsx)(LayoutProvider, {
                            ...isChatPanelLayoutEnabled ? {
                                layoutRef: ref
                            } : {},
                            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $015dA.OpenLayerObserver), {
                                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $c04Nx.DangerouslyHoistSlotSizes).Provider, {
                                    value: UNSAFE_dangerouslyHoistSlotSizes,
                                    children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $l2dXf.SkipLinksProvider), {
                                        label: skipLinksLabel,
                                        triggerLabel: skipLinksTriggerLabel,
                                        testId: testId,
                                        children: /*#__PURE__*/ (0, $5chsV.jsx)(WidthContainer, {
                                            children: /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                                                ref: ref,
                                                className: (0, $gJ6nT.default)([
                                                    isChatPanelLayoutEnabled ? $700536b761cea3fa$var$styles.root : $700536b761cea3fa$var$styles.legacyRoot,
                                                    (0, $llCao.fg)('platform-dst-motion-uplift-panel') && $700536b761cea3fa$var$styles.panelUplift,
                                                    (0, $llCao.fg)('platform-dst-top-layer') ? $700536b761cea3fa$var$styles.safetyRailWithTopLayer : $700536b761cea3fa$var$styles.safetyRail,
                                                    xcss
                                                ]),
                                                id: $700536b761cea3fa$export$a6d827031bcb31d1,
                                                "data-testid": testId,
                                                children: children
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
}
$700536b761cea3fa$export$be92b6f5f03c0fe9.displayName = "Root";

});
parcelRegister("015dA", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserver", () => $f0c4b36ad4e8b46b$export$97afddda23bcd287);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $l9kus = parcelRequire("l9kus");

var $3zaUu = parcelRequire("3zaUu");
/**
 * Layers that are registered without a namespace are grouped under this fallback namespace.
 */ const $f0c4b36ad4e8b46b$var$noNamespaceSymbol = Symbol('no-namespace');
/**
 * Returns the number of open layers across all namespaces.
 * It calculates the sum of the set sizes in the map, which corresponds to the number of open layers.
 */ function $f0c4b36ad4e8b46b$var$getTotalOpenLayerCount(registry) {
    return Array.from(registry.values()).reduce((acc, listeners)=>acc + listeners.size, 0);
}
/**
 * Returns the number of layers in the set that match the type filter.
 */ function $f0c4b36ad4e8b46b$var$getLayerCountWithFilter({ layers: layers, type: type }) {
    return Array.from(layers.values()).filter((layer)=>layer.type === type).length;
}
/**
 * Returns the layer count change listeners set for the namespace.
 * If there are no listeners registered for the namespace yet, it creates a new set
 * and adds it to the registry, then returns the new set.
 */ function $f0c4b36ad4e8b46b$var$getListeners({ registry: registry, namespace: namespace }) {
    // 1. If there are existing listeners for this namespace, return the existing set.
    const existingListeners = registry.get(namespace);
    if (existingListeners) return existingListeners;
    // 2. If there are no existing listeners for this namespace, create a new set for this namespace
    // and add it to the registry, then return the new set.
    const newSet = new Set();
    registry.set(namespace, newSet);
    return newSet;
}
/**
 * Returns an instance of the open layer observer API. It internally keeps track of the number of open layers and
 * exposes methods to get the current count, increment/decrement the count, and subscribe to changes.
 */ function $f0c4b36ad4e8b46b$var$createInternalAPI() {
    /**
	 * The layer count change listeners for each namespace.
	 */ const namespaceToChangeListenerRegistry = new Map();
    /**
	 * The registered layers for each namespace.
	 * Each layer registers with an `onClose` callback, and optionally with a layer type (`type`).
	 * **When the layer is open**, its `onClose`
	 * callback is registered in this set along with its type.
	 *
	 * This data structure is also used determine the number of open layers.
	 */ const namespaceToLayerRegistry = new Map();
    /**
	 * Calls the appropriate layer count change listeners after the number of open layers has changed.
	 */ function callChangeListeners({ namespace: namespace, newCount: newCount }) {
        // 1. Call listeners registered to the specific namespace
        if (namespace) {
            const listenersForNamespace = namespaceToChangeListenerRegistry.get(namespace);
            // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
            // iterating over it.
            Array.from(listenersForNamespace ?? []).forEach((listener)=>listener({
                    count: newCount
                }));
        }
        // 2. Call listeners registered without a specific namespace
        const noNamespaceListeners = namespaceToChangeListenerRegistry.get($f0c4b36ad4e8b46b$var$noNamespaceSymbol);
        // Return early if no listeners
        if (!noNamespaceListeners) return;
        // For the listeners without a specific namespace, we need to provide the sum of all namespace counts
        // as the callback `count` arg.
        const totalCount = $f0c4b36ad4e8b46b$var$getTotalOpenLayerCount(namespaceToLayerRegistry);
        Array.from(noNamespaceListeners).forEach((listener)=>listener({
                count: totalCount
            }));
    }
    /**
	 * Returns the current count of open layers.
	 *
	 * - If a namespace is provided, the count for that namespace is returned.
	 * - If a type is provided, only layers of that type are counted.
	 * - If both are provided, only layers matching both criteria are counted.
	 * - Otherwise, the sum of all namespace counts is returned.
	 */ function getCount({ namespace: namespace, type: type } = {}) {
        if (namespace) {
            // 1. A namespace was requested, so we count only layers in that namespace
            const layersForNamespace = namespaceToLayerRegistry.get(namespace);
            if (!layersForNamespace) return 0;
            if (type) // Count layers in the namespace that match the type filter
            return $f0c4b36ad4e8b46b$var$getLayerCountWithFilter({
                layers: layersForNamespace,
                type: type
            });
            // No type filter - just return the size of the set
            return layersForNamespace.size;
        }
        // 2. A specific namespace was not requested, so we count across all namespaces
        if (type) // Count layers in each namespace that match the type filter
        return Array.from(namespaceToLayerRegistry.values()).reduce((acc, layers)=>acc + $f0c4b36ad4e8b46b$var$getLayerCountWithFilter({
                layers: layers,
                type: type
            }), 0);
        // No type filter - count all layers across all namespaces
        return $f0c4b36ad4e8b46b$var$getTotalOpenLayerCount(namespaceToLayerRegistry);
    }
    /**
	 * Adds a listener that will be called when the number of open layers changes.
	 *
	 * @returns a cleanup function to unsubscribe, which should be called when the component unmounts.
	 */ function onChange(listener, { namespace: providedNamespace } = {}) {
        /**
		 * We are wrapping the passed listener in a function to ensure that each call to `onChange` creates a unique
		 * function reference. This is to handle scenarios where the same function is provided to several different `onChange`
		 * calls - we want to ensure that each call to `unsubscribe` only removes the specific listener registration that was added.
		 */ function wrapped(...args) {
            listener(...args);
        }
        const namespace = providedNamespace ?? $f0c4b36ad4e8b46b$var$noNamespaceSymbol;
        const listenersForNamespace = $f0c4b36ad4e8b46b$var$getListeners({
            namespace: namespace,
            registry: namespaceToChangeListenerRegistry
        });
        listenersForNamespace.add(wrapped);
        return function unsubscribe() {
            listenersForNamespace.delete(wrapped);
            // If there are no listeners for this namespace, remove the registry entry.
            if (listenersForNamespace.size === 0) namespaceToChangeListenerRegistry.delete(namespace);
        };
    }
    /**
	 * Adds a listener to the registry that tells the observer how to close the layer component.
	 * The listener should only be added if the layer is open. This is handled by `useNotifyOpenLayerObserver`.
	 *
	 * All close listeners will be called by the observer when `closeLayers` is called.
	 *
	 * @returns a cleanup function to unsubscribe, which should be called when the component unmounts.
	 */ function onClose(listener, { namespace: providedNamespace, type: type }) {
        const wrapped = {
            listener: listener,
            type: type
        };
        const namespace = providedNamespace ?? $f0c4b36ad4e8b46b$var$noNamespaceSymbol;
        const listenersForNamespace = $f0c4b36ad4e8b46b$var$getListeners({
            namespace: namespace,
            registry: namespaceToLayerRegistry
        });
        listenersForNamespace.add(wrapped);
        callChangeListeners({
            namespace: providedNamespace,
            newCount: listenersForNamespace.size
        });
        return function unsubscribe() {
            listenersForNamespace.delete(wrapped);
            callChangeListeners({
                namespace: providedNamespace,
                newCount: listenersForNamespace.size
            });
            // If there are no listeners for this namespace, remove the registry entry.
            if (listenersForNamespace.size === 0) namespaceToLayerRegistry.delete(namespace);
        };
    }
    /**
	 * Closes all open layers registered across all namespaces.
	 */ function closeLayers() {
        // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
        // iterating over it.
        Array.from(namespaceToLayerRegistry.values()).forEach((listeners)=>{
            Array.from(listeners).forEach(({ listener: listener })=>listener());
        });
    }
    const internalAPI = {
        getCount: getCount,
        onChange: onChange,
        onClose: onClose,
        closeLayers: closeLayers
    };
    return internalAPI;
}
function $f0c4b36ad4e8b46b$export$97afddda23bcd287({ children: children }) {
    // Using state to ensure a stable reference to a single instance.
    const [internalAPI] = (0, $fsvuC.useState)(()=>$f0c4b36ad4e8b46b$var$createInternalAPI());
    const parentContext = (0, $fsvuC.useContext)((0, $3zaUu.OpenLayerObserverContext));
    // We don't expect a parent context. If there is one, that means this component is nested within another `OpenLayerObserver`
    // - which we don't support.
    (0, $l9kus.default)(parentContext === null, '`OpenLayerObserver` cannot be nested within another `OpenLayerObserver`.');
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $3zaUu.OpenLayerObserverContext).Provider, {
        value: internalAPI,
        children: children
    });
}
$f0c4b36ad4e8b46b$export$97afddda23bcd287.displayName = "OpenLayerObserver";

});

parcelRegister("l2dXf", function(module, exports) {
$parcel$export(module.exports, "SkipLinksProvider", () => $7e9ab7c4cfd5c7a3$export$fe514f9f7b03d46f);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $20eii = parcelRequire("20eii");

var $gOqED = parcelRequire("gOqED");
const $7e9ab7c4cfd5c7a3$var$getByDomOrderSortFunction = ()=>{
    const layoutSlots = Array.from(document.querySelectorAll(`[data-layout-slot]`));
    return (a, b)=>{
        const indexA = a.listIndex ?? layoutSlots.indexOf(document.getElementById(a.id));
        const indexB = b.listIndex ?? layoutSlots.indexOf(document.getElementById(b.id));
        /**
		 * If they are tied it is because one (or both) is
		 * a custom skiplink with a set index.
		 *
		 * Give the custom skiplink priority.
		 */ if (indexA === indexB) {
            if (a.listIndex !== undefined) return -1;
            else return 1;
        }
        return indexA - indexB;
    };
};
function $7e9ab7c4cfd5c7a3$export$fe514f9f7b03d46f({ children: children, label: label, triggerLabel: triggerLabel, testId: testId }) {
    const [links, setLinks] = (0, $fsvuC.useState)([]);
    const registerSkipLink = (0, $fsvuC.useCallback)((skipLinkData)=>{
        // Don't add duplicate skip links
        setLinks((oldLinks)=>{
            if (oldLinks.some(({ id: id })=>id === skipLinkData.id)) return oldLinks;
            return [
                ...oldLinks,
                skipLinkData
            ].sort($7e9ab7c4cfd5c7a3$var$getByDomOrderSortFunction());
        });
    }, []);
    const unregisterSkipLink = (0, $fsvuC.useCallback)((id)=>{
        setLinks((links)=>links.filter((link)=>link.id !== id));
    }, []);
    const contextValue = (0, $fsvuC.useMemo)(()=>{
        const data = {
            registerSkipLink: registerSkipLink,
            unregisterSkipLink: unregisterSkipLink
        };
        return data;
    }, [
        registerSkipLink,
        unregisterSkipLink
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $gOqED.SkipLinksContext).Provider, {
        value: contextValue,
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $20eii.SkipLinksContainer), {
                label: label,
                triggerLabel: triggerLabel,
                testId: testId,
                links: links
            }),
            children
        ]
    });
}
$7e9ab7c4cfd5c7a3$export$fe514f9f7b03d46f.displayName = "SkipLinksProvider";

});
parcelRegister("20eii", function(module, exports) {
$parcel$export(module.exports, "SkipLinksContainer", () => $d6ec7c0157d53826$export$fce25a0c32fbc1e1);
/* skip-links-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $llCao = parcelRequire("llCao");

var $daZXj = parcelRequire("daZXj");

var $2LEzx = parcelRequire("2LEzx");

var $kncJ8 = parcelRequire("kncJ8");
const $d6ec7c0157d53826$var$styles = {
    root: "_2mHwu81Y8M _0bjKvDKxmn _4c065U8HPE _2Y7lL48HPE _3iDTPbQ4SZ _0aFT5vbt8w _1mT5xdy1CL _3iC0zdkG2W _2I62gzkG2W _0KLXruoI2d _2OUyjtGk8v _42Yu6BvQQr _1YKVNsdnbC _1pp6NdYbGa _3gBTfLGYeU _3Tg68S7dHp _2VJVb2IZbP",
    skipLinkList: "_2mHwu81Y8M _3iDTPbQ4SZ _0aFT5vbt8w _4zmD5lTNeH _0aNu0LYbGa _43nrzTPgdg _0LQT5EPgdg"
};
/**
 * Keydown handler to hide the skip links when escape is pressed.
 *
 * TODO: consider removing this, it doesn't make a lot of sense.
 * The skip links look like a popup but in reality they aren't.
 * Even though we hide them when the user presses Escape, when
 * they press TAB it will reopen the list and move to the next one...
 *
 * One potential option is to use a tree walker to focus on the
 * next focusable element in the DOM (outside the skip links
 * container).
 */ const $d6ec7c0157d53826$var$closeOnEscape = (event)=>{
    if (event.key !== 'Escape') return;
    const activeElement = document.activeElement;
    if (activeElement instanceof HTMLElement) activeElement.blur();
};
const $d6ec7c0157d53826$var$assignIndex = (num, arr)=>{
    if (!arr.includes(num)) return num;
    return $d6ec7c0157d53826$var$assignIndex(num + 1, arr);
};
/**
 * Sorts an array of skip links by list indexes.
 *
 * Skip links with custom list indexes are positioned first, followed by regular skip links,
 * which are automatically assigned available index positions to avoid conflicts.
 */ function $d6ec7c0157d53826$var$sortSkipLinks(arr) {
    const customLinks = arr.filter((link)=>Number.isInteger(link.listIndex));
    if (customLinks.length === 0) return arr;
    const usedIndexes = customLinks.map((a)=>a.listIndex);
    const regularLinksWithIndex = arr.filter((link)=>link.listIndex === undefined).map((link, index)=>{
        const listIndex = $d6ec7c0157d53826$var$assignIndex(index, usedIndexes);
        usedIndexes.push(listIndex);
        return {
            ...link,
            listIndex: listIndex
        };
    });
    return [
        ...customLinks,
        ...regularLinksWithIndex
    ].sort((a, b)=>a.listIndex - b.listIndex);
}
const $d6ec7c0157d53826$var$isOnlyWhitespaceRegex = /^\s*$/;
function $d6ec7c0157d53826$export$fce25a0c32fbc1e1({ label: label, triggerLabel: triggerLabel, testId: testId, links: links }) {
    const sortedLinks = (0, $fsvuC.useMemo)(()=>{
        return $d6ec7c0157d53826$var$sortSkipLinks(links);
    }, [
        links
    ]);
    if (sortedLinks.length === 0) return null;
    const isEmptyLabel = $d6ec7c0157d53826$var$isOnlyWhitespaceRegex.test(label);
    if ((0, $llCao.fg)('platform_dst_nav4_skip_link_a11y_1')) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $kncJ8.SkipLinksPopup), {
        label: label,
        triggerLabel: triggerLabel,
        testId: testId,
        links: sortedLinks
    });
    return /*#__PURE__*/ (0, $5chsV.jsxs)("div", {
        onKeyDown: $d6ec7c0157d53826$var$closeOnEscape,
        "data-testid": testId ? `${testId}--skip-links-container` : undefined,
        className: (0, $gJ6nT.default)([
            $d6ec7c0157d53826$var$styles.root
        ]),
        children: [
            !isEmptyLabel && /*#__PURE__*/ (0, $5chsV.jsx)((0, $daZXj.Text), {
                weight: "bold",
                testId: testId ? `${testId}--skip-links-container--label` : undefined,
                children: label
            }),
            /*#__PURE__*/ (0, $5chsV.jsx)("ol", {
                className: (0, $gJ6nT.default)([
                    $d6ec7c0157d53826$var$styles.skipLinkList
                ]),
                children: sortedLinks.map(({ id: id, label: label, onBeforeNavigate: onBeforeNavigate })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $2LEzx.SkipLink), {
                        id: id,
                        onBeforeNavigate: onBeforeNavigate,
                        children: label
                    }, id))
            })
        ]
    });
}
$d6ec7c0157d53826$export$fce25a0c32fbc1e1.displayName = "SkipLinksContainer";

});
parcelRegister("2LEzx", function(module, exports) {
$parcel$export(module.exports, "SkipLink", () => $e4a78c86a91a6915$export$ef95c37428582a65);
/* skip-link.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");

var $fsvuC = parcelRequire("fsvuC");

var $llCao = parcelRequire("llCao");

var $cGW6W = parcelRequire("cGW6W");

var $ahDs5 = parcelRequire("ahDs5");
const $e4a78c86a91a6915$var$styles = {
    skipLinkListItem: "_43nrzTPgdg",
    skipLinkListItemNew: "_4c065U2ADO"
};
const $e4a78c86a91a6915$export$ef95c37428582a65 = ({ id: id, children: children, onBeforeNavigate: onBeforeNavigate, navigate: navigate })=>{
    const href = `#${id}`;
    const handleClick = (0, $fsvuC.useCallback)((event)=>{
        event.preventDefault();
        if (navigate && (0, $llCao.fg)('platform_dst_nav4_skip_link_a11y_1')) /**
       * The consumer takes over the navigation effect (e.g. expanding the
       * side nav and focusing the first nav item). The universal pre/post
       * work below (e.g. `window.scrollTo`) still runs around it.
       */ navigate();
        else {
            // Intentionally not using `document.querySelector` because many valid IDs are not valid selectors.
            const target = document.getElementById(id);
            if (!target) return;
            /**
       * Legacy `onBeforeNavigate` hook. Intentionally NOT called when
       * `platform_dst_nav4_skip_link_a11y_1` is enabled — under the gate the
       * gate-on path delegates state mutation + focus management to `navigate`,
       * and `SkipLinksPopup` injects its popup-close behavior into the
       * `navigate` wrapper instead of relying on this hook.
       *
       * This callback can be removed entirely on gate cleanup.
       */ if (!(0, $llCao.fg)('platform_dst_nav4_skip_link_a11y_1')) onBeforeNavigate?.();
            (0, $ahDs5.focusElement)(target);
        }
        /**
     * We should look into removing this, or only calling it in specific cases.
     *
     * It means if the skip link element is in the window scroll container
     * then it might not get scrolled into view properly.
     *
     * This is not an issue for the default slots on desktop, but could break custom skip links or
     * even `Aside` on mobile.
     *
     * Keeping existing behavior for now because resetting the window scroll is actually good for some cases.
     * E.g. jumping to main / aside it makes sense to look at the start of the content.
     */ window.scrollTo(0, 0);
    }, [
        id,
        onBeforeNavigate,
        navigate
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)("li", {
        className: (0, $gJ6nT.default)([
            $e4a78c86a91a6915$var$styles.skipLinkListItem,
            (0, $llCao.fg)('platform_dst_nav4_skip_link_a11y_1') && $e4a78c86a91a6915$var$styles.skipLinkListItemNew
        ]),
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $cGW6W.Anchor), {
            /**
     * It looks like Safari handles link clicks during `pointerdown` unless it has an explicit `tabIndex={0}` :/
     *
     * Adding this explicitly makes the behavior consistent between browsers and lets us `event.preventDefault()`
     * in the `onClick` handler.
     */ tabIndex: 0,
            href: href,
            onClick: handleClick,
            children: children
        })
    });
};
$e4a78c86a91a6915$export$ef95c37428582a65.displayName = "SkipLink";

});
parcelRegister("ahDs5", function(module, exports) {
$parcel$export(module.exports, "focusElement", () => $ae991f867d0bfed7$export$5fed9cc43865dc7e);

var $dqdTY = parcelRequire("dqdTY");
function $ae991f867d0bfed7$export$5fed9cc43865dc7e(element) {
    /**
	 * Elements without an explicit `tabindex` attribute are not guaranteed to be focusable:
	 * https://html.spec.whatwg.org/multipage/interaction.html#attr-tabindex
	 *
	 * Our slots are not interactive, so this is required.
	 *
	 * In the future we may want to check if there is an existing `tabindex` attribute,
	 * as custom skip linked elements might already have one.
	 */ element.setAttribute('tabindex', '-1');
    /**
	 * Cleanup the `tabindex` attribute we set when the slot or custom target loses focus.
	 *
	 * This is preferable to always having `tabindex="-1"` because always applying the tab index can:
	 *
	 * - mess with click events
	 * - potentially cause a focus ring to be always visible
	 */ (0, $dqdTY.bind)(element, {
        type: 'blur',
        listener () {
            element.removeAttribute('tabindex');
        },
        options: {
            // Using a one-time listener so it cleans itself up
            once: true
        }
    });
    /**
	 * Move focus to the slot or custom target.
	 *
	 * Calling `.focus()` will also scroll the element into view:
	 * https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus
	 */ element.focus({
        // Forces the focus ring to appear after moving focus to the slot
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus#focusvisible
        focusVisible: true
    });
}

});


parcelRegister("kncJ8", function(module, exports) {
$parcel$export(module.exports, "SkipLinksPopup", () => $fc2cac3e1658055b$export$759eb47efaee9eec);
/* skip-links-popup.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $80czl = parcelRequire("80czl");

var $BP2AV = parcelRequire("BP2AV");

var $fz4Xf = parcelRequire("fz4Xf");

var $RG5NG = parcelRequire("RG5NG");

var $ahDs5 = parcelRequire("ahDs5");

var $2LEzx = parcelRequire("2LEzx");
const $fc2cac3e1658055b$var$contentStyles = {
    root: "_4c065U2ADO _2Y7lL45zaO _3iDTPbQ4SZ _0aFT5vbt8w _42Yu6BGYeU",
    skipLinkList: "_3iDTPbQ4SZ _0aFT5vbt8w _4zmD5lTNeH _0aNu0LYbGa _43nrzTPgdg _0LQT5EPgdg",
    label: "_2sNsIgd8bj _4c065U2ADO _1UtDYzZpcK"
};
const $fc2cac3e1658055b$var$triggerStyles = {
    root: "_0bjKvDKxmn _3hxITiYbGa _1mT5xdy1CL _3iC0zd8HPE _2I62gz8HPE _42Yu6BvQQr _1YKVNsdnbC _0KLXruoI2d _0j9PH9GYeU _0O4CrC7dHp",
    isOpen: "_1YKVNsdnbC _1VJPca0OLL"
};
const $fc2cac3e1658055b$var$popupOffset = [
    0,
    0
];
function $fc2cac3e1658055b$export$759eb47efaee9eec({ label: title, triggerLabel: triggerLabel, testId: testId, links: links }) {
    const titleId = (0, $fsvuC.useId)();
    const [isOpen, setIsOpen] = (0, $fsvuC.useState)(false);
    const triggerRef = (0, $fsvuC.useRef)(null);
    const openPopup = (0, $fsvuC.useCallback)(()=>{
        setIsOpen(true);
    }, []);
    /**
   * Closes the popup.
   *
   * Uses `flushSync` to avoid issues with focus management.
   * This ensures the popup's focus lock is fully released by the time skip links or our `onClose` try to move focus.
   */ const closePopup = (0, $fsvuC.useCallback)(()=>{
        (0, $80czl.flushSync)(()=>{
            setIsOpen(false);
        });
    }, []);
    /**
   * Restores focus to the trigger on close, if it hasn't moved to another element, such as when Esc is pressed instead of a skip link.
   *
   * We need this because using the standard `shouldReturnFocus` on the popup would break the skip link focus behaviour,
   * as focus would always move back to the trigger.
   */ const onClose = (0, $fsvuC.useCallback)(()=>{
        closePopup();
        // Focus on the body implies a skip link was not clicked
        if (document.activeElement === document.body) triggerRef.current?.focus();
    }, [
        closePopup
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $RG5NG.Popup), {
        isOpen: isOpen,
        onClose: onClose,
        placement: "bottom-start",
        shouldRenderToParent: true,
        shouldReturnFocus: false,
        role: "dialog",
        titleId: titleId,
        testId: testId ? `${testId}--skip-links-container` : undefined,
        offset: $fc2cac3e1658055b$var$popupOffset,
        content: ()=>/*#__PURE__*/ (0, $5chsV.jsxs)("div", {
                className: (0, $gJ6nT.default)([
                    $fc2cac3e1658055b$var$contentStyles.root
                ]),
                children: [
                    /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                        "data-testid": testId ? `${testId}--skip-links-container--label` : undefined,
                        id: titleId,
                        className: (0, $gJ6nT.default)([
                            $fc2cac3e1658055b$var$contentStyles.label
                        ]),
                        children: title
                    }),
                    /*#__PURE__*/ (0, $5chsV.jsx)("ol", {
                        className: (0, $gJ6nT.default)([
                            $fc2cac3e1658055b$var$contentStyles.skipLinkList
                        ]),
                        children: links.map(({ id: id, label: label, navigate: navigate })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $2LEzx.SkipLink), {
                                id: id,
                                /**
       * The popup always owns the navigation effect under the
       * `platform_dst_nav4_skip_link_a11y_1` gate (the only path
       * that renders `SkipLinksPopup`). It first closes itself
       * synchronously so its focus lock is released, then either:
       *
       *  - delegates to the consumer's `navigate` (e.g. SideNav
       *    expanding and focusing its first nav item), or
       *  - falls back to focusing the slot element with `id`.
       *
       * This means `SkipLink`'s `onBeforeNavigate` hook is never
       * needed under the gate and can be removed on cleanup.
       */ navigate: ()=>{
                                    closePopup();
                                    if (navigate) {
                                        navigate();
                                        return;
                                    }
                                    // Intentionally not using `document.querySelector` because many valid IDs are not valid selectors.
                                    const target = document.getElementById(id);
                                    if (target) (0, $ahDs5.focusElement)(target);
                                },
                                children: label
                            }, id))
                    })
                ]
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $5chsV.jsx)("div", {
                className: (0, $gJ6nT.default)([
                    $fc2cac3e1658055b$var$triggerStyles.root,
                    isOpen && $fc2cac3e1658055b$var$triggerStyles.isOpen
                ]),
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $BP2AV.default), {
                    ...triggerProps,
                    ref: (0, $fz4Xf.default)([
                        triggerProps.ref,
                        triggerRef
                    ]),
                    appearance: "primary",
                    isSelected: isOpen,
                    testId: testId ? `${testId}--skip-links-trigger` : undefined,
                    onClick: openPopup,
                    children: triggerLabel
                })
            })
    });
}
$fc2cac3e1658055b$export$759eb47efaee9eec.displayName = "SkipLinksPopup";

});



parcelRegister("dgeBf", function(module, exports) {
$parcel$export(module.exports, "TopNavStartProvider", () => $8c9cfb4b5a58f2ed$export$bc9d0ad0bce43e75);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $h3UNS = parcelRequire("h3UNS");

var $eMRN7 = parcelRequire("eMRN7");
const $8c9cfb4b5a58f2ed$export$bc9d0ad0bce43e75 = ({ children: children })=>{
    const [element, setElement] = (0, $fsvuC.useState)(null);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $eMRN7.TopNavStartElement).Provider, {
        value: element,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $h3UNS.TopNavStartAttachRef).Provider, {
            value: setElement,
            children: children
        })
    });
};
$8c9cfb4b5a58f2ed$export$bc9d0ad0bce43e75.displayName = "TopNavStartProvider";

});
parcelRegister("h3UNS", function(module, exports) {
$parcel$export(module.exports, "TopNavStartAttachRef", () => $6d6b97b1b859fce4$export$55f0a642b785fb1f);

var $fsvuC = parcelRequire("fsvuC");

var $9Tkwf = parcelRequire("9Tkwf");
const $6d6b97b1b859fce4$export$55f0a642b785fb1f = /*#__PURE__*/ (0, $fsvuC.createContext)((0, $9Tkwf.default));

});


parcelRegister("1RYkG", function(module, exports) {
$parcel$export(module.exports, "LayoutAreaSizingProvider", () => $a4784a5c8a75a368$export$c026181e8eaf0b9f);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $goVBy = parcelRequire("goVBy");

var $9PicV = parcelRequire("9PicV");

var $krf8H = parcelRequire("krf8H");

function $a4784a5c8a75a368$export$c026181e8eaf0b9f({ children: children, layoutRef: layoutRef }) {
    const [Runtime, setRuntime] = (0, $fsvuC.useState)(null);
    const [states, setStates] = (0, $fsvuC.useState)({});
    const actions = (0, $fsvuC.useRef)(null);
    const configs = (0, $fsvuC.useRef)({});
    const [lastOpenedOverlay, setLastOpenedOverlay] = (0, $fsvuC.useState)(null);
    const [configRevision, setConfigRevision] = (0, $fsvuC.useState)(0);
    const cssModes = (0, $krf8H.useCssLayoutAreaStates)(layoutRef, configRevision, Runtime === null);
    const sideNavMode = states['side-nav']?.mode ?? cssModes['side-nav'];
    const chatPanelMode = states['chat-panel']?.mode ?? cssModes['chat-panel'];
    // Overlay dismissal is available before the sizing chunk loads. Keep the open
    // order here too: replaying registrations into the runtime loses that order.
    (0, $fsvuC.useEffect)(()=>{
        const inlineChatQuery = window.matchMedia('(min-width: 40rem)');
        const dismissOlderOverlay = ()=>{
            const sideNav = configs.current['side-nav'];
            const chatPanel = configs.current['chat-panel'];
            if (!sideNav?.isOpen || !chatPanel?.isOpen || !lastOpenedOverlay) return;
            // Before allocation, CSS puts both areas in overlay below 40rem. Once
            // sizing is active, also honour overlays caused by custom widths/slots.
            if (inlineChatQuery.matches && (sideNavMode !== 'overlay' || chatPanelMode !== 'overlay')) return;
            const olderOverlay = lastOpenedOverlay === 'side-nav' ? chatPanel : sideNav;
            olderOverlay.onRequestClose?.();
        };
        dismissOlderOverlay();
        return (0, $dqdTY.bind)(inlineChatQuery, {
            type: 'change',
            listener: dismissOlderOverlay
        });
    }, [
        chatPanelMode,
        lastOpenedOverlay,
        sideNavMode
    ]);
    const mainMinWidth = (0, $fsvuC.useRef)(320);
    const loadRef = (0, $fsvuC.useRef)(()=>{});
    const ready = (0, $fsvuC.useRef)(false);
    const waiting = (0, $fsvuC.useRef)([]);
    const pending = (0, $fsvuC.useRef)([]);
    const prepareResize = (0, $fsvuC.useCallback)(()=>{
        if (ready.current) return Promise.resolve(true);
        return new Promise((resolve)=>{
            waiting.current.push(resolve);
            loadRef.current();
        });
    }, []);
    (0, $fsvuC.useEffect)(()=>{
        const root = layoutRef?.current;
        if (!root) return;
        let cancelled = false;
        let loading = false;
        const waitingForRuntime = waiting.current;
        const load = ()=>{
            if (loading) return;
            loading = true;
            (parcelRequire("aGpe2")).then(({ LayoutAreaSizingRuntime: LayoutAreaSizingRuntime })=>{
                if (!cancelled) setRuntime(()=>LayoutAreaSizingRuntime);
            }, ()=>{
                loading = false;
                pending.current = [];
                for (const resolve of waitingForRuntime.splice(0))resolve(false);
            });
        };
        loadRef.current = load;
        const loadForSplitter = (event)=>{
            if (event.target instanceof Element && event.target.closest('[data-panel-splitter]')) load();
        };
        const unbindRoot = (0, $dqdTY.bindAll)(root, [
            {
                type: 'pointerover',
                listener: loadForSplitter,
                options: {
                    passive: true
                }
            },
            {
                type: 'focusin',
                listener: loadForSplitter
            },
            {
                type: 'pointerdown',
                listener: loadForSplitter,
                options: {
                    passive: true
                }
            }
        ]);
        return ()=>{
            cancelled = true;
            ready.current = false;
            pending.current = [];
            for (const resolve of waitingForRuntime.splice(0))resolve(false);
            loadRef.current = ()=>{};
            unbindRoot();
        };
    }, [
        layoutRef
    ]);
    const onReady = (0, $fsvuC.useCallback)((runtime)=>{
        actions.current = runtime;
        if (runtime) {
            runtime.setMainMinWidth(mainMinWidth.current);
            for (const area of [
                'side-nav',
                'panel',
                'chat-panel'
            ]){
                const config = configs.current[area];
                if (config) runtime.registerArea(area, config);
            }
        }
    }, []);
    const onUpdate = (0, $fsvuC.useCallback)((next)=>{
        setStates(next);
        const runtime = actions.current;
        if (runtime && Object.values(next).some(Boolean)) {
            ready.current = true;
            for (const action of pending.current.splice(0))action(runtime);
            for (const resolve of waiting.current.splice(0))resolve(true);
        }
    }, []);
    const dispatch = (0, $fsvuC.useCallback)((action)=>{
        if (ready.current && actions.current) action(actions.current);
        else {
            pending.current.push(action);
            loadRef.current();
        }
    }, []);
    const value = (0, $fsvuC.useMemo)(()=>({
            prepareResize: prepareResize,
            registerArea: (area, config)=>{
                if (area !== 'panel' && config.isOpen && !configs.current[area]?.isOpen) setLastOpenedOverlay(area);
                configs.current[area] = config;
                setConfigRevision((revision)=>revision + 1);
                actions.current?.registerArea(area, config);
            },
            unregisterArea: (area)=>{
                delete configs.current[area];
                setConfigRevision((revision)=>revision + 1);
                actions.current?.unregisterArea(area);
            },
            setMainMinWidth: (width)=>{
                if (mainMinWidth.current !== width) setConfigRevision((revision)=>revision + 1);
                mainMinWidth.current = width;
                actions.current?.setMainMinWidth(width);
            },
            getResizeBounds: (area)=>actions.current?.getResizeBounds(area),
            startResize: (area, mode)=>dispatch((runtime)=>runtime.startResize(area, mode)),
            resize: (area, mode, width)=>dispatch((runtime)=>runtime.resize(area, mode, width)),
            completeResize: (area, mode, width)=>dispatch((runtime)=>runtime.completeResize(area, mode, width))
        }), [
        dispatch,
        prepareResize
    ]);
    const SideNavStateProvider = (0, $9PicV.layoutAreaStateContexts)['side-nav'].Provider;
    const PanelStateProvider = (0, $9PicV.layoutAreaStateContexts).panel.Provider;
    const ChatPanelStateProvider = (0, $9PicV.layoutAreaStateContexts)['chat-panel'].Provider;
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $goVBy.LayoutAreaSizingContext).Provider, {
        value: value,
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)(SideNavStateProvider, {
                value: states['side-nav'],
                children: /*#__PURE__*/ (0, $5chsV.jsx)(PanelStateProvider, {
                    value: states.panel,
                    children: /*#__PURE__*/ (0, $5chsV.jsx)(ChatPanelStateProvider, {
                        value: states['chat-panel'],
                        children: children
                    })
                })
            }),
            Runtime && /*#__PURE__*/ (0, $5chsV.jsx)(Runtime, {
                layoutRef: layoutRef,
                onReady: onReady,
                onUpdate: onUpdate
            })
        ]
    });
}
$a4784a5c8a75a368$export$c026181e8eaf0b9f.displayName = "LayoutAreaSizingProvider";

});
parcelRegister("goVBy", function(module, exports) {
$parcel$export(module.exports, "LayoutAreaSizingContext", () => $221107e4b6c5651b$export$bbdf82f5436c2324);

var $fsvuC = parcelRequire("fsvuC");
const $221107e4b6c5651b$export$bbdf82f5436c2324 = /*#__PURE__*/ (0, $fsvuC.createContext)(null);

});

parcelRegister("9PicV", function(module, exports) {
$parcel$export(module.exports, "layoutAreaStateContexts", () => $8f72cee5e896f838$export$c272236272fe50dc);

var $fsvuC = parcelRequire("fsvuC");
const $8f72cee5e896f838$export$c272236272fe50dc = {
    'side-nav': /*#__PURE__*/ (0, $fsvuC.createContext)(undefined),
    panel: /*#__PURE__*/ (0, $fsvuC.createContext)(undefined),
    'chat-panel': /*#__PURE__*/ (0, $fsvuC.createContext)(undefined)
};

});

parcelRegister("krf8H", function(module, exports) {
$parcel$export(module.exports, "useCssLayoutAreaStates", () => $dbf2606fe2868a79$export$4a5d1943691d3cd7);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");
function $dbf2606fe2868a79$export$4a5d1943691d3cd7(layoutRef, revision, isEnabled) {
    const [modes, setModes] = (0, $fsvuC.useState)({});
    (0, $fsvuC.useEffect)(()=>{
        const root = layoutRef?.current;
        if (!root || !isEnabled) return;
        const measure = ()=>{
            const selectors = {
                'side-nav': ':scope > nav[data-layout-slot]',
                panel: '[data-layout-with-panel-slot]',
                'chat-panel': ':scope > [data-layout-chat-panel]'
            };
            const next = {};
            for (const area of [
                'side-nav',
                'panel',
                'chat-panel'
            ]){
                const element = root.querySelector(selectors[area]);
                if (element) next[area] = getComputedStyle(element).gridArea.split('/')[0].trim() === area ? 'inline' : 'overlay';
            }
            setModes((previous)=>[
                    'side-nav',
                    'panel',
                    'chat-panel'
                ].every((area)=>previous[area] === next[area]) ? previous : next);
        };
        const widths = new Map();
        const observer = new ResizeObserver((entries)=>{
            let changed = false;
            for (const entry of entries)if (widths.get(entry.target) !== entry.contentRect.width) {
                widths.set(entry.target, entry.contentRect.width);
                changed = true;
            }
            if (changed) measure();
        });
        const observeSlots = ()=>{
            observer.disconnect();
            widths.clear();
            const occupied = Array.from(root.children).filter((element)=>element.matches('[data-layout-slot]:not(nav):not(header):not([role="main"]):not([data-layout-chat-panel])') && [
                    'aside',
                    'ribbon',
                    'panel'
                ].includes(getComputedStyle(element).gridArea.split('/')[0].trim()));
            for (const element of [
                root,
                ...occupied
            ]){
                widths.set(element, element.getBoundingClientRect().width);
                observer.observe(element);
            }
            measure();
        };
        observeSlots();
        const mutations = new MutationObserver(observeSlots);
        mutations.observe(root, {
            childList: true
        });
        const queries = [
            window.matchMedia('(min-width: 40rem)'),
            window.matchMedia('(min-width: 64rem)')
        ];
        const unbind = [
            (0, $dqdTY.bindAll)(window, [
                {
                    type: 'resize',
                    listener: measure
                }
            ]),
            ...queries.map((query)=>(0, $dqdTY.bindAll)(query, [
                    {
                        type: 'change',
                        listener: measure
                    }
                ]))
        ];
        return ()=>{
            observer.disconnect();
            mutations.disconnect();
            unbind.forEach((cleanup)=>cleanup());
        };
    }, [
        isEnabled,
        layoutRef,
        revision
    ]);
    return modes;
}

});

parcelRegister("aGpe2", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("4KHwV").then(()=>parcelRequire('fJRWb'));

});
parcelRegister("dk4lR", function(module, exports) {
"use strict";

function $9b3084c5dabc3940$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("8b7E8")).resolve(id));
}
module.exports = $9b3084c5dabc3940$var$load;

});
parcelRegister("8b7E8", function(module, exports) {
$parcel$export(module.exports, "register", () => $01896021d7502578$export$6503ec6e8aabbaf, (v) => $01896021d7502578$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $01896021d7502578$export$f7ad0328861e2f03, (v) => $01896021d7502578$export$f7ad0328861e2f03 = v);
var $01896021d7502578$export$6503ec6e8aabbaf;
var $01896021d7502578$export$f7ad0328861e2f03;
"use strict";
var $01896021d7502578$var$mapping = new Map();
function $01896021d7502578$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$01896021d7502578$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $01896021d7502578$var$resolve(id) {
    var resolved = $01896021d7502578$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$01896021d7502578$export$6503ec6e8aabbaf = $01896021d7502578$var$register;
$01896021d7502578$export$f7ad0328861e2f03 = $01896021d7502578$var$resolve;

});




parcelRegister("7kMmS", function(module, exports) {
$parcel$export(module.exports, "IsSideNavShortcutEnabledProvider", () => $24b4e2c3d036aa36$export$f76029d097da8c58);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $evwll = parcelRequire("evwll");
function $24b4e2c3d036aa36$export$f76029d097da8c58({ children: children, isSideNavShortcutEnabled: isSideNavShortcutEnabled }) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $evwll.IsSideNavShortcutEnabledContext).Provider, {
        value: isSideNavShortcutEnabled,
        children: children
    });
}
$24b4e2c3d036aa36$export$f76029d097da8c58.displayName = "IsSideNavShortcutEnabledProvider";

});
parcelRegister("evwll", function(module, exports) {
$parcel$export(module.exports, "IsSideNavShortcutEnabledContext", () => $3f8a1404d572969d$export$c41e1ac5602bc8d5);

var $fsvuC = parcelRequire("fsvuC");
const $3f8a1404d572969d$export$c41e1ac5602bc8d5 = /*#__PURE__*/ (0, $fsvuC.createContext)(false);

});


parcelRegister("knOLS", function(module, exports) {
$parcel$export(module.exports, "SideNavElementProvider", () => $849f025af6031702$export$85c1ff84bbf6e6dc);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $59ehV = parcelRequire("59ehV");
function $849f025af6031702$export$85c1ff84bbf6e6dc({ children: children }) {
    const sideNavRef = (0, $fsvuC.useRef)(null);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $59ehV.SideNavRefContext).Provider, {
        value: sideNavRef,
        children: children
    });
}
$849f025af6031702$export$85c1ff84bbf6e6dc.displayName = "SideNavElementProvider";

});
parcelRegister("59ehV", function(module, exports) {
$parcel$export(module.exports, "SideNavRefContext", () => $f4eb2f070ea63766$export$1cd490805a3a9874);

var $fsvuC = parcelRequire("fsvuC");
const $f4eb2f070ea63766$export$1cd490805a3a9874 = /*#__PURE__*/ (0, $fsvuC.createContext)({
    current: null
});

});


parcelRegister("9wH8f", function(module, exports) {
$parcel$export(module.exports, "SideNavToggleButtonProvider", () => $9c7c1a76a3dfac0c$export$ceb8e60e9790fc0f);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $cJX7d = parcelRequire("cJX7d");

var $6F8Q8 = parcelRequire("6F8Q8");
const $9c7c1a76a3dfac0c$export$ceb8e60e9790fc0f = ({ children: children })=>{
    const [element, setElement] = (0, $fsvuC.useState)(null);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $6F8Q8.SideNavToggleButtonElement).Provider, {
        value: element,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $cJX7d.SideNavToggleButtonAttachRef).Provider, {
            value: setElement,
            children: children
        })
    });
};
$9c7c1a76a3dfac0c$export$ceb8e60e9790fc0f.displayName = "SideNavToggleButtonProvider";

});
parcelRegister("cJX7d", function(module, exports) {
$parcel$export(module.exports, "SideNavToggleButtonAttachRef", () => $38f4c5625e5fc782$export$fb8fa9a80240785e);

var $fsvuC = parcelRequire("fsvuC");

var $9Tkwf = parcelRequire("9Tkwf");
const $38f4c5625e5fc782$export$fb8fa9a80240785e = /*#__PURE__*/ (0, $fsvuC.createContext)((0, $9Tkwf.default));

});

parcelRegister("6F8Q8", function(module, exports) {
$parcel$export(module.exports, "SideNavToggleButtonElement", () => $bb784f03217b068b$export$9c1768094bef896);

var $fsvuC = parcelRequire("fsvuC");
const $bb784f03217b068b$export$9c1768094bef896 = /*#__PURE__*/ (0, $fsvuC.createContext)(null);

});


parcelRegister("jdvjm", function(module, exports) {
$parcel$export(module.exports, "SideNavVisibilityProvider", () => $24d9818f917dde97$export$aac8e996360f6ad9);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $hpUp8 = parcelRequire("hpUp8");

var $bDAkn = parcelRequire("bDAkn");
const $24d9818f917dde97$export$aac8e996360f6ad9 = ({ children: children, defaultCollapsed: defaultCollapsed })=>{
    const initialState = typeof defaultCollapsed === 'boolean' ? {
        desktop: defaultCollapsed ? 'collapsed' : 'expanded',
        mobile: 'collapsed',
        flyout: 'closed',
        lastTrigger: null
    } : null;
    // Defaults to null so we can determine if the value has been set yet (for SSR)
    const [sideNavState, setSideNavState] = (0, $fsvuC.useState)(initialState);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $bDAkn.SideNavVisibilityState).Provider, {
        value: sideNavState,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $hpUp8.SetSideNavVisibilityState).Provider, {
            value: setSideNavState,
            children: children
        })
    });
};
$24d9818f917dde97$export$aac8e996360f6ad9.displayName = "SideNavVisibilityProvider";

});
parcelRegister("hpUp8", function(module, exports) {
$parcel$export(module.exports, "SetSideNavVisibilityState", () => $8cbdb922ec6a9685$export$f6b496b07d1ea493);

var $fsvuC = parcelRequire("fsvuC");

var $9Tkwf = parcelRequire("9Tkwf");
const $8cbdb922ec6a9685$export$f6b496b07d1ea493 = /*#__PURE__*/ (0, $fsvuC.createContext)((0, $9Tkwf.default));

});

parcelRegister("bDAkn", function(module, exports) {
$parcel$export(module.exports, "SideNavVisibilityState", () => $3b359623232c4156$export$eb04201bb6dd1e4e);

var $fsvuC = parcelRequire("fsvuC");
const $3b359623232c4156$export$eb04201bb6dd1e4e = /*#__PURE__*/ (0, $fsvuC.createContext)(null);

});



parcelRegister("gGB9z", function(module, exports) {
$parcel$export(module.exports, "useLayoutAreaSizing", () => $21a716b04fa0443d$export$f7d96a85aaf64f7c);

var $fsvuC = parcelRequire("fsvuC");

var $goVBy = parcelRequire("goVBy");

var $9PicV = parcelRequire("9PicV");
function $21a716b04fa0443d$export$f7d96a85aaf64f7c({ area: area, config: config }) {
    const context = (0, $fsvuC.useContext)((0, $goVBy.LayoutAreaSizingContext));
    const { requestedWidth: requestedWidth, defaultWidth: defaultWidth, compactDefaultWidth: compactDefaultWidth, minWidth: minWidth, maxWidth: maxWidth, isOpen: isOpen, onRequestClose: onRequestClose } = config;
    const registerArea = context?.registerArea;
    const unregisterArea = context?.unregisterArea;
    const startAreaResize = context?.startResize;
    const resizeArea = context?.resize;
    const completeAreaResize = context?.completeResize;
    const getAreaResizeBounds = context?.getResizeBounds;
    const state = (0, $fsvuC.useContext)((0, $9PicV.layoutAreaStateContexts)[area]);
    // Dismissal is not a sizing input. Register a stable delegate while keeping
    // the consumer's latest committed callback outside allocation state.
    const onRequestCloseRef = (0, $fsvuC.useRef)(onRequestClose);
    (0, $fsvuC.useEffect)(()=>{
        onRequestCloseRef.current = onRequestClose;
    }, [
        onRequestClose
    ]);
    const requestClose = (0, $fsvuC.useCallback)(()=>onRequestCloseRef.current?.(), []);
    (0, $fsvuC.useEffect)(()=>{
        registerArea?.(area, {
            requestedWidth: requestedWidth,
            defaultWidth: defaultWidth,
            compactDefaultWidth: compactDefaultWidth,
            minWidth: minWidth,
            maxWidth: maxWidth,
            isOpen: isOpen,
            onRequestClose: requestClose
        });
    }, [
        area,
        compactDefaultWidth,
        defaultWidth,
        isOpen,
        maxWidth,
        minWidth,
        registerArea,
        requestClose,
        requestedWidth
    ]);
    (0, $fsvuC.useEffect)(()=>()=>unregisterArea?.(area), [
        area,
        unregisterArea
    ]);
    const startResize = (0, $fsvuC.useCallback)((mode)=>startAreaResize?.(area, mode), [
        area,
        startAreaResize
    ]);
    const resize = (0, $fsvuC.useCallback)((mode, width)=>resizeArea?.(area, mode, width), [
        area,
        resizeArea
    ]);
    const completeResize = (0, $fsvuC.useCallback)((mode, width)=>completeAreaResize?.(area, mode, width), [
        area,
        completeAreaResize
    ]);
    const getResizeBounds = (0, $fsvuC.useCallback)(()=>getAreaResizeBounds?.(area), [
        area,
        getAreaResizeBounds
    ]);
    return {
        state: state,
        startResize: startResize,
        resize: resize,
        completeResize: completeResize,
        getResizeBounds: getResizeBounds,
        isManaged: context !== null,
        prepareResize: context?.prepareResize
    };
}

});

parcelRegister("a1xUa", function(module, exports) {
$parcel$export(module.exports, "useLayoutId", () => $c208a285e1477049$export$110c3550c7c1c9aa);

var $27Jzb = parcelRequire("27Jzb");
function $c208a285e1477049$export$110c3550c7c1c9aa({ providedId: providedId } = {}) {
    const uniqueId = (0, $27Jzb.useSkipLinkId)();
    const id = providedId ? providedId : uniqueId;
    return id;
}

});
parcelRegister("27Jzb", function(module, exports) {
$parcel$export(module.exports, "useSkipLinkId", () => $99f34335d98cd8f1$export$fa3cfac0c8e29c5c);

var $cTXsj = parcelRequire("cTXsj");
function $99f34335d98cd8f1$export$fa3cfac0c8e29c5c() {
    const uniqueId = (0, $cTXsj.useId)();
    return uniqueId;
}

});


parcelRegister("1tX1p", function(module, exports) {
$parcel$export(module.exports, "useResizingWidthCssVarOnRootElement", () => $357d80b6388acae0$export$d4931ecf0fbcc8fc);

var $fsvuC = parcelRequire("fsvuC");

var $iNmwK = parcelRequire("iNmwK");

var $8wYaX = parcelRequire("8wYaX");

var $kt503 = parcelRequire("kt503");
function $357d80b6388acae0$export$d4931ecf0fbcc8fc({ isEnabled: isEnabled = true, cssVar: cssVar, panelId: panelId }) {
    (0, $fsvuC.useEffect)(()=>{
        if (!isEnabled) return;
        return (0, $8wYaX.combine)((0, $iNmwK.monitorForElements)({
            canMonitor ({ source: source }) {
                return source.data.panelId === panelId;
            },
            onDrag ({ source: source }) {
                if (!(0, $kt503.isPanelSplitterDragData)(source.data)) return;
                /**
					 * Copies the resizing width value to the `<html>` element.
					 *
					 * Required to reflect the live width of the side navigation.
					 *
					 * Used by:
					 *   - Legacy `--leftSidebarWidth` variable
					 *   - Panel slot max-width constraint
					 *
					 * When the legacy `--leftSidebarWidth` variable is no longer needed,
					 * we could consider writing to the `Panel` element instead.
					 */ document.documentElement.style.setProperty(cssVar, source.data.resizingWidth);
            },
            onDrop () {
                document.documentElement.style.removeProperty(cssVar);
            }
        }));
    }, [
        cssVar,
        isEnabled,
        panelId
    ]);
    (0, $fsvuC.useEffect)(()=>{
        if (!isEnabled) return;
        /**
		 * Ensures that the resizing CSS var on the `<html>` element is cleaned up properly
		 * if the component unmounts during a drag.
		 */ return function cleanupGlobalResizingCssVar() {
            document.documentElement.style.removeProperty(cssVar);
        };
    }, [
        cssVar,
        isEnabled
    ]);
}

});
parcelRegister("kt503", function(module, exports) {
$parcel$export(module.exports, "isPanelSplitterDragData", () => $86cb41d21ba6850b$export$e239b3966b677000);

var $kaEB6 = parcelRequire("kaEB6");
function $86cb41d21ba6850b$export$e239b3966b677000(data) {
    return data[0, $kaEB6.panelSplitterDragDataSymbol] === true;
}

});
parcelRegister("kaEB6", function(module, exports) {
$parcel$export(module.exports, "panelSplitterDragDataSymbol", () => $cf052ddbcaae1226$export$64f49ceb7f6e9a23);
const $cf052ddbcaae1226$export$64f49ceb7f6e9a23 = Symbol('panel-splitter-drag-data');

});



parcelRegister("1swgG", function(module, exports) {
$parcel$export(module.exports, "useSafeDefaultWidth", () => $c6e9d8f87ccc2d9f$export$cff429d7d83ba1f0);
/**
 * Returns the `fallbackWidth` if the provided `defaultWidthProp` is not an integer value.
 */ function $c6e9d8f87ccc2d9f$export$cff429d7d83ba1f0({ defaultWidthProp: defaultWidthProp, fallbackDefaultWidth: fallbackDefaultWidth, slotName: slotName }) {
    // If the provided `defaultWidth` is invalid then we use our fallback.
    // We are using a runtime check because some invalid numbers like `NaN` are not caught by types,
    // and we saw some issues in products where our experience broke due to this.
    if (!Number.isInteger(defaultWidthProp)) return fallbackDefaultWidth;
    return defaultWidthProp;
}

});

// Note: this value has been pulled into a separate file to better
// support testing with Playwright. Playwright did not like importing
// an exported value from `sidenav.tsx` which has `@jsxRuntime classic`.
//
// Error:
// > importSource cannot be set when runtime is classic.
/**
 * How long the flyout should remain open after the users
 * pointer has left the side nav flyout
 */ const $506751ca64a81ea5$export$a7801e29f563faad = 400;

parcelRegister("3ruGx", function(module, exports) {
$parcel$export(module.exports, "sideNavToggleTooltipKeyboardShortcut", () => $7ba719d1baf40105$export$bcd616a79072c3e4);
/**
 * The keyboard shortcut used in tooltips for indicating how to toggle the side nav.
 *
 * Used in `SideNavToggleButton` and `SideNavPanelSplitter` tooltips.
 */ const $7ba719d1baf40105$export$bcd616a79072c3e4 = [
    'Ctrl',
    '['
];

});

parcelRegister("dXooW", function(module, exports) {
$parcel$export(module.exports, "useExpandSideNav", () => $a2ffd7e379d4bc12$export$e44b4744d8ff971a);

var $fsvuC = parcelRequire("fsvuC");

var $80czl = parcelRequire("80czl");

var $dqdTY = parcelRequire("dqdTY");

var $llCao = parcelRequire("llCao");

var $hpUp8 = parcelRequire("hpUp8");

var $5GVRi = parcelRequire("5GVRi");
/**
 * Moves focus to the first focusable item in the side nav, or the side nav element itself as a fallback.
 */ function $a2ffd7e379d4bc12$var$focusFirstNavItem(sideNavElement) {
    /**
	 * Try to get the first focusable item in the side nav.
	 * The selector is not very broad, but should be appropriate for items from this package.
	 */ const firstNavItem = sideNavElement.querySelector('a, button');
    const isFirstNavItemVisible = firstNavItem !== null && (firstNavItem.checkVisibility?.() ?? false);
    const itemToFocus = isFirstNavItemVisible ? firstNavItem : sideNavElement;
    if (itemToFocus === sideNavElement) {
        /**
		 * Elements without an explicit `tabindex` attribute are not guaranteed to be focusable:
		 * https://html.spec.whatwg.org/multipage/interaction.html#attr-tabindex
		 *
		 * Our slots are not interactive, so this is required.
		 *
		 * In the future we may want to check if there is an existing `tabindex` attribute,
		 * as custom skip linked elements might already have one.
		 */ sideNavElement.setAttribute('tabindex', '-1');
        /**
		 * Cleanup the `tabindex` attribute we set when the slot or custom target loses focus.
		 *
		 * This is preferable to always having `tabindex="-1"` because always applying the tab index can:
		 *
		 * - mess with click events
		 * - potentially cause a focus ring to be always visible
		 */ (0, $dqdTY.bind)(sideNavElement, {
            type: 'blur',
            listener () {
                sideNavElement.removeAttribute('tabindex');
            },
            options: {
                once: true
            }
        });
    }
    /**
	 * Not using `focusVisible` option because we don't want clicks on the toggle button to show a focus ring.
	 */ itemToFocus.focus();
}
const $a2ffd7e379d4bc12$var$triggersWithFocusOnExpand = new Set([
    'toggle-button',
    'skip-link'
]);
function $a2ffd7e379d4bc12$export$e44b4744d8ff971a({ trigger: trigger = 'programmatic' } = {}) {
    const setSideNavState = (0, $fsvuC.useContext)((0, $hpUp8.SetSideNavVisibilityState));
    const sideNavRef = (0, $5GVRi.useSideNavRef)();
    const expandSideNav = (0, $fsvuC.useCallback)(()=>{
        const { matches: isDesktop } = window.matchMedia('(min-width: 64rem)');
        const runUpdate = ()=>{
            if (isDesktop) setSideNavState((currentState)=>{
                // No-op if the side nav state has not been initialised yet
                // e.g. if the SideNav has not been mounted yet
                if (!currentState) return null;
                // Skip the re-render if it's a no-op change
                if (currentState.desktop === 'expanded' && currentState.flyout === 'closed') return currentState;
                return {
                    mobile: currentState.mobile,
                    desktop: 'expanded',
                    flyout: 'closed',
                    lastTrigger: trigger
                };
            });
            else setSideNavState((currentState)=>{
                // No-op if the side nav state has not been initialised yet
                // e.g. if the SideNav has not been mounted yet
                if (!currentState) return null;
                // Skip the re-render if it's a no-op change
                if (currentState.mobile === 'expanded' && currentState.flyout === 'closed') return currentState;
                return {
                    desktop: currentState.desktop,
                    mobile: 'expanded',
                    flyout: 'closed',
                    lastTrigger: trigger
                };
            });
        };
        if ($a2ffd7e379d4bc12$var$triggersWithFocusOnExpand.has(trigger) && (0, $llCao.fg)('platform_dst_nav4_skip_link_a11y_1')) {
            (0, $80czl.flushSync)(runUpdate);
            const sideNavElement = sideNavRef.current;
            if (sideNavElement) $a2ffd7e379d4bc12$var$focusFirstNavItem(sideNavElement);
        } else runUpdate();
    }, [
        setSideNavState,
        sideNavRef,
        trigger
    ]);
    return expandSideNav;
}

});
parcelRegister("5GVRi", function(module, exports) {
$parcel$export(module.exports, "useSideNavRef", () => $5cfa43cf69eadedc$export$fa4d0cff03b1ea4f);

var $fsvuC = parcelRequire("fsvuC");

var $59ehV = parcelRequire("59ehV");
function $5cfa43cf69eadedc$export$fa4d0cff03b1ea4f() {
    return (0, $fsvuC.useContext)((0, $59ehV.SideNavRefContext));
}

});


parcelRegister("h4mAl", function(module, exports) {
$parcel$export(module.exports, "useIsSideNavShortcutEnabled", () => $050f8dafd4fc6e4c$export$be30cdcd17f95ec7);

var $fsvuC = parcelRequire("fsvuC");

var $evwll = parcelRequire("evwll");
function $050f8dafd4fc6e4c$export$be30cdcd17f95ec7() {
    return (0, $fsvuC.useContext)((0, $evwll.IsSideNavShortcutEnabledContext));
}

});

parcelRegister("fxB4T", function(module, exports) {
$parcel$export(module.exports, "useSideNavToggleKeyboardShortcut", () => $d1241db1f485c9c4$export$f762e7ac9d86adb0);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $hDNNn = parcelRequire("hDNNn");

var $jDV7v = parcelRequire("jDV7v");

var $h4mAl = parcelRequire("h4mAl");

var $1MUCD = parcelRequire("1MUCD");
function $d1241db1f485c9c4$export$f762e7ac9d86adb0({ canToggleWithShortcut: canToggleWithShortcut }) {
    const openLayerObserver = (0, $jDV7v.useOpenLayerObserver)();
    const toggleVisibilityByShortcut = (0, $1MUCD.useToggleSideNav)({
        trigger: 'keyboard'
    });
    const canToggleWithShortcutStableRef = (0, $hDNNn.default)(canToggleWithShortcut);
    const isSideNavShortcutEnabled = (0, $h4mAl.useIsSideNavShortcutEnabled)();
    (0, $fsvuC.useEffect)(()=>{
        if (!isSideNavShortcutEnabled) return;
        return (0, $dqdTY.bind)(window, {
            type: 'keydown',
            listener (event) {
                if (event.ctrlKey && event.key === '[') {
                    if (canToggleWithShortcutStableRef.current && !canToggleWithShortcutStableRef.current()) // Return early if the callback returns false.
                    // If the callback is not provided, we assume the shortcut is enabled.
                    return;
                    if (event.repeat) // Ignore repeated keydown events from holding down the keys
                    return;
                    if (openLayerObserver && openLayerObserver.getCount({
                        type: 'modal'
                    }) > 0) // Return early if there are any open modals
                    return;
                    openLayerObserver?.closeLayers();
                    toggleVisibilityByShortcut();
                }
            }
        });
    }, [
        canToggleWithShortcutStableRef,
        isSideNavShortcutEnabled,
        openLayerObserver,
        toggleVisibilityByShortcut
    ]);
}

});
parcelRegister("1MUCD", function(module, exports) {
$parcel$export(module.exports, "useToggleSideNav", () => $2d9351746aa173b8$export$477ee35601a0a8ce);

var $fsvuC = parcelRequire("fsvuC");

var $llCao = parcelRequire("llCao");

var $hpUp8 = parcelRequire("hpUp8");

var $bDAkn = parcelRequire("bDAkn");

var $dXooW = parcelRequire("dXooW");
function $2d9351746aa173b8$export$477ee35601a0a8ce({ trigger: trigger = 'programmatic' } = {}) {
    const setSideNavState = (0, $fsvuC.useContext)((0, $hpUp8.SetSideNavVisibilityState));
    const sideNavState = (0, $fsvuC.useContext)((0, $bDAkn.SideNavVisibilityState));
    const expandSideNav = (0, $dXooW.useExpandSideNav)({
        trigger: trigger
    });
    const isCollapsedOnDesktop = sideNavState?.desktop === 'collapsed';
    const isCollapsedOnMobile = sideNavState?.mobile === 'collapsed';
    const toggleSideNav = (0, $fsvuC.useCallback)(()=>{
        const { matches: isDesktop } = window.matchMedia('(min-width: 64rem)');
        if ((0, $llCao.fg)('platform_dst_nav4_skip_link_a11y_1')) {
            const isExpanding = isDesktop ? isCollapsedOnDesktop : isCollapsedOnMobile;
            if (isExpanding) expandSideNav();
            else setSideNavState((currentState)=>{
                // No-op if the side nav state has not been initialised yet
                // e.g. if the SideNav has not been mounted yet
                if (!currentState) return null;
                return {
                    mobile: isDesktop ? currentState.mobile : 'collapsed',
                    desktop: isDesktop ? 'collapsed' : currentState.desktop,
                    flyout: 'closed',
                    lastTrigger: trigger
                };
            });
            return;
        }
        if (isDesktop) setSideNavState((currentState)=>{
            // No-op if the side nav state has not been initialised yet
            // e.g. if the SideNav has not been mounted yet
            if (!currentState) return null;
            return {
                mobile: currentState.mobile,
                desktop: currentState.desktop === 'expanded' ? 'collapsed' : 'expanded',
                flyout: 'closed',
                lastTrigger: trigger
            };
        });
        else setSideNavState((currentState)=>{
            // No-op if the side nav state has not been initialised yet
            // e.g. if the SideNav has not been mounted yet
            if (!currentState) return null;
            return {
                desktop: currentState.desktop,
                mobile: currentState.mobile === 'expanded' ? 'collapsed' : 'expanded',
                flyout: 'closed',
                lastTrigger: trigger
            };
        });
    }, [
        expandSideNav,
        isCollapsedOnDesktop,
        isCollapsedOnMobile,
        setSideNavState,
        trigger
    ]);
    return toggleSideNav;
}

});


parcelRegister("2SRvb", function(module, exports) {
$parcel$export(module.exports, "useSideNavVisibility", () => $b4f5de71b1c7dae7$export$4a602ad7e09bdb2c);

var $fsvuC = parcelRequire("fsvuC");

var $bDAkn = parcelRequire("bDAkn");
const $b4f5de71b1c7dae7$export$4a602ad7e09bdb2c = ({ defaultCollapsed: defaultCollapsed = false } = {})=>{
    const sideNavState = (0, $fsvuC.useContext)((0, $bDAkn.SideNavVisibilityState));
    // If the context value is `null`, it means we are still in SSR, and should use the default values.
    // For desktop, it comes from the `defaultCollapsed` prop, and for mobile, it is always `false`.
    if (sideNavState === null) return {
        isExpandedOnDesktop: !defaultCollapsed,
        isExpandedOnMobile: false
    };
    return {
        isExpandedOnDesktop: sideNavState.desktop === 'expanded',
        isExpandedOnMobile: sideNavState.mobile === 'expanded'
    };
};

});

parcelRegister("3jUQt", function(module, exports) {
$parcel$export(module.exports, "useSideNavVisibilityCallbacks", () => $45cff059e5a76520$export$1904b8f2577aba9a);

var $fsvuC = parcelRequire("fsvuC");

var $aLJHG = parcelRequire("aLJHG");
function $45cff059e5a76520$export$1904b8f2577aba9a({ onExpand: onExpand, onCollapse: onCollapse, isExpandedOnDesktop: isExpandedOnDesktop, isExpandedOnMobile: isExpandedOnMobile, lastTrigger: lastTrigger }) {
    // Wrapping in refs so we can call them in `useEffect` without changes to them triggering the `useEffect`
    const onExpandRef = (0, $fsvuC.useRef)(onExpand);
    const onCollapseRef = (0, $fsvuC.useRef)(onCollapse);
    (0, $fsvuC.useEffect)(()=>{
        onExpandRef.current = onExpand;
        onCollapseRef.current = onCollapse;
    }, [
        onExpand,
        onCollapse
    ]);
    const previousIsExpandedOnDesktop = (0, $aLJHG.default)(isExpandedOnDesktop);
    (0, $fsvuC.useEffect)(()=>{
        if (previousIsExpandedOnDesktop === undefined || previousIsExpandedOnDesktop === isExpandedOnDesktop) /**
			 * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
			 *
			 * The previous value can be equal to the current one if the component re-renders due to something else changing.
			 *
			 * In both cases the value hasn't changed and we don't want to notify consumers.
			 */ return;
        if (isExpandedOnDesktop) onExpandRef.current?.({
            screen: 'desktop',
            trigger: lastTrigger
        });
        else onCollapseRef.current?.({
            screen: 'desktop',
            trigger: lastTrigger
        });
    }, [
        previousIsExpandedOnDesktop,
        isExpandedOnDesktop,
        lastTrigger
    ]);
    const previousIsExpandedOnMobile = (0, $aLJHG.default)(isExpandedOnMobile);
    (0, $fsvuC.useEffect)(()=>{
        if (previousIsExpandedOnMobile === undefined || previousIsExpandedOnMobile === isExpandedOnMobile) /**
			 * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
			 *
			 * The previous value can be equal to the current one if the component re-renders due to something else changing.
			 *
			 * In both cases the value hasn't changed and we don't want to notify consumers.
			 */ return;
        if (isExpandedOnMobile) onExpandRef.current?.({
            screen: 'mobile',
            trigger: lastTrigger
        });
        else onCollapseRef.current?.({
            screen: 'mobile',
            trigger: lastTrigger
        });
    }, [
        previousIsExpandedOnMobile,
        isExpandedOnMobile,
        lastTrigger
    ]);
}

});


parcelRegister("6TzXj", function(module, exports) {
$parcel$export(module.exports, "SideNavHeader", () => $652e02b93d01434c$export$9d28ff3a0d89869c);
/* side-nav-header.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");
const $652e02b93d01434c$var$styles = {
    root: "_2Y7lL48HPE _46hvQm8HPE _0xmtko1Y8M"
};
const $652e02b93d01434c$export$9d28ff3a0d89869c = ({ children: children })=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        className: (0, $gJ6nT.default)([
            $652e02b93d01434c$var$styles.root
        ]),
        children: children
    });
};
$652e02b93d01434c$export$9d28ff3a0d89869c.displayName = "SideNavHeader";

});

parcelRegister("1cXVb", function(module, exports) {
$parcel$export(module.exports, "SideNavBody", () => $40d5aa5eba3ccc26$export$28f21f3651df4fa1);
/* side-nav-content.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");

var $fsvuC = parcelRequire("fsvuC");
const $40d5aa5eba3ccc26$export$28f21f3651df4fa1 = /*#__PURE__*/ (0, $fsvuC.forwardRef)($40d5aa5eba3ccc26$var$_SideNavContent);
// Placing this const below the function breaks Compiled!
const $40d5aa5eba3ccc26$var$styles = {
    scrollContainer: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4bt5LAIZbP _2WAcuGIZbP",
    paddingContainer: "_46hvQm8HPE _03SyCP8HPE _0xmtko8HPE _0LQT5E8HPE"
};
function $40d5aa5eba3ccc26$var$_SideNavContent({ children: children, testId: testId }, forwardedRef) {
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        ref: forwardedRef,
        "data-testid": testId,
        className: (0, $gJ6nT.default)([
            $40d5aa5eba3ccc26$var$styles.scrollContainer
        ]),
        children: /*#__PURE__*/ (0, $5chsV.jsx)("div", {
            className: (0, $gJ6nT.default)([
                $40d5aa5eba3ccc26$var$styles.paddingContainer
            ]),
            children: children
        })
    });
}

});

parcelRegister("6gbAc", function(module, exports) {
$parcel$export(module.exports, "SideNavFooter", () => $c352ef8c244dceaa$export$b773c4c9cf740fbe);
/* side-nav-footer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");
const $c352ef8c244dceaa$var$styles = {
    root: "_46hvQm8HPE _03SyCP8HPE _0xmtko8HPE _0LQT5E8HPE _0vfIXINvrM _4hyvPa6wH8 _1KhSQW9r67"
};
const $c352ef8c244dceaa$export$b773c4c9cf740fbe = ({ children: /**
   * The content of the layout area.
   */ children, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        className: (0, $gJ6nT.default)([
            $c352ef8c244dceaa$var$styles.root,
            xcss
        ]),
        children: children
    });
};
$c352ef8c244dceaa$export$b773c4c9cf740fbe.displayName = "SideNavFooter";

});

parcelRegister("5HD6l", function(module, exports) {
$parcel$export(module.exports, "SideNavToggleButton", () => $0c5c24d93c37a843$export$8bd77667631fec25);
/* toggle-button.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $mhEfz = parcelRequire("mhEfz");

var $dVPyc = parcelRequire("dVPyc");

var $9s66L = parcelRequire("9s66L");

var $jDV7v = parcelRequire("jDV7v");

var $cBAtE = parcelRequire("cBAtE");

var $cJX7d = parcelRequire("cJX7d");

var $3ruGx = parcelRequire("3ruGx");

var $bDAkn = parcelRequire("bDAkn");

var $h4mAl = parcelRequire("h4mAl");

var $2SRvb = parcelRequire("2SRvb");

var $1MUCD = parcelRequire("1MUCD");
const $0c5c24d93c37a843$var$toggleButtonTooltipOptions = {
    // We're disabling pointer events on the tooltip to prevent it from blocking mouse events, so that the side nav flyout stays open
    // when moving the mouse from the top bar to the side nav.
    ignoreTooltipPointerEvents: true,
    // A press swaps the label between `collapseLabel` and `expandLabel`, so keep the
    // tooltip open to show the new label.
    hasNewContentOnTriggerClick: true
};
// For duplicate "mouseenter" issue when changing icons (see below)
const $0c5c24d93c37a843$var$silentIconStyles = null;
const $0c5c24d93c37a843$export$8bd77667631fec25 = ({ defaultCollapsed: defaultCollapsed = false, expandLabel: expandLabel, collapseLabel: collapseLabel, testId: testId, interactionName: interactionName, onClick: onClick })=>{
    const { isExpandedOnDesktop: isSideNavExpandedOnDesktop, isExpandedOnMobile: isSideNavExpandedOnMobile } = (0, $2SRvb.useSideNavVisibility)({
        defaultCollapsed: defaultCollapsed
    });
    const sideNavState = (0, $fsvuC.useContext)((0, $bDAkn.SideNavVisibilityState));
    // When default state is provided to `Root` the state in context will already be
    // initialized in SSR
    const [isSideNavExpanded, setIsSideNavExpanded] = (0, $fsvuC.useState)(sideNavState === null ? !defaultCollapsed : isSideNavExpandedOnDesktop);
    const ref = (0, $fsvuC.useContext)((0, $cJX7d.SideNavToggleButtonAttachRef));
    /**
   * Addresses HOT-121458 by ensuring that the toggle button element in context is always up to date.
   *
   * My theory is that something to do with SSR, hydration and suspense was causing the
   * underlying HTML element to change but without causing the toggle button to remount.
   *
   * This meant the effect calling `ref()` did not re-run, and the value in context became stale.
   */ const [element, setElement] = (0, $fsvuC.useState)(null);
    (0, $fsvuC.useEffect)(()=>{
        ref(element);
    }, [
        element,
        ref
    ]);
    (0, $fsvuC.useEffect)(()=>{
        const { matches: matches } = window.matchMedia('(min-width: 64rem)');
        setIsSideNavExpanded(matches ? isSideNavExpandedOnDesktop : isSideNavExpandedOnMobile);
    }, [
        isSideNavExpandedOnDesktop,
        isSideNavExpandedOnMobile
    ]);
    (0, $fsvuC.useEffect)(()=>{
        // When screen size changes, ensure we use the correct visibility state
        const mediaQueryList = window.matchMedia('(min-width: 64rem)');
        return (0, $dqdTY.bind)(mediaQueryList, {
            type: 'change',
            listener () {
                setIsSideNavExpanded(mediaQueryList.matches ? isSideNavExpandedOnDesktop : isSideNavExpandedOnMobile);
            }
        });
    }, [
        isSideNavExpandedOnDesktop,
        isSideNavExpandedOnMobile
    ]);
    const toggleVisibility = (0, $1MUCD.useToggleSideNav)({
        trigger: 'toggle-button'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $mhEfz.useAnalyticsEvents)();
    const openLayerObserver = (0, $jDV7v.useOpenLayerObserver)();
    const handleClick = (0, $fsvuC.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent, {
            isSideNavVisible: isSideNavExpanded
        });
        toggleVisibility();
        openLayerObserver?.closeLayers();
    }, [
        isSideNavExpanded,
        onClick,
        openLayerObserver,
        toggleVisibility
    ]);
    const handlePointerEnter = (0, $fsvuC.useCallback)(()=>{
        // Hovers don't do anything on mobile, so not capturing
        const isDesktop = window.matchMedia('(min-width: 64rem)').matches;
        if (!isDesktop) return;
        const navigationAnalyticsEvent = createAnalyticsEvent({
            source: 'topNav',
            actionSubject: 'sideNav',
            action: 'hovered',
            actionSubjectId: 'sideNavButton',
            attributes: {
                itemState: isSideNavExpanded ? 'expanded' : 'collapsed',
                screen: 'desktop'
            }
        });
        navigationAnalyticsEvent.fire('navigation');
    }, [
        createAnalyticsEvent,
        isSideNavExpanded
    ]);
    /**
   * ## Behaviour
   * It is intentional that collapse icon will be used while the flyout is open.
   * The icon is tied to the expanded / collapse state, and not the flyout state.
   *
   * ## Why a function?
   * Unfortunately, changing the icon inside an <IconButton> when the user is over
   * the button will cause the svg element to be replaced, which can trigger a
   * "mouseenter" event. This is problematic when the user is already over the button,
   * as it can result in a "mouseenter" event after the user manually entered the button.
   *
   * `icon` accepts a function for the `icon` prop (ie a render prop), so we don't need to
   * memoize it, or pull it out into a new function
   */ const icon = (props)=>/*#__PURE__*/ (0, $5chsV.jsx)("span", {
            className: (0, $gJ6nT.default)([
                "_3iDTPbcK7c _1pp6NdYbGa"
            ]),
            children: isSideNavExpanded ? /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dVPyc))), {
                ...props
            }) : /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9s66L))), {
                ...props
            })
        });
    const isShortcutEnabled = (0, $h4mAl.useIsSideNavShortcutEnabled)();
    const tooltipProps = (0, $fsvuC.useMemo)(()=>({
            ...$0c5c24d93c37a843$var$toggleButtonTooltipOptions,
            shortcut: isShortcutEnabled ? (0, $3ruGx.sideNavToggleTooltipKeyboardShortcut) : undefined
        }), [
        isShortcutEnabled
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $cBAtE.IconButton), {
        appearance: "subtle",
        label: isSideNavExpanded ? collapseLabel : expandLabel,
        icon: icon,
        onClick: handleClick,
        onPointerEnter: handlePointerEnter,
        testId: testId,
        isTooltipDisabled: false,
        interactionName: interactionName,
        ref: setElement,
        tooltip: tooltipProps
    });
};
$0c5c24d93c37a843$export$8bd77667631fec25.displayName = "SideNavToggleButton";

});
parcelRegister("cBAtE", function(module, exports) {
$parcel$export(module.exports, "IconButton", () => $7b1c543d6d3dc2e7$export$c25acd513dcc8062);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $kfsyS = parcelRequire("kfsyS");

var $dKvIi = parcelRequire("dKvIi");

var $6TdSz = parcelRequire("6TdSz");
const $7b1c543d6d3dc2e7$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $fsvuC.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $dKvIi.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $6TdSz.ThemedIconButton) : (0, $kfsyS.default);
    return /*#__PURE__*/ (0, $5chsV.jsx)(Component, {
        ref: ref,
        ...props
    });
});

});
parcelRegister("dKvIi", function(module, exports) {
$parcel$export(module.exports, "HasCustomThemeContext", () => $d9d857dfd3d8c7c7$export$d158fa15757a1890);
$parcel$export(module.exports, "useHasCustomTheme", () => $d9d857dfd3d8c7c7$export$abfcaeeca4ae7a55);

var $fsvuC = parcelRequire("fsvuC");
const $d9d857dfd3d8c7c7$export$d158fa15757a1890 = /*#__PURE__*/ (0, $fsvuC.createContext)(false);
function $d9d857dfd3d8c7c7$export$abfcaeeca4ae7a55() {
    return (0, $fsvuC.useContext)($d9d857dfd3d8c7c7$export$d158fa15757a1890);
}

});

parcelRegister("6TdSz", function(module, exports) {
$parcel$export(module.exports, "ThemedIconButton", () => $15a1bae76ff19e0a$export$d9c2d067feb61447);
/* themed-icon-button.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $fz4Xf = parcelRequire("fz4Xf");

var $3Kmf8 = parcelRequire("3Kmf8");

var $8e1dR = parcelRequire("8e1dR");

var $9S8lo = parcelRequire("9S8lo");

var $6gtGv = parcelRequire("6gtGv");
const $15a1bae76ff19e0a$export$d9c2d067feb61447 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(function ThemedIconButton({ icon: Icon, label: label, tooltip: tooltip, ...props }, ref) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $3Kmf8.default), {
        ...tooltip,
        content: tooltip?.content ?? label,
        children: (triggerProps)=>/**
     * The `aria-describedby` from `triggerProps` is intentionally not passed down,
     * because it would cause double announcements with the `VisuallyHidden` label.
     *
     * The `@atlaskit/button` IconButton uses the same approach.
     */ /*#__PURE__*/ (0, $5chsV.jsxs)((0, $6gtGv.ThemedPressable), {
                ...props,
                shape: "square",
                ref: (0, $fz4Xf.default)([
                    ref,
                    triggerProps.ref
                ]),
                onClick: (event, analyticsEvent)=>{
                    props.onClick?.(event, analyticsEvent);
                    triggerProps?.onClick?.(event);
                },
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    props.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    props.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    props.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    props.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    props.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    props.onBlur?.(e);
                },
                children: [
                    /*#__PURE__*/ (0, $5chsV.jsx)((0, $9S8lo.default), {
                        icon: Icon
                    }),
                    /*#__PURE__*/ (0, $5chsV.jsx)((0, $8e1dR.default), {
                        children: label
                    })
                ]
            })
    });
});

});
parcelRegister("9S8lo", function(module, exports) {
$parcel$export(module.exports, "default", () => $6993306b9740d931$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $llCao = parcelRequire("llCao");
function $6993306b9740d931$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 * This is copied from @atlaskit/button to render IconButtons. Some IconButton's DOM element
 * will be re-created during SSR -> SPA hydration without using this, which delays TTVC. As
 * IconRenderer is already used in @atlaskit/button to mitigate this issue, add it here to
 * mitigate the same issue for IconButtons in navigation-system, especially for ThemedIconButton.
 *
 */ const $6993306b9740d931$var$IconRenderer = ({ icon: Icon })=>{
    // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
    'use no memo';
    const isRenderProp = $6993306b9740d931$var$isIconRenderProp(Icon);
    let iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $llCao.fg)('platform_dst_button_chevron_sizing') ? (iconName)=>iconName.startsWith('Chevron') ? 'small' : 'medium' : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $5chsV.Fragment), {
        children: isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, $5chsV.jsx)(Icon, {
            ...iconProps
        })
    });
};
$6993306b9740d931$var$IconRenderer.displayName = "IconRenderer";
var $6993306b9740d931$export$2e2bcd8739ae039 = $6993306b9740d931$var$IconRenderer;

});

parcelRegister("6gtGv", function(module, exports) {
$parcel$export(module.exports, "ThemedPressable", () => $22c6870b81b4ab5d$export$66240319f1f78d74);
/* themed-pressable.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $4twf9 = parcelRequire("4twf9");

var $3OsKS = parcelRequire("3OsKS");

var $gnkn7 = parcelRequire("gnkn7");
const $22c6870b81b4ab5d$var$styles = {
    root: "_2mHwu8gVvo _2sNsIgmnOE _0bjKvDKTcp _23rrnHyKLB _00uqCYyL8i _3xtjKNYbGa _0H9qDF6wH8 _4c065UPgdg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0jFU0VymQ6 _1mT5xdRAKS _3WzCGiyL8i _32C2rkyL8i _0DCa9DyL8i _0NqVRtYbGa _0i9AWAYbGa _3932vvYbGa _3BKYwu6wH8 _0mm6KQ6wH8 _02cRtH6wH8 _3sFUREiSCN",
    border: "_2Gfj6iOLYo _0EnhYgPgdg _4lwhQT6wH8 _0dpm39NvrM _0GBAIrogpp _2WYcYGWVPG",
    selected: "_2uo31fhe06 _1UtDYzysOt _0z8nYC0GCl _10n1R5ysOt _2nTuUYysOt _30zrXRUQDy _0clgaMysOt _1gxogc4k8R _0CMRbkysOt",
    disabled: "_2uo31ftHCb _1UtDYzn3Ip _0z8nYCs4Fm _10n1R5n3Ip _2nTuUYn3Ip _30zrXRtHCb _0clgaMn3Ip _1gxogctHCb _0CMRbkn3Ip"
};
const $22c6870b81b4ab5d$var$shapeStyles = {
    default: "_2Y7lL48HPE",
    square: "_2Y7lL4Pgdg _39xV02ymQ6 _26BoRwdnbC"
};
const $22c6870b81b4ab5d$var$appearanceStyles = {
    default: "_2uo31fGfro _1UtDYz98eZ _0z8nYCQMmr _10n1R598eZ _2nTuUY98eZ _30zrXRJxD8 _0clgaM98eZ _1gxogcK3Oy _0CMRbk98eZ",
    subtle: "_2uo31fGfro _1UtDYz98eZ _10n1R598eZ _2nTuUY98eZ _30zrXRJxD8 _0clgaM98eZ _1gxogcK3Oy _0CMRbk98eZ",
    primary: "_2uo31fxjIo _1UtDYzwGpT _10n1R5wGpT _2nTuUYwGpT _30zrXR2rJx _0clgaMwGpT _1gxogcHVA2 _0CMRbkwGpT"
};
const $22c6870b81b4ab5d$export$66240319f1f78d74 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ appearance: appearance = 'default', shape: shape = 'default', isSelected: isSelected, isDisabled: isDisabled, ...props }, ref)=>{
    const hasBorder = appearance === 'default' || isSelected;
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $3OsKS.Pressable), {
        ...(0, $gnkn7.getPrimitiveSpreadProps)(props),
        ref: ref,
        type: "button",
        /**
   * We are using some style values that are outside of the strict
   * `@atlaskit/css` types.
   */ // @ts-expect-error
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $4twf9.cx)($22c6870b81b4ab5d$var$styles.root, $22c6870b81b4ab5d$var$shapeStyles[shape], hasBorder && $22c6870b81b4ab5d$var$styles.border, $22c6870b81b4ab5d$var$appearanceStyles[appearance], isSelected && $22c6870b81b4ab5d$var$styles.selected, isDisabled && $22c6870b81b4ab5d$var$styles.disabled),
        isDisabled: isDisabled
    });
});

});
parcelRegister("gnkn7", function(module, exports) {
$parcel$export(module.exports, "getPrimitiveSpreadProps", () => $9f498716220b0637$export$e4c95325a21f9785);
/**
 * Props from primitives that we explicitly ignore and remove from spread props,
 * because they apply styles.
 *
 * `css` / `className` are not here because primitives don't support them.
 *
 * See `packages/design-system/primitives/src/components/anchor.tsx` and `packages/design-system/primitives/src/components/pressable.tsx`
 * for where these are defined. These shouldn't change very often as the direction is `xcss` over individual props.
 */ function $9f498716220b0637$export$e4c95325a21f9785({ style: style, xcss: xcss, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, ...props }) {
    return props;
}

});





parcelRegister("dfLOm", function(module, exports) {
$parcel$export(module.exports, "SideNavPanelSplitter", () => $c89c918fe8e7675b$export$5f595addf4e50d58);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $l9kus = parcelRequire("l9kus");

var $eVEPg = parcelRequire("eVEPg");

var $1MUCD = parcelRequire("1MUCD");

var $5DdU4 = parcelRequire("5DdU4");

var $5OxGn = parcelRequire("5OxGn");

var $18BJt = parcelRequire("18BJt");
const $c89c918fe8e7675b$export$5f595addf4e50d58 = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId, shouldCollapseOnDoubleClick: shouldCollapseOnDoubleClick = true, tooltipContent: tooltipContent })=>{
    const context = (0, $fsvuC.useContext)((0, $18BJt.PanelSplitterContext));
    (0, $l9kus.default)(context?.panelId === (0, $eVEPg.sideNavPanelSplitterId), 'SideNavPanelSplitter must be rendered as a child of <SideNav />.');
    const toggleSideNav = (0, $1MUCD.useToggleSideNav)({
        trigger: 'double-click'
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $5DdU4.OnDoubleClickContext).Provider, {
        value: shouldCollapseOnDoubleClick ? toggleSideNav : undefined,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $5OxGn.PanelSplitter), {
            label: label,
            onResizeStart: onResizeStart,
            onResizeEnd: onResizeEnd,
            testId: testId,
            tooltipContent: // Only displaying the tooltip if double click to collapse is enabled.
            // Otherwise, we would be displaying a tooltip with "Double click to collapse", when it actually won't.
            shouldCollapseOnDoubleClick ? tooltipContent : undefined
        })
    });
};
$c89c918fe8e7675b$export$5f595addf4e50d58.displayName = "SideNavPanelSplitter";

});
parcelRegister("5DdU4", function(module, exports) {
$parcel$export(module.exports, "OnDoubleClickContext", () => $5e613960fd3ea478$export$e253efba824eceb);

var $fsvuC = parcelRequire("fsvuC");
const $5e613960fd3ea478$export$e253efba824eceb = /*#__PURE__*/ (0, $fsvuC.createContext)(undefined);

});

parcelRegister("5OxGn", function(module, exports) {
$parcel$export(module.exports, "PanelSplitter", () => $d245715da7f5c890$export$db67e3f8d3d6da0f);
/* panel-splitter.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $80czl = parcelRequire("80czl");

var $dqdTY = parcelRequire("dqdTY");

var $l9kus = parcelRequire("l9kus");

var $cTXsj = parcelRequire("cTXsj");

var $hDNNn = parcelRequire("hDNNn");

var $jDV7v = parcelRequire("jDV7v");

var $llCao = parcelRequire("llCao");

var $iNmwK = parcelRequire("iNmwK");

var $fSwMi = parcelRequire("fSwMi");

var $8wYaX = parcelRequire("8wYaX");

var $0NS3s = parcelRequire("0NS3s");

var $8cDkT = parcelRequire("8cDkT");

var $3Kmf8 = parcelRequire("3Kmf8");

var $7CbH7 = parcelRequire("7CbH7");

var $8e1dR = parcelRequire("8e1dR");

var $eVEPg = parcelRequire("eVEPg");

var $gli8N = parcelRequire("gli8N");

var $fbLFo = parcelRequire("fbLFo");

var $bMdRk = parcelRequire("bMdRk");

var $jUdyc = parcelRequire("jUdyc");

var $kt503 = parcelRequire("kt503");

var $6A9l1 = parcelRequire("6A9l1");

var $5DdU4 = parcelRequire("5DdU4");

var $18BJt = parcelRequire("18BJt");

var $kaEB6 = parcelRequire("kaEB6");
function $d245715da7f5c890$var$signPanelSplitterDragData(data) {
    return {
        ...data,
        [(0, $kaEB6.panelSplitterDragDataSymbol)]: true
    };
}
const $d245715da7f5c890$var$containerStyles = {
    root: "_2xIroY98eZ _497WNwYbGa _2zndICT6kp _3iDTPbYbGa _1mT5xdWVPG _1ZB6UydnbC _2I62gzdnbC _42Yu6B7dHp _2UeR8bvLZJ",
    positionEnd: "_1OKFqYJg58",
    positionStart: "_3iC0zd1x6F"
};
const $d245715da7f5c890$var$grabAreaStyles = {
    root: "_39xV02vFgp _0jFU0VN91d _1mT5xdWVPG _46hvQmPgdg _03SyCPPgdg _0xmtkoPgdg _0LQT5EPgdg _1UtDYzs4Fm _0KLXruyL8i _3Z9K0wb8VS _3OZqoK0jWM _0qk6IKN8t6 _1kOSYtWkA1 _0ReiIHuudW _25IEJJjTy9 _0clgaMjTy9 _3sFUREYbGa _0CMRbkAwSC",
    rootFinesse: "_25IEJJWkXl _0clgaMWkXl _0CMRbkrzt2"
};
const $d245715da7f5c890$var$lineStyles = {
    root: "_1mT5xdWVPG _3iDTPbvLZJ _39xV024Y4b _0jFU0VN91d _1UtDYzOLYo _0KLXru98eZ _3iC0zdXJux"
};
const $d245715da7f5c890$var$tooltipStyles = {
    root: "_0GTcwRTUhv _39xV02W9qI"
};
const $d245715da7f5c890$var$PanelSplitterTooltip = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ children: children, className: className, ...props }, ref)=>{
    const style = (0, $fsvuC.useMemo)(()=>{
        if (!props.style || !props.style.transform) return props.style;
        // We cannot just match against integers safely, as browsers may introduce non-integer values due to scaling
        // In the future we can probably use `CSSStyleValue.parse()` to get the browser to handle parsing for us,
        // but there's no Firefox support yet.
        const [translateX, translateY] = props.style.transform.matchAll(/(?:-|\+)?\d*\.?\d+px/g);
        if (!translateY) // If we can't extract the translateY value we bail out and return the original style
        return props.style;
        /**
     * Adjusts the translate Y to keep the tooltip within the main content area,
     * so that it does not appear over the banner or top navigation.
     */ const newTranslateY = `max(calc(${(0, $eVEPg.contentInsetBlockStart)} + ${"var(--ds-space-100, 8px)"}), ${translateY})`;
        const newTransform = `translate3d(${translateX}, ${newTranslateY}, 0)`;
        return {
            ...props.style,
            transform: newTransform
        };
    }, [
        props.style
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $7CbH7.default), {
        ...props,
        ref: ref,
        // Must be statically passed
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $gJ6nT.default)([
            $d245715da7f5c890$var$tooltipStyles.root,
            className
        ]),
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        children: children
    });
});
/**
 * A wrapper component that renders a tooltip if the tooltipContent or shortcut is provided.
 */ const $d245715da7f5c890$var$MaybeTooltip = ({ tooltipContent: tooltipContent, shortcut: shortcut, children: children, testId: testId })=>{
    if (tooltipContent) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $3Kmf8.default), {
        testId: testId,
        content: tooltipContent,
        shortcut: shortcut,
        position: "mouse-y",
        mousePosition: "right",
        isScreenReaderAnnouncementDisabled: true,
        component: $d245715da7f5c890$var$PanelSplitterTooltip,
        shouldAlwaysFadeIn: true,
        shouldRenderToParent: true,
        children: children
    });
    return children;
};
$d245715da7f5c890$var$MaybeTooltip.displayName = "MaybeTooltip";
function $d245715da7f5c890$var$getTextDirection(element) {
    const { direction: direction } = window.getComputedStyle(element);
    return direction === 'rtl' ? 'rtl' : 'ltr';
}
const $d245715da7f5c890$var$PortaledPanelSplitter = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId, panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, onResizeStartInternal: onResizeStartInternal, onResizeInternal: onResizeInternal, prepareResize: prepareResize, getResizeBounds: getResizeBounds, panel: panel, portal: portal, resizingCssVar: resizingCssVar, resizingElementRef: resizingElementRef, position: position, tooltipContent: tooltipContent, shortcut: shortcut })=>{
    const splitterRef = (0, $fsvuC.useRef)(null);
    const labelId = (0, $cTXsj.useId)();
    // Separate state used for the input range width to remove the UI's dependency on the "persisted" layout state value being updated
    const [rangeInputValue, setRangeInputValue] = (0, $fsvuC.useState)(panelWidth);
    /**
   * We are using state to store the resize bounds _converted into pixel units_, so that we can update them when the window is resized.
   * Otherwise they can become out of sync with the actual viewport size, and cause a broken experience (inaccurate width percentage)
   * when the user tries to resize using the keyboard.
   */ const [rangeInputBounds, setRangeInputBounds] = (0, $fsvuC.useState)({
        // Using placeholder values here for the initial render. These will be calculated and updated when the range input is focused.
        min: 200,
        max: 500
    });
    const openLayerObserver = (0, $jDV7v.useOpenLayerObserver)();
    /**
   * This is a temporary workaround to enable the `SideNavPanelSplitter` component
   * to collapse the side nav on double click, without exposing the `onDoubleClick` prop on `PanelSplitter`.
   * Once `PanelSplitter` supports an `onDoubleClick` prop directly, this context can be removed.
   */ const onDoubleClick = (0, $fsvuC.useContext)((0, $5DdU4.OnDoubleClickContext));
    // Storing the initial `clientX` on `mousedown` events, to workaround a bug caused by some browser extensions
    // where the `dragstart` event incorrectly returns `0` for the `clientX` location.
    const initialClientXRef = (0, $fsvuC.useRef)(null);
    // Live allocation changes panelWidth on every frame. Only the legacy path should
    // rebind the drag listeners when this value changes.
    const legacyPanelWidth = (0, $llCao.fg)('platform-dst-chat-panel-layout') ? undefined : panelWidth;
    (0, $fsvuC.useEffect)(()=>{
        const splitter = splitterRef.current;
        (0, $l9kus.default)(splitter, 'Splitter ref must be set');
        let lastManagedResizeWidth;
        return (0, $8wYaX.combine)((0, $fSwMi.blockDraggingToIFrames)({
            element: splitter
        }), /**
     * Capturing the initial `clientX` from the mousedown, before the drag starts.
     *
     * ⚠️ Note: We are not using pragmatic-drag-and-drop's `onDragStart` for this as some browser
     * extensions can cause the client location (e.g. clientX) to incorrectly return 0 during the `dragstart` event.
     *
     * We are also not using pragmatic-drag-and-drop's `onDrag` here as it is throttled, which means
     * fast mouse movements can cause the real first drag event to be missed, causing a different clientX
     * to be captured.
     *
     * I also tried only binding an event listener inside pragmatic-drag-and-drop's `onDragStart`, which seemd to work
     * but did not feel as robust, and might have timing issues as it happens slightly later.
     */ (0, $dqdTY.bind)(splitter, {
            type: 'mousedown',
            listener: (event)=>{
                initialClientXRef.current = event.clientX;
            }
        }), (0, $iNmwK.draggable)({
            element: splitter,
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                // We will be moving the line to indicate a drag. We can disable the native drag preview
                (0, $0NS3s.disableNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage
                });
                // We don't want any native drop animation for when the user does not drop on a drop target. We want the drag to finish immediately
                (0, $8cDkT.preventUnhandled).start();
            },
            getInitialData () {
                const initialWidth = (0, $bMdRk.getPixelWidth)(panel);
                /**
         * The drag calculations require the actual computed width of the element
         * For example, if the panel has loaded with a width of 2000px, but the max bound is 1000px and is visually 1000px (due to the CSS `clamp()`),
         * the drag calculations should use the actual width of 1000px, not the width in state of 2000px.
         */ return $d245715da7f5c890$var$signPanelSplitterDragData({
                    panelId: panelId,
                    initialWidth: initialWidth,
                    resizingWidth: `${initialWidth}px`,
                    resizeBounds: getResizeBounds(),
                    // Only computing text direction when we need it, just as the drag is starting.
                    // Recomputing text direction on each new drag in case the text direction
                    // has changed. This is unlikely, but being safe.
                    direction: $d245715da7f5c890$var$getTextDirection(panel)
                });
            },
            onDragStart ({ source: source }) {
                /**
         * ⚠️ Note: We are not using the client locations (e.g. clientX) during `onDragStart`
         * because some browser extensions can cause the event properties to incorrectly return 0.
         */ (0, $l9kus.default)((0, $kt503.isPanelSplitterDragData)(source.data));
                const resizeStartData = {
                    initialWidth: source.data.initialWidth
                };
                // The layout allocation system needs to know which area is actively being
                // resized before the first drag update. Committing this synchronously keeps
                // the actively dragged area protected from automatic compression.
                if (onResizeStartInternal) (0, $80czl.flushSync)(()=>onResizeStartInternal(resizeStartData));
                onResizeStart?.(resizeStartData);
                // Close any open layers when the user starts resizing
                openLayerObserver?.closeLayers();
            },
            onDrag ({ location: location, source: source }) {
                /**
         * ⚠️ Note: We are not using the location.initial.input client locations because some browser extensions
         * can cause the client locations (e.g. clientX) in the `dragstart` event to incorrectly return 0.
         */ (0, $l9kus.default)((0, $kt503.isPanelSplitterDragData)(source.data));
                const { initialWidth: initialWidth, resizeBounds: resizeBounds, direction: direction } = source.data;
                (0, $l9kus.default)(initialClientXRef.current !== null, 'initialClientX must be set');
                /**
         * How wide the element would be if there were no width constraints,
         * based on the pointer's position.
         */ const targetWidth = (0, $jUdyc.getWidthFromDragLocation)({
                    initialWidth: initialWidth,
                    location: location,
                    // The fallback of 0 won't be used due to the invariant, however we require one to satisfy the type.
                    initialClientX: initialClientXRef.current ?? 0,
                    direction: direction,
                    position: position
                });
                const resizingWidth = `clamp(${resizeBounds.min}, ${targetWidth}px, ${resizeBounds.max})`;
                if ((0, $llCao.fg)('platform-dst-chat-panel-layout') && onResizeInternal) {
                    // The allocator needs below-minimum requests for the local-to-chat cascade.
                    const currentBounds = getResizeBounds();
                    const width = Math.max(0, Math.min(targetWidth, prepareResize ? window.innerWidth : (0, $gli8N.convertResizeBoundToPixels)(currentBounds.max)));
                    if (width !== lastManagedResizeWidth) {
                        lastManagedResizeWidth = width;
                        onResizeInternal(width);
                    }
                } else {
                    panel.style.setProperty(resizingCssVar, resizingWidth);
                    resizingElementRef?.current?.style.setProperty(resizingCssVar, resizingWidth);
                }
                source.data.resizingWidth = resizingWidth;
            },
            async onDrop ({ source: source }) {
                (0, $l9kus.default)((0, $kt503.isPanelSplitterDragData)(source.data));
                (0, $8cDkT.preventUnhandled).stop();
                if (prepareResize) {
                    if (!await prepareResize() || !panel.isConnected) return;
                }
                // PDD may deliver its final throttled drag update immediately before drop.
                // Commit that update once before measuring; do not persist a previous frame.
                if (onResizeInternal && lastManagedResizeWidth !== undefined) {
                    const width = lastManagedResizeWidth;
                    (0, $80czl.flushSync)(()=>onResizeInternal(width));
                    lastManagedResizeWidth = undefined;
                }
                const finalWidth = (0, $bMdRk.getPixelWidth)(panel);
                // Persist the final preferred width before removing the imperative drag
                // variable, so the rendered width is continuous across pointer release.
                if ((0, $llCao.fg)('platform-dst-chat-panel-layout')) (0, $80czl.flushSync)(()=>onCompleteResize(finalWidth));
                else onCompleteResize(finalWidth);
                onResizeEnd?.({
                    initialWidth: source.data.initialWidth,
                    finalWidth: finalWidth
                });
                panel.style.removeProperty(resizingCssVar);
                resizingElementRef?.current?.style.removeProperty(resizingCssVar);
            }
        }));
    }, [
        onCompleteResize,
        onResizeStartInternal,
        onResizeInternal,
        prepareResize,
        onResizeStart,
        onResizeEnd,
        panel,
        resizingCssVar,
        resizingElementRef,
        legacyPanelWidth,
        position,
        openLayerObserver,
        panelId,
        getResizeBounds
    ]);
    const onResizeStartStableRef = (0, $hDNNn.default)(onResizeStart);
    const onResizeEndStableRef = (0, $hDNNn.default)(onResizeEnd);
    const [keyboardResizeManager] = (0, $fsvuC.useState)(()=>(0, $6A9l1.createKeyboardResizeManager)({
            onResizeStart: (...args)=>{
                // Close any open layers when the user starts resizing with keyboard
                openLayerObserver?.closeLayers();
                onResizeStartStableRef.current?.(...args);
            },
            onResizeEnd: (...args)=>onResizeEndStableRef.current?.(...args)
        }));
    const focusSequence = (0, $fsvuC.useRef)(0);
    const keyboardBoundsReady = (0, $fsvuC.useRef)(false);
    const pendingKeyboardWidth = (0, $fsvuC.useRef)(null);
    const handleSliderInputChange = (0, $fsvuC.useCallback)(async (event, pendingKey)=>{
        const isManagedResize = (0, $llCao.fg)('platform-dst-chat-panel-layout') && onResizeInternal;
        const sequence = focusSequence.current;
        let value = isManagedResize ? parseFloat(event.currentTarget.value) : parseInt(event.currentTarget.value);
        if (prepareResize) {
            if (!await prepareResize() || !panel.isConnected || sequence !== focusSequence.current) return;
        }
        if (isManagedResize) {
            // The available region may have changed since focus, including without a
            // window resize. Use the allocator's current bounds for the public payload.
            const bounds = getResizeBounds();
            const min = (0, $gli8N.convertResizeBoundToPixels)(bounds.min);
            const max = (0, $gli8N.convertResizeBoundToPixels)(bounds.max);
            if (pendingKey) {
                // Native range inputs would apply these keys to the placeholder bounds.
                // Preserve the intent until the chunk provides the real bounds instead.
                const current = pendingKeyboardWidth.current ?? (0, $bMdRk.getPixelWidth)(panel);
                const isRtl = $d245715da7f5c890$var$getTextDirection(panel) === 'rtl';
                const increase = pendingKey === 'ArrowUp' || pendingKey === (isRtl ? 'ArrowLeft' : 'ArrowRight') || pendingKey === 'PageUp';
                const step = pendingKey.startsWith('Page') ? Math.max(20, (max - min) / 10) : 20;
                value = pendingKey === 'End' ? max : pendingKey === 'Home' ? min : current + (increase ? step : -step);
            }
            value = Math.max(min, Math.min(value, max));
            setRangeInputBounds({
                min: min,
                max: max
            });
        }
        pendingKeyboardWidth.current = value;
        setRangeInputValue(value);
        /**
     * We are intentionally _not_ debouncing `onCompleteResize` as we want it to be called anytime the user changes the range input value.
     * It is an internal-only callback - it's provided by `PanelSplitterProvider`, and used by layout slots to update their layout width state.
     */ onCompleteResize(value);
        keyboardResizeManager.onResize({
            initialWidth: panelWidth,
            finalWidth: value
        });
    }, [
        getResizeBounds,
        onCompleteResize,
        onResizeInternal,
        panelWidth,
        keyboardResizeManager,
        panel,
        prepareResize
    ]);
    const handleSliderKeyDown = (0, $fsvuC.useCallback)((event)=>{
        if (prepareResize && !keyboardBoundsReady.current && [
            'Home',
            'End',
            'ArrowLeft',
            'ArrowRight',
            'ArrowUp',
            'ArrowDown',
            'PageUp',
            'PageDown'
        ].includes(event.key)) {
            event.preventDefault();
            handleSliderInputChange(event, event.key);
        }
    }, [
        handleSliderInputChange,
        prepareResize
    ]);
    const resizeEventListenerCleanupFn = (0, $fsvuC.useRef)(null);
    const handleSliderFocus = (0, $fsvuC.useCallback)(async ()=>{
        const sequence = ++focusSequence.current;
        keyboardBoundsReady.current = false;
        pendingKeyboardWidth.current = null;
        if (prepareResize) {
            if (!await prepareResize() || !panel.isConnected || sequence !== focusSequence.current) return;
        }
        /**
     * We are only updating the range input's properties when the element is focused, as a performance optimisation.
     * It isn't necessary to recalculate these values until the element is going to be used.
     */ // Clean up any left over listeners in case `focus` was triggered again without `blur`.
        resizeEventListenerCleanupFn.current?.();
        // Update the range input value to match the current panel width.
        const width = prepareResize ? (0, $bMdRk.getPixelWidth)(panel) : panelWidth;
        pendingKeyboardWidth.current = width;
        setRangeInputValue(width);
        const resizeBounds = getResizeBounds();
        // Update the range input bounds to ensure they are accurate (in case the viewport was previously resized)
        setRangeInputBounds({
            min: (0, $gli8N.convertResizeBoundToPixels)(resizeBounds.min),
            max: (0, $gli8N.convertResizeBoundToPixels)(resizeBounds.max)
        });
        keyboardBoundsReady.current = true;
        /**
     * _While the slider element is focused_, add a window resize event listener to update the range input bounds
     * when the window is resized. This is needed to ensure the min and max widths accurately reflect the viewport
     * size - in case they are provided in vw units.
     *
     * This listener is cleaned up when the element is blurred.
     */ resizeEventListenerCleanupFn.current = (0, $dqdTY.bind)(window, {
            type: 'resize',
            listener: function updateState() {
                const resizeBounds = getResizeBounds();
                setRangeInputBounds({
                    min: (0, $gli8N.convertResizeBoundToPixels)(resizeBounds.min),
                    max: (0, $gli8N.convertResizeBoundToPixels)(resizeBounds.max)
                });
            }
        });
    }, [
        panelWidth,
        getResizeBounds,
        panel,
        prepareResize
    ]);
    const handleSliderBlur = (0, $fsvuC.useCallback)(()=>{
        focusSequence.current++;
        keyboardBoundsReady.current = false;
        // Remove the resize event listener when the range input is blurred.
        resizeEventListenerCleanupFn.current?.();
    }, []);
    (0, $fsvuC.useEffect)(()=>{
        return function cleanup() {
            // Cleanup the resize event listener when the component is unmounted.
            resizeEventListenerCleanupFn.current?.();
        };
    }, []);
    const ariaValueText = (0, $fsvuC.useMemo)(()=>`${(0, $fbLFo.getPercentageWithinPixelBounds)({
            currentWidth: rangeInputValue,
            resizeBounds: rangeInputBounds
        })}% width`, [
        rangeInputValue,
        rangeInputBounds
    ]);
    return /*#__PURE__*/ (0, $80czl.createPortal)(/*#__PURE__*/ (0, $5chsV.jsx)("div", {
        "data-testid": testId ? `${testId}-container` : undefined,
        className: (0, $gJ6nT.default)([
            $d245715da7f5c890$var$containerStyles.root,
            position === 'start' && $d245715da7f5c890$var$containerStyles.positionStart,
            position === 'end' && $d245715da7f5c890$var$containerStyles.positionEnd
        ]),
        children: /*#__PURE__*/ (0, $5chsV.jsx)($d245715da7f5c890$var$MaybeTooltip, {
            tooltipContent: tooltipContent,
            shortcut: shortcut,
            testId: testId ? `${testId}-tooltip` : undefined,
            children: /*#__PURE__*/ (0, $5chsV.jsxs)("div", {
                ref: splitterRef,
                "data-testid": testId,
                "data-panel-splitter": prepareResize ? '' : undefined,
                onDoubleClick: onDoubleClick,
                className: (0, $gJ6nT.default)([
                    $d245715da7f5c890$var$grabAreaStyles.root,
                    (0, $llCao.fg)('platform-dst-tokens-finesse') && $d245715da7f5c890$var$grabAreaStyles.rootFinesse
                ]),
                children: [
                    /*#__PURE__*/ (0, $5chsV.jsxs)((0, $8e1dR.default), {
                        children: [
                            /*#__PURE__*/ (0, $5chsV.jsx)("input", {
                                type: "range",
                                value: rangeInputValue,
                                step: 20,
                                min: rangeInputBounds.min,
                                max: rangeInputBounds.max,
                                "aria-valuetext": ariaValueText,
                                "aria-labelledby": labelId,
                                onChange: handleSliderInputChange,
                                onKeyDown: prepareResize ? handleSliderKeyDown : undefined,
                                onFocus: handleSliderFocus,
                                onBlur: handleSliderBlur
                            }),
                            /*#__PURE__*/ (0, $5chsV.jsx)("span", {
                                id: labelId,
                                children: label
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $5chsV.jsx)("span", {
                        className: (0, $gJ6nT.default)([
                            $d245715da7f5c890$var$lineStyles.root
                        ])
                    })
                ]
            })
        })
    }), portal);
};
$d245715da7f5c890$var$PortaledPanelSplitter.displayName = "PortaledPanelSplitter";
const $d245715da7f5c890$export$db67e3f8d3d6da0f = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId, tooltipContent: tooltipContent })=>{
    const [panel, setPanel] = (0, $fsvuC.useState)(null);
    const [portal, setPortal] = (0, $fsvuC.useState)(null);
    const context = (0, $fsvuC.useContext)((0, $18BJt.PanelSplitterContext));
    (0, $l9kus.default)(context, 'Panel splitter context not set');
    const { panelRef: panelRef, portalRef: portalRef, isEnabled: isEnabled, panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, onResizeStartInternal: onResizeStartInternal, onResizeInternal: onResizeInternal, getResizeBounds: getResizeBounds, prepareResize: prepareResize, resizingCssVar: resizingCssVar, resizingElementRef: resizingElementRef, position: position, shortcut: shortcut } = context;
    /**
   * **Explanation**
   *
   * _How React Suspense works_
   *
   * When a component is suspended:
   *
   * - it is _not_ "unmounted" and effects are _not_ cleaned up
   * - refs to react managed elements are cleared
   * - react adds `display:none !important` as an inline style to hide the element
   * - state is preserved
   *
   * When a suspended component is resumed:
   * - `display:none !important` inline style is removed
   * - it will re-render (without the refs set)
   * - refs will be set
   * - `useEffect` will _not_ re-run
   *
   * [More details](https://x.com/alexandereardon/status/1944617494569992440)
   *
   * _What does this mean for the panel splitter?_
   *
   * - The panel splitter renders into content into a react managed element (eg managed by Aside)
   * - When UI is suspended the portal ref is cleared
   * - After a suspense, we will get a render with cleared refs
   * - 🔥 This is problematic if we want to portal into that ref during the render
   *
   * _Approach: initial render_
   *
   * - We cannot portal the panel splitter until after the refs are initially set
   * - Effects run after refs being set. In an effect we set the ref values (which are populated),
   *   trigger a re-render and then portal into the refs.
   *
   * _Approach: suspense_
   *
   * - We put the refs into react `state` after every render
   * - The refs in `state` will not be cleared by suspending as effects are not run, or cleaned up,
   *   when components are suspended / resumed.
   * - After the post suspense render, we can use the `portalRef` (which was captured in an effect)
   *   to continue to portal into.
   *
   * _Why not store `portalRef` in `state` in `<PanelSplitterProvider>`?_
   *
   * - The `portalRef` is set high in the tree, so a re-render will cause a
   *   large amount of components to re-render (eg the whole sidebar)
   * - After a suspense, we would need to do _another_ large re-render to propagate the new refs
   * - With our current approach, any changes to `portalRef` will cause a re-render low in the tree
   *   (just in the `<PanelSplitter>`)
   */ // We want this effect to run after each render (see above)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $fsvuC.useEffect)(()=>{
        // Don't need to do anything
        if (!isEnabled) return;
        // It is safe to access refs in useEffect, even with Suspense
        const panelEl = panelRef.current;
        const portalEl = portalRef.current;
        (0, $l9kus.default)(panelEl, 'panelRef not set');
        (0, $l9kus.default)(portalEl, 'portal element not set');
        // Doing our own check, as this results in fewer re-renders than react
        // (which also does it's own checks to see if a re-render should occur)
        if (panelEl === panel && portalEl === portal) return;
        // If refs don't change, react won't cause infinite loops
        setPanel(panelEl);
        setPortal(portalEl);
    });
    if (!isEnabled) return null;
    if (!portal || !panel) return null;
    return /*#__PURE__*/ (0, $5chsV.jsx)($d245715da7f5c890$var$PortaledPanelSplitter, {
        label: label,
        onResizeStart: onResizeStart,
        onResizeEnd: onResizeEnd,
        testId: testId,
        panelId: panelId,
        panel: panel,
        portal: portal,
        panelWidth: panelWidth,
        onCompleteResize: onCompleteResize,
        onResizeStartInternal: onResizeStartInternal,
        onResizeInternal: onResizeInternal,
        prepareResize: prepareResize,
        getResizeBounds: getResizeBounds,
        resizingCssVar: resizingCssVar,
        resizingElementRef: resizingElementRef,
        position: position,
        tooltipContent: tooltipContent,
        shortcut: shortcut
    });
};
$d245715da7f5c890$export$db67e3f8d3d6da0f.displayName = "PanelSplitter";

});
parcelRegister("fbLFo", function(module, exports) {
$parcel$export(module.exports, "getPercentageWithinPixelBounds", () => $785f80cd7c1a2e4a$export$b5423678cdf09f5);
function $785f80cd7c1a2e4a$export$b5423678cdf09f5({ currentWidth: currentWidth, resizeBounds: resizeBounds }) {
    const resizeRange = resizeBounds.max - resizeBounds.min;
    const widthAsPercentage = (currentWidth - resizeBounds.min) / resizeRange * 100;
    if (widthAsPercentage < 0) return 0;
    if (widthAsPercentage > 100) return 100;
    return Math.floor(widthAsPercentage);
}

});

parcelRegister("bMdRk", function(module, exports) {
$parcel$export(module.exports, "getPixelWidth", () => $74fd127513769894$export$d942790ad00c41f9);
/**
 * Returns the computed width of an element in pixels.
 */ const $74fd127513769894$export$d942790ad00c41f9 = (element)=>{
    // Always returns an integer. Returns 0 if element is hidden / removed.
    return element.offsetWidth;
};

});

parcelRegister("jUdyc", function(module, exports) {
$parcel$export(module.exports, "getWidthFromDragLocation", () => $c06c04bcecbc5833$export$e360234971cb95b8);
const $c06c04bcecbc5833$export$e360234971cb95b8 = ({ initialWidth: initialWidth, location: location, initialClientX: initialClientX, direction: direction, position: position })=>{
    const diffX = location.current.input.clientX - initialClientX;
    // Resize line is positioned at the inline-end (right) of the element.
    // If the direction is left-to-right, the width will increase when the mouse is moved to the right, and vice versa.
    if (position === 'end') return direction === 'ltr' ? initialWidth + diffX : initialWidth - diffX;
    // Resize line is positioned at the inline-start (left) of the element.
    // If the direction is left-to-right, the width will decrease when the mouse is moved to the right, and vice versa.
    return direction === 'ltr' ? initialWidth - diffX : initialWidth + diffX;
};

});

parcelRegister("6A9l1", function(module, exports) {
$parcel$export(module.exports, "createKeyboardResizeManager", () => $e88fea2ab558f740$export$f7d3d5dae65f74aa);
/**
 * The debounce time for the PanelSplitter resize callback functions.
 *
 * - For `onResizeStart`, it will call the callback immediately, but not
 * again until the user stops resizing and this wait time has passed.
 * - For `onResizeEnd`, it will call the callback only after this time has
 * passed since the last resize event.
 */ const $e88fea2ab558f740$var$resizeCallbackDebounceTimeMs = 500;
function $e88fea2ab558f740$export$f7d3d5dae65f74aa({ onResizeStart: onResizeStart, onResizeEnd: onResizeEnd }) {
    let resizingState = {
        type: 'idle'
    };
    /**
	 * Starts a timer to reset the state to idle and call `onResizeEnd` after a wait time.
	 */ function startResizeEndTimer({ initialWidth: initialWidth, finalWidth: finalWidth }) {
        const markResizeAsEndedTimeout = setTimeout(()=>{
            onResizeEnd({
                initialWidth: initialWidth,
                finalWidth: finalWidth
            });
            resizingState = {
                type: 'idle'
            };
        }, $e88fea2ab558f740$var$resizeCallbackDebounceTimeMs);
        resizingState = {
            type: 'resizing',
            initialWidth: initialWidth,
            abort () {
                clearTimeout(markResizeAsEndedTimeout);
            }
        };
    }
    function onResize({ initialWidth: initialWidth, finalWidth: finalWidth }) {
        if (resizingState.type === 'idle') {
            // If the state was idle, this counts as a resize start event.
            onResizeStart({
                initialWidth: initialWidth
            });
            startResizeEndTimer({
                initialWidth: initialWidth,
                finalWidth: finalWidth
            });
            return;
        }
        if (resizingState.type === 'resizing') {
            // If the state was already resizing, clear the existing timeout and start a new one.
            resizingState.abort();
            startResizeEndTimer({
                initialWidth: resizingState.initialWidth,
                finalWidth: finalWidth
            });
            return;
        }
    }
    return {
        onResize: onResize
    };
}

});




parcelRegister("aY7iH", function(module, exports) {
$parcel$export(module.exports, "TopNavEnd", () => $c5d8cf6b246c9eac$export$8b7a38b70a3c9839);
/* top-nav-end.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");

var $fsvuC = parcelRequire("fsvuC");

var $4twf9 = parcelRequire("4twf9");

var $7EsQa = parcelRequire("7EsQa");

var $fE6ce = parcelRequire("fE6ce");

var $BWeKH = parcelRequire("BWeKH");

var $llCao = parcelRequire("llCao");

var $RG5NG = parcelRequire("RG5NG");

var $21OfU = parcelRequire("21OfU");

var $P0k5L = parcelRequire("P0k5L");

var $dKvIi = parcelRequire("dKvIi");

var $cBAtE = parcelRequire("cBAtE");

var $eVEPg = parcelRequire("eVEPg");
const $c5d8cf6b246c9eac$var$containerStyles = {
    root: "_2j3gqA7LI7 _3iDTPbQ4SZ _37wbyuF05b _4ouGXIUofl _3eQEqqW9qI _15X6MhW9qI _04KkHPBmSS _3tZeuj2Njc _1xHhlhF05b",
    withPersistentItems: "_2mHwu81Y8M _0hPCNLDIqT"
};
const $c5d8cf6b246c9eac$var$listStyles = {
    root: "_2mHwu81Y8M _0hPCNLDIqT _3iDTPbQ4SZ",
    hideOnSmallViewport: "_3iDTPbYbGa _2UeR8bQ4SZ",
    popupContainer: "_4FKVYE2ADO"
};
function $c5d8cf6b246c9eac$export$8b7a38b70a3c9839({ children: children, persistentItems: persistentItems, label: label = 'Actions', showMoreButtonLabel: showMoreButtonLabel = 'Show more' }) {
    const hasPersistentItems = (0, $llCao.fg)('platform-dst-chat-panel-layout') && persistentItems != null;
    const [isOpen, setIsOpen] = (0, $fsvuC.useState)(false);
    // Always setting to `false` for the initial render (will flip in an effect for mobile)
    const [isMobile, setIsMobile] = (0, $fsvuC.useState)(false);
    // Note: `query` is a stable value between renders
    const query = (0, $21OfU.UNSAFE_useMediaQuery)('below.sm', function onChange(event) {
        setIsMobile(event.matches);
        // Any time we shift between mobile and desktop
        // We always close the popup
        setIsOpen(false);
    });
    (0, $7EsQa.useLayoutEffect)(()=>{
        // The default is `false`, and desktop will remain as `false` (no re-render).
        // Mobile will flip from `false` to `true`.
        setIsMobile(query?.matches ?? false);
    }, [
        query
    ]);
    // The shared provider also covers the mobile overflow popup itself. Keep the
    // previous content-only namespace coverage when the layout gate is disabled.
    const actions = (0, $llCao.fg)('platform-dst-chat-panel-layout') ? children : /*#__PURE__*/ (0, $5chsV.jsx)((0, $BWeKH.OpenLayerObserverNamespaceProvider), {
        namespace: (0, $eVEPg.openLayerObserverTopNavEndNamespace),
        children: children
    });
    const content = /*#__PURE__*/ (0, $5chsV.jsxs)("nav", {
        "aria-label": label,
        className: (0, $gJ6nT.default)([
            $c5d8cf6b246c9eac$var$containerStyles.root,
            hasPersistentItems && $c5d8cf6b246c9eac$var$containerStyles.withPersistentItems
        ]),
        children: [
            isMobile ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $RG5NG.Popup), {
                isOpen: isOpen,
                onClose: ()=>setIsOpen(false),
                // Top-layer popups need a role to register as a popup with the layer observer.
                role: (0, $llCao.fg)('platform-dst-chat-panel-layout') ? 'dialog' : undefined,
                label: (0, $llCao.fg)('platform-dst-chat-panel-layout') ? label : undefined,
                placement: "bottom-start",
                shouldRenderToParent: true,
                content: ()=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $dKvIi.HasCustomThemeContext).Provider, {
                        value: false,
                        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $P0k5L.List), {
                            xcss: (0, $4twf9.cx)($c5d8cf6b246c9eac$var$listStyles.root, $c5d8cf6b246c9eac$var$listStyles.popupContainer),
                            children: actions
                        })
                    }),
                trigger: (triggerProps)=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $cBAtE.IconButton), {
                        ...triggerProps,
                        label: showMoreButtonLabel,
                        isSelected: isOpen,
                        onClick: ()=>setIsOpen(!isOpen),
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fE6ce))),
                        isTooltipDisabled: false
                    })
            }) : /*#__PURE__*/ (0, $5chsV.jsx)((0, $P0k5L.List), {
                xcss: (0, $4twf9.cx)($c5d8cf6b246c9eac$var$listStyles.root, $c5d8cf6b246c9eac$var$listStyles.hideOnSmallViewport),
                children: actions
            }),
            hasPersistentItems && persistentItems
        ]
    });
    return (0, $llCao.fg)('platform-dst-chat-panel-layout') ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $BWeKH.OpenLayerObserverNamespaceProvider), {
        namespace: (0, $eVEPg.openLayerObserverTopNavEndNamespace),
        children: content
    }) : content;
}
$c5d8cf6b246c9eac$export$8b7a38b70a3c9839.displayName = "TopNavEnd";

});
parcelRegister("P0k5L", function(module, exports) {
$parcel$export(module.exports, "List", () => $7f1ce0e4bf198342$export$54c2e3dc7acea9f5);
/* list.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");
function $7f1ce0e4bf198342$var$_List({ children: children, testId: testId, xcss: xcss }, forwardedRef) {
    return(/**
     * We are using `role="list"` instead of a `ul` element to enable more flexible
     * composition. By using ARIA roles we can validly have elements between a list
     * and list items, as long as those in-between elements have no semantics.
     */ /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        role: "list",
        ref: forwardedRef,
        className: xcss,
        "data-testid": testId,
        children: children
    }));
}
const $7f1ce0e4bf198342$export$54c2e3dc7acea9f5 = /*#__PURE__*/ (0, $fsvuC.forwardRef)($7f1ce0e4bf198342$var$_List);

});


parcelRegister("hWDRM", function(module, exports) {
$parcel$export(module.exports, "TopNavMiddle", () => $b16af41aeeb49a51$export$88836ac6da0f492f);
/* top-nav-middle.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");
parcelRequire("fsvuC");

var $BWeKH = parcelRequire("BWeKH");

var $eVEPg = parcelRequire("eVEPg");
const $b16af41aeeb49a51$var$styles = {
    root: "_2mHwu82ADO _2j3gqAiZR3 _39xV02N91d _0hPCNLDIqT _3iDTPbQ4SZ _37wbyuF05b _2UeR8bgBM8 _3E0AG21EBl _1p7Awjbt8w _4itPyXW9qI _2x7hvAF05b"
};
function $b16af41aeeb49a51$export$88836ac6da0f492f({ children: children }) {
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        className: (0, $gJ6nT.default)([
            $b16af41aeeb49a51$var$styles.root
        ]),
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $BWeKH.OpenLayerObserverNamespaceProvider), {
            namespace: (0, $eVEPg.openLayerObserverTopNavMiddleNamespace),
            children: children
        })
    });
}
$b16af41aeeb49a51$export$88836ac6da0f492f.displayName = "TopNavMiddle";

});

parcelRegister("b2OB0", function(module, exports) {
$parcel$export(module.exports, "TopNavStart", () => $7ee0fd2c7dc30f91$export$4c15269b98c5129);
/* top-nav-start.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");

var $fsvuC = parcelRequire("fsvuC");

var $h3UNS = parcelRequire("h3UNS");
/**
 * Styles for the TopNavStart element.
 */ const $7ee0fd2c7dc30f91$var$innerStyles = {
    root: "_2mHwu81Y8M _2j3gqA7dHp _0jFU0VN91d _0hPCNLDIqT _3iDTPbQ4SZ _15X6MhW9qI _04KkHPBmSS _3tZeuj2Njc"
};
function $7ee0fd2c7dc30f91$export$4c15269b98c5129({ children: children, testId: testId, sideNavToggleButton: sideNavToggleButton }) {
    const ref = (0, $fsvuC.useContext)((0, $h3UNS.TopNavStartAttachRef));
    const elementRef = (0, $fsvuC.useRef)(null);
    // FIXME: unsafe pattern with Suspense, should use callback ref / store in state
    // Should handle the underlying HTMLElement changing without a remount
    (0, $fsvuC.useEffect)(()=>{
        ref(elementRef.current);
    }, [
        elementRef,
        ref
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsxs)("div", {
        ref: elementRef,
        "data-testid": testId,
        className: (0, $gJ6nT.default)([
            $7ee0fd2c7dc30f91$var$innerStyles.root
        ]),
        children: [
            sideNavToggleButton,
            children
        ]
    });
}
$7ee0fd2c7dc30f91$export$4c15269b98c5129.displayName = "TopNavStart";

});

parcelRegister("iguLq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9b7ce0838881bb0eb6f29b86e8b3a459>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d4c195b483e44d6b$var$_react = $d4c195b483e44d6b$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $d4c195b483e44d6b$var$_iconNew = $d4c195b483e44d6b$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $d4c195b483e44d6b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Editions".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/editions
 * Usage guidance:
 * Reserved for representing premium features in upsell experiences. The Editions gem icon has officially replaced the sparkle icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d4c195b483e44d6b$var$EditionsIcon = (props)=>/*#__PURE__*/ $d4c195b483e44d6b$var$_react.default.createElement($d4c195b483e44d6b$var$_iconNew.default, Object.assign({
        name: "EditionsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m12.75 1 .096.006a.75.75 0 0 1 .54.347l2.5 4a.75.75 0 0 1-.066.883l-7.25 8.5a.75.75 0 0 1-1.14 0l-7.25-8.5a.75.75 0 0 1-.066-.883l2.5-4 .056-.079A.75.75 0 0 1 3.25 1zM8 11.813 9.719 6.5H6.28zm-1.873-.914L4.704 6.5H2.375zm3.745 0L13.625 6.5h-2.33zM11.302 5h2.596l-1.563-2.5H10.52zM6.27 5h3.46l-.782-2.5H7.052zM2.103 5h2.595l.781-2.5H3.665z"/>`
    }, props));
$d4c195b483e44d6b$var$EditionsIcon.displayName = 'EditionsIcon';
var $d4c195b483e44d6b$var$_default = module.exports.default = $d4c195b483e44d6b$var$EditionsIcon;

});

parcelRegister("cIdnd", function(module, exports) {
$parcel$export(module.exports, "Button", () => $13e2392174f496da$export$353f5b6fc5456de1);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $BP2AV = parcelRequire("BP2AV");

var $dKvIi = parcelRequire("dKvIi");

var $2byIj = parcelRequire("2byIj");
const $13e2392174f496da$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $fsvuC.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $dKvIi.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $2byIj.ThemedButton) : (0, $BP2AV.default);
    return /*#__PURE__*/ (0, $5chsV.jsx)(Component, {
        ref: ref,
        ...props
    });
});

});
parcelRegister("2byIj", function(module, exports) {
$parcel$export(module.exports, "ThemedButton", () => $6a24a82942d8e0da$export$f67fb575035cc7d0);
/* themed-button.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");

var $fsvuC = parcelRequire("fsvuC");

var $9S8lo = parcelRequire("9S8lo");

var $6gtGv = parcelRequire("6gtGv");
const $6a24a82942d8e0da$var$textButtonStyles = {
    iconBefore: "_26BoRwdnbC",
    text: "_1kk5Tkf7mX"
};
const $6a24a82942d8e0da$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(function ThemedButton({ iconBefore: IconBefore, children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $6gtGv.ThemedPressable), {
        ...props,
        ref: ref,
        children: [
            IconBefore && /*#__PURE__*/ (0, $5chsV.jsx)("span", {
                className: (0, $gJ6nT.default)([
                    $6a24a82942d8e0da$var$textButtonStyles.iconBefore
                ]),
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $9S8lo.default), {
                    icon: IconBefore
                })
            }),
            /*#__PURE__*/ (0, $5chsV.jsx)("span", {
                className: (0, $gJ6nT.default)([
                    $6a24a82942d8e0da$var$textButtonStyles.text
                ]),
                children: children
            })
        ]
    });
});

});


parcelRegister("jkJ1C", function(module, exports) {
$parcel$export(module.exports, "Hide", () => $1e1366f3963ace65$export$bed28288a051538);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $h2YWL = parcelRequire("h2YWL");

var $9TNvK = parcelRequire("9TNvK");

var $j3qNu = parcelRequire("j3qNu");

var $h0mBl = parcelRequire("h0mBl");
const $1e1366f3963ace65$var$hideAboveQueries = (0, $j3qNu.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'none'
});
const $1e1366f3963ace65$var$hideBelowQueries = (0, $h0mBl.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'none'
});
const $1e1366f3963ace65$export$bed28288a051538 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $9TNvK.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $h2YWL.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            above && $1e1366f3963ace65$var$hideAboveQueries[above],
            below && $1e1366f3963ace65$var$hideBelowQueries[below],
            ...resolvedStyles.emotion || []
        ]
    }, children);
};
$1e1366f3963ace65$export$bed28288a051538.displayName = "Hide";

});
parcelRegister("j3qNu", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_buildAboveMediaQueryCSS", () => $812df2e94c99e267$export$918f8818cfbbeb2c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $h2YWL = parcelRequire("h2YWL");

var $2714Y = parcelRequire("2714Y");

var $hH7WA = parcelRequire("hH7WA");
const $812df2e94c99e267$export$918f8818cfbbeb2c = (input)=>{
    return (0, $2714Y.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>({
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $h2YWL.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $hH7WA.media).above[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        }), {});
};

});
parcelRegister("2714Y", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_BREAKPOINTS_CONFIG", () => $dd17047f423b8398$export$e5ee4fe8b989fd09);
$parcel$export(module.exports, "UNSAFE_BREAKPOINTS_ORDERED_LIST", () => $dd17047f423b8398$export$2d293d9871c38e91);
const $dd17047f423b8398$export$e5ee4fe8b989fd09 = {
    // mobile
    xxs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '0rem',
        max: '29.99rem'
    },
    // phablet
    xs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '30rem',
        max: '47.99rem'
    },
    // tablet
    sm: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-300, 24px)",
        min: '48rem',
        max: '63.99rem'
    },
    // laptop desktop
    md: {
        gridItemGutter: "var(--ds-space-300, 24px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '64rem',
        max: '89.99rem'
    },
    // monitor
    lg: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '90rem',
        max: '110.49rem'
    },
    // large high res
    xl: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-500, 40px)",
        min: '110.5rem',
        max: null
    }
}; //TODO: This `as const` should really be `satisfies Record<Breakpoint, BreakpointConfig>`, but that's not possible in our shipped TypeScript version yet.
const $dd17047f423b8398$export$2d293d9871c38e91 = Object.keys($dd17047f423b8398$export$e5ee4fe8b989fd09);
const $dd17047f423b8398$export$b7ed752a57b4177b = $dd17047f423b8398$export$2d293d9871c38e91[0];

});

parcelRegister("hH7WA", function(module, exports) {
$parcel$export(module.exports, "media", () => $69a2424aabd7ed54$export$987d49ffe1b0900f);
const $69a2424aabd7ed54$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};

});


parcelRegister("h0mBl", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_buildBelowMediaQueryCSS", () => $1cf44c4b210175bd$export$b2a4e2b0c6417297);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $h2YWL = parcelRequire("h2YWL");

var $2714Y = parcelRequire("2714Y");

var $ar0gE = parcelRequire("ar0gE");
const $1cf44c4b210175bd$export$b2a4e2b0c6417297 = (input)=>{
    return (0, $2714Y.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>{
        if (breakpoint === 'xxs') return acc;
        return {
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $h2YWL.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $ar0gE.UNSAFE_media).below[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        };
    }, {});
};

});
parcelRegister("ar0gE", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_media", () => $0b02a049e9fe7c0d$export$c881183ca713c214);

var $hH7WA = parcelRequire("hH7WA");
const $0b02a049e9fe7c0d$export$c881183ca713c214 = (0, $hH7WA.media);

});



parcelRegister("k4sC6", function(module, exports) {
$parcel$export(module.exports, "Show", () => $96cd5d21f065505d$export$f6a3d19be20f5819);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $h2YWL = parcelRequire("h2YWL");

var $9TNvK = parcelRequire("9TNvK");

var $j3qNu = parcelRequire("j3qNu");

var $h0mBl = parcelRequire("h0mBl");
function $96cd5d21f065505d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $96cd5d21f065505d$var$showAboveQueries = (0, $j3qNu.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'revert'
});
const $96cd5d21f065505d$var$showBelowQueries = (0, $h0mBl.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'revert'
});
const $96cd5d21f065505d$var$defaultHiddenStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $96cd5d21f065505d$export$f6a3d19be20f5819 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $9TNvK.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $h2YWL.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $96cd5d21f065505d$var$defaultHiddenStyles,
            above && $96cd5d21f065505d$var$showAboveQueries[above],
            below && $96cd5d21f065505d$var$showBelowQueries[below],
            ...resolvedStyles.emotion || []
        ]
    }, children);
};
$96cd5d21f065505d$export$f6a3d19be20f5819.displayName = "Show";

});

parcelRegister("he2MH", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_useMediaQuery", () => $37105d532699afc0$export$49e55ae2c03d6045);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $7EsQa = parcelRequire("7EsQa");

var $ar0gE = parcelRequire("ar0gE");
const $37105d532699afc0$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $ar0gE.UNSAFE_media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $ar0gE.UNSAFE_media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $ar0gE.UNSAFE_media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $ar0gE.UNSAFE_media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $ar0gE.UNSAFE_media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $ar0gE.UNSAFE_media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $ar0gE.UNSAFE_media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $ar0gE.UNSAFE_media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $ar0gE.UNSAFE_media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $ar0gE.UNSAFE_media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $ar0gE.UNSAFE_media).below.xl.replace('@media ', '').trim())
};
const $37105d532699afc0$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $fsvuC.useRef)(listener);
    (0, $fsvuC.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
	 * We explicitly only react to boolean changes for binding our listener
	 * Changes to the functional reference are ignored.
	 */ const hasListener = !!listener;
    /**
	 * The `matchMedia(…)` return value for our breakpoint query.
	 */ const mq = $37105d532699afc0$var$queries[queryString];
    (0, $7EsQa.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $dqdTY.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};
$37105d532699afc0$export$49e55ae2c03d6045.displayName = "UNSAFE_useMediaQuery";

});

parcelRegister("aa5ZN", function(module, exports) {
$parcel$export(module.exports, "ModalContextProvider", () => $979ac43320d9ad8e$export$7c9538f5f3c365e9);

var $fsvuC = parcelRequire("fsvuC");

var $g9Smr = parcelRequire("g9Smr");

var $bfLoj = parcelRequire("bfLoj");
const $979ac43320d9ad8e$var$RenderModal = ({ modal: modal })=>{
    const [shouldCloseOnOverlayClick, setShouldCloseOnOverlayClick] = (0, $fsvuC.useState)();
    const [shouldCloseOnEscapePress, setShouldCloseOnEscapePress] = (0, $fsvuC.useState)();
    const Component = modal.component;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement(Component, {
        onClose: modal.close,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
        setShouldCloseOnEscapePress: setShouldCloseOnEscapePress
    });
};
$979ac43320d9ad8e$var$RenderModal.displayName = "RenderModal";
function $979ac43320d9ad8e$export$7c9538f5f3c365e9({ children: children }) {
    const id = (0, $fsvuC.useRef)(1);
    const [modals, setModals] = (0, $fsvuC.useState)([]);
    const modalContext = (0, $fsvuC.useMemo)(()=>({
            openModal: (component)=>{
                const key = String(id.current++);
                const close = ()=>{
                    setModals((mdls)=>mdls.filter((d)=>d.key !== key));
                };
                setModals((mdls)=>[
                        ...mdls,
                        {
                            close: close,
                            component: component,
                            key: key
                        }
                    ]);
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $bfLoj.ModalContext).Provider, {
        value: modalContext
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $g9Smr.default), null, modals.map((modal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement($979ac43320d9ad8e$var$RenderModal, {
            key: modal.key,
            modal: modal
        }))));
}
$979ac43320d9ad8e$export$7c9538f5f3c365e9.displayName = "ModalContextProvider";

});
parcelRegister("bfLoj", function(module, exports) {
$parcel$export(module.exports, "ModalContext", () => $ef64ce11d7644313$export$ab57792b9b6974a6);

var $fsvuC = parcelRequire("fsvuC");
const $ef64ce11d7644313$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $fsvuC.createContext)({
    openModal: ()=>{
        throw new Error("To show the modal, wrap your app's root component with a <ModalContextProvider />. import { ModalContextProvider } from '@atlassian/entry-points/modal-context-provider';");
    }
});

});


parcelRegister("kPtWX", function(module, exports) {
$parcel$export(module.exports, "ModalTrigger", () => $67c0e0d792b55b28$export$fb10b32cfe19f1e);

var $fsvuC = parcelRequire("fsvuC");

var $jWJ9H = parcelRequire("jWJ9H");

var $iNT4o = parcelRequire("iNT4o");

var $8V6dQ = parcelRequire("8V6dQ");

var $8OcK0 = parcelRequire("8OcK0");

var $4LXGz = parcelRequire("4LXGz");

var $9lAcD = parcelRequire("9lAcD");

var $gWXcM = parcelRequire("gWXcM");

var $Wd0FJ = parcelRequire("Wd0FJ");

var $bfLoj = parcelRequire("bfLoj");

var $04mR9 = parcelRequire("04mR9");

var $lflki = parcelRequire("lflki");

var $9W9aG = parcelRequire("9W9aG");
const $67c0e0d792b55b28$var$emptyEntryPointParams = {};
const $67c0e0d792b55b28$var$emptyEntryPointProps = {};
function $67c0e0d792b55b28$export$fb10b32cfe19f1e({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, Fallback: Fallback, errorFallback: ErrorFallbackComponent, title: title, modalProps: modalProps, forwardedRef: forwardedRef, onError: onError, source: source, preloadOnFocus: preloadOnFocus = true, loadingText: loadingText, errorTitle: errorTitle, errorText: errorText, errorCloseText: errorCloseText }) {
    (0, $jWJ9H.di)((0, $iNT4o.loadEntryPoint));
    const { openModal: openModal } = (0, $fsvuC.useContext)((0, $bfLoj.ModalContext));
    const environmentProvider = (0, $Wd0FJ.useRelayEnvironmentProvider)();
    const { GlobalModalErrorFallback: GlobalModalErrorFallback } = (0, $4LXGz.useEntryPointConfig)();
    const ModalErrorFallback = ErrorFallbackComponent ?? GlobalModalErrorFallback;
    const modalRef = (0, $fsvuC.useRef)(null);
    const { id: id, packageName: packageName, teamName: teamName } = source ?? {};
    const metricName = (0, $fsvuC.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const load = (0, $fsvuC.useCallback)(()=>(0, $iNT4o.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $67c0e0d792b55b28$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $fsvuC.useCallback)(({ reference: entryPointReference, dispose: dispose })=>{
        openModal(({ onClose: closeModal, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress, setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick, setShouldCloseOnEscapePress: setShouldCloseOnEscapePress })=>{
            const onClose = (extraInformation)=>{
                entryPointProps?.onClose?.(extraInformation);
                closeModal();
                dispose();
            };
            const container = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $gWXcM.InternalEntryPointContainer), {
                entryPointReference: entryPointReference,
                errorFallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement(ModalErrorFallback, {
                        error: error,
                        id: id ?? metricName,
                        teamName: teamName,
                        packageName: packageName,
                        closeModal: onClose,
                        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $04mR9.ErrorFallback), {
                            error: error,
                            closeModal: onClose,
                            errorTitle: errorTitle,
                            title: title,
                            errorText: errorText,
                            errorCloseText: errorCloseText
                        })
                    }),
                onError: ({ error: error, errorInfo: errorInfo })=>{
                    onError?.({
                        error: error,
                        errorInfo: errorInfo
                    });
                },
                fallback: Fallback ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement(Fallback, {
                    onClose: closeModal
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $9W9aG.Loading), {
                    title: title,
                    loadingText: loadingText
                }),
                id: metricName,
                placeholderName: "modal-entry-point-pressable-trigger-container",
                runtimeProps: {
                    ...entryPointProps ?? $67c0e0d792b55b28$var$emptyEntryPointProps,
                    onClose: onClose,
                    setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
                    setShouldCloseOnEscapePress: setShouldCloseOnEscapePress,
                    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
                    shouldCloseOnEscapePress: shouldCloseOnEscapePress
                }
            });
            return(// eslint-disable-next-line @atlaskit/design-system/use-modal-dialog-close-button
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $8OcK0.default), {
                ...modalProps,
                ref: modalRef,
                onClose: onClose,
                shouldCloseOnOverlayClick: shouldCloseOnOverlayClick ?? modalProps?.shouldCloseOnOverlayClick,
                shouldCloseOnEscapePress: shouldCloseOnEscapePress ?? modalProps?.shouldCloseOnEscapePress
            }, container, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $lflki.FocusInsideOnLoad), {
                entryPointReference: entryPointReference,
                autoFocusRef: modalProps?.autoFocus,
                modalRef: modalRef
            })));
        });
    }, [
        openModal,
        title,
        modalProps,
        Fallback,
        metricName,
        id,
        packageName,
        teamName,
        entryPointProps,
        ModalErrorFallback,
        onError,
        loadingText,
        errorTitle,
        errorText,
        errorCloseText
    ]);
    const triggerRef = (0, $9lAcD.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad,
        preloadOnFocus: preloadOnFocus
    });
    const mergedRef = (0, $8V6dQ.useMergeRefs)([
        triggerRef,
        forwardedRef || null
    ]);
    return children({
        ref: mergedRef,
        'aria-haspopup': 'dialog'
    });
}
$67c0e0d792b55b28$export$fb10b32cfe19f1e.displayName = "ModalTrigger";

});
parcelRegister("04mR9", function(module, exports) {
$parcel$export(module.exports, "ErrorFallback", () => $bd4bfc63418b19e9$export$8a7ad05c3ee0c78a);

var $fsvuC = parcelRequire("fsvuC");

var $BP2AV = parcelRequire("BP2AV");

var $kJ3Vl = parcelRequire("kJ3Vl");

var $djI0m = parcelRequire("djI0m");

var $79e8h = parcelRequire("79e8h");

var $fTkoK = parcelRequire("fTkoK");

var $daZXj = parcelRequire("daZXj");
const $bd4bfc63418b19e9$var$defaultErrorTitle = "Couldn't load dialog content";
const $bd4bfc63418b19e9$var$defaultErrorText = 'Something went wrong while loading the dialog content. Dismiss to go back';
const $bd4bfc63418b19e9$var$defaultCloseLabel = 'Close';
const $bd4bfc63418b19e9$export$8a7ad05c3ee0c78a = ({ error: _, closeModal: closeModal, errorTitle: errorTitle, title: title, errorText: errorText = $bd4bfc63418b19e9$var$defaultErrorText, errorCloseText: errorCloseText = $bd4bfc63418b19e9$var$defaultCloseLabel })=>{
    const modalTitle = errorTitle ?? title ?? $bd4bfc63418b19e9$var$defaultErrorTitle;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $79e8h.default), {
        hasCloseButton: true,
        closeButtonLabel: errorCloseText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $fTkoK.default), {
        appearance: "danger"
    }, modalTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $kJ3Vl.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $daZXj.Text), {
        as: "p"
    }, errorText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $djI0m.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $BP2AV.default), {
        appearance: "primary",
        onClick: closeModal
    }, errorCloseText)));
};
$bd4bfc63418b19e9$export$8a7ad05c3ee0c78a.displayName = "ErrorFallback";

});

parcelRegister("lflki", function(module, exports) {
$parcel$export(module.exports, "FocusInsideOnLoad", () => $5c2645944fc19c56$export$eb58c1f6b41ee511);

var $fsvuC = parcelRequire("fsvuC");

var $8c95s = parcelRequire("8c95s");

var $9ppez = parcelRequire("9ppez");
function $5c2645944fc19c56$var$FocusInsideOnLoadInner({ autoFocusRef: autoFocusRef, modalRef: modalRef }) {
    (0, $fsvuC.useEffect)(()=>{
        // Fence for if container element doesn't exist, but this is effectively not
        // possible.
        if (!modalRef.current) return;
        // If ref provided, use that first. Else find first focusable element or
        // container if not exists
        if (autoFocusRef?.current) {
            autoFocusRef.current.focus();
            return;
        }
        const firstFocusable = (0, $8c95s.getFirstFocusable)({
            container: modalRef.current
        });
        if (firstFocusable) {
            firstFocusable.focus();
            return;
        }
        modalRef.current.focus();
    }, [
        autoFocusRef,
        modalRef
    ]);
    return null;
}
$5c2645944fc19c56$var$FocusInsideOnLoadInner.displayName = "FocusInsideOnLoadInner";
function $5c2645944fc19c56$export$eb58c1f6b41ee511({ entryPointReference: entryPointReference, autoFocusRef: autoFocusRef, modalRef: modalRef }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $9ppez.WaitForEntryPointLoad), {
        entryPointReference: entryPointReference
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement($5c2645944fc19c56$var$FocusInsideOnLoadInner, {
        autoFocusRef: autoFocusRef,
        modalRef: modalRef
    }));
}
$5c2645944fc19c56$export$eb58c1f6b41ee511.displayName = "FocusInsideOnLoad";

});
parcelRegister("9ppez", function(module, exports) {
$parcel$export(module.exports, "WaitForEntryPointLoad", () => $8cca82d85ee319e3$export$ed96a854f3831b66);

var $fsvuC = parcelRequire("fsvuC");

var $jY9mG = parcelRequire("jY9mG");

var $9Tkwf = parcelRequire("9Tkwf");
function $8cca82d85ee319e3$var$SuspendUntilLoaded({ entryPointReference: entryPointReference, children: children }) {
    // The result is intentionally unused — this call exists purely to gate
    // the mount of children on the load completing.
    entryPointReference.getComponent();
    return children;
}
const $8cca82d85ee319e3$var$renderNothing = ()=>null;
function $8cca82d85ee319e3$export$ed96a854f3831b66({ entryPointReference: entryPointReference, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $jY9mG.ErrorBoundary), {
        FallbackComponent: $8cca82d85ee319e3$var$renderNothing,
        onError: (0, $9Tkwf.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Suspense, {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement($8cca82d85ee319e3$var$SuspendUntilLoaded, {
        entryPointReference: entryPointReference
    }, children)));
}
$8cca82d85ee319e3$export$ed96a854f3831b66.displayName = "WaitForEntryPointLoad";

});


parcelRegister("9W9aG", function(module, exports) {
$parcel$export(module.exports, "Loading", () => $fad84e1379a13d37$export$669f6ea7d267feaf);

var $fsvuC = parcelRequire("fsvuC");

var $kJ3Vl = parcelRequire("kJ3Vl");

var $djI0m = parcelRequire("djI0m");

var $79e8h = parcelRequire("79e8h");

var $fTkoK = parcelRequire("fTkoK");

var $cNFUK = parcelRequire("cNFUK");
const $fad84e1379a13d37$export$669f6ea7d267feaf = ({ loadingText: loadingText, title: title })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $79e8h.default), {
        hasCloseButton: true
    }, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $fTkoK.default), null, title) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $kJ3Vl.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $cNFUK.LoadingContent), {
        loadingText: loadingText ?? 'Loading dialog content...',
        size: "large"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $djI0m.default), null));
$fad84e1379a13d37$export$669f6ea7d267feaf.displayName = "Loading";

});
parcelRegister("cNFUK", function(module, exports) {
$parcel$export(module.exports, "LoadingContent", () => $178705649e1331e1$export$4ab3512e4872e6ff);

var $fsvuC = parcelRequire("fsvuC");

var $d0SZF = parcelRequire("d0SZF");

var $daZXj = parcelRequire("daZXj");

var $9cT91 = parcelRequire("9cT91");
const $178705649e1331e1$export$4ab3512e4872e6ff = ({ loadingText: loadingText, size: size })=>{
    const stackSpace = size === 'large' ? 'space.400' : 'space.200';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $d0SZF.Stack), {
        space: stackSpace,
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $9cT91.default), {
        size: size,
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $daZXj.Text), {
        color: "color.text.subtle"
    }, loadingText));
};
$178705649e1331e1$export$4ab3512e4872e6ff.displayName = "LoadingContent";

});



parcelRegister("kCitG", function(module, exports) {
$parcel$export(module.exports, "LinkButton", () => $4fe37d77421f3faf$export$29d11c0fe2fc51d8);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gTDLR = parcelRequire("gTDLR");

var $dKvIi = parcelRequire("dKvIi");

var $eKFxq = parcelRequire("eKFxq");
const $4fe37d77421f3faf$export$29d11c0fe2fc51d8 = /*#__PURE__*/ (0, $fsvuC.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $dKvIi.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $eKFxq.ThemedLinkButton) : (0, $gTDLR.default);
    return /*#__PURE__*/ (0, $5chsV.jsx)(Component, {
        ref: ref,
        ...props
    });
});

});
parcelRegister("eKFxq", function(module, exports) {
$parcel$export(module.exports, "ThemedLinkButton", () => $77d0dec036ff4aba$export$b0b5aeed52623827);
/* themed-link-button.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");
parcelRequire("fsvuC");

var $3R2Wy = parcelRequire("3R2Wy");

var $cIukW = parcelRequire("cIukW");
const $77d0dec036ff4aba$var$textButtonStyles = {
    iconBefore: "_26BoRwdnbC",
    text: "_1kk5Tkf7mX"
};
function $77d0dec036ff4aba$var$ThemedLinkButtonFn({ iconBefore: IconBefore, children: children, ...props }, ref) {
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $5chsV.jsxs)((0, $cIukW.ThemedAnchor), {
        ...props,
        ref: ref,
        children: [
            IconBefore && /*#__PURE__*/ (0, $5chsV.jsx)("span", {
                className: (0, $gJ6nT.default)([
                    $77d0dec036ff4aba$var$textButtonStyles.iconBefore
                ]),
                children: /*#__PURE__*/ (0, $5chsV.jsx)(IconBefore, {
                    label: "",
                    color: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $5chsV.jsx)("span", {
                className: (0, $gJ6nT.default)([
                    $77d0dec036ff4aba$var$textButtonStyles.text
                ]),
                children: children
            })
        ]
    }));
}
$77d0dec036ff4aba$var$ThemedLinkButtonFn.displayName = "ThemedLinkButtonFn";
const $77d0dec036ff4aba$export$b0b5aeed52623827 = (0, $3R2Wy.default)($77d0dec036ff4aba$var$ThemedLinkButtonFn);

});
parcelRegister("cIukW", function(module, exports) {
$parcel$export(module.exports, "ThemedAnchor", () => $ff5610f53c4eacad$export$1b69d1a78614cc52);
/* themed-anchor.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $4twf9 = parcelRequire("4twf9");

var $3R2Wy = parcelRequire("3R2Wy");

var $cGW6W = parcelRequire("cGW6W");

var $gnkn7 = parcelRequire("gnkn7");
const $ff5610f53c4eacad$var$styles = {
    root: "_2mHwu8gVvo _2sNsIgmnOE _0bjKvDKTcp _23rrnHyKLB _00uqCYyL8i _3xtjKNYbGa _0H9qDF6wH8 _4c065UPgdg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0jFU0VymQ6 _1mT5xdRAKS _3WzCGiyL8i _32C2rkyL8i _0DCa9DyL8i _0NqVRtYbGa _0i9AWAYbGa _3932vvYbGa _3BKYwu6wH8 _0mm6KQ6wH8 _02cRtH6wH8 _3sFUREiSCN",
    border: "_2Gfj6iOLYo _0EnhYgPgdg _4lwhQT6wH8 _0dpm39NvrM _0GBAIrogpp _2WYcYGWVPG",
    selected: "_2uo31fhe06 _1UtDYzysOt _0z8nYC0GCl _10n1R5ysOt _2nTuUYysOt _30zrXRUQDy _0clgaMysOt _1gxogc4k8R _0CMRbkysOt",
    disabled: "_2uo31ftHCb _1UtDYzn3Ip _0z8nYCs4Fm _10n1R5n3Ip _2nTuUYn3Ip _30zrXRtHCb _0clgaMn3Ip _1gxogctHCb _0CMRbkn3Ip"
};
const $ff5610f53c4eacad$var$appearanceStyles = {
    default: "_2uo31fGfro _1UtDYz98eZ _0z8nYCQMmr _10n1R598eZ _2nTuUY98eZ _30zrXRJxD8 _0clgaM98eZ _1gxogcK3Oy _0CMRbk98eZ",
    subtle: "_2uo31fGfro _1UtDYz98eZ _10n1R598eZ _2nTuUY98eZ _30zrXRJxD8 _0clgaM98eZ _1gxogcK3Oy _0CMRbk98eZ",
    primary: "_2uo31fxjIo _1UtDYzwGpT _10n1R5wGpT _2nTuUYwGpT _30zrXR2rJx _0clgaMwGpT _1gxogcHVA2 _0CMRbkwGpT"
};
const $ff5610f53c4eacad$var$shapeStyles = {
    default: "_2Y7lL48HPE",
    square: "_2Y7lL4Pgdg _39xV02ymQ6 _26BoRwdnbC"
};
function $ff5610f53c4eacad$var$ThemedAnchorFn({ appearance: appearance = 'default', shape: shape = 'default', isSelected: isSelected, isDisabled: isDisabled, ...props }, ref) {
    const hasBorder = appearance === 'default' || isSelected;
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $cGW6W.Anchor), {
        ...(0, $gnkn7.getPrimitiveSpreadProps)(props),
        ref: ref,
        /**
   * We are using some style values that are outside of the strict
   * `@atlaskit/css` types.
   */ // @ts-expect-error
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $4twf9.cx)($ff5610f53c4eacad$var$styles.root, $ff5610f53c4eacad$var$shapeStyles[shape], hasBorder && $ff5610f53c4eacad$var$styles.border, $ff5610f53c4eacad$var$appearanceStyles[appearance], isSelected && $ff5610f53c4eacad$var$styles.selected, isDisabled && $ff5610f53c4eacad$var$styles.disabled)
    });
}
$ff5610f53c4eacad$var$ThemedAnchorFn.displayName = "ThemedAnchorFn";
const $ff5610f53c4eacad$export$1b69d1a78614cc52 = (0, $3R2Wy.default)($ff5610f53c4eacad$var$ThemedAnchorFn);

});



parcelRegister("6Y0GL", function(module, exports) {
$parcel$export(module.exports, "CustomerServiceManagementIcon", () => $016a3c9577ba121f$export$6da5aa77c402ba0f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b9c55c8ffa026c174f3b8612196e48f7>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $2IsXX = parcelRequire("2IsXX");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $016a3c9577ba121f$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M16.43 17.42A6.97 6.97 0 0 1 12 19H6.4v-.47l3.84-3.78a3.25 3.25 0 0 0 1.76.52c.65 0 1.25-.19 1.76-.51zm.99-.99A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43l-2.67 2.67c.33.51.52 1.11.52 1.76s-.19 1.25-.51 1.76zm-.99-9.85-2.67 2.67A3.25 3.25 0 0 0 12 8.73c-.65 0-1.25.19-1.76.52L7.57 6.58A6.97 6.97 0 0 1 12 5c1.68 0 3.22.59 4.43 1.58m-9.85.99A6.97 6.97 0 0 0 5 12c0 1.68.59 3.22 1.58 4.43l2.67-2.67A3.25 3.25 0 0 1 8.73 12c0-.65.19-1.25.52-1.76z"/>
</svg>
`;
const $016a3c9577ba121f$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.238 14.751a3.25 3.25 0 0 1-1.762.516 3.25 3.25 0 0 1-1.762-.515L6.4 18.533V19H12a6.97 6.97 0 0 0 4.43-1.58zM6.58 7.571A6.97 6.97 0 0 0 5 12a6.97 6.97 0 0 0 1.58 4.43l2.669-2.668A3.25 3.25 0 0 1 8.733 12c0-.649.19-1.253.516-1.762zm8.172 2.667c.326.508.515 1.113.515 1.762s-.189 1.254-.515 1.762l2.668 2.668A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43zM12 5a6.97 6.97 0 0 0-4.43 1.58l2.668 2.668A3.25 3.25 0 0 1 12 8.733c.649 0 1.253.19 1.762.516L16.43 6.58A6.97 6.97 0 0 0 12 5"/>
</svg>
`;
function $016a3c9577ba121f$export$6da5aa77c402ba0f({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Customer Service Management', testId: testId }) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $2IsXX.IconWrapper), {
        svg: $016a3c9577ba121f$var$svg,
        customThemeSvg: $016a3c9577ba121f$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}
$016a3c9577ba121f$export$6da5aa77c402ba0f.displayName = "CustomerServiceManagementIcon";

});

parcelRegister("fep3P", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementIcon", () => $774f2d4e694569b8$export$3c6158790f5e01c4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::018e1283e27acb8e799a70f211bb080a>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $2IsXX = parcelRequire("2IsXX");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $774f2d4e694569b8$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M13.744 10.156h4.578c.688 0 .922.654.503 1.174l-7.16 8.837c-2.314-1.845-2.096-4.763-.402-6.892zm-3.538 3.521H5.63c-.688 0-.923-.654-.504-1.173l7.16-8.837c2.315 1.844 2.063 4.728.386 6.875z"/>
</svg>
`;
const $774f2d4e694569b8$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.256 10.156-2.481 3.12c-1.694 2.129-1.912 5.047.402 6.891l7.16-8.837c.42-.52.185-1.174-.503-1.174zm-8.619 2.348c-.419.52-.183 1.174.504 1.174h4.577l2.465-3.136c1.677-2.146 1.928-5.03-.386-6.875z"/>
</svg>
`;
function $774f2d4e694569b8$export$3c6158790f5e01c4({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Jira Service Management', testId: testId }) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $2IsXX.IconWrapper), {
        svg: $774f2d4e694569b8$var$svg,
        customThemeSvg: $774f2d4e694569b8$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}
$774f2d4e694569b8$export$3c6158790f5e01c4.displayName = "JiraServiceManagementIcon";

});

parcelRegister("5I8al", function(module, exports) {
$parcel$export(module.exports, "PopupTrigger", () => $36716ada163ca52f$export$95d4acdbab2fc6ef);

var $fsvuC = parcelRequire("fsvuC");

var $iNT4o = parcelRequire("iNT4o");

var $3NfiF = parcelRequire("3NfiF");

var $llCao = parcelRequire("llCao");

var $RG5NG = parcelRequire("RG5NG");

var $9lAcD = parcelRequire("9lAcD");

var $gWXcM = parcelRequire("gWXcM");

var $Wd0FJ = parcelRequire("Wd0FJ");

var $l6CQt = parcelRequire("l6CQt");

var $9EWGD = parcelRequire("9EWGD");

var $7m3a1 = parcelRequire("7m3a1");


var $co0u5 = parcelRequire("co0u5");

var $iiIie = parcelRequire("iiIie");

var $Jja7C = parcelRequire("Jja7C");

var $6te8C = parcelRequire("6te8C");
const $36716ada163ca52f$var$emptyEntryPointParams = {};
const $36716ada163ca52f$var$emptyEntryPointProps = {};
const $36716ada163ca52f$var$FallbackComponent = ({ fallback: fallback, loadingText: loadingText, onMount: onMount, onUnmount: onUnmount, shouldFocus: shouldFocus })=>{
    const ref = (0, $fsvuC.useRef)(null);
    (0, $fsvuC.useEffect)(()=>{
        if (shouldFocus) ref.current?.focus();
        onMount();
        return ()=>onUnmount();
    }, [
        onMount,
        onUnmount,
        shouldFocus
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement("span", {
        ref: ref,
        tabIndex: shouldFocus ? -1 : undefined,
        "data-testid": "popup-trigger-loading"
    }, fallback || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $Jja7C.Loading), {
        loadingText: loadingText
    }));
};
$36716ada163ca52f$var$FallbackComponent.displayName = "FallbackComponent";
function $36716ada163ca52f$export$95d4acdbab2fc6ef({ trigger: trigger, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, fallback: fallback, errorFallback: errorFallback, errorText: errorText, errorTitle: errorTitle, onError: onError, forcedReportErrorUFO: forcedReportErrorUFO, onClose: onClose, preloadOnFocus: preloadOnFocus = true, autoFocus: autoFocus, loadingText: loadingText = 'Loading popup...', loadingCompleteText: loadingCompleteText = 'Loading is complete.', ...popupProps }) {
    const environmentProvider = (0, $Wd0FJ.useRelayEnvironmentProvider)();
    const id = (0, $fsvuC.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const [isOpen, setIsOpen] = (0, $fsvuC.useState)(false);
    const [content, setContent] = (0, $fsvuC.useState)(null);
    const { statusText: statusText, announce: announce, cancelPendingAnnouncement: cancelPendingAnnouncement, resetStatus: resetStatus } = (0, $7m3a1.useStatusAnnouncement)();
    const isOpenRef = (0, $fsvuC.useRef)(false);
    const hasErrorRef = (0, $fsvuC.useRef)(false);
    const triggerFocusRef = (0, $fsvuC.useRef)(null);
    const updateRef = (0, $fsvuC.useRef)(null);
    const setInitialFocusRef = (0, $fsvuC.useRef)(null);
    const handleError = (0, $fsvuC.useCallback)((props)=>{
        if (isOpenRef.current) {
            hasErrorRef.current = true;
            resetStatus();
            announce({
                text: errorText ?? (0, $531256d3fe3ee2a2$export$73e31d6dbeb74c41),
                clearAfter: 5000
            });
        }
        onError?.(props);
    }, [
        announce,
        errorText,
        onError,
        resetStatus
    ]);
    const handleOpen = (0, $fsvuC.useCallback)(()=>{
        isOpenRef.current = true;
        setIsOpen(true);
    }, []);
    const handleClose = (0, $fsvuC.useCallback)((event, currentLevel)=>{
        isOpenRef.current = false;
        setIsOpen(false);
        if ((0, $llCao.fg)('platform_dst-popup-trigger-initial-focus-ref') && popupProps.shouldReturnFocus !== false && event?.type === 'keydown' && 'key' in event && (event.key === 'Escape' || event.key === 'Esc')) setTimeout(()=>{
            if (document.activeElement === document.body) triggerFocusRef.current?.focus();
        }, 0);
        resetStatus();
        onClose?.(event, currentLevel);
    }, [
        onClose,
        popupProps.shouldReturnFocus,
        resetStatus,
        triggerFocusRef
    ]);
    const triggerCloseRef = (0, $6te8C.useClickToCloseRef)({
        isOpen: isOpen,
        handleClose: handleClose
    });
    const load = (0, $fsvuC.useCallback)(()=>(0, $iNT4o.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $36716ada163ca52f$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const popupSetInitialFocusRef = (0, $fsvuC.useRef)(null);
    const handleSetInitialFocusRef = (0, $fsvuC.useCallback)((el)=>{
        popupSetInitialFocusRef.current?.(el);
    }, []);
    const onLoad = (0, $fsvuC.useCallback)(({ reference: entryPointReference })=>{
        // avoid re-loading entry-point when closing popup
        if (isOpen) return;
        hasErrorRef.current = false;
        handleOpen();
        setContent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $gWXcM.InternalEntryPointContainer), {
            id: id,
            entryPointReference: entryPointReference,
            fallback: // when the fallback is unmounted we want to trigger an update to the popup position
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement($36716ada163ca52f$var$FallbackComponent, {
                fallback: fallback,
                loadingText: loadingText,
                onMount: ()=>{
                    if ((0, $llCao.fg)('platform_dst-accessible-popup-loading')) announce({
                        text: loadingText,
                        delay: 100
                    });
                },
                onUnmount: ()=>{
                    if ((0, $llCao.fg)('platform_dst-accessible-popup-loading') && !hasErrorRef.current) {
                        const wasPending = cancelPendingAnnouncement();
                        if (!wasPending && isOpenRef.current) announce({
                            text: loadingCompleteText,
                            clearAfter: 5000
                        });
                    }
                    return updateRef.current?.();
                },
                shouldFocus: autoFocus !== false
            }),
            errorFallback: (props)=>errorFallback ? errorFallback(props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $l6CQt.ErrorContent), {
                    title: errorTitle,
                    errorText: errorText ?? (0, $531256d3fe3ee2a2$export$73e31d6dbeb74c41)
                }),
            runtimeProps: {
                ...entryPointProps ?? $36716ada163ca52f$var$emptyEntryPointProps,
                onContentResized: ()=>{
                    updateRef.current?.();
                },
                onClose: handleClose,
                ...(0, $llCao.fg)('platform_dst-popup-trigger-initial-focus-ref') ? {
                    setInitialFocusRef: handleSetInitialFocusRef
                } : {}
            },
            onError: handleError,
            forcedError: forcedReportErrorUFO
        }), autoFocus !== false && ((0, $llCao.fg)('platform_dst-popup-trigger-focus-container') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $iiIie.FocusOnContainerOnLoad), {
            entryPointReference: entryPointReference,
            setInitialFocusRef: setInitialFocusRef
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $co0u5.FocusInsideOnLoad), {
            entryPointReference: entryPointReference,
            setInitialFocusRef: setInitialFocusRef
        }))));
    }, [
        setContent,
        id,
        isOpen,
        entryPointProps,
        fallback,
        forcedReportErrorUFO,
        errorFallback,
        errorText,
        errorTitle,
        handleOpen,
        handleError,
        announce,
        cancelPendingAnnouncement,
        handleClose,
        handleSetInitialFocusRef,
        autoFocus,
        loadingCompleteText,
        loadingText
    ]);
    const triggerRef = (0, $9lAcD.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad,
        preloadOnFocus: preloadOnFocus
    });
    const popupTrigger = (0, $fsvuC.useCallback)((triggerProps)=>{
        const mergedRef = (0, $3NfiF.mergeRefs)([
            triggerRef,
            triggerProps.ref,
            triggerCloseRef,
            triggerFocusRef
        ]);
        return trigger({
            ...triggerProps,
            ref: mergedRef
        });
    }, [
        trigger,
        triggerRef,
        triggerCloseRef,
        triggerFocusRef
    ]);
    const popupContent = (0, $fsvuC.useCallback)(({ update: update, setInitialFocusRef: setInitialFocusRef })=>{
        updateRef.current = update;
        if ((0, $llCao.fg)('platform_dst-popup-trigger-initial-focus-ref')) popupSetInitialFocusRef.current = setInitialFocusRef;
        return content;
    }, [
        content
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $RG5NG.Popup), {
        ...popupProps,
        autoFocus: autoFocus,
        isOpen: isOpen,
        onClose: handleClose,
        trigger: popupTrigger,
        // Run time passes the setter for every role; the types hide it. Goes at the flag cleanup.
        content: popupContent
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $9EWGD.StatusAnnouncement), null, statusText));
}
$36716ada163ca52f$export$95d4acdbab2fc6ef.displayName = "PopupTrigger";

});
parcelRegister("l6CQt", function(module, exports) {
$parcel$export(module.exports, "ErrorContent", () => $15df98f4f00cd211$export$a9f602ed820d9782);
/* error-content.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fsvuC = parcelRequire("fsvuC");

var $lgvAm = parcelRequire("lgvAm");

var $6Pb6R = parcelRequire("6Pb6R");

var $jR7Rq = parcelRequire("jR7Rq");

var $d0SZF = parcelRequire("d0SZF");

var $daZXj = parcelRequire("daZXj");
const $15df98f4f00cd211$var$styles = {
    errorContainer: "_4ouGXIoaux _46hvQmkG2W _03SyCPkG2W _0xmtkokG2W _0LQT5EkG2W"
};
function $15df98f4f00cd211$export$a9f602ed820d9782({ errorText: errorText, title: title }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $jR7Rq.Flex), {
        justifyContent: "center",
        xcss: $15df98f4f00cd211$var$styles.errorContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $d0SZF.Stack), {
        space: "space.200"
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $jR7Rq.Flex), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Pb6R))), {
        label: "",
        color: "var(--ds-icon-danger, #C9372C)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $lgvAm.default), {
        size: "small",
        as: "h2"
    }, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $daZXj.Text), {
        as: "p"
    }, errorText)));
}
$15df98f4f00cd211$export$a9f602ed820d9782.displayName = "ErrorContent";

});

parcelRegister("9EWGD", function(module, exports) {
$parcel$export(module.exports, "StatusAnnouncement", () => $aadd364167cc2f8d$export$1144e05dc01c8ac);
/* status-announcement.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fsvuC = parcelRequire("fsvuC");

var $jRYjy = parcelRequire("jRYjy");

var $8e1dR = parcelRequire("8e1dR");
const $aadd364167cc2f8d$var$styles = {
    container: "_1mT5xdy1CL _2I62gzdnbC _3iC0zddnbC _39xV02dnbC _0jFU0VdnbC _1pp6NdYbGa"
};
function $aadd364167cc2f8d$export$1144e05dc01c8ac({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $jRYjy.Box), {
        xcss: $aadd364167cc2f8d$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $8e1dR.default), {
        role: "status"
    }, children));
}
$aadd364167cc2f8d$export$1144e05dc01c8ac.displayName = "StatusAnnouncement";

});

parcelRegister("7m3a1", function(module, exports) {
$parcel$export(module.exports, "useStatusAnnouncement", () => $7e130c247555d4a7$export$f2e04a9fdd1a3236);

var $fsvuC = parcelRequire("fsvuC");
function $7e130c247555d4a7$export$f2e04a9fdd1a3236() {
    const [statusText, setStatusText] = (0, $fsvuC.useState)('');
    const announceTimeout = (0, $fsvuC.useRef)(null);
    const clearTimeoutRef = (0, $fsvuC.useRef)(null);
    const cancelPendingAnnouncement = (0, $fsvuC.useCallback)(()=>{
        if (announceTimeout.current === null) return false;
        clearTimeout(announceTimeout.current);
        announceTimeout.current = null;
        return true;
    }, []);
    const cancelClear = (0, $fsvuC.useCallback)(()=>{
        if (clearTimeoutRef.current !== null) {
            clearTimeout(clearTimeoutRef.current);
            clearTimeoutRef.current = null;
        }
    }, []);
    const resetStatus = (0, $fsvuC.useCallback)(()=>{
        cancelPendingAnnouncement();
        cancelClear();
        setStatusText('');
    }, [
        cancelPendingAnnouncement,
        cancelClear
    ]);
    const announce = (0, $fsvuC.useCallback)(({ text: text, delay: delay = 0, clearAfter: clearAfter })=>{
        cancelPendingAnnouncement();
        cancelClear();
        const publish = ()=>{
            announceTimeout.current = null;
            setStatusText(text);
            if (clearAfter !== undefined) clearTimeoutRef.current = setTimeout(()=>{
                setStatusText('');
                clearTimeoutRef.current = null;
            }, clearAfter);
        };
        if (delay === 0) publish();
        else announceTimeout.current = setTimeout(publish, delay);
    }, [
        cancelPendingAnnouncement,
        cancelClear
    ]);
    (0, $fsvuC.useEffect)(()=>()=>{
            cancelPendingAnnouncement();
            cancelClear();
        }, [
        cancelPendingAnnouncement,
        cancelClear
    ]);
    return {
        statusText: statusText,
        announce: announce,
        cancelPendingAnnouncement: cancelPendingAnnouncement,
        resetStatus: resetStatus
    };
}

});

const $531256d3fe3ee2a2$export$73e31d6dbeb74c41 = 'Something went wrong while loading the popup content.';

parcelRegister("co0u5", function(module, exports) {
$parcel$export(module.exports, "FocusInsideOnLoad", () => $7d0d55dd080d4409$export$eb58c1f6b41ee511);

var $fsvuC = parcelRequire("fsvuC");

var $8c95s = parcelRequire("8c95s");

var $45Z1n = parcelRequire("45Z1n");
function $7d0d55dd080d4409$export$eb58c1f6b41ee511({ entryPointReference: entryPointReference, setInitialFocusRef: setInitialFocusRef }) {
    const handleLoad = (0, $fsvuC.useCallback)((container)=>{
        // Focus the first focusable element of the loaded experience, or the
        // popup itself when the experience has nothing focusable in it.
        const target = (0, $8c95s.getFirstFocusable)({
            container: container
        }) ?? container;
        // The popup focuses its initial target once, when it opens. If that has
        // not happened yet — because the entry point was already loaded — this
        // makes the popup focus the target instead of itself, avoiding focus
        // moving twice.
        setInitialFocusRef.current?.(target);
        target.focus();
    }, [
        setInitialFocusRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $45Z1n.FocusOnLoad), {
        entryPointReference: entryPointReference,
        onLoad: handleLoad
    });
}
$7d0d55dd080d4409$export$eb58c1f6b41ee511.displayName = "FocusInsideOnLoad";

});
parcelRegister("45Z1n", function(module, exports) {
$parcel$export(module.exports, "FocusOnLoad", () => $84e9edc44fd7bd88$export$192b96059b53397f);

var $fsvuC = parcelRequire("fsvuC");

var $9ppez = parcelRequire("9ppez");
function $84e9edc44fd7bd88$var$FocusOnLoadInner({ onLoad: onLoad }) {
    const anchorRef = (0, $fsvuC.useRef)(null);
    (0, $fsvuC.useEffect)(()=>{
        // `Popup` does not expose a ref to the element wrapping its content, so
        // it is resolved through this anchor, which renders as a sibling of the
        // loaded experience inside that element.
        const container = anchorRef.current?.parentElement;
        if (container) onLoad(container);
    }, [
        onLoad
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement("span", {
        ref: anchorRef,
        hidden: true
    });
}
$84e9edc44fd7bd88$var$FocusOnLoadInner.displayName = "FocusOnLoadInner";
function $84e9edc44fd7bd88$export$192b96059b53397f({ entryPointReference: entryPointReference, onLoad: onLoad }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $9ppez.WaitForEntryPointLoad), {
        entryPointReference: entryPointReference
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement($84e9edc44fd7bd88$var$FocusOnLoadInner, {
        onLoad: onLoad
    }));
}
$84e9edc44fd7bd88$export$192b96059b53397f.displayName = "FocusOnLoad";

});


parcelRegister("iiIie", function(module, exports) {
$parcel$export(module.exports, "FocusOnContainerOnLoad", () => $92cfe536c973988c$export$82324a1aa77ecbcc);

var $fsvuC = parcelRequire("fsvuC");

var $45Z1n = parcelRequire("45Z1n");
function $92cfe536c973988c$export$82324a1aa77ecbcc({ entryPointReference: entryPointReference, setInitialFocusRef: setInitialFocusRef }) {
    const handleLoad = (0, $fsvuC.useCallback)((container)=>{
        setInitialFocusRef.current?.(container);
        container.focus();
    }, [
        setInitialFocusRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $45Z1n.FocusOnLoad), {
        entryPointReference: entryPointReference,
        onLoad: handleLoad
    });
}
$92cfe536c973988c$export$82324a1aa77ecbcc.displayName = "FocusOnContainerOnLoad";

});

parcelRegister("Jja7C", function(module, exports) {
$parcel$export(module.exports, "Loading", () => $2aeeb65e6dfa78b3$export$669f6ea7d267feaf);

var $fsvuC = parcelRequire("fsvuC");

var $llCao = parcelRequire("llCao");

var $gP7u8 = parcelRequire("gP7u8");

var $9orrx = parcelRequire("9orrx");

var $9cT91 = parcelRequire("9cT91");

var $cNFUK = parcelRequire("cNFUK");
const $2aeeb65e6dfa78b3$var$spinnerContainerStyles = (0, $9orrx.xcss)({
    display: 'flex',
    minWidth: '160px',
    padding: 'space.250',
    justifyContent: 'center'
});
function $2aeeb65e6dfa78b3$export$669f6ea7d267feaf({ loadingText: loadingText }) {
    if ((0, $llCao.fg)('platform_dst-accessible-popup-loading')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $gP7u8.Box), {
        xcss: $2aeeb65e6dfa78b3$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $cNFUK.LoadingContent), {
        loadingText: loadingText ?? 'Loading popup...',
        size: "small"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $9cT91.default), null);
}
$2aeeb65e6dfa78b3$export$669f6ea7d267feaf.displayName = "Loading";

});

parcelRegister("6te8C", function(module, exports) {
$parcel$export(module.exports, "useClickToCloseRef", () => $a6dd30beb04bb20e$export$46ec6629f411921d);

var $fsvuC = parcelRequire("fsvuC");
function $a6dd30beb04bb20e$export$46ec6629f411921d({ isOpen: isOpen, handleClose: handleClose }) {
    const ref = (0, $fsvuC.useRef)(null);
    (0, $fsvuC.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const clickListener = ()=>{
            if (isOpen) handleClose(null);
        };
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('click', clickListener);
        return ()=>{
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            el.removeEventListener('click', clickListener);
        };
    }, [
        isOpen,
        handleClose
    ]);
    return ref;
}

});


parcelRegister("9qemp", function(module, exports) {
$parcel$export(module.exports, "LoomIcon", () => $926358163dbd421b$export$8d789f76fde3e05);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::30c7e77d0c70a3a1f66632de11893604>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $2IsXX = parcelRequire("2IsXX");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $926358163dbd421b$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302"/>
</svg>
`;
function $926358163dbd421b$export$8d789f76fde3e05({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Loom', testId: testId }) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $2IsXX.IconWrapper), {
        svg: $926358163dbd421b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}
$926358163dbd421b$export$8d789f76fde3e05.displayName = "LoomIcon";

});

parcelRegister("lu0Rs", function(module, exports) {
$parcel$export(module.exports, "generateTheme", () => $c09c98899d94f474$export$2e4ecffaca289a18);

var $6OtEx = parcelRequire("6OtEx");

var $5hh53 = parcelRequire("5hh53");

var $5PHxh = parcelRequire("5PHxh");

var $e03wm = parcelRequire("e03wm");

var $6iGq8 = parcelRequire("6iGq8");

var $8WZlz = parcelRequire("8WZlz");
const $c09c98899d94f474$var$generateOpacityValue = (color)=>color === '#000000' ? 0.3 : 0.6;
const $c09c98899d94f474$var$generateButtonCSSStates = (colors, buttonType)=>{
    const { backgroundColor: backgroundColor, color: color, highlightColor: highlightColor } = colors;
    // Add less opacity for white text so it is still legible.
    const opacityValue = $c09c98899d94f474$var$generateOpacityValue(color);
    const isCreateButton = buttonType === 'create';
    return {
        active: {
            backgroundColor: isCreateButton ? (0, $8WZlz.hexToRGBA)(backgroundColor, 0.65) : (0, $6iGq8.getContrastColor)(0.3, opacityValue, backgroundColor),
            boxShadow: (0, $e03wm.getBoxShadow)('transparent'),
            color: color
        },
        default: {
            backgroundColor: backgroundColor,
            boxShadow: (0, $e03wm.getBoxShadow)('transparent'),
            color: color
        },
        focus: {
            boxShadow: 'none',
            color: color,
            backgroundColor: backgroundColor
        },
        hover: {
            backgroundColor: isCreateButton ? (0, $8WZlz.hexToRGBA)(backgroundColor, 0.8) : (0, $6iGq8.getContrastColor)(0.1, opacityValue, backgroundColor),
            boxShadow: (0, $e03wm.getBoxShadow)('transparent'),
            color: color
        },
        selected: {
            color: color,
            backgroundColor: (0, $6iGq8.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $e03wm.getBoxShadow)('transparent')
        },
        selectedHover: {
            color: color,
            backgroundColor: (0, $6iGq8.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $e03wm.getBoxShadow)('transparent')
        }
    };
};
const $c09c98899d94f474$var$generateCreateButtonColors = (_themeBackground, themeHighlight)=>({
        backgroundColor: themeHighlight,
        color: (0, $5PHxh.generateTextColor)(themeHighlight),
        highlightColor: themeHighlight
    });
const $c09c98899d94f474$export$2e4ecffaca289a18 = (themeColors)=>{
    const { backgroundColor: backgroundColor, highlightColor: highlightColor, name: name } = themeColors;
    const color = (0, $5PHxh.generateTextColor)(backgroundColor);
    const colors = {
        ...themeColors,
        color: color
    };
    if (name === (0, $6OtEx.DEFAULT_THEME_NAME)) return 0, $5hh53.defaultThemeBrandRefresh;
    return {
        mode: {
            create: $c09c98899d94f474$var$generateButtonCSSStates($c09c98899d94f474$var$generateCreateButtonColors(backgroundColor, highlightColor), 'create'),
            iconButton: $c09c98899d94f474$var$generateButtonCSSStates(colors, 'iconButton'),
            primaryButton: $c09c98899d94f474$var$generateButtonCSSStates(colors, 'primaryButton'),
            navigation: {
                backgroundColor: backgroundColor,
                color: color
            },
            productHome: {
                color: color,
                iconColor: color,
                textColor: color,
                backgroundColor: highlightColor,
                borderRight: `${"var(--ds-border-width, 1px)"} solid ${(0, $8WZlz.hexToRGBA)(color, 0.5)}`
            },
            search: {
                default: {
                    backgroundColor: backgroundColor,
                    color: color,
                    borderColor: (0, $8WZlz.hexToRGBA)(color, 0.5)
                },
                focus: {
                    borderColor: (0, $8WZlz.hexToRGBA)(highlightColor, 0.8),
                    boxShadow: (0, $e03wm.getBoxShadow)((0, $8WZlz.hexToRGBA)(highlightColor, 0.5))
                },
                hover: {
                    backgroundColor: (0, $6iGq8.getContrastColor)(0.1, $c09c98899d94f474$var$generateOpacityValue(color), backgroundColor),
                    color: color
                }
            },
            skeleton: {
                backgroundColor: color,
                opacity: 0.08
            }
        }
    };
};

});
parcelRegister("6OtEx", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_THEME_NAME", () => $19fe887583892de8$export$2491e13b198e597d);
$parcel$export(module.exports, "default", () => $19fe887583892de8$export$2e2bcd8739ae039);
const $19fe887583892de8$var$defaultTheme = {
    mode: {
        create: {
            active: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold-pressed, #144794)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold, #1868DB)",
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold-hovered, #1558BC)",
                boxShadow: ''
            },
            selected: {
                color: '',
                backgroundColor: '',
                boxShadow: ''
            }
        },
        iconButton: {
            active: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                boxShadow: ''
            },
            selectedHover: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)",
                boxShadow: ''
            }
        },
        navigation: {
            backgroundColor: "var(--ds-surface, #FFFFFF)",
            color: "var(--ds-text-subtlest, #6B6E76)"
        },
        productHome: {
            backgroundColor: "var(--ds-text-brand, #1868DB)",
            color: "var(--ds-text, #292A2E)",
            borderRight: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
            // TODO: replace with token after brand refresh
            iconColor: '#357DE8',
            textColor: "var(--ds-text, #292A2E)"
        },
        primaryButton: {
            active: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                boxShadow: '',
                borderColor: "var(--ds-border-selected, #1868DB)"
            },
            selectedHover: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)",
                boxShadow: '',
                borderColor: "var(--ds-border-selected, #1868DB)"
            }
        },
        search: {
            default: {
                backgroundColor: "var(--ds-background-input, #FFFFFF)",
                color: "var(--ds-text-subtlest, #6B6E76)",
                borderColor: "var(--ds-border-input, #8C8F97)"
            },
            focus: {
                borderColor: "var(--ds-border-focused, #4688EC)"
            },
            hover: {
                backgroundColor: "var(--ds-background-input-hovered, #F8F8F8)"
            }
        },
        skeleton: {
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            opacity: 1
        }
    }
};
// Create deep copy of defaultTheme
const $19fe887583892de8$var$defaultThemeCopy = JSON.parse(JSON.stringify($19fe887583892de8$var$defaultTheme));
// Update iconColor and textColor in defaultThemeBrandRefresh
$19fe887583892de8$var$defaultThemeCopy.mode.productHome.iconColor = undefined;
$19fe887583892de8$var$defaultThemeCopy.mode.productHome.textColor = undefined;
const $19fe887583892de8$export$2491e13b198e597d = 'atlassian';
var $19fe887583892de8$export$2e2bcd8739ae039 = $19fe887583892de8$var$defaultTheme;

});

parcelRegister("5hh53", function(module, exports) {
$parcel$export(module.exports, "defaultThemeBrandRefresh", () => $3b253b5e8c026229$export$77823bc9863eaa03);

var $6OtEx = parcelRequire("6OtEx");
const $3b253b5e8c026229$var$defaultThemeCopy = JSON.parse(JSON.stringify((0, $6OtEx.default)));
const $3b253b5e8c026229$export$77823bc9863eaa03 = $3b253b5e8c026229$var$defaultThemeCopy;

});

parcelRegister("5PHxh", function(module, exports) {
$parcel$export(module.exports, "generateTextColor", () => $ba947b4922e4a4d3$export$10a10e7cd1193377);

var $479gE = parcelRequire("479gE");

var $8BBLg = parcelRequire("8BBLg");
const $ba947b4922e4a4d3$export$10a10e7cd1193377 = (color)=>{
    const converted = (0, $8BBLg.convertHexShorthand)(color);
    return (0, $479gE.default).contrastRatio(converted).hex;
};

});
parcelRegister("8BBLg", function(module, exports) {
$parcel$export(module.exports, "convertHexShorthand", () => $3a271f0de19801ef$export$db8d2130677f868c);
const $3a271f0de19801ef$var$hex = '[a-z0-9]';
const $3a271f0de19801ef$var$shortHandHexColorPattern = new RegExp(`#(${$3a271f0de19801ef$var$hex})(${$3a271f0de19801ef$var$hex})(${$3a271f0de19801ef$var$hex})`, 'i');
const $3a271f0de19801ef$var$repeat = (str, times)=>[
        ...Array(times)
    ].map(()=>str).join('');
const $3a271f0de19801ef$var$isShortHexColor = (color)=>color && color.length === 4;
const $3a271f0de19801ef$var$completeHexColor = (colors)=>{
    const hex = colors.map((color)=>$3a271f0de19801ef$var$repeat(color, 2)).join('');
    return `#${hex}`;
};
const $3a271f0de19801ef$var$completeTriplet = (colors)=>`#${$3a271f0de19801ef$var$repeat(colors[1], 6)}`;
const $3a271f0de19801ef$var$isTriplet = (colors)=>colors[0] === colors[1] && colors[1] === colors[2];
const $3a271f0de19801ef$export$db8d2130677f868c = (color)=>{
    if ($3a271f0de19801ef$var$isShortHexColor(color)) {
        // when color = '#ccc', matches is structured as ['#ccc', 'c', 'c', 'c', ...]
        const matches = color.match($3a271f0de19801ef$var$shortHandHexColorPattern);
        if (matches) {
            const colors = matches.slice(1, 4);
            if ($3a271f0de19801ef$var$isTriplet(colors)) return $3a271f0de19801ef$var$completeTriplet(colors);
            else return $3a271f0de19801ef$var$completeHexColor(colors);
        }
    }
    // return the color as is when it's not hex color shorthand
    return color;
};

});


parcelRegister("e03wm", function(module, exports) {
$parcel$export(module.exports, "getBoxShadow", () => $bdff393aff4ce250$export$bba5a971afe05444);
const $bdff393aff4ce250$export$bba5a971afe05444 = (color)=>`0 0 0 2px ${color}`;

});

parcelRegister("6iGq8", function(module, exports) {
$parcel$export(module.exports, "getContrastColor", () => $ce50fee3aafc17ec$export$77a1051494882576);

var $479gE = parcelRequire("479gE");

var $8WZlz = parcelRequire("8WZlz");
const $ce50fee3aafc17ec$export$77a1051494882576 = (contrastValue, opacityValue, color)=>(0, $8WZlz.hexToRGBA)((0, $479gE.default).contrast(contrastValue, color).hex, opacityValue);

});
parcelRegister("8WZlz", function(module, exports) {
$parcel$export(module.exports, "hexToRGBA", () => $a5329f3394cb0327$export$7229be6d7219ee6a);

var $479gE = parcelRequire("479gE");
const $a5329f3394cb0327$export$7229be6d7219ee6a = (hex, opacity = 1)=>{
    const rgba = {
        ...(0, $479gE.default).convert(hex).rgb,
        a: opacity
    };
    return `rgba(${Object.values(rgba).join(', ')})`;
};

});



parcelRegister("YIBUv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3aff96bcfcadf44a79300107c56beac1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0b68356b3f69919e$var$_react = $0b68356b3f69919e$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $0b68356b3f69919e$var$_iconNew = $0b68356b3f69919e$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $0b68356b3f69919e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsGraph".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/assets-graph
 * Usage guidance:
 * Reserved for representing Assets graph
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0b68356b3f69919e$var$AssetsGraphIcon = (props)=>/*#__PURE__*/ $0b68356b3f69919e$var$_react.default.createElement($0b68356b3f69919e$var$_iconNew.default, Object.assign({
        name: "AssetsGraphIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m12.78 4.28-1.833 1.832a3.5 3.5 0 0 1 0 3.774l1.833 1.834-1.06 1.06-1.833-1.833a3.5 3.5 0 0 1-3.775 0L4.28 12.78l-1.06-1.06 1.832-1.834a3.5 3.5 0 0 1 0-3.774L3.22 4.28l1.06-1.06 1.832 1.832a3.5 3.5 0 0 1 3.775 0l1.833-1.833zM9.414 6.586a2 2 0 1 0-2.828 2.827 2 2 0 0 0 2.828-2.827"/><path fill="currentcolor" d="M11.73.73a2.5 2.5 0 1 1 3.54 3.54A2.5 2.5 0 0 1 11.73.73m2.48 1.06A1 1 0 1 0 12.8 3.2a1 1 0 0 0 1.41-1.41m-2.48 9.94a2.5 2.5 0 1 1 3.54 3.54 2.5 2.5 0 0 1-3.54-3.53m2.48 1.06a1 1 0 1 0-1.41 1.42 1 1 0 0 0 1.41-1.41M.73.73a2.5 2.5 0 1 1 3.54 3.54A2.5 2.5 0 0 1 .73.73m2.48 1.06A1 1 0 1 0 1.8 3.21 1 1 0 0 0 3.21 1.8M.73 11.73a2.5 2.5 0 1 1 3.54 3.54 2.5 2.5 0 0 1-3.54-3.53m2.48 1.06a1 1 0 1 0-1.41 1.42 1 1 0 0 0 1.41-1.41"/>`
    }, props));
$0b68356b3f69919e$var$AssetsGraphIcon.displayName = 'AssetsGraphIcon';
var $0b68356b3f69919e$var$_default = module.exports.default = $0b68356b3f69919e$var$AssetsGraphIcon;

});

parcelRegister("eFDWt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::630f7862dea052120b01b06315f58212>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aae3e0b5caa1c9b1$var$_react = $aae3e0b5caa1c9b1$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $aae3e0b5caa1c9b1$var$_iconNew = $aae3e0b5caa1c9b1$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $aae3e0b5caa1c9b1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Spaces".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/spaces
 * Usage guidance:
 * Reserved for use for Jira Projects for now. This will replace the Jira rocket.
 * 
 * More context: Later, it will eventually replace the Confluence Spaces icon later when Jira Projects -> Jira Spaces. This is a planned phased rollout.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aae3e0b5caa1c9b1$var$SpacesIcon = (props)=>/*#__PURE__*/ $aae3e0b5caa1c9b1$var$_react.default.createElement($aae3e0b5caa1c9b1$var$_iconNew.default, Object.assign({
        name: "SpacesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.809 9.497A5.98 5.98 0 0 1 11 13.196a5.98 5.98 0 0 1-4.608.584 29.4 29.4 0 0 0 3.858-1.882 29.4 29.4 0 0 0 3.559-2.401"/><path fill="currentcolor" fill-rule="evenodd" d="M5 2.804a6 6 0 0 1 6.515.333c.859-.264 1.65-.424 2.308-.447.377-.013.751.017 1.083.126.338.111.678.32.888.685.354.613.152 1.296-.107 1.8-.276.538-.736 1.113-1.306 1.688q-.197.196-.413.396c-.444.413-.954.837-1.517 1.263a29 29 0 0 1-2.951 1.95 29 29 0 0 1-3.165 1.581c-.65.275-1.272.505-1.85.683h-.003q-.28.087-.548.158c-.783.206-1.511.318-2.116.288-.505-.024-1.114-.161-1.49-.63l-.052-.068-.07-.11-.07-.138a1.6 1.6 0 0 1-.078-.973c.071-.342.231-.68.431-1 .35-.56.883-1.164 1.541-1.776A6 6 0 0 1 5 2.804m-2.541 7.5a6 6 0 0 0-.698.878c-.147.235-.213.407-.236.516l-.004.046c.048.022.155.056.37.066.329.016.78-.036 1.343-.165a6 6 0 0 1-.775-1.342m8.429-5.756A4.502 4.502 0 0 0 3.52 8.435l.045.34a4.5 4.5 0 0 0 1.24 2.396C5.986 10.743 7.347 10.11 8.75 9.3s2.63-1.673 3.593-2.48a4.5 4.5 0 0 0-1.31-2.146zm2.987-.36c-.306.01-.68.066-1.111.165q.233.306.432.648.196.341.342.695c.394-.424.665-.789.816-1.081.098-.192.121-.302.127-.355l-.041-.018c-.106-.035-.288-.063-.565-.054" clip-rule="evenodd"/>`
    }, props));
$aae3e0b5caa1c9b1$var$SpacesIcon.displayName = 'SpacesIcon';
var $aae3e0b5caa1c9b1$var$_default = module.exports.default = $aae3e0b5caa1c9b1$var$SpacesIcon;

});

parcelRegister("enE1l", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2bbe3107b8dcb4caf83567322ed86022>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a78241f6f5f7d0ff$var$_react = $a78241f6f5f7d0ff$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $a78241f6f5f7d0ff$var$_iconNew = $a78241f6f5f7d0ff$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $a78241f6f5f7d0ff$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sunset".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/sunset
 * Usage guidance:
 * Farewell feed in hello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a78241f6f5f7d0ff$var$SunsetIcon = (props)=>/*#__PURE__*/ $a78241f6f5f7d0ff$var$_react.default.createElement($a78241f6f5f7d0ff$var$_iconNew.default, Object.assign({
        name: "SunsetIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v2h-1.5V1zm3 2.845 1.414-1.415 1.06 1.061-1.413 1.414zm-8.586 1.07L1.75 3.5l1.06-1.06 1.415 1.414zM8 6a3 3 0 0 0-3 3H3.5a4.5 4.5 0 0 1 9 0H11a3 3 0 0 0-3-3M2 9H0V7.5h2zm14 0h-2V7.5h2zm-1 3H1v-1.5h14zm-4.5 1.5V15h-5v-1.5z" clip-rule="evenodd"/>`
    }, props));
$a78241f6f5f7d0ff$var$SunsetIcon.displayName = 'SunsetIcon';
var $a78241f6f5f7d0ff$var$_default = module.exports.default = $a78241f6f5f7d0ff$var$SunsetIcon;

});

parcelRegister("fbSwX", function(module, exports) {
$parcel$export(module.exports, "GoalsIcon", () => $8533a16995ad639e$export$9eb74917ea768ed4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c4362ec97402bb58da4aa4719b522f90>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $2IsXX = parcelRequire("2IsXX");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $8533a16995ad639e$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M14.352 12a2.352 2.352 0 1 1-4.704 0 2.352 2.352 0 0 1 4.704 0"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M12 18.563a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125M16.102 12a4.102 4.102 0 1 1-8.204 0 4.102 4.102 0 0 1 8.204 0" clip-rule="evenodd"/>
</svg>
`;
function $8533a16995ad639e$export$9eb74917ea768ed4({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Goals', testId: testId }) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $2IsXX.IconWrapper), {
        svg: $8533a16995ad639e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}
$8533a16995ad639e$export$9eb74917ea768ed4.displayName = "GoalsIcon";

});

parcelRegister("7WsTK", function(module, exports) {
$parcel$export(module.exports, "OpsgenieIcon", () => $23fe4644514b32be$export$eeccc49dc7a12d9f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97b6247692aeac56aeb21bd6a8750acc>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $2IsXX = parcelRequire("2IsXX");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $23fe4644514b32be$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M12.696 19.45c-.49.361-.749.336-1.24-.026-2.375-1.704-4.57-3.641-6.042-5.655-.155-.207-.078-.49.155-.62l2.685-1.678q.35-.233.62.077c1.033 1.188 2.04 2.35 3.202 3.176 1.162-.826 2.17-1.988 3.202-3.176q.272-.31.62-.078l2.686 1.679c.232.13.31.413.155.62-1.472 2.014-3.667 3.95-6.043 5.68m-.62-7.411c2.118 0 3.874-1.73 3.874-3.848s-1.756-3.9-3.874-3.9c-2.117 0-3.873 1.757-3.873 3.9s1.704 3.848 3.873 3.848"/>
</svg>
`;
function $23fe4644514b32be$export$eeccc49dc7a12d9f({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Opsgenie', testId: testId }) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $2IsXX.IconWrapper), {
        svg: $23fe4644514b32be$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}
$23fe4644514b32be$export$eeccc49dc7a12d9f.displayName = "OpsgenieIcon";

});

parcelRegister("kRIKT", function(module, exports) {
$parcel$export(module.exports, "TeamsIcon", () => $0dc6f02688d7d65f$export$1bcbc9c337da86da);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7f5210074a380dcd268126674dc826a2>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $2IsXX = parcelRequire("2IsXX");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $0dc6f02688d7d65f$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M8.06 11.25a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m7.88 0a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m.17 1.31a2.89 2.89 0 0 1 2.89 2.9V18h-7.22l1.66-3.67a2.89 2.89 0 0 1 2.67-1.77M5 15.63V18h4.81l1.31-2.81a2.63 2.63 0 0 0-2.62-2.63h-.44A3.06 3.06 0 0 0 5 15.63"/>
</svg>
`;
function $0dc6f02688d7d65f$export$1bcbc9c337da86da({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Teams', testId: testId }) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $2IsXX.IconWrapper), {
        svg: $0dc6f02688d7d65f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}
$0dc6f02688d7d65f$export$1bcbc9c337da86da.displayName = "TeamsIcon";

});

parcelRegister("gK8sv", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryIcon", () => $9bae792bef25e0f9$export$21bfbeb62fdcce8d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29e2c6af008db660c9f38b0bce4ff4cc>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $2IsXX = parcelRequire("2IsXX");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $9bae792bef25e0f9$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#c97cf4)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M13.467 4.882a9.47 9.47 0 0 0 5.422 0c.159-.035.265.07.23.229-.513 1.85-.513 3.558 0 5.408.035.14-.072.264-.23.211a10.1 10.1 0 0 0-5.422 0c-.142.053-.265-.07-.212-.211.476-1.85.476-3.559 0-5.408-.053-.159.07-.264.212-.23m.724 6.553v.3c0 1.39-.972 2.412-2.173 2.412a2.153 2.153 0 0 1-2.154-2.166c0-1.198.971-2.15 2.331-2.15h.353V5.62c-.176-.017-.353-.017-.53-.017a6.387 6.387 0 0 0-6.393 6.394 6.37 6.37 0 0 0 6.393 6.377c3.533 0 6.411-2.854 6.411-6.377v-.563z"/>
</svg>
`;
const $9bae792bef25e0f9$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-5.981 5.604a6.387 6.387 0 0 0-6.394 6.394 6.373 6.373 0 0 0 6.394 6.377c3.532 0 6.41-2.854 6.41-6.377v-.563H14.19v.3c0 1.39-.97 2.412-2.171 2.413a2.154 2.154 0 0 1-2.156-2.168c0-1.197.973-2.148 2.332-2.148h.353v-4.21c-.177-.018-.353-.018-.53-.018m6.87-.722a9.47 9.47 0 0 1-5.422 0c-.141-.035-.265.07-.212.228.477 1.85.477 3.559 0 5.409-.053.14.07.264.212.211a10.1 10.1 0 0 1 5.422 0c.159.053.265-.07.23-.211-.513-1.85-.513-3.56 0-5.409.034-.158-.072-.263-.23-.228"/>
</svg>
`;
function $9bae792bef25e0f9$export$21bfbeb62fdcce8d({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Jira Product Discovery', testId: testId }) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $2IsXX.IconWrapper), {
        svg: $9bae792bef25e0f9$var$svg,
        customThemeSvg: $9bae792bef25e0f9$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}
$9bae792bef25e0f9$export$21bfbeb62fdcce8d.displayName = "JiraProductDiscoveryIcon";

});

parcelRegister("eBgj8", function(module, exports) {
$parcel$export(module.exports, "default", () => $4de8c5f0635ab312$export$2e2bcd8739ae039);
/* skeleton.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");
const $4de8c5f0635ab312$var$bgColorCssVar = '--avatar-skeleton-background-color';
const $4de8c5f0635ab312$var$styles = {
    root: "_0bjKvDaaQb _2V7sgO2M4S _3hxITi6wH8 _3vBAKHs4Fm _3iDTPbvbI6 _0KLXruNaal _1YKVNs4ERJ",
    square: "_0bjKvD0O7w",
    hexagon: "_1uo2ZfTcEg",
    strongOpacity: "_1YKVNsy8LG"
};
const $4de8c5f0635ab312$var$sizeStyles = {
    xxsmall: "_39xV02ey7F _0jFU0Vey7F",
    xsmall: "_39xV02ey7F _0jFU0Vey7F",
    UNSAFE_xsmall: "_39xV02SPN1 _0jFU0VSPN1",
    small: "_39xV02oWWg _0jFU0VoWWg",
    medium: "_39xV02Uofl _0jFU0VUofl",
    large: "_39xV02UF4f _0jFU0VUF4f",
    xlarge: "_39xV02JgOI _0jFU0VJgOI",
    xxlarge: "_39xV02NNui _0jFU0VNNui"
};
/**
 * __Skeleton__
 *
 * A skeleton is the loading state for the avatar component.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-skeleton/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-skeleton/code)
 */ const $4de8c5f0635ab312$var$Skeleton = ({ size: size, appearance: appearance = 'circle', color: color, weight: weight })=>{
    const avatarSize = size ?? 'medium';
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        style: {
            [$4de8c5f0635ab312$var$bgColorCssVar]: color ?? 'currentColor'
        },
        className: (0, $gJ6nT.default)([
            $4de8c5f0635ab312$var$styles.root,
            $4de8c5f0635ab312$var$sizeStyles[avatarSize],
            appearance === 'square' && $4de8c5f0635ab312$var$styles.square,
            appearance === 'hexagon' && $4de8c5f0635ab312$var$styles.hexagon,
            weight === 'strong' && $4de8c5f0635ab312$var$styles.strongOpacity
        ])
    });
};
$4de8c5f0635ab312$var$Skeleton.displayName = "Skeleton";
var $4de8c5f0635ab312$export$2e2bcd8739ae039 = $4de8c5f0635ab312$var$Skeleton;

});

parcelRegister("2QCED", function(module, exports) {
$parcel$export(module.exports, "useOverflowStatus", () => $23bd3db4deb30539$export$3fcfc71fab3314f2);

var $fsvuC = parcelRequire("fsvuC");

var $dJhoH = parcelRequire("dJhoH");
const $23bd3db4deb30539$export$3fcfc71fab3314f2 = ()=>(0, $fsvuC.useContext)((0, $dJhoH.OverflowContext));

});
parcelRegister("dJhoH", function(module, exports) {
$parcel$export(module.exports, "OverflowContext", () => $da1926255bafadd1$export$79f16dd643143c25);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $fsvuC = parcelRequire("fsvuC");

var $9Tkwf = parcelRequire("9Tkwf");
const $da1926255bafadd1$export$79f16dd643143c25 = /*#__PURE__*/ (0, $fsvuC.createContext)({
    isVisible: true,
    openOverflowMenu: (0, $9Tkwf.default),
    closeOverflowMenu: (0, $9Tkwf.default)
});

});


parcelRegister("bgy9E", function(module, exports) {
$parcel$export(module.exports, "AppSwitcher", () => $6aaf9d589a301cfd$export$9923361bd43fa030);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $4Cn0v = parcelRequire("4Cn0v");

var $llCao = parcelRequire("llCao");

var $cBAtE = parcelRequire("cBAtE");
const $6aaf9d589a301cfd$var$toggleButtonTooltipOptions = {
    // We're disabling pointer events on the tooltip to prevent it from blocking mouse events, so that the side nav flyout stays open
    // when moving the mouse from the top bar to the side nav.
    ignoreTooltipPointerEvents: true
};
const $6aaf9d589a301cfd$export$9923361bd43fa030 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ label: label, icon: icon, onClick: onClick, onMouseEnter: onMouseEnter, interactionName: interactionName, isSelected: isSelected, testId: testId, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup }, ref)=>{
    const pickedAppSwitcherIcon = (0, $llCao.fg)('platform_dst_ads_appswitcher_improvements') ? icon ?? (0, (/*@__PURE__*/$parcel$interopDefault($4Cn0v))) : (0, (/*@__PURE__*/$parcel$interopDefault($4Cn0v)));
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $cBAtE.IconButton), {
        ref: ref,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        icon: pickedAppSwitcherIcon,
        label: label,
        appearance: "subtle",
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        interactionName: interactionName,
        isTooltipDisabled: false,
        tooltip: $6aaf9d589a301cfd$var$toggleButtonTooltipOptions,
        isSelected: isSelected,
        testId: testId
    });
});

});

parcelRegister("kKMaM", function(module, exports) {
$parcel$export(module.exports, "SpotlightPrimaryLink", () => $0ffae6dffc4977d9$export$82ba9bc832fb64);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $dwUnm = parcelRequire("dwUnm");

var $cGW6W = parcelRequire("cGW6W");

var $daZXj = parcelRequire("daZXj");
const $0ffae6dffc4977d9$var$styles = {
    root: "_0bjKvDKxmn _24h04i2Njc _3iDTPbQ4SZ _0hPCNLDIqT _1UtDYze5R3",
    outline: "_00uqCYyL8i _3xtjKNYbGa _0H9qDF6wH8 _3hxITi6wH8 _2V7sgONvrM _3vBAKHFIvx _2Y7lL4gVvo _0KLXrugozt _0DCa9DyL8i _3932vvYbGa _02cRtH6wH8 _1eOmH6kTlo _3WzCGiyL8i _0NqVRtYbGa _3BKYwu6wH8 _3gzVzLVbka",
    primary: "_00uqCYyL8i _3xtjKNYbGa _0H9qDF6wH8 _3hxITi6wH8 _2V7sgONvrM _3vBAKHJrlu _2Y7lL4gVvo _0KLXruDM2k _0DCa9DyL8i _3932vvYbGa _02cRtH6wH8 _1eOmH6hmrj _3WzCGiyL8i _0NqVRtYbGa _3BKYwu6wH8 _3gzVzLczkD"
};
const $0ffae6dffc4977d9$export$82ba9bc832fb64 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ 'aria-label': ariaLabel, onClick: onClick, children: children, testId: testId, appearance: appearance = 'outline', href: href, target: target, rel: rel }, ref)=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $cGW6W.Anchor), {
        "aria-label": ariaLabel,
        ref: ref,
        testId: testId,
        xcss: (0, $dwUnm.cx)($0ffae6dffc4977d9$var$styles.root, $0ffae6dffc4977d9$var$styles[appearance]),
        href: href,
        target: target,
        rel: rel,
        onClick: onClick ? (e, _analyticsEvent)=>onClick(e) : undefined,
        componentName: "SpotlightPrimaryLink",
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $daZXj.Text), {
            as: "span",
            children: children
        })
    }));

});

parcelRegister("daQNA", function(module, exports) {
$parcel$export(module.exports, "SpotlightSecondaryLink", () => $d036283bcac9533f$export$797d360648cfd970);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $cGW6W = parcelRequire("cGW6W");

var $daZXj = parcelRequire("daZXj");
const $d036283bcac9533f$var$styles = {
    root: "_0bjKvDKxmn _00uqCYyL8i _3xtjKNYbGa _0H9qDF6wH8 _2Y7lL4gVvo _4c065UFQfX _24h04i2Njc _3iDTPbQ4SZ _0hPCNLDIqT _1UtDYze5R3 _0KLXrugozt _0DCa9DyL8i _3932vvYbGa _02cRtH6wH8 _1eOmH6kTlo _3WzCGiyL8i _0NqVRtYbGa _3BKYwu6wH8 _3gzVzLVbka"
};
const $d036283bcac9533f$export$797d360648cfd970 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ 'aria-label': ariaLabel, onClick: onClick, children: children, testId: testId, href: href, target: target, rel: rel }, ref)=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $cGW6W.Anchor), {
        "aria-label": ariaLabel,
        ref: ref,
        testId: testId,
        xcss: $d036283bcac9533f$var$styles.root,
        href: href,
        target: target,
        rel: rel,
        onClick: onClick ? (e, _analyticsEvent)=>onClick(e) : undefined,
        componentName: "SpotlightSecondaryLink",
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $daZXj.Text), {
            as: "span",
            children: children
        })
    }));

});

parcelRegister("kLACW", function(module, exports) {
$parcel$export(module.exports, "Aside", () => $009dae0f28d7de4f$export$ac3bdfe4cb17f64e);
/* aside.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $aLJHG = parcelRequire("aLJHG");

var $llCao = parcelRequire("llCao");

var $ekfU9 = parcelRequire("ekfU9");

var $eVEPg = parcelRequire("eVEPg");

var $kqgCs = parcelRequire("kqgCs");

var $c04Nx = parcelRequire("c04Nx");

var $cRpV8 = parcelRequire("cRpV8");

var $a1xUa = parcelRequire("a1xUa");

var $1tX1p = parcelRequire("1tX1p");

var $1swgG = parcelRequire("1swgG");
const $009dae0f28d7de4f$var$panelSplitterResizingVar = '--n_asdRsz';
/**
 * The bounds for Aside and Panel are purposely set to support the current usage in Jira.
 *
 * Jira sets the slot's width to `0px` when there is no active content to display in it.
 *   - This means the min width needs to support `0px`.
 * The Conversation Assistant component in Jira (rendered in a nav3 RightSidebar, or a nav4 Aside) has a custom resizing
 * implementation, which has a maximum width of `50vw`.
 *   - This means the max width needs to support `50vw`.
 *
 * This is not the final implementation and will be updated once Jira's usage has been fixed.
 * Ticket to track this is: https://jplat.atlassian.net/browse/BLU-3951
 *
 * We're using two different bounds for each slot here, to support the `0px` min width when programatically set using the
 * `defaultWidth` prop, and another one that is used when resizing the slots which has a sensible min width.
 */ const $009dae0f28d7de4f$var$asideWidthSlotBounds = {
    min: '0px',
    max: '50vw'
};
const $009dae0f28d7de4f$var$asideWidthResizeBounds = {
    min: '120px',
    max: '50vw'
};
function $009dae0f28d7de4f$var$getResizeBounds() {
    return $009dae0f28d7de4f$var$asideWidthResizeBounds;
}
const $009dae0f28d7de4f$var$styles = {
    root: "_1xC2CJjgYz _24h04i2Njc _1mT5xdRAKS _15X6Mhduac _1xHhlhF05b",
    inner: "_4bt5LAIZbP _2WAcuGIZbP _2I62gzgiHs _0jFU0VN91d _2MwU8rlOMI _2DiRUzHE3j"
};
const $009dae0f28d7de4f$var$fallbackDefaultWidth = 330;
function $009dae0f28d7de4f$export$ac3bdfe4cb17f64e({ children: children, xcss: xcss, defaultWidth: defaultWidthProp = $009dae0f28d7de4f$var$fallbackDefaultWidth, label: label = 'Aside', skipLinkLabel: skipLinkLabel = label, testId: testId, id: providedId }) {
    const dangerouslyHoistSlotSizes = (0, $fsvuC.useContext)((0, $c04Nx.DangerouslyHoistSlotSizes));
    const id = (0, $a1xUa.useLayoutId)({
        providedId: providedId
    });
    const defaultWidth = (0, $1swgG.useSafeDefaultWidth)({
        defaultWidthProp: defaultWidthProp,
        fallbackDefaultWidth: $009dae0f28d7de4f$var$fallbackDefaultWidth,
        slotName: 'Aside'
    });
    /**
   * Don't show the skip link if the slot has 0 width.
   *
   * Remove `isHidden` usage after https://jplat.atlassian.net/browse/BLU-3951
   *
   * TODO: when cleaning up 'platform_dst_nav4_skip_link_a11y_1' remove this call entirely
   */ (0, $ekfU9.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: defaultWidth === 0 || (0, $llCao.fg)('platform_dst_nav4_skip_link_a11y_1')
    });
    const ref = (0, $fsvuC.useRef)(null);
    const [width, setWidth] = (0, $fsvuC.useState)(defaultWidth);
    // Used to track the previous value of the `defaultWidth` prop, for logging dev warnings when it changes.
    const previousWidthProp = (0, $aLJHG.default)(defaultWidth);
    /**
   * Updates the width state based on changes to `defaultWidth`.
   * This is temporary and needed to support the current usage in Jira, and will be removed once it is no longer needed.
   * https://jplat.atlassian.net/browse/BLU-3951
   */ (0, $fsvuC.useEffect)(()=>{
        setWidth(defaultWidth);
    }, [
        defaultWidth
    ]);
    // Putting the warning in a separate effect to avoid adding `previousWidthProp` as an effect dependency when updating width.
    (0, $fsvuC.useEffect)(()=>{}, [
        defaultWidth,
        previousWidthProp
    ]);
    const asideVariableWidth = `clamp(${$009dae0f28d7de4f$var$asideWidthSlotBounds.min}, ${width}px, ${$009dae0f28d7de4f$var$asideWidthSlotBounds.max})`;
    (0, $1tX1p.useResizingWidthCssVarOnRootElement)({
        isEnabled: dangerouslyHoistSlotSizes,
        panelId: (0, $eVEPg.asidePanelSplitterId),
        cssVar: $009dae0f28d7de4f$var$panelSplitterResizingVar
    });
    return /*#__PURE__*/ (0, $5chsV.jsxs)("aside", {
        id: id,
        "data-layout-slot": true,
        "aria-label": label,
        className: (0, $gJ6nT.default)([
            $009dae0f28d7de4f$var$styles.root,
            xcss
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
        style: {
            [(0, $eVEPg.asideVar)]: asideVariableWidth
        },
        "data-testid": testId,
        ref: ref,
        children: [
            dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $kqgCs.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $eVEPg.UNSAFE_asideLayoutVar),
                value: "0px",
                mediaQuery: '@media (min-width: 64rem)',
                responsiveValue: `var(${$009dae0f28d7de4f$var$panelSplitterResizingVar}, ${asideVariableWidth})`
            }),
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $cRpV8.PanelSplitterProvider), {
                panelId: (0, $eVEPg.asidePanelSplitterId),
                panelRef: ref,
                panelWidth: width,
                onCompleteResize: setWidth,
                getResizeBounds: $009dae0f28d7de4f$var$getResizeBounds,
                resizingCssVar: $009dae0f28d7de4f$var$panelSplitterResizingVar,
                position: "start",
                children: /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                    "data-testid": testId ? `${testId}--inner` : undefined,
                    className: (0, $gJ6nT.default)([
                        $009dae0f28d7de4f$var$styles.inner
                    ]),
                    children: children
                })
            })
        ]
    });
}
$009dae0f28d7de4f$export$ac3bdfe4cb17f64e.displayName = "Aside";

});

parcelRegister("igvTL", function(module, exports) {
$parcel$export(module.exports, "Banner", () => $6fe66a297255ba5b$export$3b4e64e77073e307);
/* banner.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $llCao = parcelRequire("llCao");

var $ekfU9 = parcelRequire("ekfU9");

var $eVEPg = parcelRequire("eVEPg");

var $kqgCs = parcelRequire("kqgCs");

var $1sGZ0 = parcelRequire("1sGZ0");

var $c04Nx = parcelRequire("c04Nx");

var $a1xUa = parcelRequire("a1xUa");
const $6fe66a297255ba5b$var$styles = {
    root: "_1xC2CJweDq _4bt5LAnQyn _2WAcuGnQyn _0jFU0V9QlX _2I62gzdnbC _1mT5xdHE3j _42Yu6B8OLE"
};
function $6fe66a297255ba5b$export$3b4e64e77073e307({ children: children, xcss: xcss, height: // 48px has been chosen to align with the height of the Banner component from `@atlaskit/banner`.
height = 48, skipLinkLabel: skipLinkLabel = 'Banner', testId: testId, id: providedId }) {
    const dangerouslyHoistSlotSizes = (0, $fsvuC.useContext)((0, $c04Nx.DangerouslyHoistSlotSizes));
    const id = (0, $a1xUa.useLayoutId)({
        providedId: providedId
    });
    /**
   * Don't show the skip link if the slot has 0 height.
   *
   * TODO: when cleaning up 'platform_dst_nav4_skip_link_a11y_1' remove this call entirely
   */ (0, $ekfU9.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: height === 0 || (0, $llCao.fg)('platform_dst_nav4_skip_link_a11y_1')
    });
    return /*#__PURE__*/ (0, $5chsV.jsxs)("div", {
        id: id,
        "data-layout-slot": true,
        className: (0, $gJ6nT.default)([
            $6fe66a297255ba5b$var$styles.root,
            xcss
        ]),
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $1sGZ0.HoistCssVarToLocalGrid), {
                variableName: (0, $eVEPg.bannerMountedVar),
                value: height
            }),
            dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $kqgCs.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $eVEPg.UNSAFE_bannerVar),
                value: height
            }),
            children
        ]
    });
}
$6fe66a297255ba5b$export$3b4e64e77073e307.displayName = "Banner";

});
parcelRegister("1sGZ0", function(module, exports) {
$parcel$export(module.exports, "HoistCssVarToLocalGrid", () => $12bf5a86a333284a$export$cfa3cd08d675e56e);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $cNKD8 = parcelRequire("cNKD8");
const $12bf5a86a333284a$export$cfa3cd08d675e56e = ({ variableName: variableName, value: value })=>/*#__PURE__*/ (0, $5chsV.jsx)("style", {
        children: `#${(0, $cNKD8.gridRootId)} { ${variableName}: ${value}px }`
    });
$12bf5a86a333284a$export$cfa3cd08d675e56e.displayName = "HoistCssVarToLocalGrid";

});


parcelRegister("bDNGK", function(module, exports) {
$parcel$export(module.exports, "Main", () => $72f7d51eacb9336b$export$861edd1ccea2f746);
/* main.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $llCao = parcelRequire("llCao");

var $3PTrD = parcelRequire("3PTrD");

var $eVEPg = parcelRequire("eVEPg");

var $cNKD8 = parcelRequire("cNKD8");

var $a1xUa = parcelRequire("a1xUa");

var $60rJZ = parcelRequire("60rJZ");
const $72f7d51eacb9336b$var$contentInsetBlockStartStatic = `calc(var(--n_bnrM, 0px) + var(--n_tNvM, 0px))`;
const $72f7d51eacb9336b$var$contentHeightWhenFixedStatic = `calc(100vh - var(--n_bnrM, 0px) - var(--n_tNvM, 0px))`;
const $72f7d51eacb9336b$var$mainElementStyles = {
    root: "_1xC2CJOQJL _4bt5LAIZbP _2WAcuGIZbP _2YgrGrP0S5 _2I62gzgiHs _0jFU0VlOMI _0zToRPIZbP _1M50CAIZbP _2DiRUzHE3j"
};
function $72f7d51eacb9336b$export$861edd1ccea2f746({ children: children, xcss: xcss, skipLinkLabel: skipLinkLabel = (0, $llCao.fg)('platform_dst_nav4_skip_link_a11y_1') ? 'Main content' : 'Main Content', testId: testId, id: providedId, minWidth: minWidth = 320 }) {
    const id = (0, $a1xUa.useLayoutId)({
        providedId: providedId
    });
    (0, $60rJZ.useLayoutMainSizing)(minWidth);
    (0, $3PTrD.useSkipLink)(id, skipLinkLabel);
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $fsvuC.Fragment), {
        children: [
            (0, $llCao.fg)('platform-dst-chat-panel-layout') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
            /*#__PURE__*/ (0, $5chsV.jsx)("style", {
                children: `#${(0, $cNKD8.gridRootId)}, #${(0, $cNKD8.gridRootFitId)} { ${(0, $eVEPg.mainMinimumWidthVar)}: ${minWidth}px; }`
            }),
            /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                id: id,
                "data-layout-slot": true,
                className: (0, $gJ6nT.default)([
                    $72f7d51eacb9336b$var$mainElementStyles.root,
                    xcss
                ]),
                role: "main",
                "data-testid": testId,
                children: children
            })
        ]
    });
}
$72f7d51eacb9336b$export$861edd1ccea2f746.displayName = "Main";

});
parcelRegister("3PTrD", function(module, exports) {
$parcel$export(module.exports, "useSkipLink", () => $740700e8d97052e2$export$89d9323301efc7d6);

var $ekfU9 = parcelRequire("ekfU9");
const $740700e8d97052e2$export$89d9323301efc7d6 = (/**
	 * The unique ID for the skip link.
	 * You can use the `useSkipLinkId` hook to generate a unique ID.
	 */ id, /**
	 * The label for the skip link.
	 */ label, /**
	 * You can optionally set the position of the skip link in the list of skip links.
	 * Positions are zero-indexed.
	 */ listIndex)=>{
    (0, $ekfU9.useSkipLinkInternal)({
        id: id,
        label: label,
        listIndex: listIndex
    });
};

});

parcelRegister("60rJZ", function(module, exports) {
$parcel$export(module.exports, "useLayoutMainSizing", () => $9296ae474d78f9a8$export$da289e07ef5e0a12);

var $fsvuC = parcelRequire("fsvuC");

var $goVBy = parcelRequire("goVBy");
function $9296ae474d78f9a8$export$da289e07ef5e0a12(minWidth) {
    const context = (0, $fsvuC.useContext)((0, $goVBy.LayoutAreaSizingContext));
    const setMainMinWidth = context?.setMainMinWidth;
    (0, $fsvuC.useEffect)(()=>setMainMinWidth?.(minWidth), [
        minWidth,
        setMainMinWidth
    ]);
}

});


parcelRegister("jSJ3b", function(module, exports) {
$parcel$export(module.exports, "Panel", () => $0a08598ec4df119f$export$2ddb90ad54e5f587);
/* panel.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $fz4Xf = parcelRequire("fz4Xf");

var $iJh5O = parcelRequire("iJh5O");

var $lfw4f = parcelRequire("lfw4f");

var $ckXfQ = parcelRequire("ckXfQ");

var $llCao = parcelRequire("llCao");

var $ekfU9 = parcelRequire("ekfU9");

var $eVEPg = parcelRequire("eVEPg");

var $kqgCs = parcelRequire("kqgCs");

var $c04Nx = parcelRequire("c04Nx");

var $cRpV8 = parcelRequire("cRpV8");

var $5GVRi = parcelRequire("5GVRi");

var $a1xUa = parcelRequire("a1xUa");

var $1tX1p = parcelRequire("1tX1p");

var $1swgG = parcelRequire("1swgG");
const $0a08598ec4df119f$var$panelSplitterResizingVar = '--n_pnlRsz';
const $0a08598ec4df119f$var$fallbackDefaultWidth = 365;
/**
 * We typically use the `defaultWidth` as the minimum resizing width,
 * but for large default widths we fallback to a standard value.
 *
 * This standard value of `400px` is to align with the Global Preview Panels.
 */ const $0a08598ec4df119f$var$fallbackResizeMinWidth = 400;
const $0a08598ec4df119f$var$styles = {
    root: "_1xC2CJ39pk _2p6ht9F05b _24h04i2Njc _42Yu6B7dHp _0jFU0VlOMI _1mT5xdHE3j _2I62gzgiHs _0KLXruoI2d _39xV02mSzM _2EWYUbwuPN _0hAebtlfZc _3gynorcCME _0E5nkyIZbP",
    border: "_2YmqfPYbGa _2OUyjtGk8v _4uZkDnOeNX _1RYJRxYbGa",
    scrollContainer: "_4bt5LAIZbP _2WAcuGIZbP _0jFU0VN91d",
    hidden: "_3iDTPbYbGa",
    entering: "_1jZhRJ3mzc _2qDx9m7CF6 _03Q0eexlqh _4xtBsMCT93 _4tikTSThaV _3JI830y1CL _2nUT5xdEse",
    exiting: "_1jZhRJiZOe _2qDx9m7CF6 _03Q0eexlqh _4xtBsMouYb _4tikTSThaV _0LZf8iy1CL _2nUT5xcfkA",
    contentEntering: "_2fBhteeOAp",
    contentExiting: "_2fBhtezSOH",
    contentChangeContainer: "_0jFU0VN91d"
};
const $0a08598ec4df119f$var$PanelContentMotion = ({ children: children })=>{
    const { state: state, ref: ref } = (0, $iJh5O.useMotion)();
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        ref: ref,
        className: (0, $gJ6nT.default)([
            $0a08598ec4df119f$var$styles.contentChangeContainer,
            state === 'entering' && $0a08598ec4df119f$var$styles.contentEntering,
            state === 'exiting' && $0a08598ec4df119f$var$styles.contentExiting
        ]),
        children: children
    });
};
$0a08598ec4df119f$var$PanelContentMotion.displayName = "PanelContentMotion";
function $0a08598ec4df119f$export$2ddb90ad54e5f587({ children: children, defaultWidth: defaultWidthProp = $0a08598ec4df119f$var$fallbackDefaultWidth, label: label = 'Panel', skipLinkLabel: skipLinkLabel = label, testId: testId, id: providedId, xcss: xcss, hasBorder: hasBorder = true, maxWidth: maxWidth, contentKey: contentKey }) {
    const dangerouslyHoistSlotSizes = (0, $fsvuC.useContext)((0, $c04Nx.DangerouslyHoistSlotSizes));
    const id = (0, $a1xUa.useLayoutId)({
        providedId: providedId
    });
    const isMotionUpliftEnabled = (0, $llCao.fg)('platform-dst-motion-uplift-panel');
    const isContentMotionEnabled = (0, $llCao.fg)('platform-dst-motion-uplift-panel-content');
    const prevContentKeyRef = (0, $fsvuC.useRef)(contentKey);
    (0, $fsvuC.useEffect)(()=>{
        if (isContentMotionEnabled && contentKey !== undefined) prevContentKeyRef.current = contentKey;
    }, [
        contentKey,
        isContentMotionEnabled
    ]);
    const defaultWidth = (0, $1swgG.useSafeDefaultWidth)({
        defaultWidthProp: defaultWidthProp,
        fallbackDefaultWidth: $0a08598ec4df119f$var$fallbackDefaultWidth,
        slotName: 'Panel'
    });
    // useMotion is applied only when the `platform-dst-motion-uplift-panel` gate is enabled.
    const { state: state, ref: motionRef, reanimate: reanimate } = (0, $iJh5O.useMotion)({
        onFinish: (state)=>{
            if (state === 'exiting' && defaultWidthRef.current === 0) // Set width to 0 as animation is complete
            setWidth(0);
        },
        initialState: defaultWidth === 0 ? 'hidden' : undefined
    });
    /**
   * Don't show the skip link if the slot has 0 width.
   *
   * Remove `isHidden` usage after https://jplat.atlassian.net/browse/BLU-3951
   *
   * TODO: when cleaning up 'platform_dst_nav4_skip_link_a11y_1' remove this call entirely
   */ (0, $ekfU9.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: defaultWidth === 0 || (0, $llCao.fg)('platform_dst_nav4_skip_link_a11y_1')
    });
    const ref = (0, $fsvuC.useRef)(null);
    const [width, setWidth] = (0, $fsvuC.useState)(defaultWidth);
    // Used to track the previous value of the `defaultWidth` prop, for logging dev warnings when it changes.
    const defaultWidthRef = (0, $fsvuC.useRef)(defaultWidth);
    // `mergeRefs` returns a new callback ref on every call, and combined with a new array literal
    // this would cause React to detach/re-attach the ref on every render. Memoise it so the merged
    // ref is stable across renders.
    const mergedRef = (0, $fsvuC.useMemo)(()=>isMotionUpliftEnabled ? (0, $fz4Xf.default)([
            ref,
            motionRef
        ]) : ref, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        isMotionUpliftEnabled,
        motionRef
    ]);
    /**
   * TODO: Remove this useEffect once the `width: 0` usage is removed from Jira.
   * It updates the width state based on changes to `defaultWidth`, as a temporary stopgap to support Jira's current usage.
   * https://jplat.atlassian.net/browse/BLU-3951
   */ (0, $fsvuC.useEffect)(()=>{
        if (defaultWidthRef.current === defaultWidth) return;
        if (isMotionUpliftEnabled) {
            if (defaultWidth === 0) {
                reanimate((0, $ckXfQ.Reanimate).exit);
                defaultWidthRef.current = defaultWidth;
                // Set width to 0 once the exit animation is complete
                return;
            } else if (defaultWidthRef.current === 0) reanimate((0, $ckXfQ.Reanimate).enter);
        }
        defaultWidthRef.current = defaultWidth;
        setWidth(defaultWidth);
    }, [
        defaultWidth,
        isMotionUpliftEnabled,
        reanimate
    ]);
    const sideNavRef = (0, $5GVRi.useSideNavRef)();
    /**
   * The minimum width that the panel can be resized to by the user.
   *
   * We only use the `defaultWidth` up to a point to avoid huge panels.
   */ const minWidth = Math.min(defaultWidth, $0a08598ec4df119f$var$fallbackResizeMinWidth);
    /**
   * Returns the bounds for resizing, evaluated lazily when needed.
   *
   * Defined separately to the slot bounds because the resizing bounds need to be resolvable to a pixel value,
   * and the panel's slot bounds use a complex CSS expression.
   */ const getResizeBounds = (0, $fsvuC.useCallback)(()=>{
        const sideNavWidth = sideNavRef.current?.offsetWidth ?? 0;
        /**
     * By default the panel should not resize larger than the page content, equivalent to the `Main` + `Aside` slots.
     *
     * This maximum width is equivalent to half the viewport width, after removing the sidebar width.
     *
     * Consumers can opt in to a larger maximum via the `maxWidth` prop.
     */ const defaultMaxWidth = `${Math.round((window.innerWidth - sideNavWidth) / 2)}px`;
        return {
            min: `${minWidth}px`,
            max: maxWidth ?? defaultMaxWidth
        };
    }, [
        maxWidth,
        minWidth,
        sideNavRef
    ]);
    const panelWidthSlotBounds = {
        min: `${minWidth}px`,
        // `sideNavLiveWidthVar` is not defined if the `SideNav` is not mounted, so we fallback to `0px`.
        // Consumers can opt in to a larger maximum via the `maxWidth` prop.
        max: maxWidth ?? `round(nearest, calc((100vw - var(${0, $eVEPg.sideNavLiveWidthVar}, 0px)) / 2), 1px)`
    };
    const panelVariableWidth = `clamp(${panelWidthSlotBounds.min}, ${width}px, ${panelWidthSlotBounds.max})`;
    (0, $1tX1p.useResizingWidthCssVarOnRootElement)({
        isEnabled: dangerouslyHoistSlotSizes,
        cssVar: $0a08598ec4df119f$var$panelSplitterResizingVar,
        panelId: (0, $eVEPg.panelPanelSplitterId)
    });
    return /*#__PURE__*/ (0, $5chsV.jsxs)("section", {
        id: id,
        "data-layout-slot": true,
        "aria-label": label,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $gJ6nT.default)([
            $0a08598ec4df119f$var$styles.root,
            isMotionUpliftEnabled && state === 'hidden' && $0a08598ec4df119f$var$styles.hidden,
            isMotionUpliftEnabled && state === 'entering' && $0a08598ec4df119f$var$styles.entering,
            isMotionUpliftEnabled && state === 'exiting' && $0a08598ec4df119f$var$styles.exiting,
            !isMotionUpliftEnabled && defaultWidth === 0 && $0a08598ec4df119f$var$styles.hidden,
            hasBorder && $0a08598ec4df119f$var$styles.border,
            xcss
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            [(0, $eVEPg.panelVar)]: panelVariableWidth,
            '--minWidth': `${minWidth}px`
        },
        "data-testid": testId,
        ref: mergedRef,
        children: [
            dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $kqgCs.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $eVEPg.UNSAFE_panelLayoutVar),
                value: "0px",
                mediaQuery: '@media (min-width: 90rem)',
                responsiveValue: `var(${$0a08598ec4df119f$var$panelSplitterResizingVar}, ${panelVariableWidth})`
            }),
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $cRpV8.PanelSplitterProvider), {
                panelId: (0, $eVEPg.panelPanelSplitterId),
                panelRef: ref,
                panelWidth: width,
                onCompleteResize: setWidth,
                getResizeBounds: getResizeBounds,
                resizingCssVar: $0a08598ec4df119f$var$panelSplitterResizingVar,
                position: "start",
                children: /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                    className: (0, $gJ6nT.default)([
                        $0a08598ec4df119f$var$styles.scrollContainer,
                        isMotionUpliftEnabled && state === 'entering' && $0a08598ec4df119f$var$styles.contentEntering,
                        isMotionUpliftEnabled && state === 'exiting' && $0a08598ec4df119f$var$styles.contentExiting
                    ]),
                    children: isContentMotionEnabled ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $lfw4f.default), {
                        exitThenEnter: contentKey !== undefined,
                        children: /*#__PURE__*/ (0, $5chsV.jsx)($0a08598ec4df119f$var$PanelContentMotion, {
                            children: children
                        }, contentKey === undefined ? prevContentKeyRef.current : contentKey)
                    }) : children
                })
            })
        ]
    });
}
$0a08598ec4df119f$export$2ddb90ad54e5f587.displayName = "Panel";

});

parcelRegister("diAaG", function(module, exports) {
$parcel$export(module.exports, "TopNav", () => $3bf4d9dc2eca4f16$export$41d0d88a6b0e456f);
/* top-nav.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $5PUly = parcelRequire("5PUly");

var $llCao = parcelRequire("llCao");

var $ekfU9 = parcelRequire("ekfU9");

var $dKvIi = parcelRequire("dKvIi");

var $j5TFs = parcelRequire("j5TFs");

var $7J86F = parcelRequire("7J86F");

var $1eLZh = parcelRequire("1eLZh");

var $eVEPg = parcelRequire("eVEPg");

var $kqgCs = parcelRequire("kqgCs");

var $1sGZ0 = parcelRequire("1sGZ0");

var $c04Nx = parcelRequire("c04Nx");

var $a1xUa = parcelRequire("a1xUa");
/**
 * Styles for the container for the top nav items.
 *
 * The background and border are applied to a different element for z-indexing reasons:
 *
 * - The items sit above the expanded side nav
 * - The background sits below the expanded side nav
 */ const $3bf4d9dc2eca4f16$var$styles = {
    root: "_1xC2CJ8ySg _2mHwu82ADO _2Y7lL48HPE _2R4pr3OeNX _3iDTPbgBM8 _2iEGP292QF _0hPCNLDIqT _0KLXrulfZc _24h04i2Njc _0jFU0VmTzZ _2I62gza2UD _1mT5xdHE3j _42Yu6B8OLE _0RYKppcK7c _3E0AG2ifeC"
};
/**
 * The top nav layout area. It will display at the top of the screen, below the banner if one is present.
 */ function $3bf4d9dc2eca4f16$var$TopNavOld({ children: children, xcss: xcss, height: heightProp, skipLinkLabel: skipLinkLabel = 'Top Bar', testId: testId, id: providedId, customTheme: customThemeConfig }) {
    const dangerouslyHoistSlotSizes = (0, $fsvuC.useContext)((0, $c04Nx.DangerouslyHoistSlotSizes));
    const id = (0, $a1xUa.useLayoutId)({
        providedId: providedId
    });
    (0, $ekfU9.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: (0, $llCao.fg)('platform_dst_nav4_skip_link_a11y_1')
    });
    const height = heightProp ?? ((0, $llCao.fg)('platform_dst_ads_appswitcher_improvements') ? 56 : 48);
    const customTheme = (0, $7J86F.useCustomTheme)(customThemeConfig);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $dKvIi.HasCustomThemeContext).Provider, {
        value: customTheme.isEnabled,
        children: /*#__PURE__*/ (0, $5chsV.jsxs)("header", {
            id: id,
            "data-layout-slot": true,
            className: (0, $gJ6nT.default)([
                $3bf4d9dc2eca4f16$var$styles.root,
                xcss
            ]),
            "data-testid": testId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: customTheme.isEnabled ? customTheme.style : undefined,
            children: [
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $1sGZ0.HoistCssVarToLocalGrid), {
                    variableName: (0, $eVEPg.topNavMountedVar),
                    value: height
                }),
                dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
                // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
                // When they aren't needed anymore we can delete them wholesale.
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $kqgCs.DangerouslyHoistCssVarToDocumentRoot), {
                    variableName: (0, $eVEPg.UNSAFE_topNavVar),
                    value: height
                }),
                children
            ]
        })
    });
}
$3bf4d9dc2eca4f16$var$TopNavOld.displayName = "TopNavOld";
/**
 * The top nav layout area. It will display at the top of the screen, below the banner if one is present.
 */ function $3bf4d9dc2eca4f16$var$TopNavNew({ children: children, xcss: xcss, height: heightProp, skipLinkLabel: skipLinkLabel = 'Top Bar', testId: testId, id: providedId, customTheme: customThemeConfig }) {
    const dangerouslyHoistSlotSizes = (0, $fsvuC.useContext)((0, $c04Nx.DangerouslyHoistSlotSizes));
    const id = (0, $a1xUa.useLayoutId)({
        providedId: providedId
    });
    (0, $ekfU9.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: (0, $llCao.fg)('platform_dst_nav4_skip_link_a11y_1')
    });
    const height = heightProp ?? ((0, $llCao.fg)('platform_dst_ads_appswitcher_improvements') ? 56 : 48);
    const customTheme = (0, $1eLZh.useCustomThemeNew)(customThemeConfig);
    const hasDefaultBackground = customTheme.isEnabled ? customTheme.hasDefaultBackground : true;
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $dKvIi.HasCustomThemeContext).Provider, {
        value: customTheme.isEnabled,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $j5TFs.HasDefaultBackgroundColorContext).Provider, {
            value: hasDefaultBackground,
            children: /*#__PURE__*/ (0, $5chsV.jsxs)("header", {
                id: id,
                "data-layout-slot": true,
                className: (0, $gJ6nT.default)([
                    $3bf4d9dc2eca4f16$var$styles.root,
                    xcss
                ]),
                "data-testid": testId,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: customTheme.isEnabled ? customTheme.style : undefined,
                children: [
                    /*#__PURE__*/ (0, $5chsV.jsx)((0, $1sGZ0.HoistCssVarToLocalGrid), {
                        variableName: (0, $eVEPg.topNavMountedVar),
                        value: height
                    }),
                    dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
                    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
                    // When they aren't needed anymore we can delete them wholesale.
                    /*#__PURE__*/ (0, $5chsV.jsx)((0, $kqgCs.DangerouslyHoistCssVarToDocumentRoot), {
                        variableName: (0, $eVEPg.UNSAFE_topNavVar),
                        value: height
                    }),
                    children
                ]
            })
        })
    });
}
$3bf4d9dc2eca4f16$var$TopNavNew.displayName = "TopNavNew";
const $3bf4d9dc2eca4f16$export$41d0d88a6b0e456f = (0, $5PUly.componentWithFG)('platform_dst_nav4_custom_theming_fhs_1', $3bf4d9dc2eca4f16$var$TopNavNew, $3bf4d9dc2eca4f16$var$TopNavOld);

});
parcelRegister("j5TFs", function(module, exports) {
$parcel$export(module.exports, "HasDefaultBackgroundColorContext", () => $dc6dac2feb9078db$export$e4314fea1a98d918);

var $fsvuC = parcelRequire("fsvuC");
const $dc6dac2feb9078db$export$e4314fea1a98d918 = /*#__PURE__*/ (0, $fsvuC.createContext)(true);

});

parcelRegister("7J86F", function(module, exports) {
$parcel$export(module.exports, "useCustomTheme", () => $61786836cfd96684$export$c0c5f5b297b77726);

var $fsvuC = parcelRequire("fsvuC");

var $8qlzn = parcelRequire("8qlzn");
function $61786836cfd96684$export$c0c5f5b297b77726(theme) {
    const value = (0, $fsvuC.useMemo)(()=>{
        if (!theme?.backgroundColor || !theme?.highlightColor) return {
            isEnabled: false
        };
        /**
			 * Re-creating the `theme` object from it's pieces.
			 *
			 * _Technically_ we could just use `theme`, but that would involve an eslint opt out
			 * as we would be leveraging a value (`theme`) not in the dependency array.
			 *
			 * The current approach is the most correct™️ and avoids foot guns.
			 * We are only using values in the effect that are defined in the dependency array 🙌
			 */ const value = {
            backgroundColor: theme.backgroundColor,
            highlightColor: theme.highlightColor
        };
        const style = (0, $8qlzn.getCustomThemeStyles)(value);
        if (!style) // Either the `backgroundColor` or `highlightColor` could not be parsed
        return {
            isEnabled: false
        };
        return {
            isEnabled: true,
            style: style
        };
    }, // Using individual properties as keys for improved memoization.
    // Now this effect will only run if the values change rather than
    // the reference to the object (which might be new on every call)
    [
        theme?.backgroundColor,
        theme?.highlightColor
    ]);
    return value;
}

});
parcelRegister("8qlzn", function(module, exports) {
$parcel$export(module.exports, "getCustomThemeStyles", () => $6fc23c53c9a6a406$export$3986d75fe2da3239);

var $1SSqM = parcelRequire("1SSqM");

var $7TC9U = parcelRequire("7TC9U");

var $3X7vk = parcelRequire("3X7vk");

var $9gPcH = parcelRequire("9gPcH");

var $bwupS = parcelRequire("bwupS");

var $4Ehxx = parcelRequire("4Ehxx");
function $6fc23c53c9a6a406$var$toRGBString({ r: r, g: g, b: b }) {
    return `rgb(${r}, ${g}, ${b})`;
}
function $6fc23c53c9a6a406$var$toRGBAString({ r: r, g: g, b: b, a: a }) {
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
// Using raw hex codes because custom colors break out of the tokens model
// We will need to invert the colors based on backgroundColor independently of the app's color mode (dark/light)
// Values here are not final
const $6fc23c53c9a6a406$var$buttonStyles = {
    light: {
        ['--ds-top-bar-button-background']: 'transparent',
        ['--ds-top-bar-button-background-hovered']: (0, $9gPcH.palette).Neutral200A,
        ['--ds-top-bar-button-background-pressed']: (0, $9gPcH.palette).Neutral300A,
        ['--ds-top-bar-button-border']: (0, $9gPcH.palette).Neutral300A,
        ['--ds-top-bar-button-selected-background']: (0, $9gPcH.palette).Neutral300A,
        ['--ds-top-bar-button-selected-background-hovered']: (0, $9gPcH.palette).Neutral400A,
        ['--ds-top-bar-button-selected-background-pressed']: (0, $9gPcH.palette).Neutral500A,
        ['--ds-top-bar-button-disabled-text']: (0, $9gPcH.palette).Neutral400A,
        ['--ds-top-bar-button-disabled-background']: (0, $9gPcH.palette).Neutral100A
    },
    dark: {
        ['--ds-top-bar-button-background']: 'transparent',
        ['--ds-top-bar-button-background-hovered']: (0, $9gPcH.palette).DarkNeutral200A,
        ['--ds-top-bar-button-background-pressed']: (0, $9gPcH.palette).DarkNeutral300A,
        ['--ds-top-bar-button-border']: (0, $9gPcH.palette).DarkNeutral300A,
        ['--ds-top-bar-button-selected-background']: (0, $9gPcH.palette).DarkNeutral300A,
        ['--ds-top-bar-button-selected-background-hovered']: (0, $9gPcH.palette).DarkNeutral400A,
        ['--ds-top-bar-button-selected-background-pressed']: (0, $9gPcH.palette).DarkNeutral500A,
        ['--ds-top-bar-button-disabled-text']: (0, $9gPcH.palette).DarkNeutral400A,
        ['--ds-top-bar-button-disabled-background']: (0, $9gPcH.palette).DarkNeutral100A
    }
};
const $6fc23c53c9a6a406$var$logoStyles = {
    light: {
        ['--ds-top-bar-logo-icon']: (0, $9gPcH.palette).DarkNeutral0,
        ['--ds-top-bar-logo-text']: (0, $9gPcH.palette).DarkNeutral0
    },
    dark: {
        [(0, $1SSqM.themedLogoIcon)]: (0, $9gPcH.palette).Neutral0,
        [(0, $1SSqM.themedLogoText)]: (0, $9gPcH.palette).Neutral0
    }
};
function $6fc23c53c9a6a406$export$3986d75fe2da3239({ backgroundColor: backgroundColor, highlightColor: highlightColor }) {
    const backgroundRgb = typeof backgroundColor === 'string' ? (0, $3X7vk.parseHex)(backgroundColor) : backgroundColor;
    const highlightRgb = typeof highlightColor === 'string' ? (0, $3X7vk.parseHex)(highlightColor) : highlightColor;
    if (!backgroundRgb || !highlightRgb) return null;
    const textColor = (0, $7TC9U.getTextColor)(backgroundRgb);
    const colorMode = (0, $7TC9U.getColorMode)(backgroundRgb);
    const highlightTextColor = (0, $7TC9U.getTextColor)(highlightRgb);
    return {
        backgroundColor: $6fc23c53c9a6a406$var$toRGBString(backgroundRgb),
        color: textColor.hex,
        ...$6fc23c53c9a6a406$var$buttonStyles[colorMode],
        ...$6fc23c53c9a6a406$var$logoStyles[colorMode],
        ...$6fc23c53c9a6a406$var$getSelectedStyles({
            backgroundColor: backgroundRgb,
            colorMode: colorMode
        }),
        /**
		 * Search colors are the same as Nav 3
		 */ [(0, $4Ehxx.themedSearchBorder)]: $6fc23c53c9a6a406$var$toRGBAString({
            ...textColor.rgb,
            a: 0.5
        }),
        [(0, $4Ehxx.themedSearchBorderFocused)]: $6fc23c53c9a6a406$var$toRGBAString({
            ...highlightRgb,
            a: 0.8
        }),
        /**
		 * Primary button colors are the same as Nav 3,
		 * except the text color which can sometimes differ because we're
		 * now following WCAG
		 */ ['--ds-top-bar-button-primary-background']: $6fc23c53c9a6a406$var$toRGBString(highlightRgb),
        ['--ds-top-bar-button-primary-background-hovered']: $6fc23c53c9a6a406$var$toRGBAString({
            ...highlightRgb,
            a: 0.8
        }),
        ['--ds-top-bar-button-primary-background-pressed']: $6fc23c53c9a6a406$var$toRGBAString({
            ...highlightRgb,
            a: 0.65
        }),
        ['--ds-top-bar-button-primary-text']: highlightTextColor.hex
    };
}
/**
 * Precomputed RGBA values for the selected backgrounds
 */ const $6fc23c53c9a6a406$var$selectedBackgroundRGBA = {
    light: (0, $bwupS.paletteRgba).Neutral300A,
    dark: (0, $bwupS.paletteRgba).DarkNeutral300A
};
function $6fc23c53c9a6a406$var$getSelectedStyles({ backgroundColor: backgroundColor, colorMode: colorMode }) {
    /**
	 * The background color of the selected button in its default state.
	 *
	 * We are referring to this as a foreground color because it is semi-transparent,
	 * so is not the actual color displayed when the button is on top of a background color.
	 */ const foregroundColor = $6fc23c53c9a6a406$var$selectedBackgroundRGBA[colorMode];
    /**
	 * The blended color seen when the selected background is over the top bar.
	 */ const blendedBackground = (0, $7TC9U.simpleAlphaComposite)({
        background: backgroundColor,
        foreground: foregroundColor
    });
    return {
        ['--ds-top-bar-button-selected-text']: (0, $7TC9U.getTextColor)(blendedBackground).hex,
        // Border colors are chosen to match the text, while remaining in the palette
        ['--ds-top-bar-button-selected-border']: (0, $7TC9U.isLight)(blendedBackground) ? (0, $9gPcH.palette).Neutral1100 : (0, $9gPcH.palette).DarkNeutral1100
    };
}

});
parcelRegister("1SSqM", function(module, exports) {
$parcel$export(module.exports, "themedLogoIcon", () => $4d23b7c9703ad1e8$export$24328117f1132113);
$parcel$export(module.exports, "themedLogoText", () => $4d23b7c9703ad1e8$export$91b0830f8f4ab279);
$parcel$export(module.exports, "LogoRenderer", () => $4d23b7c9703ad1e8$export$35e88bd9b061a3a4);
/* logo-renderer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $dKvIi = parcelRequire("dKvIi");
const $4d23b7c9703ad1e8$export$24328117f1132113 = '--ds-top-bar-logo-icon';
const $4d23b7c9703ad1e8$export$91b0830f8f4ab279 = '--ds-top-bar-logo-text';
function $4d23b7c9703ad1e8$export$35e88bd9b061a3a4({ logoOrIcon: LogoOrIcon }) {
    const hasCustomTheme = (0, $dKvIi.useHasCustomTheme)();
    if (hasCustomTheme) return /*#__PURE__*/ (0, $5chsV.jsx)(LogoOrIcon, {
        label: "",
        size: "small",
        iconColor: `var(${$4d23b7c9703ad1e8$export$24328117f1132113})`,
        textColor: `var(${$4d23b7c9703ad1e8$export$91b0830f8f4ab279})`
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)(LogoOrIcon, {
        size: "small",
        label: "",
        appearance: "brand"
    });
}
$4d23b7c9703ad1e8$export$35e88bd9b061a3a4.displayName = "LogoRenderer";

});

parcelRegister("7TC9U", function(module, exports) {
$parcel$export(module.exports, "isLight", () => $23ece66c222259c4$export$44af652f4cca9039);
$parcel$export(module.exports, "getColorMode", () => $23ece66c222259c4$export$5573a5bab3e074b5);
$parcel$export(module.exports, "getTextColor", () => $23ece66c222259c4$export$5357fe757c335c0d);
$parcel$export(module.exports, "simpleAlphaComposite", () => $23ece66c222259c4$export$e5e64c30bee1469b);
/**
 * Removes sRGB gamma correction from the provided channel.
 * The resulting linear channel directly corresponds to subpixel intensity.
 *
 * Expects a normalized sRGB value (between 0 and 1)
 *
 * This formula is derived from WCAG2 guidelines:
 * https://www.w3.org/WAI/WCAG22/Techniques/general/G18.html#tests
 */ function $23ece66c222259c4$var$linearizeRGBChannel(channel) {
    return channel <= 0.04045 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
}
/**
 * This formula is derived from WCAG2 guidelines:
 * https://www.w3.org/WAI/WCAG22/Techniques/general/G18.html#tests
 */ function $23ece66c222259c4$var$relativeLuminanceW3C({ r: r, g: g, b: b }) {
    /**
	 * Normalized sRGB - each channel is between 0 and 1
	 */ const normal = {
        r: r / 255,
        g: g / 255,
        b: b / 255
    };
    /**
	 * linear RGB - the gamma correction of sRGB is removed and
	 * the channels correspond directly to subpixel intensity
	 */ const linear = {
        r: $23ece66c222259c4$var$linearizeRGBChannel(normal.r),
        g: $23ece66c222259c4$var$linearizeRGBChannel(normal.g),
        b: $23ece66c222259c4$var$linearizeRGBChannel(normal.b)
    };
    // For linear RGB, the relative luminance of a color is defined as:
    const L = 0.2126 * linear.r + 0.7152 * linear.g + 0.0722 * linear.b;
    return L;
}
/**
 * This is the intersection point for W3C contrast ratio against:
 *
 * 1. black
 * 2. white
 *
 * In other words, the background luminance for which W3C contrast is equal
 * for both white and black text.
 *
 * Using a precomputed flip point means we can save a lot of calculations.
 *
 * This is only the theoretical flip point, and we can adjust it as needed.
 */ const $23ece66c222259c4$var$flipLuminance = 0.179129;
function $23ece66c222259c4$export$44af652f4cca9039(color) {
    return $23ece66c222259c4$var$relativeLuminanceW3C(color) >= $23ece66c222259c4$var$flipLuminance;
}
function $23ece66c222259c4$export$5573a5bab3e074b5(backgroundColor) {
    if ($23ece66c222259c4$var$relativeLuminanceW3C(backgroundColor) >= $23ece66c222259c4$var$flipLuminance) return 'light';
    return 'dark';
}
const $23ece66c222259c4$var$textColor = {
    light: {
        hex: '#000',
        rgb: {
            r: 0,
            g: 0,
            b: 0
        }
    },
    dark: {
        hex: '#FFF',
        rgb: {
            r: 255,
            g: 255,
            b: 255
        }
    }
};
function $23ece66c222259c4$export$5357fe757c335c0d(backgroundColor) {
    const colorMode = $23ece66c222259c4$export$5573a5bab3e074b5(backgroundColor);
    return $23ece66c222259c4$var$textColor[colorMode];
}
function $23ece66c222259c4$export$e5e64c30bee1469b({ background: background, foreground: foreground }) {
    return {
        r: foreground.a * foreground.r + background.r * (1 - foreground.a),
        g: foreground.a * foreground.g + background.g * (1 - foreground.a),
        b: foreground.a * foreground.b + background.b * (1 - foreground.a)
    };
}

});

parcelRegister("3X7vk", function(module, exports) {
$parcel$export(module.exports, "parseHex", () => $0ea412edcf434dd6$export$103711ef09c6edec);
// valid hex color (optional alpha channel) - 3, 4, 6, or 8 digits after the #
const $0ea412edcf434dd6$var$isValidHex = (hex)=>// Not using `([a-f0-9]{3,4}){1,2}` because that allows 7 digits which is invalid
    /^#(([a-f0-9]{3,4})|([a-f0-9][a-f0-9]){3,4})$/i.test(hex);
function $0ea412edcf434dd6$export$103711ef09c6edec(color) {
    if (!$0ea412edcf434dd6$var$isValidHex(color)) return null;
    let channels;
    if (color.length <= 5) // Hex code is shorthand - RGB channels are one digit
    channels = {
        r: color[1].repeat(2),
        g: color[2].repeat(2),
        b: color[3].repeat(2)
    };
    else // Hex code is longhand - RGB channels are two digits
    channels = {
        r: color.slice(1, 3),
        g: color.slice(3, 5),
        b: color.slice(5, 7)
    };
    return {
        r: parseInt(channels.r, 16),
        g: parseInt(channels.g, 16),
        b: parseInt(channels.b, 16)
    };
}

});

parcelRegister("9gPcH", function(module, exports) {
$parcel$export(module.exports, "palette", () => $6063bad036dfd923$export$eaad8caa32d2521d);
const $6063bad036dfd923$export$eaad8caa32d2521d = {
    'DarkNeutral-100': '#111213',
    'DarkNeutral-100A': '#01040475',
    DarkNeutral0: '#18191A',
    DarkNeutral100: '#1F1F21',
    DarkNeutral100A: '#BDBDBD0A',
    DarkNeutral200: '#242528',
    DarkNeutral200A: '#CECED912',
    DarkNeutral250: '#2B2C2F',
    DarkNeutral250A: '#D9DAE71A',
    DarkNeutral300: '#303134',
    DarkNeutral300A: '#E3E4F21F',
    DarkNeutral350: '#3D3F43',
    DarkNeutral350A: '#E8EDFD2E',
    DarkNeutral400: '#4B4D51',
    DarkNeutral400A: '#E5E9F640',
    DarkNeutral500: '#63666B',
    DarkNeutral500A: '#E9F0FB5C',
    DarkNeutral600: '#7E8188',
    DarkNeutral700: '#96999E',
    DarkNeutral800: '#A9ABAF',
    DarkNeutral900: '#BFC1C4',
    DarkNeutral1000: '#CECFD2',
    DarkNeutral1100: '#E2E3E4',
    Neutral0: '#FFFFFF',
    Neutral100: '#F8F8F8',
    Neutral100A: '#17171708',
    Neutral200: '#F0F1F2',
    Neutral200A: '#0515240F',
    Neutral300: '#DDDEE1',
    Neutral300A: '#0B120E24',
    Neutral400: '#B7B9BE',
    Neutral400A: '#080F214A',
    Neutral500: '#8C8F97',
    Neutral500A: '#050C1F75',
    Neutral600: '#7D818A',
    Neutral700: '#6B6E76',
    Neutral800: '#505258',
    Neutral900: '#3B3D42',
    Neutral1000: '#292A2E',
    Neutral1100: '#1E1F21'
};

});

parcelRegister("bwupS", function(module, exports) {
$parcel$export(module.exports, "paletteRgba", () => $d3bff3dbe629cda8$export$c9b84419dae66a82);
const $d3bff3dbe629cda8$export$c9b84419dae66a82 = {
    DarkNeutral300A: {
        r: 0xe3,
        g: 0xe4,
        b: 0xf2,
        a: 0x1f / 255
    },
    Neutral300A: {
        r: 0x0b,
        g: 0x12,
        b: 0x0e,
        a: 0x24 / 255
    }
};

});

parcelRegister("4Ehxx", function(module, exports) {
$parcel$export(module.exports, "themedSearchBorder", () => $4acfd1831a89ba5c$export$ae6fbf5ba3a7a784);
$parcel$export(module.exports, "themedSearchBorderFocused", () => $4acfd1831a89ba5c$export$ee42b8430f4c19bd);
$parcel$export(module.exports, "useLegacySearchTheme", () => $4acfd1831a89ba5c$export$18a29b1ed2212823);

var $dKvIi = parcelRequire("dKvIi");
const $4acfd1831a89ba5c$export$ae6fbf5ba3a7a784 = '--ds-top-bar-search-border';
const $4acfd1831a89ba5c$export$ee42b8430f4c19bd = '--ds-top-bar-search-border-focused';
/**
 * Theme object intended for use with Search Platform components while transitioning to nav4.
 *
 * This is for backwards compatibility with the legacy theming API that was designed for nav3.
 *
 * As nav4 matures we will ideally evolve the theming solution inside Search Platform,
 * at which point this legacy theme object will not be needed.
 */ const $4acfd1831a89ba5c$var$legacySearchTheme = {
    default: {
        backgroundColor: 'transparent',
        color: 'currentColor',
        borderColor: `var(${$4acfd1831a89ba5c$export$ae6fbf5ba3a7a784})`
    },
    focus: {
        /**
     * When expanded the input ignores the custom theme,
     * except for its border which is derived from the highlight color.
     */ color: "var(--ds-text, #292A2E)",
        backgroundColor: "var(--ds-background-input-pressed, #FFFFFF)",
        borderColor: `var(${$4acfd1831a89ba5c$export$ee42b8430f4c19bd})`,
        boxShadow: `inset 0px 0px 0px 1px var(${$4acfd1831a89ba5c$export$ee42b8430f4c19bd})`
    },
    hover: {
        /**
     * This is not actually used for the search bar input (at least by the Search Platform components).
     *
     * Instead it's used as the hover background color for a close button when on mobile.
     */ backgroundColor: `var(--ds-top-bar-button-background-hovered)`
    }
};
function $4acfd1831a89ba5c$export$18a29b1ed2212823() {
    const hasCustomTheme = (0, $dKvIi.useHasCustomTheme)();
    if (hasCustomTheme) return $4acfd1831a89ba5c$var$legacySearchTheme;
    return undefined;
}

});



parcelRegister("1eLZh", function(module, exports) {
$parcel$export(module.exports, "useCustomThemeNew", () => $6b0275c67b888354$export$92ae7a8762fba89e);

var $fsvuC = parcelRequire("fsvuC");

var $fg2Kk = parcelRequire("fg2Kk");

var $2I5i9 = parcelRequire("2I5i9");

var $3X7vk = parcelRequire("3X7vk");

var $7J86F = parcelRequire("7J86F");
function $6b0275c67b888354$var$toRGBString({ r: r, g: g, b: b }) {
    return `rgb(${r}, ${g}, ${b})`;
}
function $6b0275c67b888354$export$92ae7a8762fba89e(theme) {
    const value = (0, $7J86F.useCustomTheme)(theme);
    /**
   * We use the color mode to determine the default background color for the top nav.
   * We need to use the hook because the user could change their color mode preference.
   */ const colorMode = (0, $fg2Kk.useColorMode)();
    const hasDefaultBackground = (0, $fsvuC.useMemo)(()=>{
        if (!value.isEnabled) return true;
        const defaultBackground = (0, $3X7vk.parseHex)((0, $2I5i9.getTokenValue)('elevation.surface', colorMode === 'light' ? '#FFFFFF' : '#1F1F21'));
        return defaultBackground ? value.style.backgroundColor === $6b0275c67b888354$var$toRGBString(defaultBackground) : true;
    }, [
        value,
        colorMode
    ]);
    if (value.isEnabled) return {
        ...value,
        hasDefaultBackground: hasDefaultBackground
    };
    return value;
}

});


parcelRegister("bbyHr", function(module, exports) {
$parcel$export(module.exports, "PrimaryButton", () => $c64234adddf9e1dc$export$ac16a6a04d9b7c84);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fsvuC = parcelRequire("fsvuC");

var $h2YWL = parcelRequire("h2YWL");

var $3KROw = parcelRequire("3KROw");

var $3Kmf8 = parcelRequire("3Kmf8");

var $3BuLI = parcelRequire("3BuLI");

var $e7JFt = parcelRequire("e7JFt");
function $c64234adddf9e1dc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c64234adddf9e1dc$var$VAR_BUTTON_SELECTED_COLOR = '--button-selected-color';
const $c64234adddf9e1dc$var$VAR_BUTTON_SELECTED_BORDER_COLOR = '--button-selected-border-color';
const $c64234adddf9e1dc$var$buttonBaseStyles = {
    name: "8cx1fx",
    styles: "display:flex;height:100%;position:relative;align-items:center;justify-content:center;flex-direction:column"
};
const $c64234adddf9e1dc$var$buttonNoOpStyle = {
    name: "zvio0b",
    styles: "--noop:1"
};
const $c64234adddf9e1dc$var$buttonHighlightedStyles = /*#__PURE__*/ (0, $h2YWL.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&& > *': {
        color: `var(${$c64234adddf9e1dc$var$VAR_BUTTON_SELECTED_COLOR})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        height: 3,
        position: 'absolute',
        backgroundColor: `var(${$c64234adddf9e1dc$var$VAR_BUTTON_SELECTED_BORDER_COLOR})`,
        borderStartEndRadius: "var(--ds-radius-xsmall, 1px)",
        borderStartStartRadius: "var(--ds-radius-xsmall, 1px)",
        content: '""',
        insetBlockEnd: 0,
        insetInlineEnd: "var(--ds-space-050, 4px)",
        insetInlineStart: "var(--ds-space-050, 4px)"
    }
});
const $c64234adddf9e1dc$export$ac16a6a04d9b7c84 = /*#__PURE__*/ (0, $fsvuC.forwardRef)((props, ref)=>{
    const { children: children, component: component, isHighlighted: isHighlighted, isLoading: isLoading, isSelected: isSelected, onClick: onClick, testId: testId, theme: theme, tooltip: tooltip, shortcut: shortcut, ...rest } = props;
    const themeFromContext = (0, $3BuLI.useTheme)();
    const button = /*#__PURE__*/ (0, $h2YWL.jsx)("div", {
        style: {
            [$c64234adddf9e1dc$var$VAR_BUTTON_SELECTED_COLOR]: themeFromContext.mode.primaryButton.selected.color,
            [$c64234adddf9e1dc$var$VAR_BUTTON_SELECTED_BORDER_COLOR]: themeFromContext.mode.primaryButton.selected.borderColor
        },
        css: [
            $c64234adddf9e1dc$var$buttonBaseStyles,
            isHighlighted && $c64234adddf9e1dc$var$buttonHighlightedStyles
        ],
        role: "listitem",
        "data-vc": "primary-button"
    }, /*#__PURE__*/ (0, $h2YWL.jsx)((0, $3KROw.default), {
        appearance: "primary",
        component: component,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        ref: ref,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
        theme: theme || (0, $e7JFt.getPrimaryButtonTheme)(themeFromContext),
        css: [
            $c64234adddf9e1dc$var$buttonNoOpStyle
        ],
        ...rest
    }, children));
    if (tooltip) return /*#__PURE__*/ (0, $h2YWL.jsx)((0, $3Kmf8.default), {
        content: tooltip,
        hideTooltipOnClick: true,
        shortcut: shortcut
    }, button);
    return button;
});

});
parcelRegister("3BuLI", function(module, exports) {
$parcel$export(module.exports, "useTheme", () => $8da5b86ae6878167$export$93d4e7f90805808f);

var $fsvuC = parcelRequire("fsvuC");

var $fDcMf = parcelRequire("fDcMf");
const $8da5b86ae6878167$export$93d4e7f90805808f = ()=>(0, $fsvuC.useContext)((0, $fDcMf.ThemeContext));

});
parcelRegister("fDcMf", function(module, exports) {
$parcel$export(module.exports, "ThemeContext", () => $95ad77bcc966803f$export$2c657da244d00bd6);

var $fsvuC = parcelRequire("fsvuC");

var $kMwgd = parcelRequire("kMwgd");
const $95ad77bcc966803f$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $fsvuC.createContext)((0, $kMwgd.defaultTheme));

});
parcelRegister("kMwgd", function(module, exports) {
$parcel$export(module.exports, "defaultTheme", () => $dd41b18571f16d50$export$164de7ab8df77ef0);

var $crals = parcelRequire("crals");
const $dd41b18571f16d50$export$164de7ab8df77ef0 = (0, $crals.atlassianTheme);

});
parcelRegister("crals", function(module, exports) {
$parcel$export(module.exports, "atlassianTheme", () => $ed7ce1cb38b5deef$export$eeee8619e1b91cb0);

var $6OtEx = parcelRequire("6OtEx");

var $lu0Rs = parcelRequire("lu0Rs");
const $ed7ce1cb38b5deef$export$eeee8619e1b91cb0 = (0, $lu0Rs.generateTheme)({
    name: (0, $6OtEx.DEFAULT_THEME_NAME),
    backgroundColor: '#FFFFFF',
    highlightColor: '#0052CC'
});

});




parcelRegister("e7JFt", function(module, exports) {
$parcel$export(module.exports, "getPrimaryButtonTheme", () => $86e25c704d52089c$export$14dd6915caf431fe);
const $86e25c704d52089c$export$14dd6915caf431fe = ({ mode: { primaryButton: primaryButton } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...primaryButton.default,
                ...props.isSelected && primaryButton.selected,
                fontWeight: "var(--ds-font-weight-medium, 500)",
                padding: `0 ${"var(--ds-space-050, 4px)"}`,
                marginLeft: 0,
                marginRight: 0,
                ':hover': props.isSelected ? primaryButton.selectedHover : primaryButton.hover,
                ':focus': primaryButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                '&&': {
                    ...props.state === 'active' && primaryButton.active
                }
            },
            spinnerStyles: spinnerStyles
        };
    };

});


parcelRegister("blaS2", function(module, exports) {
$parcel$export(module.exports, "usePanelManager", () => $d6941cd8ef627820$export$3946869e2f4977e4);

var $ftHiu = parcelRequire("ftHiu");

var $3Pz86 = parcelRequire("3Pz86");
function $d6941cd8ef627820$export$3946869e2f4977e4() {
    const manager = (0, $ftHiu.usePanelActionsInternal)();
    const state = (0, $3Pz86.usePanelStateInternal)();
    return {
        state: state,
        manager: manager
    };
}

});
parcelRegister("ftHiu", function(module, exports) {
$parcel$export(module.exports, "PanelProvider", () => $abf9e80f737bcd23$export$e7dba2ce3ae71ca);
$parcel$export(module.exports, "usePanelActionsInternal", () => $abf9e80f737bcd23$export$5f6762d4d1cd693d);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $llCao = parcelRequire("llCao");


var $8IVcJ = parcelRequire("8IVcJ");
const $abf9e80f737bcd23$export$18d6b45fa585ca8a = /*#__PURE__*/ (0, $fsvuC.createContext)(null);
/**
 * Pure reducer function handling panel, preloaded entry point, and requested-width state transitions.
 *
 * LayoutWithPanel mirrors its requested width here. To apply provider width changes to an
 * already-mounted layout, connect its panelWidth and onPanelWidthChange props to the provider
 * with platform-dst-panel-system-width-persistence enabled.
 */ function $abf9e80f737bcd23$var$panelReducer(state, action) {
    switch(action.type){
        case 'PANEL_OPEN':
            {
                const { instanceId: instanceId, panelContent: panelContent, params: params } = action.payload;
                const newPanel = {
                    instanceId: instanceId,
                    panelContent: panelContent,
                    params: params || {}
                };
                return {
                    ...state,
                    activePanel: newPanel
                };
            }
        case 'PANEL_OPEN_ENTRYPOINT':
            {
                const { instanceId: instanceId, entryPoint: entryPoint, params: params, entryPointReference: entryPointReference } = action.payload;
                const newPanel = {
                    instanceId: instanceId,
                    entryPoint: entryPoint,
                    params: params || {},
                    entryPointReference: entryPointReference
                };
                return {
                    ...state,
                    activePanel: newPanel
                };
            }
        case 'PANEL_CLOSE':
            {
                const { instanceId: instanceId } = action.payload;
                // A delayed close from replaced content must not close the new panel.
                if (state.activePanel?.instanceId !== instanceId) return state;
                return {
                    ...state,
                    activePanel: null
                };
            }
        case 'PANEL_SAVE_ENTRYPOINT':
            {
                const { instanceId: instanceId, entryPointReference: entryPointReference } = action.payload;
                const filtered = state.preloadedPanels.filter((p)=>p.instanceId !== instanceId);
                return {
                    ...state,
                    preloadedPanels: [
                        ...filtered,
                        {
                            instanceId: instanceId,
                            entryPointReference: entryPointReference
                        }
                    ]
                };
            }
        case 'PANEL_SET_WIDTH':
            {
                const { width: width } = action.payload;
                if (state.panelWidth === width) return state;
                return {
                    ...state,
                    panelWidth: width
                };
            }
        default:
            return state;
    }
}
function $abf9e80f737bcd23$export$e7dba2ce3ae71ca({ children: children, initialState: initialState }) {
    const [state, dispatch] = (0, $fsvuC.useReducer)($abf9e80f737bcd23$var$panelReducer, {
        activePanel: null,
        preloadedPanels: [],
        panelWidth: (0, $llCao.fg)('platform-dst-chat-panel-layout') ? (0, $eff8acf902328ef9$export$f1a3e4e33b782668) : (0, $eff8acf902328ef9$export$cf6877cd1fb9ba52),
        ...initialState
    });
    // Create stable manager object with memoization
    // This object reference never changes, so ManagerContext consumers never re-render
    const manager = (0, $fsvuC.useMemo)(()=>{
        return {
            /**
			 * Opens a panel with either an entry point or React content.
			 * Always replaces the active panel, including when the instance ID is unchanged.
			 *
			 * **Note:** This is a low-level API. For most use cases, prefer using the `Trigger` component,
			 * which handles entry point loading and ID generation automatically.
			 *
			 * **ID Generation:** The instanceId must be provided. For best practices, use the `Trigger`
			 * component's instanceId (either provided or auto-generated) rather than generating IDs
			 * at the manager level. This keeps ID management co-located with the trigger.
			 *
			 * @param options - Instance ID, optional params, and either entryPoint (with an optional
			 * preloaded entryPointReference) or panelContent.
			 */ openPanel: (options)=>{
                const { instanceId: instanceId, params: params } = options;
                if (options.entryPoint !== undefined) dispatch({
                    type: 'PANEL_OPEN_ENTRYPOINT',
                    payload: {
                        instanceId: instanceId,
                        params: params,
                        entryPoint: options.entryPoint,
                        entryPointReference: options.entryPointReference
                    }
                });
                else dispatch({
                    type: 'PANEL_OPEN',
                    payload: {
                        instanceId: instanceId,
                        params: params,
                        panelContent: options.panelContent
                    }
                });
            },
            closePanel: (instanceId)=>{
                dispatch({
                    type: 'PANEL_CLOSE',
                    payload: {
                        instanceId: instanceId
                    }
                });
            },
            /**
			 * Saves a preloaded EntryPoint reference for a given panel instance.
			 * Useful for mixing Trigger and programmatic panel opening.
			 *
			 * @param instanceId - Unique identifier for this panel instance
			 * @param entryPointReference - Preloaded EntryPoint reference
			 */ saveEntryPointReference: (instanceId, entryPointReference)=>{
                dispatch({
                    type: 'PANEL_SAVE_ENTRYPOINT',
                    payload: {
                        instanceId: instanceId,
                        entryPointReference: entryPointReference
                    }
                });
            },
            setPanelWidth: (width)=>{
                dispatch({
                    type: 'PANEL_SET_WIDTH',
                    payload: {
                        width: width
                    }
                });
            }
        };
    }, []);
    return /*#__PURE__*/ (0, $5chsV.jsx)($abf9e80f737bcd23$export$18d6b45fa585ca8a.Provider, {
        value: manager,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $8IVcJ.StateContext).Provider, {
            value: state,
            children: children
        })
    });
}
$abf9e80f737bcd23$export$e7dba2ce3ae71ca.displayName = "PanelProvider";
function $abf9e80f737bcd23$export$5f6762d4d1cd693d() {
    const manager = (0, $fsvuC.useContext)($abf9e80f737bcd23$export$18d6b45fa585ca8a);
    if (!manager) throw new Error("usePanelActionsInternal must be used within a <PanelProvider>. Wrap your app with: <PanelProvider><App /></PanelProvider>");
    return manager;
}

});
const $eff8acf902328ef9$export$cf6877cd1fb9ba52 = 365;
const $eff8acf902328ef9$export$f1a3e4e33b782668 = 400;

parcelRegister("8IVcJ", function(module, exports) {
$parcel$export(module.exports, "StateContext", () => $97dd7e08f59aa00e$export$437ae3f50102760d);

var $fsvuC = parcelRequire("fsvuC");
const $97dd7e08f59aa00e$export$437ae3f50102760d = /*#__PURE__*/ (0, $fsvuC.createContext)(null);

});


parcelRegister("3Pz86", function(module, exports) {
$parcel$export(module.exports, "usePanelStateInternal", () => $71558c1349e79f5a$export$3fff25b77d81bf59);

var $fsvuC = parcelRequire("fsvuC");

var $8IVcJ = parcelRequire("8IVcJ");
function $71558c1349e79f5a$export$3fff25b77d81bf59() {
    const state = (0, $fsvuC.useContext)((0, $8IVcJ.StateContext));
    if (!state) throw new Error("usePanelStateInternal must be used within a <PanelProvider>. Wrap your app with: <PanelProvider><App /></PanelProvider>");
    return state;
}

});


parcelRegister("4vELg", function(module, exports) {
$parcel$export(module.exports, "Help", () => $112b0898a83ec9a9$export$1be7516c0280bee8);
/**
 * @jsxRuntime classic
 */ 
var $fsvuC = parcelRequire("fsvuC");

var $c2Y7c = parcelRequire("c2Y7c");

var $6q7lh = parcelRequire("6q7lh");

var $7QUpN = parcelRequire("7QUpN");
const $112b0898a83ec9a9$var$HELP_NOTIFICATION_BADGE_ID = 'atlassian-navigation-help-notification-count';
const $112b0898a83ec9a9$export$1be7516c0280bee8 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(function Help({ label: label, onClick: onClick, onMouseEnter: onMouseEnter, isSelected: isSelected, testId: testId, interactionName: interactionName, isListItem: isListItem, badge: badge, shortcut: shortcut }, ref) {
    const sharedProps = {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c2Y7c))),
        label: label,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        isSelected: isSelected,
        testId: testId,
        interactionName: interactionName,
        ref: ref,
        shortcut: shortcut
    };
    if (!badge) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $7QUpN.EndItem), {
        ...sharedProps,
        isListItem: isListItem
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $6q7lh.BadgeContainer), {
        id: $112b0898a83ec9a9$var$HELP_NOTIFICATION_BADGE_ID,
        badge: badge,
        // We only need to set the list item role on the top level element (BadgeContainer)
        isListItem: isListItem
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $7QUpN.EndItem), {
        ...sharedProps,
        // We explicitly set the EndItem to not be a list item,
        // because the BadgeContainer already has a list item role (if `isListItem` is true)
        isListItem: false
    }));
});

});
parcelRegister("6q7lh", function(module, exports) {
$parcel$export(module.exports, "BadgeContainer", () => $96b6db237b50e10e$export$f710265eb5a003da);
/* badge-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");
const $96b6db237b50e10e$var$styles = {
    root: "_1mT5xdRAKS _3iDTPbQ4SZ",
    badgeContainer: "_1mT5xdWVPG _1ANEUSLRg7 _2I62gz5UaJ _3iC0zd8HPE _1pp6NdYbGa"
};
const $96b6db237b50e10e$export$f710265eb5a003da = ({ children: children, id: badgeId, badge: Badge, isListItem: isListItem = true })=>/*#__PURE__*/ (0, $5chsV.jsxs)("div", {
        role: isListItem ? 'listitem' : undefined,
        className: (0, $gJ6nT.default)([
            $96b6db237b50e10e$var$styles.root
        ]),
        children: [
            children,
            /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                id: badgeId,
                "aria-hidden": true,
                className: (0, $gJ6nT.default)([
                    $96b6db237b50e10e$var$styles.badgeContainer
                ]),
                children: /*#__PURE__*/ (0, $5chsV.jsx)(Badge, {})
            })
        ]
    });
$96b6db237b50e10e$export$f710265eb5a003da.displayName = "BadgeContainer";

});

parcelRegister("7QUpN", function(module, exports) {
$parcel$export(module.exports, "EndItem", () => $cb95833ddfe327df$export$b3477e90773be2d0);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $aFiMz = parcelRequire("aFiMz");

var $cBAtE = parcelRequire("cBAtE");
const $cb95833ddfe327df$export$b3477e90773be2d0 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ label: label, icon: icon, onClick: onClick, onMouseEnter: onMouseEnter, isSelected: isSelected, testId: testId, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, isListItem: isListItem = true, shortcut: shortcut }, forwardedRef)=>{
    const Wrapper = isListItem ? (0, $aFiMz.ListItem) : (0, $fsvuC.Fragment);
    return /*#__PURE__*/ (0, $5chsV.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $cBAtE.IconButton), {
            ref: forwardedRef,
            icon: icon,
            label: label,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            appearance: "subtle",
            isSelected: isSelected,
            isTooltipDisabled: false,
            testId: testId,
            interactionName: interactionName,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHasPopup,
            // Only creating object when shortcut is provided
            tooltip: shortcut ? {
                shortcut: shortcut
            } : undefined
        })
    });
});

});
parcelRegister("aFiMz", function(module, exports) {
$parcel$export(module.exports, "ListItem", () => $b59d0bd21a153ef2$export$a7b06bfba60a8a78);
/* list-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");
function $b59d0bd21a153ef2$var$_ListItem({ children: children, testId: testId, xcss: xcss }, ref) {
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        role: "listitem",
        ref: ref,
        className: xcss,
        "data-testid": testId,
        children: children
    });
}
const $b59d0bd21a153ef2$export$a7b06bfba60a8a78 = /*#__PURE__*/ (0, $fsvuC.forwardRef)($b59d0bd21a153ef2$var$_ListItem);

});



parcelRegister("ikffN", function(module, exports) {
$parcel$export(module.exports, "Notifications", () => $85d0b9e328187bed$export$36ba2f559d49a8f6);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $byNe2 = parcelRequire("byNe2");

var $6q7lh = parcelRequire("6q7lh");

var $7QUpN = parcelRequire("7QUpN");
const $85d0b9e328187bed$var$NOTIFICATIONS_BADGE_ID = 'atlassian-navigation-notification-count';
const $85d0b9e328187bed$export$36ba2f559d49a8f6 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(function Notifications({ label: label, onClick: onClick, onMouseEnter: onMouseEnter, isSelected: isSelected, testId: testId, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, isListItem: isListItem, badge: badge, shortcut: shortcut }, ref) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $6q7lh.BadgeContainer), {
        id: $85d0b9e328187bed$var$NOTIFICATIONS_BADGE_ID,
        badge: badge,
        // We only need to set the list item role on the top level element (BadgeContainer)
        isListItem: isListItem,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $7QUpN.EndItem), {
            label: label,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            isSelected: isSelected,
            testId: testId,
            interactionName: interactionName,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHasPopup,
            ref: ref,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($byNe2))),
            // We explicitly set the EndItem to not be a list item,
            // because the BadgeContainer already has a list item role (if `isListItem` is true)
            isListItem: false,
            shortcut: shortcut
        })
    });
});

});

parcelRegister("1Fl7t", function(module, exports) {
$parcel$export(module.exports, "AppLogo", () => $d1eb14860a64c1ca$export$113a612889e1565d);
/* app-logo.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");

var $fsvuC = parcelRequire("fsvuC");

var $4twf9 = parcelRequire("4twf9");

var $llCao = parcelRequire("llCao");

var $cGW6W = parcelRequire("cGW6W");

var $cogH0 = parcelRequire("cogH0");

var $daZXj = parcelRequire("daZXj");

var $3Kmf8 = parcelRequire("3Kmf8");

var $dKvIi = parcelRequire("dKvIi");

var $1SSqM = parcelRequire("1SSqM");
const $d1eb14860a64c1ca$var$anchorStyles = {
    root: "_0bjKvD8fU6 _3iDTPbQ4SZ _0hPCNLDIqT _0jFU0VUofl _3YEZNOdnbC _0GTcwR1Y8M _4kLJBnyL8i _0mJftuYbGa _1vb6Qj6wH8 _4vhRtvOLYo",
    interactionStates: "_1eOmH6o126 _3gzVzLJovG",
    interactionStatesCustomTheming: "_1eOmH6JxD8 _3gzVzL8abp"
};
const $d1eb14860a64c1ca$var$logoWrapperStyles = {
    root: "_2Y7lL41Y8M"
};
const $d1eb14860a64c1ca$var$iconContainerStyles = {
    root: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _1EqgXloWWg _0NUa3roWWg"
};
const $d1eb14860a64c1ca$var$logoTextStyles = {
    root: "_39xV02W9qI _1EqgXlsz7G _20VacPYbGa _03SyCPFQfX _3iDTPbYbGa _0aFT5vbt8w _37wbyuDIqT _2rc81eQ4SZ"
};
const $d1eb14860a64c1ca$var$secondaryNameStyles = {
    root: "_43nrzTLl21"
};
function $d1eb14860a64c1ca$var$isTextClamped(element) {
    // Checking for vertical height rather than horizontal height.
    // When text is "clamped", it's technically being clamped vertically! 🤯
    return element.scrollHeight > element.clientHeight;
}
const $d1eb14860a64c1ca$export$113a612889e1565d = ({ name: name, label: label, secondaryName: secondaryName, href: href, icon: icon, onClick: onClick })=>{
    const ref = (0, $fsvuC.useRef)(null);
    const nameRef = (0, $fsvuC.useRef)(null);
    const hasCustomTheme = (0, $dKvIi.useHasCustomTheme)();
    const showSecondaryName = Boolean(secondaryName) && (0, $llCao.fg)('platform_dst_ads_appswitcher_improvements');
    /**
   * Show the tooltip if the name is truncated
   */ const canTooltipAppear = (0, $fsvuC.useCallback)(()=>{
        const text = nameRef.current;
        return Boolean(text && $d1eb14860a64c1ca$var$isTextClamped(text));
    }, []);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $cGW6W.Anchor), {
        ref: ref,
        "aria-label": label,
        href: href,
        // @ts-expect-error - non-standard values for `borderRadius` and the custom theming interaction states
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $4twf9.cx)($d1eb14860a64c1ca$var$anchorStyles.root, hasCustomTheme ? $d1eb14860a64c1ca$var$anchorStyles.interactionStatesCustomTheming : $d1eb14860a64c1ca$var$anchorStyles.interactionStates),
        onClick: onClick,
        children: /*#__PURE__*/ (0, $5chsV.jsxs)((0, $cogH0.Inline), {
            space: "space.075",
            alignBlock: "center",
            xcss: $d1eb14860a64c1ca$var$logoWrapperStyles.root,
            children: [
                /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                    className: (0, $gJ6nT.default)([
                        $d1eb14860a64c1ca$var$iconContainerStyles.root
                    ]),
                    children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $1SSqM.LogoRenderer), {
                        logoOrIcon: icon
                    })
                }),
                /*#__PURE__*/ (0, $5chsV.jsxs)("span", {
                    className: (0, $gJ6nT.default)([
                        $d1eb14860a64c1ca$var$logoTextStyles.root
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $5chsV.jsx)((0, $3Kmf8.default), {
                            content: name,
                            position: "bottom",
                            ignoreTooltipPointerEvents: true,
                            hideTooltipOnMouseDown: true,
                            // We don't need a duplicate hidden element containing tooltip content
                            // as the content of the tooltip matches what is rendered in the nav item.
                            isScreenReaderAnnouncementDisabled: true,
                            canAppear: canTooltipAppear,
                            children: (tooltipProps)=>/*#__PURE__*/ (0, $5chsV.jsx)("span", {
                                    ...tooltipProps,
                                    children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $daZXj.Text), {
                                        "aria-hidden": true,
                                        color: "inherit",
                                        weight: "semibold",
                                        maxLines: 1,
                                        ref: nameRef,
                                        children: name
                                    })
                                })
                        }),
                        showSecondaryName && /*#__PURE__*/ (0, $5chsV.jsx)("span", {
                            className: (0, $gJ6nT.default)([
                                $d1eb14860a64c1ca$var$secondaryNameStyles.root
                            ]),
                            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $daZXj.Text), {
                                "aria-hidden": true,
                                color: "color.text.subtlest",
                                weight: "regular",
                                maxLines: 1,
                                size: "small",
                                children: secondaryName
                            })
                        })
                    ]
                })
            ]
        })
    });
};
$d1eb14860a64c1ca$export$113a612889e1565d.displayName = "AppLogo";

});

parcelRegister("jkVRV", function(module, exports) {
$parcel$export(module.exports, "CustomLogo", () => $3a9ec39047fcab09$export$4156d88e9ccc616b);
/* custom-logo.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");

var $fsvuC = parcelRequire("fsvuC");

var $4twf9 = parcelRequire("4twf9");

var $cGW6W = parcelRequire("cGW6W");

var $dKvIi = parcelRequire("dKvIi");

var $1SSqM = parcelRequire("1SSqM");
const $3a9ec39047fcab09$var$anchorStyles = {
    root: "_0bjKvDKxmn _3iDTPbQ4SZ _0hPCNLDIqT _0jFU0VUofl",
    customLogoBorderRadius: "_0bjKvD8fU6",
    newMargin: "_0GTcwR1Y8M",
    newInteractionStates: "_1eOmH6o126 _3gzVzLJovG",
    newInteractionStatesCustomTheming: "_1eOmH6JxD8 _3gzVzL8abp"
};
const $3a9ec39047fcab09$var$sharedIconOrLogoContainerStyles = {
    root: "_4bt5LAnQyn _2WAcuGnQyn _2Y7lL41Y8M _0LETLXoWWg _1PTmduOLYo _3G0Ib8gIor"
};
const $3a9ec39047fcab09$var$iconContainerStyles = {
    root: "_3iDTPbQ4SZ _1EqgXloWWg _24h04iyL8i _2rc81eYbGa"
};
const $3a9ec39047fcab09$var$logoContainerStyles = {
    root: "_3iDTPbYbGa _1EqgXlsz7G _24h04iyL8i _2rc81eQ4SZ"
};
const $3a9ec39047fcab09$export$4156d88e9ccc616b = ({ href: href, logo: logo, icon: icon, onClick: onClick, label: label })=>{
    const ref = (0, $fsvuC.useRef)(null);
    (0, $fsvuC.useEffect)(()=>{
        return;
    }, []);
    const hasCustomTheme = (0, $dKvIi.useHasCustomTheme)();
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $cGW6W.Anchor), {
        ref: ref,
        "aria-label": label,
        href: href,
        // @ts-expect-error - non-standard values for `borderRadius` and the custom theming interaction states
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $4twf9.cx)($3a9ec39047fcab09$var$anchorStyles.root, $3a9ec39047fcab09$var$anchorStyles.customLogoBorderRadius, $3a9ec39047fcab09$var$anchorStyles.newMargin, hasCustomTheme ? $3a9ec39047fcab09$var$anchorStyles.newInteractionStatesCustomTheming : $3a9ec39047fcab09$var$anchorStyles.newInteractionStates),
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                className: (0, $gJ6nT.default)([
                    $3a9ec39047fcab09$var$sharedIconOrLogoContainerStyles.root,
                    $3a9ec39047fcab09$var$iconContainerStyles.root
                ]),
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $1SSqM.LogoRenderer), {
                    logoOrIcon: icon
                })
            }),
            /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                className: (0, $gJ6nT.default)([
                    $3a9ec39047fcab09$var$sharedIconOrLogoContainerStyles.root,
                    $3a9ec39047fcab09$var$logoContainerStyles.root
                ]),
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $1SSqM.LogoRenderer), {
                    logoOrIcon: logo
                })
            })
        ]
    });
};
$3a9ec39047fcab09$export$4156d88e9ccc616b.displayName = "CustomLogo";

});

parcelRegister("gKFPX", function(module, exports) {
$parcel$export(module.exports, "CustomTitle", () => $b6bd921b96786f6d$export$9ccddf7ee2a0e24e);
/* custom-title.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $dKvIi = parcelRequire("dKvIi");
const $b6bd921b96786f6d$var$styles = {
    root: "_4bt5LAnQyn _2WAcuGnQyn _2sNsIgmnOE _1ANEUSLRg7 _1EqgXlgZxp _39HuIbz8Lp _0LQT5E1Y8M _03SyCP2ADO _3iDTPbYbGa _2rc81eQ4SZ",
    subtleText: "_1UtDYzZpcK"
};
const $b6bd921b96786f6d$export$9ccddf7ee2a0e24e = /*#__PURE__*/ (0, $fsvuC.forwardRef)(function CustomTitle({ children: children, testId: testId }, ref) {
    const hasCustomTheme = (0, $dKvIi.useHasCustomTheme)();
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        ref: ref,
        "data-testid": testId,
        className: (0, $gJ6nT.default)([
            $b6bd921b96786f6d$var$styles.root,
            !hasCustomTheme && $b6bd921b96786f6d$var$styles.subtleText
        ]),
        children: children
    });
});

});

parcelRegister("jjliv", function(module, exports) {
$parcel$export(module.exports, "LogIn", () => $7145c9102b24ee7f$export$88195aaac9f90319);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $dM6XP = parcelRequire("dM6XP");

var $aFiMz = parcelRequire("aFiMz");

var $j7YjD = parcelRequire("j7YjD");
const $7145c9102b24ee7f$export$88195aaac9f90319 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ onClick: onClick, onMouseEnter: onMouseEnter, testId: testId, interactionName: interactionName, href: href, label: label }, ref)=>/**
		 * This component doesn't use `EndItem` internally because it renders a
		 * `LinkIconButton` instead of an `IconButton`.
		 *
		 * We could make another abstraction, but this is the only top navigation item
		 * that renders a link.
		 */ /*#__PURE__*/ (0, $5chsV.jsx)((0, $aFiMz.ListItem), {
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $j7YjD.LinkIconButton), {
            ref: ref,
            label: label,
            href: href,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            testId: testId,
            interactionName: interactionName,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($dM6XP))),
            appearance: "subtle",
            isTooltipDisabled: false
        })
    }));

});
parcelRegister("j7YjD", function(module, exports) {
$parcel$export(module.exports, "LinkIconButton", () => $a92ffee81b5a302f$export$edad7fca51b767e1);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $6dQ8U = parcelRequire("6dQ8U");

var $dKvIi = parcelRequire("dKvIi");

var $dSGsI = parcelRequire("dSGsI");
const $a92ffee81b5a302f$export$edad7fca51b767e1 = /*#__PURE__*/ (0, $fsvuC.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $dKvIi.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $dSGsI.ThemedLinkIconButton) : (0, $6dQ8U.default);
    return /*#__PURE__*/ (0, $5chsV.jsx)(Component, {
        ref: ref,
        ...props
    });
});

});
parcelRegister("dSGsI", function(module, exports) {
$parcel$export(module.exports, "ThemedLinkIconButton", () => $c452d8264b99b6dc$export$a1ab08e79d264ec8);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $3R2Wy = parcelRequire("3R2Wy");

var $fz4Xf = parcelRequire("fz4Xf");

var $3Kmf8 = parcelRequire("3Kmf8");

var $8e1dR = parcelRequire("8e1dR");

var $cIukW = parcelRequire("cIukW");
function $c452d8264b99b6dc$var$ThemedLinkIconButtonFn({ icon: Icon, label: label, tooltip: tooltip, ...props }, ref) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $3Kmf8.default), {
        ...tooltip,
        content: tooltip?.content ?? label,
        children: (triggerProps)=>/**
				 * The `aria-describedby` from `triggerProps` is intentionally not passed down,
				 * because it would cause double announcements with the `VisuallyHidden` label.
				 *
				 * The `@atlaskit/button` IconButton uses the same approach.
				 */ /*#__PURE__*/ (0, $5chsV.jsxs)((0, $cIukW.ThemedAnchor), {
                ...props,
                shape: "square",
                ref: (0, $fz4Xf.default)([
                    ref,
                    triggerProps.ref
                ]),
                onClick: (event, analyticsEvent)=>{
                    props.onClick?.(event, analyticsEvent);
                    triggerProps?.onClick?.(event);
                },
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    props.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    props.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    props.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    props.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    props.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    props.onBlur?.(e);
                },
                children: [
                    /*#__PURE__*/ (0, $5chsV.jsx)(Icon, {
                        label: "",
                        color: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $5chsV.jsx)((0, $8e1dR.default), {
                        children: label
                    })
                ]
            })
    });
}
$c452d8264b99b6dc$var$ThemedLinkIconButtonFn.displayName = "ThemedLinkIconButtonFn";
const $c452d8264b99b6dc$export$a1ab08e79d264ec8 = (0, $3R2Wy.default)($c452d8264b99b6dc$var$ThemedLinkIconButtonFn);

});



parcelRegister("h0GIl", function(module, exports) {
$parcel$export(module.exports, "Profile", () => $1e3cd01b0feb8eb7$export$5120f2d0b8d4cab8);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $itXZv = parcelRequire("itXZv");

var $7QUpN = parcelRequire("7QUpN");
const $1e3cd01b0feb8eb7$export$5120f2d0b8d4cab8 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ src: src, ...props }, ref)=>{
    const ProfileAvatar = (0, $fsvuC.useCallback)(()=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $itXZv.default), {
            appearance: "circle",
            src: src,
            size: "small"
        }), [
        src
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $7QUpN.EndItem), {
        ...props,
        ref: ref,
        icon: ProfileAvatar
    });
});

});

parcelRegister("3JOSi", function(module, exports) {
$parcel$export(module.exports, "Settings", () => $be962f546bfadacf$export$c72f6eaae7b9adff);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $hQpu3 = parcelRequire("hQpu3");

var $7QUpN = parcelRequire("7QUpN");
const $be962f546bfadacf$export$c72f6eaae7b9adff = /*#__PURE__*/ (0, $fsvuC.forwardRef)((props, ref)=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $7QUpN.EndItem), {
        ...props,
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hQpu3)))
    }));

});

parcelRegister("e6iLQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $36f46f30eab313f6$export$2e2bcd8739ae039);
/* skeleton-heading-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");
const $36f46f30eab313f6$var$styles = {
    skeleton: "_4c065UPgdg _2Y7lL45zaO _2Gfj6iQEt6 _4Gb5FivLZJ _2jfUf9r1As _47eTBt2ADO _3wEj0XGsB2 _0GBAIrogpp",
    customWidth: "_2jfUf9yRC6"
};
/**
 * These styles are mirrored in:
 * packages/design-system/theme/src/constants.tsx
 * packages/design-system/menu/src/menu-item/skeleton-item.tsx
 *
 * Please update both.
 */ const $36f46f30eab313f6$var$shimmerKeyframes = null;
/**
 * These styles are defined using `css` rather than `cssMap` as there is a
 * bug when using `cssMap` that causes a build failure due to the use of keyframes.
 */ const $36f46f30eab313f6$var$shimmerStyles = null;
/**
 * __Skeleton heading item__
 *
 * A skeleton heading item is used in place of a heading item when its contents it not ready.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/skeleton-heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $36f46f30eab313f6$var$SkeletonHeadingItem = ({ isShimmering: isShimmering = false, testId: testId, width: width, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        className: (0, $gJ6nT.default)([
            $36f46f30eab313f6$var$styles.skeleton,
            width && $36f46f30eab313f6$var$styles.customWidth,
            isShimmering && "",
            isShimmering && "_21qtfOkSs3 _0160FKkSs3 _1nw4qxfONH _1iAcE9fONH _2VLDZtSHWH _0YTlblSHWH _30VpOT55dm _2ofBtg55dm _2WuqwLHVQb _2lXp1JHVQb _3wEj0XGsB2 _4diMdqGsB2",
            xcss
        ]),
        style: {
            '--width': width
        },
        "data-ds--menu--skeleton-heading-item": true,
        "data-testid": testId
    });
};
$36f46f30eab313f6$var$SkeletonHeadingItem.displayName = "SkeletonHeadingItem";
var $36f46f30eab313f6$export$2e2bcd8739ae039 = $36f46f30eab313f6$var$SkeletonHeadingItem;

});

const $5b20f9eca5080b27$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $5b20f9eca5080b27$export$f005e2e9f707cb5f = 'commercial';
const $5b20f9eca5080b27$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $5b20f9eca5080b27$export$a739cd5aac835909 = 'stg';
const $5b20f9eca5080b27$export$42dd0cdd351a4a9 = 'prod';
const $5b20f9eca5080b27$export$404582bc18fe4d9e = 'dev';

// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
const $2beb1c5a9011e8fc$export$6eafea55f7947469 = 'data-pdnd-honey-pot';

// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
const $f924aeb8b4d03d56$export$7d0a15ee70427305 = 2147483647;

// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $58ff2e19b0510997$export$fd3d00026297c0ad = 'text/plain';

// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $0ff3806a414665e6$export$4c44a460f123106 = 'text/uri-list';

/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */ const $2e2e8445b88fdb4c$export$c9c4cc54e73b125d = 'application/vnd.pdnd';

const $e9181d8bc9d96b1b$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $e9181d8bc9d96b1b$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $e9181d8bc9d96b1b$export$13f57c02915787b3 = 'atlaskit-portal';

const $2842d286e8760d3e$export$ed5835cc67e87f72 = 'akPortalMount';
const $2842d286e8760d3e$export$80816bd900e5bd00 = 'akPortalUnmount';

const $8d44ad6280d93004$export$42f4885608027d0c = 'non_boolean';

/* eslint-disable jira/filename-case */ // SCREENS
const $46f069e6c968f461$export$f636b5b56f1d624a = 'Screen';
const $46f069e6c968f461$export$9d2de6eebf7462b5 = 'Drawer';
const $46f069e6c968f461$export$1171103ea9083ffa = 'Modal';
const $46f069e6c968f461$export$cae2783c9279926 = 'InlineDialog';
const $46f069e6c968f461$export$d1123261ca8831d2 = 'Dropdown';
const $46f069e6c968f461$export$238d30785c4bca84 = 'Banner';
const $46f069e6c968f461$export$a1562d08625f5d7e = 'UI';
const $46f069e6c968f461$export$947dac6c72b26f81 = 'TRACK';
const $46f069e6c968f461$export$f1d537d508d2945a = 'SCREEN';
const $46f069e6c968f461$export$12346a674644c156 = 'OPERATIONAL';

/* eslint-disable jira/filename-case */ const $eb8cfa569eede1a9$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $eb8cfa569eede1a9$export$e9c56aa3b027d98f = 'jira-customer-service';
const $eb8cfa569eede1a9$export$1346c9aa3cbb477d = 'jira-software';
const $eb8cfa569eede1a9$export$202f50ee62667e32 = 'jira-product-discovery';
const $eb8cfa569eede1a9$export$db515c8cec1e6f79 = 'jira-core';
const $eb8cfa569eede1a9$export$c811f21c9ad05dc2 = 'confluence';
const $eb8cfa569eede1a9$export$961148c98d198270 = 'opsgenie';
const $eb8cfa569eede1a9$export$a310f85340477585 = 'assets';
const $eb8cfa569eede1a9$export$d5e9b613bc4c47f = 'compass';

const $9924ccd0a7eb3f48$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $9924ccd0a7eb3f48$export$f005e2e9f707cb5f = 'commercial';
const $9924ccd0a7eb3f48$export$17b81a3d6c98013c = 'isolated-cloud';
const $9924ccd0a7eb3f48$export$a739cd5aac835909 = 'staging';
const $9924ccd0a7eb3f48$export$42dd0cdd351a4a9 = 'prod';
const $9924ccd0a7eb3f48$export$404582bc18fe4d9e = 'dev';
const $9924ccd0a7eb3f48$export$87285944378c596 = 'Atl-Ctx-Perimeter';
const $9924ccd0a7eb3f48$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
const $9924ccd0a7eb3f48$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';
const $9924ccd0a7eb3f48$export$74814ca8786924c3 = 'Bifrost-Atl-Ctx-Cloud-Service-Provider';
const $9924ccd0a7eb3f48$export$b61e047ddcc35726 = 'GCP';
const $9924ccd0a7eb3f48$export$1baf17f3e645a2b2 = 'AWS';

/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // this is autogenerated file, see scripts/version-update.js
const $2604faf4ecb0fc27$export$a4ad2735b021c132 = '1.9.1';

const $402a0cf753e25867$export$790b3707cd7b148f = 'network';
const $402a0cf753e25867$export$31e3351e7cd6ef5 = 'memory';
const $402a0cf753e25867$export$1f09aaaa930516f = 'disk';

const $ef5fca219fe79279$export$3f072f06b90c3985 = 'navigation';

const $f8a69c6d37cb4ab8$export$d6830277b06edd6 = 'normal';
const $f8a69c6d37cb4ab8$export$1eee5ddc4f6d41c5 = 400;

// Gate off keepAlive. UCT refresh window:
// https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
const $e15c9062f5fd0542$export$8b012b965402e06a = 580000;
const $e15c9062f5fd0542$export$68a6a6cccbaf5f06 = 30000;
const $e15c9062f5fd0542$export$6fe3216720bb7a79 = 15000;
const $e15c9062f5fd0542$export$e5f3cb8ab5223cd4 = 15000;
const $e15c9062f5fd0542$export$bf6cd96e19b2987f = 100;
const $e15c9062f5fd0542$export$bcf3b302e1a0ba63 = 30000;
const $e15c9062f5fd0542$export$74f911c394187993 = 4430;
const $e15c9062f5fd0542$export$5d72de7e544ab20f = 300000;
const $e15c9062f5fd0542$export$a5991d6597d2d0f8 = 15000;
const $e15c9062f5fd0542$export$6a0c27ebdbd1f0ed = 240;
const $e15c9062f5fd0542$export$3f57674185473b5d = 5000;
const $e15c9062f5fd0542$export$1ad8434180c5936c = 300000;

const $35a4dea637e0d056$export$81189edc9b923717 = 1;

const $d06951238cc95036$export$cf090d5281b5ae06 = 10000;
const $d06951238cc95036$export$8575e30be0feb909 = 30000;

// temp solution until we can get it automated
const $6b756b851d60bfdf$export$2295b861f318254a = '0.1.5';

const $790d54a7af2f6d42$export$d8b468db8a225bc9 = 250;

const $7b7d6f3fbc64b228$export$e5a5b1df38d9e289 = 4;

const $9f5054f87e3e2d3a$export$5e28bf885ebebfa6 = '[browser-storage-controls]';
const $9f5054f87e3e2d3a$export$aeb1f5aa1188ce28 = 5000; // min gap between sends of the same action
const $9f5054f87e3e2d3a$export$ee3d07c2528881e2 = 10; // hard cap per action per page load

/* eslint-disable jira/filename-case */ const $d0b0f317b4f60123$export$881d135f98d8d7d0 = 100;
const $d0b0f317b4f60123$export$9ab5bdcb8a1d6c34 = false;
const $d0b0f317b4f60123$export$f267d0e9ab3eb265 = false;
const $d0b0f317b4f60123$export$12c1dc38ea1692da = 0;
const $d0b0f317b4f60123$export$34932e325e1234b3 = false;

const $f9196309764c88eb$export$98a7370239de6730 = 86400000;

// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $69c4eea1f1404581$export$338a9f6c7a1f02b0 = 'text/html';

// ACT Event types
// AdControlDropdownMenu
const $ccaff9c1e22335c3$export$17ff257e1f6e39f5 = 'AD_CONTROL_DROP_DOWN_MENU_OPENED';
const $ccaff9c1e22335c3$export$7fc09cf740f33ed4 = 'AD_CONTROL_DROP_DOWN_MENU_CLOSED';
const $ccaff9c1e22335c3$export$e33200507ac1d20a = 'DISMISS_STARTED';
const $ccaff9c1e22335c3$export$103f41d1f3bf374e = 'DISMISS_SUCCEEDED';
const $ccaff9c1e22335c3$export$6d3088110036f124 = 'DISMISS_FAILED';
const $ccaff9c1e22335c3$export$5595c6967e83d351 = 'REASONS_BUTTON_CLICKED';
const $ccaff9c1e22335c3$export$ff50ad60f08a4bc0 = 'REASONS_MODAL_SHOWN';
const $ccaff9c1e22335c3$export$6bd2d8eacca15ce1 = 'REASONS_MODAL_DISMISSED';
const $ccaff9c1e22335c3$export$5c5fc6956b7600ea = 'FLAG_DISMISSED';

// same types defined in analytics-web-client but avoid creating dependency with that
const $ddd31af8f515fa50$export$a1562d08625f5d7e = 'ui';
const $ddd31af8f515fa50$export$947dac6c72b26f81 = 'track';
const $ddd31af8f515fa50$export$f1d537d508d2945a = 'screen';
const $ddd31af8f515fa50$export$12346a674644c156 = 'operational';
const $ddd31af8f515fa50$export$b055de0e665cb20c = 'unknown';

/* eslint-disable jira/filename-case */ const $8f860a533cc71fca$export$ff39ebd4bb12b718 = 201;
const $8f860a533cc71fca$export$3288b14b6745c572 = 204;
const $8f860a533cc71fca$export$9de493bcd9b1d977 = 400;
const $8f860a533cc71fca$export$67d19e9a991baa07 = 401;
const $8f860a533cc71fca$export$a3269a3914b007e3 = 403;
const $8f860a533cc71fca$export$8bca792d963eb0ef = 404;
const $8f860a533cc71fca$export$4a3cb39801694eee = 407;
const $8f860a533cc71fca$export$fa405bbf47d510e2 = 408;
const $8f860a533cc71fca$export$c09e7ea0fc79f34f = 409;
const $8f860a533cc71fca$export$5244030134e99 = 412;
const $8f860a533cc71fca$export$f90ac1df0b60853d = 413;
const $8f860a533cc71fca$export$a447d0a965e16776 = 422;
const $8f860a533cc71fca$export$3b48aba8957000cd = 426;
const $8f860a533cc71fca$export$6763168a631449a2 = 429;
const $8f860a533cc71fca$export$e813cd7045fcc98d = 500;
const $8f860a533cc71fca$export$2ce38d41a306034e = 502;
const $8f860a533cc71fca$export$974c37534b0191b1 = 503;
const $8f860a533cc71fca$export$5400e8dddac3fcf3 = 504;

/* eslint-disable jira/filename-case */ const $f0e9a194674bc930$export$b5a308a17bc991f3 = 'projectKey';
const $f0e9a194674bc930$export$929d50f83189406c = 'boardId';
const $f0e9a194674bc930$export$da6f46390e1a426f = 'projectId';

/* eslint-disable jira/filename-case */ const $5f6e091542d432a9$export$b8b9d90f9e5bd72b = 'jiraAtlassianNavigationNav4';
const $5f6e091542d432a9$export$d57b6b390e78d90f = 'jira-cosmos';
const $5f6e091542d432a9$export$69cbedccc0df48 = 'viewAtlassianNavigationMenu';
const $5f6e091542d432a9$export$b110169935468339 = 'AtlaskitAtlassianNavigationNav4';
const $5f6e091542d432a9$export$eed606b4351295d7 = 'login';
const $5f6e091542d432a9$export$35e541d26a145a7c = 'logout';

/* eslint-disable jira/filename-case */ const $3b258ee19859baa5$export$2bd315ece9f68967 = 'v4';

/* eslint-disable jira/filename-case */ const $192a2eeaa0a1dbf6$export$2ee9e5a3556c1e43 = 'sidebar';
const $192a2eeaa0a1dbf6$export$793ed84f5e13fedc = 'top';
const $192a2eeaa0a1dbf6$export$f1c9dd0f5207dd5e = 'tab';
const $192a2eeaa0a1dbf6$export$b83d0ee9325a2d0a = 'projectTitle';

/* eslint-disable jira/filename-case */ // TopNav or sidebar
const $fad9173ee481d7de$export$17ff3f7e02c6ac22 = 'global';
const $fad9173ee481d7de$export$33d8c916a600c5e9 = 'container';

/* eslint-disable jira/filename-case */ const $6b2913942bd90807$export$6dd9406e478a1fe2 = 'navigationItem';
const $6b2913942bd90807$export$b887e88d8d0739f6 = 'button';
const $6b2913942bd90807$export$64fed82162bd367 = 'dropdownItem';
const $6b2913942bd90807$export$b0a8b257f1f878a2 = 'searchInput';

const $5bdb53f12f87b5a8$export$cb2f616a76599e00 = 'APP_SWITCHER';

const $b435b412b2dfd147$export$b8b9d90f9e5bd72b = '@jira/navigation-apps__atlassian-navigation';
const $b435b412b2dfd147$export$4766f0c4b6fe35dc = 'TOP_LEVEL';
const $b435b412b2dfd147$export$9934c8d98fd9e572 = 'atlassianSwitcher';

const $98fd96abde9f3719$export$3364800d9d60baf9 = 'localStorage';

const $a911def61a058b00$export$45e63649edff1e2a = 'ASSETS';
const $a911def61a058b00$export$eb7589a4ee50c678 = 'tenantless';

const $11c0f1bd3f72e082$export$c2c502a6524b22c7 = 'com.atlassian.jira.modules.servicemanagement.status-pages-entity:status-pages-entity-field-cftype';

const $110b74e2943f9928$export$e26f00bd90899835 = 'success';
const $110b74e2943f9928$export$edb46161045fece7 = 'error';

/**
 * CSS variables that mirror the legacy `@atlaskit/page-layout` CSS custom properties.
 *
 * These are provided for consumers that previously relied on the `@atlaskit/page-layout`
 * CSS variables and need to reference them when using the navigation system.
 */ const $266ff4fb0e8e331a$export$f963aecf2d4465bd = 'var(--leftPanelWidth, 0px)';
const $266ff4fb0e8e331a$export$750459958906793 = 'var(--rightPanelWidth, 0px)';
const $266ff4fb0e8e331a$export$f897e1ed9f8ed251 = 'var(--leftSidebarWidth, 0px)';
const $266ff4fb0e8e331a$export$b44ab66843c05a69 = 'var(--rightSidebarWidth, 0px)';
const $266ff4fb0e8e331a$export$aeff86a16f13529 = 'var(--topNavigationHeight, 0px)';
const $266ff4fb0e8e331a$export$ed7cc0d417ee89e = 'var(--bannerHeight, 0px)';

// temp solution until we can get it automated
const $ddd67f40feddf208$export$2295b861f318254a = '0.1.5';

const $161c8cfa8193bed5$export$d8b468db8a225bc9 = 250;

const $c0bb806f19dcd148$export$e0744546db5b6189 = 'rovo_chat_sites_source_filter';

const $f3039341ab1981e1$export$ad7805b1cbcab15e = 'JSMGROWTH-524';
const $f3039341ab1981e1$export$ac82a6f95aaaebf5 = 'grw-524_jsm_jpd_rovo_sidekick_killswitch';
const $f3039341ab1981e1$export$f562d49e335d7782 = 'jsm-contextual-suggestions';
const $f3039341ab1981e1$export$47ba9a433044383c = 'rovoQuickActions';
const $f3039341ab1981e1$export$8103addd67bbde0d = 60;

/* eslint-disable jira/filename-case */ const $1771eb0e641090af$export$53d41ff2666118e1 = 'agility-backlog';
const $1771eb0e641090af$export$7552fe2669628499 = 'bitbucket-issue';
const $1771eb0e641090af$export$41a718da0a8636f4 = 'connect-issue';
const $1771eb0e641090af$export$cebf0bc8b2ccaf57 = 'core-issue';
const $1771eb0e641090af$export$f154708d773ba5a0 = 'jira-board';
const $1771eb0e641090af$export$5e91e17726e54450 = 'jiraCalendar';
const $1771eb0e641090af$export$2dac1950892123f5 = 'jiraTimeline';
const $1771eb0e641090af$export$82540942fb014b0a = 'business-calendar';
const $1771eb0e641090af$export$7ca28938a07e0c33 = 'business-list';
const $1771eb0e641090af$export$f6cf06aaaeb58a54 = 'business-timeline';
const $1771eb0e641090af$export$b2c0462ff17aa26e = 'business-board';
const $1771eb0e641090af$export$a607850ebccd28ac = 'business-approvals';
const $1771eb0e641090af$export$1da6cede3561048f = 'business-files';
const $1771eb0e641090af$export$b19f949fb9713614 = 'full-issue';
const $1771eb0e641090af$export$c3899e01aa51a88e = 'jsm-full-issue';
const $1771eb0e641090af$export$a5132300c5214280 = 'embed-issue';
const $1771eb0e641090af$export$36d32bfbadaf29fb = 'work-item-view';
const $1771eb0e641090af$export$710114090a811b37 = 'global-issue-navigator-issue';
const $1771eb0e641090af$export$ce88447986394f2d = 'mobile-issue';
const $1771eb0e641090af$export$6a90d9196d330040 = 'project-issue-navigator';
const $1771eb0e641090af$export$2247c9059c171db1 = 'roadmap-issue';
const $1771eb0e641090af$export$cd16d39c55c569d0 = 'simple-software-board';
const $1771eb0e641090af$export$f72626bf0d75dfad = 'software-backlog-issue';
const $1771eb0e641090af$export$778b4609e784cb27 = 'software-deployments-issue';
const $1771eb0e641090af$export$5b73d694a6048002 = 'version-detail-issue';
const $1771eb0e641090af$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $1771eb0e641090af$export$21b5b7189add7861 = 'software-incidents-issue';
const $1771eb0e641090af$export$9c5d81b901471b27 = 'software-issue';
const $1771eb0e641090af$export$1735f6ad917dc411 = 'change-calendar';
const $1771eb0e641090af$export$7063ee6d0035a982 = 'queues-issue-view';
const $1771eb0e641090af$export$e3ab9da1dcf8e2ba = 'live-chat-issue-view';
const $1771eb0e641090af$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $1771eb0e641090af$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $1771eb0e641090af$export$14a8072f422804fd = 'issue-navigator-next';
const $1771eb0e641090af$export$cd2e8394c029507b = 'issue-navigator-detail-view';
const $1771eb0e641090af$export$9dac02c804d7acd8 = 'classic-software-board';
const $1771eb0e641090af$export$d6a617b7cd271a10 = 'jira-home-recommended';
const $1771eb0e641090af$export$49d57bef9ac2550b = 'global-issue-create';
const $1771eb0e641090af$export$9aea6bdc77a1b448 = 'csm-live-conversation-issue-view';
const $1771eb0e641090af$export$887083471231a492 = 'ham-work-items';
const $1771eb0e641090af$export$74b1da58ccd0577f = 'agents-watchtower';

/* eslint-disable jira/filename-case */ const $74cc6705a5fdb0de$export$2b91517d6d5b4365 = `
query isRovoEnabledQuery($cloudId: ID!, $shouldIncludeBetaAiFeatures: Boolean!) {
  jira {
    isRovoEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence")
	}

	jira_isRovoLLMEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence")
	jira_isBetaAiFeaturesEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence") @include(if: $shouldIncludeBetaAiFeatures)
	jira_rovoEnablementStatus(cloudId: $cloudId)@optIn(to: "JiraRovoEnablementStatus") {
		isRovoEntitlementEnabledForTenant
		isRovoAiFeaturesEnabledInAnyJiraProducts {
			isEnabled
			disabledReason
		}
		rovoAiFeaturesEnabledJiraProducts
	}
}
`;

const $1056e2b7e19aa4e0$export$f4208f01301e1342 = 'HELP';

/* eslint-disable jira/filename-case */ const $2b56b53c34bc2033$export$c43c7444da662fa1 = '1';
const $2b56b53c34bc2033$export$e99efa3985fa3c26 = 'helpPanel';
const $2b56b53c34bc2033$export$23aa6670f346c214 = 368;

/* eslint-disable jira/filename-case */ const $a250aea31dc76f65$export$53f45136e435c2fd = 'help_button_ui_state';

const $863aeee714b20c92$export$2ce650757fdac12a = 'NOTIFICATIONS';

/* eslint-disable jira/filename-case */ const $71a8d80581e45c48$export$e0226a83abddbd07 = 'check-notifications';

/* eslint-disable jira/filename-case */ const $8dfb0c8c68d6c8c9$export$14c62ba6f49b806f = 9;

/* eslint-disable jira/filename-case */ const $70e36d23224a09de$export$3a54edb6ba4daa82 = 'TOP_NAV';
const $70e36d23224a09de$export$2ee9e5a3556c1e43 = 'SIDEBAR';

const $8ce4c0417f34b437$export$b98e411ae80c806f = '/';

const $eb044bb12d0b1d65$export$c1b33b1e65f8bd62 = 'SEARCH';

const $ba3615aabbc9caed$export$eeb0307e2964e28d = "var(--ds-text, #292A2E)";

const $73820dc7daa419bb$export$7168c0a11fb9ab29 = "var(--ds-text-subtlest, #6B6E76)";

const $bd344c6c2142b1d3$export$4ac85ff259fe4fce = "var(--ds-background-neutral-subtle-hovered, #0515240F)";

const $98d257b803724cde$export$271fb8b1437b1d62 = "var(--ds-link-visited, #803FA5)";

const $57a8d3ee2467d6bc$export$1b6b909295618bea = 'SETTINGS';


$parcel$global.rlb("5h6rP")
//# sourceMappingURL=shared~atlassian-navigation~atlaskit~ar.b0dcd9de.js.map
